(function(){
    angular.module('app.controllers',['ngPostMessage']).controller('CashBoxController',
      function($window,$uibModal, $stateParams, $api, dates, $header, $rootScope, $state, $scope, $filter, $sce, $log, $user,
        $translate, Info, Items, Workers, Resources, Customer, Order, CustomerCards,  Transaction, Categories, Retainer){

        $scope.statusShow = ''; 
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var query = window.location.search.substring(1);
        var qs = query ? parse_query_string(query) : {};

        var ctrl = this;

        // console.log(Order.data);
        ctrl.hide_prices = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices') ? true : false;

        $scope.datesProvider = dates;
        $scope.isEmv = false;
        ctrl.show_stock = $rootScope.$user.show_stock;
        $scope.channelHash = $rootScope.generateUniqueId();

        $scope.isMobile = (angular.element(document).width() < 769)
        ctrl.categoryFilter = -1;
        ctrl.maxDebt = null;
        ctrl.isCreditTransaction = false;
        ctrl.isCreditCreditCard = false;
        ctrl.isOrderTransaction = false;
        ctrl.prepaid = false;
        ctrl.isDebtTransaction = false;
        ctrl.searchItem = "";
        ctrl.customerData = null;
        ctrl.employees = [];
        ctrl.resources = Resources && Resources.data ? Resources.data : [];
        ctrl.customer_search_name = "";
        ctrl.searchCustomerResult = [];
        ctrl.items = [];
        ctrl.currentModal = null;
        ctrl.dealer_vat = Info ? parseFloat(Info.data.vat) : 0;
        ctrl.businessInfo = Info;
        ctrl.businessHasCardReader = Info.data.card_reader;
        ctrl.msg_channel_inv_link = Info.data.msg_channel_inv_link;
        ctrl.businessHasEnv = Info.data.env; // is the business has env card reader
        ctrl.useCardReader = ctrl.businessHasCardReader == '1' ? true : false;
        ctrl.sendInvoice = true;
        ctrl.useIframe = false;
        ctrl.creditDeal = false;
        ctrl.isEmv = false;
        ctrl.numberOfPaymentsEmv = 1;
        ctrl.cardQty = 1;
        ctrl.cardQtyModel = 1;
        ctrl.cardPrice = 0;
        ctrl.cardPerItemModel = 1;
        ctrl.cardPerItem = 1;
        ctrl.makeCardIndex = 0;
        ctrl.cerdit_company = Info.data.cerdit_company;
        ctrl.checkCustomerCards = false;
        ctrl.z_credit_credit_deal = Info.data.z_credit_credit_deal;
        ctrl.show_discount = 0;
        ctrl.total_discount = '';

        ctrl.BanksList = [
            {'bank_number': 'service_1', 'name': 'Bit', img_url: "assets/images/bank_bit_icon.png"},
            {'bank_number': 'service_2', 'name': 'Paybox', img_url: "assets/images/service_paybox_icon.png"},
            {'bank_number': 12, 'name':	'בנק הפועלים'},
            {'bank_number': 10, 'name': 'בנק לאומי'},
            {'bank_number': 11, 'name': 'בנק דיסקונט'},
            {'bank_number': 20, 'name': 'בנק מזרחי טפחות'},
            {'bank_number': 31, 'name': 'הבנק הבינלאומי הראשון'},
            {'bank_number': 14, 'name': 'בנק אוצר החייל'},
            {'bank_number': 17, 'name': 'בנק מרכנתיל דיסקונט'},
            {'bank_number': 9, 'name': 'בנק הדואר'},
            {'bank_number': 13, 'name': 'בנק איגוד'},
            {'bank_number': 46, 'name': 'בנק מסד'},
            {'bank_number': 52, 'name': 'בנק פועלי אגודת ישראל'},
            {'bank_number': 90, 'name': 'בנק דיסקונט למשכנתאות'},
            {'bank_number': 4, 'name': 'בנק יהב לעובדי המדינה'},
            {'bank_number': 26, 'name': 'יובנק בע"מ'},
            {'bank_number': 7, 'name': 'בנק לפיתוח התעשיה'},
            {'bank_number': 8, 'name': 'בנק הספנות לישראל'},
            {'bank_number': 6, 'name': 'בנק אדנים'},
            {'bank_number': 54, 'name': 'בנק ירושלים'},
            {'bank_number': 34, 'name': 'בנק ערבי ישראלי'},
            {'bank_number': 1, 'name': 'בנק יורו טרייד'},
            {'bank_number': 19, 'name': 'בנק החקלאות לישראל'},
            {'bank_number': 200, 'name': 'one zero'},
        ];

        ctrl.form = {
            email: "",
            phone: "",
            name: "",
            customer_occ_name: "",
            customer_occ_phone: "",
            comment: "",
            customer: null,
            quotation: 0,
            retainer_start_date: null,
            retainer_count: '',
            retainer_infinity: false,
            retainer_period: 'monthly',
        };

        ctrl.occ_customer = false;

        /** Get customers data */
        if(Customer) {
          ctrl.customerData = Customer.data;
        }

        if(Workers) {
          ctrl.employees = Workers.data;
        }

        ctrl.cashboxTotal = 0;
        ctrl.cashboxTotalByItemsCard = 0;
        ctrl.totalPaid = 0;
        ctrl.cashboxLoading = false;
        ctrl.isManuallyEditingTotal = false;
        if(CustomerCards) {
          ctrl.customerCards = CustomerCards.data;
        }

        for(var i in Items.data){
            if(Items.data[i].categories != null && Items.data[i].item_type != 'card') {
                Items.data[i].categories = String(Items.data[i].categories).replace("{", "[").replace("}", "]");
                Items.data[i].categories = JSON.parse(Items.data[i].categories);
            }
        }

        // Fill payment methods
        ctrl.methods = {
            oncredit: {},
            cash: {},
            cheque: {},
            credit_card_external: {},
            bank_transfer: {},
            credit_card: {},
            items_card: {},
            pay_link: {},
            retainer: {},
        };

        ctrl.resetPaymentMethods = function() {
          Object.keys(ctrl.methods).forEach(function(key, i){
              ctrl.methods[key] = {
                  active: false,
                  disabled: false,
                  amount: null,
                  subtotal: null,
                  vat: null,
                  payment_details: {
                    cheque_number: null,
                      cheque_due_date: moment().format('MM/DD/YYYY'),
                      bank_number: null,
                      branch_number: null,
                      bank_account_number: null,
                      credit_card_ext_number: null,
                  }
              }
          });
        };

        $scope.$watch('ctrl.form.quotation', function(newValue, oldValue) {
          if (newValue !== oldValue) {
            ctrl.resetPaymentMethods();
            if (newValue) {
              ctrl.choosePayMethod('cash');
            }
          }
        });

        ctrl.resetPaymentMethods();
        ctrl.categories = Categories.data.filter(function (el) { return el.active; });
        var activeCategoryIds = ctrl.categories.map(function (cat) { return cat.id; });
        Items.data = Items.data.filter(function (el) {
            if (el.item_type === 'card' || el.inactive) return false;

            if (!el.categories || !el.categories.length || (el.categories.length == 1 && el.categories[0] == 0)) return true;

            for (var j = 0; j < el.categories.length; j++) {
                if (activeCategoryIds.indexOf(el.categories[j]) !== -1) {
                    return true;
                }
            }

            return false;
        });

        ctrl.products = Items.data;
        ctrl.lastMethod = null;
        $scope.method = null;

        ctrl.load_credit_data = function(){
            ctrl.items = Transaction.data.items;
            ctrl.trigger_items_update(false, true);
        };

        ctrl.update_transaction_customer_data = function() {
            if(!ctrl.form.customer) {
              if (!ctrl.occ_customer) {
                ctrl.remove_customer();
              }
            } else {
              ctrl.customer_search_name = ctrl.customerData.firstname;
              ctrl.customer_search_name +=  ctrl.customerData.lastname ? ' ' + ctrl.customerData.lastname : '';
              ctrl.customer_search_name +=  ctrl.customerData.notes ? ' (' + ctrl.customerData.notes + ')' : '';

              ctrl.form.email = ctrl.customerData.email;
              ctrl.form.phone = ctrl.customerData.phone || ctrl.customerData.telephone;
              ctrl.form.name = ctrl.customerData.firstname;
              ctrl.form.name += ctrl.customerData.lastname ? ' ' + ctrl.customerData.lastname : '';
              ctrl.loadCustomersCards(ctrl.form.customer);
            }
        };

        if (qs.customer) {
          $api.customers.single.get({id: qs.customer}, function(response){
            ctrl.form.customer = response.data ? response.data.id : null;
            ctrl.customerData = response.data ? response.data : null;
            if (response.data) {
              ctrl.form.customer_occ_name = "";
              ctrl.form.customer_occ_phone = "";
              ctrl.occ_customer = false;
            }
            ctrl.update_transaction_customer_data();
          });
        }
        if (qs.quotation) {
          ctrl.form.quotation = true;
        }

        /**
         * Clear customers data from form
         */
        ctrl.remove_customer = function() {
            ctrl.form.email = "";
            ctrl.form.phone = "";
            ctrl.form.name = "";
            ctrl.form.customer_occ_name = "";
            ctrl.form.customer_occ_phone = "";
            ctrl.customerData = {};
            ctrl.form.customer = null;
            ctrl.customer_search_name = "";
            ctrl.customerCards = null;
            ctrl.customerCreditCards = null;
            ctrl.removeRetainer();
        }

        ctrl.removeRetainer = function() {
          ctrl.customerCreditCards = null;
          ctrl.methods['retainer'] = {
            active: false,
            disabled: false,
            amount: null,
            subtotal: null,
            vat: null,
          };
        }

        /**
         * Only for mobile view
         */
        ctrl.openSelectCustomer = function() {
            $uibModal.open({
              templateUrl: "app/modules/customers/popup/customers.popup.html",
              controller: "CustomersSelectController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal medium-modal",
              resolve: {
                Customers: function($api) {
                  return $api.resolve("customers@get", {limit: 20});
                }
              }
            }).result.then(function (selected_customer) {
              ctrl.form.customer = selected_customer ? selected_customer.id : null;
              ctrl.customerData = selected_customer ? selected_customer : null;
              if (selected_customer) {
                ctrl.form.customer_occ_name = "";
                ctrl.form.customer_occ_phone = "";
                ctrl.occ_customer = false;
              }
              ctrl.update_transaction_customer_data();
            });
          }

        /**
         * Only for mobile view
         */
        ctrl.openSelectItem = function() {
            $uibModal.open({
              templateUrl: "app/modules/settings/items/popup/items.popup.html",
              controller: "ItemsSelectController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal medium-modal select-item-modal",
              resolve: {
                Items: [function () {
                  return ctrl.products;
                }]
              }
            }).result.then(function (selected_item) {
              if(selected_item) {
                ctrl.addItem(selected_item);
              }
            });
        }


        ctrl.openSelectEmployee = function() {
          $uibModal.open({
            templateUrl: "app/modules/workers/popup/workers.popup.html",
            controller: "WorkersSelectController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal select-worker-modal",
            resolve: {
              Workers: [function () {
                return ctrl.employees;
              }]
            }
          }).result.then(function (selected_employee) {
            ctrl.form.employee = selected_employee.id;
          });
      }

        ctrl.showBankList = function() {
            $uibModal.open({
                templateUrl: "app/modules/cashbox/popup/bank.popup.html",
                controller: "BanksSelectController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal medium-modal",
                resolve: {
                    Banks: [function () {
                        return ctrl.BanksList;
                    }]
                }
            }).result.then(function (bank) {
                if(bank) {
                    ctrl.methods[$scope.method].payment_details.bank_number = bank.bank_number;
                    ctrl.methods[$scope.method].payment_details.bank_name = bank.name;
                }
            });
        }

        ctrl.giftCardIndex = 0;
        ctrl.openGiftCardDetails = function(index) {
          ctrl.giftCardIndex = index;

          $uibModal.open({
            templateUrl: "app/modules/settings/gift_cards/popup/details.view.html",
            controller: "GiftCardsDetailsController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal large-modal",
            resolve: {
              Customer: [function () {
                return ctrl.customerData;
              }],
              Item: [function () {
                return ctrl.items[index];
              }],
              Templates: ['$api', function ($api) {
                return $api.resolve("giftCardTemplate@get");
              }],
              Info: ['$api', function ($api) {
                return $api.resolve("settings.info@get");
              }],
            }
          }).result.then(function (response) {
            if (response) {
              if (ctrl.items[ctrl.giftCardIndex]) {
                ctrl.items[ctrl.giftCardIndex].item_name = ctrl.items[ctrl.giftCardIndex].item_name ? ctrl.items[ctrl.giftCardIndex].item_name : ctrl.items[ctrl.giftCardIndex].name;

                ctrl.items[ctrl.giftCardIndex].isGiftCard = true;
                ctrl.items[ctrl.giftCardIndex].gift_card_template_id = response.template_id;
                ctrl.items[ctrl.giftCardIndex].gifted_to = response.values.receiver;
                ctrl.items[ctrl.giftCardIndex].sender_text = response.values.sender;
                ctrl.items[ctrl.giftCardIndex].service_text = response.values.service;
                ctrl.items[ctrl.giftCardIndex].message_text = response.values.message;
                ctrl.items[ctrl.giftCardIndex].name = response.values.name;
                ctrl.items[ctrl.giftCardIndex].page_bg_color = response.settings.page_bg_color;
                ctrl.items[ctrl.giftCardIndex].card_bg_color = response.settings.card_bg_color;
                ctrl.items[ctrl.giftCardIndex].primary_color = response.settings.primary_color;
                ctrl.items[ctrl.giftCardIndex].text_color = response.settings.text_color;
                ctrl.items[ctrl.giftCardIndex].logo = response.settings.logo;
                ctrl.items[ctrl.giftCardIndex].image = response.settings.image;
                ctrl.items[ctrl.giftCardIndex].receiver = response.settings.receiver;
                ctrl.items[ctrl.giftCardIndex].sender = response.settings.sender;
                ctrl.items[ctrl.giftCardIndex].service = response.settings.service;
                ctrl.items[ctrl.giftCardIndex].value = response.settings.value;
                ctrl.items[ctrl.giftCardIndex].message = response.settings.message;
              }
            }
          });
        }

        ctrl.selectedCards = [];
        ctrl.openGiftCardModal = function() {
          $uibModal.open({
            templateUrl: "app/modules/settings/gift_cards/popup/select.view.html",
            controller: "GiftCardsSelectController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal",
            resolve: {
              GiftCards: ['$api', function ($api) {
                return $api.resolve("giftCard@get");
              }],
              SelectedGiftCards: ['$api', function ($api) {
                return ctrl.selectedCards;
              }],
            }
          }).result.then(function (response) {
            if (response) {
              var seen = {};
              var updatedCards = [];
              for (var i = 0; i < response.length; i++) {
                var card = response[i];
                var number = card.number;
                if (number && !seen[number]) {
                  seen[number] = true;
                  updatedCards.push(card);
                }
              }
              ctrl.selectedCards = updatedCards;

              var responseSet = {};
              for (i = 0; i < ctrl.selectedCards.length; i++) {
                responseSet[ctrl.selectedCards[i].number] = true;
              }

              var keptItems = [];
              for (i = 0; i < ctrl.items.length; i++) {
                var item = ctrl.items[i];
                if (item.item_type != 'gift_card') {
                  keptItems.push(item);
                  continue;
                }

                if (responseSet[item.number]) {
                  keptItems.push(item);
                }
              }
              ctrl.items = keptItems;

              var giftCardSet = {};
              for (i = 0; i < ctrl.items.length; i++) {
                var item = ctrl.items[i];
                if (item.item_type == 'gift_card') {
                  giftCardSet[item.number] = item;
                }
              }

              var totalLeft = ctrl.cashboxTotal;

              for (var i in ctrl.selectedCards) {
                var card = ctrl.selectedCards[i];

                if (giftCardSet[card.number]) {
                  continue;
                }

                var balance = card.balance * 1 <= totalLeft ? card.balance * 1 : totalLeft;
                balance = balance > 0 ? balance : 0;
                totalLeft -= balance;

                var subtotal = (balance * 1 / (100 + ctrl.dealer_vat)) * 100;
                subtotal = (Math.round(subtotal * 100)) / 100;
                var tax = balance * 1 - subtotal;

                ctrl.items.push({
                  item_duration: null,
                  item_id: null,
                  item_type: "gift_card",
                  gift_card_id: card.id,
                  name: card.name,
                  number: card.number,
                  original_price: card.price,
                  balance: card.balance * 1,
                  price: balance * -1,
                  quantity: 1,
                  subtotal: subtotal * -1,
                  tax: tax * -1,
                });

                ctrl.methods['retainer'].disabled = true;
              }
            }
          });
        }

        /**
         * Search customer
         */
        ctrl.find_customer = function() {
          $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response){
            if (response.str == ctrl.customer_search_name) {
              ctrl.searchCustomerResult = response.data;
            }
          });
        }

        /**
         * Select customer
         *
         * @param index
         * @param $event
         */
        ctrl.chooseCustomer = function(index,$event){
          ctrl.customerData = ctrl.searchCustomerResult[index];
          ctrl.form.customer = ctrl.customerData.id;
          ctrl.form.customer_occ_name = "";
          ctrl.form.customer_occ_phone = "";
          ctrl.occ_customer = false;
          ctrl.form.randomCustomer = 0;
          ctrl.searchCustomerResult = [];
          ctrl.update_transaction_customer_data();

          $event.stopPropagation();
        }

        /**
         * Empty search customer field
         */
        ctrl.cleanCustomerSearch = function() {
          if(ctrl.form.customer == null || typeof ctrl.form.customer === "undefined") {
            ctrl.customer_search_name = '';
          }
        }

        /**
         * Load all customer's cards
         *
         * @param customer_id
         */
        ctrl.loadCustomersCards = function (customer_id) {
          //ctrl.customerCards = $api.resolve("cards.customers@get", {"id": customer_id});
          $api.cards.customers.get({"id": customer_id}, function (response) {
              if (response.status == "success") {
                ctrl.customerCards = response.data;
                ctrl.matchCardsForItems();

                if (ctrl.checkCustomerCards) {
                  for (var i in ctrl.items) {
                    var card = ctrl.getCustomerCardForItem(ctrl.items[i].id); 
                    if (card && !card.expired && card['balance'] && card['balance'] > 0 && !ctrl.items[i].isCard) {
                      ctrl.items[i].card_balance_used = card['balance'] < ctrl.items[i].quantity ? card['balance'] : ctrl.items[i].quantity;
                    }
                  }
                }
                ctrl.checkCustomerCards = false
              }
            }
          );
          $api.customers.credit_cards.get({"id": customer_id}, function (response) {
            if (response.status == "success") {
              ctrl.customerCreditCards = response.data;
            }
          });
        }

        ctrl.giftCardTotal = function() {
          var total = 0;
          ctrl.items.forEach(function(item) {
            if (item.item_type == 'gift_card') {
              total += Math.abs(item.price);
            }
          });
          return total;
        }

        /**
         * Return Card for specific Item if customer has bought it
         *
         * @param item_id
         * @returns {boolean}
         */
        ctrl.getCustomerCardForItem = function (item_id) {
          var itemCard = false;
          if (ctrl.form.customer && angular.isArray(ctrl.customerCards)) {
            ctrl.customerCards.forEach(function (card) {
              if (card.item_id == item_id) {
                itemCard = card;
              }
            })
          }
          return itemCard;
        }

        /**
         * Check if customer has Card for particular Item with positive balance
         *
         * @param item_id
         * @returns {boolean}
         */
        ctrl.hasCustomerCardForItem = function(item_id) {
          var hasCard = false;
          var card = ctrl.getCustomerCardForItem(item_id);
          if(card && card.balance > 0) {
            if (card.expired) {
              hasCard = 'expired';
            } else {
              hasCard = true;
            }
          }
          return hasCard;
        }

        /**
         * Show Card popup
         *
         * @param item
         */
        ctrl.useCardPopup = function (item) {
          var card = ctrl.getCustomerCardForItem(item.id);
          if (card.expired) {
            swal({
              text: $translate.instant('SWAL_CARD_EXPIRED_TEXT'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 3000
            });
            return;
          }

          ctrl.cashboxLoading = true;
          $uibModal.open({
            templateUrl: "app/modules/cashbox/popup/use-card.form.html",
            controller: "CashboxUseCardFormController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal small-modal card-balance-edit-modal",
            resolve: {
              Card: function ($api) {
                $log.log('card.id: ' + card.id);
                return $api.resolve("cards.single@get", {"id": card.id});
              },
              Item: function () {
                return item;
              }
            }
          }).result.then(function (data) {
            if(data) {
              for (var i in ctrl.items) {
                if (ctrl.items[i].id == data.item.id && ctrl.items[i].price == data.item.price && !ctrl.items[i].isCard) {
                  ctrl.items[i].card_balance_used = data.card_balance_used;
                  break;
                }
              }
            }
            ctrl.cashboxLoading = false;
          })
        }


        $scope.$on('$messageIncoming', function (event, data){
            if(data.msg == "Ok"){
                ctrl.creditPaymentId = data.value;
                ctrl.completePayment();
            }
            else if(data.msg == "Error"){
                ctrl.currentModal.close();

                var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                  message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                }

                swal({
                    title: message,
                    text: $translate.instant('SWAL_PELECARD_MESSAGE_TEXT'),
                    type: "warning",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 3000
                });
            }

        });

        ctrl.askedStockReturn = false;
        ctrl.stockReturn = false;
        ctrl.confirmStock = function(){
          swal({
            title: "",
            text: $translate.instant('SWAL_STOCK_RETURN_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            ctrl.stockReturn = !!(result.value);
            ctrl.askedStockReturn = true;
            ctrl.newTransaction();
          });
        }

        ctrl.askedCardRefund = false;
        ctrl.confirmCreditRefund = function(){
          swal({
            title: "",
            text: $translate.instant('SWAL_CREDIT_CARD_REFUND_AMOUNT_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if (result.value) {
              ctrl.askedCardRefund = true;
              ctrl.newTransaction();
            }
          });
        }

        ctrl.askedGiftCardRefund = false;
        ctrl.giftCardRefund = false;
        ctrl.confirmGiftCardRefund = function() {
          swal({
            title: "",
            text: $translate.instant('SWAL_GIFT_CARD_REFUND_AMOUNT_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if (result.value) {
              ctrl.askedGiftCardRefund = true;
              ctrl.giftCardRefund = true;
              ctrl.newTransaction();
            }
          });
        }
        

        ctrl.newTransaction = function(){
          if(!ctrl.customerData) {
            ctrl.customerData = {};
          }

          var hasGiftCards = false;
          var hasSaleItem = false;
          var hasGiftCardRefund = false;
          for (var i in ctrl.items) {
            var item = ctrl.items[i];
            if (item.item_type == 'sale') {
              hasSaleItem = true;
            }
            if (item.isGiftCard*1) {
              hasGiftCardRefund = true;
            }

            if (ctrl.items[i].item_type == 'gift_card') {
              hasGiftCards = true;

              if (Math.abs(item.price * 1) > item.balance * 1) {
                swal({
                  title: $translate.instant('SWAL_GIFT_CARD_BALANCE_ERROR_TITLE'),
                  text: $translate.instant('SWAL_GIFT_CARD_BALANCE_ERROR_TEXT', {number: item.number, balance: item.balance, price: Math.abs(item.price)}),
                  type: "error",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                });
                return;
              }
            }
          }

          if (hasGiftCards && ctrl.cashboxTotal < 0) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARD_NEGATIVE_TOTAL_ERROR_TITLE'),
              text: $translate.instant('SWAL_GIFT_CARD_NEGATIVE_TOTAL_ERROR_TEXT'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            });
            return;
          }

          if (typeof ctrl.methods.cheque.payment_details.cheque_due_date == 'object') // Format moment;
            ctrl.methods.cheque.payment_details.cheque_due_date = ctrl.methods.cheque.payment_details.cheque_due_date.format('MM/DD/YYYY');

          if (ctrl.isCreditTransaction && ctrl.methods.credit_card.active && !ctrl.askedCardRefund) {
            ctrl.confirmCreditRefund();
            return;
          }

          if (ctrl.show_stock && ctrl.isCreditTransaction && !ctrl.askedStockReturn && hasSaleItem) {
            ctrl.confirmStock();
            return;
          }

          if (hasGiftCardRefund && ctrl.isCreditTransaction && !ctrl.askedGiftCardRefund) {
            ctrl.confirmGiftCardRefund();
            return;
          }

          ctrl.cashboxLoading = true;
          $api.transactions.save({
            items: ctrl.items,
            methods: ctrl.methods,
            customer: ctrl.form.customer,
            email: ctrl.form.email,
            phone: ctrl.occ_customer ? ctrl.form.customer_occ_phone : ctrl.form.phone,
            customer_name: ctrl.occ_customer ? ctrl.form.customer_occ_name : (ctrl.form.name ? ctrl.form.name : ""),
            isDebtTransaction: ctrl.isDebtTransaction,
            isCreditTransaction: ctrl.isCreditTransaction,
            isCreditCreditCard: ctrl.isCreditCreditCard,
            stockReturn: ctrl.stockReturn,
            giftCardRefund: ctrl.giftCardRefund,
            isOrderTransaction: ctrl.isOrderTransaction,
            isAllPayedByCard: ctrl.isAllPayedByCard(),
            referenceTransaction: (Transaction != null) ? (Transaction.data.id) : (null),
            order_id: Order ? (Order.data.id) : null,
            send_documents: ctrl.customerData.send_documents,
            send_type: ctrl.businessInfo.data.msg_channel_inv_link,
            unique_id_for_creditcard: ctrl.creditPaymentId,
            sendInvoice: ctrl.sendInvoice,
            comment: ctrl.form.comment,
            quotation: ctrl.form.quotation,
            creditCardId: ctrl.creditCardId,
            retainer_id: ctrl.form.retainer_id || null,
            retainer_start_date: ctrl.form.retainer_start_date,
            retainer_period: ctrl.form.retainer_period,
            retainer_count: ctrl.form.retainer_count,
            retainer_infinity: ctrl.form.retainer_infinity,
          },
          function(res){
            if (res.status && res.status == 'error') {
              swal({
                title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
                text: res.message ? res.message : $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TEXT'),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              });
              ctrl.cashboxLoading = false;
              return;
            }

            if(res.file_url && ctrl.customerData.send_documents == 4
              || ( ( ctrl.customerData.send_documents == 0 || ctrl.customerData.send_documents == null ) && ctrl.businessInfo.data.msg_channel_inv_link == 4 )
              || (ctrl.businessInfo.data.print_invoices && !ctrl.form.customer)){
              $scope.receipt_url = res.file_url;
              printJS($scope.receipt_url);
            }

            ctrl.items = [];
            ctrl.cashboxTotal = [];
            ctrl.resetPaymentMethods();

            var successTitle = $translate.instant('SWAL_TRANSACTIONS_SAVE_TITLE');
            if (ctrl.form.quotation) {
              successTitle = $translate.instant('SWAL_TRANSACTIONS_QUOTATION_SAVE_TITLE');
            } else if (ctrl.isCreditTransaction) {
              successTitle = $translate.instant('SWAL_TRANSACTIONS_CREDIT_SAVE_TITLE');
            }

            swal({
              title: successTitle,
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 1500
            });
            $user.go_default_screen();
            ctrl.remove_customer();
            ctrl.cashboxLoading = false;
          },
          function (res) {
            swal({
              title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
              text: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TEXT'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 3000
            });
            ctrl.cashboxLoading = false;
          });
        };

        ctrl.newTransactionPrepare = function(){
          for(var method in ctrl.methods){
            ctrl.recalculatePaymentData(method);
        }
        
          if(!ctrl.customerData) {
            ctrl.customerData = {};
          }

          if (typeof ctrl.methods.cheque.payment_details.cheque_due_date == 'object') // Format moment;
              ctrl.methods.cheque.payment_details.cheque_due_date = ctrl.methods.cheque.payment_details.cheque_due_date.format('MM/DD/YYYY');


          var errorEmv = false; // is ther any errors in script
          /** validate data */
            // payments deal
            if(isNaN(ctrl.numberOfPaymentsEmv)){
              errorEmv = true;
              alert("מספר התשלומים חייב להכיל ערך מספרי");
            }else {
              if (ctrl.numberOfPaymentsEmv != 1) {
                // Number of payments is a number
                if (parseInt(ctrl.numberOfPaymentsEmv) < 1 || parseInt(ctrl.numberOfPaymentsEmv) > 18) {
                  errorEmv = true;
                  alert("מספר התשלומים חייב להיות מספר בין 1 ל- 18");
                }
              }
            }

            if(!errorEmv) {
              
              ctrl.cashboxLoading = true;
              $api.transactions.prepare.save({
                      pay_link: true,
                      items: ctrl.items,
                      methods: ctrl.methods,
                      customer: ctrl.form.customer,
                      email: ctrl.form.email,
                      phone: ctrl.occ_customer ? ctrl.form.customer_occ_phone : ctrl.form.phone,
                      customer_name: ctrl.occ_customer ? ctrl.form.customer_occ_name : (ctrl.form.name ? ctrl.form.name : ""),
                      isDebtTransaction: ctrl.isDebtTransaction,
                      isCreditTransaction: ctrl.isCreditTransaction,
                      isCreditCreditCard: ctrl.isCreditCreditCard,
                      isOrderTransaction: ctrl.isOrderTransaction,
                      isAllPayedByCard: ctrl.isAllPayedByCard(),
                      referenceTransaction: (Transaction != null) ? (Transaction.data.id) : (null),
                      order_id: Order ? (Order.data.id) : null,
                      send_documents: ctrl.customerData.send_documents,
                      send_type: ctrl.businessInfo.data.msg_channel_inv_link,
                      unique_id_for_creditcard: ctrl.creditPaymentId,
                      numberOfPaymentsEmv: ctrl.numberOfPaymentsEmv,
                      sendInvoice: ctrl.sendInvoice,
                      comment: ctrl.form.comment,
                      quotation: ctrl.form.quotation,
                      creditCardId: ctrl.creditCardId,
                      retainer_id: ctrl.form.retainer_id || null,
                  },
                  function(res){
                      ctrl.items = [];
                      ctrl.cashboxTotal = [];
                      ctrl.resetPaymentMethods();
                      swal({
                          title: $translate.instant('SWAL_TRANSACTIONS_SAVE_LINK_TITLE'),
                          text: "",
                          type: "success",
                          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                          timer: 1500
                      });
                      $user.go_default_screen();
                      ctrl.remove_customer();
                      ctrl.cashboxLoading = false;
                  },
                  function (res) {
                      swal({
                          title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
                          text: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TEXT'),
                          type: "error",
                          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                          timer: 3000
                      });
                      ctrl.cashboxLoading = false;
                  });
            }
        };

        ctrl.resetPayment = function(){
            ctrl.cashboxLoading = false;
            $scope.method = ctrl.lastMethod = ctrl.firstPayMethod = undefined;
            ctrl.totalPaid = 0;
            for(var method in ctrl.methods){
              ctrl.methods[method].amount = null;
            }
        };

        ctrl.resetZCredit = function(){
          if (Info.data.cerdit_company == "3") {
            $api.transactions.resetzcredit.get()
          }
        }

          /**
           * Fill all payment details for each payment method
           */
          ctrl.completePayment = function(){
            if($scope.method != null && ctrl.currentModal != null){
                ctrl.currentModal.close();
            }

            var checkedPayMethodsAmount = 0;
            for(var pMethod in ctrl.methods) {
                if (ctrl.methods[pMethod].active) checkedPayMethodsAmount++;
            }

            if (!$scope.method) {
              var isGiftCards = false;
              for (var i in ctrl.items) {
                  if (ctrl.items[i].item_type == 'gift_card') {
                      isGiftCards = true;
                      break;
                  }
              }

              if (isGiftCards && !ctrl.methods.cash.active) {
                ctrl.methods = ctrl.choosePayMethod('cash');
              }
            }

            // Send transaction if all payment details has been already filled
            if($scope.method && $scope.method == ctrl.lastMethod){
                ctrl.newTransaction();
                return;
            }

            if($scope.method == null){
              for(var method in ctrl.methods) {
                  if (ctrl.methods[method].active) {
                      if (!ctrl.firstPayMethod) {
                          ctrl.firstPayMethod = method;
                      }
                      ctrl.lastMethod = method;
                  }
              }
              $scope.method = ctrl.firstPayMethod;

              // Check if only Cash payment method was chosen then do not show additional prompts
              if (ctrl.firstPayMethod == ctrl.lastMethod && (ctrl.firstPayMethod == 'cash' || ctrl.firstPayMethod == 'retainer')) {
                ctrl.methods[ctrl.firstPayMethod].amount = ctrl.cashboxTotal;
                ctrl.recalculatePaymentData(ctrl.firstPayMethod);
                ctrl.newTransaction();
                return;

                // Check if only Items_Card payment method was chosen then do not show additional prompts
              } else if (ctrl.firstPayMethod == ctrl.lastMethod && ctrl.firstPayMethod == 'items_card') {
                ctrl.methods[ctrl.firstPayMethod].amount = ctrl.cashboxTotalByItemsCard;
                ctrl.newTransaction();
                return;
              } else if (ctrl.firstPayMethod == ctrl.lastMethod && ctrl.firstPayMethod == 'pay_link') {
                ctrl.methods[ctrl.firstPayMethod].amount = ctrl.cashboxTotal;
                ctrl.newTransactionPrepare();
                return;
              }


            } else {
                var getNextMethod = false;
                for(var method in ctrl.methods) {
                    if (ctrl.methods[method].active) {
                        if (getNextMethod) {
                            $scope.method = method;
                            break;
                        }
                        if ($scope.method == method) {
                            getNextMethod = true;
                        }
                    }
                }
                if (!$scope.method) {
                    $scope.method = ctrl.firstPayMethod;
                }
            }

            ctrl.totalPaid = 0;
            for(var method in ctrl.methods){
                ctrl.recalculatePaymentData(method);
            }

            if (ctrl.isCreditTransaction && ctrl.methods.credit_card.active) {
              if (ctrl.methods.credit_card.amount > ctrl.isCreditCreditCard.total*1) {
                swal({
                  title: '',
                  text: $translate.instant('SWAL_CREDIT_CARD_REFUND_AMOUNT_ERROR_TEXT'),
                  type: "error",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 3000
                });
                ctrl.resetPayment();
                return;
              }
            }


            var template = "";
            if($scope.method == "credit_card"){
                if (ctrl.isCreditTransaction) {
                  ctrl.newTransaction();
                  return;
                }

                template = "credit.view.html";
                $scope.showContinue = false;

                if (Info.data.cerdit_company == "1") {
                  var tamp = ctrl.useCardReader ? "9" : "6";
                  var customer = ctrl.form.name ? ctrl.form.name : "לקוח לקוח";

                  $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/yaad?credit_suplier=" + Info.data.credit_suplier + "&amount=" + ctrl.methods["credit_card"].amount + "&tmp=" + tamp + "&customer=" + customer + "&b_id=" + Info.data.id);
                } else if (Info.data.cerdit_company == "0") {
                  $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/tranzila?credit_suplier=" + Info.data.credit_suplier + "&amount=" + ctrl.methods["credit_card"].amount);
                } else if (Info.data.cerdit_company == "2") {
                  var cardReader = ctrl.useCardReader ? true : false;
                  $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/pelecard?amount=" + ctrl.methods["credit_card"].amount + "&reader=" + cardReader + "&b_id=" + Info.data.id);
                } else if (Info.data.cerdit_company == "3") {
                  var useIframe = ctrl.useIframe ? true : false;
                  if (useIframe && !ctrl.creditCardId) {
                    ctrl.prepareTransaction(3, true);
                    //$scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/zcredit?amount=" + ctrl.methods["credit_card"].amount + "&b_id=" + Info.data.id + "&iframe=1");
                  } else {
                    if (!ctrl.creditCardId) {
                      if(isNaN(ctrl.numberOfPaymentsEmv)){
                        errorEmv = true;
                        alert("מספר התשלומים חייב להכיל ערך מספרי");
                      }else {
                        if (ctrl.numberOfPaymentsEmv != 1) {
                          // Number of payments is a number
                          if (parseInt(ctrl.numberOfPaymentsEmv) < 1 || parseInt(ctrl.numberOfPaymentsEmv) > 18) {
                            errorEmv = true;
                            alert("מספר התשלומים חייב להיות מספר בין 1 ל- 18");
                          }
                        }
                      }

                      template = "credit_zcard.view.html";
                    } else {
                      template = "";
                    }

                    ctrl.prepareTransaction(3, false);
                  }
                }
              //}
            }else{
                template = "payment.view.html";
            }

            if (template) {
              ctrl.currentModal = $uibModal.open({
                  templateUrl: "app/modules/cashbox/methods/" + template,
                  scope: $scope,
                  windowTopClass: "form-modal small-modal",
                  keyboard  : false
              });
            }
        };

        ctrl.prepareTransaction = function(company, iframe) {
          iframe = iframe || false;
          ctrl.cashboxLoading = true;
          
          $api.transactions.prepare.save(
            {
              items: ctrl.items,
              methods: ctrl.methods,
              customer: ctrl.form.customer,
              email: ctrl.form.email,
              phone: ctrl.occ_customer ? ctrl.form.customer_occ_phone : ctrl.form.phone,
              customer_name: ctrl.occ_customer ? ctrl.form.customer_occ_name : (ctrl.form.name ? ctrl.form.name : ""),
              isDebtTransaction: ctrl.isDebtTransaction,
              isCreditTransaction: ctrl.isCreditTransaction,
              isCreditCreditCard: ctrl.isCreditCreditCard,
              isOrderTransaction: ctrl.isOrderTransaction,
              isAllPayedByCard: ctrl.isAllPayedByCard(),
              referenceTransaction: (Transaction != null) ? (Transaction.data.id) : (null),
              order_id: Order ? (Order.data.id) : null,
              send_documents: ctrl.customerData ? ctrl.customerData.send_documents : false,
              send_type: ctrl.businessInfo.data.msg_channel_inv_link,
              unique_id_for_creditcard: ctrl.creditPaymentId,
              numberOfPaymentsEmv: ctrl.numberOfPaymentsEmv,
              sendInvoice: ctrl.sendInvoice,
              comment: ctrl.form.comment,
              quotation: ctrl.form.quotation,
              creditCardId: ctrl.creditCardId,
              retainer_id: ctrl.form.retainer_id || null,
            },
            function(res) {
              if (res && res.status && res.status == 'success') {
                if (!company) {
    
                  if(res.wskey == null || !res.wskey){
                    $scope.statusShow = "קרתה תקלה בעת ביצוע העסקה";
                  }
                }
                
                if (company == 3 && res.data && res.data.id_hash) {
                  if (iframe) {
                    ctrl.listenPaymentIframe(res.data.id_hash);
                    $rootScope.listenPaymentIframe(res.data.id_hash);
                    $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/zcredit?id_hash="+res.data.id_hash+"&amount=" + ctrl.methods["credit_card"].amount + "&b_id=" + Info.data.id + "&iframe=1");
                  } else {
                    ctrl.listenPaymentIframe(res.data.id_hash);
                    $rootScope.listenPaymentIframe(res.data.id_hash);
                    $api.zcredit.get({"amount": ctrl.methods["credit_card"].amount, "b_id": Info.data.id, "npay": ctrl.numberOfPaymentsEmv, "id_hash": res.data.id_hash, "credit_deal": ctrl.creditDeal, "credit_card_id": ctrl.creditCardId}, function(response) {
                      ctrl.currentModal.close();                      
                    }, function(response) {
                      ctrl.currentModal.close();                      
                    });
                  }
                }
              } else {
                ctrl.currentModal.close();
                ctrl.cashboxLoading = false;

                if (!company) {
                  $scope.statusShow = "המסוף לא מגיב";
                }
              }
            }
          );
        }

        ctrl.listenPaymentIframe = function(hash) {
          var channel = (!pusher.channel('business-'+$rootScope.$user['b_id'])) ? pusher.subscribe('business-'+$rootScope.$user['b_id']) : pusher.channel('business-'+$rootScope.$user['b_id']);
          var eventName = 'iframe-result-'+hash;
          var eventHandler = function(response) {
            console.log(eventName, response);
            if (response) {
                if (response.result == 'success') {

                    var res = response.data;
                    if (res.file_url && ctrl.customerData) {
                      if(ctrl.customerData.send_documents == 4
                          || ((ctrl.customerData.send_documents == 0 || ctrl.customerData.send_documents == null) && ctrl.businessInfo.data.msg_channel_inv_link == 4)
                          || (ctrl.businessInfo && ctrl.businessInfo.data && ctrl.businessInfo.data.print_invoices && !ctrl.form.customer)){
                          $scope.receipt_url = res.file_url;
                          printJS($scope.receipt_url);
                      }
                    }
    
                    ctrl.items = [];
                    ctrl.cashboxTotal = [];
                    ctrl.resetPaymentMethods();
                    $user.go_default_screen();
                    ctrl.remove_customer();
                    ctrl.cashboxLoading = false;
    
                } else if (response.result == 'error') {
                    ctrl.currentModal.close();
                    ctrl.cashboxLoading = false;
                }
            }
          };
    
          channel.bind(eventName, eventHandler);

          ctrl.unsubscribePaymentIframe = function() {
            channel.unbind(eventName, eventHandler);
          };
        }

        $scope.$on('$destroy', function() {
          if (ctrl.unsubscribePaymentIframe) {
              ctrl.unsubscribePaymentIframe();
          }
      });
        
        var channel = (!pusher.channel('business-'+$rootScope.$user['b_id'])) ? pusher.subscribe('business-'+$rootScope.$user['b_id']) : pusher.channel('business-'+$rootScope.$user['b_id']);
        channel.bind('zcredit-event', function(response) {
          ctrl.checkZcreditResponse(response);
        });


        /**
        * Fill payment data
        *
        * @param method
        */
        ctrl.recalculatePaymentData = function(method){
          if(method == $scope.method && method == ctrl.lastMethod) {
              var method_amount = ctrl.cashboxTotal - ctrl.totalPaid;
              ctrl.methods[method].amount = method_amount;
          } else {
              ctrl.totalPaid += ctrl.methods[method].amount;
              var method_amount = ctrl.methods[method].amount;
          }
          var subtotal = (method_amount / (100 + ctrl.dealer_vat)) * 100;
          subtotal = (Math.round(subtotal * 100))/100;
          ctrl.methods[method].subtotal = subtotal;
          var tax = method_amount - subtotal;
          ctrl.methods[method].vat =  tax;
        };


        ctrl.filterCategory = function(c_id){
            ctrl.categoryFilter = c_id;

            if(c_id == -1){
                ctrl.products = Items.data;
                return;
            }

            ctrl.searchItem = "";

            ctrl.products = [];
            var list = Items.data;
            for(var i in list)
                if(list[i].categories != null && list[i].categories.indexOf(c_id) != -1){
                    ctrl.products.push(list[i]);
                }
        };

        ctrl.addItem = function(product){
          if (product.item_type == 'course') {
            $api.courses.cashbox.get({
              id: product.id
            }, function (res) {
              if (res && res.data) {
                product.courses = res.data;
              }
            });
          }

          for(var i in ctrl.items){
              if(ctrl.items[i].id == product.id && ctrl.items[i].price == product.price && !ctrl.items[i].isCard && !ctrl.items[i].card_balance_used){
                  ctrl.items[i].quantity++;
                  return;
              }
          }
          product = JSON.parse(JSON.stringify(product));
          product.quantity = 1;
          product.price = parseFloat(parseFloat(product.price).toFixed(2));

          product.subtotal = (product.price / (100 + ctrl.dealer_vat)) * 100;
          product.subtotal = (Math.round(product.subtotal * 100))/100;
          product.tax = product.price - product.subtotal;
          product.original_price = product.price;

          ctrl.items.push(product);

          if (ctrl.form.quotation) {
            ctrl.resetPaymentMethods();
            ctrl.choosePayMethod('cash');
          }
        };

        ctrl.removeItem = function(index){
          if(!ctrl.isDebtTransaction){
            var item = ctrl.items[index];

            ctrl.items.splice(index, 1);

            if (item && item.item_type == 'gift_card' && item.number) {
              var newSelected = [];
              for (var i = 0; i < ctrl.selectedCards.length; i++) {
                if (ctrl.selectedCards[i].number !== item.number) {
                  newSelected.push(ctrl.selectedCards[i]);
                }
              }
              ctrl.selectedCards = newSelected;
            }

            if (ctrl.selectedCards.length == 0) {
              ctrl.methods['retainer'].disabled = false;
            }
          }
        };

        ctrl.makeCard = function(index) {
          ctrl.cardQty = ctrl.items[index].quantity*1;
          ctrl.cardQtyModel = ctrl.items[index].quantity*1;
          ctrl.cardPerItem = ctrl.items[index].price*1;
          ctrl.cardPerItemModel = ctrl.items[index].price*1;
          ctrl.cardPrice = ctrl.items[index].price*ctrl.cardQty;
          ctrl.expired_at = ctrl.items[index].expired_at;
          ctrl.makeCardIndex = index;

          ctrl.currentModal = $uibModal.open({
              templateUrl: "app/modules/cashbox/methods/card.popup.html",
              scope: $scope,
              windowTopClass: "form-modal small-modal",
              keyboard  : false
          });
        };

        ctrl.makeCardAccept = function() {
            // if (!ctrl.expired_at) {
            //   swal({
            //     text: $translate.instant('SWAL_CARD_EXPIRED_DATE_REQUIRED'),
            //     type: "error",
            //     confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            //     timer: 3000,
            //   });
            //   return
            // }
            
            if (ctrl.items[ctrl.makeCardIndex]) {
              ctrl.items[ctrl.makeCardIndex].isCard = true;
              ctrl.items[ctrl.makeCardIndex].cardQty = ctrl.cardQty*1;
              ctrl.items[ctrl.makeCardIndex].cardPrice = ctrl.cardPrice*1;
              ctrl.items[ctrl.makeCardIndex].price = ctrl.cardPerItem*1;
              ctrl.items[ctrl.makeCardIndex].quantity = ctrl.cardQty*1;
              ctrl.items[ctrl.makeCardIndex].expired_at = ctrl.expired_at;
            }
            ctrl.currentModal.close();
        }

        ctrl.checkAlreadyExistCard = function(index) {
          for (var i in ctrl.items) {
            if (i != index) {
              if (ctrl.items[i].isCard && ctrl.items[index].id == ctrl.items[i].id) {
                return true;
              }
            }
          }
          return false;
        }

        ctrl.roundedPerCardItem = function() {
          return (ctrl.cardQty != 0 && ctrl.cardQty && ctrl.cardPrice) ? (Math.round((ctrl.cardPrice/ctrl.cardQty)*100) / 100) : 0;
        }

        ctrl.changeCardQty = function() {
          if (ctrl.cardQtyModel && ctrl.cardQtyModel > 0) {
            ctrl.cardPrice = Math.round((ctrl.cardPerItem * ctrl.cardQtyModel)*100)/100;
          } else {
            ctrl.cardPrice = ctrl.cardPerItem;
          }
          ctrl.cardQty = ctrl.cardQtyModel;
          //ctrl.cardPerItem = ctrl.roundedPerCardItem();
        }

        ctrl.changeCardPerItem = function() {
          if (ctrl.cardPerItemModel && ctrl.cardPerItemModel > 0) {
            ctrl.cardPrice = Math.round((ctrl.cardPerItemModel * ctrl.cardQty)*100)/100;
          } else {
            ctrl.cardPrice = 0
          }
          ctrl.cardPerItem = ctrl.cardPerItemModel;
        }

        ctrl.changeCardPrice = function() {
          if (ctrl.cardPrice && ctrl.cardPrice > 0) {
            ctrl.cardPerItemModel = ctrl.roundedPerCardItem();
            ctrl.cardPerItem = ctrl.roundedPerCardItem();
          } else {
            ctrl.cardPerItemModel = 0;
            ctrl.cardPerItem = 0;
          }
        }

        ctrl.trigger_items_update = function(newValue, oldValue){
            if(newValue != oldValue && !ctrl.isManuallyEditingTotal){
                ctrl.cashboxTotal = 0;
                ctrl.cashboxTotalByItemsCard = 0;
                
                for (var i in ctrl.items) {
                  if(ctrl.items[i].card_balance_used > ctrl.items[i].quantity) {
                    ctrl.items[i].card_balance_used = ctrl.items[i].quantity;
                  }
                  var amountWithoutCards = ctrl.items[i].card_balance_used && !ctrl.items[i].isCard
                    ? ctrl.items[i].quantity - ctrl.items[i].card_balance_used
                    : ctrl.items[i].quantity;
                  ctrl.cashboxTotal += (ctrl.items[i].price) * amountWithoutCards;
                  ctrl.cashboxTotalByItemsCard += (ctrl.items[i].price) *  (ctrl.items[i].quantity - amountWithoutCards);

                  //console.log(Order.data);
                  //console.log(ctrl.items[i]);
                }

                if (!ctrl.prepaid && ctrl.isCreditTransaction && (Transaction && Transaction.data && Transaction.data.prepaid)) {
                  ctrl.cashboxTotal = Transaction.data.total;
                }

                if(ctrl.isDebtTransaction && ctrl.cashboxTotal > ctrl.maxDebt) {
                    ctrl.items[0].price = ctrl.maxDebt;


                    ctrl.items[0].subtotal = (ctrl.items[0].quantity / (100 + ctrl.dealer_vat)) * 100;
                    ctrl.items[0].subtotal = (Math.round(ctrl.items[0].subtotal * 100))/100;
                    ctrl.items[0].tax = ctrl.items[0].price - ctrl.items[0].subtotal;
                    // ctrl.items[0].tax = (Math.round(ctrl.items[0].tax * 100))/100;

                    swal({
                        title: $translate.instant('SWAL_CASHBOX_UPDATE_TITLE'), 
                        html: $translate.instant('SWAL_CASHBOX_UPDATE_TEXT').replace('[price]', $filter('price')(ctrl.maxDebt)),
                        type: "info",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }
            }
        };

        $scope.$watch("ctrl.items", ctrl.trigger_items_update, true);

        $scope.$watch("ctrl.searchItem", function(newValue, oldValue){
            if(oldValue != newValue){

                ctrl.categoryFilter = -1;

                if(ctrl.searchItem == "") {
                    ctrl.products = Items.data;
                    return;
                }

                ctrl.products = [];
                var list = Items.data;
                for(var i in list){
                    if(list[i].name.indexOf(ctrl.searchItem) != -1){
                        ctrl.products.push(list[i]);
                    }
                }
            }
        });

        var check_oncredit_customer = function(){
            if(ctrl.methods.oncredit.active == true && !ctrl.form.customer){
                swal({
                    title: $translate.instant('SWAL_CHECK_ONCREDIT_TITLE'),
                    text: $translate.instant('SWAL_CHECK_ONCREDIT_TEXT'),
                    type: "info",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                ctrl.methods.oncredit.active = false;
            }
        };

        $scope.$watch("ctrl.form.customer", check_oncredit_customer);
        $scope.$watch("ctrl.methods.oncredit.active", check_oncredit_customer);

        $header.title = "קופה";
        $header.breadcrumbs.push({
            "title": "קופה"
        });

        /**
         * Check if customer payed by his Items Cards for all order
         *
         * @returns {boolean}
         */
        ctrl.isAllPayedByCard = function() {
          var isAllPayedByCard = true;
          if(ctrl.items && ctrl.items.length > 0) {
            ctrl.items.forEach(function (item) {
              if(!item.card_balance_used || item.quantity != item.card_balance_used) {
                isAllPayedByCard = false;
              }
            });
          } else {
            isAllPayedByCard = false;
          }
          ctrl.methods['items_card'].active =  isAllPayedByCard ? true : false;

          return isAllPayedByCard;
        }

        ctrl.isAllPayedByGiftCards = function() {
          var total = 0;

          for (var i = 0; i < ctrl.items.length; i++) {
            var it = ctrl.items[i];
            total += it.price * 1;
          }

          return total == 0;
        }

        if(Transaction != null){
            ctrl.isCreditTransaction = true;
            ctrl.load_credit_data();

            if (Transaction.data.customer_data) {
              ctrl.customerData = Transaction.data.customer_data;
              ctrl.customerData.oncredit = parseFloat(ctrl.customerData.oncredit);
              ctrl.form.customer = String(ctrl.customerData.id);
            } else {
              ctrl.form.customer = null;
              if (Transaction.data.customer_name) {
                ctrl.occ_customer = true;
                ctrl.form.customer_occ_name = Transaction.data.customer_name;
                ctrl.form.customer_occ_phone = Transaction.data.customer_phone;
              }
            }

            if (Transaction.data.payments) {
              for (var i in Transaction.data.payments) {
                if (Transaction.data.payments[i].allow_credit && ctrl.cerdit_company == 3) {
                  ctrl.isCreditCreditCard = Transaction.data.payments[i];
                }
              }
            }

            ctrl.update_transaction_customer_data();

            $header.title += " - זיכוי עסקה";
            $header.breadcrumbs.push({
                "title" : "זיכוי עסקה"
            });
        }

        /**
         * Initiate dept data for closing the dept
         */
        if ($state.current.name == 'app.cashbox.closedebt' && $stateParams.customer) {
          ctrl.isDebtTransaction = true;
          ctrl.form.customer = $stateParams.customer;
          ctrl.customerData = Customer.data;
          ctrl.update_transaction_customer_data();

          ctrl.maxDebt = parseFloat(parseFloat(ctrl.customerData.oncredit).toFixed(2));
          ctrl.items.push({
            quantity: 1,
            price: ctrl.maxDebt,
            name: "יתרת לקוח"
          });
          ctrl.trigger_items_update(true, false);

          $header.title += " - כיסוי יתרה";
          $header.breadcrumbs.push({
            "title": "כיסוי יתרה"
          });
        }


        ctrl.load_order_data = function(){

            ctrl.isOrderTransaction = true;
            ctrl.prepaid = Order.data.prepaid;

            if(Order.data.customer ) {
                ctrl.form.customer = String(Order.data.customer);
                ctrl.customerData = Order.data.customer_data;
                ctrl.checkCustomerCards = true;
                ctrl.update_transaction_customer_data();
            }

            ctrl.form.email = Order.data.email;
            ctrl.form.phone = Order.data.phone;
            if(!ctrl.form.customer) {
                ctrl.form.name = Order.data.customer_name;
                ctrl.form.customer_occ_name = Order.data.customer_name;
                ctrl.form.customer_occ_phone = Order.data.customer_phone;
            }

            var newItem, duration;

            ctrl.items = [];

            ctrl.bu_type = parseInt(Info.data.type);
            for(var i in Order.data.items){
                if (Order.data.items[i].part) {
                  continue;
                }

                var increasedPresentItemQuantity = false;
                newItem = Order.data.items[i].item_data;
                newItem.quantity = parseFloat(newItem.quantity);
                if(newItem.item_type == 'service')
                    newItem.quantity = 1;
                newItem.in_order = true;
                newItem.price = (newItem.price == '' || newItem.price == null) ? 0 : parseFloat(parseFloat(newItem.price).toFixed(2));
                newItem.original_price = newItem.price;

                // Merge duplicate with equal prices
                ctrl.items.forEach(function (item, index) {
                  if(ctrl.items[index].id === newItem.id && ctrl.items[index].price == newItem.price && ctrl.items[index].resource_id == Order.data.items[i].resource_id) {
                    ctrl.items[index].quantity++;
                    increasedPresentItemQuantity = true;
                  }
                })

                var subtotal = (newItem.price / (100 + ctrl.dealer_vat)) * 100;
                subtotal = (Math.round(subtotal * 100))/100;
                newItem.subtotal = subtotal;
                newItem.tax = newItem.price - subtotal;
                
                newItem.resource = Order.data.items[i].resource_id+'';
                for (var i in ctrl.resources) {
                  if (ctrl.resources[i].id+'' == newItem.resource) {
                    if (!ctrl.resources[i].sales_active) {
                      newItem.resource = '';
                    }
                  }
                }
                // newItem.tax = (Math.round(newItem.tax * 100))/100;

                if(ctrl.bu_type == 2){
                    newItem.quantityDisabled = true;
                }

                if(ctrl.bu_type == 2){
                    Order.data.items[i].start_time = moment(Order.data.items[i].start_time);
                    Order.data.items[i].end_time = moment(Order.data.items[i].end_time);
                    duration = moment.duration(Order.data.items[i].end_time.diff(Order.data.items[i].start_time));
                    if(newItem.item_type == 'service')
                        newItem.quantity = Math.round(duration.asDays());
                }

                if(!increasedPresentItemQuantity)
                  ctrl.items.push(newItem);
            }

            if (Order.data.prepaid) {
              var subtotal = (Order.data.prepaid*1 / (100 + ctrl.dealer_vat)) * 100;
              subtotal = (Math.round(subtotal * 100))/100;
              var tax = Order.data.prepaid*1 - subtotal;

              ctrl.items.push({
                item_duration: null,
                item_id: null,
                item_type: "prepaid",
                name: "מקדמה",
                original_price: Order.data.prepaid*-1,
                price: Order.data.prepaid*-1,
                quantity: 1,
                subtotal: subtotal*-1,
                tax: tax*-1,
              });
            }

            ctrl.trigger_items_update(false, true);

            $header.title += " - סגירת הזמנה";
            $header.breadcrumbs.push({
                "title" : "סגירת הזמנה"
            });
        };

        ctrl.load_retainer_data = function() {
          ctrl.form.retainer_id = Retainer.data.id ? String(Retainer.data.id) : null;
          ctrl.creditCardId = Retainer.data.credit_card_id ? String(Retainer.data.credit_card_id) : null;
          ctrl.form.customer = Retainer.data.customer_id || null;
          ctrl.form.retainer_start_date = Retainer.data.retainer_start_date ? moment(Retainer.data.retainer_start_date).toDate() : null;
          ctrl.form.retainer_count = Retainer.data.retainer_count || null;
          ctrl.form.retainer_infinity = Retainer.data.retainer_infinity || false;
          ctrl.form.retainer_period = Retainer.data.retainer_period || 'monthly';
          ctrl.cashboxTotal = Retainer.data.transaction_data.total || 0;
          ctrl.sendInvoice = Retainer.data.transaction_data.sendInvoice ? true : false;

          ctrl.customerData = Retainer.data.transaction_data.customer_data;
          ctrl.update_transaction_customer_data();

          ctrl.items = [];
          for(var i in Retainer.data.transaction_data.items) {
            ctrl.items.push(Retainer.data.transaction_data.items[i]);
          }

          for(var i in Retainer.data.transaction_data.payments) {
            ctrl.methods[i] = Retainer.data.transaction_data.payments[i];
          }

          ctrl.disableRemainingPayMethods();
        }

          /**
           * Toggle payment method
           *
           * @param method
           */
        ctrl.choosePayMethod = function(method){
            if(ctrl.items.length > 0 && !ctrl.methods[method].disabled) {
                ctrl.methods[method].active = !ctrl.methods[method].active;
            }

            ctrl.disableRemainingPayMethods();
            return ctrl.methods
        };

          /**
           * Disable other payment methods if 2 of them already was chosen.
           * If less than 2, then enable.
           */
        ctrl.disableRemainingPayMethods = function() {
            var checkedPayMethodsAmount = 0;
            for(var pMethod in ctrl.methods) {
                if (ctrl.methods[pMethod].active) checkedPayMethodsAmount++;
            }

            var isDisabled = true;
            if(checkedPayMethodsAmount < 2) {
                isDisabled = false;
          }
            for(pMethod in ctrl.methods) {
                if (!ctrl.methods[pMethod].active) ctrl.methods[pMethod].disabled = isDisabled;
            }

            if (ctrl.methods['credit_card'].active) {
                ctrl.methods['credit_card_external'].disabled = true
                ctrl.methods['pay_link'].disabled = true
                ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['pay_link'].active) {
              ctrl.methods['credit_card_external'].disabled = true
              ctrl.methods['credit_card'].disabled = true
              ctrl.methods['oncredit'].disabled = true
              ctrl.methods['cash'].disabled = true
              ctrl.methods['cheque'].disabled = true
              ctrl.methods['bank_transfer'].disabled = true
              ctrl.methods['items_card'].disabled = true
              ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['credit_card_external'].active) {
                ctrl.methods['credit_card'].disabled = true
                ctrl.methods['pay_link'].disabled = true
                ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['credit_card'].active ||
                ctrl.methods['oncredit'].active ||
                ctrl.methods['cash'].active ||
                ctrl.methods['cheque'].active ||
                ctrl.methods['bank_transfer'].active ||
                ctrl.methods['items_card'].active
              ) {
              ctrl.methods['pay_link'].disabled = true
              ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['retainer'].active) {
              ctrl.methods['credit_card'].disabled = true
              ctrl.methods['pay_link'].disabled = true
              ctrl.methods['oncredit'].disabled = true
              ctrl.methods['cash'].disabled = true
              ctrl.methods['cheque'].disabled = true
              ctrl.methods['bank_transfer'].disabled = true
              ctrl.methods['items_card'].disabled = true
              ctrl.methods['credit_card_external'].disabled = true
            }
        }

          /**
           * Makes Payment button disabled
           *
           * @returns {boolean}
           */
        ctrl.isDisabledPaymentBtn = function() {
            return  (ctrl.isDebtTransaction && ctrl.cashboxTotal > ctrl.maxDebt)
                || ctrl.cashboxTotal == 0
                || (!ctrl.methods.cash.active && !ctrl.methods.credit_card.active && !ctrl.methods.oncredit.active
                    && !ctrl.methods.cheque.active && !ctrl.methods.credit_card_external.active && !ctrl.methods.pay_link.active && !ctrl.methods.bank_transfer.active && !ctrl.methods.retainer.active)
                || (ctrl.methods.retainer.active && (!ctrl.form.retainer_start_date || !ctrl.creditCardId || !ctrl.form.retainer_period || (!ctrl.form.retainer_count && !ctrl.form.retainer_infinity)))
                || (ctrl.isCardItemPresent() && (!ctrl.customerData || angular.equals(ctrl.customerData, {}))
                || (ctrl.creditDeal && (ctrl.numberOfPaymentsEmv*1 < 3 || ctrl.numberOfPaymentsEmv*1 > 18)));
        }

        /**
        * Check if user going to buy item with type 'card'
        *
        * @returns {boolean}
        */
        ctrl.isCardItemPresent = function () {
          var isCardItemPresent = false;
          ctrl.items.forEach(function (item) {
              if(item.item_type == 'card') {
                  isCardItemPresent = true;
              }
          })

          return isCardItemPresent;
        }

        ctrl.isDisabledPaymentBtn();

          /**
           * Check if payment details is invalid
           * @returns {boolean}
           */
        ctrl.paymentDetailsInvalid = function() {
            if($scope.method == 'cheque' || $scope.method == 'bank_transfer') {
                if(!ctrl.methods[$scope.method].payment_details.bank_number) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Mark Item with card indicator property if customer has appropriate Card
         */
        ctrl.matchCardsForItems = function() {
          for(var i in ctrl.products) {
            if(ctrl.hasCustomerCardForItem(ctrl.products[i].id)) {
              ctrl.products[i].customer_has_card = true;
            } else {
              ctrl.products[i].customer_has_card = false;
            }
          }
        };

        ctrl.paymentDetailsInvalid();



        if(Order){
            ctrl.load_order_data();
        }

        if (Retainer) {
          ctrl.load_retainer_data();
        }

        ctrl.changePercentage = function(index, total) {
          if (!total) {
            ctrl.total_discount = '';
          }

          var originalItem = false;
          for (var i in ctrl.products) {
            if (ctrl.items[index] && ctrl.products[i].id == ctrl.items[index].id) {
              originalItem = ctrl.products[i];
            }
          }

          var original_price = ctrl.items[index].original_price ? ctrl.items[index].original_price : originalItem.price;

          if (ctrl.items[index].discount && ctrl.items[index].discount > 0) {
            ctrl.items[index].price = Math.round((original_price * (1 - ctrl.items[index].discount*1 / 100))*100)/100;
          } else if (ctrl.items[index].original_price) {
            ctrl.items[index].price = original_price;
          }
        };

        ctrl.changePrice = function(index) {
          if ((ctrl.items[index].discount && ctrl.items[index].discount > 0) || ctrl.show_discount) {
            var originalItem = false;
            for (var i in ctrl.products) {
              if (ctrl.items[index] && ctrl.products[i].id == ctrl.items[index].id) {
                originalItem = ctrl.products[i];
              }
            }

            var original_price = ctrl.items[index].original_price ? ctrl.items[index].original_price : originalItem.price;

            var discount = Math.round((1 - ctrl.items[index].price / original_price)*10000)/100;
            if (discount && discount > 0) {
              ctrl.items[index].discount = discount;
            } else {
              ctrl.items[index].discount = '';
            }
          }
        }

        ctrl.changeTotalPercentage = function() {
          ctrl.items.forEach(function (item, index) {
            item.discount = item.card_balance_used ? item.discount : ctrl.total_discount;
            ctrl.changePercentage(index, true);
          });
        }

        ctrl.changeTotalSum = function() {
          if (!ctrl.cashboxTotal) {
            return;
          }

          // Set flag to prevent automatic recalculation while editing
          ctrl.isManuallyEditingTotal = true;

          var originalTotal = 0;
          ctrl.items.forEach(function (item) {
            originalTotal += item.original_price * ((item.quantity || 1) - (item.card_balance_used || 0));
          });

          if (ctrl.cashboxTotal > originalTotal) {
            ctrl.cashboxTotal = originalTotal;
          }

          var totalDiscount = (originalTotal - (ctrl.cashboxTotal || 0)) / originalTotal * 100;
          ctrl.total_discount = !totalDiscount || totalDiscount < 0 ? '' : parseFloat(totalDiscount).toFixed(2)*1;
          ctrl.changeTotalPercentage();
          
          // Reset flag after a short delay to allow normal recalculation later
          setTimeout(function() {
            ctrl.isManuallyEditingTotal = false;
          }, 100);
        }
    });

    angular.module("app.controllers").controller("BanksSelectController", function ($scope, $state, Banks, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;
        ctrl.banks = Banks;
        ctrl.item_name = "";


        /**
         * search item
        */
        $scope.find_item = function(forceEmptySearch) {
            if( ctrl.item_name != "" || forceEmptySearch) {
                var found = [];
                for (var i in Banks) {
                    if (Banks[i].name && Banks[i].name.toLowerCase().indexOf(ctrl.item_name.toLowerCase()) >= 0) {
                        found.push(Banks[i]);
                    }
                }
                ctrl.banks = found;
            } else {
                ctrl.banks = Banks;
            }

            if ($('#res_dt').DataTable()) {
              $('#res_dt').DataTable().clear().draw();
            }
        }

        $scope.find_item(true);



        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('scrollY', '500px')
            .withOption('aaSorting', [])
            .withOption('searching', false)
            .withOption('info', false)
            .withOption('paging', false);

        ctrl.selectBank = function (index) {
            $uibModalInstance.close(ctrl.banks[index]);
        }

    });

    function parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair.shift());
        var value = decodeURIComponent(pair.join("="));
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
          query_string[key] = value;
          // If second entry with this name
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], value];
          query_string[key] = arr;
          // If third or later entry with this name
        } else {
          query_string[key].push(value);
        }
      }
      return query_string;
    }
})();

(function () {

    angular.module('app.controllers')

        .controller('UsersListController', function (Users, $state, $header, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            var ctrl = this;

            /**
             * Assign data to the table
             */
            ctrl.tableData = Users.data;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "משתמשים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.admin"
            });
            $header.breadcrumbs.push({
                "title": "משתמשים"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider);

        });

})();

(function() {

    angular.module("app.controllers").controller("UsersFormController", function($scope, $state, $api, $rootScope, dates, Businesses, User, $uibModal, $translate) {

        if ($rootScope.userRole !== 1){
          $state.go('app.dashboard');
          return;
        }

        var ctrl = this;

        ctrl.form = {};

        ctrl.user_roles = [
          {title: 'USER_ROLE_MANAGER', key: 0},
          {title: 'USER_ROLE_EMPLOYEE', key: 2},
          {title: 'USER_ROLE_EMPLOYEE_PERMISSION', key: 3}
        ];
        ctrl.resources = [];
        

        $scope.formScreen = 0;
        $scope.isMobile = (angular.element(document).width() < 769)

        $scope.isEdit = false;
        if ($rootScope.b_id) {
          $scope.b_id = $rootScope.b_id;
          delete $rootScope.b_id;
        }

        /**
         * Initialize edit data
         */
        if(User != null) {
            $scope.isEdit = true;
            ctrl.form = User.data;
            ctrl.form.password = "";
            ctrl.form.b_id = String(User.data.b_id);
            ctrl.form.role = String(User.data.role);
            ctrl.form.resource_id = String(User.data.resource_id);
        } else {
          ctrl.form.b_id = String($scope.b_id);
          ctrl.form.role = '0'; // Set manager role as default.
        }

        if (Businesses){

          ctrl.businesses = Businesses.data;
        } else {
          ctrl.businesses = [];
        }

        for (var i in ctrl.businesses) {
            if (ctrl.businesses[i].id*1 == ctrl.form.b_id*1)
                ctrl.name_business = ctrl.businesses[i].name;
        }

        ctrl.showBusinessList = function() {
            $uibModal.open({
                templateUrl: "app/modules/admin/modules/users/modules/popup/business.popup.html",
                controller: "BusinessSelectController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal medium-modal",
                resolve: {
                    Businesses: [function () {
                        return ctrl.businesses;
                    }]
                }
            }).result.then(function (business) {
                if(business) {
                    ctrl.form.b_id = business.id;
                    ctrl.name_business = business.name;
                }
            });
        }



        /**
         * Triggers when users form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(User == null)
                /**
                 * In case it's a new customer form
                 */
                $api.users.save(ctrl.form, function(response){
                    if(response.status === 'success') {
                        swal({
                            title: $translate.instant('SWAL_ADMIN_USERS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.admin.users", {}, {reload: true});
                    }
                });
            else {

                if($scope.formScreen == 0 && (ctrl.form.password != "" || ctrl.form.email != User.data.email)) {
                    $scope.formScreen = 1;
                    return;
                }

                /**
                 * In case it's an edit form
                 */
                $api.users.single.save({
                    id: User.data.id
                }, ctrl.form, function(response){
                    if(response.success) {
                        swal({
                            title: $translate.instant('SWAL_ADMIN_USERS_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.formScreen = 0;
                        $state.transitionTo("app.admin.users", {id: User.data.id}, {reload: true});
                    }
                });
            }
        };

        /**
         * Triggers user delete
         */
        ctrl.delete = function () {

            if($scope.formScreen == 0) {
                $scope.formScreen = 2;
                return false;
            }

            $api.users.single.delete({id: User.data.id}, function(response) {
                if(response.success) {
                    swal({
                        title: $translate.instant('SWAL_ADMIN_USERS_DELETE_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.admin.users", {}, {reload: true});
                }
            });
        };

        ctrl.business_change = function(index) {
            ctrl.roleChange();    
        };

        ctrl.roleChange = function() {
            ctrl.resources = [];
            if (ctrl.form.role == 3) {
                $api.businesses.resources.get({id: ctrl.form.b_id}, function(response) {
                    if (response.success) {
                        ctrl.resources = response.resources;
                    }
                });
            }
        };

        ctrl.roleChange();
    });


    angular.module("app.controllers").controller("BusinessSelectController", function ($scope, $state, Businesses, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        var ctrl = this;
        ctrl.businesses = Businesses;

        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('scrollY', '500px')
            .withOption('aaSorting', [])
            .withOption('searching', true)
            .withOption('info', false)
            .withOption('paging', false);

        ctrl.selectBusiness = function (index) {
            $uibModalInstance.close(ctrl.businesses[index]);
        }

    });

})();

(function () {
    angular.module('app.controllers')
        .controller('LogsListController', function (Logs, $api, $state, $header, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole !== 1) {
                $state.go('app.dashboard');
                return;
            }

            var ctrl = this;
            ctrl.date = moment();
            ctrl.type = "all";

            ctrl.tableData = Logs.data ? Logs.data.logs : [];
            ctrl.displayDate = "";

            ctrl.datePickerPrev = function() {
                ctrl.date = moment(ctrl.date).add(-1, "days");
            };

            ctrl.datePickerNext = function() {
                ctrl.date = moment(ctrl.date).add(1, "days");
            };

            $scope.$watch("ctrl.date", function(newValue, oldValue) {
                if (document.activeElement) {
                    if (!document.querySelector('.inputs-wrapper .date-picker-date-time')) {
                        document.activeElement.blur();
                    }
                }
                ctrl.get_logs();
            });

            ctrl.change_type = function(type) {
                ctrl.type = type;
                ctrl.get_logs();
            };

            ctrl.get_logs = function() {
                ctrl.tableData = [];
                $api.logs.get({
                    date: moment(ctrl.date).format("YYYY-MM-DD"),
                    type: ctrl.type
                }, function(data) {
                    if (data.success) {
                        ctrl.tableData = data.data.logs;
                        if ($('#res_dt').DataTable()) {
                            $('#res_dt').DataTable().clear().draw();
                          }
                    }
                });
            }

            $header.title = "משתמשים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.admin"
            });
            $header.breadcrumbs.push({
                "title": "משתמשים"
            });

            $scope.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip')
                .withLanguage(dataTablesHebrewProvider)
                .withOption('searching', false)
                .withOption('pageLength', 100)
                .withOption('autoWidth', false)
                .withOption('responsive', true)
                .withPaginationType('full_numbers');
        });
})();

(function () {

  angular.module('app.controllers')
    .controller('CustomFieldsListController', function (CustomFields, $state, $header, $scope, $api, $customFields, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $translate) {

      if ($rootScope.userRole !== 1) {
        $state.go('app.dashboard');
        return;
      }

      var ctrl = this;
      ctrl.types = $customFields.getTypes();
      ctrl.tableData = CustomFields.data;

      $header.title = 'Custom fields';
      $header.breadcrumbs.push({
        title: 'הגדרות',
        state: 'app.admin'
      });

      $header.breadcrumbs.push({
        title: 'Custom fields'
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withLanguage(dataTablesHebrewProvider)
        .withOption('columnDefs', [
          { targets: -1, orderable: false }
        ]);

      ctrl.getCurrentName = function (names) {
        var currentLocale = $rootScope.currentLanguage ? $rootScope.currentLanguage : 'en_US';
        var data = JSON.parse(names);

        var result = data[currentLocale];
        if (!data[currentLocale]) {
          var values = Object.keys(data).map(function (key) {
            return data[key];
          });

          for (var i = 0; i < values.length; i++) {
            if (values[i] && values[i].trim()) {
              result = values[i];
              break;
            }
          }
        }
        return result;
      };

      ctrl.getBusinesses = function (businesses) {
        return businesses.map(function (business) {
          return business.name;
        }).join(', ');
      };

      ctrl.getType = function (key) {
        var typeTitle = key;

        for (var i = 0; i < ctrl.types.length; i++) {
          if (ctrl.types[i].key === key) {
            typeTitle = ctrl.types[i].title;
            break;
          }
        }

        return typeTitle;
      };

      ctrl.editItem = function (id) {
        $state.go('app.admin.custom-fields.edit', { id: id });
      };

      ctrl.removeItem = function (id) {
        swal({
          title: "",
          text: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_DELETE_CONFIRM_TEXT'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function(result) {
          if (result.value) {
            $api.customFields.single.delete({ id: id }, function (response) {
              if (response.success) {
                swal({
                  title: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_DELETE_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.admin.custom-fields", {}, { reload: true });
              }
            });
          }
        });
      };
    });
})();

(function () {

  angular.module('app.controllers')
    .controller('CustomFieldsFormController', function ($scope, $state, $api, $rootScope, Businesses, CustomField, $customFields, $uibModal, $timeout, $translate) {

    if ($rootScope.userRole !== 1) {
      $state.go('app.dashboard');
      return;
    }

    $timeout(function() {
      $('.v2').parent().find('.chosen-container').addClass('v2');
    }, 100);

    $scope.isMobile = (angular.element(document).width() < 769)

    var ctrl = this;
    ctrl.availableLocales = $rootScope.availableLocales;
    ctrl.requiredLocales = ['hb_ISR', 'en_US'];

    ctrl.types = $customFields.getTypes();

    ctrl.isEdit = false;
    ctrl.form = {};
    ctrl.selectedBusinesses = [];

    if (CustomField != null) {
      ctrl.isEdit = true;
      ctrl.form = CustomField.data;
      ctrl.form.name = JSON.parse(ctrl.form.name);
    }

    ctrl.businesses = [];
    if (Businesses) {
      ctrl.businesses = Businesses.data.map(function (business) {
        return {
          id: business.id,
          name: business.name
        };
      });

      if (ctrl.isEdit) {
        for (var i = 0; i < ctrl.form.businesses.length; i++) {
          var selected = ctrl.form.businesses[i];
          var found = null;
      
          for (var j = 0; j < ctrl.businesses.length; j++) {
            if (ctrl.businesses[j].id === selected.id) {
              found = ctrl.businesses[j];
              break;
            }
          }
      
          ctrl.selectedBusinesses.push(found || selected);
        }
      }
    }

    ctrl.isLocalRequired = function (locale) {
      return ctrl.requiredLocales.indexOf(locale) !== -1;
    }

    ctrl.showBusinessList = function () {
      $uibModal.open({
        templateUrl: "app/modules/admin/modules/users/modules/popup/business.popup.html",
        controller: "BusinessSelectController",
        controllerAs: "ctrl",
        scope: $scope,
        windowTopClass: "form-modal medium-modal",
        resolve: {
          Businesses: [function () {
            return ctrl.businesses;
          }]
        }
      }).result.then(function (business) {
        if (business) {
          ctrl.form.b_id = business.id;
          ctrl.name_business = business.name;
        }
      });
    }

    
    ctrl.submit = function () {
      if (ctrl.selectedBusinesses.length == 0) {
        return;
      }

      ctrl.form.businesses = ctrl.selectedBusinesses.map(function (business) {
        return business.id;
      });

      if (CustomField == null) {
        $api.customFields.save(ctrl.form, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.admin.custom-fields", {}, { reload: true });
          }
        });
      } else {
        $api.customFields.single.save({
          id: CustomField.data.id
        }, ctrl.form, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_SAVE_EDIT_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.admin.custom-fields", { id: CustomField.data.id }, { reload: true });
          }
        });
      }
    };
  });


  angular.module("app.controllers").controller("BusinessSelectController", function ($scope, $state, Businesses, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

    var ctrl = this;
    ctrl.businesses = Businesses;

    $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('pageLength', 100)
      .withOption('scrollY', '500px')
      .withOption('aaSorting', [])
      .withOption('searching', true)
      .withOption('info', false)
      .withOption('paging', false);

    ctrl.selectBusiness = function (index) {
      $uibModalInstance.close(ctrl.businesses[index]);
    }

  });

})();

(function () {

    angular.module('app.controllers')

        .controller('SmsLogsController', function (Logs, $state, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.tableData = Logs && Logs.data ? Logs.data : [];

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_SMS_LOGS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]).withOption('columnDefs', [
                { targets: [2, 3], width: 'auto' }
            ]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = Logs && Logs.data ? Logs.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }
        });
})();

(function () {

    angular.module('app.controllers')

        .controller('SecondResourcesSingleController', function (SecondResource, Info, $api, $state, $scope, $header, $filter, $date, $rootScope, dates, $stateParams, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.loading = false;

            ctrl.request = null;

            ctrl.b_settings = Info.data;

            ctrl.resource_view_types = [
              {
                title: 'RESOURCES_SHIFTS_VIEW_BUSINESS',
                value: 1
              },
              {
                title: 'RESOURCES_SHIFTS_VIEW_CUSTOMERS',
                value: 2
              }
            ];

            if(typeof $rootScope.capacityType != "undefined") {
              ctrl.resource_view_type = $rootScope.capacityType;
            } else {
              ctrl.resource_view_type = ctrl.resource_view_types[1].value;
            }

            $scope.second_resource = SecondResource.data;
            ctrl.edit_params = {id: $scope.second_resource.id};

            $rootScope.capacityData = SecondResource.data.capacity;

            $scope.datesProvider = dates;

            /**
             * In case capacity ID wasn't found
             */

            if (SecondResource.status == "failed")
                $state.transitionTo("app.settings.resources", {}, { reload: true });

            /**
             * Open capcity form
             */
            ctrl.capacityForm = function(time) {
                $rootScope.capacityID = SecondResource.data.id;
                $rootScope.capacityDate = $filter("date")(time*1000, "yyyy-MM-dd");
                $rootScope.capacityType = ctrl.resource_view_type;
                $state.transitionTo("app.settings.second_resources.capacity", {id: SecondResource.data.id}, { reload: true });
            };

            /**
             * Load data when change is made
             */
            ctrl.loadData = function(date) {

                ctrl.loading = true;

                if(ctrl.request != null)
                    ctrl.request.$cancelRequest();

                ctrl.request = $api.second_resources.capacity.get({
                    "id": SecondResource.data.id,
                    "date": date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    "capacity_type": ctrl.resource_view_type
                }, function(response) {

                    $rootScope.capacityData = response.data;

                    ctrl.loading = false;

                    ctrl.request = null;
                });
            };

            /**
             * Define page date settings
             */

            $scope.$watch("ctrl.capacityDate", function (newValue, oldValue) {
                if (newValue != oldValue) {
                    newValue = new Date(newValue);
                    ctrl.initDisplayDate(newValue);
                }
            });

            ctrl.initDisplayDate = function (date) {

                var
                    Sunday = $date.getSunday(date),
                    Saturyday = $date.getSaturday(date);

                ctrl.displayDate =
                    (Saturyday.getDate() < 10 ? ("0" + Saturyday.getDate()) : (Saturyday.getDate()))
                    + "/" +
                    ((Saturyday.getMonth() + 1) < 10 ? ("0" + (Saturyday.getMonth() + 1)) : ((Saturyday.getMonth() + 1)))
                    + "/" +
                    Saturyday.getFullYear();

                ctrl.displayDate += " - ";

                ctrl.displayDate +=
                    (Sunday.getDate() < 10 ? ("0" + Sunday.getDate()) : (Sunday.getDate()))
                    + "/" +
                    ((Sunday.getMonth() + 1) < 10 ? ("0" + (Sunday.getMonth() + 1)) : ((Sunday.getMonth() + 1)))
                    + "/" +
                    Sunday.getFullYear();

                ctrl.loadData(Sunday);
            };

            ctrl.nextWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() + (3600 * 24 * 7 * 1000));
            };

            ctrl.prevWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() - (3600 * 24 * 7 * 1000));
            };

            ctrl.displayDate = "";

            if(typeof $rootScope.capacityID == typeof undefined || $rootScope.capacityID == null)
                ctrl.initDisplayDate(new Date());
            else {
                $rootScope.wrapperClasses = "wrapper wrapper-content";
                ctrl.initDisplayDate(new Date($rootScope.capacityDate));
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים - <b>" + SecondResource.data.name + "</b>";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            }, {
                "title": "משאבים",
                "state": "app.settings.second_resources"
            }, {
                "title": SecondResource.data.name
            });

            /**
             * Customer delete
             */
            ctrl.delete = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_RESOURCE_DELETE_CONFIRM_TEXT').replace('[name]', SecondResource.data.name),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.second_resources.single.delete({ id: SecondResource.data.id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_RESOURCE_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.settings.second_resources", {}, { reload: true });
                            }
                        });
                });
            };

            //Config for selectize (categories)
            $scope.userConfig = {
              create: true,
              sortField: 'text'
            };

          ctrl.changeShiftsView = function() {
              if(typeof ctrl.capacityDate == typeof undefined)
                ctrl.initDisplayDate(new Date());
              else {
                ctrl.initDisplayDate(new Date(ctrl.capacityDate));
              }
            }
        });

})();

(function () {

    angular.module('app.controllers')

        .controller('SecondResourcesListController', function (SecondResources, $state, $header, $api, Info, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.bu_type = parseInt(Info.data.type);
            ctrl.second_resource = Info.data.second_resource;
            ctrl.second_resource_name = Info.data.second_resource_name;

            /**
             * Changing the state to the single customer state
             * @param {int} customer_id Customer ID
             * @return {void} void
             */
            ctrl.open_resource_card = function(resource_id) {
                if(ctrl.bu_type == 1) {
                    $state.transitionTo("app.settings.second_resources.single", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                } else {
                    $state.transitionTo("app.settings.second_resources.edit", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                }
            };

            /**
             * Assign data to the table
             */
            ctrl.tableData = SecondResources.data;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "משאבים"
            });

            ctrl.search_value = "";
            ctrl.find_table = function() {
                //reset data
                ctrl.tableData = SecondResources.data;
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                            found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }

                var found = [];
            }

            ctrl.drop = function(){
                var order = [];
                for(var i in ctrl.tableData) {
                    order.push(ctrl.tableData[i].id);
                }
                $api.second_resources.save({ordering: order}, function(response){
                    if(response.status === "success"){
                    }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("SecondResourcesFormController", function($scope, $state, $api, dates, SecondResource, DeleteButton, $rootScope, $resource, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            status: 1,
            is_default: "false",
          sales_active: 1,
          hide_online: 0,
        };

        ctrl.DeleteButton = DeleteButton;

        /**
         * Initialize edit data
         */
        if(SecondResource != null) {
          ctrl.form = SecondResource.data;
          ctrl.form.is_default = "" + ctrl.form.is_default;
          ctrl.form.sales_active = (ctrl.form.sales_active) ? 1 : 0;
          ctrl.form.hide_online = ctrl.form.hide_online;
          ctrl.form.worker_avatar = ctrl.form.avatar ? ctrl.form.avatar : 'assets/images/avatar.jpg';
        }



        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(SecondResource == null)
                /**
                 * In case it's a new customer form
                 */
                $api.second_resources.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RESOURCES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.second_resources", {}, {reload: true});
                    }
                });
            else {
                /**
                 * In case it's an edit form
                 */


                if (ctrl.form.open_orders && ctrl.form.open_orders*1 > 0 && !ctrl.form.sales_active) {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_RESOURCES_SAVE_HAVE_ORDERS_TEXT'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        showCancelButton: true,
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    }).then(function(result) {
                        if(result.value) {
                            ctrl.send();
                        }
                    });
                } else {
                    ctrl.send();
                }
            }
        };

        ctrl.send = function() {
            $api.second_resources.single.save({
                id: SecondResource.data.id
            }, ctrl.form, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCES_SAVE_EDIT_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.go("^", {id: SecondResource.data.id}, {reload: true});
                }
            });
        };

        /**
         * Customer delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_RESOURCES_DELETE_CONFIRM_TEXT').replace('[name]', Resource.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: "אישור",
                cancelButtonText: "ביטול",
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.second_resources.single.delete({ id: SecondResource.data.id }, function (response) {
                        if (response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_RESOURCES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.second_resources", {}, { reload: true });
                        }
                    });
            });
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name  == 'worker_avatar' ? 'worker_avatar' : 'logo';
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            fdata.append("worker_id", ctrl.form.id);
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
            }, function(error){
                console.log(error);
            });
        };

    });

})();

(function () {

    angular.module("app.controllers").controller("SecondResourcesCapacityController", function ($scope, $state, $api, dates, $rootScope, CapacityData, $filter, $stateParams, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(CapacityData == null) {
            $state.transitionTo("app.settings.second_resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
            return;
        }

        ctrl.formScreen = 0;

        ctrl.form = {
            start_time: "08:00",
            end_time: "16:00",
            shift2_start_time: "08:00",
            shift2_end_time: "16:00",
            start_date: $rootScope.capacityDate,
            end_date: $rootScope.capacityDate,
            has_end_date: "0"
        };

        console.log($stateParams.date);

        $scope.datesProvider = dates;

        /**
         * Apply saved data on "ctrl.form" variable
         */
        ctrl.initFormData = function() {

            ctrl.form.start_time = $filter("hourAndMinute")(CapacityData.data.start_time);
            ctrl.form.end_time = $filter("hourAndMinute")(CapacityData.data.end_time);

            if(CapacityData.data.shift2_start_time) {
                ctrl.form.shift2_start_time = $filter("hourAndMinute")(CapacityData.data.shift2_start_time);
                ctrl.form.shift2_end_time = $filter("hourAndMinute")(CapacityData.data.shift2_end_time);
            }

            ctrl.form.end_date = CapacityData.data.end_date ?  CapacityData.data.end_date : ctrl.form.end_date;
            ctrl.form.has_second_shift = CapacityData.data.shift2_start_time ? true : false;
            ctrl.form.has_end_date = CapacityData.data.end_date ? "1" : "0";
        };

        /**
         * Initialize edit data
         */
        if (CapacityData.data != null)
            if (CapacityData.data.start_time != null)
                ctrl.initFormData();

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.submit = function () {
            ctrl.form.has_shifts = true;
            $api.second_resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.second_resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.delete = function () {

            ctrl.initFormData();
            ctrl.form.has_shifts = false;
            $api.second_resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_DELETE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.second_resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('ResourcesSingleController', function (Resource, Info, $api, $state, $scope, $header, $filter, $date, $rootScope, dates, $stateParams, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.loading = false;

            ctrl.request = null;

            ctrl.b_settings = Info.data;

            ctrl.resource_view_types = [
              {
                title: 'RESOURCES_SHIFTS_VIEW_BUSINESS',
                value: 1
              },
              {
                title: 'RESOURCES_SHIFTS_VIEW_CUSTOMERS',
                value: 2
              }
            ];

            if(typeof $rootScope.capacityType != "undefined") {
              ctrl.resource_view_type = $rootScope.capacityType;
            } else {
              ctrl.resource_view_type = ctrl.resource_view_types[1].value;
            }

            $scope.resource = Resource.data;
            ctrl.edit_params = {id: $scope.resource.id};

            $rootScope.capacityData = Resource.data.capacity;

            $scope.datesProvider = dates;

            /**
             * In case capacity ID wasn't found
             */

            if (Resource.status == "failed")
                $state.transitionTo("app.settings.resources", {}, { reload: true });

            /**
             * Open capcity form
             */
            ctrl.capacityForm = function(time) {
                $rootScope.capacityID = Resource.data.id;
                $rootScope.capacityDate = $filter("date")(time*1000, "yyyy-MM-dd");
                $rootScope.capacityType = ctrl.resource_view_type;
                $state.transitionTo("app.settings.resources.capacity", {id: Resource.data.id}, { reload: true });
            };

            /**
             * Load data when change is made
             */
            ctrl.loadData = function(date) {

                ctrl.loading = true;

                if(ctrl.request != null)
                    ctrl.request.$cancelRequest();

                ctrl.request = $api.resources.capacity.get({
                    "id": Resource.data.id,
                    "date": date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    "capacity_type": ctrl.resource_view_type
                }, function(response) {

                    $rootScope.capacityData = response.data;

                    ctrl.loading = false;

                    ctrl.request = null;
                });
            };

            /**
             * Define page date settings
             */

            $scope.$watch("ctrl.capacityDate", function (newValue, oldValue) {
                if (newValue != oldValue) {
                    newValue = new Date(newValue);
                    ctrl.initDisplayDate(newValue);
                }
            });

            ctrl.initDisplayDate = function (date) {

                var
                    Sunday = $date.getSunday(date),
                    Saturyday = $date.getSaturday(date);

                ctrl.displayDate =
                    (Saturyday.getDate() < 10 ? ("0" + Saturyday.getDate()) : (Saturyday.getDate()))
                    + "/" +
                    ((Saturyday.getMonth() + 1) < 10 ? ("0" + (Saturyday.getMonth() + 1)) : ((Saturyday.getMonth() + 1)))
                    + "/" +
                    Saturyday.getFullYear();

                ctrl.displayDate += " - ";

                ctrl.displayDate +=
                    (Sunday.getDate() < 10 ? ("0" + Sunday.getDate()) : (Sunday.getDate()))
                    + "/" +
                    ((Sunday.getMonth() + 1) < 10 ? ("0" + (Sunday.getMonth() + 1)) : ((Sunday.getMonth() + 1)))
                    + "/" +
                    Sunday.getFullYear();

                ctrl.loadData(Sunday);
            };

            ctrl.nextWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() + (3600 * 24 * 7 * 1000));
            };

            ctrl.prevWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() - (3600 * 24 * 7 * 1000));
            };

            ctrl.displayDate = "";

            if(typeof $rootScope.capacityID == typeof undefined || $rootScope.capacityID == null)
                ctrl.initDisplayDate(new Date());
            else {
                $rootScope.wrapperClasses = "wrapper wrapper-content";
                ctrl.initDisplayDate(new Date($rootScope.capacityDate));
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים - <b>" + Resource.data.name + "</b>";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            }, {
                "title": "משאבים",
                "state": "app.settings.resources"
            }, {
                "title": Resource.data.name
            });

            /**
             * Customer delete
             */
            ctrl.delete = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_RESOURCE_DELETE_CONFIRM_TEXT').replace('[name]', Resource.data.name),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.resources.single.delete({ id: Resource.data.id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_RESOURCE_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.settings.resources", {}, { reload: true });
                            }
                        });
                });
            };

            //Config for selectize (categories)
            $scope.userConfig = {
              create: true,
              sortField: 'text'
            };

          ctrl.changeShiftsView = function() {
              if(typeof ctrl.capacityDate == typeof undefined)
                ctrl.initDisplayDate(new Date());
              else {
                ctrl.initDisplayDate(new Date(ctrl.capacityDate));
              }
            }
        });

})();

(function() {

    angular.module("app.controllers").controller("ResourcesPermissionsController", function($scope, $state, $api, Resource, $rootScope, $resource, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        if ($rootScope.userRole != 0){
            $state.go('app.dashboard', {}, {reload: true});
            return;
        }

        var ctrl = this;
        
        ctrl.default_permissions = {
            dashboard: {enabled: true},
            customers: {enabled: true, personal: false},
            leads: {enabled: true},
            calendar: {enabled: true, personal: false},
            cashbox: {enabled: true},
            business_settings: {enabled: true},
            workers: {enabled: true},
            reports: {enabled: true},
            marketing: {enabled: true},
            business_analysis: {enabled: true},
			hide_prices: {enabled: false},
        };

        ctrl.form = {
        };


        /**
         * Initialize edit data
         */
        if(Resource != null) {
          ctrl.form.permissions = ctrl.default_permissions;
          var permissions = Resource.data.permissions ? Resource.data.permissions : false;
          if (permissions) {
            for (var i in permissions) {
                if (ctrl.default_permissions[i]) {
                    ctrl.form.permissions[i].enabled = permissions[i].enabled;
                    ctrl.form.permissions[i].personal = permissions[i].personal;
                }
            }
          }
        }


        ctrl.submit = function() {

            if(Resource != null) {
                $api.resources.permissions.save({
                    id: Resource.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RESOURCES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.go("^", {id: Resource.data.id}, {reload: true});
                    }
                });
            }
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('ResourcesListController', function (Resources, $state, $header, $api, Info, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;
            ctrl.show_inactive = false;

            ctrl.bu_type = parseInt(Info.data.type);

            /**
             * Changing the state to the single customer state
             * @param {int} customer_id Customer ID
             * @return {void} void
             */
            ctrl.open_resource_card = function(resource_id) {
                if(ctrl.bu_type == 1) {
                    $state.transitionTo("app.settings.resources.single", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                } else {
                    $state.transitionTo("app.settings.resources.edit", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                }
            };

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "משאבים"
            });

            ctrl.search_value = "";
            ctrl.find_table = function () {
                var search = ctrl.search_value ? ctrl.search_value.toLowerCase() : '';
                var showInactive = ctrl.show_inactive;

                var filteredData = [];
                for (var i = 0; i < Resources.data.length; i++) {
                    var item = Resources.data[i];
                    var isInactive = item.status * 1 === 0 && item.sales_active * 1 === 0;
                    var isActive = item.status * 1 === 1 || item.sales_active * 1 === 1;

                    if ((isInactive && showInactive) || (isActive && !showInactive)) {
                        if (search) {
                            var found = false;
                            for (var key in item) {
                                if (
                                    item.hasOwnProperty(key) &&
                                    item[key] != null &&
                                    item[key].toString().toLowerCase().indexOf(search) !== -1
                                ) {
                                    found = true;
                                    break;
                                }
                            }
                            if (found) {
                                filteredData.push(item);
                            }
                        } else {
                            filteredData.push(item);
                        }
                    }
                }

                ctrl.tableData = filteredData;
            };

            ctrl.drop = function(){
                var order = [];
                for(var i in ctrl.tableData) {
                    order.push(ctrl.tableData[i].id);
                }
                $api.resources.save({ordering: order}, function(response){
                    if(response.status === "success"){
                    }
                });
            };

            ctrl.change_inactive = function () {
                ctrl.find_table();
            }

            ctrl.find_table();
        });
})();

(function() {

    angular.module("app.controllers").controller("ResourcesFormController", function($scope, $state, $api, dates, Resource, DeleteButton, $rootScope, $resource, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            status: 1,
          is_default: "false",
          sales_active: 1,
          hide_online: 0,
        };

        ctrl.DeleteButton = DeleteButton;

        /**
         * Initialize edit data
         */
        if(Resource != null) {
          ctrl.form = Resource.data;
          ctrl.form.is_default = "" + ctrl.form.is_default;
          ctrl.form.sales_active = (ctrl.form.sales_active) ? 1 : 0;
          ctrl.form.hide_online = ctrl.form.hide_online;
          ctrl.form.worker_avatar = ctrl.form.avatar ? ctrl.form.avatar : 'assets/images/avatar.jpg';
        }



        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(Resource == null)
                /**
                 * In case it's a new customer form
                 */
                $api.resources.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RESOURCES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.resources", {}, {reload: true});
                    }
                });
            else {
                /**
                 * In case it's an edit form
                 */

                if (ctrl.form.open_orders && ctrl.form.open_orders*1 > 0 && ctrl.form.status*1 == 0) {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_RESOURCES_SAVE_HAVE_ORDERS_TEXT'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        showCancelButton: true,
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    }).then(function(result) {
                        if(result.value) {
                            ctrl.send();
                        }
                    });
                } else {
                    ctrl.send();
                }
            }
        };

        ctrl.send = function() {
            $api.resources.single.save({
                id: Resource.data.id
            }, ctrl.form, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCES_SAVE_EDIT_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.go("^", {id: Resource.data.id}, {reload: true});
                }
            });
        };


        /**
         * Customer delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_RESOURCES_DELETE_CONFIRM_TEXT').replace('[name]', Resource.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: "אישור",
                cancelButtonText: "ביטול",
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.resources.single.delete({ id: Resource.data.id }, function (response) {
                        if (response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_RESOURCES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.resources", {}, { reload: true });
                        }
                    });
            });
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name  == 'worker_avatar' ? 'worker_avatar' : 'logo';
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            fdata.append("worker_id", ctrl.form.id);
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
            }, function(error){
                console.log(error);
            });
        };

    });

})();

(function () {

    angular.module("app.controllers").controller("ResourcesCapacityController", function ($scope, $state, $api, dates, $rootScope, CapacityData, $filter, $stateParams, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(CapacityData == null) {
            $state.transitionTo("app.settings.resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
            return;
        }

        ctrl.formScreen = 0;

        ctrl.form = {
            start_time: "08:00",
            end_time: "16:00",
            shift2_start_time: "08:00",
            shift2_end_time: "16:00",
            start_date: $rootScope.capacityDate,
            end_date: $rootScope.capacityDate,
            has_end_date: "0"
        };

        $scope.datesProvider = dates;

        /**
         * Apply saved data on "ctrl.form" variable
         */
        ctrl.initFormData = function() {

            ctrl.form.start_time = $filter("hourAndMinute")(CapacityData.data.start_time);
            ctrl.form.end_time = $filter("hourAndMinute")(CapacityData.data.end_time);

            if(CapacityData.data.shift2_start_time) {
                ctrl.form.shift2_start_time = $filter("hourAndMinute")(CapacityData.data.shift2_start_time);
                ctrl.form.shift2_end_time = $filter("hourAndMinute")(CapacityData.data.shift2_end_time);
            }

            ctrl.form.end_date = CapacityData.data.end_date ?  CapacityData.data.end_date : ctrl.form.end_date;
            ctrl.form.has_second_shift = CapacityData.data.shift2_start_time ? true : false;
            ctrl.form.has_end_date = CapacityData.data.end_date ? "1" : "0";
        };

        /**
         * Initialize edit data
         */
        if (CapacityData.data != null)
            if (CapacityData.data.start_time != null)
                ctrl.initFormData();

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.submit = function () {
            ctrl.form.has_shifts = true;
            $api.resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.delete = function () {

            ctrl.initFormData();
            ctrl.form.has_shifts = false;
            $api.resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_DELETE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('LogsController', function ($scope, $header, $timeout, $api, $log, $compile, DTOptionsBuilder, dataTablesHebrewProvider, $translate, $rootScope, $uibModal, $state) {
            if ($rootScope.userRole == 1) {
                $state.go('app.admin', {}, { reload: true });
                return;
            }

            var ctrl = this;
            ctrl.enabled_retainers = $rootScope.$user.enabled_retainers;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "היסטוריית עסקאות";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_TRANSACTIONS"
            });

            ctrl.open_log_card = function (logData) {
                $state.transitionTo("app.settings.logs.info", {
                    "id": logData.id
                }, {
                    reload: false
                });
            };

            /**
             * Initiate DataTable Options
             */
            ctrl.initDtOptions = function () {
                $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', 20)
                        //.withOption('order', [[1, 'desc']])
                        .withOption('aaSorting', [])
                        .withOption('searching', false)
                        .withOption('ajax', ctrl.loadLogs)
                        .withOption('serverSide', true)
                        .withDataProp('data')
                        .withOption('rowCallback', ctrl.logsRawCallback)
                        .withOption('createdRow', function (row, data, dataIndex) {
                            // Recompiling so we can bind Angular directive to the DT
                            $compile(angular.element(row).contents())($scope);
                        });
            };

            /**
             * Load logs
             *
             * @param data
             * @param callback
             * @param settings
             */
            ctrl.loadLogs = function (data, callback, settings) {
                var orderCol = '';
                var orderDir = '';

                if (data.order.length) {
                    // Use only last order parameters
                    var colIndex = data.order[data.order.length - 1].column
                    orderCol = data.columns[colIndex]['name'];
                    orderDir = data.order[data.order.length - 1].dir;
                }

                var getMethod = ctrl.show_pending_payments ? $api.transactions.pending : (ctrl.show_retainers ? $api.transactions.retainers : $api.transactions);

                getMethod.get(
                    {
                        limit: data.length,
                        offset: data.start,
                        order: orderCol,
                        order_dir: orderDir,
                        search: ctrl.search_value,
                        filter: ctrl.filter,
                    }
                    , function (result) {
                        if (result && result.data) {
                            $log.log(result);

                            callback({
                                recordsTotal: result.recordsTotal,
                                recordsFiltered: result.recordsFiltered,
                                data: result.data,
                                draw: data.draw + 1
                            });
                        }

                    });
            };


            ctrl.search_value = "";
            ctrl.filter = {
                payment_type: '',
            };

            ctrl.show_pending_payments = false;
            ctrl.show_retainers = false;

            ctrl.toggle_retainers = function () {
                ctrl.show_retainers = !ctrl.show_retainers;
                ctrl.show_pending_payments = false;

                ctrl.updateColumns();
                ctrl.initDtOptions();
                // if ($('#logs_dt').DataTable() && $('#logs_dt').DataTable().ajax) {
                //     $('#logs_dt').DataTable().ajax.reload();
                // }
            }

            ctrl.toggle_pending_payments = function () {
                ctrl.show_pending_payments = !ctrl.show_pending_payments;
                ctrl.show_retainers = false;

                ctrl.updateColumns();
                ctrl.initDtOptions();
                // if ($('#logs_dt').DataTable() && $('#logs_dt').DataTable().ajax) {
                //     $('#logs_dt').DataTable().ajax.reload();
                // }
            }

            ctrl.filterModal = false;

            ctrl.openFilter = function () {
                if (!ctrl.filterModal) {
                    $timeout(function () {
                        ctrl.filterModal = true;
                        $('#page-wrapper').addClass('with-filter');
                    });
                }
            }

            ctrl.closeFilter = function () {
                if (ctrl.filterModal) {
                    ctrl.filterModal = false;
                    $('#page-wrapper').removeClass('with-filter');
                }
            }

            ctrl.applyFilter = function () {
                ctrl.find_table();
                ctrl.closeFilter();
            }

            ctrl.clearFilter = function (notSubmit) {

                ctrl.filter = {
                    'date_from': null,
                    'date_to': null,
                    'payment_type': ''
                };
                if (!notSubmit) {
                    ctrl.find_table();
                }
                ctrl.closeFilter();
            }

            ctrl.clearFilter(true);


            ctrl.find_table = function () {
                if ($('#logs_dt').DataTable() && $('#logs_dt').DataTable().ajax) {
                    $('#logs_dt').DataTable().ajax.reload();
                }
            }

            /**
             * Bind events to a new row
             *
             * @param nRow
             * @param aData
             * @param iDisplayIndex
             * @param iDisplayIndexFull
             * @returns {*}
             */
            ctrl.logsRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                if (!ctrl.show_pending_payments && !ctrl.show_retainers) {
                    $(nRow).unbind('click');
                    $(nRow).bind('click', function () {
                        $scope.$apply(function () {
                            ctrl.open_log_card(aData);
                        });
                    });
                }
                
                if (aData.status === 'second_try') {
                    $(nRow).addClass('deleted-row');
                }
                
                return nRow;
            }

            if (window.innerWidth < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 3;
            }

            ctrl.initDtOptions();

            /**
             * Customer table column definitions
             * @type {*[]}
             */
            ctrl.dtColumns = [];

            var documentNumberColumn = {
                name: 'document_number',
                data: null,
                title: $translate('SETTINGS_LOG_TR_NUM'),
                render: function (data, type, full, meta) {
                    return data.document_number +
                        (data.quotation ? "<div class='prepaid-label'>" + $translate.instant('SETTINGS_LOG_QUOTATION_LABEL') + "</div>" : "") +
                        (data.prepaid ? "<div class='prepaid-label show-mobile'>" + $translate.instant('SETTINGS_LOG_PREPAID_LABEL') + "</div>" : "") +
                        (data.payment_type == 9 ? "<div class='prepaid-label show-mobile'>" + $translate.instant('SETTINGS_LOG_PAID_LINK_LABEL') + "</div>" : "");
                }
            };

            var dateColumn = {
                name: 'date',
                data: null,
                title: $translate('SETTINGS_LOG_DATE'),
                render: function (data, type, full, meta) {
                    return moment(data.date, "YYYY-MM-DD").format("DD/MM/YYYY");
                }
            };

            var timeColumn = {
                name: 'date',
                data: null,
                title: $translate('SETTINGS_LOG_TIME'),
                render: function (data, type, full, meta) {
                    return moment(data.date, "YYYY-MM-DD HH:mm").format("HH:mm");
                }
            };

            var totalColumn = {
                name: 'total',
                data: null,
                title: $translate('SETTINGS_LOG_TR_AM'),
                render: function (data, type, full, meta) {
                    return "<div style='direction: ltr; text-align: right;'>" + data.total + "₪</div>";
                }
            };

            var prepaidColumn = {
                name: 'prepaid',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    return (data.prepaid ? "<div class='prepaid-label hide-mobile'>" + $translate.instant('SETTINGS_LOG_PREPAID_LABEL') + "</div>" : "") +
                        (data.payment_type == 9 ? "<div class='prepaid-label hide-mobile'>" + $translate.instant('SETTINGS_LOG_PAID_LINK_LABEL') + "</div>" : "");
                }
            };

            var pendingColumn = {
                name: 'pending',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    return "<div class='prepaid-label hide-mobile'>" + $translate.instant('SETTINGS_LOG_PENDING_PAYMENT_LABEL') + "</div>";
                }
            };

            var customerColumn = {
                name: 'customer_name',
                data: 'customer_name',
                title: $translate('SETTINGS_LOG_CUST_NAME')
            };

            var startDateColumn = {
                name: 'retainer_start_date',
                data: 'retainer_start_date',
                title: $translate('SETTINGS_LOG_RETAINER_START_DATE')
            };

            var nextPaymentDateColumn = {
                name: 'next_withdrawal_date',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_NEXT_PAYMENT_DATE'),
                render: function (data, type, full, meta) {
                    return "<div>" + (data.status === 'second_try' || data.status === 'active' ? (data.second_try_withdrawal_date ? data.second_try_withdrawal_date : data.next_withdrawal_date) : '')+ "</div>";
                }
            };

            var chargetPeriodColumn = {
                name: 'retainer_period',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_PERIOD'),
                render: function (data, type, full, meta) {
                    return "<div>" + (data.retainer_period ? $translate.instant('SETTINGS_LOG_RETAINER_PERIOD_' + data.retainer_period.toUpperCase()) : '') + "</div>";
                }
            };

            var chargesCountColumn = {
                name: 'retainer_count',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_COUNT'),
                render: function (data, type, full, meta) {
                    return "<div>" + (data.retainer_infinity ? $translate.instant('SETTINGS_LOG_RETAINER_INFINITY') : data.retainer_count) + "</div>";
                }
            };

            var chargesWasColumn = {
                name: 'charges_was',
                data: 'charges_was',
                title: $translate('SETTINGS_LOG_RETAINER_CHARGES_WAS')
            };

            var chargesLeftColumn = {
                name: 'charges_left',
                data: 'charges_left',
                title: $translate('SETTINGS_LOG_RETAINER_CHARGES_LEFT')
            };

            var reatinerStatusColumn = {
                name: 'retainer_status',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_STATUS'),
                render: function (data, type, full, meta) {
                    return "<div>" + $translate.instant('SETTINGS_LOG_RETAINER_STATUS_' + data.status.toUpperCase()) + "</div>";
                }
            };

            var buttonsColumn = {
                name: 'buttons',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    var add_details = '';
                    add_details += '<div class="customer-table-icons">';
                    if (data.order_id != null) {
                        add_details += '<a class="btn icon circle small bordered blue" ng-click="ctrl.toEditOrder(\'' + data.order_id + '\');"><i class="las la-eye"></i></a>';
                    }
                    add_details += '<a class="btn icon circle small bordered red" ng-click="ctrl.deleteTransaction(' + data.id + ');"><i class="las la-trash"></i></a>';
                    add_details += '</div>';

                    return add_details;
                }
            };

            var retainerButtonsColumn = {
                name: 'buttons',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    var add_details = '';
                    add_details += '<div class="customer-table-icons">';
                    add_details += '<a class="btn icon circle small bordered blue" ng-click="ctrl.toEditRetainer(\'' + data.id + '\');"><i class="las la-edit"></i></a>';
                    add_details += '<a class="btn icon circle small bordered red" ng-click="ctrl.deleteRetainer(' + data.id + ');"><i class="las la-trash"></i></a>';
                    add_details += '</div>';

                    return add_details;
                }
            };

            ctrl.updateColumns = function () {
                if (ctrl.show_pending_payments) {
                    ctrl.dtColumns = [
                        dateColumn,
                        timeColumn,
                        totalColumn,
                        pendingColumn,
                        customerColumn,
                        buttonsColumn
                    ];
                } else if (ctrl.show_retainers) {
                    ctrl.dtColumns = [
                        dateColumn,
                        timeColumn,
                        totalColumn,
                        customerColumn,
                        startDateColumn,
                        nextPaymentDateColumn,
                        chargetPeriodColumn,
                        chargesCountColumn,
                        chargesWasColumn,
                        chargesLeftColumn,
                        reatinerStatusColumn,
                        retainerButtonsColumn
                    ];
                } else {
                    ctrl.dtColumns = [
                        documentNumberColumn,
                        dateColumn,
                        timeColumn,
                        totalColumn,
                        prepaidColumn,
                        customerColumn
                    ];
                }
            };

            ctrl.updateColumns();

            ctrl.dtInstanceCallback = function (dtInstance) {
                ctrl.dtInstanceLogs = dtInstance;
            };

            ctrl.toEditOrder = function (order_id) {
                $uibModal.open({
                    templateUrl: "app/modules/calendar/order/order.form.html",
                    controller: "OrderFormController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Items: function($api) {
                            return $api.resolve("items.items_with_duration@get");
                        },
                        Customers: function($api) {
                            return $api.resolve("customers@get");
                        },
                        Resources: function($api) {
                            return $api.resolve("resources@get");
                        },
                        SecondResources: function($api) {
                            return $api.resolve("second_resources@get");
                        },
                        Info: function ($api) {
                            return $api.resolve("settings.info@get");
                        },
                        Clubs: function($api) {
                            return $api.resolve("settings.clubs@get");
                        },
                        Customer: function($api) {
                            return null;
                        },
                        Order: function($api) {
                            return $api.resolve("orders.single@get", {
                                "id": order_id
                            });
                        },
                        Messages:  function($api) {
                            return $api.resolve("settings.messages@get");
                        },
                        CalendarCourse: null,
                        CalendarEvent: null,
                        EventCopy: false,
                        CoursesFields: ['$api', function ($api) {
                            return $api.resolve('coursesFields.lists@get');
                        }],
                    }
                });
            };

            ctrl.deleteTransaction = function (id) {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_WAITING_LIST_DELETE_CONFIRM_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function (result) {
                    if (result.value) {
                        $api.transactions.remove.get({ id: id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });

                                ctrl.dtInstanceLogs.reloadData(null, false);
                            }
                        });
                    }
                });
            };

            ctrl.toEditRetainer = function (id) {
                $state.transitionTo("app.cashbox.retainer", { retainerID: id }, {
                    reload: true
                });
            };

            ctrl.deleteRetainer = function (id) {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_WAITING_LIST_DELETE_CONFIRM_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function (result) {
                    if (result.value) {
                        $api.transactions.remove_retainer.get({ id: id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });

                                ctrl.dtInstanceLogs.reloadData(null, false);
                            }
                        });
                    }
                });
            };
        });

})();

(function() {

    angular.module("app.controllers").controller("LogsInfoController", function($scope, Transaction, $rootScope, $state, $api, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.isMobile = (angular.element(document).width() < 769)
        $scope.transaction = Transaction.data;

        ctrl.printInvoice = function(url) {
          printJS(url);
        }

        ctrl.smsInvoice = function(id) {
          $api.transactions.send_sms_invoice.get({id:id},
          function(res){
            swal({
              title: $translate.instant('SWAL_SMS_INVOICE_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 1500
            });
          },
          function (res) {
          });
        }
    });

})();

(function() {

    angular.module("app.controllers").controller("LeadsWhatsappController", function($scope, $state, Statuses, $api, $business, $rootScope, Info, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var tmp_msg_channels = $business.getMsgChannels();
        $scope.msg_channels = [];
        for (var i = 0; i < tmp_msg_channels.length; i++) {
          if (tmp_msg_channels[i].index != 4 && tmp_msg_channels[i].index != 0) {
            $scope.msg_channels.push(tmp_msg_channels[i]);
          }
        }

        var ctrl = this;

        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];
        
        ctrl.form = {
          enabled: Info.data && Info.data.lead_settings && Info.data.lead_settings.whatsapp && Info.data.lead_settings.whatsapp.enabled ? Info.data.lead_settings.whatsapp.enabled : false,
          status: Info.data && Info.data.lead_settings && Info.data.lead_settings.whatsapp && Info.data.lead_settings.whatsapp.status ? Info.data.lead_settings.whatsapp.status :'',
          arrival_source: Info.data && Info.data.lead_settings && Info.data.lead_settings.whatsapp && Info.data.lead_settings.whatsapp.arrival_source ? Info.data.lead_settings.whatsapp.arrival_source :'',
        };


      ctrl.submit = function() {
        if (!Info.data || !Info.data.lead_settings || !Info.data.lead_settings.whatsapp || !Info.data.lead_settings.whatsapp.enabled) {
          ctrl.form.date = moment().format("YYYY-MM-DD HH:mm:ss");
        }
        $api.settings.lead_settings.save({whatsapp: ctrl.form}, function(response){
          if(response.success) {
            swal({
                title: $translate.instant('SETTINGS_LEADS_WHATSAPP_SAVED'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
            });
            $state.transitionTo("app.settings.leads", {}, {reload: true});
          }
        });
      };

      var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}var result=MD5('');console.log(result);var result=MD5('');console.log(result);

      var ID_prefix = MD5(Info.data.id).slice(28,32);
      ctrl.token = ID_prefix + Info.data.id;
    });

})();

(function() {

    angular.module("app.controllers").controller("LeadsWebhookController", function($scope, $state, Statuses, $api, $business, $rootScope, Info, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var tmp_msg_channels = $business.getMsgChannels();
        $scope.msg_channels = [];
        for (var i = 0; i < tmp_msg_channels.length; i++) {
          if (tmp_msg_channels[i].index != 4 && tmp_msg_channels[i].index != 0) {
            $scope.msg_channels.push(tmp_msg_channels[i]);
          }
        }

        var ctrl = this;

        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];

        ctrl.url = 'https://'+window.location.hostname+'/api/leads/action/add';
        
        ctrl.form = {
          status: Info.data && Info.data.lead_settings && Info.data.lead_settings.webhook && Info.data.lead_settings.webhook.status ? Info.data.lead_settings.webhook.status :'',
          arrival_source: Info.data && Info.data.lead_settings && Info.data.lead_settings.webhook && Info.data.lead_settings.webhook.arrival_source ? Info.data.lead_settings.webhook.arrival_source :'',
        };


      ctrl.submit = function() {

        $api.settings.lead_settings.save({webhook: ctrl.form}, function(response){
          if(response.success) {
            swal({
                title: $translate.instant('SETTINGS_LEADS_WEBHOOK_SAVED'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
            });
            $state.transitionTo("app.settings.leads", {}, {reload: true});
          }
        });
      };

      var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}var result=MD5('');console.log(result);var result=MD5('');console.log(result);

      var ID_prefix = MD5(Info.data.id).slice(28,32);
      ctrl.token = ID_prefix + Info.data.id;
    });

})();

(function() {

    angular.module("app.controllers").controller("LeadsStatusesNewController", function($scope, $state, $api, Status, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
            color: '#a9cfe8',
            type: '0',
        };

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(Status != null) {
            $scope.isEdit = true;
            ctrl.form = Status.data;
            ctrl.form.color = ctrl.form.color ? ctrl.form.color : '#a9cfe8';
            ctrl.form.type = String(ctrl.form.type * 1);
        }

        ctrl.submit = function() {

            if(Status == null)
                $api.statuses.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_STATUSES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.leads.statuses", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.statuses.single.save({
                    id: Status.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_STATUSES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.leads.statuses", {}, {reload: true});
                    }
                });
        };

      
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_STATUSES_DELETE_CONFIRM_TEXT').replace('[name]', Status.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.statuses.single.delete({id: Status.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_STATUSES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.leads.statuses", {}, {reload: true});
                        }
                    });
            });
        };
       
    });

})();

(function () {

    angular.module("app.controllers").controller("LeadsStatusesController", function ($scope, $state, $api, $header, Statuses, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider, $translate) {

        if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, { reload: true });
            return;
        }

        var ctrl = this;

        ctrl.tableData = Statuses && Statuses.data ? Statuses.data.map(function (row) {
            row.type = String(row.type * 1);
            return row;
        }) : [];

        /**
         * Module header configuration (title and breadcrumbs)
         */
        $header.title = "פריטים";
        $header.breadcrumbs.push({
            "title": "NAV_SETTINGS",
            "state": "app.settings"
        });
        $header.breadcrumbs.push({
            "title": "SETTINGS_LEADS_STATUSES"
        });

        /**
         * Datatable configuration
         */
        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]);

        ctrl.search_value = "";
        ctrl.find_table = function () {
            ctrl.tableData = Statuses && Statuses.data ? Statuses.data : [];
            if (ctrl.search_value) {
                var newData = [];
                for (var i in ctrl.tableData) {
                    var found = false;
                    for (var k in ctrl.tableData[i]) {
                        if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                            found = true;
                        }
                    }

                    if (found) {
                        newData.push(ctrl.tableData[i]);
                    }
                }

                ctrl.tableData = newData;
            }
        };

        ctrl.update = function(item) {
            $api.statuses.single.save({
                id: item.id
            }, item, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_STATUSES_SAVE_EDIT_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }
            });
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('LeadsSettingsController', function ($state, $header, $scope, $api, Info, $business, $translate, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var tmp_msg_channels = $business.getMsgChannels();
            $scope.msg_channels = [];
            for (var i = 0; i < tmp_msg_channels.length; i++) {
            if (tmp_msg_channels[i].index != 4 && tmp_msg_channels[i].index != 0) {
                $scope.msg_channels.push(tmp_msg_channels[i]);
            }
            }

            var ctrl = this;

            ctrl.form = {
                notify: Info.data && Info.data.lead_settings && Info.data.lead_settings && Info.data.lead_settings.notify ? Info.data.lead_settings.notify :[],
            };

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "קטגוריות";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "לידים"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider);

            ctrl.submitSettings = function() {
                $api.settings.lead_settings.save(ctrl.form, function(response){
                    if(response.success) {
                    swal({
                        title: $translate.instant('SETTINGS_LEADS_SAVED'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.leads", {}, {reload: true});
                    }
                });
            };

        });

})();

(function() {

    angular.module("app.controllers").controller("LeadsFacebookController", function($scope, $window, $state, Statuses, $api, $rootScope, Info, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];
        ctrl.pages = Info.data && Info.data.fb_pages ? Info.data.fb_pages : [];
        
        ctrl.form = {
          status: Info.data && Info.data.lead_settings && Info.data.lead_settings.facebook && Info.data.lead_settings.facebook.status ? Info.data.lead_settings.facebook.status :'',
          arrival_source: Info.data && Info.data.lead_settings && Info.data.lead_settings.facebook && Info.data.lead_settings.facebook.arrival_source ? Info.data.lead_settings.facebook.arrival_source :'',
        };

        ctrl.loginFacebook = function() {
          window.FB.login(function(response){
            if (response.authResponse) {

              window.FB.login(function(response){
                $api.fb_auth.save({authResponse: response}, function (response) {
                  $window.location.reload();
                });
              }, {scope: ['pages_show_list', 'leads_retrieval', 'pages_read_engagement', 'ads_management', 'pages_manage_metadata', 'pages_manage_ads', 'email', 'public_profile']});
              
            }
          }, {scope: ['pages_show_list', 'leads_retrieval', 'pages_read_engagement', 'ads_management', 'pages_manage_metadata', 'pages_manage_ads', 'email', 'public_profile', 'business_management']});
        }


      ctrl.submit = function() {
        $api.settings.lead_settings.save({facebook: ctrl.form}, function(response){
          if(response.success) {
            swal({
                title: $translate.instant('SETTINGS_LEADS_FACEBOOK_SAVED'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
            });
            $state.transitionTo("app.settings.leads", {}, {reload: true});
          }
        });
      };

       
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('ItemsListController', function (Items, Categories, $state, $api, $uibModal, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.show_inactive = false;

            ctrl.show_stock = $rootScope.$user.show_stock;

            /**
             * Assign data to the table
             */
            for(var i in Items.data) {
                if(Items.data[i].categories != null) {
                    Items.data[i].categories = String(Items.data[i].categories).replace("{", "[").replace("}", "]");
                    Items.data[i].categories = JSON.parse(Items.data[i].categories);
                }
            }

            $scope.categories = {};

            for(var i in Categories.data)
                $scope.categories[Categories.data[i].id] = Categories.data[i];

            ctrl.data = Items.data;
            ctrl.tableData = [];
            for (var i in ctrl.data) {
                if (ctrl.data[i].item_type != 'card' && ((ctrl.show_inactive && ctrl.data[i].inactive) || (!ctrl.show_inactive && !ctrl.data[i].inactive))) {
                    ctrl.tableData.push({id: ctrl.data[i].id, bg_color: ctrl.data[i].bg_color, item_image: ctrl.data[i].item_image, name: ctrl.data[i].name, price: ctrl.data[i].price, categories: ctrl.data[i].categories, item_type: ctrl.data[i].item_type, stock: ctrl.data[i].stock});
                }
            }
            

            //ctrl.tableData = ctrl.data.filter(function (el) { return el.item_type != 'card' && (ctrl.show_inactive || !el.inactive) });

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_ITEMS"
            });

            /**
             * Datatable configuration
             */
            
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'asc']]).withOption('pageLength', 20);

            ctrl.change_inactive = function () {
                ctrl.tableData = [];
                for (var i in ctrl.data) {
                    if (ctrl.data[i].item_type != 'card' && ((ctrl.show_inactive && ctrl.data[i].inactive) || (!ctrl.show_inactive && !ctrl.data[i].inactive))) {
                        var item = {id: ctrl.data[i].id, bg_color: ctrl.data[i].bg_color, item_image: ctrl.data[i].item_image, name: ctrl.data[i].name, price: ctrl.data[i].price, categories: ctrl.data[i].categories, item_type: ctrl.data[i].item_type, stock: ctrl.data[i].stock};
                        var found = false;
                        if (!ctrl.search_value) {
                            found = true
                        } else {
                            for (var k in item) {
                                if (item[k] && item[k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                    found = true;
                                }
                            }
                        }

                        if (found) {
                            ctrl.tableData.push(item);
                        }
                    }
                }
                
                //$scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'asc']]).withOption('pageLength', 20);
                if ($('#items_dt').DataTable()) {
                    //$('#items_dt').DataTable().clear().draw();
                }
            }

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.change_inactive();
            }


            ctrl.stockModal = function (item_id) {
                $uibModal.open({
                    templateUrl: "app/modules/settings/items/stock/items.stock.html",
                    controller: "ItemsStockController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal small-modal",
                    resolve: {
                        Item: function ($api, $stateParams, $rootScope) {
                            $rootScope.$stateParams = $stateParams;
                            return $api.resolve("items.single@get", {"id": item_id});
                        }
                    }
                }).result.then(function (val) {
                    $api.items_list.get(function(response){
                        if (response.data) {
                            Items.data = response.data;
                            for(var i in Items.data) {
                                if(Items.data[i].categories != null) {
                                    Items.data[i].categories = String(Items.data[i].categories).replace("{", "[").replace("}", "]");
                                    Items.data[i].categories = JSON.parse(Items.data[i].categories);
                                }
                            }
                            ctrl.data = Items.data;
                            ctrl.tableData = [];
                            for (var i in ctrl.data) {
                                if (ctrl.data[i].item_type != 'card' && ((ctrl.show_inactive && ctrl.data[i].inactive) || (!ctrl.show_inactive && !ctrl.data[i].inactive))) {
                                    ctrl.tableData.push({id: ctrl.data[i].id, bg_color: ctrl.data[i].bg_color, item_image: ctrl.data[i].item_image, name: ctrl.data[i].name, price: ctrl.data[i].price, categories: ctrl.data[i].categories, item_type: ctrl.data[i].item_type, stock: ctrl.data[i].stock});
                                }
                            }
                        }
                    });
                });
            }

            ctrl.drop = function(){
                var order = [];
                for(var i in ctrl.tableData) {
                  order.push(ctrl.tableData[i].id);
                }
                $api.items.save({ordering: order}, function(response){
                  if(response.status === "success"){
                  }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("ItemsFormController", function($scope, $state, $api, dates, Item, Items, Info, Categories, Resources, DigitalForms, $rootScope, $translate, $resource) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            duration: "",
            bg_color: "#a9cfe8",
            item_type: 'service',
            customer_allowed_booking: 0,
            inactive: 0,
            digital_form_once: 0,
            digital_form_hour: 1,
            require_online_payment: 0,
            online_payment_type: 1,
            online_payment_amount: '',
            digital_form_option: "order_start",
        };
        ctrl.itemsSelectBoxConfig = {
            create: true,
            sortField: 'text'
        };

        ctrl.business = Info.data;
        
        ctrl.dates = dates;

        ctrl.dfs = DigitalForms.data || [];

        ctrl.resources = Resources.data;

        $scope.isEdit = false;
        $scope.itemId = false;

        ctrl.show_stock = $rootScope.$user.show_stock;

        /**
         * Initialize edit data
         */
        if(Item != null) {
            $scope.isEdit = true;

            $scope.itemId = Item.data.id;

            if(Item.data.categories != null) {
                Item.data.categories = String(Item.data.categories).replace("{", "[").replace("}", "]");
                Item.data.categories = JSON.parse(Item.data.categories);
            }

            ctrl.form.name = Item.data.name;
            ctrl.form.name_second = Item.data.name_second ? Item.data.name_second : '';
            ctrl.form.description = Item.data.description ? Item.data.description : '';
            ctrl.form.item_image = Item.data.item_image ? Item.data.item_image : '';
            ctrl.form.amount = Item.data.amount;
            ctrl.form.price = parseFloat(Item.data.price);
            ctrl.form.categories = Item.data.categories && Item.data.categories[0]?String(Item.data.categories[0]):'';
            ctrl.form.duration = String(Item.data.duration);
            ctrl.form.duration_second = Item.data.duration_second ? String(Item.data.duration_second) : 0;
            ctrl.form.break = Item.data.break ? String(Item.data.break) : 0;
            ctrl.form.item_id = Item.data.item_id;
            ctrl.form.bg_color = String(Item.data.bg_color);
            ctrl.form.item_type = Item.data.item_type;
            ctrl.form.customer_allowed_booking = parseInt(Item.data.customer_allowed_booking);
            ctrl.form.inactive = Item.data.inactive;
            ctrl.form.digital_form_once = Item.data.digital_form_once;
            ctrl.form.require_online_payment = Item.data.require_online_payment;
            ctrl.form.online_payment_type = parseInt(Item.data.online_payment_type);
            ctrl.form.online_payment_amount = parseFloat(Item.data.online_payment_amount);
            ctrl.form.digital_form = Item.data.digital_form ? String(Item.data.digital_form) : '0';
            ctrl.form.digital_form_hour = Item.data.digital_form_hour ? parseFloat(Item.data.digital_form_hour) : 0;
            ctrl.form.digital_form_option = Item.data.digital_form_option ? Item.data.digital_form_option : 'order_start';

            Item.data.resources = Item.data.resources ? JSON.parse(Item.data.resources) : {};
            Item.data.resources_options = Item.data.resources_options ? JSON.parse(Item.data.resources_options) : {};
            
        }
        
        ctrl.form.resources = {};
        ctrl.form.resources_options = {};
        for (var i in ctrl.resources) {
            ctrl.form.resources[ctrl.resources[i].id] = (Item && Item.data && Item.data.resources && Item.data.resources[ctrl.resources[i].id] === false) ? false : true;
            ctrl.form.resources_options[ctrl.resources[i].id] = (Item && Item.data && Item.data.resources_options && Item.data.resources_options[ctrl.resources[i].id] && (Item.data.resources_options[ctrl.resources[i].id].price || Item.data.resources_options[ctrl.resources[i].id].duration)) ? angular.copy(Item.data.resources_options[ctrl.resources[i].id]) : {duration: '', price: ''};
        }

        ctrl.isMobile = (angular.element(document).width() < 769);

        // Get list of existing Items
        Items.$promise.then(function () {
                ctrl.items = Items.data;
                for (var i in ctrl.items) {
                    ctrl.items[i].originalPrice = ctrl.items[i].price;
                    ctrl.items[i].price = parseFloat(parseFloat(ctrl.items[i].price).toFixed(2));
                    ctrl.items[i].quantity = 1;
                }
            },
            // Fail to get Items
            function () {
                ctrl.items = [];
                console.error("Get API Items failed");
            });

        $scope.categories = {};

        for(var i in Categories.data){
            $scope.categories[Categories.data[i].id] = Categories.data[i];
        }

        ctrl.submit = function(){
            ctrl.form.categories = [ctrl.form.categories];
            // ctrl.form.bg_color = $scope.colorConfig.selectedColor;
            if(Item == null)
                /**
                 * In case it's a new customer form
                 */
                $api.items.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_ITEMS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.items", {}, {reload: true});
                    } else if (response.status == "exist") {
                        swal({
                            title: $translate.instant('SWAL_ITEMS_SAVE_EXIST_TITLE'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        });
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.items.single.save({
                    id: Item.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_ITEMS_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.items", {id: Item.data.id}, {reload: true});
                    }
                });
        };

        /**
         * Triggers item delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_ITEMS_DELETE_CONFIRM_TEXT').replace('[name]', Item.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.items.single.delete({id: Item.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_ITEMS_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.items", {}, {reload: true});
                        } else if (response.status == "exist") {
                            swal({
                                title: $translate.instant('SWAL_ITEMS_DELETE_EXIST_TITLE'),
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
            });
        };

        // Handler for item selected event for Cards type
        ctrl.itemSelected = function(item_id) {
            //itemSelected(ctrl.form.item_id)
            ctrl.items.forEach(function (item) {
                if(item.id == item_id){
                    if(item.categories != null) {
                        item.categories = String(item.categories)
                            .replace("{", "[")
                            .replace("}", "]");
                        ctrl.form.categories = String(JSON.parse(item.categories));
                    }
                }
            })
        }


        ctrl.cardTypeSelected = function() {
            ctrl.form.categories = "";
        }

        // config for selectize (categories)
        $scope.userConfig = {
            create: true,
            sortField: 'text'
        };

        $scope.colorConfig = {
            customOptions: {
                size: 30,
                roundCorners: true
            },
            customColors: [
                "#a9cfe8",
                "#7bd148",
                "#5484ed",
                "#46d6db",
                "#7ae7bf",
                "#FF7F50",
                "#DDA0DD",
                "#FF6666"
            ],
            selectedColor: ctrl.form.bg_color
        };

        ctrl.openStockLog = function() {
            $scope.$close({item_id: Item.data.id});
            $state.transitionTo('app.settings.items.stock_log', {id: Item.data.id}, { reload: true });
        }

        ctrl.removeImage = function(type) {
            event.preventDefault();
            ctrl.form[type] = '';
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var reader = new FileReader();

            reader.onload = function(e) {
                var image =  document.createElement('img');
                image.src = e.target.result;
                image.onload = function() {
                    var fdata = new FormData();
                    fdata.append("image", element.files[0], new_file_name);
                    fdata.append("type", element.name);
                    
                    console.log(element.files[0]);
                    $resource($api.baseURL + '/Image/upload', {}, {
                        postWithFile: {
                            method: "POST",
                            params: fdata,
                            transformRequest: angular.identity,
                            headers: {'Content-Type': undefined}
                        }
                    }).postWithFile(fdata).$promise.then(function(response){
                        if (response.image) {
                            ctrl.form[element.name] = response.image;
                        }
                    }, function(error){
                        console.log(error);
                    });
                }
            }

            reader.readAsDataURL(element.files[0]);
        };
    });

})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("ManageResourcesController", function($scope, $uibModalInstance, $api, $translate, Account, Resources) {
        
        var ctrl = this;
        
        ctrl.account = Account;
        ctrl.saveLoading = false;
        ctrl.availableResources = Resources && Resources.data ? Resources.data : [];
        ctrl.selectedResources = [];
        
        // Initialize resources with current sync status
        ctrl.availableResources.forEach(function(resource) {
            // Check if this resource is currently synced with this account
            resource.selected = ctrl.account.resources && ctrl.account.resources.some(function(accResource) {
                return accResource === resource.id;
            });
        });
        
        /**
         * Update selected resources
         */
        ctrl.updateSelectedResources = function() {
            ctrl.selectedResources = ctrl.availableResources.filter(function(resource) {
                return resource.selected;
            });
        };

        // Update selected resources count
        ctrl.updateSelectedResources();
        
        /**
         * Save resources configuration
         */
        ctrl.saveResources = function() {
            ctrl.saveLoading = true;
            
            var resourcesData = {
                resources: ctrl.selectedResources.map(function(resource) {
                    return resource.id;
                })
            };
            
            $api.googlecalendar.resources.save({
                id: ctrl.account.id
            }, resourcesData, function(response) {
                ctrl.saveLoading = false;
                
                if (response.success) {
                    swal({
                        title: $translate.instant('RESOURCES_SAVED_SUCCESS'),
                        text: $translate.instant('RESOURCES_SAVED_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    }).then(function() {
                        $uibModalInstance.close(ctrl.account);
                    });
                } else {
                    swal({
                        title: $translate.instant('RESOURCES_SAVE_ERROR'),
                        text: response.message || $translate.instant('RESOURCES_SAVE_ERROR_DESCRIPTION'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }
            }, function(error) {
                ctrl.saveLoading = false;
                console.error('Resources save error:', error);
                
                swal({
                    title: $translate.instant('RESOURCES_SAVE_ERROR'),
                    text: $translate.instant('RESOURCES_SAVE_ERROR_DESCRIPTION'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };


        /**
         * Disconnect account
         */
        ctrl.disconnectAccount = function() {
            swal({
                title: $translate.instant('DISCONNECT_ACCOUNT_CONFIRM_TITLE'),
                text: $translate.instant('DISCONNECT_ACCOUNT_CONFIRM_TEXT').replace('[email]', ctrl.account.email),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('DISCONNECT'),
                cancelButtonText: $translate.instant('CANCEL'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result.value) {
                    $api.googlecalendar.single.delete({
                        id: ctrl.account.id
                    }, function(response) {
                        if (response.success) {
                            swal({
                                title: $translate.instant('SUCCESS'),
                                text: $translate.instant('ACCOUNT_DISCONNECTED'),
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $uibModalInstance.close(ctrl.account);
                        }
                    }, function(error) {
                        var errorMessage = $translate.instant('ACCOUNT_DISCONNECT_ERROR');
                        if (error && error.data && typeof error.data === 'string' && error.data.includes('<div')) {
                            errorMessage = $translate.instant('API_ENDPOINT_NOT_AVAILABLE');
                        }
                        
                        swal({
                            title: $translate.instant('ERROR'),
                            text: errorMessage,
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                        });
                    });
                }
            });
        };
    });

})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("ConnectAccountController", function($scope, $uibModalInstance, $api, $translate, Resources, GoogleCalendarAccounts, GoogleCalendarService) {
        
        var ctrl = this;
        
        ctrl.authLoading = false;
        ctrl.authSuccess = false;
        ctrl.saveLoading = false;
        ctrl.availableResources = Resources && Resources.data ? Resources.data : [];
        ctrl.googleCalendarAccounts = GoogleCalendarAccounts && GoogleCalendarAccounts.data ? GoogleCalendarAccounts.data : [];
        ctrl.selectedResources = [];
        ctrl.googleAccount = null;
        
        // Initialize resources with selection state
        ctrl.availableResources.forEach(function(resource) {
            resource.selected = false;
        });
        
        /**
         * Authenticate with Google
         */
        ctrl.authenticateWithGoogle = function() {
            ctrl.authLoading = true;
            
            // Check if user is already signed in and token is valid
            if (GoogleCalendarService.isSignedIn()) {
                // Try to get user info with existing token
                GoogleCalendarService.checkAndRefreshToken().then(function(tokenResponse) {
                    // If we have a valid token, try to get user info
                    return GoogleCalendarService.getUserInfo();
                }).then(function(userInfo) {
                    ctrl.authLoading = false;
                    ctrl.authSuccess = true;
                    ctrl.googleAccount = {
                        id: userInfo.getId(),
                        email: userInfo.getEmail(),
                        name: userInfo.getName(),
                        picture: userInfo.getImageUrl()
                    };
                    swal({
                        title: $translate.instant('GOOGLE_AUTH_SUCCESS'),
                        text: $translate.instant('GOOGLE_AUTH_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error) {
                    // If existing token fails, proceed with fresh authentication
                    performFreshAuthentication();
                });
            } else {
                // No valid token, proceed with fresh authentication
                performFreshAuthentication();
            }
            
            function performFreshAuthentication() {
                // Initialize and sign in via Google Identity Services
                GoogleCalendarService.initialize().then(function(){
                    return GoogleCalendarService.signIn();
                }).then(function(result){
                    ctrl.authLoading = false;
                    ctrl.authSuccess = true;
                    // Normalize user data for backend save

                    var existingAccount = ctrl.googleCalendarAccounts.find(function(account) {
                        return account.google_account_id === result.user.getId();
                    });

                    if (existingAccount) {
                        ctrl.authSuccess = false;
                        GoogleCalendarService.signOut();
                        swal({
                            title: $translate.instant('GOOGLE_AUTH_ERROR'),
                            text: $translate.instant('GOOGLE_AUTH_ALREADY_CONNECTED'),
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                        });
                        return;
                    }

                    // Get the token response directly from the service
                    var tokenResponse = window.googleTokenResponse;
                    
                    ctrl.googleAccount = {
                        id: result.user.getId(),
                        email: result.user.getEmail(),
                        name: result.user.getName(),
                        picture: result.user.getImageUrl(),
                        access_token: tokenResponse.access_token,
                        refresh_token: tokenResponse.refresh_token,
                        token_expires_at: tokenResponse.expires_in ? new Date(Date.now() + tokenResponse.expires_in * 1000).toISOString() : null,
                    };
                    
                    swal({
                        title: $translate.instant('GOOGLE_AUTH_SUCCESS'),
                        text: $translate.instant('GOOGLE_AUTH_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error){
                    ctrl.authLoading = false;
                    console.error('Google authentication error:', error);
                    var errorText = (typeof error === 'string') ? error : (error && error.message) ? error.message : $translate.instant('GOOGLE_AUTH_ERROR_DESCRIPTION');
                    
                    // Handle specific error types
                    if (errorText && errorText.includes('Token expired')) {
                        errorText = 'Your Google session has expired. Please try again.';
                    } else if (errorText && errorText.includes('popup_closed')) {
                        errorText = 'Sign-in was cancelled. Please try again.';
                    } else if (errorText && errorText.includes('access_denied')) {
                        errorText = 'Access was denied. Please make sure to grant all required permissions.';
                    } else if (errorText && errorText.includes('popup_blocked')) {
                        errorText = 'Popup was blocked by your browser. Please allow popups for this site and try again.';
                    }
                    
                    swal({
                        title: $translate.instant('GOOGLE_AUTH_ERROR'),
                        text: errorText,
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            }
        };
        
        /**
         * Update selected resources
         */
        ctrl.updateSelectedResources = function() {
            ctrl.selectedResources = ctrl.availableResources.filter(function(resource) {
                return resource.selected;
            });
        };
        
        /**
         * Save account with selected resources
         */
        ctrl.saveAccount = function() {
            if (ctrl.selectedResources.length === 0) {
                swal({
                    title: $translate.instant('NO_RESOURCES_SELECTED'),
                    text: $translate.instant('NO_RESOURCES_SELECTED_DESCRIPTION'),
                    type: "warning",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                return;
            }
            
            ctrl.saveLoading = true;
            
            var accountData = {
                google_account_id: ctrl.googleAccount.id,
                email: ctrl.googleAccount.email,
                name: ctrl.googleAccount.name,
                avatar_url: ctrl.googleAccount.picture,
                access_token: ctrl.googleAccount.access_token,
                refresh_token: ctrl.googleAccount.refresh_token,
                token_expires_at: new Date(ctrl.googleAccount.token_expires_at).toISOString(),
                is_active: true,
                resources: ctrl.selectedResources.map(function(resource) {
                    return resource.id;
                })
            };
            
            $api.googlecalendar.save(accountData, function(response) {
                ctrl.saveLoading = false;
                
                if (response.success) {
                    swal({
                        title: $translate.instant('ACCOUNT_SAVED_SUCCESS'),
                        text: $translate.instant('ACCOUNT_SAVED_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 5000
                    }).then(function() {
                        $uibModalInstance.close(response.account);
                    });
                } else {
                    swal({
                        title: $translate.instant('ACCOUNT_SAVE_ERROR'),
                        text: response.message || $translate.instant('ACCOUNT_SAVE_ERROR_DESCRIPTION'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }
            }, function(error) {
                ctrl.saveLoading = false;
                console.error('Account save error:', error);
                
                swal({
                    title: $translate.instant('ACCOUNT_SAVE_ERROR'),
                    text: $translate.instant('ACCOUNT_SAVE_ERROR_DESCRIPTION'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };
    });

})();

(function () {
  angular.module('app.controllers')
    .controller('GiftCardsTemplatesSettingsController', function ($rootScope, GiftCardsTemplates) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;

      ctrl.templates = [];

      for (var i in GiftCardsTemplates.data) {
        ctrl.templates.push(GiftCardsTemplates.data[i]);
      }
    });
})();

(function () {
  angular.module('app.controllers').controller('GiftCardsTemplateSettingsController', function ($state, $rootScope, $api, $scope, $resource, $translate, GiftCardsTemplate, Info) {
    if ($rootScope.userRole === 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;

    ctrl.settings = {
      name: '',
      page_bg_color: '#EEF3FC',
      card_bg_color: '#ffffff',
      primary_color: '#275A7B',
      text_color: '#1A202C',
      logo: '/assets/images/gift-card-logo.png',
      image: '/assets/images/gift-card-image.png',
      receiver: true,
      sender: true,
      service: true,
      value: true,
      message: true,
    };

    ctrl.isEdit = false;

    if (GiftCardsTemplate != null) {
      ctrl.settings = angular.extend({}, ctrl.settings, GiftCardsTemplate.data);
      ctrl.isEdit = true;
    }

    ctrl.values = {
      number: $translate.instant('DEFAULT_GIFT_CARD_NUMBER'),
      business: $translate.instant('DEFAULT_GIFT_CARD_BUSINESS'),
      address: $translate.instant('DEFAULT_GIFT_CARD_ADDRESS'),
      service: $translate.instant('DEFAULT_GIFT_CARD_SERVICE'),
      receiver: $translate.instant('DEFAULT_GIFT_CARD_RECEIVER'),
      value: $translate.instant('DEFAULT_GIFT_CARD_VALUE'),
      message: $translate.instant('DEFAULT_GIFT_CARD_MESSAGE'),
      sender: $translate.instant('DEFAULT_GIFT_CARD_SENDER'),
    };

    if (Info) {
      ctrl.values.business = Info.data.name || ctrl.values.business;
      ctrl.values.address = Info.data.address || ctrl.values.address;
    }

    ctrl.bumpSettings = function() {
      ctrl.settings = angular.extend({}, ctrl.settings);
    };

    ctrl.resetColors = function() {
      ctrl.settings = {
        page_bg_color: '#EEF3FC',
        card_bg_color: '#ffffff',
        primary_color: '#275A7B',
        text_color: '#1A202C',
        logo: ctrl.settings.logo || '/assets/images/gift-card-logo.png',
        image: ctrl.settings.image || '/assets/images/gift-card-image.png',
        receiver: ctrl.settings.receiver || true,
        sender: ctrl.settings.sender || true,
        service: ctrl.settings.service || true,
        value: ctrl.settings.value || true,
        message: ctrl.settings.message || true,
      };

      ctrl.bumpSettings();
    };

    ctrl.getFilename = function (path) {
      var MAX = 28;

      if (!path || path == '') {
        return $translate.instant('GIFT_CARD_IMAGE_PLACEHOLDER');
      }

      var filename = String(path).split(/[\\/]/).pop();

      if (filename.length <= MAX) {
        return filename;
      }
      
      var dot = filename.lastIndexOf('.');
      var name = (dot > 0) ? filename.slice(0, dot) : filename;
      var ext = (dot > 0) ? filename.slice(dot) : '';

      var endPart = name.slice(-1) + ext;
      var roomForStart = MAX - endPart.length - 3;

      if (roomForStart < 1) {
        return '...' + endPart.slice(-(MAX - 3));
      }

      var startPart = name.slice(0, roomForStart);
      return startPart + '...' + endPart;
    };

    ctrl.removeImage = function (type, $event) {
      if ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }

      ctrl.settings[type] = '';
      ctrl.bumpSettings();
    };

    $scope.uploadImage = function (element) {
      var new_file_name = 'gift_card_' + element.name;
      new_file_name += '_' + Date.now() + '.' + element.files[0].name.split('.').pop();

      var fdata = new FormData();
      fdata.append("image", element.files[0], new_file_name);
      fdata.append("type", element.name);

      $resource($api.baseURL + '/Image/upload', {}, {
        postWithFile: {
          method: "POST",
          params: fdata,
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        }
      }).postWithFile(fdata).$promise.then(function (response) {
        ctrl.settings[element.name] = response.image;
        ctrl.bumpSettings();
      }, function (error) {
        console.log(error);
      });
    };

    ctrl.saveTemplate = function () {
      if (GiftCardsTemplate == null) {
        $api.giftCardTemplate.save(ctrl.settings, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.settings.gift_cards.templates", {}, { reload: true });
          }
        });
      } else {
        $api.giftCardTemplate.single.save({ id: GiftCardsTemplate.data.id }, ctrl.settings, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_SAVE_EDIT_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.settings.gift_cards.templates", { id: GiftCardsTemplate.data.id }, { reload: true });
          }
        });
      }
    };

    ctrl.delete = function () {
      swal({
        title: "",
        text: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_DELETE_CONFIRM_TEXT'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
        confirmButtonClass: "btn-danger",
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value)
          $api.giftCardTemplate.single.delete({ id: GiftCardsTemplate.data.id }, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_DELETE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.gift_cards.templates", {}, { reload: true });
            }
          });
      });
    };
  });
})();

(function () {
  angular.module('app.controllers').controller('GiftCardsSingleSettingsController', function ($scope, $rootScope, $api, $translate, GiftCard, Info, Transactions, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal) {
    if ($rootScope.userRole === 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;

    ctrl.settings = {};
    ctrl.values = {};
    ctrl.balance = 0;
    ctrl.transactions = angular.copy(Transactions.data || []);
    ctrl.tableData = ctrl.transactions;

    if (GiftCard) {
      ctrl.settings.page_bg_color = GiftCard.data.page_bg_color;
      ctrl.settings.card_bg_color = GiftCard.data.card_bg_color;
      ctrl.settings.primary_color = GiftCard.data.primary_color;
      ctrl.settings.text_color = GiftCard.data.text_color;
      ctrl.settings.logo = GiftCard.data.logo;
      ctrl.settings.image = GiftCard.data.image;
      ctrl.settings.sender = GiftCard.data.sender;
      ctrl.settings.receiver = GiftCard.data.receiver;
      ctrl.settings.value = GiftCard.data.value;
      ctrl.settings.service = GiftCard.data.service;
      ctrl.settings.message = GiftCard.data.message;
      ctrl.settings.name = GiftCard.data.name;

      ctrl.values.number = GiftCard.data.number;
      ctrl.values.sender = GiftCard.data.sender_text;
      ctrl.values.receiver = GiftCard.data.gifted_to;
      ctrl.values.value = GiftCard.data.price;
      ctrl.values.service = GiftCard.data.service_text;
      ctrl.values.message = GiftCard.data.message_text;

      ctrl.balance = GiftCard.data.balance;
    }

    if (Info) {
      var address = [];
      if (Info.data.city) {
        address.push(Info.data.city);
      }
      if (Info.data.address) {
        address.push(Info.data.address);
      }
      if (Info.data.home_number) {
        address.push(Info.data.home_number);
      }
      
      ctrl.values.business = Info.data.name;
      ctrl.values.address = address.join(', ');
    }

    ctrl.changeBalanceModal = function () {
      $uibModal.open({
        templateUrl: "app/modules/settings/gift_cards/popup/balance.view.html",
        controller: "GiftCardsBalanceController",
        controllerAs: "ctrl",
        scope: $scope,
        windowTopClass: "form-modal small-modal",
        resolve: {
          GiftCard: [function () {
            return GiftCard.data;
          }],
        }
      }).result.then(function (response) {
        if (response) {
          $api.giftCard.balance.save({ id: response.id }, { balance: response.balance }, function (res) {
            if (res.success) {
              swal({
                title: $translate.instant('SWAL_GIFT_CARDS_BALANCE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });

              ctrl.balance = response.balance;
              ctrl.loadTransactions();
            }
          });
        }
      });
    };

    ctrl.loadTransactions = function () {
      $api.giftCard.transactions.single.get({ id: GiftCard.data.id }, function (res) {
        ctrl.transactions = angular.copy(res.data || []);
        ctrl.tableData = ctrl.transactions;
      });
    };

    /**
     * Datatable configuration
     */
    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('order', [[0, 'asc']])
      .withOption('pageLength', 20);

  });
})();

(function () {
  angular.module('app.controllers').controller('GiftCardsListSettingsController', function ($scope, $rootScope, GiftCards, DTOptionsBuilder, dataTablesHebrewProvider) {
    if ($rootScope.userRole === 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.showUsed = false;

    ctrl.giftCards = angular.copy(GiftCards.data || []);
    ctrl.tableData = [];

    function isUsed(card) {
      return !!(card.used === true || card.used === 1 || card.used === '1' || card.used === 'true');
    }

    ctrl.applyFilters = function () {
      ctrl.tableData = ctrl.giftCards.filter(function (el) {
        return ctrl.showUsed ? isUsed(el) : !isUsed(el);
      });
    };

    ctrl.changeUsed = function () {
      ctrl.applyFilters();
    };

    ctrl.applyFilters();

    /**
     * Datatable configuration
     */
    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('order', [[0, 'asc']])
      .withOption('pageLength', 20);
  });
})();

(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsTemplatesController', function(TemplatesList, $state, $header, $api, $scope, $uibModalInstance, $window, $sce, $translate) {
  
            var ctrl = this;
            ctrl.list = TemplatesList.list;
        
            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.createForm = function(form) {
                form.fields = JSON.parse(form.fields);
                
                $api.digital_forms.save(form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                    }
                });
            }
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsPreviewController', function(DForm, $header, $api, $scope, $uibModalInstance, $window, $sce, $translate) {
  
            var ctrl = this;
            
            $scope.DigitalForm = DForm.data;
            $scope.business = DForm.data.business;
            $scope.DigitalForm.data = DForm.data && DForm.data.data ? JSON.parse(DForm.data.data) : [];
            $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';

            if ($scope.DigitalForm.data) {
                for (var i in $scope.DigitalForm.data) {
                    if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                        $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                    }
                }
            }
            
        
            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            ctrl.back = function() {
                $window.history.back();
            };
           
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsListController', function (DigitalForms, $state, $api, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;
            ctrl.df_templates = [];
            
            ctrl.tableData = DigitalForms && DigitalForms.data ? DigitalForms.data : [];

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_DIGITAL_FORMS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('id', [[0, 'desc']]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = DigitalForms && DigitalForms.data ? DigitalForms.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                            found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }
        });
})();

(function() {

    angular.module("app.controllers").controller("DigitalFormsFormController", function($scope, $state, $api, $resource, dates, DigitalForm, DigitalForms, PhotosStock, $rootScope, $translate, $timeout, $tiff_page) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        
        ctrl.master_business = $rootScope.$user && $rootScope.$user.dealer_name == 'MASTER_BUSINESS' ? true : false;

        ctrl.form = {
            name: '',
            text_form: false,
            text: '',
            logo: '',
            hide_logo: false,
            locked: false,
            fields: [
                {
                    name: '',
                    type: 'input',//input, textarea, radio, checkbox, select, date, comment, signature, text, business_signature, map
                    items: [],
                    require: false,
                    other: false,
                    other_name: '',
                }
            ],
        };

        ctrl.mapOptions = PhotosStock && PhotosStock.data ? PhotosStock.data : [];
        
        $scope.isEdit = false;
        $scope.sortableOptions = { handle: '.drag-handle' };

        /**
         * Initialize edit data
         */
        if(DigitalForm != null && DigitalForm.data) {
            $scope.isEdit = true;
            ctrl.form.name = DigitalForm.data.name;
            ctrl.form.logo = DigitalForm.data.logo;
            ctrl.form.hide_logo = DigitalForm.data.hide_logo;
            ctrl.form.locked = DigitalForm.data.locked;
            ctrl.form.text_form = DigitalForm.data.text_form;
            ctrl.form.text = DigitalForm.data.text;
            ctrl.form.fields = JSON.parse(DigitalForm.data.fields);
        }
        ctrl.isMobile = (angular.element(document).width() < 769);

        DigitalForms.$promise.then(function () {
                ctrl.digital_forms = DigitalForms.data;
                for (var i in ctrl.digital_forms) {
                }
            },
            function () {
                ctrl.digital_forms = [];
            });

        ctrl.checkRequiredFields = function() {
            var check = true;
            for (var i in ctrl.form.fields) {
                if (ctrl.form.fields[i].require && (ctrl.form.fields[i].type == 'checkbox' || ctrl.form.fields[i].type == 'radio' || ctrl.form.fields[i].type == 'select') && (!ctrl.form.fields[i].items || !ctrl.form.fields[i].items.length)) {
                    check = false;
                    break
                }
            }

            return check;
        }

        ctrl.onChangeType = function(index, type) {
            if (type == 'input' || type == 'textarea' || type == 'date') {
                ctrl.form.fields[index].items = [];
            }
        }

        ctrl.onAddItem = function(index) {
            if (ctrl.form.fields[index]) {
                var value = 0;
                for (var i in ctrl.form.fields[index].items) {
                    if (value <= ctrl.form.fields[index].items[i].value) {
                        value = ctrl.form.fields[index].items[i].value + 1
                    }
                }
                ctrl.form.fields[index].items.push(
                    {
                        value: value,
                        name: '',
                    }
                );
            }
        }

        ctrl.onRemoveItem = function(index, i) {
            if (ctrl.form.fields[index]) {
                ctrl.form.fields[index].items.splice(i, 1);
            }
        }

        ctrl.onAddField = function() {
            ctrl.form.fields.push(
                {
                    name: '',
                    type: 'input',
                    items: [],
                    require: false,
                    other: false,
                    other_name: '',
                }
            )
        }

        ctrl.onRemoveField = function(index) {
            ctrl.form.fields.splice(index, 1);
        }

        ctrl.submit = function(){
            if(DigitalForm == null)
                /**
                 * In case it's a new customer form
                 */
                $api.digital_forms.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                        $scope.$close();
                    } else if (response.status == "exist") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_EXIST_TITLE'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        });
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.digital_forms.single.save({
                    id: DigitalForm.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                        $scope.$close();
                    }
                });
        };

        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_DD_DELETE_CONFIRM_TEXT').replace('[name]', DigitalForm.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.digital_forms.single.delete({id: DigitalForm.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_DD_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                        } else if (response.status == "exist") {
                            swal({
                                title: $translate.instant('SWAL_DD_DELETE_EXIST_TITLE'),
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
            });
        };

        ctrl.removeImage = function(type) {
            event.preventDefault();
            ctrl.form[type] = '';
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var reader = new FileReader();

            reader.onload = function(e) {
                var image =  document.createElement('img');
                image.src = e.target.result;
                image.onload = function() {
                    var fdata = new FormData();
                    fdata.append("image", element.files[0], new_file_name);
                    fdata.append("type", element.name);
                    
                    $resource($api.baseURL + '/Image/upload', {}, {
                        postWithFile: {
                            method: "POST",
                            params: fdata,
                            transformRequest: angular.identity,
                            headers: {'Content-Type': undefined}
                        }
                    }).postWithFile(fdata).$promise.then(function(response){
                        if (response.image) {
                            ctrl.form[element.name] = response.image;
                        }
                    }, function(error){
                        console.log(error);
                    });
                }
            }

            reader.readAsDataURL(element.files[0]);
        };


        ctrl.showImage = function($event, image) {
            $event.stopPropagation();
            $event.preventDefault();
            swal({
                imageUrl: image,
                imageWidth: 800,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: $translate.instant('CALL_CANCEL'),
            })
    
        }

        ctrl.removeImage = function($event, index) {
            $event.stopPropagation();
            $event.preventDefault();
            ctrl.form.fields[index].image = '';
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();
            var index = $(element).data('index');
            console.log(index);

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            $tiff_page.start_loading('save_image');
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form.fields[index].image = response.image;
                $tiff_page.stop_loading('save_image');
            }, function(error){
                $tiff_page.stop_loading('save_image');
                console.log(error);
            });
        };
    });

})();

(function () {
  angular.module("app.controllers")
    .controller("CustomFieldsSingleSettingsController", function ($scope, $state, $header, $customFields, CustomField, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.title = CustomField && CustomField.data && CustomField.data.name ? $customFields.getCurrentName(CustomField.data.name) : '';
      ctrl.tableData = CustomField && CustomField.data && CustomField.data.values ? CustomField.data.values : [];
      ctrl.search_value = '';

      $header.breadcrumbs.push({
        "title": "SETTINGS_CUSTOM_FIELDS"
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withOption('searching', false)
        .withLanguage(dataTablesHebrewProvider)
        .withOption('order', [[0, 'desc']]);

      ctrl.find_table = function () {
        if (!ctrl.originalTableData) {
          ctrl.originalTableData = angular.copy(ctrl.tableData);
        }

        var newData = [];
        var searchValue = ctrl.search_value ? ctrl.search_value.toLowerCase() : '';

        if (!searchValue) {
          ctrl.tableData = angular.copy(ctrl.originalTableData);
          return;
        }

        for (var i = 0; i < ctrl.originalTableData.length; i++) {
          var found = false;
          for (var key in ctrl.originalTableData[i]) {
            if (
              ctrl.originalTableData[i][key] &&
              ctrl.originalTableData[i][key].toString().toLowerCase().indexOf(searchValue) > -1
            ) {
              found = true;
              break;
            }
          }
          
          if (found) {
            newData.push(ctrl.originalTableData[i]);
          }
        }

        ctrl.tableData = newData;
      }
    });
})();

(function () {
  angular.module("app.controllers")
    .controller("CustomFieldsFormSettingsController", function ($stateParams, $state, $api, CustomFieldValue, $rootScope, $translate) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.isEdit = false;
      ctrl.listId = $stateParams.id;

      ctrl.form = {
        value: '',
        position: 0,
        active: true,
      };

      if (CustomFieldValue != null) {
        ctrl.isEdit = true;
        ctrl.form = {
          value: CustomFieldValue.data.value,
          position: CustomFieldValue.data.position,
          active: CustomFieldValue.data.active,
        }
      }

      ctrl.submit = function () {
        if (CustomFieldValue == null) {
          $api.customFields.value.add.save({id: ctrl.listId}, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_SAVE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.custom_fields.single", {id: ctrl.listId}, { reload: true });
            }
          });
        } else {
          $api.customFields.value.update.save({
            id: ctrl.listId,
            vid: CustomFieldValue.data.id
          }, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_UPDATE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.custom_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
            }
          });
        }
      };

      ctrl.delete = function () {
        swal({
          title: "",
          text: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_DELETE_CONFIRM_TEXT').replace('[value]', CustomFieldValue.data.value),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value)
            $api.customFields.value.remove.delete({
              id: ctrl.listId,
              vid: CustomFieldValue.data.id
            }, function (response) {
              if (response.success) {
                swal({
                  title: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_DELETE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.settings.custom_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
              }
            });
        });
      };
    });
})();

(function () {
  angular.module("app.controllers")
    .controller("CoursesFieldsSingleSettingsController", function ($scope, $state, $header, CoursesField, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.title = CoursesField && CoursesField.data ? CoursesField.data.name : '';
      ctrl.tableData = CoursesField && CoursesField.data && CoursesField.data.values ? CoursesField.data.values : [];
      ctrl.search_value = '';

      $header.breadcrumbs.push({
        "title": "SETTINGS_COURSES_FIELDS"
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withOption('searching', false)
        .withLanguage(dataTablesHebrewProvider)
        .withOption('order', [[0, 'desc']]);

      ctrl.find_table = function () {
        if (!ctrl.originalTableData) {
          ctrl.originalTableData = angular.copy(ctrl.tableData);
        }

        var newData = [];
        var searchValue = ctrl.search_value ? ctrl.search_value.toLowerCase() : '';

        if (!searchValue) {
          ctrl.tableData = angular.copy(ctrl.originalTableData);
          return;
        }

        for (var i = 0; i < ctrl.originalTableData.length; i++) {
          var found = false;
          for (var key in ctrl.originalTableData[i]) {
            if (
              ctrl.originalTableData[i][key] &&
              ctrl.originalTableData[i][key].toString().toLowerCase().indexOf(searchValue) > -1
            ) {
              found = true;
              break;
            }
          }
          
          if (found) {
            newData.push(ctrl.originalTableData[i]);
          }
        }

        ctrl.tableData = newData;
      }
    });
})();

(function () {
  angular.module("app.controllers")
    .controller("CoursesFieldsFormSettingsController", function ($stateParams, $state, $api, CoursesFieldValue, CoursesField, $rootScope, $translate) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.isEdit = false;
      ctrl.listId = $stateParams.id;
      ctrl.coursesField = CoursesField.data;

      ctrl.form = {
        value: '',
        position: 0,
        cashbox_condition: false,
      };

      if (CoursesFieldValue != null) {
        ctrl.isEdit = true;
        ctrl.form = {
          value: CoursesFieldValue.data.value,
          position: CoursesFieldValue.data.position,
          cashbox_condition: CoursesFieldValue.data.cashbox_condition,
        }
      }

      ctrl.submit = function () {
        if (CoursesFieldValue == null) {
          $api.coursesFields.value.add.save({id: ctrl.listId}, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_COURSES_FIELDS_VALUE_SAVE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.courses_fields.single", {id: ctrl.listId}, { reload: true });
            }
          });
        } else {
          $api.coursesFields.value.update.save({
            id: ctrl.listId,
            vid: CoursesFieldValue.data.id
          }, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_COURSES_FIELDS_VALUE_UPDATE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.courses_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
            }
          });
        }
      };

      ctrl.delete = function () {
        swal({
          title: "",
          text: $translate.instant('SWAL_COURSES_FIELDS_VALUE_DELETE_CONFIRM_TEXT').replace('[value]', CoursesFieldValue.data.value),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value)
            $api.coursesFields.value.remove.delete({
              id: ctrl.listId,
              vid: CoursesFieldValue.data.id
            }, function (response) {
              if (response.success) {
                swal({
                  title: $translate.instant('SWAL_COURSES_FIELDS_VALUE_DELETE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.settings.courses_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
              }
            });
        });
      };
    });
})();

(function () {

  angular.module('app.controllers')

    .controller('CategoriesListController', function (Categories, $api, $state, $header, $scope, $translate, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;

      /**
       * Assign data to the table
       */
      ctrl.tableData = Categories.data;

      /**
       * Module header configuration (title and breadcrumbs)
       */
      $header.title = "קטגוריות";
      $header.breadcrumbs.push({
        "title": "הגדרות",
        "state": "app.settings"
      });
      $header.breadcrumbs.push({
        "title": "קטגוריות"
      });

      /**
       * Datatable configuration
       */
      $scope.dtOptions =
        DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider);

      ctrl.search_value = "";
      ctrl.find_table = function() {
        ctrl.tableData = Categories.data;
        if (ctrl.search_value) {
          var newData = [];
          for (var i in ctrl.tableData) {
            var found = false;
            for (var k in ctrl.tableData[i]) {
                if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                found = true;
                }
            }

            if (found) {
                newData.push(ctrl.tableData[i]);
            }
          }

          ctrl.tableData = newData;
        }
      }

      ctrl.drop = function(){
        var order = [];
        for(var i in ctrl.tableData) {
          order.push(ctrl.tableData[i].id);
        }
        $api.categories.save({ordering: order}, function(response){
          if(response.status === "success"){
          }
        });
      };

      ctrl.change_active = function (category) {
        if (!category.active) {
          swal({
              title: $translate.instant('SWAL_ARE_YOU_SURE'),
              text: $translate.instant('NOTIFICATION_CHANGE_CATEGORIES_ACTIVE'),
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              showLoaderOnConfirm: true
          }).then(function(result) {
              if (!result.value) {
                category.active = true;
              }
              ctrl.submit(category);
          });
        } else {
          ctrl.submit(category);
        }
      };

      ctrl.submit = function (category) {
        $api.categories.single.save({
          id: category.id
        }, category, function (response) {
        });
      }

    });
})();

(function() {

    angular.module("app.controllers").controller("CategoriesFormController", function($scope, $state, $api, dates, Category, $rootScope, $translate, $timeout) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
            active: true,
        };

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(Category != null) {
            $scope.isEdit = true;
            ctrl.form = Category.data;
        }

        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(Category == null)
                /**
                 * In case it's a new customer form
                 */
                $api.categories.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_C_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.categories.single.save({
                    id: Category.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {id: Category.data.id}, {reload: true});
                    }
                });
        };

        /**
         * Triggers category delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_CATEGORIES_DELETE_CONFIRM_TEXT').replace('[name]', Category.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.categories.single.delete({id: Category.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_CATEGORIES_C_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.categories", {}, {reload: true});
                        } else if (response.status == "exist") {
                            swal({
                                title: $translate.instant('SWAL_CATEGORIES_DELETE_EXIST_TITLE'),
                                text: "",
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
            });
        };

        ctrl.change_active = function () {
            if (!ctrl.form.active) {
                swal({
                    title: $translate.instant('SWAL_ARE_YOU_SURE'),
                    text: $translate.instant('NOTIFICATION_CHANGE_CATEGORIES_ACTIVE'),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if (!result.value) {
                        $timeout(function() {
                            ctrl.form.active = true;
                        });
                    }
                });
            }
        };
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('CallLogsController', function (CallLogs, $state, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.tableData = CallLogs && CallLogs.data ? CallLogs.data : [];

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_CALL_LOGS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[2, 'desc']]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = CallLogs && CallLogs.data ? CallLogs.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }
        });
})();

(function() {

    angular.module("app.controllers").controller("InterestedFormController", function($scope, $state, $api, Interested, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
        };

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */

        if(Interested != null) {
            $scope.isEdit = true;
            ctrl.form = Interested.data;
        }

        ctrl.submit = function() {

            if(Interested == null)
                $api.interested.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_INTERESTED_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.additional_fields.interested", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.interested.single.save({
                    id: Interested.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_INTERESTED_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.additional_fields.interested", {}, {reload: true});
                    }
                });
        };

      
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_INTERESTED_DELETE_CONFIRM_TEXT').replace('[name]', Interested.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.interested.single.delete({id: Interested.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_INTERESTED_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.additional_fields.interested", {}, {reload: true});
                        }
                    });
            });
        };
       
    });

})();

(function() {

    angular.module("app.controllers").controller("InterestedController", function($scope, $state, $api, $header, Interested, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;

      ctrl.tableData = Interested && Interested.data ? Interested.data : [];

      $header.breadcrumbs.push({
          "title": "SETTINGS_INTERESTED"
      });

      /**
       * Datatable configuration
       */
      $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]);

      ctrl.search_value = "";
      ctrl.find_table = function() {
          ctrl.tableData = Interested && Interested.data ? Interested.data : [];
          if (ctrl.search_value) {
              var newData = [];
              for (var i in ctrl.tableData) {
                  var found = false;
                  for (var k in ctrl.tableData[i]) {
                      if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                        found = true;
                      }
                  }

                  if (found) {
                      newData.push(ctrl.tableData[i]);
                  }
              }

              ctrl.tableData = newData;
          }
      }

    });

})();

(function () {
    angular.module('app.controllers').controller('CustomersCardTransactionsController',
        function (Customer, Card, CardsTransactions, $state, $header, $scope, $api, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {
            var ctrl = this;

            ctrl.transactions = CardsTransactions.data;
            ctrl.card = Card.data;
            ctrl.customer = Customer.data;

            $header.breadcrumbs.push({
                    "title": "לקוחות",
                    "state": "app.customers"
                }, {
                    "title": Customer.data.firstname + " " + Customer.data.lastname,
                    "state": "app.customers.single({id:" + Customer.data.id + "})"
                },
                {
                    "title": "CUSTOMERS_CARDS_INFO_TAB"
                });
            $header.title = "CUSTOMERS_CARDS_TRANSACTIONS_LABEL" + '. ' + ctrl.card.name;

            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', 20)
                        .withOption('aaSorting', [])
                        .withOption('searching', false);

            if (window.innerWidth < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 3;
            }

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.transactions = CardsTransactions.data;
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.transactions) {
                        var found = false;
                        for (var k in ctrl.transactions[i]) {
                            if (ctrl.transactions[i][k] && ctrl.transactions[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.transactions[i]);
                        }
                    }

                    ctrl.transactions = newData;
                }
            }

        });
})();

(function() {

    angular.module("app.controllers").controller("ColoringFormController", function($scope, $state, $tiff_page, $api, Color, Customer, $rootScope, $uibModalInstance, $translate) {
      
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      $scope.isMobile = (angular.element(document).width() < 769);
      ctrl.form = {
        customer_id: Customer.data.id,
        business_id: Customer.data.b_id
      };

      ctrl.color_inputs = {2:false, 3:false, 4:false};
      /**
       * Initialize edit data
       */
      if (Color != null) {
        ctrl.form = Color.data;
        ctrl.color_inputs[2] = ctrl.form.color_number_2 || ctrl.form.color_dosage_2;
        ctrl.color_inputs[3] = ctrl.form.color_number_3 || ctrl.form.color_dosage_3;
        ctrl.color_inputs[4] = ctrl.form.color_number_4 || ctrl.form.color_dosage_4;
      }

      ctrl.add_color = function () {
        for (var i in ctrl.color_inputs) {
          if (!ctrl.color_inputs[i]) {
            ctrl.color_inputs[i] = true;
            break;
          }
        }
      }

      ctrl.submit = function () {

        $tiff_page.start_loading('save_coloring');
        if (Color == null) {
          var form = ctrl.form;
          form.date = moment(ctrl.form.date).format("YYYY-MM-DD");
          $api.coloring.save(form, function (response) {
            $tiff_page.stop_loading('save_coloring');
            if (response.status == "success") {
              $uibModalInstance.close(response.data);
              if (response.status == "success") {
                swal({
                  title: $translate.instant('SWAL_COLORING_SAVE_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
              }
            }
          }, function (response) {
            $tiff_page.stop_loading('save_coloring');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_COLORING_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
        } else {
          $api.coloring.single.save({
            id: Color.data.id
          }, ctrl.form, function (response) {
            $tiff_page.stop_loading('save_coloring');
            $uibModalInstance.close(response.data);
            if (response.status == "success") {
              swal({
                title: $translate.instant('SWAL_COLORING_SAVE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
            }
          }, function (response) {
            $tiff_page.stop_loading('save_coloring');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_COLORING_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
         }
      };

      ctrl.remove = function () {
        if (Color) {
          swal({
              title: "",
              text: $translate.instant('SWAL_COLORING_REMOVE_CONFIRMATION_TEXT'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              closeOnConfirm: false,
              showLoaderOnConfirm: true
          }).then(function(result) {
              if(result.value)
                  $api.coloring.single.delete({id: Color.data.id}, function(response) {
                      if(response.status == "success") {
                          swal({
                              title: $translate.instant('SWAL_COLORING_REMOVE_TITLE'),
                              text: "",
                              type: "success",
                              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                              timer: 2000
                          });
                          $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                      }
                  });
          });
        }
      };
    });

})();

(function () {
  angular.module("app.controllers").controller("CardBalanceFormController",
    function (Card, $api, $scope, $state, $rootScope, $uibModalInstance, $translate) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }
      var ctrl = this;
      ctrl.card = Card.data;

      // Form data
      ctrl.form = {
        amount_changed: 0,
        expired_at: ctrl.card.expired_at ? moment(ctrl.card.expired_at).toDate() : null,
        comment: ''
      };

      /**
       * Change customer card balance
       */
      ctrl.saveForm = function () {
        $api.cards.single.save({id: ctrl.card.id, data: ctrl.form}, function (response) {
          if (response.status == "success") {
            swal({
              title: $translate.instant('CARD_CHANGED_BALANCE_MSG'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            }).then(function () {
              $state.transitionTo("app.customers.single", {
                "id": $scope.customer.id
              }, {
                reload: true
              });
              $uibModalInstance.close();
            });
          }
        });
      }

    });
})();

(function() {

    angular.module("app.controllers").controller("CustomersSMSController", function($scope, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {};

        /**
         * Triggers when SMS form is submited
         */
        ctrl.submit = function() {

            $api.sms.save({
                message: ctrl.form.message,
                phone: Customer.data.telephone
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_SMS_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

    });

})();

(function () {

  angular.module('app.controllers')

      .controller('WorkersSingleController', function (Worker, $api, $state, $scope, $header, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal, $rootScope,$stateParams, $translate) {

          if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
          }

          // b_type=2 -> motel
          // b_type=1 -> store
          //$scope.b_type = $rootScope.$user.b_type;

          var ctrl = this;

          $scope.isMobile = (angular.element(document).width() < 769);

          
          

          $scope.selectizeConfig = {
              create: true,
              sortField: 'text'
          };


          if (Worker.status == "failed")
              $state.transitionTo("app.workers", {}, { reload: true });

          if (Worker.data.lastname == null)
              Worker.data.lastname = "";

          $scope.worker = Worker.data;
          $scope.businessId = $stateParams.id;

          
          

          /**
           * Module header configuration (title and breadcrumbs)
           */
          $header.title = "ניהול עובדים - <b>" + Worker.data.emp_firstname + " " + Worker.data.emp_lastname + "</b>";
          $header.breadcrumbs.push({
              "title": "עובדים",
              "state": "app.workers"
          }, {
                  "title": Worker.data.emp_firstname + " " + Worker.data.emp_lastname
              });
              /*
              $scope.deletetime = function(id){
                swal.fire({
                  title: 'הכנס סיסמת מנהל',
                  input: 'password',
                  inputAttributes: {
                    autocapitalize: 'off',
                    name: "password",
                    autocomplete: 'new-password'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'אישור',
                  cancelButtonText: 'ביטול',
                  showLoaderOnConfirm: true,
                  preConfirm: function(password){
                    
                    return $api.workers.employee_transactions.single.delete({password:password,id:id}, function(response){ 
                      console.log(response)
                          if(response.status == "success") {
                            $state.transitionTo("app.workers.single", {id: Worker.data.id}, {reload: true});
                          }
                          else{
                            swal.fire({
                              title: "הססמא לא נכונה נא לנסות שנית",
                              confirmButtonText: 'אישור',
                            })
                          }
                        })
                    }
                  })
                    
                      
              }
              */
              
              $scope.turntoinput = function(id,start,end){
                Swal.fire({
                  title: 'הכנס סיסמת מנהל',
                  input: 'password',
                  inputAttributes: {
                    autocapitalize: 'off',
                    name: "password",
                    autocomplete: 'new-password'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'אישור',
                  cancelButtonText: 'ביטול',
                  preConfirm: function(password){
                    return $api.workers.employee_transactions.save({password:password,update: true}, function(response){ 
                      if (response.status == "success") {
                        start_time = moment(start).format('YYYY-MM-DDThh:mm')
                        end_time = moment(end).format('YYYY-MM-DDThh:mm')
  
                        Swal.close()	
                        Swal.fire({
                          title: 'שינוי רשומה',
                          type: 'info',
                          html:
                          '<form class="update_hours"><input type="hidden" name="id" value="'+id+'"><h3>כניסה</h3><input type="datetime-local" class="swal2-input" name="start" value="'+start_time+'"><h3>יציאה</h3><input type="datetime-local" class="swal2-input" name="end" class="" value="'+end_time+'"><br><button type="submit" class="btn blue-btn">עדכן רשומה</button>&nbsp;<button type="button" class="btn btn-danger delete-time">מחק רשומה</button></form>',
                          showCloseButton: true,
                          showCancelButton: true,
                          showConfirmButton: false,
                          focusConfirm: false,
                          cancelButtonText:
                            'ביטול',
                        })
                        
                        $(document).find(".delete-time").bind('click', function(e) {
                          $api.workers.employee_transactions.single.delete({password:password,id:id}, function(response){
                            if(response.status == "success") {
                              swal.close()
                              $state.transitionTo("app.workers.single", {id: Worker.data.id}, {reload: true});
                            }
                            else{
                              swal.fire({
                                title: "הססמא לא נכונה נא לנסות שנית",
                                confirmButtonText: 'אישור',
                              })
                            }
                          });
                        });
                        $(document).find(".update_hours").bind('submit', function(e) {
                          e.preventDefault()
                          var fields = {};
                          $(this).find(":input").each(function() {
                              fields[this.name] = $(this).val();
                          });
                          fields["update"] = true;
                          $api.workers.employee_transactions.save(fields, function(response){ 
                            swal.close()
                            if (response.status == "success") {
                              $state.transitionTo("app.workers.single", {id: Worker.data.id}, {reload: true});
                            }
                            else{
                              swal.fire({
                                title: "ארעה שגיאה אנא נסה שנית",
                                confirmButtonText: 'אישור',
                              })
                            }
                          })
                        })
                      }
                      else{
                        swal.fire({
                          title: "הססמא לא נכונה נא לנסות שנית",
                          confirmButtonText: 'אישור',
                        })
                      }
                    })
                    }
                
                })
              }

              ctrl.showHideSearch = function () {
                  $scope.showHideSearchInput = !$scope.showHideSearchInput;
                ctrl.setDataTableOptions($scope.showHideSearchInput);
              }
              ctrl.setDataTableOptions = function (showSearch) {
                if (window.innerWidth < 768) {
                  if(typeof showSearch === "undefined") {
                    $scope.showHideSearchInput = false;
                  }
                  $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('order', [[0, 'desc']])
                      .withOption('aaSorting', [])
                      .withOption('searching', $scope.showHideSearchInput);
                } else {
                  if(typeof showSearch === "undefined") {
                    $scope.showHideSearchInput = false;
                  }
                  $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('order', [[0, 'desc']])
                      .withOption('aaSorting', [])
                      .withOption('searching', $scope.showHideSearchInput);
                }
              }
  
              ctrl.setDataTableOptions();

              ctrl.getData = function(){
                  $api.workers.employee_transactions.get({id: Worker.data.id}, function(response) {
                      if (response.status == 'success') { 
                        ctrl.tableData = response.data;
                      }
                  });
              }
              ctrl.getData();
          /**
           * Worker delete
           */
          ctrl.delete = function () {
              swal({
                  title: "",
                  text: $translate.instant('SWAL_WORKERS_DELETE_CONFIRM_TEXT').replace('[name]', Worker.data.emp_firstname),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                  confirmButtonClass: "btn-danger",
                  closeOnConfirm: false,
                  showLoaderOnConfirm: true
              }).then(function(result) {
                  if(result.value)
                      $api.workers.single.delete({id: Worker.data.id}, function(response) {
                          if(response.status == "success") {
                              swal({
                                  title: $translate.instant('SWAL_WORKERS_DELETE_TITLE'),
                                  text: "",
                                  type: "success",
                                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                  timer: 2000
                              });
                              $state.transitionTo("app.workers", {}, {reload: true});
                          }
                      });
              });
          };

          ctrl.recover = function () {
              
            $api.workers.recover.get({id: Worker.data.id}, function(response) {
              if(response.status == "success") {
                $state.transitionTo("app.workers", {}, {reload: true});
              }
            });
          };


          

          
      });

})();

(function(){
  angular.module('app.controllers').controller('WorkersListController',
    function ($state, $header, $scope, $api, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log) {
      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      ctrl.worker_name = "";
      ctrl.show_deleted = false;

      $header.title = "NAV_WORKERS";
      $header.breadcrumbs.push({
        "title": "NAV_WORKERS"
      });

      /**
         * search customer
         */
      $scope.find_worker = function() {
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      /**
       * Open customer data
       *
       * @param customerData
       */
      ctrl.open_customer_card = function (customerData) {
        $state.transitionTo("app.customers.single", {
          "id": customerData.id
        }, {
          reload: false
        });
      };

      ctrl.change_deleted = function () {
        ctrl.initDtOptions();
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      /**
       * Initiate DataTable Options
       */
      ctrl.initDtOptions = function(){
        $scope.dtOptions =
          DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            //.withOption('order', [[1, 'desc']])
            .withOption('aaSorting', [])
            .withOption('searching', ctrl.showHideSearchInput)
            .withOption('ajax', ctrl.loadWorkers)
            .withOption('serverSide', true)
            .withDataProp('data')
            .withOption('rowCallback', ctrl.WorkerRawCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });
      };

      ctrl.showHideSearchInput = false;
      ctrl.showHideSearch = function () {
        ctrl.showHideSearchInput = !ctrl.showHideSearchInput;
        ctrl.initDtOptions();
      };

      /**
       * Load customers
       *
       * @param data
       * @param callback
       * @param settings
       */
      ctrl.loadWorkers = function (data, callback, settings) {
        var orderCol = '';
        var orderDir = '';
        var searchStr = '';

        if(data.order.length) {
          // Use only last order parameters
          var colIndex = data.order[data.order.length - 1].column
          var orderCol = data.columns[colIndex]['name'];
          var orderDir = data.order[data.order.length - 1].dir;
        }

        $api.workers.list.get(
          {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.worker_name, deleted: ctrl.show_deleted}
          , function (result) {
          if (result && result.data) {
            $log.log(result);

            callback({
              recordsTotal: result.recordsTotal,
              recordsFiltered: result.recordsFiltered,
              data: result.data,
              draw: data.draw + 1
            });
          }

        });
      };

      /**
       * Bind events to a new row
       *
       * @param nRow
       * @param aData
       * @param iDisplayIndex
       * @param iDisplayIndexFull
       * @returns {*}
       */
      ctrl.WorkerRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        //console.log(aData)
        $(nRow).unbind('click');
        $(nRow).bind('click', function() {
          $scope.$apply(function() {
            ctrl.open_worker_card(aData);
          });
        });
        $(nRow).find(".start-job").unbind('click');
        $(nRow).find(".start-job").bind('click', function(e) {
          e.stopPropagation()

          swal.fire({
            title: 'הכנס סיסמת עובד',
            input: 'password',
            inputAttributes: {
              autocapitalize: 'off',
              name: "password",
              autocomplete: 'new-password'
            },
            showCancelButton: true,
            confirmButtonText: 'אישור',
            cancelButtonText: 'ביטול',
            showLoaderOnConfirm: true,
            preConfirm: function(password){
              return $api.workers.save({password:password,user_id: aData.id}, function(response){
                if (response.status == "success") {
                  $(".start-job,.end-job").attr("disabled", true);
                  $api.employeeTransactions.save({employee_id:aData.id}, function(response){
                    if(response.status == "success") {
                      $state.transitionTo("app.workers", {}, {reload: true});
                    }
                    else{
                      swal.fire({
                        title: "ארעה שגיעה",
                        confirmButtonText: 'אישור',
                      })
                      $(".end-job,.start-job").attr("disabled", false);
                    }
                  });

                }
                else{
                  swal.fire({
                    title: "הססמא לא נכונה נא לנסות שנית",
                    confirmButtonText: 'אישור',
                  })
                  $(".end-job,.start-job").attr("disabled", false);
                }
              })
            },
            allowOutsideClick: function(){!swal.isLoading()}
          })
        });

        $(nRow).find(".end-job").unbind('click');
        $(nRow).find(".end-job").bind('click', function(e) {
          e.stopPropagation()


          swal.fire({
            title: 'הכנס סיסמת עובד',
            input: 'password',
            inputAttributes: {
              autocapitalize: 'off',
              name: "password",
              autocomplete: 'new-password'
            },
            showCancelButton: true,
            confirmButtonText: 'אישור',
            cancelButtonText: 'ביטול',
            showLoaderOnConfirm: true,
            preConfirm: function(password){
              return $api.workers.save({password:password,user_id: aData.id}, function(response){
                if (response.status == "success") {
                  $(".end-job,.start-job").attr("disabled", true);
                  $api.employeeTransactions.save({id:aData.tran_id}, function(response){
                    if(response.status == "success") {
                      $state.transitionTo("app.workers", {}, {reload: true});
                    }
                    else{
                      swal.fire({
                        title: "ארעה שגיאה",
                        confirmButtonText: 'אישור',
                      })
                      $(".end-job,.start-job").attr("disabled", false);
                    }
                  });

                }
                else{
                  swal.fire({
                    title: "הססמא לא נכונה נא לנסות שנית",
                    confirmButtonText: 'אישור',
                  })
                  $(".end-job,.start-job").attr("disabled", false);
                }
              })
            },
            allowOutsideClick: function(){!swal.isLoading()}
          })
          /*
          $scope.$apply(function() {
              $api.employeeTransactions.save({id:aData.tran_id}, function(response){
                if(response.status == "success") {
                  $state.transitionTo("app.workers", {}, {reload: true});
                }
           });
          });*/
        });

        return nRow;
      }

      ctrl.open_worker_card = function (workerData) {

        $state.transitionTo("app.workers.single", {
          "id": workerData.id
        }, {
          reload: false
        });
      };


      if (window.innerWidth < 768) {
        ctrl.showHideSearchInput = false;
        $.fn.DataTable.ext.pager.numbers_length = 3;
      }

      ctrl.initDtOptions();

      /**
       * Customer table column definitions
       * @type {*[]}
       */
      ctrl.dtColumns = [
        { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'customer-name full',
          render: function(data, type, full, meta) {
            var html = '<div class="customer-pic-wrapper"><img src="assets/images/avatar.jpg" alt="User Profile" class="customer-pic"></div> ';
            html+= data.emp_firstname ? ' ' + data.emp_firstname : '';
            html+= data.emp_lastname ? ' ' + data.emp_lastname : '';
            return html;
          }
        },

       {data: null, title: '', orderable: false,
          render: function(data, type, full, meta) {
            //console.log(data.trn_status)
            if(data.trn_status === null || data.trn_status === 1){
              return '<button class="btn text primary start-job">כניסה</button>';
            }
            else{
              return '<button class="btn text error end-job">יציאה</button>';
            }
          }
        },
      ];
      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstanceCustomers = dtInstance;
      }

    });
})();

(function () {
   angular.module("app.controllers")
      .controller("WorkersFormController", function ($scope, $state, $api, dates, Worker, isModal, Info, $rootScope, $uibModalInstance, $translate) {
         if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, { reload: true });
            return;
         }

         var ctrl = this;
         // ctrl.isModal;
         ctrl.worker_country = {
            "code": "IL",
            "name": "Israel"
         };

         $scope.isModal = isModal;
         ctrl.form = {
            gender: "-1",
            send_notifications: "0",
            self_order: "0",
            group_notifications: "0"
         };

         ctrl.bu_type = parseInt(Info.data.type);

         /**
          * Initialize edit data
          */
         if (Worker != null) {
            ctrl.form = Worker.data;

            if (ctrl.form.emp_birthdate != null) {
               ctrl.form.emp_birthdate = String(ctrl.form.emp_birthdate).split("-");
               ctrl.form.birthdate_year = String(Number(ctrl.form.emp_birthdate[0]));
               ctrl.form.birthdate_month = String(Number(ctrl.form.emp_birthdate[1]));
               ctrl.form.birthdate_day = String(Number(ctrl.form.emp_birthdate[2]));
            }

            if (ctrl.form.emp_jobstartdate != null) {
               ctrl.form.emp_jobstartdate = String(ctrl.form.emp_jobstartdate).split("-");
               ctrl.form.startjob_year = String(Number(ctrl.form.emp_jobstartdate[0]));
               ctrl.form.startjob_month = String(Number(ctrl.form.emp_jobstartdate[1]));
               ctrl.form.startjob_day = String(Number(ctrl.form.emp_jobstartdate[2]));
            }

            if (ctrl.form.emp_jobenddate != null) {
               ctrl.form.emp_jobenddate = String(ctrl.form.emp_jobenddate).split("-");
               ctrl.form.endjob_year = String(Number(ctrl.form.emp_jobenddate[0]));
               ctrl.form.endjob_month = String(Number(ctrl.form.emp_jobenddate[1]));
               ctrl.form.endjob_day = String(Number(ctrl.form.emp_jobenddate[2]));
            }
            ctrl.form.emp_password = ""
         }

         /**
          * Give access from the scope to the datesProvider
          */
         $scope.datesProvider = dates;

         /**
          * Triggers when customers form is submited
          * Preparing the API call for creating or editing the current customer
          */
         ctrl.submit = function () {

            if (ctrl.form.gender == null)
               ctrl.form.gender = -1;

            if (Worker == null)
               /**
                * In case it's a new customer form
                */
               $api.workers.save(ctrl.form, function (response) {
                  if (response.status == "success") {

                     if ($scope.isModal) {
                        console.log("Worker was saved");
                        // if form is calles from order
                        // return new customer object
                        var promise = $api.resolve("workers.single@get", { "id": response.id });
                        promise.then(function (response) {
                           $uibModalInstance.close(response.data);
                        });
                     } else {
                        $state.transitionTo("app.workers", {}, { reload: true });
                     }
                  }
               });
            else
               /**
                * In case it's an edit form
                */
               $api.workers.single.save({
                  id: Worker.data.id
               }, ctrl.form, function (response) {
                  if (response.status == "success") {
                     swal({
                        title: $translate.instant('SWAL_WORKERS_SAVE_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                     });
                     $state.transitionTo("app.workers.single", { id: Worker.data.id }, { reload: true });
                  }
               });
         };

         ctrl.onCountryChange = function () {
            ctrl.form.country = ctrl.customer_country.code;
            //console.log(ctrl.form.country);
         }

         $scope.countries = [
            {
               "code": "AF",
               "name": "Afghanistan"
            },
            {
               "code": "AX",
               "name": "\u00c5land Islands"
            },
            {
               "code": "AL",
               "name": "Albania"
            },
            {
               "code": "DZ",
               "name": "Algeria"
            },
            {
               "code": "AS",
               "name": "American Samoa"
            },
            {
               "code": "AD",
               "name": "Andorra"
            },
            {
               "code": "AO",
               "name": "Angola"
            },
            {
               "code": "AI",
               "name": "Anguilla"
            },
            {
               "code": "AQ",
               "name": "Antarctica"
            },
            {
               "code": "AG",
               "name": "Antigua and Barbuda"
            },
            {
               "code": "AR",
               "name": "Argentina"
            },
            {
               "code": "AM",
               "name": "Armenia"
            },
            {
               "code": "AW",
               "name": "Aruba"
            },
            {
               "code": "AU",
               "name": "Australia"
            },
            {
               "code": "AT",
               "name": "Austria"
            },
            {
               "code": "AZ",
               "name": "Azerbaijan"
            },
            {
               "code": "BS",
               "name": "Bahamas"
            },
            {
               "code": "BH",
               "name": "Bahrain"
            },
            {
               "code": "BD",
               "name": "Bangladesh"
            },
            {
               "code": "BB",
               "name": "Barbados"
            },
            {
               "code": "BY",
               "name": "Belarus"
            },
            {
               "code": "BE",
               "name": "Belgium"
            },
            {
               "code": "BZ",
               "name": "Belize"
            },
            {
               "code": "BJ",
               "name": "Benin"
            },
            {
               "code": "BM",
               "name": "Bermuda"
            },
            {
               "code": "BT",
               "name": "Bhutan"
            },
            {
               "code": "BO",
               "name": "Bolivia, Plurinational State of"
            },
            {
               "code": "BQ",
               "name": "Bonaire, Sint Eustatius and Saba"
            },
            {
               "code": "BA",
               "name": "Bosnia and Herzegovina"
            },
            {
               "code": "BW",
               "name": "Botswana"
            },
            {
               "code": "BV",
               "name": "Bouvet Island"
            },
            {
               "code": "BR",
               "name": "Brazil"
            },
            {
               "code": "IO",
               "name": "British Indian Ocean Territory"
            },
            {
               "code": "BN",
               "name": "Brunei Darussalam"
            },
            {
               "code": "BG",
               "name": "Bulgaria"
            },
            {
               "code": "BF",
               "name": "Burkina Faso"
            },
            {
               "code": "BI",
               "name": "Burundi"
            },
            {
               "code": "KH",
               "name": "Cambodia"
            },
            {
               "code": "CM",
               "name": "Cameroon"
            },
            {
               "code": "CA",
               "name": "Canada"
            },
            {
               "code": "CV",
               "name": "Cape Verde"
            },
            {
               "code": "KY",
               "name": "Cayman Islands"
            },
            {
               "code": "CF",
               "name": "Central African Republic"
            },
            {
               "code": "TD",
               "name": "Chad"
            },
            {
               "code": "CL",
               "name": "Chile"
            },
            {
               "code": "CN",
               "name": "China"
            },
            {
               "code": "CX",
               "name": "Christmas Island"
            },
            {
               "code": "CC",
               "name": "Cocos (Keeling) Islands"
            },
            {
               "code": "CO",
               "name": "Colombia"
            },
            {
               "code": "KM",
               "name": "Comoros"
            },
            {
               "code": "CG",
               "name": "Congo"
            },
            {
               "code": "CD",
               "name": "Congo, the Democratic Republic of the"
            },
            {
               "code": "CK",
               "name": "Cook Islands"
            },
            {
               "code": "CR",
               "name": "Costa Rica"
            },
            {
               "code": "CI",
               "name": "C\u00f4te d'Ivoire"
            },
            {
               "code": "HR",
               "name": "Croatia"
            },
            {
               "code": "CU",
               "name": "Cuba"
            },
            {
               "code": "CW",
               "name": "Cura\u00e7ao"
            },
            {
               "code": "CY",
               "name": "Cyprus"
            },
            {
               "code": "CZ",
               "name": "Czech Republic"
            },
            {
               "code": "DK",
               "name": "Denmark"
            },
            {
               "code": "DJ",
               "name": "Djibouti"
            },
            {
               "code": "DM",
               "name": "Dominica"
            },
            {
               "code": "DO",
               "name": "Dominican Republic"
            },
            {
               "code": "EC",
               "name": "Ecuador"
            },
            {
               "code": "EG",
               "name": "Egypt"
            },
            {
               "code": "SV",
               "name": "El Salvador"
            },
            {
               "code": "GQ",
               "name": "Equatorial Guinea"
            },
            {
               "code": "ER",
               "name": "Eritrea"
            },
            {
               "code": "EE",
               "name": "Estonia"
            },
            {
               "code": "ET",
               "name": "Ethiopia"
            },
            {
               "code": "FK",
               "name": "Falkland Islands (Malvinas)"
            },
            {
               "code": "FO",
               "name": "Faroe Islands"
            },
            {
               "code": "FJ",
               "name": "Fiji"
            },
            {
               "code": "FI",
               "name": "Finland"
            },
            {
               "code": "FR",
               "name": "France"
            },
            {
               "code": "GF",
               "name": "French Guiana"
            },
            {
               "code": "PF",
               "name": "French Polynesia"
            },
            {
               "code": "TF",
               "name": "French Southern Territories"
            },
            {
               "code": "GA",
               "name": "Gabon"
            },
            {
               "code": "GM",
               "name": "Gambia"
            },
            {
               "code": "GE",
               "name": "Georgia"
            },
            {
               "code": "DE",
               "name": "Germany"
            },
            {
               "code": "GH",
               "name": "Ghana"
            },
            {
               "code": "GI",
               "name": "Gibraltar"
            },
            {
               "code": "GR",
               "name": "Greece"
            },
            {
               "code": "GL",
               "name": "Greenland"
            },
            {
               "code": "GD",
               "name": "Grenada"
            },
            {
               "code": "GP",
               "name": "Guadeloupe"
            },
            {
               "code": "GU",
               "name": "Guam"
            },
            {
               "code": "GT",
               "name": "Guatemala"
            },
            {
               "code": "GG",
               "name": "Guernsey"
            },
            {
               "code": "GN",
               "name": "Guinea"
            },
            {
               "code": "GW",
               "name": "Guinea-Bissau"
            },
            {
               "code": "GY",
               "name": "Guyana"
            },
            {
               "code": "HT",
               "name": "Haiti"
            },
            {
               "code": "HM",
               "name": "Heard Island and McDonald Islands"
            },
            {
               "code": "VA",
               "name": "Holy See (Vatican City State)"
            },
            {
               "code": "HN",
               "name": "Honduras"
            },
            {
               "code": "HK",
               "name": "Hong Kong"
            },
            {
               "code": "HU",
               "name": "Hungary"
            },
            {
               "code": "IS",
               "name": "Iceland"
            },
            {
               "code": "IN",
               "name": "India"
            },
            {
               "code": "ID",
               "name": "Indonesia"
            },
            {
               "code": "IR",
               "name": "Iran, Islamic Republic of"
            },
            {
               "code": "IQ",
               "name": "Iraq"
            },
            {
               "code": "IE",
               "name": "Ireland"
            },
            {
               "code": "IM",
               "name": "Isle of Man"
            },
            {
               "code": "IL",
               "name": "Israel"
            },
            {
               "code": "IT",
               "name": "Italy"
            },
            {
               "code": "JM",
               "name": "Jamaica"
            },
            {
               "code": "JP",
               "name": "Japan"
            },
            {
               "code": "JE",
               "name": "Jersey"
            },
            {
               "code": "JO",
               "name": "Jordan"
            },
            {
               "code": "KZ",
               "name": "Kazakhstan"
            },
            {
               "code": "KE",
               "name": "Kenya"
            },
            {
               "code": "KI",
               "name": "Kiribati"
            },
            {
               "code": "KP",
               "name": "Korea, Democratic People's Republic of"
            },
            {
               "code": "KR",
               "name": "Korea, Republic of"
            },
            {
               "code": "KW",
               "name": "Kuwait"
            },
            {
               "code": "KG",
               "name": "Kyrgyzstan"
            },
            {
               "code": "LA",
               "name": "Lao People's Democratic Republic"
            },
            {
               "code": "LV",
               "name": "Latvia"
            },
            {
               "code": "LB",
               "name": "Lebanon"
            },
            {
               "code": "LS",
               "name": "Lesotho"
            },
            {
               "code": "LR",
               "name": "Liberia"
            },
            {
               "code": "LY",
               "name": "Libya"
            },
            {
               "code": "LI",
               "name": "Liechtenstein"
            },
            {
               "code": "LT",
               "name": "Lithuania"
            },
            {
               "code": "LU",
               "name": "Luxembourg"
            },
            {
               "code": "MO",
               "name": "Macao"
            },
            {
               "code": "MK",
               "name": "Macedonia, the Former Yugoslav Republic of"
            },
            {
               "code": "MG",
               "name": "Madagascar"
            },
            {
               "code": "MW",
               "name": "Malawi"
            },
            {
               "code": "MY",
               "name": "Malaysia"
            },
            {
               "code": "MV",
               "name": "Maldives"
            },
            {
               "code": "ML",
               "name": "Mali"
            },
            {
               "code": "MT",
               "name": "Malta"
            },
            {
               "code": "MH",
               "name": "Marshall Islands"
            },
            {
               "code": "MQ",
               "name": "Martinique"
            },
            {
               "code": "MR",
               "name": "Mauritania"
            },
            {
               "code": "MU",
               "name": "Mauritius"
            },
            {
               "code": "YT",
               "name": "Mayotte"
            },
            {
               "code": "MX",
               "name": "Mexico"
            },
            {
               "code": "FM",
               "name": "Micronesia, Federated States of"
            },
            {
               "code": "MD",
               "name": "Moldova, Republic of"
            },
            {
               "code": "MC",
               "name": "Monaco"
            },
            {
               "code": "MN",
               "name": "Mongolia"
            },
            {
               "code": "ME",
               "name": "Montenegro"
            },
            {
               "code": "MS",
               "name": "Montserrat"
            },
            {
               "code": "MA",
               "name": "Morocco"
            },
            {
               "code": "MZ",
               "name": "Mozambique"
            },
            {
               "code": "MM",
               "name": "Myanmar"
            },
            {
               "code": "NA",
               "name": "Namibia"
            },
            {
               "code": "NR",
               "name": "Nauru"
            },
            {
               "code": "NP",
               "name": "Nepal"
            },
            {
               "code": "NL",
               "name": "Netherlands"
            },
            {
               "code": "NC",
               "name": "New Caledonia"
            },
            {
               "code": "NZ",
               "name": "New Zealand"
            },
            {
               "code": "NI",
               "name": "Nicaragua"
            },
            {
               "code": "NE",
               "name": "Niger"
            },
            {
               "code": "NG",
               "name": "Nigeria"
            },
            {
               "code": "NU",
               "name": "Niue"
            },
            {
               "code": "NF",
               "name": "Norfolk Island"
            },
            {
               "code": "MP",
               "name": "Northern Mariana Islands"
            },
            {
               "code": "NO",
               "name": "Norway"
            },
            {
               "code": "OM",
               "name": "Oman"
            },
            {
               "code": "PK",
               "name": "Pakistan"
            },
            {
               "code": "PW",
               "name": "Palau"
            },
            {
               "code": "PS",
               "name": "Palestine, State of"
            },
            {
               "code": "PA",
               "name": "Panama"
            },
            {
               "code": "PG",
               "name": "Papua New Guinea"
            },
            {
               "code": "PY",
               "name": "Paraguay"
            },
            {
               "code": "PE",
               "name": "Peru"
            },
            {
               "code": "PH",
               "name": "Philippines"
            },
            {
               "code": "PN",
               "name": "Pitcairn"
            },
            {
               "code": "PL",
               "name": "Poland"
            },
            {
               "code": "PT",
               "name": "Portugal"
            },
            {
               "code": "PR",
               "name": "Puerto Rico"
            },
            {
               "code": "QA",
               "name": "Qatar"
            },
            {
               "code": "RE",
               "name": "R\u00e9union"
            },
            {
               "code": "RO",
               "name": "Romania"
            },
            {
               "code": "RU",
               "name": "Russian Federation"
            },
            {
               "code": "RW",
               "name": "Rwanda"
            },
            {
               "code": "BL",
               "name": "Saint Barth\u00e9lemy"
            },
            {
               "code": "SH",
               "name": "Saint Helena, Ascension and Tristan da Cunha"
            },
            {
               "code": "KN",
               "name": "Saint Kitts and Nevis"
            },
            {
               "code": "LC",
               "name": "Saint Lucia"
            },
            {
               "code": "MF",
               "name": "Saint Martin (French part)"
            },
            {
               "code": "PM",
               "name": "Saint Pierre and Miquelon"
            },
            {
               "code": "VC",
               "name": "Saint Vincent and the Grenadines"
            },
            {
               "code": "WS",
               "name": "Samoa"
            },
            {
               "code": "SM",
               "name": "San Marino"
            },
            {
               "code": "ST",
               "name": "Sao Tome and Principe"
            },
            {
               "code": "SA",
               "name": "Saudi Arabia"
            },
            {
               "code": "SN",
               "name": "Senegal"
            },
            {
               "code": "RS",
               "name": "Serbia"
            },
            {
               "code": "SC",
               "name": "Seychelles"
            },
            {
               "code": "SL",
               "name": "Sierra Leone"
            },
            {
               "code": "SG",
               "name": "Singapore"
            },
            {
               "code": "SX",
               "name": "Sint Maarten (Dutch part)"
            },
            {
               "code": "SK",
               "name": "Slovakia"
            },
            {
               "code": "SI",
               "name": "Slovenia"
            },
            {
               "code": "SB",
               "name": "Solomon Islands"
            },
            {
               "code": "SO",
               "name": "Somalia"
            },
            {
               "code": "ZA",
               "name": "South Africa"
            },
            {
               "code": "GS",
               "name": "South Georgia and the South Sandwich Islands"
            },
            {
               "code": "SS",
               "name": "South Sudan"
            },
            {
               "code": "ES",
               "name": "Spain"
            },
            {
               "code": "LK",
               "name": "Sri Lanka"
            },
            {
               "code": "SD",
               "name": "Sudan"
            },
            {
               "code": "SR",
               "name": "Suriname"
            },
            {
               "code": "SJ",
               "name": "Svalbard and Jan Mayen"
            },
            {
               "code": "SZ",
               "name": "Swaziland"
            },
            {
               "code": "SE",
               "name": "Sweden"
            },
            {
               "code": "CH",
               "name": "Switzerland"
            },
            {
               "code": "SY",
               "name": "Syrian Arab Republic"
            },
            {
               "code": "TW",
               "name": "Taiwan, Province of China"
            },
            {
               "code": "TJ",
               "name": "Tajikistan"
            },
            {
               "code": "TZ",
               "name": "Tanzania, United Republic of"
            },
            {
               "code": "TH",
               "name": "Thailand"
            },
            {
               "code": "TL",
               "name": "Timor-Leste"
            },
            {
               "code": "TG",
               "name": "Togo"
            },
            {
               "code": "TK",
               "name": "Tokelau"
            },
            {
               "code": "TO",
               "name": "Tonga"
            },
            {
               "code": "TT",
               "name": "Trinidad and Tobago"
            },
            {
               "code": "TN",
               "name": "Tunisia"
            },
            {
               "code": "TR",
               "name": "Turkey"
            },
            {
               "code": "TM",
               "name": "Turkmenistan"
            },
            {
               "code": "TC",
               "name": "Turks and Caicos Islands"
            },
            {
               "code": "TV",
               "name": "Tuvalu"
            },
            {
               "code": "UG",
               "name": "Uganda"
            },
            {
               "code": "UA",
               "name": "Ukraine"
            },
            {
               "code": "AE",
               "name": "United Arab Emirates"
            },
            {
               "code": "GB",
               "name": "United Kingdom"
            },
            {
               "code": "US",
               "name": "United States"
            },
            {
               "code": "UM",
               "name": "United States Minor Outlying Islands"
            },
            {
               "code": "UY",
               "name": "Uruguay"
            },
            {
               "code": "UZ",
               "name": "Uzbekistan"
            },
            {
               "code": "VU",
               "name": "Vanuatu"
            },
            {
               "code": "VE",
               "name": "Venezuela, Bolivarian Republic of"
            },
            {
               "code": "VN",
               "name": "Viet Nam"
            },
            {
               "code": "VG",
               "name": "Virgin Islands, British"
            },
            {
               "code": "VI",
               "name": "Virgin Islands, U.S."
            },
            {
               "code": "WF",
               "name": "Wallis and Futuna"
            },
            {
               "code": "EH",
               "name": "Western Sahara"
            },
            {
               "code": "YE",
               "name": "Yemen"
            },
            {
               "code": "ZM",
               "name": "Zambia"
            },
            {
               "code": "ZW",
               "name": "Zimbabwe"
            }
         ];
   });
})();

(function() {

    angular.module("app.controllers").controller("LaserFilePopupFieldController", function($scope, $api, $resource, $state, $tiff_page, $uibModalStack, DTOptionsBuilder, dataTablesHebrewProvider, Field, Category_id, $rootScope, $uibModalInstance, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = Field ? Field : {};
        ctrl.form.category_id = Category_id ? Category_id : 1;

        $scope.isEdit = Field ? true : false;
       
        ctrl.submit = function(){
            if(!ctrl.form.id)
                $api.settings.laser_file_field.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_LF_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        //$state.transitionTo("app.settings.laser_file", {}, {reload: true});
                        $uibModalInstance.close();
                    }
                });
            else
                $api.settings.laser_file_field.single.save({
                    id: ctrl.form.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_LF_SAVE_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        
                        $uibModalInstance.close();
                    }
                });
        };

        ctrl.delete = function(){
            swal({
                title: "",
                text: $translate.instant('SWAL_LF_FIELD_DELETE_CONFIRM_TEXT').replace('[name]', ctrl.form.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.settings.laser_file_field.single.delete({id: ctrl.form.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_LF_FIELD_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $uibModalInstance.close();
                        }
                    });
            });
        };

        ctrl.showImage = function($event, image) {
            $event.stopPropagation();
            $event.preventDefault();
            swal({
                imageUrl: image,
                imageWidth: 800,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: $translate.instant('CALL_CANCEL'),
            })
    
        }

        ctrl.removeImage = function($event, key) {
            $event.stopPropagation();
            $event.preventDefault();
            ctrl.form.image = '';
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();
    
            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            $tiff_page.start_loading('save_image');
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
                $tiff_page.stop_loading('save_image');
            }, function(error){
                $tiff_page.stop_loading('save_image');
                console.log(error);
            });
        };
    });

})();

(function() {

    angular.module("app.controllers").controller("LaserFileController", function($scope, $api, $business, $state, $translate, $uibModal, $uibModalStack, Info, Data, Customer, Order, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.laser_categories = $business.laser_categories;
        ctrl.laser_category = 1;

        ctrl.form = [];
        ctrl.customer_id = Customer ? Customer.id : false;
        ctrl.order_id = Order ? Order.id : null;
        ctrl.fields = [];
        ctrl.blank = {};
        ctrl.orders = {};
        ctrl.orders_count = {};

        if (Info.data) {
            for (var i in Info.data) {
                if (Info.data[i].active) {
                    ctrl.fields.push(Info.data[i]);
                    ctrl.blank[Info.data[i].id] = '';
                }
            }
        }

        ctrl.init_list = function(data){
            ctrl.form = [];
            ctrl.orders = {};
            ctrl.orders_count = {};
            for (var i in data) {
                var d = JSON.parse(data[i].data);
                d.id = data[i].id
                d.show = false
                d.category_id = data[i].category_id;
                for (var j in ctrl.fields) {
                    //old code compatibility
                    if (d[ctrl.fields[j].code]) {
                        d[ctrl.fields[j].id] = d[ctrl.fields[j].code];
                    }
                    //old list code compatibility
                    if (ctrl.fields[j].list) {
                        for (var k in ctrl.fields[j].list) {
                            if (ctrl.fields[j].list[k].code && ctrl.fields[j].list[k].code == d[ctrl.fields[j].id]) {
                                d[ctrl.fields[j].id] = String(ctrl.fields[j].list[k].id);
                            }
                        }
                    }


                    if ((ctrl.fields[j].type == 'date' || ctrl.fields[j].type == 'datetime') && d[ctrl.fields[j].id]) {
                        d[ctrl.fields[j].id] = new Date(d[ctrl.fields[j].id]);
                    }
                }

                if (!ctrl.orders[data[i].order_id]) {
                    d.first = true;
                } else {
                    d.first = false;
                }

                if (data[i].order_id) {
                  ctrl.orders[data[i].order_id] = 'closed';
                  ctrl.orders_count[data[i].order_id] = ctrl.orders_count[data[i].order_id] ? ctrl.orders_count[data[i].order_id] + 1 : 1;
                  d.order_id = data[i].order_id;
                }

                ctrl.form.push(d);
            }
        }

        if (Data.data) {
            ctrl.init_list(Data.data);
        }

        ctrl.display_laser_orders = function(data, hide) {
          ctrl.orders[data.order_id] = hide ? 'closed' : 'opened';
          for (var i in ctrl.form) {
            if (ctrl.form[i].order_id == data.order_id) {
              ctrl.form[i].show = hide ? false : true;
            }
          }
        }

        ctrl.submit = function(easy){
            $api.laser_file.save({form: ctrl.form, customer_id: ctrl.customer_id, order_id: ctrl.order_id}, function(response){
                if (response.status === "success") {
                    ctrl.init_list(response.data);
                }
                if(response.status === "success" && !easy){
                    swal({
                        title: $translate.instant('SWAL_LF_P_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $uibModalStack.dismiss($uibModalStack.getTop().key);
                }
            });
        };

        ctrl.add_line = function(){
            //var copy = JSON.parse(JSON.stringify(ctrl.blank));
            var copy = {};
            copy.show = true;
            copy.category_id = ctrl.laser_category;
            
            if (Info.data) {
              for (var i in Info.data) {
                  if (Info.data[i].active && Info.data[i].category_id == ctrl.laser_category) {
                    if (Info.data[i].type == 'date' || Info.data[i].type == 'datetime') {
                      copy[Info.data[i].id] = new Date(new Date().setSeconds(0, 0));
                    } else {
                      copy[Info.data[i].id] = '';
                    }
                  }
              }
            }

            ctrl.form.push(copy);
        };

        ctrl.remove_line = function(index){
            swal({
                title: "",
                text: $translate.instant('LASER_FILE_REMOVE_LINE_CONFIRM'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value) {
                    ctrl.form[index].remove = true;
                    ctrl.submit(true);
                }
            });
        };

        ctrl.laser_map = function(index, field){
            $('body').addClass('fixed-body');

            $uibModal.open({
                templateUrl: "app/modules/settings/laser_file/map/laser_file.map.html",
                controller: "LaserFileMapController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Data: ctrl.form[index],
                  Field: field
                }
              }).result.then(function (val) {
                $('body').removeClass('fixed-body');
                  if (val) {
                      ctrl.form[index].menmap = val.men;
                      ctrl.form[index][field.id] = val.existed;
                      ctrl.submit(true);
                  }
              });
        };


    });

})();

(function() {

    angular.module("app.controllers").controller("LaserFileMapController", function($scope, $api, $state, Data, Field, $uibModalStack, $translate, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.men = Data.menmap ? true : false;
        ctrl.field = Field;
        ctrl.existed = Data && Data[ctrl.field.id] ? Data[ctrl.field.id] : false;

        var canvas, ctx;
        var pos = { x: 0, y: 0 };
        
        ctrl.init = function() {
          setTimeout( function() {
            canvas = document.getElementById('can');

            ctx = canvas.getContext('2d');
            ctrl.resize();

            document.addEventListener('mousemove', ctrl.draw);
            document.addEventListener('mousedown', ctrl.setPosition);
            document.addEventListener('mouseenter', ctrl.setPosition);

            document.addEventListener('touchmove', ctrl.draw);
            document.addEventListener('touchstart', ctrl.setPosition);

            ctrl.print();
          }, 500);
        }

        // new position from mouse event
        ctrl.setPosition = function (e) {
          pos.x = e.touches && e.touches["0"] ? e.touches["0"].clientX : e.clientX;
          pos.y = e.touches && e.touches["0"] ? e.touches["0"].clientY : e.clientY;
        }

        // resize canvas
        ctrl.resize = function() {
          var rect = ctx.canvas.parentElement.getBoundingClientRect()
          ctx.canvas.width = rect.width;
          ctx.canvas.height = ctx.canvas.width * 1.059;

          ctrl.change_image();
        }

        ctrl.draw = function(e) {
          if (e.buttons !== 1 && !e.touches) return;
          
          ctx.beginPath(); // begin

          ctx.lineWidth = 4;
          ctx.lineCap = 'round';
          ctx.strokeStyle = 'rgba(255, 0, 0, 0.5)';

          ctx.moveTo(pos.x-ctx.canvas.getBoundingClientRect().left, pos.y-ctx.canvas.getBoundingClientRect().top); // from
          ctrl.setPosition(e);
          ctx.lineTo(pos.x-ctx.canvas.getBoundingClientRect().left, pos.y-ctx.canvas.getBoundingClientRect().top); // to

          ctrl.generateSprayPoints(pos) // new

          //ctx.stroke(); // draw it!
        }

        ctrl.getRandomOffset = function(radius) {
          var randomAngle = Math.random() * (2 * Math.PI);
          var randomRadius = Math.random() * radius;
        
          return {
            x: Math.cos(randomAngle) * randomRadius,
            y: Math.sin(randomRadius) * randomAngle
          }
        }

        ctrl.generateSprayPoints = function(pos) {
          var amountOfPoints = 20
        
          for (var i = 0; i < amountOfPoints; i++) {
            var offset = ctrl.getRandomOffset(ctx.lineWidth * 2);
            var x = pos.x + offset.x - ctx.canvas.getBoundingClientRect().left
            var y = pos.y + offset.y - ctx.canvas.getBoundingClientRect().top
        
            ctx.fillStyle = ctx.strokeStyle
            ctx.fillRect(x, y, 1, 1)
          }
        }

        ctrl.erase = function() {
          swal({
              title: "",
              text: $translate.instant('LASER_FILE_MAP_CLEAR_CONFIRM'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              closeOnConfirm: false,
              showLoaderOnConfirm: true
          }).then(function(result) {
              if(result.value)
                ctrl.existed = [];
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctrl.resize();
          });
        }

        ctrl.change_image = function () {
          var background = new Image();
          background.src = ctrl.field.image ? ctrl.field.image : (ctrl.men ? "assets/images/menmap.jpg" : "assets/images/womenmap.jpg");

          background.onload = function(){
            ctx.canvas.parentElement.style.background = 'url('+background.src+') center no-repeat';
            ctx.canvas.parentElement.style.backgroundSize = 'contain';
          }
        }

        ctrl.print = function() {
          if (ctrl.existed) {
            var img = new Image;
            img.onload = function(){
              ctx.drawImage(img,0,0, ctx.canvas.width, ctx.canvas.height);
            };
            img.src = ctrl.existed;
          }
        }

        ctrl.save = function() {
          ctrl.existed = canvas.toDataURL();
        }

        ctrl.init();

    });

})();

(function() {

    angular.module("app.controllers").controller("LaserFileListController", function($scope, $api, $state, $uibModalStack, DTOptionsBuilder, dataTablesHebrewProvider, Field, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.list = Field.list ? Field.list : [];
       

        ctrl.submit = function(){
            $uibModalStack.dismiss($uibModalStack.getTop().key);
            return;
            $api.settings.laser_file.save({laser_file: ctrl.form}, function(response){
                if(response.status === "success"){
                    swal({
                        title: "פרטי העסק נשמרו",
                        type: "success",
                        confirmButtonText: "אישור",
                        timer: 2000
                    });

                    
                }
            });
        };

        ctrl.add_value = function(){
          var id = 1;
          for (var i in ctrl.list) {
            if (id <= ctrl.list[i].id) {
                id = ctrl.list[i].id;
            }
          }
          ctrl.list.push({id: id+1, name: ''});
        };

        ctrl.remove_value = function(index){
            ctrl.list = ctrl.list.slice(0, index).concat(ctrl.list.slice(index + 1, ctrl.list.length))
        };

    });

})();

(function () {
    angular.module('app.controllers').controller('ItemsStockLogController',
        function (Item, StockTransactions, $state, $header, $scope, $api, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal) {
            var ctrl = this;

            ctrl.transactions = StockTransactions.data;
            ctrl.item = Item.data;

            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', 20)
                        .withOption('aaSorting', [])
                        .withOption('searching', false);

            if (window.innerWidth < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 3;
            }

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.transactions = StockTransactions.data;
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.transactions) {
                        var found = false;
                        for (var k in ctrl.transactions[i]) {
                            if (ctrl.transactions[i][k] && ctrl.transactions[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.transactions[i]);
                        }
                    }

                    ctrl.transactions = newData;
                }
            }

            ctrl.open_log_card = function (id) {

                $uibModal.open({
                    templateUrl: "app/modules/settings/logs/modules/logs-info/logs.info.html",
                    controller: "LogsInfoController",
                    controllerAs: "ctrl",
                    windowTopClass: "form-modal small-modal",
                    scope: $scope,
                    resolve: {
                    Transaction: function ($api) {
                        return $api.resolve("transactions.single@get", {"id": id});
                        }
                    }
                }).closed.then(function() {

                });
            };

        });
})();

(function () {
    angular.module("app.controllers").controller("ItemsStockController",
      function (Item, $api, $scope, $state, $rootScope, $uibModalInstance, $translate) {
  
        if ($rootScope.userRole == 1) {
          $state.go('app.admin', {}, {reload: true});
          return;
        }
        var ctrl = this;
        ctrl.item = Item.data;
  
        // Form data
        ctrl.form = {
          amount_changed: 0,
          cost: 0,
          comment: ''
        };
  
        /**
         * Change item stock
         */
        ctrl.saveForm = function () {
          $api.items.single.save({id: ctrl.item.id, action: 'change_stock', data: ctrl.form}, function (response) {
            if (response.status == "success") {
              swal({
                title: $translate.instant('ITEM_CHANGED_STOCK_MSG'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              }).then(function () {
                $uibModalInstance.close();
              });
            }
          });
        }
  
      });
  })();
  
(function() {

    angular.module("app.controllers").controller("ItemsSelectController", function($scope, $state, Items, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.items = Items;
        ctrl.item_name = "";


        /**
         * search item
        */
        $scope.find_item = function() {
            var found = [];
            
            for (var i in Items) {
                if (ctrl.item_name == "" || (Items[i].name && Items[i].name.toLowerCase().indexOf(ctrl.item_name.toLowerCase().trim()) >= 0)) {
                    found.push(Items[i]);
                }
            }
            if (ctrl.items.length != found.length) {
                ctrl.items = found;
                if ($('#items_dt').DataTable()) {
                    $('#items_dt').DataTable().clear().draw();
                }
            }
        }

        $scope.find_item();


        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('scrollY', '500px')
            .withOption('order', [[2, 'asc']])
            .withOption('searching', false);

        ctrl.selectCustomer = function(index) {
            $uibModalInstance.close(ctrl.items[index]);
        }

    });

})();

(function () {
  angular.module("app.controllers").controller("GiftCardsSelectController", function ($scope, $state, GiftCards, SelectedGiftCards, $rootScope, $uibModalInstance, DTOptionsBuilder, dataTablesHebrewProvider, $timeout) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.search = '';
    ctrl.giftCards = angular.copy(GiftCards.data || []);
    ctrl.tableData = [];

    ctrl.selectedCards = SelectedGiftCards || [];
    ctrl.giftCardToggle = function (row) {
      var i, idx = -1;
      for (i = 0; i < ctrl.selectedCards.length; i++) {
        if (ctrl.selectedCards[i].id === row.id) {
          idx = i;
          break;
        }
      }

      if (idx > -1) {
        ctrl.selectedCards.splice(idx, 1);
      } else {
        ctrl.selectedCards.push(row);
      }
    };

    ctrl.isSelected = function (row) {
      for (var i = 0; i < ctrl.selectedCards.length; i++) {
        if (ctrl.selectedCards[i].id === row.id) {
          return true;
        }
      }
      return false;
    };

    function isUsed(card) {
      return !!(card.used === true || card.used === 1 || card.used === '1' || card.used === 'true');
    }

    function toStr(v) {
      return (v == null ? '' : (v + '')).toLowerCase();
    }

    function matchesSearch(card) {
      var q = toStr(ctrl.search).trim();
      if (!q) {
        return true;
      }

      var tokens = q.split(/\s+/);
      var hay = [
        toStr(card.number),
        toStr(card.name),
        toStr(card.service_text),
        toStr(card.sender_text),
        toStr(card.gifted_to)
      ].join(' ');

      for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] && hay.indexOf(tokens[i]) === -1) {
          return false;
        }
      }
      return true;
    }

    ctrl.applyFilters = function () {
      ctrl.tableData = ctrl.giftCards.filter(function (el) {
        return !isUsed(el) && matchesSearch(el);
      });
    };

    ctrl.applyFilters();

    var searchDebounce;
    $scope.$watch(function () { return ctrl.search; }, function () {
      if (searchDebounce) {
        $timeout.cancel(searchDebounce);
      }

      searchDebounce = $timeout(function () {
        ctrl.applyFilters();
      }, 150);
    });

    /**
     * Datatable configuration
     */
    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('order', [[0, 'asc']])
      .withOption('pageLength', 20);

    ctrl.confirm = function () {
      $uibModalInstance.close(ctrl.selectedCards);
    };
  });
})();
(function () {
  angular.module("app.controllers").controller("GiftCardsDetailsController", function ($scope, $state, Customer, Item, Templates, Info, $rootScope, $uibModalInstance) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.item = Item.isGiftCard ? angular.copy(Item) : null;

    ctrl.values = {
      receiver: ctrl.item ? ctrl.item.gifted_to : '',
      message: ctrl.item ? ctrl.item.message_text : '',
    };

    if (Info) {
      var address = [];
      if (Info.data.city) {
        address.push(Info.data.city);
      }
      if (Info.data.address) {
        address.push(Info.data.address);
      }
      if (Info.data.home_number) {
        address.push(Info.data.home_number);
      }
      
      ctrl.values.business = Info.data.name;
      ctrl.values.address = address.join(', ');
    }

    if (Item) {
      ctrl.values.value = Item.price * Item.quantity;
      ctrl.values.service = ctrl.item ? ctrl.item.service_text : Item.name;
    }

    if (Customer) {
      ctrl.values.sender = ctrl.item ? ctrl.item.sender_text : [Customer.firstname, Customer.lastname].join(' ');
    }

    ctrl.templates = [];
    if (Templates) {
      ctrl.templates = Templates.data;
    }

    ctrl.localSettings = {};
    ctrl.selectedTemplate = 0;
    if (ctrl.item && ctrl.item.gift_card_template_id) {
      var foundIndex = -1;
      for (var i = 0; i < ctrl.templates.length; i++) {
        if (ctrl.templates[i].id == ctrl.item.gift_card_template_id) {
          foundIndex = i;
          break;
        }
      }

      ctrl.selectedTemplate = foundIndex > -1 ? foundIndex : 0;
    }

    ctrl.bumpSettings = function() {
      ctrl.localSettings = angular.extend({}, ctrl.localSettings);
    };

    ctrl.bumpValues = function() {
      ctrl.values = angular.extend({}, ctrl.values);
    };

    ctrl.selectTemplate = function(index) {
      ctrl.selectedTemplate = index;

      var template = ctrl.templates[index];
      if (template) {
        ctrl.localSettings.page_bg_color = ctrl.item ? ctrl.item.page_bg_color : template.page_bg_color;
        ctrl.localSettings.card_bg_color = ctrl.item ? ctrl.item.card_bg_color : template.card_bg_color;
        ctrl.localSettings.primary_color = ctrl.item ? ctrl.item.primary_color : template.primary_color;
        ctrl.localSettings.text_color = ctrl.item ? ctrl.item.text_color : template.text_color;
        ctrl.localSettings.logo = ctrl.item ? ctrl.item.logo : template.logo;
        ctrl.localSettings.image = ctrl.item ? ctrl.item.image : template.image;
        ctrl.localSettings.receiver = ctrl.item ? ctrl.item.receiver : template.receiver;
        ctrl.localSettings.sender = ctrl.item ? ctrl.item.sender : template.sender;
        ctrl.localSettings.service = ctrl.item ? ctrl.item.service : template.service;
        ctrl.localSettings.value = ctrl.item ? ctrl.item.value : template.value;
        ctrl.localSettings.message = ctrl.item ? ctrl.item.message : template.message;

        ctrl.values.name = ctrl.item ? ctrl.item.name : template.name;
      }

      ctrl.bumpSettings()
    };
    
    ctrl.$onInit = function () {
      if (ctrl.templates.length) {
        ctrl.selectTemplate(ctrl.selectedTemplate);
      }
    };

    $scope.$watch(
      function () {
        return ctrl.selectedTemplate;
      },

      function (idx, prev) {
        if (idx !== prev && idx != null && ctrl.templates[idx]) {
          ctrl.selectTemplate(idx);
        }
      }
    );

    ctrl.save = function () {
      $uibModalInstance.close({
        template_id: ctrl.templates[ctrl.selectedTemplate] ? ctrl.templates[ctrl.selectedTemplate].id : null,
        settings: ctrl.localSettings,
        values: ctrl.values,
      });
    };
  });
})();

(function () {
  angular.module("app.controllers").controller("GiftCardsBalanceController", function ($state, GiftCard, $rootScope, $uibModalInstance) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.giftCard = GiftCard ? angular.copy(GiftCard) : null;

    ctrl.save = function () {
      $uibModalInstance.close(ctrl.giftCard);
    };
  });
})();

(function () {

    angular.module('app.controllers')

        .controller('NotificationsListController', function (Notifications, $state, $user, $api, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.tableData = Notifications && Notifications.data ? Notifications.data : [];

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NOTIFICATIONS_LIST"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[2, 'desc']]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = Notifications && Notifications.data ? Notifications.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }

            ctrl.delete = function(id) {
                $api.notifications.remove.get({id: id}, function (response) {
                    if (response.status == "success") {
                        $state.go($state.current, {}, {reload: true});
                        $user.getNotifications();
                    }
                });
            }
        });
})();

(function(){
  angular.module('app.controllers').controller('NotesListController',
    function ($state, $header, $scope, $api, DTOptionsBuilder, $tiff_page, $uibModal, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log) {
      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      ctrl.search = "";
      ctrl.type = "notes";

      $header.title = "NAV_NOTES";
      $header.breadcrumbs.push({
        "title": "NAV_NOTES"
      });

      ctrl.change_type = function(type) {
        ctrl.type = type;
        $scope.find_items();
      }

   
      $scope.find_items = function() {
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      ctrl.add_note = function(note) {
        $uibModal.open({
          templateUrl: "app/modules/notes/modules/notes-form/notes.form.html",
          controller: "NotesFormController",
          controllerAs: "ctrl",
          scope: $scope,
          smallModal: true,
          windowTopClass: "form-modal small-modal",
          resolve: {
            Customer: function($api) {
              return {data: note ? {id: note.customer_id, name: note.customer_name} : null};
            },
            Resources: function($api) {
              return $api.resolve("resources@get");
            },
            Note: note ? note : null,
          }
        }).result.then(function (val) {
          $('#cust_dt').DataTable().ajax.reload();
        });
      };

      ctrl.add_medical_note = function(medical_note) {
        $uibModal.open({
          templateUrl: "app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html",
          controller: "MedicalNotesFormController",
          controllerAs: "ctrl",
          scope: $scope,
          smallModal: true,
          windowTopClass: "form-modal small-modal",
          resolve: {
            Customer: function($api) {
              return {data: medical_note ? {id: medical_note.customer_id, name: medical_note.customer_name} : null};
            },
            Resources: function($api) {
              return $api.resolve("resources@get");
            },
            MedicalNote: medical_note ? medical_note : null,
          }
        }).result.then(function (val) {
          $('#cust_dt').DataTable().ajax.reload();
        });
      };

      /**
       * Initiate DataTable Options
       */
      ctrl.initDtOptions = function(){
        $scope.dtOptions =
          DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            //.withOption('order', [[1, 'desc']])
            .withOption('aaSorting', [])
            .withOption('searching', false)
            .withOption('ajax', ctrl.loadList)
            .withOption('serverSide', true)
            .withDataProp('data')
            .withOption('rowCallback', ctrl.ListRawCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });
      };

      /**
       * Load customers
       *
       * @param data
       * @param callback
       * @param settings
       */
      ctrl.loadList = function (data, callback, settings) {
        var orderCol = '';
        var orderDir = '';

        if(data.order.length) {
          // Use only last order parameters
          var colIndex = data.order[data.order.length - 1].column
          var orderCol = data.columns[colIndex]['name'];
          var orderDir = data.order[data.order.length - 1].dir;
        }

        $tiff_page.start_loading('list');
        var point = ctrl.type == "notes" ? $api.notes : $api.medical_notes;

        point.get(
          {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.search},
            function (result) {
              if (result && result.data) {

                $tiff_page.stop_loading('list');

                callback({
                  recordsTotal: result.recordsTotal,
                  recordsFiltered: result.recordsFiltered,
                  data: result.data,
                  draw: data.draw + 1
                });
              }

        });
      };

      /**
       * Bind events to a new row
       *
       * @param nRow
       * @param aData
       * @param iDisplayIndex
       * @param iDisplayIndexFull
       * @returns {*}
       */
      ctrl.ListRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        if (aData.removed_at) {
          $(nRow).addClass('deleted-row');
        } else {
          $(nRow).removeClass('deleted-row');
        }

        $(nRow).unbind('click');
        $(nRow).bind('click', function() {
          $scope.$apply(function() {
            if (ctrl.type == "notes") {
              ctrl.add_note(aData);
            } else if (ctrl.type == "medical_notes") {
              ctrl.add_medical_note(aData);
            }
          });
        });
        
        return nRow;
      }

      ctrl.initDtOptions();

      /**
       * Customer table column definitions
       * @type {*[]}
       */
      ctrl.dtColumns = [
        { name: 'customer_name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'customer-name',
          render: function(data, type, full, meta) {
            var html = "";
            if (data.customer_name || data.customer_avatar) {
              html += '<div class="customer-pic-wrapper"><img src="'+(data.customer_avatar ? data.customer_avatar : 'assets/images/avatar.jpg')+'" alt="User Profile" class="customer-pic"></div> ';
              html += data.customer_name;
            }
            return html;
          }
        },
        { name: 'created_at', data: 'created_at_display', title: $translate('NOTES_CREATED_AT') },
        { name: 'resource_name', data: 'resource_name', title: $translate('NOTES_RESOURCE') },
        { name: 'text', data: 'text', title: $translate('NOTES_TEXT') },
        { name: 'remind_at', data: 'remind_at_display', title: $translate('NOTES_REMIND_AT') },
      ];
      
      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstanceCustomers = dtInstance;
      }

    });
})();

(function() {

    angular.module("app.controllers").controller("NotesFormController", function($scope, $state, $timeout, $translate, $rootScope, Note, Resources, Customer, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.date = new Date();
        ctrl.customer_modal = Customer && Customer.data ? true : false;
        ctrl.customer_search_name = Customer && Customer.data ? Customer.data.name : "";
        ctrl.customer_selected_name = "";
        ctrl.searchCustomerResult = [];
    
        ctrl.form = {
          customer_id: Customer && Customer.data ? Customer.data.id : false,
          resource_id: "",
          text: "",
          remind_at: "",
          remind_at_date: ctrl.date,
          remind_at_time: '',
        };

        $scope.isEdit = false;

        $scope.resources = Resources.data;

        /**
         * Initialize edit data
         */
        if(Note != null) {
            $scope.isEdit = true;
            
            ctrl.form.customer_id = Note.customer_id;
            ctrl.form.resource_id = String(Note.resource_id);
            ctrl.form.text = Note.text;
            ctrl.form.remind_at_date = Note.remind_at ? new Date(Note.remind_at) : undefined;
            ctrl.form.remind_at_time = Note.remind_at ? new Date(Note.remind_at) : undefined;
        }

        ctrl.find_customer = function() {
            $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response){
                if (response.str == ctrl.customer_search_name) {
                    ctrl.searchCustomerResult = response.data;
                }
            });
        }

        ctrl.chooseCustomer = function(index,$event){
            ctrl.customerData = ctrl.searchCustomerResult[index];
            ctrl.form.customer_id = ctrl.customerData.id;
            ctrl.customer_selected_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.customer_search_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.searchCustomerResult = [];
            $event.stopPropagation();
        }

        ctrl.cleanCustomerSearch = function() {
            ctrl.customer_search_name = ctrl.customer_selected_name;
            $timeout(function(){
                ctrl.searchCustomerResult = [];
                }, 200);
        }

        ctrl.submit = function(){
            ctrl.form.remind_at = ctrl.combineDateTime(ctrl.form.remind_at_time, ctrl.form.remind_at_date);

            if(Note == null)
                $api.notes.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
            else
                $api.notes.single.save({
                    id: Note.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
        };

        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_NOTES_DELETE_CONFIRM_TEXT'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.notes.single.delete({id: Note.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_NOTES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $scope.$close();
                        }
                    });
            });
        };

        ctrl.combineDateTime = function(dateTime1, dateTime2) {
            // Get time (hours, minutes) from dateTime1 in local timezone format
            if (!dateTime1 || !dateTime2) return null;

            var hours = dateTime1 ? dateTime1.getHours() : 0;
            var minutes = dateTime1 ? dateTime1.getMinutes() : 0;

            // Get day, month, and year from dateTime2 in local timezone
            dateTime2 = new Date(dateTime2);
            var day = dateTime2.getDate();
            var month = dateTime2.getMonth();
            var year = dateTime2.getFullYear();

            // Create a new Date object using the local timezone
            var combinedDateTime = new Date(year, month, day, hours, minutes);

            // Adjust the combinedDateTime by the local timezone offset
            var timezoneOffset = combinedDateTime.getTimezoneOffset();
            combinedDateTime.setMinutes(combinedDateTime.getMinutes() - timezoneOffset);

            return combinedDateTime;
          }

    });

})();

(function() {

    angular.module("app.controllers").controller("MedicalNotesLogController", function($scope, $state, $translate, $rootScope, Log, DTOptionsBuilder, dataTablesHebrewProvider, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
    
        ctrl.list = Log.data ? Log.data : [];

        $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('aaSorting', [])
            .withOption('searching', false);
    });

})();

(function() {

    angular.module("app.controllers").controller("MedicalNotesFormController", function($scope, $state, $timeout, $translate, $rootScope, MedicalNote, Resources, Customer, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.date = new Date();
        ctrl.customer_modal = Customer && Customer.data ? true : false;
        ctrl.customer_search_name = Customer && Customer.data ? Customer.data.name : "";
        ctrl.customer_selected_name = "";
        ctrl.searchCustomerResult = [];
    
        ctrl.form = {
          customer_id: Customer && Customer.data ? Customer.data.id : false,
          resource_id: "",
          text: "",
          remind_at: "",
          remind_at_date: ctrl.date,
          remind_at_time: '',
        };
        
        $scope.isEdit = false;

        $scope.resources = Resources.data;

        /**
         * Initialize edit data
         */
        if(MedicalNote != null) {
            $scope.isEdit = true;
            
            ctrl.form.customer_id = MedicalNote.customer_id;
            ctrl.form.resource_id = String(MedicalNote.resource_id);
            ctrl.form.text = MedicalNote.text;
            ctrl.form.remind_at_date = MedicalNote.remind_at ? new Date(MedicalNote.remind_at) : undefined;
            ctrl.form.remind_at_time = MedicalNote.remind_at ? new Date(MedicalNote.remind_at) : undefined;
        }

        ctrl.find_customer = function() {
            $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response){
                if (response.str == ctrl.customer_search_name) {
                    ctrl.searchCustomerResult = response.data;
                }
            });
        }

        ctrl.chooseCustomer = function(index,$event){
            ctrl.customerData = ctrl.searchCustomerResult[index];
            ctrl.form.customer_id = ctrl.customerData.id;
            ctrl.customer_selected_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.customer_search_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.searchCustomerResult = [];
            $event.stopPropagation();
        }

        ctrl.cleanCustomerSearch = function() {
            ctrl.customer_search_name = ctrl.customer_selected_name;
            $timeout(function(){
                ctrl.searchCustomerResult = [];
                }, 200);
        }

        ctrl.submit = function(){
            ctrl.form.remind_at = ctrl.combineDateTime(ctrl.form.remind_at_time, ctrl.form.remind_at_date);

            if(MedicalNote == null)
                $api.medical_notes.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
            else
                $api.medical_notes.single.save({
                    id: MedicalNote.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
        };

        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_NOTES_DELETE_CONFIRM_TEXT'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.medical_notes.single.delete({id: MedicalNote.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_NOTES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $scope.$close();
                        }
                    });
            });
        };

        ctrl.combineDateTime = function(dateTime1, dateTime2) {
            // Get time (hours, minutes) from dateTime1 in local timezone format
            if (!dateTime1 || !dateTime2) return null;

            var hours = dateTime1 ? dateTime1.getHours() : 0;
            var minutes = dateTime1 ? dateTime1.getMinutes() : 0;

            // Get day, month, and year from dateTime2 in local timezone
            dateTime2 = new Date(dateTime2);
            var day = dateTime2.getDate();
            var month = dateTime2.getMonth();
            var year = dateTime2.getFullYear();

            // Create a new Date object using the local timezone
            var combinedDateTime = new Date(year, month, day, hours, minutes);

            // Adjust the combinedDateTime by the local timezone offset
            var timezoneOffset = combinedDateTime.getTimezoneOffset();
            combinedDateTime.setMinutes(combinedDateTime.getMinutes() - timezoneOffset);

            return combinedDateTime;
          }

    });

})();

(function() {

    angular.module("app.controllers").controller("AutomationsFormController", function($scope, $cfilter, $resource, $cookies, $state, dates, $api, $timeout, Automation, DigitalForms, CustomerStatuses, $rootScope, $translate, $user) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            "name": "",
            "trigger": "",
            "order_status": "",
            "birthday_time": null,
            "send_message": true,
            "active": true,
            "recommendation": false,
            "digital_form_id": '',
            "notify_type": "email",
            "notify_text": "",
            "remind_type": "",
            "remind_time": "",
            "timetype": "minutes",
            "filter": {},
            "files": [],
            "once": false,
            "last": false,
            "change_customer_status": false,
            "status_id": 0,
        };

        $scope.datesProvider = dates;

        var fileElement = null;

        $scope.isEdit = false;
        $scope.automationId = false;
        ctrl.triggers = [
            { id:'cashbox_sell', name: $translate.instant('AUTOMATION_TRIGGER_CASHBOX_SELL'), after: true, before: false, now: false },
            { id:'order_date', name: $translate.instant('AUTOMATION_TRIGGER_ORDER_DATE'), after: true, before: true, now: true },
            { id:'status', name: $translate.instant('AUTOMATION_TRIGGER_STATUS'), after: true, before: false, now: false },
            { id:'order_status', name: $translate.instant('AUTOMATION_TRIGGER_ORDER_STATUS'), after: true, before: false, now: false },
            { id:'birthday', name: $translate.instant('AUTOMATION_TRIGGER_BIRTHDAY'), after: true, before: true, now: false },
        ];

        ctrl.orderStatuses = [
            { name: $translate.instant('ORDER_STATUS_OPEN'), value: '0,2' },
            { name: $translate.instant('ORDER_STATUS_CANCELLED'), value: '1' },
            { name: $translate.instant('ORDER_STATUS_PAID'), value: '3' },
            { name: $translate.instant('ORDER_STATUS_CUSTOMER_BOOKED'), value: '4' },
        ];

        ctrl.wa_status = $cookies.get("wa_status");

        $scope.uploadFile = function(element){
            ctrl.form.files = element.files;
            fileElement = element;
            $scope.$apply();
        };

        ctrl.digitalForms = DigitalForms ? DigitalForms.data : [];
        ctrl.customerStatuses = CustomerStatuses ? CustomerStatuses.data : [];

        /**
         * Filter
        */
        $rootScope.automations_filter = {};

        /**
         * Initialize edit data
         */
        if(Automation != null) {
            $scope.isEdit = true;

            $scope.automationId = Automation.data.id;

            ctrl.form.name = Automation.data.name;
            ctrl.form.trigger = Automation.data.trigger;
            ctrl.form.order_status = Automation.data.order_status;
            if (Automation.data.birthday_time) {
                var parts = Automation.data.birthday_time.split(':'); // ['05', '04']
                var date = new Date();
                date.setHours(parseInt(parts[0], 10));
                date.setMinutes(parseInt(parts[1], 10));
                date.setSeconds(0);
                date.setMilliseconds(0);
                ctrl.form.birthday_time = date;
            } else {
                ctrl.form.birthday_time = null;
            }

            ctrl.form.send_message = Automation.data.send_message;
            ctrl.form.active = Automation.data.active;
            ctrl.form.recommendation = Automation.data.recommendation;
            ctrl.form.once = Automation.data.once;
            ctrl.form.last = Automation.data.last;
            ctrl.form.notify_type = Automation.data.notify_type;
            ctrl.form.notify_text = Automation.data.notify_text;
            ctrl.form.remind_type = Automation.data.remind_type;
            ctrl.form.remind_time = Automation.data.remind_time;
            ctrl.form.timetype = Automation.data.timetype;
            ctrl.form.digital_form_id = Automation.data.digital_form_id ? Automation.data.digital_form_id : '';
            ctrl.form.filter = Automation.data.filter ? JSON.parse(Automation.data.filter) : {};
            ctrl.form.files = Automation.data.files ? JSON.parse(Automation.data.files) : {};

            ctrl.form.change_customer_status = Automation.data.change_customer_status;
            ctrl.form.status_id = Automation.data.status_id;

            $rootScope.automations_filter = ctrl.form.filter;
        }

        ctrl.isMobile = (angular.element(document).width() < 769);

        ctrl.checkRemindType = function(type) {
            for (var i in ctrl.triggers) {
                if (ctrl.triggers[i].id == ctrl.form.trigger) {
                    if (ctrl.form.remind_type == type && !ctrl.triggers[i][type]) {
                        ctrl.form.remind_type = "";
                    }
                    return ctrl.triggers[i][type];
                }
            }
            return false;
        }

        ctrl.displayRemindType = true;
        
        $scope.$watch('ctrl.form.trigger', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                ctrl.displayRemindType = false;
                $timeout(function() {
                    ctrl.displayRemindType = true;
                });
            }
        });

        ctrl.variables = {
            'customer_name' : "[the customer's name]",
            "customer_name|he" : "[שם הלקוח]",
            'businesses_name' : "[name of the business]",
            "businesses_name|he" : "[שם בית העסק]",
        };

        ctrl.insertVariable = function(code) {
            code = $user.currentLanguage == 'hb_ISR' ? code+'|he' : code;
            var variable = ctrl.variables[code] ? ctrl.variables[code] : '['+code+']';
            ctrl.form.notify_text += variable;
        }

        ctrl.submit = function(){
            ctrl.form.filter = $rootScope.automations_filter || {};

            if (ctrl.form.name == '' || ctrl.form.trigger == '' || (ctrl.form.change_customer_status && ctrl.form.status_id == 0)) {
                return;
            }

            var fdata = new FormData();
            if (fileElement && fileElement.files && fileElement.files.length > 0) {
                fdata.append("file", fileElement.files[0]);
            } else if (ctrl.form.files && ctrl.form.files.length > 0) {
                fdata.append("uploaded_file", JSON.stringify(ctrl.form.files));
            } else {
                fdata.append("uploaded_file", '');
            }
            
            fdata.append("name", ctrl.form.name);
            fdata.append("trigger", ctrl.form.trigger);
            fdata.append("order_status", ctrl.form.order_status);
            if (ctrl.form.birthday_time instanceof Date) {
                var hours = ctrl.form.birthday_time.getHours();
                var minutes = ctrl.form.birthday_time.getMinutes();
                if (hours < 10) hours = '0' + hours;
                if (minutes < 10) minutes = '0' + minutes;

                fdata.append("birthday_time", hours + ':' + minutes);
            } else {
                fdata.append("birthday_time", '');
            }
            fdata.append("send_message", ctrl.form.send_message);
            fdata.append("active", ctrl.form.active);
            fdata.append("recommendation", ctrl.form.recommendation);
            fdata.append("once", ctrl.form.once);
            fdata.append("last", ctrl.form.last);
            fdata.append("notify_type", ctrl.form.notify_type);
            fdata.append("notify_text", ctrl.form.notify_text);
            fdata.append("remind_type", ctrl.form.remind_type);
            fdata.append("remind_time", ctrl.form.remind_time == null ? '' : ctrl.form.remind_time);
            fdata.append("digital_form_id", ctrl.form.digital_form_id ? ctrl.form.digital_form_id : '');
            fdata.append("timetype", ctrl.form.timetype);
            fdata.append("change_customer_status", ctrl.form.change_customer_status);
            fdata.append("status_id", ctrl.form.status_id);
            fdata.append("filter", JSON.stringify(ctrl.form.filter));

            $resource($api.baseURL + '/automations'+((Automation == null) ? '' : '/id/:id'), ((Automation == null) ? {} : {id: Automation.data.id}), {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                if(response.status == "success") {
                    if(Automation == null) {
                        swal({
                            title: $translate.instant('SWAL_AUTOMATIONS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.marketing.automations", {}, {reload: true});
                    } else {
                        swal({
                            title: $translate.instant('SWAL_AUTOMATIONS_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.marketing.automations", {id: Automation.data.id}, {reload: true});
                    }
                }
            }, function(error){
                console.log(error);
            });
        };

        
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_AUTOMATIONS_DELETE_CONFIRM_TEXT').replace('[name]', Automation.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.automations.single.delete({id: Automation.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_AUTOMATIONS_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.marketing.automations", {}, {reload: true});
                        }
                    });
            });
        };


        $cfilter.apply('automations');
    });

})();

(function () {
  angular.module('app.controllers').controller('DigitalFormsAllListController',
    function ($state, $header, $scope, $api, DTOptionsBuilder, $tiff_page, $uibModal, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.search = "";

      $header.title = "NAV_DIGITAL_FORMS";
      $header.breadcrumbs.push({
        "title": "NAV_DIGITAL_FORMS"
      });

      /**
         * search customer
         */
      $scope.find_items = function () {
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      ctrl.newForm = function () {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
          controller: "CustomersDigitalFormsAddController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal laser-file-modal",
          resolve: {
            DigitalForms: ['$api', function ($api) {
              return $api.resolve("digital_forms@get");
            }],
            Customer: null,
            DigitalForm: null,
            Order: null,
            OrderForm: false
          }
        }).result.then(function (result) {
          if (result) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        });
      }

      ctrl.add_digital_form = function (digital_form) {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
          controller: "CustomersDigitalFormsController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal laser-file-modal",
          resolve: {
            Customer: digital_form && digital_form.customer_id ? ['$api', function ($api) {
                return $api.resolve('customers.single@get', { id: digital_form.customer_id });
              }
            ] : null,
            DigitalForm: digital_form ? ['$api', function ($api) {
                return $api.resolve('customer_forms@get', { id: digital_form.id });
              }
            ] : null,
            DigitalForms: null,
            Business: [ '$api', function ($api) {
                return $api.resolve('settings.info@get');
              }
            ],
            Order: null
          }
        }).result.then(function (val) {
          $('#cust_dt').DataTable().ajax.reload();
        });
      };

      /**
       * Initiate DataTable Options
       */
      ctrl.initDtOptions = function () {
        $scope.dtOptions =
          DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            //.withOption('order', [[1, 'desc']])
            .withOption('aaSorting', [])
            .withOption('searching', false)
            .withOption('ajax', ctrl.loadList)
            .withOption('serverSide', true)
            .withDataProp('data')
            .withOption('rowCallback', ctrl.ListRawCallback)
            .withOption('createdRow', function (row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });
      };

      /**
       * Load Digital Forms
       *
       * @param data
       * @param callback
       * @param settings
       */
      ctrl.loadList = function (data, callback, settings) {
        var orderCol = '';
        var orderDir = '';

        if (data.order.length) {
          // Use only last order parameters
          var colIndex = data.order[data.order.length - 1].column
          var orderCol = data.columns[colIndex]['name'];
          var orderDir = data.order[data.order.length - 1].dir;
        }

        $tiff_page.start_loading('list');

        $api.digital_forms.all.save({
          limit: data.length,
          offset: data.start,
          order: orderCol,
          order_dir: orderDir,
          search: ctrl.search
        }, function (result) {
          if (result && result.data) {
            $tiff_page.stop_loading('list');

            callback({
              recordsTotal: result.recordsTotal,
              recordsFiltered: result.recordsFiltered,
              data: result.data,
              draw: data.draw + 1
            });
          }
        });
      };

      /**
       * Bind events to a new row
       *
       * @param nRow
       * @param aData
       * @param iDisplayIndex
       * @param iDisplayIndexFull
       * @returns {*}
       */
      ctrl.ListRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        //console.log(aData)
        $(nRow).unbind('click');
        $(nRow).bind('click', function () {
          $scope.$apply(function () {
            ctrl.add_digital_form(aData);
          });
        });

        return nRow;
      }

      ctrl.initDtOptions();

      /**
       * Customer table column definitions
       * @type {*[]}
       */
      ctrl.dtColumns = [
        {
          name: 'customer_name', data: null, title: $translate('CUSTOMER_FORMS_CUSTOMER_NAME'), class: 'customer-name',
          render: function (data, type, full, meta) {
            var html = "";
            if (data.customer_name || data.customer_avatar) {
              html += '<div class="customer-pic-wrapper"><img src="' + (data.customer_avatar ? data.customer_avatar : 'assets/images/avatar.jpg') + '" alt="User Profile" class="customer-pic"></div> ';
              html += data.customer_name;
            }
            return html;
          }
        },
        { name: 'name', data: 'name', title: $translate('CUSTOMER_FORMS_NAME') },
        { name: 'date', data: 'date_display', title: $translate('CUSTOMER_FORMS_DATE') },
        { name: 'fill_date', data: 'fill_date_display', title: $translate('CUSTOMER_FORMS_FILL_DATE') },
        { name: 'icons', orderable: false,
          render: function (data, type, full, meta) {
            var html = '<div class="buttons-box">';
            html += '<button tooltip="' + $translate.instant('CUSTOMERS_DF_PDF_TOOLTIP') + '" class="have-tooltip green btn icon circle large single-model-message" ng-click="$event.stopPropagation(); ctrl.send_form(' + full.id + ')">';
            html += '<i class="las la-file-pdf"></i>';
            html += '</button>';
            html += '<button tooltip="' + $translate.instant('CUSTOMERS_DF_PRINT_TOOLTIP') + '" class="have-tooltip blue btn icon circle large single-model-message" ng-click="$event.stopPropagation(); ctrl.print_form(' + full.id + ')">';
            html += '<i class="las la-print"></i>';
            html += '</button>';
            html += '</div>';
            return html;
          }
        },
        { name: 'remove', orderable: false,
          render: function (data, type, full, meta) {
            var html = '<div class="buttons-box">';
            html += '<button class="btn text border-red" ng-click="ctrl.removeForm(' + full.id + '); $event.stopPropagation()">' + $translate.instant('SETTINGS_INFO_REMOVE') + '</button>';
            html += '</div>';
            return html;
          }
        },
      ];

      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstanceCustomers = dtInstance;
      }

      ctrl.removeForm = function (form_id) {
        swal({
          title: "",
          text: $translate.instant('SWAL_CUSTOMER_DELETE_CONFIRM_TEXT'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            $api.customer_forms.delete({ id: form_id }, function (response) {
              if (response.status == "success") {
                ctrl.dtInstanceCustomers.reloadData(null, false)
              }
            });
          }
        });
      }

      ctrl.print_form = function (form_id) {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html",
          controller: "CustomersDigitalFormsPrintController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal laser-file-modal",
          resolve: {
            DigitalForm: function ($api, $stateParams, $rootScope) {
              $rootScope.$stateParams = $stateParams;
              return $api.resolve("customer_forms@get", { "id": form_id });
            }
          }
        });
      };

      ctrl.send_form = function (form_id) {
        $api.customer_forms.pdf.save({ id: form_id }, function (response) {
          if (response.status == "success") {
            swal({
              title: $translate.instant('SWAL_CUSTOMER_FORM_SEND_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      };
    });
})();

(function(){
    angular.module('app.controllers').controller('LeadsListController',
      function ($state, $header, $scope, $api, $user, $cfilter, Statuses, Resources, dates, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $rootScope, $translate, $compile, $timeout) {
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        
        ctrl.dtInstance = {};
        ctrl.statuses = Statuses.data;
        ctrl.resources = Resources.data;

        ctrl.customer_name = $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.search : "";
        ctrl.show_deleted = $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.deleted : false;
        ctrl.entriesPerPage = $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.limit : "20";

        $scope.datesProvider = dates;

        $header.title = "NAV_LEADS";
        $header.breadcrumbs.push({
          "title": "NAV_LEADS"
        });

        /**
         * Open customer data
         *
         * @param customerData
         */
        ctrl.open_customer_card = function (customerData) {
          $state.transitionTo("app.leads.single", {
            "id": customerData.id
          }, {
            reload: false
          });
        };

        ctrl.download_in_progress = false;
        /**
         * Download customer data
         *
         */
        ctrl.downloadCustomerData = function () {
          var opts = $rootScope.lead_page_data_options || {};

          var colIndex = opts.order;
          var orderDir = opts.order_dir ? opts.order_dir : '';
          var orderCol = '';

          if (colIndex != null && orderDir != '' && ctrl.dtColumns[colIndex]) {
            orderCol = ctrl.dtColumns[colIndex].name;
          }

          var filter = $rootScope.leads_filter || {};

          ctrl.download_in_progress = true;
          $api.customers.download.download(
            {order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted * 1, leads: true, filter: filter}
            , function success(response) {
              ctrl.download_in_progress = false;

              var blob = new Blob([response.data], { type: 'text/csv;charset=UTF-8' });

              var cd = response.headers('Content-Disposition') ||
                       response.headers('content-disposition') ||
                       '';

              var match = /filename="?([^"]+)"?/.exec(cd);
              var filename = match && match[1] ? match[1] : 'leads.csv';

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }, function error(err) {
              ctrl.download_in_progress = false;
              console.error('Download failed', err);
            }
          );
        };

        /**
         * search customer
         */
        $scope.find_customer = function() {
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Initiate DataTable Options
         */
        ctrl.initDtOptions = function(){
          var initialOrder = [];
          if ($rootScope.lead_page_data_options && $rootScope.lead_page_data_options.order_dir) {
            var columnIndex = $rootScope.lead_page_data_options.order; 
            var orderDirection = $rootScope.lead_page_data_options.order_dir;
            initialOrder = [[columnIndex, orderDirection]];
          }
          
          $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', ctrl.entriesPerPage)
              .withOption('order', initialOrder)
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('displayStart', $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.offset : 0)
              .withOption('ajax', ctrl.loadCustomers)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('rowCallback', ctrl.customerRawCallback)
              .withOption('initComplete', function() {
                $("#custom-pagination-container").find("#cust_dt_info").remove();
                $("#custom-pagination-container").find("#cust_dt_paginate").remove();
                $("#cust_dt_info").prependTo("#custom-pagination-container");
                $("#cust_dt_paginate").prependTo("#custom-pagination-container");
              })
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.change_deleted = function () {
          ctrl.initDtOptions();
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Load customers
         *
         * @param data
         * @param callback
         * @param settings
         */
        ctrl.loadCustomers = function (data, callback, settings) {
          var orderCol = '';
          var orderDir = '';
          var colIndex = 0;

          if(data.order.length) {
            // Use only last order parameters
            colIndex = data.order[data.order.length - 1].column
            orderCol = data.columns[colIndex]['name'];
            orderDir = data.order[data.order.length - 1].dir;
          }

          //remember current position
          $rootScope.lead_page_data_options = {
            limit: data.length,
            offset: data.start,
            order: colIndex,
            order_dir: orderDir,
            search: ctrl.customer_name,
            deleted: ctrl.show_deleted*1
          };
          var filter = $rootScope.leads_filter || {};

          callback({recordsTotal:0, recordsFiltered: 0, data: [], draw: data.draw+1});
          $scope.module_is_loading = true;
          $api.customers.list.get(
            {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted*1, leads: true, filter: filter}
            , function (result) {
              $scope.module_is_loading = false;
            if (result && result.data) {

              callback({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: result.data,
                draw: data.draw + 1
              });
            }

          });
        };

        ctrl.moveToCustomers = function(id) {
          $api.customers.movelead.get({id: id}, function(response) {
            if(response.status == "success") {
              $state.transitionTo("app.leads", {}, {reload: true});
            }
          });
        };

        /**
         * Bind events to a new row
         *
         * @param nRow
         * @param aData
         * @param iDisplayIndex
         * @param iDisplayIndexFull
         * @returns {*}
         */
        ctrl.customerRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $(nRow).unbind('click').bind('click', function (event) {
            // Prevent click event from firing when clicking on select dropdown
            if ($(event.target).closest('select, .prevent-click').length) {
                event.stopPropagation(); // Stop the event from bubbling up to the row click handler
            } else {
                $scope.$apply(function() {
                    ctrl.open_customer_card(aData);
                });
            }
          });
          return nRow;
        }

        if (window.innerWidth < 768) {
          $.fn.DataTable.ext.pager.numbers_length = 3;
        }

        ctrl.initDtOptions();
        $scope.customerStatuses = {};
        $scope.customerResources = {};

        /**
         * Customer table column definitions
         * @type {*[]}
         */
        ctrl.configureColumns = function() {
          ctrl.dtColumns = [
            { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125 w-100',
              render: function(data, type, full, meta) {
                var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
                var repeat = data.repeat_at ? '<span class="repeat-at"><i class="las la-sync"></i></span>' : '';
                var html = '<div class="customer-pic-outer"><div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>'+repeat+'</div>';
                html+= '<b>';
                html+= data.firstname ? ' ' + data.firstname : '';
                html+= data.lastname ? ' ' + data.lastname : '';
                html+= '</b>';
                return '<div class="flex nowrap">'+html+'</div>';
              }
            },
            { name: 'phone', data: null, title: $translate('CUSTOMERS_PHONE'), class: 'customer-phone',
              render: function(data, type, full, meta) {
                return "<span class='nowrap'>"+(data.phone ? data.phone : '')+"</span>";
              }
            },
            { name: 'date', data: null, title: $translate('CUSTOMERS_DATE'), class: 'customer-date',
              render: function(data, type, full, meta) {
                return "<span class='nowrap'>"+data.date+"</span>";
              }
            },
            { name: 'resource_lead_name', data: null, title: $translate('CUSTOMERS_RESOURSE'), class: 'customer-resources',
              render: function(data, type, full, meta) {
                //return data.resource_lead_name ? data.resource_lead_name : '';
                $scope.customerResources[data.id] = String(data.resource_id || '');
                return '<div class="form-group form-select prevent-click">'
                  +'<select class="form-control" ng-model="customerResources[' + data.id + ']" ng-change="ctrl.updateData(' + data.id + ', {resource_lead: customerResources[' + data.id + ']})">'
                      +'<option value="">{{"CUSTOMERS_RESOURSE" | translate}}</option>'
                      +'<option ng-repeat="resource in ctrl.resources" ng-if="resource.sales_active" value="{{resource.id}}">{{resource.name}}</option>'
                  +'</select></div>';
              }
            },
            { name: 'statuses_name', data: null, title: $translate('CUSTOMERS_STATUS'), class: 'customer-status',
              render: function(data, type, full, meta) {
                //return data.statuses_name ? '<span class="btn btn-primary btn-xs category-item" style="background-color: '+ctrl.hexToRgbA(data.statuses_color ? data.statuses_color : '#a9cfe8')+'">'+data.statuses_name+'</span>' : '';
                $scope.customerStatuses[data.id] = String(data.status_id || '');
                return '<div class="form-group form-select prevent-click">'
                  +'<select class="form-control" ng-model="customerStatuses[' + data.id + ']" ng-change="ctrl.updateData(' + data.id + ', {status_id: customerStatuses[' + data.id + ']})">'
                      +'<option value="">{{"CUSTOMERS_STATUS" | translate}}</option>'
                      +'<option ng-repeat="status in ctrl.statuses" value="{{status.id}}">{{status.name}}</option>'
                  +'</select></div>';
              }
            },
            { name: 'arrival_source', data: null, title: $translate('CUSTOMER_ARRIVAL_SOURCE'), class: 'customer-arrivalsource hidden-xs',
              render: function(data, type, full, meta) {
                return data.arrival_source;
              }
            },
            {name: 'desktop_icons', data: null, title: '', orderable: false, class: 'desktop-icons-column',
              render: function (data, type, full, meta) {
                var add_details = '<div class="customers_add_details icons desktop">';

                if (data.oncredit > 0) {
                  add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
                }
                if (data.has_cards) {
                  add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
                }
                if ((data.has_color)) {
                  add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
                }

                add_details += '</div>';

                return add_details;
              }
            },
            {name: 'current_year_income', data: null, title: '', class: 'customer-income', sortable: false,
              render: function (data, type, full, meta) {

                var add_details = '';
                add_details += '<div class="customers_call_details icons mobile" style="'+((data.oncredit > 0 || data.has_cards || data.has_color) ? '' : 'margin-top: 0;')+'">';

                if (data.phone) {

                  var phone = data.phone;
                  var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                  for (var s in mas) {
                    phone = phone.replace(mas[s], '')
                  }
                  phone = '+972'+phone;

                  
                  add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                  add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
                  add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation(); ctrl.moveToCustomers('+data.id+')" ><i class="las la-users"></i></a>';
                }

                add_details += '</div>';
                return add_details;
                //return '<span class="customers_list_year_income">' + (data.current_year_income ? parseFloat(data.current_year_income).toLocaleString('en') : '') + '</span>'+add_details;
              }
            },
            {name: 'icons', sortable: false, data: null, title: '', class: 'customer-icons',
              render: function (data, type, full, meta) {
                var add_details = '';
                add_details += '<div class="customers_call_details icons desktop">';

                if (data.phone) {

                  var phone = data.phone;
                  var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                  for (var s in mas) {
                    phone = phone.replace(mas[s], '')
                  }
                  phone = '+972'+phone;

                  add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                  add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
                }

                add_details += '</div>';

                return add_details;
              }
            },
          ];

          if ($rootScope.lead_appearence === 0) {
            ctrl.dtColumns.push({
              name: 'customer', data: null, title: '', class: 'lead-to-customer', orderable: false,
              render: function(data, type, full, meta) {
                return '<button class="btn text primary" ng-click="d(); $event.stopPropagation(); ctrl.moveToCustomers('+data.id+')">'+$translate.instant('CUSTOMERS_MAKE_CUSTOMER')+'</button>';
              }
            });
          }
        };

        ctrl.configureColumns();

        $scope.$watch(function() {
            return $rootScope.lead_appearence;
        }, function(newValue, oldValue) {
            if (newValue !== oldValue && (newValue === 0 || newValue === 1)) {
              //? fix when refresh on leads page
              $scope.find_customer();

              // ctrl.initDtOptions();
              //   ctrl.configureColumns();
                
              //   $timeout(function() {
              //     if ($('#cust_dt').DataTable()) {
              //         $('#cust_dt').DataTable().destroy();
              //         $('#cust_dt').DataTable(ctrl.dtInstance);
              //     }
              //   }, 0);
            }
        });

        ctrl.updateData = function(customerId, newValue) {
          newValue.id = customerId;
          $api.customers.update.save(newValue, function(response) {
            if(response.status == "success") {
              if ($rootScope.lead_appearence === 1) {
                $state.transitionTo("app.leads", {}, {reload: true});
                $user.getLeadsCount();
              }
            }
          });
        }

        ctrl.hexToRgbA = function(hex){
          var c;
          if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
              c= hex.substring(1).split('');
              if(c.length== 3){
                  c= [c[0], c[0], c[1], c[1], c[2], c[2]];
              }
              c= '0x'+c.join('');
              return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
          }
          return 'rgba(169,207,232,0.1)';
        }


        /**
         * Filter
        */
        $cfilter.apply('leads', true);
        $scope.submit_filter = function() {
          $scope.find_customer();
        }

      });
})();

(function () {

    angular.module('app.controllers').controller('CustomersDigitalFormsPrintController',
        function(DigitalForm, $scope, $state, $rootScope, $timeout, $uibModal, $tiff_page) {
  
            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            var ctrl = this;

            ctrl.business_logo = $rootScope.$user ? $rootScope.$user.logo : null;
            ctrl.business_name = $rootScope.$user ? $rootScope.$user.dealer_name : null;
            $scope.business = DigitalForm.data.business;

            ctrl.init_signatures = function() {
                $timeout( function() {
                    if ($scope.DigitalForm.data) {
                        for (var i in $scope.DigitalForm.data) {
                            if ($scope.DigitalForm.data[i].type == 'signature') {
                                var el = document.getElementById('can'+i);
                                if (el) {
                                    canvas[i] = new PortrayCanvas(el, {
                                        lineWidth: 2,
                                        period: 5,
                                        //disabled: !!$scope.DigitalForm.fill_date,
                                        lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                                    });

                                    //put canvas like image
                                    var img = document.createElement('img');
                                    img.src = canvas[i].canvas.toDataURL();
                                    img.width = el.width;
                                    img.height = el.height;
                                    el.parentNode.replaceChild(img, el);


                                }
                            }
                        }
                    }
                }, 500);
            }

            ctrl.openForm = function(form){
                $scope.DigitalForm = form;
                $scope.DigitalForm.data = form.data ? (typeof form.data === 'string' ? JSON.parse(form.data) : form.data) : [];
                $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';
    
                if ($scope.DigitalForm.data) {
                    for (var i in $scope.DigitalForm.data) {
                        if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                            $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                        }
                    }
                }

                ctrl.init_signatures();
            }

            $scope.DigitalForm = {};
            if (DigitalForm.data && DigitalForm.data.id) {
                
                $tiff_page.start_loading('printing');
                ctrl.openForm(DigitalForm.data);


                $timeout(function() {
                    if (!$scope.printTriggered) {
                        $scope.printTriggered = true;
                        window.print();
                        $scope.$close();
                        $tiff_page.stop_loading('printing');
                    }
                }, 500);
                
            }

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            var canvas = {};
        });
})();
(function () {
  angular.module('app.controllers').controller('CustomersDigitalFormsAddController', function ($scope, $state, $api, Customer, DigitalForms, DigitalForm, Order, OrderForm, $rootScope, $translate, $timeout) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;

    ctrl.form = {
      customer_id: '',
      form_id: '',
      order_id: null,
    };

    if (Customer && Customer.data) {
      ctrl.customer_page = true;
      ctrl.form.customer_id = Customer.data.id;
    }

    if (Order && Order.id) {
      ctrl.form.order_id = Order.id;
    }

    $scope.forms = DigitalForms.data;
    $scope.DigitalForm = DigitalForm ? DigitalForm : null;

    ctrl.customer_modal = false;
    ctrl.customer_search_name = "";
    ctrl.customer_selected_name = "";
    ctrl.searchCustomerResult = [];
    ctrl.orderForm = OrderForm;

    $scope.isMobile = (angular.element(document).width() < 769);

    ctrl.find_customer = function () {
      $api.customers.find.get({ str: ctrl.customer_search_name, limit: 20 }, function (response) {
        if (response.str == ctrl.customer_search_name) {
          ctrl.searchCustomerResult = response.data;
        }
      });
    }

    ctrl.chooseCustomer = function (index, $event) {
      ctrl.customerData = ctrl.searchCustomerResult[index];
      ctrl.form.customer_id = ctrl.customerData.id;
      ctrl.customer_selected_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
      ctrl.customer_search_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
      ctrl.searchCustomerResult = [];
      $event.stopPropagation();
    }

    ctrl.cleanCustomerSearch = function () {
      ctrl.customer_search_name = ctrl.customer_selected_name;
      $timeout(function () {
        ctrl.searchCustomerResult = [];
      }, 200);
    }

    ctrl.backForm = function () {
      ctrl.form = {
        customer_id: '',
        form_id: '',
        order_id: null,
      };
      $scope.DigitalForm = null;
    };

    ctrl.chooseForm = function () {
      $api.digital_forms.preview.get({ id: ctrl.form.form_id }, function (response) {
        if (response.status === "success") {
          $scope.DigitalForm = response.data;
          $scope.DigitalForm.data = response.data && response.data.data ? JSON.parse(response.data.data) : [];
          $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';

          if ($scope.DigitalForm.data) {
            for (var i in $scope.DigitalForm.data) {
              if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
              }
            }
          }

          ctrl.init_signatures();
          $scope.initMapCanvases();
        }
      });
    };

    ctrl.textValueWithBR = function (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    };

    var canvas = {};
    ctrl.init_signatures = function () {
      setTimeout(function () {
        if ($scope.DigitalForm && $scope.DigitalForm.data) {
          for (var i in $scope.DigitalForm.data) {
            if ($scope.DigitalForm.data[i].type == 'signature') {
              var el = document.getElementById('can' + i);
              if (el) {
                canvas[i] = new PortrayCanvas(el, {
                  lineWidth: 2,
                  period: 5,
                  disabled: $scope.DigitalForm.cf_locked,
                  lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                });
              }
            }
          }
        }
      }, 500);
    };

    ctrl.save = function () {
      if ($scope.DigitalForm && $scope.DigitalForm.id) {
        $scope.DigitalForm.data.forEach(function (f, i) {
          if (f.type === 'signature' && canvas[i]) {
            f.value = canvas[i].getLines();
          }

          if (f.type === 'map' && f._canvas && f._drawTexts) {
            f._drawTexts();
            f.value = f._canvas.toDataURL();
          }
        });

        if ((OrderForm && ctrl.form.order_id) || !OrderForm) {
          if ($scope.DigitalForm.locked) {
            swal({
              title: $translate.instant('DIGITAL_FORM_LOCKED'),
              text: $translate.instant('DIGITAL_FORM_LOCKED_TEXT'),
              type: "warning",
              showCancelButton: true,
              confirmButtonText: $translate.instant('OPTION_YES'),
              cancelButtonText: $translate.instant('OPTION_NO'),
            }).then(function (res) {
              if (res.value) {
                ctrl.send_form();
              }
            });
          } else {
            ctrl.send_form();
          }
        } else {
          $scope.$close({id: $scope.DigitalForm.id, data: $scope.DigitalForm.data, order_id: ctrl.form.order_id, customer_id: ctrl.form.customer_id, b_id: $rootScope.$user.b_id});
        }
      }
    };

    ctrl.close = function() {
      if ((OrderForm && ctrl.form.order_id) || !OrderForm) {
        $scope.$close();
      } else {
        $scope.$close({id: $scope.DigitalForm.id, data: $scope.DigitalForm.data, order_id: ctrl.form.order_id, customer_id: ctrl.form.customer_id, b_id: $rootScope.$user.b_id});
      }
    }

    ctrl.send_to_customer = function() {
      $api.digital_forms.send.save({
          id: ctrl.form.form_id*1,
          customer_id: ctrl.form.customer_id*1,
          order_id: ctrl.form.order_id*1
      }, function(response){
          if(response.status == "success") {
              swal({
                  title: $translate.instant('SWAL_DF_TITLE'),
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
              });

              $scope.$close();
          }
      });
    };

    ctrl.send_form = function () {
      var cleanedData = [];

      for (var i = 0; i < $scope.DigitalForm.data.length; i++) {
        var f = $scope.DigitalForm.data[i];

        // Create a shallow clone
        var clean = {};
        for (var key in f) {
          if (
            key !== '_canvas' &&
            key !== '_ctx' &&
            key !== '_drawTexts' &&
            key !== '_activeText' &&
            key !== 'tool' &&
            key !== 'color' &&
            key !== 'size' &&
            key !== 'textInput'
          ) {
            clean[key] = f[key];
          }
        }

        cleanedData.push(clean);
      }

      $api.customer_forms.new.save({
        id: $scope.DigitalForm.id,
        data: {
          data: cleanedData,
          customer_id: ctrl.form.customer_id,
          order_id: ctrl.form.order_id,
          b_id: $rootScope.$user.b_id,
        },
      }, function (response) {
        if (response.status === "success") {
          swal({
            title: $translate.instant('DIGITAL_FORM_FILLED'),
            text: "",
            type: "success",
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            timer: 2000,
          });

          $scope.$close(response);
        }
      });
    };


    $scope.initMapCanvases = function () {
      // init defaults
      if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

      $scope.DigitalForm.data.forEach(function (field) {
        if (field.type === 'map') {
          field.tool = 'pen';
          field.color = '#000000';
          field.size = 5;
          field.textInput = '';
          field.texts = [];
          field._activeText = null;
        }
      });

      setTimeout(function () {
        if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

        $scope.DigitalForm.data.forEach(function (field, index) {
          if (field.type !== 'map' || !field.map) return;

          var canvasEl = document.getElementById('mapCanvas' + index);
          if (!canvasEl) return;

          var ctx = canvasEl.getContext('2d');
          var rect = canvasEl.getBoundingClientRect();
          canvasEl.width = rect.width;
          canvasEl.height = rect.width * 0.7;

          var img = new Image();
          img.src = field.map;
          img.onload = function () {
            // Set canvas width based on container
            var parentWidth = canvasEl.parentElement.offsetWidth;
            var aspectRatio = img.height / img.width;

            canvasEl.width = parentWidth;
            canvasEl.height = parentWidth * aspectRatio;
            canvasEl.parentNode.style.height = (parentWidth * aspectRatio) + 'px';
          };

          if (field.value) {
            var img = new Image();
            img.src = field.value;
            img.onload = function () {
                ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);
            };
          }

          field._ctx = ctx;
          field._canvas = canvasEl;

          var inputDiv = document.createElement('div');
          inputDiv.contentEditable = true;
          inputDiv.className = 'canvas-text-input';
          inputDiv.style.position = 'absolute';
          inputDiv.style.display = 'none';
          inputDiv.style.outline = 'none';
          inputDiv.style.zIndex = 1000;
          inputDiv.style.whiteSpace = 'nowrap';
          canvasEl.parentElement.appendChild(inputDiv);

          var pos = { x: 0, y: 0 };
          var drawing = false;

          function setPosition(e) {
            var bounds = canvasEl.getBoundingClientRect();
            pos.x = (e.clientX || e.touches[0].clientX) - bounds.left;
            pos.y = (e.clientY || e.touches[0].clientY) - bounds.top;
          }

          function draw(e) {
            if (!drawing) return;

            ctx.lineWidth = field.size;
            ctx.strokeStyle = field.color;
            ctx.fillStyle = field.color;
            ctx.lineCap = 'round';

            if (field.tool === 'pen') {
              ctx.beginPath();
              ctx.moveTo(pos.x, pos.y);
              setPosition(e);
              ctx.lineTo(pos.x, pos.y);
              ctx.stroke();
            } else if (field.tool === 'spray') {
              setPosition(e);
              for (var i = 0; i < 20; i++) {
                var angle = Math.random() * 2 * Math.PI;
                var radius = Math.random() * field.size * 2;
                var x = pos.x + Math.cos(angle) * radius;
                var y = pos.y + Math.sin(angle) * radius;
                ctx.fillRect(x, y, 1, 1);
              }
            }
          }

          canvasEl.addEventListener('mousedown', function (e) {
            if (field.tool === 'pen' || field.tool === 'spray') {
              drawing = true;
              setPosition(e);
              draw(e);
            }
          });

          canvasEl.addEventListener('mouseup', function () {
            drawing = false;
          });

          canvasEl.addEventListener('mousemove', draw);

          canvasEl.addEventListener('click', function (e) {
            var bounds = canvasEl.getBoundingClientRect();
            var x = e.clientX - bounds.left;
            var y = e.clientY - bounds.top;

            if (field.tool === 'text') {
              // First: save current input if visible and has content
              if (inputDiv.style.display === 'block' && inputDiv.innerText.trim()) {
                var val = inputDiv.innerText.trim();
                var canvasX = parseFloat(inputDiv.style.left);
                var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                if (field._activeText) {
                  field._activeText.value = val;
                  field._activeText.x = canvasX;
                  field._activeText.y = canvasY;
                } else {
                  field.texts.push({
                    value: val,
                    x: canvasX,
                    y: canvasY,
                    color: field.color,
                    size: field.size
                  });
                }

                inputDiv.style.display = 'none';
                inputDiv.innerText = '';
                field._activeText = null;
                drawTexts();
              }

              // Then: check if user clicked on existing text
              var clicked = false;
              field.texts.forEach(function (t) {
                var w = ctx.measureText(t.value).width;
                var h = t.size * 3;
                if (x >= t.x && x <= t.x + w && y >= t.y - h && y <= t.y) {
                  inputDiv.innerText = t.value;
                  inputDiv.style.left = t.x + 'px';
                  inputDiv.style.top = (t.y - h) + 'px';
                  inputDiv.style.display = 'block';
                  inputDiv.style.color = t.color;
                  inputDiv.style.font = "500 " + (t.size * 3) + "px Arial";
                  inputDiv.focus();
                  field._activeText = t;
                  clicked = true;
                }
              });

              if (!clicked) {
                inputDiv.innerText = '';
                inputDiv.style.left = x + 'px';
                inputDiv.style.top = y + 'px';
                inputDiv.style.color = field.color;
                inputDiv.style.font = "500 " + (field.size * 3) + "px Arial";
                inputDiv.dataset.x = x;
                inputDiv.dataset.y = y;
                inputDiv.style.display = 'block';
                field._activeText = null;
                inputDiv.focus();
              }
            } else {
              inputDiv.style.display = 'none';
              field._activeText = null;
            }
          });

          document.addEventListener('click', function (e) {
            if (!inputDiv.contains(e.target) && e.target !== canvasEl) {
              if (inputDiv.style.display === 'block') {
                var val = inputDiv.innerText.trim();
                if (val) {
                    var canvasX = parseFloat(inputDiv.style.left);
                    var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                    if (field._activeText) {
                        field._activeText.value = val;
                        field._activeText.x = canvasX;
                        field._activeText.y = canvasY;
                    } else {
                        field.texts.push({
                        value: val,
                        x: canvasX,
                        y: canvasY,
                        color: field.color,
                        size: field.size
                        });
                    }

                    drawTexts();
                }
                inputDiv.style.display = 'none';
                inputDiv.innerText = '';
              }
            }
          });

          function drawTexts() {
            field.texts.forEach(function (t) {
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = t.color;
              ctx.font = "300 " + (t.size * 3) + "px Arial";

              var lines = t.value.split('\n');
              var lineHeight = t.size * 3 * 1.2;

              for (var i = 0; i < lines.length; i++) {
                ctx.fillText(lines[i], t.x, t.y + i * lineHeight);
              }
            });
          }

          field._drawTexts = drawTexts;
        });
      }, 500);
    };

    $scope.clearCanvas = function(field) {
      if (!field._ctx || !field._canvas) return;

      // Clear canvas
      field._ctx.clearRect(0, 0, field._canvas.width, field._canvas.height);

      // Clear stored texts
      field.texts = [];

      // Hide any visible text editor
      var inputDivs = field._canvas.parentElement.querySelectorAll('.canvas-text-input');
      angular.forEach(inputDivs, function(div) {
        div.style.display = 'none';
      });
    };

    // Color click logic for UI
    $scope.openColorPicker = function ($event, field) {
      var input = $event.currentTarget.nextElementSibling;
      if (input && input.type === 'color') input.click();
    };

    if (DigitalForm) {
      ctrl.init_signatures();
      $scope.initMapCanvases();
    }

    
  });
})();
(function () {

    angular.module('app.controllers').controller('CustomersDigitalFormsController',
        function(Customer, DigitalForm, DigitalForms, Order, Business, $scope, $state, $api, $rootScope, $translate, $uibModal) {
  
            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            var ctrl = this;

            ctrl.business_logo = $rootScope.$user ? $rootScope.$user.logo : null;
            ctrl.business_name = $rootScope.$user ? $rootScope.$user.dealer_name : null;
            $scope.business = Business.data;
            $scope.business.online_booking_data = $scope.business.online_booking_data ? JSON.parse($scope.business.online_booking_data) : {};
            $scope.DigitalFormList = DigitalForms ? DigitalForms : [];

            ctrl.init_signatures = function() {
                setTimeout( function() {
                    if ($scope.DigitalForm.data) {
                        for (var i in $scope.DigitalForm.data) {
                            if ($scope.DigitalForm.data[i].type == 'signature') {
                                var el = document.getElementById('can'+i);
                                if (el) {
                                    canvas[i] = new PortrayCanvas(el, {
                                        lineWidth: 2,
                                        period: 5,
                                        //disabled: !!$scope.DigitalForm.fill_date,
                                        disabled: $scope.DigitalForm.cf_locked,
                                        lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                                    });
                                }
                            }
                        }
                    }
                }, 500);
            }


            $scope.initMapCanvases = function () {
                // init defaults
                if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

                $scope.DigitalForm.data.forEach(function (field) {
                    if (field.type === 'map') {
                    field.tool = 'pen';
                    field.color = '#000000';
                    field.size = 5;
                    field.textInput = '';
                    field.texts = [];
                    field._activeText = null;
                    }
                });
                
                setTimeout(function () {
                    if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

                    $scope.DigitalForm.data.forEach(function (field, index) {
                    if (field.type !== 'map' || !field.map) return;

                    var canvasEl = document.getElementById('mapCanvas' + index);
                    if (!canvasEl) return;

                    var ctx = canvasEl.getContext('2d');
                    var rect = canvasEl.getBoundingClientRect();
                    canvasEl.width = rect.width;
                    canvasEl.height = rect.width * 0.7;

                    var img = new Image();
                    img.src = field.map;
                    img.onload = function () {
                        // Set canvas width based on container
                        var parentWidth = canvasEl.parentElement.offsetWidth;
                        var aspectRatio = img.height / img.width;

                        canvasEl.width = parentWidth;
                        canvasEl.height = parentWidth * aspectRatio;
                        canvasEl.parentNode.style.height = (parentWidth * aspectRatio) + 'px';
                    };

                    if (field.value) {
                        var img = new Image();
                        img.src = field.value;
                        img.onload = function () {
                            ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);
                        };
                    }

                    field._ctx = ctx;
                    field._canvas = canvasEl;

                    var inputDiv = document.createElement('div');
                    inputDiv.contentEditable = true;
                    inputDiv.className = 'canvas-text-input';
                    inputDiv.style.position = 'absolute';
                    inputDiv.style.display = 'none';
                    inputDiv.style.outline = 'none';
                    inputDiv.style.zIndex = 1000;
                    inputDiv.style.whiteSpace = 'nowrap';
                    canvasEl.parentElement.appendChild(inputDiv);

                    var pos = { x: 0, y: 0 };
                    var drawing = false;

                    function setPosition(e) {
                        var bounds = canvasEl.getBoundingClientRect();
                        pos.x = (e.clientX || e.touches[0].clientX) - bounds.left;
                        pos.y = (e.clientY || e.touches[0].clientY) - bounds.top;
                    }

                    function draw(e) {
                        if (!drawing) return;

                        ctx.lineWidth = field.size;
                        ctx.strokeStyle = field.color;
                        ctx.fillStyle = field.color;
                        ctx.lineCap = 'round';

                        if (field.tool === 'pen') {
                        ctx.beginPath();
                        ctx.moveTo(pos.x, pos.y);
                        setPosition(e);
                        ctx.lineTo(pos.x, pos.y);
                        ctx.stroke();
                        } else if (field.tool === 'spray') {
                        setPosition(e);
                        for (var i = 0; i < 20; i++) {
                            var angle = Math.random() * 2 * Math.PI;
                            var radius = Math.random() * field.size * 2;
                            var x = pos.x + Math.cos(angle) * radius;
                            var y = pos.y + Math.sin(angle) * radius;
                            ctx.fillRect(x, y, 1, 1);
                        }
                        }
                    }

                    canvasEl.addEventListener('mousedown', function (e) {
                        if (field.tool === 'pen' || field.tool === 'spray') {
                        drawing = true;
                        setPosition(e);
                        draw(e);
                        }
                    });

                    canvasEl.addEventListener('mouseup', function () {
                        drawing = false;
                    });

                    canvasEl.addEventListener('mousemove', draw);

                    canvasEl.addEventListener('click', function (e) {
                        var bounds = canvasEl.getBoundingClientRect();
                        var x = e.clientX - bounds.left;
                        var y = e.clientY - bounds.top;

                        if (field.tool === 'text') {
                        // First: save current input if visible and has content
                        if (inputDiv.style.display === 'block' && inputDiv.innerText.trim()) {
                            var val = inputDiv.innerText.trim();
                            var canvasX = parseFloat(inputDiv.style.left);
                            var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                            if (field._activeText) {
                            field._activeText.value = val;
                            field._activeText.x = canvasX;
                            field._activeText.y = canvasY;
                            } else {
                            field.texts.push({
                                value: val,
                                x: canvasX,
                                y: canvasY,
                                color: field.color,
                                size: field.size
                            });
                            }

                            inputDiv.style.display = 'none';
                            inputDiv.innerText = '';
                            field._activeText = null;
                            drawTexts();
                        }

                        // Then: check if user clicked on existing text
                        var clicked = false;
                        field.texts.forEach(function (t) {
                            var w = ctx.measureText(t.value).width;
                            var h = t.size * 3;
                            if (x >= t.x && x <= t.x + w && y >= t.y - h && y <= t.y) {
                            inputDiv.innerText = t.value;
                            inputDiv.style.left = t.x + 'px';
                            inputDiv.style.top = (t.y - h) + 'px';
                            inputDiv.style.display = 'block';
                            inputDiv.style.color = t.color;
                            inputDiv.style.font = "500 " + (t.size * 3) + "px Arial";
                            inputDiv.focus();
                            field._activeText = t;
                            clicked = true;
                            }
                        });

                        if (!clicked) {
                            inputDiv.innerText = '';
                            inputDiv.style.left = x + 'px';
                            inputDiv.style.top = y + 'px';
                            inputDiv.style.color = field.color;
                            inputDiv.style.font = "500 " + (field.size * 3) + "px Arial";
                            inputDiv.dataset.x = x;
                            inputDiv.dataset.y = y;
                            inputDiv.style.display = 'block';
                            field._activeText = null;
                            inputDiv.focus();
                        }
                        } else {
                        inputDiv.style.display = 'none';
                        field._activeText = null;
                        }
                    });

                    document.addEventListener('click', function (e) {
                        if (!inputDiv.contains(e.target) && e.target !== canvasEl) {
                        if (inputDiv.style.display === 'block') {
                            var val = inputDiv.innerText.trim();
                            if (val) {
                                var canvasX = parseFloat(inputDiv.style.left);
                                var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                                if (field._activeText) {
                                    field._activeText.value = val;
                                    field._activeText.x = canvasX;
                                    field._activeText.y = canvasY;
                                } else {
                                    field.texts.push({
                                    value: val,
                                    x: canvasX,
                                    y: canvasY,
                                    color: field.color,
                                    size: field.size
                                    });
                                }

                                drawTexts();
                            }
                            inputDiv.style.display = 'none';
                            inputDiv.innerText = '';
                        }
                        }
                    });

                    function drawTexts() {
                        field.texts.forEach(function (t) {
                        ctx.textBaseline = 'bottom';
                        ctx.fillStyle = t.color;
                        ctx.font = "300 " + (t.size * 3) + "px Arial";

                        var lines = t.value.split('\n');
                        var lineHeight = t.size * 3 * 1.2;

                        for (var i = 0; i < lines.length; i++) {
                            ctx.fillText(lines[i], t.x, t.y + i * lineHeight);
                        }
                        });
                    }

                    field._drawTexts = drawTexts;
                    });
                }, 500);
            };

            $scope.clearCanvas = function(field) {
            if (!field._ctx || !field._canvas) return;

            // Clear canvas
            field._ctx.clearRect(0, 0, field._canvas.width, field._canvas.height);

            // Clear stored texts
            field.texts = [];

            // Hide any visible text editor
            var inputDivs = field._canvas.parentElement.querySelectorAll('.canvas-text-input');
            angular.forEach(inputDivs, function(div) {
                div.style.display = 'none';
            });
            };

            // Color click logic for UI
            $scope.openColorPicker = function ($event, field) {
            var input = $event.currentTarget.nextElementSibling;
            if (input && input.type === 'color') input.click();
            };
            

            ctrl.openForm = function(form){
                $scope.DigitalForm = form;
                $scope.DigitalForm.data = form.data ? (typeof form.data === 'string' ? JSON.parse(form.data) : form.data) : [];
                $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';
    
                if ($scope.DigitalForm.data) {
                    for (var i in $scope.DigitalForm.data) {
                        if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                            $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                        }
                    }
                }

                ctrl.init_signatures();
                $scope.initMapCanvases();
            }

            $scope.DigitalForm = {};
            if (DigitalForm && DigitalForm.data && DigitalForm.data.id) {
                ctrl.openForm(DigitalForm.data);
            }
        
            $scope.isMobile = (angular.element(document).width() < 769);

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            var canvas = {};

            ctrl.init_signatures();
            $scope.initMapCanvases();

            ctrl.save = function(){
                if ($scope.DigitalForm.id) {
                    var cleanedData = [];

                    for (var i = 0; i < $scope.DigitalForm.data.length; i++) {
                        var f = $scope.DigitalForm.data[i];

                        if ((f.type == 'signature') && canvas[i]) {
                            f.value = canvas[i].getLines();
                        }

                        if (f.type === 'map' && f._canvas && f._drawTexts) {
                            f._drawTexts();
                            f.value = f._canvas.toDataURL();
                        }

                        // Create a shallow clone
                        var clean = {};
                        for (var key in f) {
                            if (
                                key !== '_canvas' &&
                                key !== '_ctx' &&
                                key !== '_drawTexts' &&
                                key !== '_activeText' &&
                                key !== 'tool' &&
                                key !== 'color' &&
                                key !== 'size' &&
                                key !== 'textInput'
                            ) {
                                clean[key] = f[key];
                            }
                        }

                        cleanedData.push(clean);
                    }
                    
                    $api.customer_forms.save({
                        id: $scope.DigitalForm.id,
                        data: cleanedData,
                    }, function (response) {
                        if (response.status === "success") {
    
                            swal({
                                title: $translate.instant('DIGITAL_FORM_FILLED'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });

                            $scope.$close($scope.DigitalFormList);
                        }
                    });
                }
            };

            ctrl.newForm = function() {
                $uibModal.open({
                    templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                    controller: "CustomersDigitalFormsAddController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal laser-file-modal",
                    resolve: {
                      Customer: Customer,
                      Order: Order,
                      OrderForm: false,
                      DigitalForm: null,
                      DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                      }]
                    }
                  }).result.then(function (result) {
                    
                    if (result && result.form_data) {
                        $scope.DigitalFormList = result.form_data;
                    }
                });
            }



            
        });
})();
(function() {
    
    angular.module("app.components").factory("$wachat", function($rootScope){
        
        var $wachat = this;
        $wachat.customer = false;
        
        $wachat.apply = function(customer) {
            $wachat.customer = customer;
        };

        return $wachat;
    });
})();
(function() {
  angular.module("app.controllers").controller("CustomersWaChatController", function($rootScope, $wachat, $cookies, $scope, $api, $resource, $translate) {
    $scope.wa_history = false;
    $scope.files = false;
    $scope.wa_message = '';
    $scope.chat_id = false;
    var fileElement = null;
    var wa_status = $cookies.get("wa_status");

    $scope.getHistory = function() {
      if (wa_status != 'authorized') {
        $scope.wa_history = {invokeStatus: { descr: $translate.instant('WA_CHAT_NOT_AUTHORIZED') }};
        return;
      }
      $api.whatsapp.wachat.get({ chat_id: $scope.chat_id, customer_id: $wachat.customer.id }, function(response) {
        if (response && response.data) {
          $scope.wa_history = response.data;
          $scope.scrollWaToBottom();
        }
      });
    };

    if ($wachat.customer && $wachat.customer.id) {
      var phone = $wachat.customer.phone;
      if (phone[0] === '0') {
        phone = '972' + phone.substr(1);
      }

      $scope.chat_id = phone + "@c.us";

      $scope.getHistory();

      if ($wachat.customer.avatar) {
        $scope.wa_avatar = $wachat.customer.avatar;
      }

      $api.whatsapp.avatar.get({}, function(response) {
        if (response && response.data && response.data.urlAvatar) {
          $scope.wa_avatar_my = response.data.urlAvatar;
        }
      });

      $api.whatsapp.avatar.get({ chat_id: $scope.chat_id }, function(response) {
        if (response && response.data && response.data.urlAvatar) {
          $scope.wa_avatar = response.data.urlAvatar;
        }
      });
    }

    $scope.subscribeToWaChat = function() {
      if (wa_status != 'authorized') {
        $scope.wa_history = {invokeStatus: { descr: $translate.instant('WA_CHAT_NOT_AUTHORIZED') }};
        return;
      }
      
      if (!pusher.channel('wa-' + $scope.chat_id)) {
        // If not subscribed, subscribe to the channel
        var channel = pusher.subscribe('wa-' + $scope.chat_id);

        channel.bind('message', function(data) {
          $scope.getHistory();
        });
      }
    };

    $scope.subscribeToWaChat();

    $scope.$on('$destroy', function() {
      // Unsubscribe from the channel when the controller is destroyed
      pusher.unsubscribe('wa-' + $scope.chat_id);
    });

    $scope.sendWaMessage = function() {
      if ($scope.wa_message || ($scope.files && $scope.files.length)) {
        var fdata = new FormData();
        if (fileElement) {
          for (var i = 0; i < fileElement.files.length; i++) {
            fdata.append("files", fileElement.files[i]);
          }
        }
        fdata.append("message", $scope.wa_message);
        fdata.append("chat_id", $scope.chat_id);

        $resource($api.baseURL + '/whatsapp/action/message', {}, {
          postWithFile: {
            method: "POST",
            params: fdata,
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
          }
        }).postWithFile(fdata).$promise.then(function(response) {
          $scope.wa_message = '';
          $scope.files = false;
        }, function(error) {
          console.log(error);
        });
      }
    };

    $scope.scrollWaToBottom = function() {
      $scope.$applyAsync(function() {
        var container = document.getElementById('wa-chat-container');
        if (container) {
          container.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });

          var page_wrap = document.getElementById('wrapper');
          if (page_wrap) {
            page_wrap.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
          }
        }
      });
    };

    $scope.formattedText = function(text) {
      // Replace "\n" with "<br>" for line breaks
      return text.replace(/\n/g, '<br />');
    };

    $scope.getReadableTime = function(timestamp) {
      var now = moment();
      var momentTimestamp = moment.unix(timestamp);

      var formattedTime;

      if (now.isSame(momentTimestamp, 'day')) {
        // If the timestamp is today, display in 'HH:mm' format
        formattedTime = momentTimestamp.format('HH:mm');
      } else {
        // If the timestamp is not today, display in 'DD-MM-YYYY HH:mm' format
        formattedTime = momentTimestamp.format('DD-MM-YYYY HH:mm');
      }
      return formattedTime;
    };

    $scope.audio = false;
    $scope.audioEndedHandler = null;
    $scope.currentAudioId = null;

    $scope.playWaRecord = function(item) {
      if ($scope.audio) {
        $scope.audio.pause();
        $scope.audio.removeEventListener('ended', $scope.audioEndedHandler);
      }

      if (item.downloadUrl && $scope.currentAudioId != item.idMessage) {
        $scope.audio = new Audio(item.downloadUrl);
        $scope.audio.play();
        $scope.currentAudioId = item.idMessage;

        $scope.audioEndedHandler = function() {
          $scope.currentAudioId = null;
        };
        $scope.audio.addEventListener('ended', $scope.audioEndedHandler);

      } else {
        $scope.currentAudioId = null;
      }
    };

    $scope.uploadFile = function(element) {
      $scope.files = element.files;
      fileElement = element;
      $scope.$apply();
    };

    $scope.clearFiles = function() {
      $scope.files = false;
      fileElement.value = '';
    };

  });
})();
(function() {

    angular.module("app.controllers").controller("CustomersSMSController", function($scope, $resource, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {
            message: "",
            files: []
        };

        var fileElement = null

        /**
         * Triggers when SMS form is submited
         */
        ctrl.submit = function() {

            var fdata = new FormData();
            if (fileElement) {
                fdata.append("file", fileElement.files[0]);
            }
            fdata.append("message", ctrl.form.message);
            fdata.append("phone", Customer.data.phone);
            fdata.append("customer_id", Customer.data.id);

            $resource($api.baseURL + '/sms', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_CUSTOMER_SMS_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            }, function(error){
                console.log(error);
            });

            return;
            $api.sms.save({
                message: ctrl.form.message,
                files: ctrl.form.files,
                phone: Customer.data.phone,
                customer_id: Customer.data.id
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_CUSTOMER_SMS_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

        $scope.uploadFile = function(element){
            ctrl.form.files = element.files;
            fileElement = element;
            $scope.$apply();
        };

    });

})();

(function () {
    angular.module('app.controllers')

        .controller('CustomersSingleController', function (Customer, Info, LaserInfo, CustomFields, $api, $state, $location, $scope, $translate, $wachat, $tiff_page, $customFields, $header, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal, $rootScope, $window, $resource, $business, $webview) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            // b_type=2 -> motel
            // b_type=1 -> store
            $scope.b_type = $rootScope.$user.b_type;
            $scope.documents = $rootScope.$user.documents;
            $scope.forms = $rootScope.$user.forms;

            var ctrl = this;

            ctrl.isWebView = $webview.isWebView
            ctrl.isPdfUrl = $webview.isPdfUrl
            ctrl.isImageUrl = $webview.isImageUrl;
            ctrl.laser_categories = $business.laser_categories;
            ctrl.laser_category = 1;
            ctrl.tabLoading = false;
            ctrl.hide_prices = ($rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices'));
            ctrl.personal_only = ($rootScope.userRole == 3 && $rootScope.employee_permissions && $rootScope.employee_permissions.customers && $rootScope.employee_permissions.customers.personal);
            if (ctrl.personal_only) {
              if (Customer.data && (Customer.data.resource_lead == $rootScope.$user.resource_id || Customer.data.resource == $rootScope.$user.resource_id || (Customer.data.worked_resources && Customer.data.worked_resources.indexOf($rootScope.$user.resource_id) > -1))) {
                ctrl.personal_only = false;
              }
            }

            $scope.isMobile = (angular.element(document).width() < 769);

            ctrl.orderStatus = [
                {title: 'CUSTOMERS_ORDERS_FILTER_ALL', value: 'all'},
                {title: 'CUSTOMERS_ORDERS_FILTER_OPENED', value: 'opened'},
                {title: 'CUSTOMERS_ORDERS_FILTER_PAID', value: 'paid'},
                {title: 'CUSTOMERS_ORDERS_FILTER_DECLINED', value: 'declined'},
                {title: 'CUSTOMERS_ORDERS_FILTER_CANCELED', value: 'canceled'},
            ];

            $scope.selectizeConfig = {
                create: true,
                sortField: 'text'
            };

            ctrl.business = Info.data;

            ctrl.menuList = [
              { name: 'history' },
              { name: 'wachat' },
              { name: 'notes' },
              { name: 'medical_notes' },
              { name: 'cards' },
              { name: 'color' },
              { name: 'transaction' },
              { name: 'documents' },
              { name: 'forms' },
              { name: 'laser' },
              { name: 'files' },
              { name: 'smses' },
            ];

            ctrl.menuTitles = {
              'history': $translate.instant("CUSTOMERS_ORDER_HIST"),
              'wachat': $translate.instant("CUSTOMERS_WA_CHAT"),
              'notes': $translate.instant("CUSTOMERS_NOTE"),
              'medical_notes': $translate.instant("CUSTOMERS_MEDICAL_NOTE"),
              'cards': $translate.instant("CUSTOMERS_CARDS_INFO_TAB"),
              'color': $translate.instant("CUSTOMERS_COLOR"),
              'transaction': $translate.instant("CUSTOMERS_TRANSACTIONS"),
              'documents': $translate.instant("CUSTOMERS_DOCUMENTS"),
              'forms': $translate.instant("CUSTOMERS_FORMS"),
              'laser': $translate.instant("CALENDAR_ORDER_LASER_FILE"),
              'files': $translate.instant("CUSTOMERS_FILES"),
              'smses': $translate.instant("CUSTOMERS_SMSES"),
            };

            //ctrl.active_tab = '';

            if (ctrl.business.customer_menu_order) {
              var default_order = ctrl.menuList;
              ctrl.menuList = ctrl.business.customer_menu_order;
              //ctrl.active_tab = ctrl.menuList[0].name;

              for (var j in default_order) {
                var found = false;
                for (var i in ctrl.menuList) {
                  if (ctrl.menuList[i].name == default_order[j].name) {
                    found = true;
                  }
                }

                if (!found) {
                  ctrl.menuList.push(default_order[j]);
                }
              }
            }

            ctrl.goBackOrNavigate = function(hasLead, $event) {
              $event && $event.preventDefault();

              var raw = null, target = null;
              try {
                raw = sessionStorage.getItem('backTarget');
                target = raw ? JSON.parse(raw) : null;
              } catch (e) {
                target = null;
              }

              if (target && target.name) {
                $state.go(target.name, target.params || {}, { location: 'replace' });
                return;
              }

              if (hasLead) {
                $state.go('app.leads');
              } else {
                $state.go('app.customers');
              }
            };

            ctrl.openPdf = function(url) {
              $uibModal.open({
                templateUrl: "app/modules/pdf-preview/pdf-preview.view.html",
                controller: "PdfPreviewController",
                controllerAs: "ctrl",
                windowTopClass: "form-modal full-modal",
                scope: $scope,
                resolve: {
                  pdfUrl: function () {
                    return ctrl.isPdfUrl(url) ? url : '';
                  },
                  imageUrl: function () {
                    return ctrl.isImageUrl(url) ? url : '';
                  }
                },
              });
            };

            ctrl.menuListByPermission = function() {
              var menuList = [];
              if (ctrl.personal_only) {
                ctrl.menuList = menuList;
                return;
              }

              for (var i in ctrl.menuList) {
                var item = ctrl.menuList[i];

                switch (item.name) {
                  case 'history':
                    if (!$rootScope.isUserAllowedAccess('calendar')) {
                      continue;
                    }
                    break;
                  case 'transaction':
                    if (!$rootScope.isUserAllowedAccess('cashbox') || ctrl.hide_prices) {
                      continue;
                    }
                    break;
                  default:
                    break;
                }

                menuList.push(item);
              }

              ctrl.menuList = menuList;
              ctrl.active_tab = ctrl.menuList[0].name;
            }

            ctrl.menuListByPermission();


            ctrl.active_item_type = '';

            if (Customer.status == "failed")
                $state.transitionTo("app.customers", {}, { reload: true });

            if (Customer.data.lastname == null)
                Customer.data.lastname = "";

            $scope.customer = Customer.data;
            $scope.customer.custom_fields = $scope.customer.custom_fields ? JSON.parse($scope.customer.custom_fields) : false;

            $scope.customer.custom_values_list = [];
            ctrl.customFields = CustomFields.data ? CustomFields.data : [];
            ctrl.customFields.forEach(function (field) {
              field.name = $customFields.getCurrentName(field.name);
              if ($scope.customer.custom_values && $scope.customer.custom_values[field.id]) {
                var value = $scope.customer.custom_values[field.id];
                if (value) {
                  if (field.type == 'date') {
                    value = moment(value).format('DD/MM/YYYY')
                  }

                  if (field.type == 'datetime') {
                    value = moment(value).format('DD/MM/YYYY HH:mm')
                  }

                  if (field.type == 'list') {
                    var filteredValues = field.values.filter(function (item) {
                      return item.id == value;
                    });
                    value = filteredValues.length > 0 ? filteredValues[0].value : '---';
                  }
                } else {
                  value = '---';
                }

                $scope.customer.custom_values_list.push({
                  name: field.name,
                  value: value,
                });
              }
            });

            //ctrl.tableData = $scope.customer.history;

            ctrl.initedDrag = false;
        ctrl.initDrag = function () {
          // ************************ Drag and drop ***************** //
          var dropArea = document.getElementById("drop-area");

          if (!dropArea || ctrl.initedDrag) return;

          ctrl.initedDrag = true;

          dropArea.addEventListener('dragenter', highlight, false)
          dropArea.addEventListener('dragover', highlight, false)

          dropArea.addEventListener('dragleave', unhighlight, false)
          dropArea.addEventListener('drop', unhighlight, false)
          
          dropArea.addEventListener('drop', handleDrop, false);

          function preventDefaults (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          function highlight(e) {
            preventDefaults(e);
            dropArea.classList.add('highlight');
          }

          function unhighlight(e) {
            preventDefaults(e);
            dropArea.classList.remove('highlight');
          }

          function handleDrop(e) {
            var dt = e.dataTransfer;
            $scope.uploadFile(dt);
          }

        };
            
            ctrl.dtInstance = null;

            ctrl.dtIntanceCallback = function (instance) {
                ctrl.dtInstance = instance;
            }

            if($scope.customer.resource  != null) {
              $api.resources.single.get({
                id: $scope.customer.resource
              }, function(response) {
                $scope.customer.resource_name = response.data.name;
              });
            }

            if($scope.customer.resource_lead  != null) {
              $api.resources.single.get({
                id: $scope.customer.resource_lead
              }, function(response) {
                $scope.customer.resource_lead_name = response.data.name;
              });
            }


            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול לקוחות - <b>" + Customer.data.firstname + " " + Customer.data.lastname + "</b>";
            $header.breadcrumbs.push({
                "title": "לקוחות",
                "state": "app.customers"
            }, {
                    "title": Customer.data.firstname + " " + Customer.data.lastname
                });

            ctrl.showHideSearch = function () {
                $scope.showHideSearchInput = !$scope.showHideSearchInput;
              ctrl.setDataTableOptions($scope.showHideSearchInput);
            }
            ctrl.setDataTableOptions = function (showSearch) {
              if (window.innerWidth < 768) {
                if(typeof showSearch === "undefined") {
                  $scope.showHideSearchInput = false;
                }
                $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    //.withOption('scrollY', '500px')
                    //.withOption('order', [[1, 'desc']])
                    .withOption('aaSorting', [])
                    .withOption('searching', $scope.showHideSearchInput);
              } else {
                if(typeof showSearch === "undefined") {
                  $scope.showHideSearchInput = false;
                }
                $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    //.withOption('scrollY', '500px')
                    //.withOption('order', [[1, 'desc']])
                    .withOption('aaSorting', [])
                    .withOption('searching', $scope.showHideSearchInput);
              }
            }

            ctrl.setDataTableOptions();

            ctrl.go_quotation = function () {
              $location.url('/cashbox?customer=' + $scope.customer.id + '&quotation=true');
            }

            /**
             * Customer delete
             */
            ctrl.delete = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_CUSTOMER_DELETE_CONFIRM_TEXT').replace('[name]', Customer.data.firstname),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.customers.single.delete({id: Customer.data.id}, function(response) {
                            if(response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.customers", {}, {reload: true});
                            } else if (response.status == "exist") {
                              swal({
                                  title: $translate.instant('SWAL_CUSTOMER_DELETE_EXIST_TITLE'),
                                  type: "warning",
                                  confirmButtonText: $translate.instant('CUSTOMER_CONFIRM_REMOVE'),
                                  showCancelButton: true,
                                  cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                                  confirmButtonClass: "btn-danger",
                                  cancelButtonClass: "btn btn-danger",
                                  closeOnConfirm: false,
                                  showLoaderOnConfirm: true
                              }).then(function(result) {
                                if(result.value)
                                  $api.customers.remove.delete({id: Customer.data.id, confirm: 1}, function(response) {
                                    if(response.status == "success") {
                                      swal({
                                        title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                        text: "",
                                        type: "success",
                                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                        timer: 2000
                                      });
                                      $state.transitionTo("app.customers", {}, {reload: true});
                                    }
                                  });
                              });
                            }
                        });
                });
            };

            /**
             * Customer recover
             */
             ctrl.recover = function () {
              
              $api.customers.recover.get({id: Customer.data.id}, function(response) {
                if(response.status == "success") {
                  $state.transitionTo("app.customers", {}, {reload: true});
                }
              });
          };

          ctrl.open_log_card = function (logData) {

            $uibModal.open({
              templateUrl: "app/modules/settings/logs/modules/logs-info/logs.info.html",
              controller: "LogsInfoController",
              controllerAs: "ctrl",
              windowTopClass: "form-modal small-modal",
              scope: $scope,
              resolve: {
                Transaction: function ($api) {
                  return $api.resolve("transactions.single@get", {"id": logData.id});
                  }
              }
            }).closed.then(function() {

            });
          };

          ctrl.edit_customer = function() {
            $uibModal.open({
              templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
              controller: "CustomersFormController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal medium-modal side-modal",
              resolve: {
                Customer: ['$api', function ($api) {
                  return $api.resolve("customers.single@get", {"id": $scope.customer.id});
                }],
                isModal: false,
                Lead: false,
                Info: ['$api', function ($api) {
                  return $api.resolve("settings.info@get");
                }],
                Resources: ['$api', function ($api) {
                  return $api.resolve("resources@get");
                }],
                Statuses: ['$api', function ($api) {
                  return $api.resolve("statuses@get");
                }],
                Interested: ['$api', function ($api) {
                  return $api.resolve("interested@get");
                }],
                CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                  return $api.resolve("customFields.all@get");
                }],
                Phone: null,
              }
            });
          }


            /**
             * Opens "Edit Order" form
             */
            ctrl.edit_order_form = function(order) {

                $uibModal.open({
                    templateUrl: "app/modules/calendar/order/order.form.html",
                    controller: "OrderFormController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Items: function($api) {
                            return $api.resolve("items.items_with_duration@get");
                        },
                        Customers: function($api) {
                            return $api.resolve("customers@get");
                        },
                        Resources: function($api) {
                            return $api.resolve("resources@get");
                        },
                        SecondResources: function($api) {
                          return $api.resolve("second_resources@get");
                        },
                        Info: function ($api) {
                            return $api.resolve("settings.info@get");
                        },
                        Clubs: function($api) {
                            return $api.resolve("settings.clubs@get");
                        },
                        Customer: function($api) {
                          return null;
                        },
                        Order: function($api) {
                            return $api.resolve("orders.single@get", {
                                "id": order.order_id
                            });
                        },
                        CalendarEvent: null,
                        CalendarCourse: null,
                        Messages:  function($api) {
                            return $api.resolve("settings.messages@get");
                        },
                        EventCopy: false,
                        CoursesFields: ['$api', function ($api) {
                          return $api.resolve('coursesFields.lists@get');
                        }],
                    }
                }).closed.then(function() {

                });
            };

            ctrl.request_review = function (customer_id, type) {
              swal({
                  title: '',
                  text: $translate.instant('CONFIRM_REVIEW_REQUEST'),
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('OPTION_YES'),
                  cancelButtonText: $translate.instant('OPTION_NO'),
              }).then(function (res) {
                  if (res.value) {
                      ctrl.sendReviewRequest(customer_id, type);
                  }
              });
            };

             /**
             *
             * @param type Social network type
             */
          ctrl.sendReviewRequest = function (customer_id, type) {
            $tiff_page.start_loading('request_review');
            $api.customers.request_review.get({
                    id: customer_id,
                    type: type,
                },
                function (response) {
                    $scope.customer[type+'_review_request'] = true;
                    $tiff_page.stop_loading('request_review');
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('REVIEW_REQUEST_SUCCESS_SENT'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        }).then(function(){

                        });
                    }
                });
          }

          ctrl.social_link = function (customer_id) {
            $tiff_page.start_loading('social_link');
            $api.customers.social_link.get({
                  id: customer_id,
                },
                function (response) {
                    $tiff_page.stop_loading('social_link');
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('SOCIAL_LINK_SUCCESS_SENT'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        }).then(function(){

                    });
                }
              });
          }

            /**
             * Load customer's orders history
             */
            ctrl.loadOrderHistory = function() {
                // Check filters
                var filter = null;
                if(ctrl.historyOrdersStatusFilter) {
                    filter = ctrl.historyOrdersStatusFilter;
                }
                $scope.customer.history = null;
                ctrl.tableData = null;

              $api.orders.customer_history.get({id: Customer.data.id, filter_status: filter}, function(response) {
                if (response.status == 'success') {
                  ctrl.tableData = response.data;
                  $scope.customer.history = response.data;
                }
                });


            }

            /**
             * Show transactions with Card
             * @param customer_id
             */
            ctrl.open_customer_card_transactions = function(card_id) {
                $state.transitionTo("app.customers.card_transactions", {
                    "card_id": card_id,
                    "id": $scope.customer.id
                }, {
                    reload: false
                });
            };

            /**
             * Set active tab and re-render DataTable
             * @param index
             */
            ctrl.initedTableData = [];
            ctrl.setActiveTab = function (index) {
              ctrl.active_tab = index;
              ctrl.initedTableData = [];
              ctrl.tableData = [];
              if (index == 'wachat') {
                $wachat.apply($scope.customer);
                return;
              }
              ctrl.tabLoading = true;

              $api.customers.tab_info.get({id: $scope.customer.id, tab: index}, function(response) {
                ctrl.tabLoading = false;
                if (response.success && response.tab == ctrl.active_tab) {
                  ctrl.tableData = response.data;
                  ctrl.initedTableData = response.data;
                  if (index == 'history') {
                    var historyData = []
                    for (var i in response.data) {
                      var row = response.data[i];

                      row.images_before = [];
                      row.images_after = [];

                      for (j = 1; j <= 5; j++) {
                        if (row['order_image_before' + j] != null) {
                          row.images_before.push(row['order_image_before' + j]);
                        }
                      }

                      for (j = 1; j <= 5; j++) {
                        if (row['order_image_after' + j] != null) {
                          row.images_after.push(row['order_image_after' + j]);
                        }
                      }
                      historyData.push(row);
                    }

                    ctrl.tableData = historyData;
                    ctrl.initedTableData = historyData;
                  }
                  if (index == 'files') {
                    ctrl.initDrag();
                  }
                  if (index == 'laser') {
                    ctrl.init_laser_list(response.data);
                  }
                }
              });
            }

            ctrl.setActiveTab(ctrl.active_tab);

            ctrl.showImage = function($event, images) {
              $event.stopPropagation();
              $event.preventDefault();

              var current = 0;

              Swal.fire({
                html:
                  '<div style="position: relative; display: flex; justify-content: center; align-items: center; width: 100%; height: 400px;">' +
                    '<img id="swal-image" src="' + images[0] + '" style="max-width:100%; max-height: 100%; display: block;" />' +
                    '<button id="prev-btn" class="btn icon default"' +
                            'style="opacity: 0.8; position: absolute; top: 50%; inset-inline-start: 0; transform: translateY(-50%); ' +
                                  'cursor: pointer; display: none;">' +
                      '<i class="las la-angle-right rotatable"></i>' +
                    '</button>' +
                    '<button id="next-btn" class="btn icon default" ' +
                            'style="opacity: 0.8; position: absolute; top: 50%; inset-inline-end: 0; transform: translateY(-50%); ' +
                                  'cursor: pointer;">' +
                      '<i class="las la-angle-left rotatable"></i>' +
                    '</button>' +
                  '</div>',
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: $translate.instant('CALL_CANCEL'),
                allowOutsideClick: false,
                allowEscapeKey: false,
                onOpen: function(popup) {
                  // popup is the modal DOM element
                  var img     = popup.querySelector('#swal-image');
                  var prevBtn = popup.querySelector('#prev-btn');
                  var nextBtn = popup.querySelector('#next-btn');

                  var updateArrows = function() {
                    prevBtn.style.display = (current > 0) ? 'block' : 'none';
                    nextBtn.style.display = (current < images.length - 1) ? 'block' : 'none';
                    img.src = images[current];
                  };

                  prevBtn.addEventListener('click', function() {
                    if (current > 0) {
                      current--;
                      updateArrows();
                    }
                  });
                  nextBtn.addEventListener('click', function() {
                    if (current < images.length - 1) {
                      current++;
                      updateArrows();
                    }
                  });

                  // initialize
                  updateArrows();
                }
              });
            };
            
            ctrl.searchTableData = function(key) {

              if (ctrl[key]) {
                var newData = [];
                for (var i in ctrl.initedTableData) {
                  var found = false;
                  for (var k in ctrl.initedTableData[i]) {
                    if (k == "item_data" && ctrl.initedTableData[i][k].name && ctrl.initedTableData[i][k].name.toString().toLowerCase().indexOf(ctrl[key].toLowerCase()) > -1) {
                      found = true;
                    } else if (ctrl.initedTableData[i][k] && ctrl.initedTableData[i][k].toString().toLowerCase().indexOf(ctrl[key].toLowerCase()) > -1) {
                      found = true;
                    }
                  }

                  if (found) {
                    newData.push(ctrl.initedTableData[i]);
                  }
                }

                ctrl.tableData = newData;
              }
              
              if ($('#res_dt-'+key).DataTable()) {
                //$('#res_dt-'+key).DataTable().clear().draw();
              }
            }

            /**
             * Show change Card balance popup
             */
            ctrl.showChangeCard = function(card_id) {
              $uibModal.open({
                templateUrl: "app/modules/customers/modules/customers-single/cards/change-balance.form.html",
                controller: "CardBalanceFormController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal small-modal card-balance-edit-modal",
                resolve: {
                  Card: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("cards.single@get", {"id": card_id});
                  }
                }
              })
            }

            ctrl.removeDocument = function(id) {
              swal({
                title: '',
                text: $translate.instant('CONFIRM_DELETE_DD'),
                type: "warning",
                showCancelButton: true,
                confirmButtonText: $translate.instant('OPTION_YES'),
                cancelButtonText: $translate.instant('OPTION_NO'),
              }).then(function (res) {
                  if (res.value) {
                    $api.customer_documents.delete({id: id}, function(response) {
                      if(response.status == "success") {
                        $state.transitionTo("app.customers.single", { "id": $scope.customer.id }, { reload: true });
                      }
                    });
                  }
              });
            }

            ctrl.documentName = function(document) {
              if (document && document.url) {
                var splited = document.url.split($scope.customer.id + "-");
                return splited[1] ? splited[1] : splited[0];
              }

              return '';
            }

            $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromParams) {
              $rootScope.previousState = fromState;
              $rootScope.previousStateParams = fromParams;
            });

            /**
             * Load previous location
             */
            ctrl.go_back = function () {
                if ($rootScope.previousState) {
                  $state.go($rootScope.previousState, $rootScope.previousStateParams);
                } else {
                  $window.history.back();
                }
              }
          
            ctrl.edit_color_form = function(coloring_id) {

              $uibModal.open({
                  templateUrl: "app/modules/customers/modules/customers-single/cards/coloring.form.html",
                  controller: "ColoringFormController",
                  controllerAs: "ctrl",
                  scope: $scope,
                  windowTopClass: "form-modal small-modal",
                  resolve: {
                    Color: function ($api, $stateParams, $rootScope) {
                      $rootScope.$stateParams = $stateParams;
                      return (coloring_id) ? $api.resolve("coloring.single@get", {"id": coloring_id}) : null;
                    },
                    Customer: Customer
                  }
              }).closed.then(function() {
                
              });
            }

            ctrl.add_form = function() {
              $uibModal.open({
                  templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                  controller: "CustomersDigitalFormsAddController",
                  controllerAs: "ctrl",
                  scope: $scope,
                  windowTopClass: "form-modal medium-modal laser-file-modal",
                  resolve: {
                    Customer: Customer,
                    DigitalForms: ['$api', function($api) {
                      return $api.resolve("digital_forms@get");
                    }],
                    DigitalForm: null,
                    Order: null,
                    OrderForm: false,
                  }
              }).closed.then(function() {
                $state.transitionTo("app.customers.single", { "id": $scope.customer.id }, { reload: true });
              });
            }

            ctrl.change_item_type = function(type) {
              if (ctrl.active_item_type == type) {
                ctrl.active_item_type = '';
              } else {
                ctrl.active_item_type = type;
              }
              var new_data = [];
              for ( var k in $scope.customer.transactions_items ) {
                if ($scope.customer.transactions_items[k]['type'] == ctrl.active_item_type || ctrl.active_item_type == '') {
                  new_data.push($scope.customer.transactions_items[k]);
                }
              }
              
              ctrl.tableData = new_data;
            }



            //Laser file
            ctrl.laser_form = [];
            ctrl.laser_fields = [];
            ctrl.laser_blank = {};
            ctrl.laser_orders = {};
            ctrl.laser_orders_count = {};
    
            if (LaserInfo.data) {
              for (var i in LaserInfo.data) {
                if (LaserInfo.data[i].active) {
                  ctrl.laser_fields.push(LaserInfo.data[i]);
                  ctrl.laser_blank[LaserInfo.data[i].id] = '';
                }
              }
            }

            ctrl.init_laser_list = function(data){
              ctrl.laser_form = [];
              ctrl.laser_orders = {};
              ctrl.laser_orders_count = {};
              for (var i in data) {
                var d = JSON.parse(data[i].data);
                d.id = data[i].id
                d.show = false
                d.category_id = data[i].category_id;
                for (var j in ctrl.laser_fields) {
                    //old code compatibility
                    if (d[ctrl.laser_fields[j].code]) {
                      d[ctrl.laser_fields[j].id] = d[ctrl.laser_fields[j].code];
                    }
                    //old list code compatibility
                    if (ctrl.laser_fields[j].list) {
                      for (var k in ctrl.laser_fields[j].list) {
                        if (ctrl.laser_fields[j].list[k].code && ctrl.laser_fields[j].list[k].code == d[ctrl.laser_fields[j].id]) {
                          d[ctrl.laser_fields[j].id] = String(ctrl.laser_fields[j].list[k].id);
                        }
                      }
                    }


                    if ((ctrl.laser_fields[j].type == 'date' || ctrl.laser_fields[j].type == 'datetime') && d[ctrl.laser_fields[j].id]) {
                      d[ctrl.laser_fields[j].id] = new Date(d[ctrl.laser_fields[j].id]);
                    }
                }

                if (!ctrl.laser_orders[data[i].order_id]) {
                  d.first = true;
                } else {
                  d.first = false;
                }

                if (data[i].order_id) {
                  ctrl.laser_orders[data[i].order_id] = 'closed';
                  ctrl.laser_orders_count[data[i].order_id] = ctrl.laser_orders_count[data[i].order_id] ? ctrl.laser_orders_count[data[i].order_id] + 1 : 1;
                  d.order_id = data[i].order_id;
                }

                ctrl.laser_form.push(d);
              }
            }

            ctrl.display_laser_orders = function(data, hide) {
              ctrl.laser_orders[data.order_id] = hide ? 'closed' : 'opened';
              for (var i in ctrl.laser_form) {
                if (ctrl.laser_form[i].order_id == data.order_id) {
                  ctrl.laser_form[i].show = hide ? false : true;
                }
              }
            }
    
            ctrl.submit_fields = function(easy){
                $api.laser_file.save({form: ctrl.laser_form, customer_id: Customer.data.id}, function(response){
                    if (response.status === "success"){
                      ctrl.init_laser_list(response.data);
                    }
                    if(response.status === "success" && !easy){
                        swal({
                            title: $translate.instant('SWAL_CUSTOMER_LASER_FILE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    }
                });
            };
    
            ctrl.add_line = function(){
              //var copy = JSON.parse(JSON.stringify(ctrl.laser_blank));
              var copy = {};
              copy.show = true;
              copy.category_id = ctrl.laser_category;
              
              if (LaserInfo.data) {
                for (var i in LaserInfo.data) {
                    if (LaserInfo.data[i].active && LaserInfo.data[i].category_id == ctrl.laser_category) {
                      if (LaserInfo.data[i].type == 'date' || LaserInfo.data[i].type == 'datetime') {
                        copy[LaserInfo.data[i].id] = new Date(new Date().setSeconds(0, 0));
                      } else {
                        copy[LaserInfo.data[i].id] = '';
                      }
                    }
                }
              }

              ctrl.laser_form.push(copy);
            };
    
            ctrl.remove_line = function(index){
              swal({
                  title: "",
                  text: $translate.instant('LASER_FILE_REMOVE_LINE_CONFIRM'),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                  confirmButtonClass: "btn-danger",
                  closeOnConfirm: false,
                  showLoaderOnConfirm: true
              }).then(function(result) {
                  if(result.value) {
                    ctrl.laser_form[index].remove = true;
                    ctrl.submit_fields(true);
                  }
              });
            };

            ctrl.laser_map = function(index, field){
              $('body').addClass('fixed-body');
              $uibModal.open({
                templateUrl: "app/modules/settings/laser_file/map/laser_file.map.html",
                controller: "LaserFileMapController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Data: ctrl.laser_form[index],
                  Field: field
                }
              }).result.then(function (val) {
                $('body').removeClass('fixed-body');
                if (val) {
                  ctrl.laser_form[index].menmap = val.men;
                  ctrl.laser_form[index][field.id] = val.existed;
                  ctrl.submit_fields(true);
                }
              });
            };

            ctrl.add_note = function(note) {
              $uibModal.open({
                templateUrl: "app/modules/notes/modules/notes-form/notes.form.html",
                controller: "NotesFormController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Customer: function($api) {
                    return {data: Customer && Customer.data ? {id: Customer.data.id, name: (Customer.data.firstname || '') + " " + (Customer.data.lastname || '')} : null};
                  },
                  Resources: function($api) {
                    return $api.resolve("resources@get");
                  },
                  Note: note ? note : null,
                }
              }).result.then(function (val) {
                ctrl.setActiveTab('notes');
              });
            };

            ctrl.add_medical_note = function(medical_note) {
              $uibModal.open({
                templateUrl: "app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html",
                controller: "MedicalNotesFormController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Customer: function($api) {
                    return {data: Customer && Customer.data ? {id: Customer.data.id, name: (Customer.data.firstname || '') + " " + (Customer.data.lastname || '')} : null};
                  },
                  Resources: function($api) {
                    return $api.resolve("resources@get");
                  },
                  MedicalNote: medical_note ? medical_note : null,
                }
              }).result.then(function (val) {
                ctrl.setActiveTab('medical_notes');
              });
            };

            ctrl.open_medical_note_log = function (event, medical_note) {
              event.stopPropagation();
              $uibModal.open({
                templateUrl: "app/modules/medical_notes/modules/medical_notes-log/medical_notes.log.html",
                controller: "MedicalNotesLogController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal large-modal",
                resolve: {
                  Log: function($api) {
                    return $api.resolve("medical_notes.log@get", {"id": medical_note.id});
                  }
                }
              });
            };

            $scope.uploadFile = function(element){
              if (element.files && element.files.length > 0) {
                for (var i = 0; i < element.files.length; i++) {
                  $scope.postFile(element.files[i]);
                }
              }
            };


            $scope.postFile = function(file){
              var fdata = new FormData();
              fdata.append("file", file);
              fdata.append("customer_id", Customer.data.id);
  
              $resource($api.baseURL + '/Files/upload', {}, {
                  postWithFile: {
                      method: "POST",
                      params: fdata,
                      transformRequest: angular.identity,
                      headers: {'Content-Type': undefined}
                  }
              }).postWithFile(fdata).$promise.then(function(response){
                  if (response) {
                      if(response.status == "success"){
                        ctrl.setActiveTab('files');
                      } else if (response.status == "failed"){
                        swal({
                            title: response.message,
                            type: "error",
                            timer: 3000
                        });
                      }
                  }
              }, function(error){
                  console.log(error);
              });
            };

          ctrl.deleteFile = function (id) {
            swal({
              title: "",
              text: $translate.instant('SWAL_FILES_DELETE_CONFIRM_TEXT'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              closeOnConfirm: false,
              showLoaderOnConfirm: true
            }).then(function(result) {
              if(result.value)
                $api.files.single.delete({id: id}, function(response) {
                  if(response.status == "success") {
                    ctrl.setActiveTab('files');

                    swal({
                        title: $translate.instant('SWAL_FILES_DELETE_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $scope.$close();
                  }
                });
            });
        };

        ctrl.removeForm = function(id) {
          swal({
            title: "",
            text: $translate.instant('SWAL_CUSTOMER_DELETE_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
              if(result.value)
                  $api.customer_forms.delete({id: id}, function(response) {
                      if(response.status == "success") {
                        $state.transitionTo("app.customers.single", { "id": $scope.customer.id }, { reload: true });
                      }
                  });
          });
        };

        ctrl.print_form = function(form_id) {
          $uibModal.open({
            templateUrl: "app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html",
            controller: "CustomersDigitalFormsPrintController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal laser-file-modal",
            resolve: {
              DigitalForm: function ($api, $stateParams, $rootScope) {
                $rootScope.$stateParams = $stateParams;
                return $api.resolve("customer_forms@get", {"id": form_id});
              }
            }
          });
        };

        ctrl.send_form = function(form_id) {
          $api.customer_forms.pdf.save({id: form_id}, function(response) {
            if (response.status == "success") {
              swal({
                title: $translate.instant('SWAL_CUSTOMER_FORM_SEND_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
            }
          });
        };

        ctrl.request_card = function() {
          //ask swal
          swal({
            title: $translate.instant('SWAL_CUSTOMER_CARD_REQUEST_TITLE'),
            text: "",
            type: "question",
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-primary",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if(result.value) {
              $api.customers.request_card.get({
                id: Customer.data.id
              }, function(response) {
                if(response.status == "success") {
                  swal({
                    title: $translate.instant('SWAL_CUSTOMER_CARD_REQUEST_SUCCESS_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                } else {
                  swal({
                    title: $translate.instant('SWAL_CUSTOMER_CARD_REQUEST_ERROR_TITLE'),
                    text: $translate.instant(response.data.message),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 3000
                  });
                }
              });
            }
          });
        };

        ctrl.goToOrder = function(event, order) {
          event.preventDefault();
          event.stopPropagation();
          $state.go('app.calendar.date', {date: moment(order.order_date, 'HH:mm DD/MM/YYYY').format('YYYY-MM-DD HH:mm')});
        };

        ctrl.dropMenu = function(){
          var order = [];
          for (var i in ctrl.menuList) {
            order.push(ctrl.menuList[i]);
          }

          $api.settings.menuorder.save({order: order}, function(response){
            
          });
        };

        ctrl.calculateAge = function (birthdate) {
          if (!birthdate) return '';
          var birthDate = new Date(birthdate);
          var today = new Date();
          var age = today.getFullYear() - birthDate.getFullYear();
          var monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }
          return age;
        };

        ctrl.hexToRgbA = function(hex){
          var c;
          if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
              c= hex.substring(1).split('');
              if(c.length== 3){
                  c= [c[0], c[0], c[1], c[1], c[2], c[2]];
              }
              c= '0x'+c.join('');
              return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
          }
          return 'rgba(169,207,232,0.1)';
        }


        });
})();

(function() {

    angular.module("app.controllers").controller("CustomersPublicFormController", function($scope, $state, $api, dates,
     Customer, $rootScope, $tiff_page, $resource, $translate) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      $scope.isMobile = (angular.element(document).width() < 769);

      ctrl.form = {
         firstname: '',
         lastname: '',
         email: '',
         phone: '',
         birthdate: '',
         gender: '',
         telephone: '',
         address: '',
         city: '',
         zipcode: '',
         home_number: '',
         dealer_id: '',
         avatar: '',
      };

      $scope.business = Customer.business ? Customer.business : null;
   

      /**
       * Initialize edit data
       */
      if (Customer != null && Customer.data) {
        ctrl.form = Customer.data;
        ctrl.form.gender = String(ctrl.form.gender);
        
        if (ctrl.form.birthdate != null) {
          ctrl.form.birthdate = String(ctrl.form.birthdate).split("-");
          ctrl.form.birthdate_year = String(Number(ctrl.form.birthdate[0]));
          ctrl.form.birthdate_month = String(Number(ctrl.form.birthdate[1]));
          ctrl.form.birthdate_day = String(Number(ctrl.form.birthdate[2]));
        }
      }
      /**
       * Give access from the scope to the datesProvider
       */
      $scope.datesProvider = dates;

      /**
       * Triggers when customers form is submited
       * Preparing the API call for creating or editing the current customer
       */
      ctrl.submit = function () {

        if (ctrl.form.gender == null)
          ctrl.form.gender = -1;

        if (Customer !== null) {
         $tiff_page.start_loading('save_customer');
         $api.social.customer_post.save({
            id: $rootScope.$stateParams.id
          }, ctrl.form, function (response) {
            $scope.business = false;
            $tiff_page.stop_loading('save_customer');
            swal({
              title: $translate.instant('CUSTOMER_PUBLIC_SAVED'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            }).then(function(){
            });

          }, function (response) {
            $tiff_page.stop_loading('save_customer');
            var error = '';
            if (response.data.errors) {
              for (var key in response.data.errors) {
                error += response.data.errors[key] + '<br>';
              }
            }

            swal({
              title: $translate.instant('CUSTOMER_PUBLIC_ERROR'),
              html: error,
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            }).then(function(){
            });
          });
         }
      };

      /**
       * Upload new avatar
       *
       * @param element
       */
      $scope.uploadImage = function (element) {
        var file = element.files[0];
        var obj = new FormData();
        var new_file_name = 'customer_avatar' + '_' + Date.now() + '.' + element.files[0].name.split('.').pop();
        obj.append('image', file, new_file_name);
        obj.append("type", element.name);
        obj.append("customer_id", $rootScope.$stateParams.id);
        var reader = new FileReader();
        reader.onload = function (data) {
          ctrl.sendImage(obj);
        };
        reader.readAsDataURL(file);
      };

      /**
       * Sending file
       *
       * @param fdata
       */
      ctrl.sendImage = function (fdata) {
        $resource($api.baseURL + '/social/action/customer_avatar_upload', {}, {
          postWithFile: {
            method: "POST",
            params: fdata,
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          }
        }).postWithFile(fdata).$promise.then(function (response) {
          ctrl.form.avatar = response.image;
        }, function (error) {
        });
      }

    });

})();

(function(){
    angular.module('app.controllers').controller('CustomersListController',
      function ($state, $header, $scope, $api, $cfilter, dates, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log, $timeout) {
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.dtInstance = {};
        ctrl.customer_name = $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.search : "";
        ctrl.show_deleted = $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.deleted : false;
        ctrl.entriesPerPage = $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.limit : "20";

        $scope.datesProvider = dates;

        $header.title = "NAV_CUSTOMERS";
        $header.breadcrumbs.push({
          "title": "NAV_CUSTOMERS"
        });

        /**
         * Open customer data
         *
         * @param customerData
         */
        ctrl.open_customer_card = function (customerData) {
          $state.transitionTo("app.customers.single", {
            "id": customerData.id
          }, {
            reload: false
          });
        };

        ctrl.download_in_progress = false;
        /**
         * Download customer data
         *
         */
        ctrl.downloadCustomerData = function () {
          var opts = $rootScope.customer_page_data_options || {};

          var colIndex = opts.order;
          var orderDir = opts.order_dir ? opts.order_dir : '';
          var orderCol = '';

          if (colIndex != null && orderDir != '' && ctrl.dtColumns[colIndex]) {
            orderCol = ctrl.dtColumns[colIndex].name;
          }

          var filter = $rootScope.customers_filter || {};

          ctrl.download_in_progress = true;
          $api.customers.download.download(
            {order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted * 1, filter: filter}
            , function success(response) {
              ctrl.download_in_progress = false;

              var blob = new Blob([response.data], { type: 'text/csv;charset=UTF-8' });

              var cd = response.headers('Content-Disposition') ||
                       response.headers('content-disposition') ||
                       '';

              var match = /filename="?([^"]+)"?/.exec(cd);
              var filename = match && match[1] ? match[1] : 'customers.csv';

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }, function error(err) {
              ctrl.download_in_progress = false;
              console.error('Download failed', err);
            }
          );
        };

        /**
         * Initiate DataTable Options
         */
        ctrl.initDtOptions = function(){
          var initialOrder = [];
          if ($rootScope.customer_page_data_options && $rootScope.customer_page_data_options.order_dir) {
            var columnIndex = $rootScope.customer_page_data_options.order; 
            var orderDirection = $rootScope.customer_page_data_options.order_dir;
            initialOrder = [[columnIndex, orderDirection]];
          }

          $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', ctrl.entriesPerPage)
              .withOption('order', initialOrder)
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('displayStart', $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.offset : 0)
              .withOption('ajax', ctrl.loadCustomers)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('rowCallback', ctrl.customerRawCallback)
              .withOption('initComplete', function() {
                $("#custom-pagination-container").find("#cust_dt_info").remove();
                $("#custom-pagination-container").find("#cust_dt_paginate").remove();
                $("#cust_dt_info").prependTo("#custom-pagination-container");
                $("#cust_dt_paginate").prependTo("#custom-pagination-container");
              })
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.change_deleted = function () {
          ctrl.initDtOptions();
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Load customers
         *
         * @param data
         * @param callback
         * @param settings
         */
        ctrl.loadCustomers = function (data, callback, settings) {
          var orderCol = '';
          var orderDir = '';
          var colIndex = 0;

          if(data.order.length) {
            // Use only last order parameters
            colIndex = data.order[data.order.length - 1].column
            orderCol = data.columns[colIndex]['name'];
            orderDir = data.order[data.order.length - 1].dir;
          }

          $rootScope.customer_page_data_options = {
            limit: data.length,
            offset: data.start,
            order: colIndex,
            order_dir: orderDir,
            search: ctrl.customer_name,
            deleted: ctrl.show_deleted*1
          };

          var filter = $rootScope.customers_filter || {};

          callback({recordsTotal:0, recordsFiltered: 0, data: [], draw: data.draw+1});
          $scope.module_is_loading = true;
          $api.customers.list.get(
            {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted*1, filter: filter}
            , function (result) {
              $scope.module_is_loading = false;
            if (result && result.data) {
              callback({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: result.data,
                draw: data.draw + 1
              });
            }

          });
        };

        ctrl.customer_name = "";

        /**
         * search customer
         */
        $scope.find_customer = function() {
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Bind events to a new row
         *
         * @param nRow
         * @param aData
         * @param iDisplayIndex
         * @param iDisplayIndexFull
         * @returns {*}
         */
        ctrl.customerRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $(nRow).unbind('click');
          $(nRow).bind('click', function() {
            $scope.$apply(function() {
              ctrl.open_customer_card(aData);
            });
          });
          return nRow;
        }

        if (window.innerWidth < 768) {
          $.fn.DataTable.ext.pager.numbers_length = 3;
        }

        ctrl.initDtOptions();

        /**
         * Filter
        */
        $cfilter.apply('customers', true);
        $scope.submit_filter = function() {
          $scope.find_customer();
        }

        /**
         * Customer table column definitions
         * @type {*[]}
         */

        function escapeHtml(str) {
          if (!str) return '';
          return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        }

        ctrl.dtColumns = [
          { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125 w-100',
            render: function(data, type, full, meta) {
              var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
              var html = '<div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>';
              html+= '<b>';
              html+= data.firstname ? ' ' + escapeHtml(data.firstname) : '';
              html+= data.lastname ? ' ' + escapeHtml(data.lastname) : '';
              html+= '</b>';
              html+= data.wa_stop ? ' <span class="have-tooltip" tooltip="'+$translate.instant('CUSTOMERS_STOP_WA')+'"><i class="las la-hand-paper color-red"></i></span>' : '';
              return '<div class="flex nowrap">'+html+'</div>';
            }
          },
          {name: 'last_visit', data: null, title: $translate('CUSTOMERS_LAST_VISIT'), class: 'customer-name',
            render: function (data, type, full, meta) {
              var add_details = '<span ng-hide="\''+ data['last_visit'] +'\' ==\'01/01/1970\'">'+ (data['last_visit'] ? data['last_visit'] : '') +'</span>'
              
              add_details += '<div class="customers_add_details icons mobile">';

              if (data.oncredit > 0) {
                add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
              }
              if (data.has_cards) {
                add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
              }
              if ((data.has_color)) {
                add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
              }
              
              add_details += '</div>';

              return add_details;
            }
          },
          {name: 'desktop_icons', data: null, title: '', orderable: false, class: 'desktop-icons-column',
            render: function (data, type, full, meta) {
              var add_details = '<div class="customers_add_details icons desktop">';

              if (data.oncredit > 0) {
                add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
              }
              if (data.has_cards) {
                add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
              }
              if ((data.has_color)) {
                add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
          {name: 'current_year_income', data: null, title: '', class: 'customer-income', sortable: false,
            render: function (data, type, full, meta) {

              var add_details = '';
              add_details += '<div class="customers_call_details icons mobile" style="'+((data.oncredit > 0 || data.has_cards || data.has_color) ? '' : 'margin-top: 0;')+'">';

              if (data.phone) {

                var phone = data.phone;
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                phone = '+972'+phone;

                
                add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
              }

              add_details += '</div>';
              return add_details;
              //return '<span class="customers_list_year_income">' + (data.current_year_income ? parseFloat(data.current_year_income).toLocaleString('en') : '') + '</span>'+add_details;
            }
          },
          {name: 'icons', sortable: false, data: null, title: '', class: 'customer-icons',
            render: function (data, type, full, meta) {
              var add_details = '';
              add_details += '<div class="customers_call_details icons desktop">';

              if (data.phone) {

                var phone = data.phone;
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                phone = '+972'+phone;

                add_details += '<a class="btn icon circle small bordered green" href="/cashbox?customer='+data.id+'"><i class="las la-hand-holding-usd"></i></a>';
                add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
        ];
      });
})();

(function() {

    angular.module("app.controllers").controller("CustomersFormController", function($scope, $state, $api, $customFields, dates,
     Customer, isModal, Lead, Info, Resources, Statuses, Interested, CustomFields, Phone, $rootScope, $uibModalInstance, $tiff_page, $translate, $resource) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      $scope.isMobile = (angular.element(document).width() < 769);
      ctrl.customer_country = {
        "code": "IL",
        "name": "Israel"
      };
      $scope.isModal = isModal;
      ctrl.resources = Resources.data;
      ctrl.statuses = Statuses.data;
      ctrl.interesteds = Interested.data;

      ctrl.form = {
        gender: "-1",
        send_notifications: "0",
        self_order: Info.data.allow_online_booking*1 > 0 ? "1" : "0",
        group_notifications: "1",
        lead: Lead ? true : false,
        lead_platform: Lead ? 'manual' : null,
        custom_values: {},
      };

      ctrl.customFields = CustomFields.data ? CustomFields.data : [];
      ctrl.customFields.forEach(function (field) {
         field.name = $customFields.getCurrentName(field.name);
         ctrl.form.custom_values[field.id] = (field.type === 'date' || field.type === 'datetime') ? (new Date()) : '';
      });

      ctrl.bu_type = parseInt(Info.data.type);

      /**
       * Initialize edit data
       */
      if (Customer != null) {
        ctrl.form = Customer.data;
        ctrl.form.gender = String(ctrl.form.gender);
        ctrl.form.status_id = ctrl.form.status_id ? String(ctrl.form.status_id) : '';
        ctrl.form.interested_id = ctrl.form.interested_id ? String(ctrl.form.interested_id) : '';
        ctrl.form.send_notifications = String(Number(ctrl.form.send_notifications));
        ctrl.form.self_order = String(Number(ctrl.form.self_order));
        ctrl.form.group_notifications = String(Number(ctrl.form.group_notifications));
        ctrl.form.resource = String(ctrl.form.resource);
        ctrl.form.resource_lead = String(ctrl.form.resource_lead);
        if (ctrl.form.country == null) {
          ctrl.form.country = "IL";
        }

        if (ctrl.form.birthdate != null) {
          ctrl.form.birthdate = String(ctrl.form.birthdate).split("-");
          ctrl.form.birthdate_year = String(Number(ctrl.form.birthdate[0]));
          ctrl.form.birthdate_month = String(Number(ctrl.form.birthdate[1]));
          ctrl.form.birthdate_day = String(Number(ctrl.form.birthdate[2]));
        }

        if (ctrl.customFields.length > 0) {
         var custom_values = {}
         ctrl.customFields.forEach(function (field) {
            var value = ctrl.form.custom_values[field.id];
            if (field.type === 'date' || field.type === 'datetime') {
               if (value) {
                  custom_values[field.id] = new Date(value);
               } else {
                  custom_values[field.id] = new Date();
               }
            } else {
               custom_values[field.id] = value || '';
            }
         });

         ctrl.form.custom_values = custom_values;
        }
      } else {
        ctrl.form.send_notifications = Info.data.msg_channel_scheduling;
        ctrl.form.send_documents = Info.data.msg_channel_inv_link;
        ctrl.form.send_reminder = Info.data.send_reminder;
        ctrl.form.reminder_send_type = Info.data.reminder_send_type;
        ctrl.form.request_order_confirmation = Info.data.request_order_confirmation;
        if(ctrl.resources && ctrl.resources.length > 0) {
          for(var i in ctrl.resources) {
            if(ctrl.resources[i]['is_default'] == true) {
              ctrl.form.resource = String(ctrl.resources[i]['id']);
            }
          }
        }

        if (Phone != null) {
            //check if it's number then phone alse name
            if (Phone.match(/^\d+$/)) {
               ctrl.form.phone = Phone;
            } else {
               ctrl.form.firstname = Phone;
            }
         }
      }

      ctrl.form.avatar = ctrl.form.avatar ? ctrl.form.avatar : 'assets/images/avatar.jpg';

      /**
       * Give access from the scope to the datesProvider
       */
      $scope.datesProvider = dates;

      /**
       * Triggers when customers form is submited
       * Preparing the API call for creating or editing the current customer
       */
      ctrl.submit = function () {

        if (ctrl.form.gender == null)
          ctrl.form.gender = -1;

        $tiff_page.start_loading('save_customer');
        if (Customer == null) {
          $api.customers.save(ctrl.form, function (response) {
            $tiff_page.stop_loading('save_customer');
            if (response.status == "success") {

              if ($scope.isModal) {
                var promise = $api.resolve("customers.single@get", {"id": response.id});
                promise.then(function (response) {
                  $uibModalInstance.close(response.data);
                });
              } else {
                  $state.transitionTo((ctrl.form.lead) ? "app.leads" : "app.customers", {}, {reload: true});
              }
            }
          }, function (response) {
            $tiff_page.stop_loading('save_customer');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_CUSTOMER_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
        } else {
          $api.customers.single.save({
            id: Customer.data.id
          }, ctrl.form, function (response) {
            $tiff_page.stop_loading('save_customer');
            $uibModalInstance.close(response.data);
            if (response.status == "success") {
              swal({
                title: $translate.instant('SWAL_CUSTOMER_SAVE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo((ctrl.form.lead) ? "app.leads.single" : "app.customers.single", {id: Customer.data.id}, {reload: true});
            }
          }, function (response) {
            $tiff_page.stop_loading('save_customer');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_CUSTOMER_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
         }
      };

      ctrl.moveToLeads = function () {
         ctrl.form.lead = true;
         $tiff_page.stop_loading('save_customer');
         $api.customers.single.save({
            id: Customer.data.id
          }, ctrl.form, function (response) {
            $tiff_page.stop_loading('save_customer');
         });
      };

      ctrl.onCountryChange = function () {
        ctrl.form.country = ctrl.customer_country.code;
      }

      /**
       * Upload new avatar
       *
       * @param element
       */
      $scope.uploadImage = function (element) {
        var file = element.files[0];
        var obj = new FormData();
        var new_file_name = 'customer_avatar' + '_' + Date.now() + '.' + element.files[0].name.split('.').pop();
        obj.append('image', file, new_file_name);
        obj.append("type", element.name);
        obj.append("customer_id", ctrl.form.id);
        var reader = new FileReader();
        reader.onload = function (data) {
          ctrl.sendImage(obj);
        };
        reader.readAsDataURL(file);
      };

      /**
       * Sending file
       *
       * @param fdata
       */
      ctrl.sendImage = function (fdata) {
        $resource($api.baseURL + '/Image/upload', {}, {
          postWithFile: {
            method: "POST",
            params: fdata,
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          }
        }).postWithFile(fdata).$promise.then(function (response) {
          ctrl.form.avatar = response.image;
        }, function (error) {
        });
      }

        $scope.countries = [
            {
               "code":"AF",
               "name":"Afghanistan"
            },
            {
               "code":"AX",
               "name":"\u00c5land Islands"
            },
            {
               "code":"AL",
               "name":"Albania"
            },
            {
               "code":"DZ",
               "name":"Algeria"
            },
            {
               "code":"AS",
               "name":"American Samoa"
            },
            {
               "code":"AD",
               "name":"Andorra"
            },
            {
               "code":"AO",
               "name":"Angola"
            },
            {
               "code":"AI",
               "name":"Anguilla"
            },
            {
               "code":"AQ",
               "name":"Antarctica"
            },
            {
               "code":"AG",
               "name":"Antigua and Barbuda"
            },
            {
               "code":"AR",
               "name":"Argentina"
            },
            {
               "code":"AM",
               "name":"Armenia"
            },
            {
               "code":"AW",
               "name":"Aruba"
            },
            {
               "code":"AU",
               "name":"Australia"
            },
            {
               "code":"AT",
               "name":"Austria"
            },
            {
               "code":"AZ",
               "name":"Azerbaijan"
            },
            {
               "code":"BS",
               "name":"Bahamas"
            },
            {
               "code":"BH",
               "name":"Bahrain"
            },
            {
               "code":"BD",
               "name":"Bangladesh"
            },
            {
               "code":"BB",
               "name":"Barbados"
            },
            {
               "code":"BY",
               "name":"Belarus"
            },
            {
               "code":"BE",
               "name":"Belgium"
            },
            {
               "code":"BZ",
               "name":"Belize"
            },
            {
               "code":"BJ",
               "name":"Benin"
            },
            {
               "code":"BM",
               "name":"Bermuda"
            },
            {
               "code":"BT",
               "name":"Bhutan"
            },
            {
               "code":"BO",
               "name":"Bolivia, Plurinational State of"
            },
            {
               "code":"BQ",
               "name":"Bonaire, Sint Eustatius and Saba"
            },
            {
               "code":"BA",
               "name":"Bosnia and Herzegovina"
            },
            {
               "code":"BW",
               "name":"Botswana"
            },
            {
               "code":"BV",
               "name":"Bouvet Island"
            },
            {
               "code":"BR",
               "name":"Brazil"
            },
            {
               "code":"IO",
               "name":"British Indian Ocean Territory"
            },
            {
               "code":"BN",
               "name":"Brunei Darussalam"
            },
            {
               "code":"BG",
               "name":"Bulgaria"
            },
            {
               "code":"BF",
               "name":"Burkina Faso"
            },
            {
               "code":"BI",
               "name":"Burundi"
            },
            {
               "code":"KH",
               "name":"Cambodia"
            },
            {
               "code":"CM",
               "name":"Cameroon"
            },
            {
               "code":"CA",
               "name":"Canada"
            },
            {
               "code":"CV",
               "name":"Cape Verde"
            },
            {
               "code":"KY",
               "name":"Cayman Islands"
            },
            {
               "code":"CF",
               "name":"Central African Republic"
            },
            {
               "code":"TD",
               "name":"Chad"
            },
            {
               "code":"CL",
               "name":"Chile"
            },
            {
               "code":"CN",
               "name":"China"
            },
            {
               "code":"CX",
               "name":"Christmas Island"
            },
            {
               "code":"CC",
               "name":"Cocos (Keeling) Islands"
            },
            {
               "code":"CO",
               "name":"Colombia"
            },
            {
               "code":"KM",
               "name":"Comoros"
            },
            {
               "code":"CG",
               "name":"Congo"
            },
            {
               "code":"CD",
               "name":"Congo, the Democratic Republic of the"
            },
            {
               "code":"CK",
               "name":"Cook Islands"
            },
            {
               "code":"CR",
               "name":"Costa Rica"
            },
            {
               "code":"CI",
               "name":"C\u00f4te d'Ivoire"
            },
            {
               "code":"HR",
               "name":"Croatia"
            },
            {
               "code":"CU",
               "name":"Cuba"
            },
            {
               "code":"CW",
               "name":"Cura\u00e7ao"
            },
            {
               "code":"CY",
               "name":"Cyprus"
            },
            {
               "code":"CZ",
               "name":"Czech Republic"
            },
            {
               "code":"DK",
               "name":"Denmark"
            },
            {
               "code":"DJ",
               "name":"Djibouti"
            },
            {
               "code":"DM",
               "name":"Dominica"
            },
            {
               "code":"DO",
               "name":"Dominican Republic"
            },
            {
               "code":"EC",
               "name":"Ecuador"
            },
            {
               "code":"EG",
               "name":"Egypt"
            },
            {
               "code":"SV",
               "name":"El Salvador"
            },
            {
               "code":"GQ",
               "name":"Equatorial Guinea"
            },
            {
               "code":"ER",
               "name":"Eritrea"
            },
            {
               "code":"EE",
               "name":"Estonia"
            },
            {
               "code":"ET",
               "name":"Ethiopia"
            },
            {
               "code":"FK",
               "name":"Falkland Islands (Malvinas)"
            },
            {
               "code":"FO",
               "name":"Faroe Islands"
            },
            {
               "code":"FJ",
               "name":"Fiji"
            },
            {
               "code":"FI",
               "name":"Finland"
            },
            {
               "code":"FR",
               "name":"France"
            },
            {
               "code":"GF",
               "name":"French Guiana"
            },
            {
               "code":"PF",
               "name":"French Polynesia"
            },
            {
               "code":"TF",
               "name":"French Southern Territories"
            },
            {
               "code":"GA",
               "name":"Gabon"
            },
            {
               "code":"GM",
               "name":"Gambia"
            },
            {
               "code":"GE",
               "name":"Georgia"
            },
            {
               "code":"DE",
               "name":"Germany"
            },
            {
               "code":"GH",
               "name":"Ghana"
            },
            {
               "code":"GI",
               "name":"Gibraltar"
            },
            {
               "code":"GR",
               "name":"Greece"
            },
            {
               "code":"GL",
               "name":"Greenland"
            },
            {
               "code":"GD",
               "name":"Grenada"
            },
            {
               "code":"GP",
               "name":"Guadeloupe"
            },
            {
               "code":"GU",
               "name":"Guam"
            },
            {
               "code":"GT",
               "name":"Guatemala"
            },
            {
               "code":"GG",
               "name":"Guernsey"
            },
            {
               "code":"GN",
               "name":"Guinea"
            },
            {
               "code":"GW",
               "name":"Guinea-Bissau"
            },
            {
               "code":"GY",
               "name":"Guyana"
            },
            {
               "code":"HT",
               "name":"Haiti"
            },
            {
               "code":"HM",
               "name":"Heard Island and McDonald Islands"
            },
            {
               "code":"VA",
               "name":"Holy See (Vatican City State)"
            },
            {
               "code":"HN",
               "name":"Honduras"
            },
            {
               "code":"HK",
               "name":"Hong Kong"
            },
            {
               "code":"HU",
               "name":"Hungary"
            },
            {
               "code":"IS",
               "name":"Iceland"
            },
            {
               "code":"IN",
               "name":"India"
            },
            {
               "code":"ID",
               "name":"Indonesia"
            },
            {
               "code":"IR",
               "name":"Iran, Islamic Republic of"
            },
            {
               "code":"IQ",
               "name":"Iraq"
            },
            {
               "code":"IE",
               "name":"Ireland"
            },
            {
               "code":"IM",
               "name":"Isle of Man"
            },
            {
               "code":"IL",
               "name":"Israel"
            },
            {
               "code":"IT",
               "name":"Italy"
            },
            {
               "code":"JM",
               "name":"Jamaica"
            },
            {
               "code":"JP",
               "name":"Japan"
            },
            {
               "code":"JE",
               "name":"Jersey"
            },
            {
               "code":"JO",
               "name":"Jordan"
            },
            {
               "code":"KZ",
               "name":"Kazakhstan"
            },
            {
               "code":"KE",
               "name":"Kenya"
            },
            {
               "code":"KI",
               "name":"Kiribati"
            },
            {
               "code":"KP",
               "name":"Korea, Democratic People's Republic of"
            },
            {
               "code":"KR",
               "name":"Korea, Republic of"
            },
            {
               "code":"KW",
               "name":"Kuwait"
            },
            {
               "code":"KG",
               "name":"Kyrgyzstan"
            },
            {
               "code":"LA",
               "name":"Lao People's Democratic Republic"
            },
            {
               "code":"LV",
               "name":"Latvia"
            },
            {
               "code":"LB",
               "name":"Lebanon"
            },
            {
               "code":"LS",
               "name":"Lesotho"
            },
            {
               "code":"LR",
               "name":"Liberia"
            },
            {
               "code":"LY",
               "name":"Libya"
            },
            {
               "code":"LI",
               "name":"Liechtenstein"
            },
            {
               "code":"LT",
               "name":"Lithuania"
            },
            {
               "code":"LU",
               "name":"Luxembourg"
            },
            {
               "code":"MO",
               "name":"Macao"
            },
            {
               "code":"MK",
               "name":"Macedonia, the Former Yugoslav Republic of"
            },
            {
               "code":"MG",
               "name":"Madagascar"
            },
            {
               "code":"MW",
               "name":"Malawi"
            },
            {
               "code":"MY",
               "name":"Malaysia"
            },
            {
               "code":"MV",
               "name":"Maldives"
            },
            {
               "code":"ML",
               "name":"Mali"
            },
            {
               "code":"MT",
               "name":"Malta"
            },
            {
               "code":"MH",
               "name":"Marshall Islands"
            },
            {
               "code":"MQ",
               "name":"Martinique"
            },
            {
               "code":"MR",
               "name":"Mauritania"
            },
            {
               "code":"MU",
               "name":"Mauritius"
            },
            {
               "code":"YT",
               "name":"Mayotte"
            },
            {
               "code":"MX",
               "name":"Mexico"
            },
            {
               "code":"FM",
               "name":"Micronesia, Federated States of"
            },
            {
               "code":"MD",
               "name":"Moldova, Republic of"
            },
            {
               "code":"MC",
               "name":"Monaco"
            },
            {
               "code":"MN",
               "name":"Mongolia"
            },
            {
               "code":"ME",
               "name":"Montenegro"
            },
            {
               "code":"MS",
               "name":"Montserrat"
            },
            {
               "code":"MA",
               "name":"Morocco"
            },
            {
               "code":"MZ",
               "name":"Mozambique"
            },
            {
               "code":"MM",
               "name":"Myanmar"
            },
            {
               "code":"NA",
               "name":"Namibia"
            },
            {
               "code":"NR",
               "name":"Nauru"
            },
            {
               "code":"NP",
               "name":"Nepal"
            },
            {
               "code":"NL",
               "name":"Netherlands"
            },
            {
               "code":"NC",
               "name":"New Caledonia"
            },
            {
               "code":"NZ",
               "name":"New Zealand"
            },
            {
               "code":"NI",
               "name":"Nicaragua"
            },
            {
               "code":"NE",
               "name":"Niger"
            },
            {
               "code":"NG",
               "name":"Nigeria"
            },
            {
               "code":"NU",
               "name":"Niue"
            },
            {
               "code":"NF",
               "name":"Norfolk Island"
            },
            {
               "code":"MP",
               "name":"Northern Mariana Islands"
            },
            {
               "code":"NO",
               "name":"Norway"
            },
            {
               "code":"OM",
               "name":"Oman"
            },
            {
               "code":"PK",
               "name":"Pakistan"
            },
            {
               "code":"PW",
               "name":"Palau"
            },
            {
               "code":"PS",
               "name":"Palestine, State of"
            },
            {
               "code":"PA",
               "name":"Panama"
            },
            {
               "code":"PG",
               "name":"Papua New Guinea"
            },
            {
               "code":"PY",
               "name":"Paraguay"
            },
            {
               "code":"PE",
               "name":"Peru"
            },
            {
               "code":"PH",
               "name":"Philippines"
            },
            {
               "code":"PN",
               "name":"Pitcairn"
            },
            {
               "code":"PL",
               "name":"Poland"
            },
            {
               "code":"PT",
               "name":"Portugal"
            },
            {
               "code":"PR",
               "name":"Puerto Rico"
            },
            {
               "code":"QA",
               "name":"Qatar"
            },
            {
               "code":"RE",
               "name":"R\u00e9union"
            },
            {
               "code":"RO",
               "name":"Romania"
            },
            {
               "code":"RU",
               "name":"Russian Federation"
            },
            {
               "code":"RW",
               "name":"Rwanda"
            },
            {
               "code":"BL",
               "name":"Saint Barth\u00e9lemy"
            },
            {
               "code":"SH",
               "name":"Saint Helena, Ascension and Tristan da Cunha"
            },
            {
               "code":"KN",
               "name":"Saint Kitts and Nevis"
            },
            {
               "code":"LC",
               "name":"Saint Lucia"
            },
            {
               "code":"MF",
               "name":"Saint Martin (French part)"
            },
            {
               "code":"PM",
               "name":"Saint Pierre and Miquelon"
            },
            {
               "code":"VC",
               "name":"Saint Vincent and the Grenadines"
            },
            {
               "code":"WS",
               "name":"Samoa"
            },
            {
               "code":"SM",
               "name":"San Marino"
            },
            {
               "code":"ST",
               "name":"Sao Tome and Principe"
            },
            {
               "code":"SA",
               "name":"Saudi Arabia"
            },
            {
               "code":"SN",
               "name":"Senegal"
            },
            {
               "code":"RS",
               "name":"Serbia"
            },
            {
               "code":"SC",
               "name":"Seychelles"
            },
            {
               "code":"SL",
               "name":"Sierra Leone"
            },
            {
               "code":"SG",
               "name":"Singapore"
            },
            {
               "code":"SX",
               "name":"Sint Maarten (Dutch part)"
            },
            {
               "code":"SK",
               "name":"Slovakia"
            },
            {
               "code":"SI",
               "name":"Slovenia"
            },
            {
               "code":"SB",
               "name":"Solomon Islands"
            },
            {
               "code":"SO",
               "name":"Somalia"
            },
            {
               "code":"ZA",
               "name":"South Africa"
            },
            {
               "code":"GS",
               "name":"South Georgia and the South Sandwich Islands"
            },
            {
               "code":"SS",
               "name":"South Sudan"
            },
            {
               "code":"ES",
               "name":"Spain"
            },
            {
               "code":"LK",
               "name":"Sri Lanka"
            },
            {
               "code":"SD",
               "name":"Sudan"
            },
            {
               "code":"SR",
               "name":"Suriname"
            },
            {
               "code":"SJ",
               "name":"Svalbard and Jan Mayen"
            },
            {
               "code":"SZ",
               "name":"Swaziland"
            },
            {
               "code":"SE",
               "name":"Sweden"
            },
            {
               "code":"CH",
               "name":"Switzerland"
            },
            {
               "code":"SY",
               "name":"Syrian Arab Republic"
            },
            {
               "code":"TW",
               "name":"Taiwan, Province of China"
            },
            {
               "code":"TJ",
               "name":"Tajikistan"
            },
            {
               "code":"TZ",
               "name":"Tanzania, United Republic of"
            },
            {
               "code":"TH",
               "name":"Thailand"
            },
            {
               "code":"TL",
               "name":"Timor-Leste"
            },
            {
               "code":"TG",
               "name":"Togo"
            },
            {
               "code":"TK",
               "name":"Tokelau"
            },
            {
               "code":"TO",
               "name":"Tonga"
            },
            {
               "code":"TT",
               "name":"Trinidad and Tobago"
            },
            {
               "code":"TN",
               "name":"Tunisia"
            },
            {
               "code":"TR",
               "name":"Turkey"
            },
            {
               "code":"TM",
               "name":"Turkmenistan"
            },
            {
               "code":"TC",
               "name":"Turks and Caicos Islands"
            },
            {
               "code":"TV",
               "name":"Tuvalu"
            },
            {
               "code":"UG",
               "name":"Uganda"
            },
            {
               "code":"UA",
               "name":"Ukraine"
            },
            {
               "code":"AE",
               "name":"United Arab Emirates"
            },
            {
               "code":"GB",
               "name":"United Kingdom"
            },
            {
               "code":"US",
               "name":"United States"
            },
            {
               "code":"UM",
               "name":"United States Minor Outlying Islands"
            },
            {
               "code":"UY",
               "name":"Uruguay"
            },
            {
               "code":"UZ",
               "name":"Uzbekistan"
            },
            {
               "code":"VU",
               "name":"Vanuatu"
            },
            {
               "code":"VE",
               "name":"Venezuela, Bolivarian Republic of"
            },
            {
               "code":"VN",
               "name":"Viet Nam"
            },
            {
               "code":"VG",
               "name":"Virgin Islands, British"
            },
            {
               "code":"VI",
               "name":"Virgin Islands, U.S."
            },
            {
               "code":"WF",
               "name":"Wallis and Futuna"
            },
            {
               "code":"EH",
               "name":"Western Sahara"
            },
            {
               "code":"YE",
               "name":"Yemen"
            },
            {
               "code":"ZM",
               "name":"Zambia"
            },
            {
               "code":"ZW",
               "name":"Zimbabwe"
            }
         ];

    });

})();

(function() {

    angular.module("app.controllers").controller("CustomersDFController", function($scope, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.forms = $rootScope.$user.forms;

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {};

        ctrl.submit = function() {
            
            $api.digital_forms.send.save({
                id: ctrl.form.form,
                customer_id: Customer.data.id,
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_DF_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

    });

})();

(function() {

    angular.module("app.controllers").controller("CustomersDDController", function($scope, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.documents = $rootScope.$user.documents;

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {};

        ctrl.submit = function() {
            
            $api.settings.digital_documents.save({
                id: ctrl.form.document,
                customer_id: Customer.data.id,
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_DD_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

    });

})();

(function () {
    angular.module('app.controllers')
      .controller('PublicCardRequestController', function (Info, $sce, $scope, $translate) {
        var ctrl = this;

        $scope.business = Info.data ? Info.data.business : null;
        ctrl.iframe = Info.data && Info.data.iframe ? $sce.trustAsResourceUrl(Info.data.iframe) : null;
        $scope.channelHash = Info.data ? Info.data.id : null;


        var channel = (!pusher.channel('business-'+$scope.business.id)) ? pusher.subscribe('business-'+$scope.business.id) : pusher.channel('business-'+$scope.business.id);
        channel.bind('iframe-result-'+$scope.channelHash, function(response) {
            if (response) {
                if (response.result == 'success') {
                    swal({
                        title: $translate.instant('SWAL_IFRAME_REQUEST_CARD_SUCCESS_TITLE'),
                        text: "",
                        type: "success",
                    });
                } else if (response.result == 'error') {
                    var message = '';
                    swal({
                        title: response.message ? response.message : message,
                        text: $translate.instant('SWAL_IFRAME_REQUEST_CARD_ERROR_TEXT'),
                        type: "warning",
                    });
                }
            }
        });
        
    });
})();
(function () {

    angular.module('app.controllers')

        .controller('BusinessesListController', function (Categories, $state, $header, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            /**
             * Assign data to the table
             */
            ctrl.tableData = Categories.data;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "קטגוריות";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "קטגוריות"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider);

        });

})();

(function() {

    angular.module("app.controllers").controller("BusinessesFormController", function($scope, $state, $api, dates, Category, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {};

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(Category != null) {
            $scope.isEdit = true;
            ctrl.form = Category.data;
        }

        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(Category == null)
                /**
                 * In case it's a new customer form
                 */
                $api.categories.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_ADD_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.categories.single.save({
                    id: Category.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_SAVE_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {id: Category.data.id}, {reload: true});
                    }
                });
        };

        /**
         * Triggers category delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_CATEGORIES_DELETE_CONFIRM_TITLE').replace('[name]', Category.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.categories.single.delete({id: Category.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_CATEGORIES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.categories", {}, {reload: true});
                        }
                    });
            });
        };
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('BusinessSingleController', function (Business, Variants, $api, $state, $scope, $rootScope, $header, $stateParams, $translate) {

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }
            var ctrl = this;
            ctrl.businessId = $stateParams.id;
            ctrl.business = Business.data;
            ctrl.business.language = "SETTINGS_INFO_" + ctrl.business.language_code.toUpperCase() + "_LANG";

            ctrl.variants = [];

            if (Variants){
                ctrl.variants = Variants.data;
            }



            //Module header configuration (title and breadcrumbs)
            $header.title = "Business - <b>" + Business.data.name + "</b>";
            $header.breadcrumbs.push({
                "title": "Businesses",
                "state": "app.admin"
            }, {
                    "title": Business.data.name
                });

            ctrl.createNewUser = function () {
              $rootScope.b_id = ctrl.businessId;
              $state.go('app.admin.users.new')
            }

            /**
             * Business delete
             */
            ctrl.removeBusiness = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_ADMIN_BUSINESS_DELELE_CONFIRM_TEXT').replace('[name]', Business.data.name),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.businesses.single.delete({id: Business.data.id}, function(response) {
                            if(response.success) {
                                swal({
                                    title: $translate.instant('SWAL_ADMIN_BUSINESS_DELELE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.admin", {}, {reload: true});
                            }
                        });
                });
            };
        });

})();

(function() {

    angular.module("app.controllers").controller("BusinessMessageController",
        function($scope, $state, $api, Types, Business, Resources, $business, $rootScope, dates, $translate) {

            var ctrl = this;

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            ctrl.form = {
                type: "info",
                text: "",
            };

            ctrl.submit = function() {

                $api.businesses.message.save(ctrl.form, function(response){
                    if(response.success) {
                        swal({
                            title: $translate.instant('SWAL_BUSINESS_MESSAGE_SENT_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.admin", {}, {reload: true});
                    }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("BusinessFormController",
        function($scope, $state, $api, $tiff_page, Types, Variants, Business, Resources, $business, $rootScope, dates, $translate) {

            var ctrl = this;

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            ctrl.types = [];
            ctrl.variants = [];
            ctrl.resources = [];

            if (Types){
                ctrl.types = Types.data;
            }

            if (Variants){
                ctrl.variants = Variants.data;
            }

            if (Resources){
                ctrl.resources = Resources.data;
            }

            $scope.datesProvider = dates;

            ctrl.form = {
                //vat: 17,
                type: "1",
                credit_card: "1",
                paid_link: "0",
                courses: "0",
                second_resource: "0",
                cashbox: "1",
                zero_vat: "0",
                ai_assistant: "0",
                online_payments: "0",
                card_reader: "0",
                sms_own_sign: "0",
                enabled_retainers: "0",
                customers_settings: {
                  send_notifications: {update_all: 0, value: null},
                  self_order: {update_all: 0, value: null},
                  resource: {update_all: 0, value: null},
                  send_reminder: {update_all: 0, value: null},
                  reminder_send_type: {update_all: 0, value: null},
                  send_documents: {update_all: 0, value: null},
                  request_order_confirmation: {update_all: 0, value: null}
                }
            };

            //Initialize edit data
            if(Business != null) {
                //ctrl.form.vat = Number(Business.data.vat);
                ctrl.form.address = String(Business.data.address);
                ctrl.form.home_number = String(Business.data.home_number);
                ctrl.form.zip = String(Business.data.zip);
                ctrl.form.agent = String(Business.data.agent);
                ctrl.form.cashbox = String(Number(Business.data.cashbox));
                ctrl.form.ai_assistant = String(Number(Business.data.ai_assistant));
                ctrl.form.online_payments = String(Number(Business.data.online_payments));
                ctrl.form.card_reader = String(Number(Business.data.card_reader));
                ctrl.form.sms_own_sign = String(Number(Business.data.sms_own_sign));
                ctrl.form.city = String(Business.data.city);
                ctrl.form.credit_card = String(Number(Business.data.credit_card));
                ctrl.form.paid_link = String(Number(Business.data.paid_link));
                ctrl.form.courses = String(Number(Business.data.courses));
                ctrl.form.second_resource = String(Number(Business.data.second_resource));
                ctrl.form.second_resource_name = Business.data.second_resource_name ? String(Business.data.second_resource_name) : '';
                ctrl.form.email = String(Business.data.email);
                ctrl.form.language = "SETTINGS_INFO_" + Business.data.language_code.toUpperCase() + "_LANG";
                ctrl.form.language_code = String(Business.data.language_code);
                ctrl.form.emv_terminal_id = String(Business.data.emv_terminal_id);
                ctrl.form.zcredit_key = String(Business.data.zcredit_key);
                ctrl.form.z_credit_credit_deal = String(Number(Business.data.z_credit_credit_deal));
                ctrl.form.call_token = String(Business.data.call_token);
                ctrl.form.name = String(Business.data.name);
                ctrl.form.phone = String(Business.data.phone);
                ctrl.form.type = String(Business.data.type);
                ctrl.form.variant = String(Business.data.variant);
                ctrl.form.dealer_type = String(Business.data.dealer_type);
                ctrl.form.zero_vat = String(Number(Business.data.zero_vat));
                ctrl.form.company_id = String(Business.data.company_id);
                ctrl.form.status = String(Business.data.status);
                ctrl.form.deductions_file = String(Business.data.deductions_file);
                ctrl.form.wa_instance = Business.data.wa_instance ? String(Business.data.wa_instance) : '';
                ctrl.form.wa_token = Business.data.wa_token ? String(Business.data.wa_token) : '';
                ctrl.form.credit_suplier = String(Business.data.credit_suplier);
                ctrl.form.cerdit_company = String(Business.data.cerdit_company);
                ctrl.form.credit_yaad_key = String(Business.data.credit_yaad_key);
                ctrl.form.enabled_retainers = String(Number(Business.data.enabled_retainers));
                ctrl.hideUser = true;
            }else{
                ctrl.hideUser = false;
            }

            $scope.bis_statuses = $business.getAllStatuses();
            $scope.credit_comp = $business.getAllCreditComp();
            ctrl.businessControls = $business;

            $scope.sanitizeString = function(str) {
                if (typeof str === 'string') {
                    // Allow printable ASCII characters, Hebrew characters, and space
                    return str.replace(/[^\x20-\x7E\u0590-\u05FF]/g, ''); 
                }
                return str;
            };

            $scope.sanitizeData = function(excelRows) {
                return excelRows.map(function(row) {
                    var sanitizedRow = {};
                    for (var key in row) {
                        if (row.hasOwnProperty(key)) {
                            sanitizedRow[key] = $scope.sanitizeString(row[key]);
                        }
                    }
                    return sanitizedRow;
                });
            };


            // /**
            //  * Triggers when customers form is submited
            //  * Preparing the API call for creating or editing the current customer
            //  */
            $scope.uploadExcel = function(event, type) {
                type = type || 'customers';
                SelectedFile = event.target.files[0];

                var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
                if (typeof (FileReader) != "undefined") {
                    var reader = new FileReader();

                    $tiff_page.start_loading('load_excel');

                    //For Browsers other than IE.
                    if (reader.readAsBinaryString) {
                        reader.onload = function (e) {
                            $scope.ProcessExcel(e.target.result, type);
                        };
                        reader.readAsBinaryString(SelectedFile);
                    } else {
                        //For IE Browser.
                        reader.onload = function (e) {
                            var data = "";
                            var bytes = new Uint8Array(e.target.result);
                            for (var i = 0; i < bytes.byteLength; i++) {
                                data += String.fromCharCode(bytes[i]);
                            }
                            $scope.ProcessExcel(data, type);
                        };
                        reader.readAsArrayBuffer(SelectedFile);
                    }
                } else {
                    alert("This browser does not support HTML5.");
                }
            };
            $scope.ProcessExcel = function (data, type) {
                //Read the Excel File data.
                var workbook = XLSX.read(data, {
                    type: 'binary'
                });

                if (type == 'crm') {
                    //Fetch all sheets from the workbook
                    var sanitizedData = {};
                    for (var y in workbook.SheetNames) {
                        var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[workbook.SheetNames[y]]);

                        // Sanitize the data to remove strange symbols
                        sanitizedData[workbook.SheetNames[y]] = $scope.sanitizeData(excelRows);
                    }
                } else {
                    //Fetch the name of First Sheet.
                    var firstSheet = workbook.SheetNames[0];
                    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);

                    // Sanitize the data to remove strange symbols
                    var sanitizedData = $scope.sanitizeData(excelRows);
                }
                
                $tiff_page.stop_loading('load_excel');
                // Assign the sanitized data to the form
                ctrl.form[type] = sanitizedData;
            };
           
            ctrl.submit = function() {
                $tiff_page.start_loading('load_submit');
                if(Business == null){
                    $api.businesses.save(ctrl.form, function(response){
                        
                        if(response.success) {
                            swal({
                                title: $translate.instant('SWAL_BUSINESS_ADD_TITLE'),
                                text: $translate.instant('SWAL_BUSINESS_ADD_TEXT'),
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.admin", {}, {reload: true});
                        }
                    });
                    $tiff_page.stop_loading('load_submit');
                }
                else
                    /**
                     * In case it's an edit form
                     */
                    $api.businesses.single.save({
                        id: Business.data.id
                    }, ctrl.form, function(response){
                        if(response.success) {
                            if (response.waiting) {
                                ctrl.checkImportStatus();
                                return;
                            }

                            $tiff_page.stop_loading('load_submit');
                            swal({
                                title: $translate.instant('SWAL_BUSINESS_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.admin.single-business", {id: Business.data.id}, {reload: true});
                        }
                    }, function () {
                        $tiff_page.stop_loading('load_submit');
                        swal({
                            title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                            text: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TEXT'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });

                    });
            };

            ctrl.checkImportStatus = function() {
                $api.businesses.check_import.get({id: Business.data.id}, function(response) {
                    if (response.success) {
                        if (response.waiting) {
                            angular.element(document.querySelector( '#loading_count' )).addClass('active');
                            angular.element(document.querySelector( '#l_imported' )).html("<b>"+((response.imported_records) ? response.imported_records : 0)+"</b>");
                            angular.element(document.querySelector( '#l_total' )).html("<b>"+((response.total) ? response.total : 0)+"</b>");

                            setTimeout(ctrl.checkImportStatus, 500);
                            return;
                        } else {
                            angular.element(document.querySelector( '#loading_count' )).removeClass('active');
                            $tiff_page.stop_loading('load_submit');
                            if (response.imported) {
                                swal({
                                    title: "Data was imported successfully",
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 20000
                                });
                            } else {
                                swal({
                                    title: $translate.instant('SWAL_BUSINESS_SAVE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 20000
                                });
                            }
                            $state.transitionTo("app.admin.single-business", {id: Business.data.id}, {reload: true});
                        }
                    } else {
                        angular.element(document.querySelector( '#loading_count' )).removeClass('active');
                        $tiff_page.stop_loading('load_submit');
                        swal({
                            title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                            text: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TEXT'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 30000
                        });
                    }
                }, function () {
                    angular.element(document.querySelector( '#loading_count' )).removeClass('active');
                    $tiff_page.stop_loading('load_submit');
                    swal({
                        title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                        text: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TEXT'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 30000
                    }); 
                });
            }
        });
})();
(function() {

    angular.module("app.controllers").controller("BusinessCopyController",
        function($scope, $state, $api, Variants, $rootScope, $uibModal, $translate) {

            var ctrl = this;

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            ctrl.variants = [];
            
            if (Variants){
                ctrl.variants = Variants.data;
            }

            ctrl.form = {
                variant: "",
                name: "",
                email: "",
				password: "",
				name: "",
                copy: true
            };

            
            ctrl.submit = function() {

                $api.businesses.save(ctrl.form, function(response){
                    if(response.success && response.data && response.data.b_id) {
                        $uibModal.open({
                            templateUrl: "app/modules/admin/modules/business-form/business.form.html",
                            controller: "BusinessFormController",
                            controllerAs: "ctrl",
                            windowTopClass: "form-modal",
                            resolve: {
                                Business: ['$api', '$rootScope', function ($api, $rootScope) {
                                    return $api.resolve("businesses.single@get", {"id": response.data.b_id});
                                }],
                                Types: ['$api', function ($api) {
                                    return $api.resolve("businesses.types@get");
                                }],
                                Variants: ['$api', function ($api) {
                                    return $api.resolve("businesses.variants@get");
                                }],
                                Resources: ['$api', '$rootScope', function ($api, $rootScope) {
                                    return $api.resolve("resources@get", {"b_id": response.data.b_id});
                                }]
                            }
                          }).result.then(function (val) {
                            $scope.$close();
                        });
                    }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("WorkersSelectController", function($scope, $state, DTOptionsBuilder, Workers, dataTablesHebrewProvider, $rootScope, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.workers = Workers;


        ctrl.selectCustomer = function(index) {
            $uibModalInstance.close(ctrl.workers[index]);
        }

        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            .withOption('scrollY', '500px')
            .withOption('order', [[1, 'desc']])
            .withOption('searching', false);


    });

})();

(function () {
  angular.module('app.controllers')
    .controller('PhotosStockSettingsController', function ($state, $scope, $header, $api, $rootScope, PhotosStock, DTOptionsBuilder, dataTablesHebrewProvider, $translate) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }
      
      $header.breadcrumbs.push({
        title: 'SETTINGS_PHOTOS_STOCK'
      });

      var ctrl = this;
      ctrl.tableData = PhotosStock ? PhotosStock.data : [];

      $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider)
        .withOption('order', [[2, 'desc']])
        .withOption('columnDefs', [
          { targets: [0], width: '40px', orderable: false },
          { targets: [1, 2], width: 'auto' },
          { targets: [3], width: '40px', orderable: false }
        ]);


      ctrl.uploadProgress = 0;
      $scope.uploadFile = function(element){
        if (ctrl.uploadProgress > 1) return;
        if (element.files && element.files.length > 0) {
          ctrl.uploadProgress = element.files.length;
          for (var i = 0; i < element.files.length; i++) {
            $scope.postFile(element.files[i]);
          }
        }
      };


      $scope.postFile = function(file) {
          var fdata = new FormData();
          fdata.append("file", file);

          $api.photosStock.upload(fdata).$promise.then(function(response) {
            ctrl.uploadProgress--;
            if (response) {
              if (response.success && ctrl.uploadProgress < 1) {
                ctrl.getPhotos();
              } else {
                swal({
                  title: response.message,
                  type: "error",
                  timer: 3000
                });
              }
            }
          }).catch(function(error) {
              console.log(error);
          });
      };

      ctrl.deletePhoto = function(photoId) {
          swal({
              title: "",
              text: $translate.instant('SWAL_PHOTOS_STOCK_DELETE_CONFIRM_TEXT'),
              type: "warning",
              showCancelButton: true,
              confirmButtonClass: "btn-danger",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          }).then(function(result) {
            if(result.value) {
              $api.photosStock.delete.delete({ id: photoId }).$promise.then(function(response) {
                if (response && response.success) {
                  ctrl.tableData = ctrl.tableData.filter(function(item) {
                      return item.id !== photoId;
                  });
                  swal('', $translate.instant('SWAL_PHOTOS_STOCK_DELETE_SUCCESS_TEXT'), "success");
                } else {
                  swal('', $translate.instant('SWAL_PHOTOS_STOCK_DELETE_ERROR_TEXT'), "error");
                }
              });
            }
          });
      };

      ctrl.getPhotos = function() {
        $api.photosStock.get().$promise.then(function(response) {
          if (response && response.success) {
            ctrl.tableData = response.data;
          }
        });
      };

    });
})();

(function (){

    angular.module('app.controllers').controller('OnlineSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        Info.data.online_booking_data = Info.data && Info.data.online_booking_data ? JSON.parse(Info.data.online_booking_data) : {};
        
        ctrl.form = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.name ? Info.data.online_booking_data : {};
        ctrl.form.background_picture = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background_picture && Info.data.online_booking_data.background_picture != "" ? Info.data.online_booking_data.background_picture : 'women';
        ctrl.form.icon = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.icon && Info.data.online_booking_data.icon != "" ? Info.data.online_booking_data.icon : location.protocol + "//" + location.host+'/assets/images/pwa-icon.png';
        ctrl.form.background = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background && Info.data.online_booking_data.background != "" ? Info.data.online_booking_data.background : (Info.data.online_booking_data.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
        ctrl.form.background1 = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background1 ? Info.data.online_booking_data.background1 : '';
        ctrl.form.background2 = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background2 ? Info.data.online_booking_data.background2 : '';
        ctrl.form.background3 = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background3 ? Info.data.online_booking_data.background3 : '';
        ctrl.form.online_logo = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.online_logo && Info.data.online_booking_data.online_logo != "" ? (Info.data.online_booking_data.online_logo == "removed" ? "" : Info.data.online_booking_data.online_logo) : location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
        ctrl.form.online_color = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.online_color && Info.data.online_booking_data.online_color != "" ? Info.data.online_booking_data.online_color : 'purple';
        ctrl.form.online_text_color = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.online_text_color && Info.data.online_booking_data.online_text_color != "" ? Info.data.online_booking_data.online_text_color : '#ffffff';
        ctrl.form.available_hours = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.available_hours && Info.data.online_booking_data.available_hours != "" ? Info.data.online_booking_data.available_hours : 'calendar';

        if (ctrl.form.online_color == 'purple') {
            ctrl.form.online_color = '#8C60AE';
        }
        if (ctrl.form.online_color == 'turquoise') {
            ctrl.form.online_color = '#61B9A0';
        }

        ctrl.form.name = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.name ? String(Info.data.online_booking_data.name) : '';
        ctrl.form.address = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.address ? String(Info.data.online_booking_data.address) : '';
        ctrl.form.phone = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.phone ? String(Info.data.online_booking_data.phone) : '';
        ctrl.form.facebook = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.facebook ? String(Info.data.online_booking_data.facebook) : '';
        ctrl.form.instagram = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.instagram ? String(Info.data.online_booking_data.instagram) : '';
        ctrl.form.linkedin = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.linkedin ? String(Info.data.online_booking_data.linkedin) : '';
        ctrl.form.twitter = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.twitter ? String(Info.data.online_booking_data.twitter) : '';
        ctrl.form.facebook_pixel = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.facebook_pixel ? String(Info.data.online_booking_data.facebook_pixel) : '';

        ctrl.form.allow_update = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_update ? String(Info.data.online_booking_data.allow_update) : '0';
        ctrl.form.allow_cancel = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_cancel ? String(Info.data.online_booking_data.allow_cancel) : '0';
        ctrl.form.update_hours = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.update_hours ? String(Info.data.online_booking_data.update_hours) : '4h';
        ctrl.form.cancel_hours = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.cancel_hours ? String(Info.data.online_booking_data.cancel_hours) : '4h';
        ctrl.form.closest_time = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.closest_time ? String(Info.data.online_booking_data.closest_time) : '0';
        ctrl.form.latest_time = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.latest_time ? Info.data.online_booking_data.latest_time*1 : 365;

        ctrl.form.instagram = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.instagram ? String(Info.data.online_booking_data.instagram) : '';
        ctrl.form.status = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.status ? String(Info.data.online_booking_data.status) : 'pending';
        ctrl.form.resource = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.resource ? String(Info.data.online_booking_data.resource) : '0';
        ctrl.form.display_category = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_category ? String(Info.data.online_booking_data.display_category) : '0';
        ctrl.form.display_earliest = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_earliest ? String(Info.data.online_booking_data.display_earliest) : '0';
        ctrl.form.allow_multi = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_multi ? String(Info.data.online_booking_data.allow_multi) : '0';
        ctrl.form.allow_first_available = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_first_available ? String(Info.data.online_booking_data.allow_first_available) : '0';
        ctrl.form.about = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.about ? String(Info.data.online_booking_data.about) : '';
        ctrl.form.display_price = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_price ? String(Info.data.online_booking_data.display_price) : '0';
        ctrl.form.display_duration = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_duration ? String(Info.data.online_booking_data.display_duration) : '1';

        ctrl.form.disable_confirmation_code = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.disable_confirmation_code ? String(Info.data.online_booking_data.disable_confirmation_code) : '0';
        ctrl.form.confirmation_code = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.confirmation_code ? String(Info.data.online_booking_data.confirmation_code) : '0';
        ctrl.form.allow_new = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_new ? String(Info.data.online_booking_data.allow_new) : '1';
        ctrl.form.waiting_list = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.waiting_list ? String(Info.data.online_booking_data.waiting_list) : '0';
        ctrl.form.interval = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.interval ? String(Info.data.online_booking_data.interval) : '';

        ctrl.form.alias = Info.data && Info.data.alias ? Info.data.alias : '';
        ctrl.form.allow_online_booking = String(parseInt(Info.data.allow_online_booking));

        ctrl.aliasStatus = 'pending';
        ctrl.aliasTimer = null;
        ctrl.copied = false;

        $scope.msg_channels = $business.getMsgChannels();
        $scope.getMsgChannelByIndex = $business.getMsgChannelByIndex;

        ctrl.submit = function(){
            if (ctrl.aliasStatus == 'symbols' || ctrl.aliasStatus == 'taken' || ctrl.aliasStatus == 'length') {
                return;
            }

            $api.settings.online.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_ONLINE_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                }
            });
        };

        ctrl.removeImage = function(type) {
            event.preventDefault();
            if (type == "background") {
                ctrl.form[type] = (ctrl.form.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
            } else if (type == "icon") {
                ctrl.form[type] = location.protocol + "//" + location.host+'/assets/images/pwa-icon.png';
            } else if (type == "online_logo") {
                ctrl.form[type] = 'removed';// location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
            } else {
                ctrl.form[type] = '';
            }
        }

        ctrl.checkDefaultBack = function(e) {
            if (ctrl.form.background.indexOf("pwa-default-") > 0) {
                ctrl.form.background = (ctrl.form.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
            }
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var reader = new FileReader();

            reader.onload = function(e) {
                var image =  document.createElement('img');
                image.src = e.target.result;
                image.onload = function() {
                    var fdata = new FormData();
                    fdata.append("image", element.files[0], new_file_name);
                    fdata.append("type", element.name);

                    if (element.name == "icon" && (element.files[0].type != 'image/png' || image.width != 512 || image.height != 512)) {
                        alert('Image must be 512x512 .png');
                        return;
                    }
                    console.log(element.files[0]);
                    $resource($api.baseURL + '/Image/upload', {}, {
                        postWithFile: {
                            method: "POST",
                            params: fdata,
                            transformRequest: angular.identity,
                            headers: {'Content-Type': undefined}
                        }
                    }).postWithFile(fdata).$promise.then(function(response){
                        ctrl.form[element.name] = response.image;
                    }, function(error){
                        console.log(error);
                    });
                }
            }

            reader.readAsDataURL(element.files[0]);
        };

        var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_};

        ctrl.uniqueBusinessBookingURL = function () {
            var alias = ctrl.form.alias;
            if (alias == '') {
                var ID_prefix = MD5(Info.data.id).slice(28,32);
                alias = ID_prefix + Info.data.id;
            }
            return 'https://' + (window.location.hostname == 'app.tiffulit.co.il' ? '' : 'stage') + 'booking.tiffulit.co.il/' + alias;
        };

        ctrl.validateAlias = function() {
            var alias = ctrl.form.alias;
            var aliasPattern = /^[a-zA-Z0-9-_]{5,25}$/;
            
            clearTimeout(ctrl.aliasTimer);
            if (alias.length >= 5 && alias.length <= 25) {
                if (aliasPattern.test(alias)) {
                    ctrl.aliasStatus = 'pending';
                    ctrl.aliasTimer = setTimeout(function() {
                        ctrl.aliasStatus = 'loading';
                        $api.settings.online.isAliasTaken.save({alias: alias}, function(response) {
                            if (response.status === "success") {
                                ctrl.aliasStatus = 'success';
                            } else {
                                ctrl.aliasStatus = 'taken';
                            }
                        });
                    }, 1000);
                } else {
                    ctrl.aliasStatus = 'symbols';
                }
            } else {
                if (alias.length > 0) {
                    ctrl.aliasStatus = 'length';
                } else {
                    ctrl.aliasStatus = 'pending';
                }
            }
        };

        ctrl.onAliasChange = function() {
            ctrl.validateAlias();
        };

        ctrl.copyLink = function() {
            var url = ctrl.uniqueBusinessBookingURL();
            navigator.clipboard.writeText(url).then(function() {
                ctrl.copied = true;
                setTimeout(function() {
                    ctrl.copied = false;
                }, 3000);
            }).catch(function(error) {
                console.error('Failed to copy URL: ', error);
            });
        };

        ctrl.handleDisableCode = function() {
            if (ctrl.form.disable_confirmation_code == '1') {
                swal({
                    title: "",
                    html: $translate.instant('SWAL_SETTINGS_ONLINE_DISABLE_CODE_TEXT') + "<br />" + $translate.instant('SWAL_SETTINGS_ONLINE_DISABLE_CODE_QUESTION'),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                }).then(function(result) {
                    if (!result.value) {
                        ctrl.form.disable_confirmation_code = '0';
                    }
                });
            }
        };
    });
})();

(function () {

    angular.module('app.controllers')

        .controller('MessagesSettingsController', function ($api, $state, Messages, $rootScope, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.form = Messages.data;

            ctrl.msg_placeholders = {
                'customer_name' : "[the customer's name]",
                'item_name' : "[Item description]",
                'start_date' : "[date]",
                'start_time' : "[time]",
                'datetime' : "[datetime]",
                'businesses_name' : "[name of the business]",
                'order_id' : "[order ID]",
                'link' : "[link]",
                'week_day' : "[week day]",
                'resource' : "[resource]",
                "customer_name|he" : "[שם הלקוח]",
                "item_name|he" : "[שם המוצר]",
                "item_name|he2" : "[שם הטיפול]",
                "start_date|he" : "[תאריך]",
                "start_time|he" : "[שעה]",
                "businesses_name|he" : "[שם בית העסק]",
                "order_id|he" : "[סכום יתרה]",
                'link|he' : "[קישור]",
                'datetime|he' : "[תאריך ושעת השירות]",
                'week_day|he' : "[יום בשבוע]",
                'resource|he' : "[שם העובד]",
            };

            /**
             * Submit the data to the API and save neccessary information
             * @return {void}
             */
            ctrl.submit = function () {

                var validate = true;
                for (var key in ctrl.form) {
                    if (key != 'id' && key != 'b_id') {
                        const matches = ctrl.form[key].match(/\[(.*?)\]/g);
                        for (var i in matches) {
                            var check = false;
                            for (var j in ctrl.msg_placeholders) {
                                if (matches[i] == ctrl.msg_placeholders[j]) {
                                    check = true
                                }
                            }

                            validate = check ? validate : false;
                        }
                    }
                }

                if (!validate) {
                    swal({
                        title: "",
                        text: $translate.instant("SETTINGS_MESS_VALIDATE"),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 3000
                    });
                    return;
                }


                $api.settings.messages.save(ctrl.form, function (response) {
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_SETTINGS_MESSAGES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings", {}, { reload: true });
                    }
                });
            }
        });
})();

(function (){
    angular.module('app.controllers').controller('LaserFileSettingsController', function ($header, $business, $uibModal, $uibModalStack, $api, $state, $filter, dates, $scope, $business, Info, $translate, $rootScope, $resource){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;
        ctrl.laser_categories = $business.laser_categories;

        ctrl.category = 1;

        ctrl.form = Info.data;
        $scope.sortableOptions = { handle: '.drag-handle' };

        $scope.msg_channels = $business.getMsgChannels();
        $scope.getMsgChannelByIndex = $business.getMsgChannelByIndex;

        ctrl.submit = function(preventClose){
            $api.settings.laser_file.save({laser_file: ctrl.form}, function(response){
                if(response.status === "success"){
                    if (!preventClose) {
                        swal({
                            title: $translate.instant('SWAL_LF_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    
                        $state.transitionTo("app.settings", {}, {reload: true});
                    }

                    if (response.data) {
                        ctrl.form = response.data;
                    }
                }
            });
        };

        ctrl.setup_list = function (field) {
            $uibModal.open({
              templateUrl: "app/modules/settings/laser_file/list/laser_file.list.html",
              controller: "LaserFileListController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal small-modal",
              resolve: {
                Field: field,
              }
            }).result.then(function (val) {

                if (val) {
                    field.list = val;
                    ctrl.submit(true);
                }
              
            });
        }

        ctrl.new_field = function(field) {
            $uibModal.open({
                templateUrl: "app/modules/settings/laser_file/popup_field/laser_file.popup_field.html",
                controller: "LaserFilePopupFieldController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Field: field ? angular.copy(field) : null,
                  Category_id: ctrl.category
                }
            }).result.then(function (val) {
                ctrl.refresh_list();
            });
        }

        ctrl.change_category = function(id) {
            ctrl.category = id;
        }

        ctrl.refresh_list = function() {
            $api.settings.laser_file.get(function(response){
                if (response.data) {
                    ctrl.form = response.data;
                }
            });
        }
    });
})();

(function (){

    angular.module('app.controllers').controller('LandingSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        Info.data.landing_data = Info.data && Info.data.landing_data ? JSON.parse(Info.data.landing_data) : {};
        ctrl.form = Info.data.landing_data;
        ctrl.form.template = Info.data && Info.data.landing_data && Info.data.landing_data.template ? Info.data.landing_data.template : 1;
      
        ctrl.form.landing_alias = Info.data && Info.data.landing_alias ? Info.data.landing_alias : '';

        ctrl.aliasStatus = 'pending';
        ctrl.aliasTimer = null;
        ctrl.copied = false;

        ctrl.submit = function(publish){
            publish = publish || false;
            if (ctrl.aliasStatus == 'symbols' || ctrl.aliasStatus == 'taken' || ctrl.aliasStatus == 'length') {
                return;
            }

            var post_data = ctrl.form;
            post_data.publish = publish;
            $api.settings.landing.save(post_data, function(response){
                if(response.status === "success" && publish){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_LANDING_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                }
            });
        };
       
        var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_};

        ctrl.uniqueBusinessBookingURL = function () {
            var alias = ctrl.form.landing_alias;
            if (alias == '') {
                var ID_prefix = MD5(Info.data.id).slice(28,32);
                alias = ID_prefix + Info.data.id;
            }
            return 'https://' + (window.location.hostname == 'app.tiffulit.co.il' ? '' : 'stage') + 'landing.tiffulit.co.il/' + alias;
        };

        ctrl.editPage = function(){
            $api.settings.landing.edit_page.get(function(response) {
                if (response.status === "success") {
                    window.open(ctrl.uniqueBusinessBookingURL() + "/" + response.data, '_blank');
                }
            });
        };

        ctrl.validateAlias = function() {
            var alias = ctrl.form.landing_alias;
            var aliasPattern = /^[a-zA-Z0-9-_]{5,25}$/;
            
            clearTimeout(ctrl.aliasTimer);
            if (alias.length >= 5 && alias.length <= 25) {
                if (aliasPattern.test(alias)) {
                    ctrl.aliasStatus = 'pending';
                    ctrl.aliasTimer = setTimeout(function() {
                        ctrl.aliasStatus = 'loading';
                        $api.settings.landing.isAliasTaken.save({landing_alias: alias}, function(response) {
                            if (response.status === "success") {
                                ctrl.aliasStatus = 'success';
                            } else {
                                ctrl.aliasStatus = 'taken';
                            }
                        });
                    }, 1000);
                } else {
                    ctrl.aliasStatus = 'symbols';
                }
            } else {
                if (alias.length > 0) {
                    ctrl.aliasStatus = 'length';
                } else {
                    ctrl.aliasStatus = 'pending';
                }
            }
        };

        ctrl.onAliasChange = function() {
            ctrl.validateAlias();
        };

        ctrl.copyLink = function() {
            var url = ctrl.uniqueBusinessBookingURL();
            navigator.clipboard.writeText(url).then(function() {
                ctrl.copied = true;
                setTimeout(function() {
                    ctrl.copied = false;
                }, 3000);
            }).catch(function(error) {
                console.error('Failed to copy URL: ', error);
            });
        };

        ctrl.resetColors = function(){
            ctrl.form.bg2 = '#EEF3FC';
            ctrl.form.bg1 = '#F0F9FF';
            ctrl.form.text = '#2A313C';
            ctrl.form.sub = '#FCA8CF';
            ctrl.form.button = '#275A7B';
            ctrl.form.graph = '#FBE4EF';
        };
    });
})();

(function (){
    angular.module('app.controllers').controller('InfoSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        ctrl.form = JSON.parse(JSON.stringify(Info.data));
        ctrl.form.msg_channel_scheduling = String(ctrl.form.msg_channel_scheduling);
        ctrl.form.msg_channel_inv_link = String(ctrl.form.msg_channel_inv_link);
        ctrl.form.print_invoices = ctrl.form.print_invoices;
        ctrl.form.show_stock = ctrl.form.show_stock;
        ctrl.form.stop_saturday_messages = ctrl.form.stop_saturday_messages;
        ctrl.form.stop_saturday_messages_condition = ctrl.form.stop_saturday_messages_condition;
        ctrl.form.manage_employee = ctrl.form.manage_employee;
        ctrl.form.send_reminder = String(ctrl.form.send_reminder);
        ctrl.form.reminder_send_type = String(ctrl.form.reminder_send_type);
        ctrl.form.avatar = ctrl.form.image ? ctrl.form.image : 'assets/images/avatar.jpg';
        ctrl.form.logo = ctrl.form.logo ? ctrl.form.logo : 'assets/images/logo/business_logo_placeholder.png';
        ctrl.form.language_code = Info.data.language_code;
        ctrl.form.type = String(Info.data.type);
        ctrl.form.prepaid = Info.data.prepaid ? Info.data.prepaid*1 : '';
        ctrl.form.ave_calculation = Info.data.ave_calculation ? Info.data.ave_calculation+'' : '0';
        ctrl.form.stop_messages = ctrl.form.stop_messages;
        ctrl.form.show_notes = ctrl.form.show_notes;
        ctrl.form.show_notes_page = ctrl.form.show_notes_page;
        ctrl.form.show_digital_forms_page = ctrl.form.show_digital_forms_page;
        ctrl.form.manage_leads = ctrl.form.manage_leads;
        ctrl.form.default_screen = Info.data.default_screen;
        ctrl.form.credit_suplier = String(Info.data.credit_suplier);
        ctrl.form.request_order_confirmation = String(parseInt(Info.data.request_order_confirmation));
        ctrl.form.dd_df_channel = String(ctrl.form.dd_df_channel);
        ctrl.form.online_channel = String(ctrl.form.online_channel);
        ctrl.form.not_arrive_option = String(Info.data.not_arrive_option*1);
        ctrl.form.update_order_notification = String(Info.data.update_order_notification*1);
        ctrl.form.lead_appearence = String(Info.data.lead_appearence * 1);
        ctrl.form.display_wa_messages = Info.data.display_wa_messages;
        ctrl.form.display_order_user = Info.data.display_order_user;
        ctrl.form.display_one_block_services = Info.data.display_one_block_services;
        ctrl.form.display_hebrew_dates = Info.data.display_hebrew_dates;

        if(Info.data.processing_time != null){
            ctrl.form.processing_time = $filter("hourAndMinute")(Info.data.processing_time);
        }else{
            ctrl.form.processing_time = "00:00";
        }

        bu_type = parseInt(Info.data.type);
        if(bu_type == 1) {
            $scope.default_screens = ["Dashboard", "Calendar-Daily", "Calendar-Weekly"];
        } else if(bu_type == 2) {
            $scope.default_screens = ["Dashboard", "Calendar-Orders", "Calendar-Occupation"];
        }
        $scope.BU_Types = BU_Types.data;
        $scope.datesProvider = dates;
        $scope.msg_channels = $business.getMsgChannels();
        $scope.getMsgChannelByIndex = $business.getMsgChannelByIndex;

        ctrl.submit = function(){
            $api.settings.info.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_INFO_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                    $rootScope.changeLanguage(ctrl.form.language_code);
                    $rootScope.show_notes_page = ctrl.form.show_notes_page;
                    $rootScope.customer_wa_chat = ctrl.form.customer_wa_chat;
                    $rootScope.cashbox_discount = ctrl.form.cashbox_discount;
                    $rootScope.lead_appearence = ctrl.form.lead_appearence * 1;
                    $rootScope.display_order_user = ctrl.form.display_order_user;
                    $rootScope.display_one_block_services = ctrl.form.display_one_block_services;
                    $rootScope.display_hebrew_dates = ctrl.form.display_hebrew_dates;
                }
            });
        };

        ctrl.checkCustomerDefault = function(option) {
            swal({
                title: "",
                text: $translate.instant('NOTIFICATION_MOVE_TO_CUSTOMER_CONFIRM'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result.value) {
                    ctrl.form['move_'+option] = result.value;
                    $api.settings.mass_customers.save(ctrl.form, function(response){
                        if(response.status === "success"){
                            swal({
                                title: $translate.instant('SWAL_SETTINGS_INFO_SAVE_TITLE'),
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    });
                }
            });
        }

        ctrl.changeCustomerWaChat = function() {
            ctrl.form.customer_wa_chat = !ctrl.form.customer_wa_chat;
            swal({
                title: $translate.instant('NOTIFICATION_CHANGE_CUSTOMER_WA_CHAT'),
                input: 'password',
                inputPlaceholder: $translate.instant('SWAL_PASSWORD_PLACEHOLDER'),
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result.value) {
                    $api.auth.check_password.save({password: result.value}, function(response){
                        if (response && response.check) {
                            ctrl.form.customer_wa_chat = !ctrl.form.customer_wa_chat;
                        }
                    });
                }
            });
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name  == 'avatar' ? 'avatar' : 'logo';
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
            }, function(error){
                console.log(error);
            });
        };

        ctrl.telephonyLink = window.location.origin+'/api/telephony';
    });
})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("GoogleCalendarController", function($scope, $state, $api, $translate, $uibModal, $rootScope, GoogleCalendarAccounts, $header) {
        
        if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $header.breadcrumbs.push({
            "title": "GOOGLE_CALENDAR_SETTINGS"
        });

        var ctrl = this;
        
        ctrl.loading = false;
        ctrl.accounts = GoogleCalendarAccounts && GoogleCalendarAccounts.data ? GoogleCalendarAccounts.data : [];
        ctrl.apiError = false;
        
        /**
         * Connect new Google account
         */
        ctrl.connectNewAccount = function() {
            $uibModal.open({
                templateUrl: 'app/modules/settings/google_calendar/modules/connect-account/connect-account.modal.html',
                controller: 'ConnectAccountController as ctrl',
                windowClass: 'form-modal small-modal',
                resolve: {
                    Resources: function ($api) {
                        return $api.resolve("resources@get");
                    },
                    GoogleCalendarAccounts: function () {
                        return $api.resolve("googlecalendar@get");
                    }
                }
            }).result.then(function(account) {
                $api.googlecalendar.get(function(response) {
                    if (response.success) {
                        ctrl.accounts = response.data;
                    }
                });
            });
        };
        
        /**
         * Toggle account active status
         */
        ctrl.toggleAccountStatus = function(account) {
            ctrl.loading = true;
            
            $api.googlecalendar.active.save({
                id: account.id
            }, {
                is_active: account.is_active
            }, function(response) {
                ctrl.loading = false;
                if (response.status === 'success') {
                    swal({
                        title: $translate.instant('SUCCESS'),
                        text: $translate.instant('ACCOUNT_STATUS_UPDATED'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }
            }, function(error) {
                ctrl.loading = false;
                account.is_active = !account.is_active; // Revert the change
                
                // Handle JSON parsing errors (HTML responses)
                var errorMessage = $translate.instant('ACCOUNT_STATUS_UPDATE_ERROR');
                if (error && error.data && typeof error.data === 'string' && error.data.includes('<div')) {
                    errorMessage = $translate.instant('API_ENDPOINT_NOT_AVAILABLE');
                    ctrl.apiError = true;
                }
                
                swal({
                    title: $translate.instant('ERROR'),
                    text: errorMessage,
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };
        
        /**
         * Edit account resources
         */
        ctrl.editAccountResources = function(account) {
            $uibModal.open({
                templateUrl: 'app/modules/settings/google_calendar/modules/manage-resources/manage-resources.modal.html',
                controller: 'ManageResourcesController as ctrl',
                windowClass: 'form-modal small-modal',
                resolve: {
                    Account: function() {
                        return account;
                    },
                    Resources: function($api) {
                        return $api.resolve("resources@get");
                    },
                }
            }).result.then(function(updatedAccount) {
                $api.googlecalendar.get(function(response) {
                    if (response.success) {
                        ctrl.accounts = response.data;
                    }
                });
            });

        };
        
        
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('DocumentSettingsController', function ($api, $state, $scope, Settings, Language, $rootScope, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;
            ctrl.form = Settings.data;
            $scope.lang = Language;

            /**
             * Submit the data to the API and save neccessary information
             * @return {void}
             */
            ctrl.submit = function () {

                $api.settings.documents.save({
                    lang: Language
                }, ctrl.form, function (response) {
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DOCUMENTS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings", {}, { reload: true });
                    }
                });
            }
        });
})();

(function (){

    angular.module('app.controllers').controller('DigitalDocumentsSettingsController', function ($api, $state, DigitalDocuments, $scope, $rootScope, $resource, $translate) {

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;
        ctrl.form = {};

        ctrl.list = [];

        if (DigitalDocuments && DigitalDocuments.list) {
            for (var i in DigitalDocuments.list) {
                ctrl.list.push({id: DigitalDocuments.list[i].id, name: DigitalDocuments.list[i].name});
            }
        }
        
        ctrl.submit = function(){
            $api.settings.online.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_DD_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                }
            });
        };

        ctrl.removeFile = function(id) {
            event.preventDefault();
            $api.settings.digital_documents.single.delete({id: id}, function(response){
                if(response.status == "success"){
                    ctrl.list = ctrl.list.filter(function( obj ) {
                        return obj.id !== id;
                    });
                } else if (response.status == "failed"){
                    swal({
                        title: response.message,
                        type: "error",
                        timer: 3000
                    });
                }
            });
        }

        $scope.uploadFile = function(element){
            var fdata = new FormData();
            fdata.append("file", element.files[0]);

            $resource($api.baseURL + '/DigitalDocuments/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                if (response) {
                    if(response.status == "success"){
                        ctrl.list.push({id: response.id, name: response.fileName});
                    } else if (response.status == "failed"){
                        swal({
                            title: response.message,
                            type: "error",
                            timer: 3000
                        });
                    }
                }
            }, function(error){
                console.log(error);
            });
        };

    });
})();

(function () {
  angular.module('app.controllers')
    .controller('CustomFieldsSettingsController', function ($state, $header, $rootScope, $customFields, CustomFields) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({
        title: 'SETTINGS_CUSTOM_FIELDS'
      });

      var ctrl = this;
      ctrl.customFields = CustomFields ? CustomFields.data : [];
      for (var i = 0; i < ctrl.customFields.length; i++) {
        ctrl.customFields[i].name = $customFields.getCurrentName(ctrl.customFields[i].name);
      }
    });
})();

(function () {
  angular.module('app.controllers')
    .controller('CoursesFieldsSettingsController', function ($state, $header, $rootScope, CoursesFields) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({
        title: 'SETTINGS_COURSES_FIELDS'
      });

      var ctrl = this;
      ctrl.coursesFields = CoursesFields ? CoursesFields.data : [];
    });
})();

(function (){

    angular.module('app.controllers').controller('ColorSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        ctrl.form = Info.data;
        ctrl.form.interval = String(Info.data.interval);
        ctrl.form.holiday_color = ctrl.form.holiday_color ? ctrl.form.holiday_color : '#E77471';
        ctrl.form.back_color = ctrl.form.back_color ? ctrl.form.back_color : '#F2F6FF';
        ctrl.form.menu_color = ctrl.form.menu_color ? ctrl.form.menu_color : '#216089';
        ctrl.form.calendar_color = ctrl.form.calendar_color ? ctrl.form.calendar_color : '#f2f2f2';
        ctrl.form.switch_colors = ctrl.form.switch_colors ? ctrl.form.switch_colors : false;
        ctrl.form.calendar_stripe_color = ctrl.form.calendar_stripe_color ? ctrl.form.calendar_stripe_color : '#f7fafc';
        ctrl.form.calendar_event_color = ctrl.form.calendar_event_color ? ctrl.form.calendar_event_color : '#778899';
        ctrl.form.calendar_default = ctrl.form.calendar_default;

        $scope.datesProvider = dates;

        ctrl.submit = function(){
            $api.settings.info.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_COLOR_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                    $rootScope.changeLanguage(ctrl.form.language_code);
                    
                    $rootScope.color_form = ctrl.form;
                    $rootScope.submitColors();
                }
            });
        };

        ctrl.resetColors = function(){
            ctrl.form.back_color = '#F2F6FF';
            ctrl.form.menu_color = '#216089';
            ctrl.resetColorsCalendar();
        };

        ctrl.resetColorsCalendar = function(){
            ctrl.form.calendar_color = '#f2f2f2';
            ctrl.form.holiday_color = '#E77471';
        };
    });
})();

(function () {

    angular.module('app.controllers')

        .controller('AdditionalFieldsSettingsController', function ($state, $header, $rootScope, $customFields, CustomFields) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.breadcrumbs.push({
                "title": 'SETTINGS_ADDITIONAL_FIELDS'
            });
            
            var ctrl = this;
            ctrl.customFields = CustomFields ? CustomFields.data : [];
            for (var i = 0; i < ctrl.customFields.length; i++) {
                ctrl.customFields[i].name = $customFields.getCurrentName(ctrl.customFields[i].name);
            }
        });

})();

(function () {

    angular.module('app.controllers')

        .controller('TaxFilesReportsController', function ($state, $header, $scope, $api, $rootScope, $window) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.form = {
                from: '',
                to: '',
            }

            ctrl.submit = function () {
                $api.settings.tax_files.save(ctrl.form, function (response) {
                    ctrl.check();
                });
            }

            ctrl.check = function () {
                $api.settings.tax_files_check.save(ctrl.form, function (response) {

                    if (response.data && response.data.status && response.data.status == 2) {
                        if (response.data.zip_link) {
                            $scope.downloadFile(response.data.zip_link);
                        }
                    } else {
                        setTimeout(function() { ctrl.check(); }, 1000);
                    }
                });
            }

            $scope.downloadFile = function(link) {
                $window.open('/back-end/'+link, '_blank');
            };

        });
})();

(function () {
    angular.module('app.controllers')
        .controller('DebtRemindController', function ($window, $header, $api, $scope, $state, $rootScope, $uibModalInstance, $uibModal, $translate, customerData) {

            var ctrl = this;

            ctrl.customer = customerData;

            ctrl.form = {
                send_method: 1,
                message: $translate.instant('REMIND_DEBT_MSG') + ' ' + ctrl.customer.oncredit + '₪'
                    + '. ' + ctrl.customer.businesses_name,
            };

            if (customerData.send_notifications && customerData.send_notifications != 0) {
                ctrl.form.send_method = customerData.send_notifications;
            }

            /**
             * Send message to API
             */
            ctrl.sendReminder = function() {
                switch (parseInt(ctrl.form.send_method)) {
                    case 1:
                        ctrl._sendEmail();
                        break;
                    case 2:
                        ctrl._sendSMS();
                        break;
                    case 3:
                        ctrl._sendWhatsApp();
                        break;
                }
            }

            /**
             * Send SMS
             * @private
             */
            ctrl._sendSMS = function() {
                $api.sms.save({
                    message: ctrl.form.message,
                    phone: ctrl.customer.phone
                }, function(response){
                    ctrl._showSendingResult(response);
                });
            }

            /**
             * Send message through WhatsApp
             * @private
             */
            ctrl._sendWhatsApp = function() {
                $api.whatsapp.save({
                    message: ctrl.form.message,
                    phone: ctrl.customer.phone
                }, function(response){
                    ctrl._showSendingResult(response);
                });
            }

            /**
             * Send message through Email
             * @private
             */
            ctrl._sendEmail = function() {
                $api.mails.save({
                    subject: $translate.instant('REMIND_DEBT_EMAIL_SUBJ'),
                    message: ctrl.form.message,
                    email_address: ctrl.customer.email
                }, function(response){
                    ctrl._showSendingResult(response);
                });
            }

            /**
             * Notify user if message was sent successfully
             * @param response
             * @private
             */
            ctrl._showSendingResult = function(response) {
                if(response.status == "success" && !response.error) {
                    swal({
                        title: $translate.instant('REMIND_DEBT_MSG_SUCCESS'),
                        type: "success",
                        confirmButtonText: $translate.instant('SETTINGS_INFO_SEND'),
                        timer: 2000
                    }).then(function () {
                        $uibModalInstance.close();
                    });
                } else {
                    swal({
                        title: $translate.instant('REMIND_DEBT_MSG_ERROR'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SETTINGS_INFO_SEND'),
                        timer: 2000
                    }).then(function () {
                        $uibModalInstance.close();
                    });
                }
            }
        });
})();

(function () {
    angular.module('app.controllers')
        .controller('RecommendationsController', function ($header, Recommendations, $api, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $state, $rootScope, $translate, $timeout, $cookies) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.title = "MARKETING_RECOMMENDATIONS";
            $header.breadcrumbs.push({
                "title": "MARKETING_RECOMMENDATIONS"
            });

            var ctrl = this;

            ctrl.tableData = Recommendations.data;

            ctrl.send = function(id){
                $api.automations.recommendations.send.get({id: id}, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RECOMMENDATIONS_SEND_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                        });

                        $state.go($state.current, {}, {reload: true});
                    }
                });
            }

            ctrl.delete = function(id){
                swal({
                    title: "",
                    text: $translate.instant('SWAL_RECOMMENDATION_DELETE_CONFIRM_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value) {
                        $api.automations.recommendations.single.delete({id: id}, function(response){
                            if(response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_RECOMMENDATION_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                
                                $state.go($state.current, {}, {reload: true});
                            }
                        });
                    }
                });
            }



            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    .withOption('aaSorting', [])
                    .withOption('columnDefs', [
                        { targets: [-1, -2], orderable: false } // Disabling sorting for the last two columns
                    ])
                    .withOption('searching', false);

        });
})();

(function () {
    angular.module('app.controllers')
        .controller('AutomationsController', function ($header, Automations, $api, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $state, $rootScope, $translate, $timeout, $cookies) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.title = "MARKETING_AUTOMATIONS";
            $header.breadcrumbs.push({
                "title": "MARKETING_AUTOMATIONS"
            });

            var ctrl = this;

            ctrl.tableData = Automations.data;

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                .withLanguage(dataTablesHebrewProvider)
                .withOption('pageLength', 100)
                .withOption('aaSorting', [])
                .withOption('searching', false);

            ctrl.updateActive = function(row){
                $api.automations.activations.save({id: row.id}, {active: row.active}, function(response){
                    if(response.status != "success") {
                        row.active = !row.active;
                    }
                });
                
            }

        });
})();

(function(){
    angular.module('app.controllers').controller('CustomersBookingsController',
      function ($state, $header, $scope, $api, DTOptionsBuilder, $tiff_page, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log) {
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        $header.title = "NAV_CUSTOMERS_BOOKINGS";
        $header.breadcrumbs.push({
          "title": "NAV_CUSTOMERS_BOOKINGS"
        });

        $scope.activeTab = 'pending';

        ctrl.changeTab = function(tab) {
          $scope.activeTab = tab;
        };


        /**
         * Initiate DataTable Options
         */
        ctrl.initDtOptions = function(){
          $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', 20)
              //.withOption('order', [[1, 'desc']])
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('ajax', ctrl.loadCustomersBookings)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('rowCallback', ctrl.bookingRawCallback)
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.initDtOptionsWaitings = function(){
          $scope.dtOptionsWaitings =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', 20)
              //.withOption('order', [[1, 'desc']])
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('ajax', ctrl.loadCustomersBookings)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.search_value = "";
        ctrl.find_table = function() {
          if ($scope.activeTab == 'pending') {
            if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
              $('#cust_dt').DataTable().ajax.reload();
            }
          } else {
            if ($('#cust_dt_waitings').DataTable() && $('#cust_dt_waitings').DataTable().ajax) {
              $('#cust_dt_waitings').DataTable().ajax.reload();
            }
          }
        }

        ctrl.delete = function (wlistId) {
          swal({
            title: "",
            text: $translate.instant('SWAL_WAITING_LIST_DELETE_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if (result.value) {
              $api.customers_bookings.remove_waiting_list.get({list_id: wlistId}, function (response) {
                if (response.status == "success") {
                  swal({
                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                    text: "",
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });

                  ctrl.dtInstanceCustomers.reloadData(null, false);
                }
              });
            }
          });
        };

        /**
         * Load customers bookings
         *
         * @param data
         * @param callback
         * @param settings
         */
        ctrl.loadCustomersBookings = function (data, callback, settings) {
          var orderCol = '';
          var orderDir = '';

          if(data.order.length) {
            // Use only last order parameters
            var colIndex = data.order[data.order.length - 1].column
            var orderCol = data.columns[colIndex]['name'];
            var orderDir = data.order[data.order.length - 1].dir;
          }
          $tiff_page.start_loading('list');
          $api.customers_bookings[(($scope.activeTab == 'pending') ? 'list' : 'waiting_list')].get(
            {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.search_value}
            , function (result) {
              $tiff_page.stop_loading('list');
            if (result && result.data) {

              callback({
                recordsTotal: result.recordsTotal ? result.recordsTotal : 0,
                recordsFiltered: result.recordsFiltered ? result.recordsFiltered : 0,
                data: result.data,
                draw: data.draw + 1
              });
            }

          });
            
        };

        /**
         * Bind events to a new row
         *
         * @param nRow
         * @param aData
         * @param iDisplayIndex
         * @param iDisplayIndexFull
         * @returns {*}
         */
        ctrl.bookingRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $(nRow).find('td').not(".calendar-col").unbind('click');
          $(nRow).find('td').not(".calendar-col").bind('click', function() {
            $scope.$apply(function() {
              $state.go('app.calendar.order-edit', {id: aData.id});
            });
          });

          $(nRow).find('td.calendar-col').unbind('click');
          $(nRow).find('td.calendar-col').bind('click', function() {
            $scope.$apply(function() {
              $state.go('app.calendar.date', {date: moment(aData.order_date).format('YYYY-MM-DD HH:mm')});
            });
          });
          
          return nRow;
        }

        if (window.innerWidth < 768) {
          $.fn.DataTable.ext.pager.numbers_length = 3;
        }

        ctrl.initDtOptions();
        ctrl.initDtOptionsWaitings();

        /**
         * Bookings table column definitions
         * @type {*[]}
         */
        ctrl.dtColumns = [
          { name: 'name', data: 'customer_name', title: $translate('CUSTOMERS_NAME'), class: 'customer-name'},
          { name: 'order_date', data: null, title: $translate('BOOKING_DATE_TIME_TTL'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['order_date']).format('HH:mm DD/MM/YYYY');
            }
          },
          { name: 'name', data: 'customer_phone', title: $translate('CUSTOMERS_PHONE'), class: ''},
          { data: null, title: '', orderable: false, class: 'calendar-col',
            render: function(data, type, full, meta) {
              return '<i class="las la-eye"></i>';
            }
          },
        ];

        ctrl.dtColumnsWaitingList = [
          { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'customer-name',
            render: function (data, type, full, meta) {
              return data['name'] ? data['name'] : data['customer_name'];
            }
          },
          { name: 'phone', data: null, title: $translate('CUSTOMERS_PHONE'), class: '',
            render: function (data, type, full, meta) {
              return data['phone'] ? data['phone'] : data['customer_phone'];
            }
          },
          { name: 'item_name', data: 'item_name', title: $translate('BOOKING_ITEM'), class: ''},
          { name: 'resource_name', data: null, title: $translate('BOOKING_RESOURCE'), class: '',
            render: function (data, type, full, meta) {
              return data['resource_name'] ? data['resource_name'] : $translate.instant('BOOKING_RESOURCE_ANY');
            }
          },
          { name: 'from', data: null, title: $translate('BOOKING_WAITING_DATE'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['from']).format('DD/MM/YYYY');
            }
          },
          { name: 'from', data: null, title: $translate('BOOKING_DATE_TIME_FROM'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['from']).format('HH:mm');
            }
          },
          { name: 'to', data: null, title: $translate('BOOKING_DATE_TIME_TO'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['to']).format('HH:mm');
            }
          },
          {name: 'icons', sortable: false, data: null, title: '', class: 'customer-icons',
            render: function (data, type, full, meta) {
              var add_details = '';
              add_details += '<div class="customer-table-icons">';

              if (data.phone) {
                var phone = data.phone;
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                phone = '+972'+phone;

                add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
                add_details += '<a class="btn icon circle small bordered red" ng-click="ctrl.delete(' + data.id + ');"><i class="las la-trash"></i></a>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
        ];

        ctrl.dtInstanceCallback = function (dtInstance) {
          ctrl.dtInstanceCustomers = dtInstance;
        }

      });
})();

(function() {

    angular.module("app.controllers").controller("CustomersSelectController", function($scope, $state, $timeout, DTOptionsBuilder,
          dataTablesHebrewProvider, $rootScope, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.customers = [];
        ctrl.customer_name = "";

        var debounceTimeout = null;
        var currentRequest = null;

        $scope.find_customer = function() {
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }

            debounceTimeout = setTimeout(function() {
                if (currentRequest && currentRequest.abort) {
                    currentRequest.abort();
                }

                currentRequest = $api.customers.find.get(
                    { str: ctrl.customer_name },
                    function(response) {
                        if (response.str == ctrl.customer_name) {
                            ctrl.customers = response.data;
                        }
                    },
                    function(error) {
                    }
                );
            }, 100);
        };

        ctrl.selectCustomer = function(customer) {
            $uibModalInstance.close(customer);
        }

        $scope.find_customer();
    });

})();

(function () {
  angular.module("app.controllers").controller("CashboxUseCardFormController",
    function (Card, Item, $api, $scope, $state, $rootScope, $uibModalInstance, $translate, $log) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }
      var ctrl = this;
      ctrl.card = Card.data;
      ctrl.item = Item;

      ctrl.form = {
        card_balance_used: 0,
        item: ctrl.item,
        card: ctrl.card
      };

      if (ctrl.item.card_balance_used) {
        ctrl.form.card_balance_used = ctrl.item.card_balance_used;
      }

      /**
       * Use card
       */
      ctrl.saveForm = function () {
        $uibModalInstance.close(ctrl.form);
      }

      ctrl.close = function () {
        $uibModalInstance.close();
      }

    });
})();

(function () {

  angular.module('app.controllers')

    .controller('OrderFormController', ['Clubs', 'Info', 'Items', 'Resources', 'SecondResources', 'Customer', 'Order', 'CalendarEvent', 'EventCopy', 'CalendarCourse', 'CoursesFields', 'Messages',
        'dates', '$api', '$scope', '$state', '$rootScope', '$uibModal', '$uibModalStack', '$filter', '$translate', '$timeout' , '$log', '$tiff_page', '$window', '$resource', '$sce',
        function (Clubs, Info, Items, Resources, SecondResources, Customer, Order, CalendarEvent, EventCopy, CalendarCourse, CoursesFields, Messages, dates, $api, $scope, $state, $rootScope,
                  $uibModal, $uibModalStack, $filter, $translate, $timeout, $log, $tiff_page, $window, $resource, $sce) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {
          reload: true
        });
        return;
      }

      $scope.getTrustedHtml = function(item, badge, onTop) {
        var html = "<span tooltip='" + item + "' class='have-tooltip " + (onTop ? 'tooltip-top' : '') + " tooltip-wrap'>" + badge + item + "</span>";
        return $sce.trustAsHtml(html);
      };

      $scope.filterItems = function(orderItem) {
        return function(item) {
          return (
            orderItem.item_type === item.item_type && (!item.inactive || item.id === orderItem.item_id)
          );
        };
      };

      $scope.getItemPriority = function (item) {
        const status = ctrl.hasCustomerCardForItem(item.id); 
        if (status === true) return 0;
        if (status === 'expired') return 1;
        return 2;
      };
      
      var ctrl = this;

      ctrl.hide_prices = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices') ? true : false;
      ctrl.searchResult = [];

      ctrl.isMobile = (angular.element(document).width() < 769);
      ctrl.start_time = "00:00";

      ctrl.date = moment();

      ctrl.business = Info.data;

      ctrl.prepared_form = false;

      ctrl.is_prepaid = ctrl.business.prepaid && ctrl.business.prepaid*1 > 0;

      ctrl.bu_type = parseInt(Info.data.type);

      ctrl.dealer_type = Info.data.dealer_type;

      ctrl.courses_fields = CoursesFields && CoursesFields.data ? CoursesFields.data : [];

      ctrl.customer = null;
      ctrl.customer_search_name = "";
      ctrl.formItemsChangedNotSaved = false;

      ctrl.allow_sending = false;

      ctrl.notifications_type = 0;

      ctrl.dealer_vat = parseFloat(Info.data.vat);

      ctrl.is_edit = false;

      ctrl.order = null;

      ctrl.clubs = Clubs.data;

      ctrl.message_template = Messages.data;
      ctrl.holidays = {};
      ctrl.holidayName = "";

      ctrl.images_count = [1,2,3,4,5];

      ctrl.is_full_prepaid = false;

      // need for correct rendering list after adding new customer
      ctrl.showCustomerSelect = true;

      ctrl.allow_edit = false;

      ctrl.showMultiServiceDropdown = false;
      ctrl.multiServiceFilterText = '';
      ctrl.multiServiceSelectedItems = [];

      $scope.$watch("ctrl.form.date", function(newValue, oldValue, event) {
        ctrl.detectHolidays();

        if (document.activeElement) {
          //document.activeElement.blur();
        }
      });

      ctrl.detectHolidays = function() {
        
        var year = ctrl.form.date ? ctrl.form.date.format("YYYY") : ctrl.date.format("YYYY");

        if(!ctrl.holidays[year]) {
            $api.holidays.get({
                year: year
            }, function(response) {

                if(response.status == "success") {

                    ctrl.holidays[year] = response.data.holidays;

                    ctrl.setDetectedHoliday(ctrl.form.date);
                }
            });
        } else {
          ctrl.setDetectedHoliday(ctrl.form.date);
        }
      };

      ctrl.setDetectedHoliday = function(date) {
        ctrl.holidayName = ctrl.getHolidayName(date);
      };

      ctrl.getHolidayName = function(date) {
        if (!date || !date.format) {
          return "";
        }
        var
            fullDate = date.format("YYYY-MM-DD"),
            year = date.format("YYYY");

        if(ctrl.holidays[year]) {
            if(ctrl.holidays[year][fullDate]) {
                if (ctrl.holidays[year][fullDate][0] && ctrl.holidays[year][fullDate][0].name) {
                    return $filter('hebrewHolidayName')(ctrl.holidays[year][fullDate][0].name);
                }
            }
            else {
                for(var i in ctrl.holidays[year]) {
                  if(ctrl.holidays[year][i][0] != undefined) {
                    var startDate = moment(ctrl.holidays[year][i][0].date),
                      endDate = moment(ctrl.holidays[year][i][0].observed);

                    if (startDate.unix() <= date.unix() && date.unix() <= endDate.unix()) {
                      return $filter('hebrewHolidayName')(ctrl.holidays[year][i][0].name);
                    }
                  }
                }
            }
        }

        return "";
      };

      if (!Order) {
        if ($scope.new_order_date && typeof $scope.new_order_date.format === "function") {
          if (ctrl.bu_type == 1) {
            ctrl.start_time = $scope.new_order_date.format("HH:mm");
          } else {
            ctrl.start_time = $scope.new_order_date;
          }
          ctrl.date = $scope.new_order_date;
        }
        ctrl.approved_date = null;
      } else if (!EventCopy) {
        ctrl.is_edit = true;
        ctrl.order = Order.data;
        if ($scope.new_order_date && typeof $scope.new_order_date.format === "function") {
          ctrl.date = $scope.new_order_date;
        }
        ctrl.approved_date = ctrl.order && ctrl.order.approved_date != null ?
          moment(ctrl.order.approved_date).format("DD/MM/YYYY HH:mm"): null;
      }

      ctrl.form = {
        date: ctrl.date,
        randomCustomer: false,
        eventDescription: '',
        typeOfOrder: 0,
        item_id: '',
        courses_fields: {},
        items:
          [{
            start_time: ctrl.start_time,
            item_type: 'service'
          }],
        meetings: [
          {
            date: ctrl.date,
            start_time: ctrl.start_time,
          }
        ],
        customers_list: [],
      };

      if(CalendarEvent) {
        CalendarEvent.$promise.then(function (response) {
          ctrl.is_edit = true;
          ctrl.event = CalendarEvent.data[0];
          
          ctrl.form.repeat = ctrl.event.repeat;
          ctrl.form.period = ctrl.event.period;
          ctrl.form.endDate = moment(ctrl.event.repeat_end_date).format("YYYY-MM-DD");
          ctrl.date = moment(ctrl.event.start_date_time).format("DD/MM/YYYY HH:mm");
          ctrl.form.date = moment(ctrl.event.start_date_time);
          ctrl.form.event_description = ctrl.event.description;
          ctrl.form.items[0].start_time = moment(ctrl.event.start_date_time).format("HH:mm");
          ctrl.form.items[0].duration = String(moment.duration(moment(ctrl.event.end_date_time).diff(moment(ctrl.event.start_date_time))).asMinutes());
          ctrl.form.items[0].resource = String(ctrl.event.resource_id);
          ctrl.form.isEvent = true;
          ctrl.form.typeOfOrder = 1;
          $scope.selected_resource = String(ctrl.event.resource_id);
          if (ctrl.form.items[0].start_time == "00:00") {
            ctrl.form.all_day = true;  
          }
        });
      }

      if(CalendarCourse) {
        CalendarCourse.$promise.then(function (response) {

          ctrl.is_edit = true;
          ctrl.course = CalendarCourse.data;
          ctrl.date = moment(ctrl.course.start_date);
          ctrl.form.date = moment(ctrl.course.start_date);
          ctrl.form.item_id = String(ctrl.course.item_id);
          ctrl.form.item_data = ctrl.course.item_data;
          ctrl.form.meetings = [];
          ctrl.form.customers_list = [];

          if (ctrl.course.meetings) {
            for (var i in ctrl.course.meetings) {
              ctrl.form.meetings.push({
                name: ctrl.course.meetings[i].name,
                date: moment(ctrl.course.meetings[i].start_time).format("YYYY-MM-DD"),
                start_time: moment(ctrl.course.meetings[i].start_time).format("HH:mm"),
                resource: String(ctrl.course.meetings[i].resource_id),
                second_resource: String(ctrl.course.meetings[i].second_resource_id || ''),
                duration: String(moment.duration(moment(ctrl.course.meetings[i].end_time).diff(moment(ctrl.course.meetings[i].start_time))).asMinutes())
              });
            }
          }

          if (ctrl.course.customers) {
            for (var i in ctrl.course.customers) {
              ctrl.form.customers_list.push({
                id: ctrl.course.customers[i].customer_id,
                firstname: ctrl.course.customers[i].firstname,
                lastname: ctrl.course.customers[i].lastname,
                avatar: ctrl.course.customers[i].avatar
              });
            }
          }

          if (ctrl.course.courses_fields) {
            for (var i in ctrl.course.courses_fields) {
              ctrl.form.courses_fields[i] = String(ctrl.course.courses_fields[i]);
            }
          }

          ctrl.form.typeOfOrder = 2;
          ctrl.form.isCourse = true;
        });
      }
      

      $scope.showCancelBtn = ctrl.is_edit && ctrl.order && (([1, 3, 4, 7].indexOf(ctrl.order.status) === -1) || (ctrl.order.status == 3 && !ctrl.business.cashbox));
      ctrl.isOrderTransaction = true;


      if (ctrl.bu_type == 2) {
          ctrl.form.items[0].end_time = ctrl.start_time;
      }

      if ($scope.selected_resource) {
          ctrl.form.items[0].resource = String($scope.selected_resource);
          ctrl.form.meetings[0].resource = String($scope.selected_resource);
      }
      //Auto select resource if only one is available
      else if (Resources.data.length == 1) {
          ctrl.form.items[0].resource = Resources.data[0].id;
          ctrl.form.meetings[0].resource = Resources.data[0].id;
      } else {
        //Auto select resource if only one active is available
        var active = false
        var count_active = 0;
        for (var i in Resources.data) {
          
          if (Resources.data[i].status == 1) {
            count_active++;
            if (active === false && count_active == 1) {
              active = Resources.data[i].id;
            } else if (count_active > 1) {
              active = false;
            }
          }
        }
        
        if (active) {
          ctrl.form.items[0].resource = active;
          ctrl.form.meetings[0].resource = active;
        }
      }

      ctrl.items = Items.data;
      for (var i in ctrl.items) {
          ctrl.items[i].originalPrice = ctrl.items[i].price;
          ctrl.items[i].price = parseFloat(parseFloat(ctrl.items[i].price).toFixed(2));
          ctrl.items[i].quantity = 1;
      }
      ctrl.byType = 0;
      ctrl.setNightsType = function (type) {
          ctrl.byType = type;
      }
      $scope.userConfig = {
          create: true,
          //sortField: 'text'
      };

      ctrl.resources = Resources.data;
      ctrl.second_resources = SecondResources.data;

      var format = 'hh:mm:ss';
      var new_dates = [];

      for (var hour in dates.hours) {
        var time = moment(dates.hours[hour],format);          
        
        if (time.isBetween(moment(ctrl.business.min_time, format), moment(ctrl.business.max_time, format)) || 
            time.isSame(moment(ctrl.business.min_time, format)) ||
            time.isSame(moment(ctrl.business.max_time, format))) {
          new_dates.push(dates.hours[hour]);
        }
      }
      if (new_dates.length > 0) {
        dates.hours = new_dates;
      }
      ctrl.dates = dates;
      

      ctrl.random_customer_changed = function () {
        if (ctrl.form.randomCustomer) {
          ctrl.form.customer = {};
          ctrl.form.phone = "";
          ctrl.form.email = "";
          ctrl.form.customer_name = "";
          ctrl.customer_search_name = "";
          ctrl.allow_sending = true;
          ctrl.notifications_type = 2;
          ctrl.customerCards = null;
        }
      };

      ctrl.changeOrderType = function () {
        switch (ctrl.form.typeOfOrder) {
          case '0':
            ctrl.form.isEvent = false;
            ctrl.form.isCourse = false;
            break;
          case '1':
            ctrl.form.isEvent = true;
            ctrl.form.isCourse = false;
            break;
          case '2':
            ctrl.form.isEvent = false;
            ctrl.form.isCourse = true;
            break;
        }
      }

      /**
       * When selecting customer from list,
       * fill email and phone
       */

      ctrl.customer_selected = function () {
        ctrl.customer_search_name = '';
        if (ctrl.form.customer) {
          ctrl.customer_search_name += ctrl.form.customer.firstname;
          ctrl.customer_search_name +=  ctrl.form.customer.lastname ? ' ' + ctrl.form.customer.lastname : '';
          ctrl.customer_search_name +=  ctrl.form.customer.notes ? ' (' + ctrl.form.customer.notes + ')' : '';
        }

        var selected_customer = ctrl.form.customer;
        ctrl.customer = selected_customer;

        ctrl.allow_sending = ctrl.customer && ctrl.customer.send_notifications > 0;
        if (selected_customer) {
          ctrl.form.phone = selected_customer.phone || selected_customer.telephone; // mobile
          ctrl.form.email = selected_customer.email;
          ctrl.notifications_type = selected_customer.send_notifications;
          ctrl.loadCustomersCards(selected_customer.id);
        }

        if (ctrl.form.isCourse) {
          ctrl.add_customer_item();
        }
      }

      /**
       * search customer
       */
      $scope.find_customer = function() {
        ctrl.customer = null;
        ctrl.form.customer = null;

        $api.customers.find.get({str: ctrl.customer_search_name}, function(response){
          if (response.str == ctrl.customer_search_name) {
            ctrl.searchResult = response.data;
          }
        });
      }


      // Set value to search box
      $scope.chooseCustomer = function(index,$event){
        ctrl.form.customer = ctrl.searchResult[index];
        ctrl.customer_selected();
        ctrl.form.randomCustomer = 0;
        ctrl.searchResult = [];
        $event.stopPropagation();
      }

      $scope.searchboxClicked = function($event){
        $event.stopPropagation();
      }

      $scope.containerClicked = function(){
        ctrl.searchResult = [];
      }

      ctrl.cleanCustomerSearch = function() {
        if(angular.equals(ctrl.form.customer, {}) || typeof ctrl.form.customer === "undefined") {
          ctrl.customer_search_name = '';
        }
      }

      ctrl.get_customer_by_id = function (id) {
        var promise = $api.resolve("customers.single@get", {"id": id});
        promise.then(function(response){
          ctrl.form.customer = response.data;
          if(ctrl.form.customer) {
            ctrl.form.randomCustomer = false;
            ctrl.customer_selected();
          } else {
            ctrl.form.randomCustomer = true;
            ctrl.customer = null;
            ctrl.allow_sending = true;
            ctrl.notifications_type = 2;
          }
        });
      }

      if (Customer) {
        ctrl.get_customer_by_id(Customer.id);
      }

      ctrl.cancel_order = function (type) {
        $tiff_page.start_loading('cancel_order');
        var data = {
          id: ctrl.order.id,
          reason: ctrl.form.cancelReason,
          discardSms: ctrl.form.discardSms,
          all_repeatable: ctrl.form.all_repeatable ? ctrl.form.repeat_id : 0,
        }
        if(type == 'decline_booking') {
          data.type = 'decline_booking';
        }
        $api.orders.single.delete(data, function (response) {
          $tiff_page.stop_loading('cancel_order');
          $uibModalStack.dismissAll();
          if (response.status === "success") {
            swal({
              title: $translate.instant('SWAL_ORDERS_DELETE_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      };

      ctrl.decline_order = function() {
        ctrl.form.cancelReason = 'ביטול ע"י העסק';
        ctrl.cancel_order('decline_booking');
      }

      ctrl.deleteCourse = function() {
        swal({
          title: $translate.instant('SWAL_COURSE_DELETE_TITLE'),
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
        }).then(function(result) {
          if (result && result.value) {
            $api.courses.single.delete({
              id: ctrl.course.id
            }, function (response) {
              if (response.status === "success") {
                swal({
                  title: $translate.instant('SWAL_COURSE_DELETE_SUCCESS_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $uibModalStack.dismissAll();
              }
            });
          }
        });
      }

      ctrl.calculate_totals = function () {
        ctrl.form.total = 0;
        for (var i in ctrl.form.items) {
          if (ctrl.bu_type == 1 && ctrl.form.items[i].item && ctrl.form.items[i].item.price) {
            if(ctrl.form.items[i].item.item_type == 'service')
              ctrl.form.total += ctrl.form.items[i].item.price;
            else if(ctrl.form.items[i].item.item_type == 'sale')
              ctrl.form.total += ctrl.form.items[i].item.price * ctrl.form.items[i].item.quantity;
          } else if (ctrl.bu_type == 2 && ctrl.form.items[i].item ) {
            if(ctrl.form.items[i].item.item_type == 'service' && ctrl.form.items[i].nights > 0 )
              ctrl.form.total += ctrl.form.items[i].item.price * ctrl.form.items[i].nights;
            else if (ctrl.form.items[i].item.item_type == 'sale')
              ctrl.form.total += ctrl.form.items[i].item.price * ctrl.form.items[i].item.quantity;
          }
        }
        if (ctrl.dealer_type === "licensed") {
          ctrl.form.subtotal = (ctrl.form.total / (100 + ctrl.dealer_vat)) * 100;
          ctrl.form.subtotal = (Math.round(ctrl.form.subtotal * 100))/100;
          ctrl.form.tax = ctrl.form.total - ctrl.form.subtotal;
        }

        ctrl.is_full_prepaid = ctrl.order && ctrl.form && (ctrl.form.total == ctrl.order.prepaid);
      };
      ctrl.calculate_totals();

      ctrl.motels_update_item_nights = function (itemIndex) {
        var item = ctrl.form.items[itemIndex];
        if (ctrl.byType === 1) {
          if(item.item_type == 'service') {
            item.end_time = moment(item.start_time).add(item.nights, 'days');
          }
        } else {
          if(item.item_type == 'service') {
            if (item.start_time && item.end_time) {
              var duration;
              item.start_time = moment(item.start_time);
              item.end_time = moment(item.end_time);
              duration = moment.duration(item.end_time.diff(item.start_time));
              item.nights = Math.round(duration.asDays());
            } else {
              item.nights = null;
            }
            ctrl.calculate_totals();
          }
        }
      }

      ctrl.removeImage = function($event, key) {
        $event.stopPropagation();
        $event.preventDefault();
        ctrl.form[key] = '';
      }

      ctrl.showImage = function($event, image) {
        $event.stopPropagation();
        $event.preventDefault();
        swal({
            imageUrl: image,
            imageWidth: 800,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: $translate.instant('CALL_CANCEL'),
        })
      }

      ctrl.checkFirstWImage = function(key, k) {
        var w_image = false;
        for (var i in ctrl.images_count) {
          if ((!ctrl.form[key+ctrl.images_count[i]] || ctrl.form[key+ctrl.images_count[i]] == '') && !w_image) {  
            w_image = ctrl.images_count[i];
          }

          if (w_image == k) {
            return true;
          }
        }

        return false;
      }

      ctrl.changeStartTime = function($orderItemIndex) {
        if ($orderItemIndex == 0 && ctrl.form.items.length > 1) {
          for (var i = $orderItemIndex + 1; i < ctrl.form.items.length; i++) {
            ctrl.form.items[i].start_time = moment(ctrl.form.items[i-1].start_time, 'HH:mm').add(ctrl.form.items[i-1].duration, 'minutes').format('HH:mm');
          }
        }
      }

      ctrl.load_order_data = function () {
        var start_date, start_hour, start_minute, duration;
        var item = false;
        var joinedItems = [];
        if (Order.data) {
          for (var i in Order.data.items) {
            if (Order.data.items[i]['item_data'] && Order.data.items[i]['item_data']['item_type'] != 'sale' && !item) {
              item = Order.data.items[i];
            }

            if (!Order.data.items[i].part) {
              joinedItems.push(Order.data.items[i]);
              ctrl.multiServiceSelectedItems.push(Order.data.items[i].item_id.toString());
            }
          }
        }

        ctrl.form = {
          customer: null,
          notes: Order.data.notes,
          phone: Order.data.phone,
          email: Order.data.email,
          image_before1: Order.data.image_before1,
          image_before2: Order.data.image_before2,
          image_before3: Order.data.image_before3,
          image_before4: Order.data.image_before4,
          image_before5: Order.data.image_before5,
          image_after1: Order.data.image_after1,
          image_after2: Order.data.image_after2,
          image_after3: Order.data.image_after3,
          image_after4: Order.data.image_after4,
          image_after5: Order.data.image_after5,
          approval_sent: Order.data.approval_sent,
          request_feedback: Order.data.request_feedback,
          date: moment(item.start_time),
          items: joinedItems//Order.data.items
        };
        if(Order.data.id && Order.data.customer) {
          if (Order.data.customer_data && Order.data.customer_data.id == Order.data.customer) {
            ctrl.form.customer = Order.data.customer_data;
            if(ctrl.form.customer) {
              ctrl.form.randomCustomer = false;
              ctrl.customer_selected();
            } else {
              ctrl.form.randomCustomer = true;
              ctrl.customer = null;
              ctrl.allow_sending = true;
              ctrl.notifications_type = 2;
            }
          } else {
            ctrl.get_customer_by_id(Order.data.customer);
          }
        } else {
          ctrl.form.randomCustomer = true;
          ctrl.customer = null;
          ctrl.customer_search_name = "";
          ctrl.allow_sending = true;
          ctrl.notifications_type = 2;
          if(Order.data.customer_name && Order.data.customer_name !="") {
            ctrl.form.customer_name = ctrl.customer_search_name = Order.data.customer_name;
          }
        }


        // if (!ctrl.form.customer) {
        //   ctrl.form.randomCustomer = true;
        //   ctrl.customer = null;
        //   ctrl.allow_sending = true;
        //   ctrl.notifications_type = 2;
        // } else {
        //   ctrl.customer_selected();
        // }

        for (var i in ctrl.form.items) {
          ctrl.form.items[i].item_id = String(ctrl.form.items[i].item_id);
          ctrl.form.items[i].resource = String(ctrl.form.items[i].resource_id);

          for (var j in Order.data.items) {
            if (ctrl.form.items[i].id == Order.data.items[j].part) {
              ctrl.form.items[i].enabled_second = true;
              ctrl.form.items[i].resource_second = Order.data.items[j].resource_id;
              ctrl.form.items[i].duration_second = Order.data.items[j].duration;
              ctrl.form.items[i].start_time_second = Order.data.items[j].start_time;
              ctrl.form.items[i].end_time_second = Order.data.items[j].end_time;
            }
          }

          if (ctrl.bu_type == 1 && ctrl.form.items[i].item_data.item_type == 'service') {
            var start_date_time = moment(ctrl.form.items[i].start_time);
            var end_date_time = moment(ctrl.form.items[i].end_time);
            ctrl.form.items[i].start_time = moment(start_date_time).format('HH:mm');
            ctrl.form.items[i].duration = String(moment.duration(end_date_time.diff(start_date_time)).asMinutes());
            if(ctrl.form.items[i].duration < 10)
              ctrl.form.items[i].duration = "0" + ctrl.form.items[i].duration;
            
            if (ctrl.form.items[i].enabled_second) {
              var start_date_time_second = moment(ctrl.form.items[i].start_time_second);
              var end_date_time_second = moment(ctrl.form.items[i].end_time_second);
              ctrl.form.items[i].start_time_second = moment(start_date_time_second).format('HH:mm');
              ctrl.form.items[i].duration_second = String(moment.duration(end_date_time_second.diff(start_date_time_second)).asMinutes());
              if(ctrl.form.items[i].duration_second < 10)
                ctrl.form.items[i].duration_second = "0" + ctrl.form.items[i].duration_second;
            }
          } else if (ctrl.bu_type == 2 && ctrl.form.items[i].item_data.item_type == 'service') {

            if (!ctrl.form.items[i].adults) {
              ctrl.form.items[i].adults = 0;
            }

            if (!ctrl.form.items[i].kids) {
              ctrl.form.items[i].kids = 0;
            }

            if (!ctrl.form.items[i].babies) {
              ctrl.form.items[i].babies = 0;
            }

            ctrl.motels_update_item_nights(i);
          }
          ctrl.saveOriginalItemsData(i);
          ctrl.calculate_totals();

          if (ctrl.form.items[i].item_data) {
            if (!ctrl.form.items[i].item)
              ctrl.form.items[i].item = {};
            ctrl.form.items[i].item.price = ctrl.form.items[i].item_data.price*1;
            ctrl.form.items[i].item_type = ctrl.form.items[i].item_data.item_type;
            if(ctrl.form.items[i].item_data.item_type != 'service') {
              ctrl.form.items[i].item.quantity = ctrl.form.items[i].item_data.quantity;
            }
          }
        }
        if(Order.data.id) {
          ctrl.originalFormItemsData = angular.copy(ctrl.form.items);
        }
        
        ctrl.form.repeat_id = (Order.data.repeat_id ? Order.data.repeat_id : null);
      };

      ctrl.approveArrival = function() {
        if (!Order.data || !Order.data.id) return;

        $api.orders.approval.save({
            id: Order.data.id
        }, {}, function (response) {
            ctrl.form.approval_sent = 2;
        });
      };


      $scope.uploadImage = function(element){
        var new_file_name = element.name;
        new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

        var fdata = new FormData();
        fdata.append("image", element.files[0], new_file_name);
        fdata.append("type", element.name);
        $tiff_page.start_loading('save_image');
        
        $resource($api.baseURL + '/Image/upload', {}, {
            postWithFile: {
                method: "POST",
                params: fdata,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            }
        }).postWithFile(fdata).$promise.then(function(response){
            ctrl.form[element.name] = response.image;
            $tiff_page.stop_loading('save_image');
        }, function(error){
            $tiff_page.stop_loading('save_image');
            console.log(error);
        });
      };

      /**
       * Save order to API
       *
       * @param callBack
       */
      ctrl.send_order_form = function (callBack) {

        if(ctrl.form.isEvent) {
            ctrl.save_event();
            return;
        }

        if(ctrl.form.isCourse) {
          ctrl.save_course();
          return;
        }

        if (ctrl.bu_type == 2) {
          for (var i in ctrl.form.items) {
            if(ctrl.form.items[i].item_type == 'service'){
              ctrl.form.items[i].start_time = ctrl.form.items[i].start_time.year() + "-" + (ctrl.form.items[i].start_time.month() + 1) + "-" + ctrl.form.items[i].start_time.date();
              ctrl.form.items[i].end_time = ctrl.form.items[i].end_time.year() + "-" + (ctrl.form.items[i].end_time.month() + 1) + "-" + ctrl.form.items[i].end_time.date();
            }
          }
        }

        var original_start = false;
        var modified_start = false;

        for (var j in ctrl.originalFormItemsData) {
          if (ctrl.originalFormItemsData[j].start_time) {
            var start_moment = moment(ctrl.originalFormItemsData[j].start_time, 'HH:mm');
            if (!original_start || start_moment.isBefore(original_start)) {
              original_start = start_moment;
            }
          }
        }

        
        for (var i in ctrl.form.items) {
          if (ctrl.form.items[i].start_time) {
            var start_moment = moment(ctrl.form.items[i].start_time, 'HH:mm');
            if (!modified_start || start_moment.isBefore(modified_start)) {
              modified_start = start_moment;
            }
          }

          if (!ctrl.form.items[i].item.price) {
            //when price empty force to zero
            ctrl.form.items[i].item.price = 0;            
            /*
              swal({
                title: "שגיאה",
                type: "error",
                text: $translate.instant('ORDER_ITEMS_EMPTY_PRICE'),
                confirmButtonText: "אישור",
              });
              return;
            */
          }
        }

        var changed_items_time = (!original_start || !modified_start || (original_start && modified_start && original_start.format('HH:mm') != modified_start.format('HH:mm')));

        var order_data = JSON.parse(JSON.stringify(ctrl.form));
        
        order_data.date = moment(ctrl.form.date).format("YYYY-MM-DD HH:mm");
        if( typeof(order_data.customer) == "object" && order_data.customer !== null) {
          order_data.customer = order_data.customer.id;
          order_data.allow_sending = ctrl.allow_sending;
        }
        if(ctrl.order && ctrl.order.status == 4) {
          order_data.status = 0;
          order_data.booking_approved = true;
        }

        $tiff_page.start_loading('save_order');
        if (ctrl.is_edit) {
          if (Info.data.update_order_notification == 2 && changed_items_time) {
            swal({
                text: $translate.instant('CALENDAR_UPDATE_ORDER_NOTIFICATION'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: $translate.instant('OPTION_YES'),
                cancelButtonText: $translate.instant('OPTION_NO')
            }).then(function(result) {
              order_data.send_notification = result.value ? 1 : 0;
              $api.orders.single.save({
                "id": ctrl.order.id
              }, order_data, function (response) {
                $tiff_page.stop_loading('save_order');
                if (response.status === "success") {
                  if(angular.isUndefined(callBack)) {
                    $uibModalStack.dismissAll();
                  }
                  if(!ctrl.formItemsChangedNotSaved) {
                    swal({
                      title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                      type: "success",
                      confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                      timer: 2000
                    });
                  } else {
                    ctrl.formItemsChangedNotSaved = false;
                    if (callBack) {
                      callBack(function () {
                        $uibModalStack.dismissAll();
                      });
                    }
                  }
                }
              });
            });
          } else {
            $api.orders.single.save({
              "id": ctrl.order.id
            }, order_data, function (response) {
              $tiff_page.stop_loading('save_order');
              if (response.status === "success") {
                if(angular.isUndefined(callBack)) {
                  $uibModalStack.dismissAll();
                }
                if(!ctrl.formItemsChangedNotSaved) {
                  swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                } else {
                  ctrl.formItemsChangedNotSaved = false;
                  if (callBack) {
                    callBack(function () {
                      $uibModalStack.dismissAll();
                    });
                  }
                }
              }
            });
          }
          
        } else {
          $api.orders.save(order_data, function (response) {
            $tiff_page.stop_loading('save_order');
            if (response.status === "success") {
              ctrl.savePreparedDF(response.id);
              $uibModalStack.dismissAll();
              swal({
                title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              if(callBack){
                callBack();
              }
            } else {
              if (response.overlap) {
                swal({
                    title: "",
                    text: $translate.instant('CALENDAR_ORDER_REPEAT_OVERLAP'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('CALENDAR_ORDER_REPEAT_OVERLAP_YES'),
                    cancelButtonText: $translate.instant('CALENDAR_ORDER_REPEAT_OVERLAP_NO'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value) {
                      $tiff_page.start_loading('save_order');
                      order_data['confirm_repeat'] = true;
                      $api.orders.save(order_data, function (response) {
                        $tiff_page.stop_loading('save_order');
                        if (response.status === "success") {
                          ctrl.savePreparedDF(response.id);
                          $uibModalStack.dismissAll();
                          swal({
                            title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                          });
                          if(callBack){
                            callBack();
                          }
                        }
                      });
                    }
                });
              } else if (response.overlap == 0) {
                $tiff_page.start_loading('save_order');
                order_data['confirm_repeat'] = true;
                $api.orders.save(order_data, function (response) {
                  $tiff_page.stop_loading('save_order');
                  if (response.status === "success") {
                    $uibModalStack.dismissAll();
                    swal({
                      title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                      type: "success",
                      confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                      timer: 2000
                    });
                    if(callBack){
                      callBack();
                    }
                  }
                });
              }
            }
          });
        }
      };

      ctrl.save_event = function() {
          var event_data = JSON.parse(JSON.stringify(ctrl.form));
          var start_time = (ctrl.form.all_day ? "00:00" : ctrl.form.items[0].start_time).split(':');
          var start_date_time =  moment(ctrl.form.date).hours(start_time[0]).minutes(start_time[1]);
          event_data.end_date =  moment(ctrl.form.endDate).format("YYYY-MM-DD HH:mm");
          event_data.start_date_time = start_date_time.format("YYYY-MM-DD HH:mm");
          event_data.end_date_time = start_date_time
              .add((ctrl.form.all_day ? 60*24 : ctrl.form.items[0].duration),'minutes').format("YYYY-MM-DD HH:mm");
          event_data.resource_id = ctrl.form.items[0].resource;
          event_data.description = ctrl.form.event_description;
          if (ctrl.is_edit) {
            if (event_data.repeat) {
              swal({
                  title: "",
                  text: $translate.instant('ORDER_EVENT_EDIT_CONFIRMATION'),
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('ORDER_EVENT_EDIT_CONFIRMATION_ALL'),
                  cancelButtonText: $translate.instant('ORDER_EVENT_EDIT_CONFIRMATION_CURRENT'),
                  confirmButtonClass: "btn-primary",
                  cancelButtonClass: "btn-primary",
                  closeOnConfirm: false,
                  showLoaderOnConfirm: false
              }).then(function(result) {
                if (result.dismiss && result.dismiss == "overlay") {
                  return;
                }
                event_data.all_events = result.value ? true : false;
                ctrl.edit_event(event_data);
              });
            } else {
              ctrl.edit_event(event_data);
            }

          } else {
              $tiff_page.start_loading('save_event');
              $api.events.save(event_data, function (response) {
                  $tiff_page.stop_loading('save_event');
                  $uibModalStack.dismissAll();
                  if (response.status === "success") {
                    swal({
                      title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                      type: "success",
                      confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                      timer: 2000
                    });
                  } else {
                    swal({
                      title: $translate.instant('SWAL_ORDERS_ERROR_TITLE'),
                      type: "error",
                      confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                      timer: 2000
                    });
                  }
              });
          }
      }

      ctrl.save_course = function() {
        var data = JSON.parse(JSON.stringify(ctrl.form));
        if (ctrl.is_edit) {
          ctrl.edit_course(data);
        } else {
            $tiff_page.start_loading('save_course');
            $api.courses.save(data, function (response) {
                $tiff_page.stop_loading('save_course');
                $uibModalStack.dismissAll();
                if (response.status === "success") {
                  swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                } else {
                  swal({
                    title: $translate.instant('SWAL_ORDERS_ERROR_TITLE'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                }
            });
        }
    }

      ctrl.edit_event = function(event_data) {
        $tiff_page.start_loading('save_event');
        $api.events.single.save({
            "id": ctrl.event.id
        }, event_data, function (response) {
            $tiff_page.stop_loading('save_event');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.edit_course = function(data) {
        $tiff_page.start_loading('save_course');
        $api.courses.single.save({
            "id": ctrl.course.id
        }, data, function (response) {
            $tiff_page.stop_loading('save_course');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.remove_item_from_order = function ($orderItemIndex) {
        ctrl.form.items.splice($orderItemIndex, 1);
        ctrl.multiServiceSelectedItems.splice($orderItemIndex, 1);
        ctrl.calculate_totals();
      };

      ctrl.completeOrder = function (orderId, directly) {
          if (!directly) {
            if (ctrl.business.cashbox) {
                swal({
                    title: '',
                    text: $translate.instant('ORDER_CLOSE__WITHOUT_PAYMENT_ALERT_TTL'),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('OPTION_YES'),
                    cancelButtonText: $translate.instant('OPTION_NO'),
                }).then(function (res) {
                    if (res.value) {
                        ctrl._postCompletedOrder(orderId, true);
                    }
                });
            } else {
                ctrl._postCompletedOrder(orderId);
            }
          } else {
            ctrl._postPaidOrder(orderId);
          }
      };

      ctrl.request_review = function (customer_id, type) {
        swal({
            title: '',
            text: $translate.instant('CONFIRM_REVIEW_REQUEST'),
            type: "warning",
            showCancelButton: true,
            confirmButtonText: $translate.instant('OPTION_YES'),
            cancelButtonText: $translate.instant('OPTION_NO'),
        }).then(function (res) {
            if (res.value) {
                ctrl.sendReviewRequest(customer_id, type);
            }
        });
      };
      
      /**
       *
       * @param orderId
       * @param completeWithoutPayment Parameter define whether order could be completed without payment even though business has cashbox
       * @private
       */
      ctrl._postCompletedOrder = function (orderId, completeWithoutPayment) {
          $tiff_page.start_loading('complete_order');
          $api.transactions.save({
                  items: ctrl.form.items,
                  customer: ctrl.form.customer,
                  email: ctrl.form.email,
                  phone: ctrl.form.phone,
                  request_feedback: ctrl.form.request_feedback,
                  isOrderTransaction: ctrl.isOrderTransaction,
                  order_id: orderId,
                  completeWithoutPayment: completeWithoutPayment ? true : undefined,
              },
              function (response) {
                  $tiff_page.stop_loading('complete_order');
                  if (response.status == "success") {
                      swal({
                          title: $translate.instant('SWAL_ORDERS_TRANSACTION_SAVE_SUCCESS_TITLE'),
                          text: "",
                          type: "success",
                          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                          timer: 2000
                      }).then(function(){
                          $uibModalStack.dismissAll();
                      });
                  }
              });
      }

      ctrl._postPaidOrder = function (orderId) {
        $tiff_page.start_loading('complete_order');
        $api.transactions.save({
                mark_paid: true,
                order_id: orderId,
            },
            function (response) {
                $tiff_page.stop_loading('complete_order');
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_ORDERS_TRANSACTION_SAVE_SUCCESS_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    }).then(function(){
                        $uibModalStack.dismissAll();
                    });
                }
            });
    }

       /**
       *
       * @param type Social network type
       */
      ctrl.sendReviewRequest = function (customer_id, type) {
        $tiff_page.start_loading('request_review');
        $api.customers.request_review.get({
                id: customer_id,
                type: type,
            },
            function (response) {
                $tiff_page.stop_loading('request_review');
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('REVIEW_REQUEST_SUCCESS_SENT'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    }).then(function(){
                      $uibModalStack.dismissAll();
                    });
                }
            });
      }

      ctrl.add_service_item = function () {
        var duration_splitted_to_fives, start_time_hour_index = null,
          next_item_start_time = null;

        if (ctrl.form.items[ctrl.form.items.length - 1].item && ctrl.form.items[ctrl.form.items.length - 1].duration) {

          duration_splitted_to_fives = ctrl.form.items[ctrl.form.items.length - 1].enabled_second ? parseInt(ctrl.form.items[ctrl.form.items.length - 1].duration_second / 5) : parseInt(ctrl.form.items[ctrl.form.items.length - 1].duration / 5);

          for (var i in dates.hours) {
            if (ctrl.form.items[ctrl.form.items.length - 1].enabled_second) {
              if (dates.hours[i] == ctrl.form.items[ctrl.form.items.length - 1].start_time_second) {
                start_time_hour_index = parseInt(i);
              }
            } else if (dates.hours[i] == ctrl.form.items[ctrl.form.items.length - 1].start_time) {
              start_time_hour_index = parseInt(i);
            }
          }

          next_item_start_time = start_time_hour_index + duration_splitted_to_fives;
          if (next_item_start_time >= dates.hours.length) {
            next_item_start_time = next_item_start_time - dates.hours.length;
          }

          var start_time = dates.hours[next_item_start_time];
          if (ctrl.bu_type == 2) {
            start_time = ctrl.form.items[0].start_time;
          }
        } else {
          start_time = ctrl.form.items[0].start_time;
        }

        //Auto select resource if only one is available
        if(ctrl.resources.length == 1) {
            $scope.selected_resource = ctrl.resources[0].id;
        }

        ctrl.form.items.push({
          item_type: 'service',
          start_time: start_time,
          resource: $scope.selected_resource ? String($scope.selected_resource) : ("")
        });

        if (ctrl.bu_type == 2) {
          ctrl.form.items[ctrl.form.items.length - 1].end_time = ctrl.form.items[0].end_time;
        }
      };

      ctrl.add_sales_item = function () {
        ctrl.form.items.push({
          item_type: 'sale',
          quantity: 1
        });
      };

      ctrl.add_meeting_item = function () {
        if(ctrl.resources.length == 1) {
          $scope.selected_resource = ctrl.resources[0].id;
        }

        ctrl.form.meetings.push({
          date: ctrl.date,
          start_time: ctrl.form.meetings[0] ? ctrl.form.meetings[0].start_time : ctrl.start_time,
          resource: $scope.selected_resource ? String($scope.selected_resource) : (""),
          second_resource: "",
        });
      }

      ctrl.remove_meeting_item = function (index) {
        ctrl.form.meetings.splice(index, 1);
      }

      ctrl.add_customer_item = function () {
        if (ctrl.form.customer) {
          ctrl.form.customers_list.push(angular.copy(ctrl.form.customer));
          delete ctrl.form.customer
          delete ctrl.customer
          ctrl.customer_search_name = ""
        }
      }

      ctrl.remove_customer_item = function (index) {
        ctrl.form.customers_list.splice(index, 1);
      }

      ctrl.check_existed_customer = function (id) {
        for (var i in ctrl.form.customers_list) {
          if (ctrl.form.customers_list[i].id == id) {
            return true;
          }
        }

        return false;
      }

      ctrl.show_laser_file = function () {
        if (ctrl.form.customer) {
          $uibModal.open({
            templateUrl: "app/modules/settings/laser_file/popup/laser_file.popup.html",
            controller: "LaserFileController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal laser-file-modal",
            resolve: {
              Info: ['$api', function ($api) {
                return $api.resolve("settings.laser_file@get");
              }],
              Data: ['$api', function ($api) {
                return $api.resolve("laser_file@get", {"customer_id": ctrl.form.customer.id});
              }],
              Customer: ctrl.form.customer,
              Order: ctrl.order,
            }
          }).result.then(function () {
            
          });
        }
      }
      
      ctrl.add_form = function() {
        if (ctrl.form.customer) {
          if (ctrl.order && ctrl.order.digital_form && ctrl.order.digital_form.length) {
            $uibModal.open({
              templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
              controller: "CustomersDigitalFormsController",
              controllerAs: "ctrl",
              scope: $scope,
              mediumModal: true,
              windowTopClass: "form-modal medium-modal laser-file-modal",
              resolve: {
                Customer: ['$api', function ($api) {
                    return $api.resolve('customers.single@get', { id: ctrl.form.customer.id });
                  }
                ],
                DigitalForm: null,
                DigitalForms: ['$api', function($api) {
                    return ctrl.order.digital_form;
                  }
                ],
                Business: [ '$api', function ($api) {
                    return $api.resolve('settings.info@get');
                  }
                ],
                Order: ctrl.order
              }
            }).result.then(function (response) {
              if (response) {
                ctrl.order.digital_form = response;
              }
            });
          } else {
            $uibModal.open({
                templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                controller: "CustomersDigitalFormsAddController",
                controllerAs: "ctrl",
                scope: $scope,
                mediumModal: true,
                windowTopClass: "form-modal medium-modal laser-file-modal",
                resolve: {
                  Customer: {data: ctrl.form.customer},
                  Order: ctrl.order,
                  OrderForm: true,
                  DigitalForm: ctrl.prepared_form ? ctrl.prepared_form : null,
                  DigitalForms: ['$api', function($api) {
                    return $api.resolve("digital_forms@get");
                  }]
                }
              }).result.then(function (result) {
                if (result && result.form_data) {
                  ctrl.order.digital_form = result.form_data;
                } else if (result) {
                  ctrl.prepared_form = result;
                }
              });
          }
        }
      }

      ctrl.savePreparedDF = function (order_id) {
        if (ctrl.prepared_form) {
          ctrl.prepared_form.order_id = order_id;
          ctrl.prepared_form.customer_id = ctrl.form.customer && ctrl.form.customer.id ? ctrl.form.customer.id : null;
          $api.customer_forms.new.save({
              id: ctrl.prepared_form.id,
              data: ctrl.prepared_form,
          }, function (response) {
              if (response.status === "success") {
              }
          });
        }

        ctrl.prepared_form = false;
      }

      ctrl.enable_second_change = function ($orderItemIndex) {
        if (ctrl.form.items[$orderItemIndex].enabled_second) {
          
          if (ctrl.form.items[$orderItemIndex].item.break) {
            ctrl.form.items[$orderItemIndex].resource_second = ctrl.form.items[$orderItemIndex].resource;
            if(ctrl.form.items[$orderItemIndex].item.duration_second && ctrl.form.items[$orderItemIndex].item.duration_second != '-1') {
              ctrl.form.items[$orderItemIndex].duration_second = String(ctrl.form.items[$orderItemIndex].item.duration_second);
            } else {
              ctrl.form.items[$orderItemIndex].duration_second = undefined;
            }
            
            var newDateObj = new Date('01/01/2023 '+ctrl.form.items[$orderItemIndex].start_time);
            var date = new Date(newDateObj.getTime() + (ctrl.form.items[$orderItemIndex].item.break+(ctrl.form.items[$orderItemIndex].duration*1))*60000);
            ctrl.form.items[$orderItemIndex].start_time_second = date.getHours() + ':' + date.getMinutes();
          }
        }
      };

      ctrl.order_item_resource_change = function ($orderItemIndex) {
        ctrl.saveOriginalItemsData($orderItemIndex);
        ctrl.multiServiceSelectedItems[$orderItemIndex] = ctrl.form.items[$orderItemIndex].item_id;
        ctrl.form.items[$orderItemIndex].enabled_second = false;
        if(ctrl.form.items[$orderItemIndex].item.duration && ctrl.form.items[$orderItemIndex].item.duration != '-1') {
          ctrl.form.items[$orderItemIndex].duration = String(ctrl.form.items[$orderItemIndex].item.duration);
        } else {
          ctrl.form.items[$orderItemIndex].duration = undefined;
        }

        if (ctrl.form.items[$orderItemIndex].item.break) {
          ctrl.form.items[$orderItemIndex].enabled_second = true;
          ctrl.form.items[$orderItemIndex].resource_second = ctrl.form.items[$orderItemIndex].resource;
          if(ctrl.form.items[$orderItemIndex].item.duration_second && ctrl.form.items[$orderItemIndex].item.duration_second != '-1') {
            ctrl.form.items[$orderItemIndex].duration_second = String(ctrl.form.items[$orderItemIndex].item.duration_second);
          } else {
            ctrl.form.items[$orderItemIndex].duration_second = undefined;
          }
          

          var newDateObj = new Date('01/01/2023 '+ctrl.form.items[$orderItemIndex].start_time);
          var date = new Date(newDateObj.getTime() + (ctrl.form.items[$orderItemIndex].item.break+(ctrl.form.items[$orderItemIndex].duration*1))*60000);
          ctrl.form.items[$orderItemIndex].start_time_second = date.getHours() + ':' + date.getMinutes();
        }

        ctrl.calculate_totals();
      };

      ctrl.saveOriginalItemsData = function($orderItemIndex) {
        for (var i in ctrl.items) {
          if (ctrl.items[i].id == ctrl.form.items[$orderItemIndex].item_id) {
            ctrl.form.items[$orderItemIndex].item = angular.copy(ctrl.items[i]);
          }
        }
      }

      ctrl.addNewCustomer = function () {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
          controller: "CustomersFormController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal side-modal",
          resolve: {
            Customer: null,
            isModal: true,
            Lead: false,
            Info: ['$api', function ($api) {
              return $api.resolve("settings.info@get");
            }],
            Resources: ['$api', function ($api) {
              return $api.resolve("resources@get");
            }],
            Statuses: ['$api', function ($api) {
              return $api.resolve("statuses@get");
            }],
            Interested: ['$api', function ($api) {
              return $api.resolve("interested@get");
            }],
            Phone: function () {
              return ctrl.searchResult.length ? null : ctrl.customer_search_name;
            },
            CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
              return $api.resolve("customFields.all@get");
            }],
          }
        }).result.then(function (new_customer) {
          // after creating new customer, update form data
          // ctrl.customers.push(new_customer);
          ctrl.customer = new_customer;
          ctrl.form.customer = new_customer;
          // hide list
          ctrl.showCustomerSelect = false;
          setTimeout(function(){
            ctrl.customer_selected();
            // show list
            ctrl.showCustomerSelect = true;
          //     // rerender customer select
          //     angular.element("#customers_select").val(new_customer.id).trigger('chosen:updated');
          },100);
        });
      }

      ctrl.form_validate = function() {
        //console.log($scope.orderForm.$error.required);
      }

      ctrl.openSelectCustomer = function() {
        $uibModal.open({
          templateUrl: "app/modules/customers/popup/customers.popup.html",
          controller: "CustomersSelectController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal"
        }).result.then(function (selected_customer) {
          ctrl.customer = selected_customer;
          ctrl.form.customer = selected_customer;
          ctrl.customer_selected();
        });
      }

      ctrl.openSelectItem = function($orderItemIndex, orderItem, course) {
        course = course || false;
        temp = [];
        for( var i in ctrl.items) {
          if(!course && ctrl.items[i].item_type == orderItem.item_type && (!ctrl.items[i].inactive || ctrl.items[i].id == orderItem.item_id))
            temp.push(ctrl.items[i]);

          if(course && orderItem.item_type == 'course' && (!ctrl.items[i].inactive || ctrl.items[i].id == ctrl.form.item_id))
            temp.push(ctrl.items[i]);
        }
        $uibModal.open({
          templateUrl: "app/modules/settings/items/popup/items.popup.html",
          controller: "ItemsSelectController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal select-item-modal",
          resolve: {
            Items: [function () {
              return temp;
            }]
          }
        }).result.then(function (selected_item) {
            if (selected_item) {
              if (course)  {
                ctrl.form.item_id = ("" + selected_item.id);
              } else {
                ctrl.form.items[$orderItemIndex].item_id = ("" + selected_item.id);
                for (var i in ctrl.items) {
                  if (ctrl.items[i].id == ctrl.form.items[$orderItemIndex].item_id) {
                    ctrl.form.items[$orderItemIndex].item = ctrl.items[i];
                  }
                }
                ctrl.order_item_resource_change($orderItemIndex);
              }
            }
        });
    }

      ctrl.customers_select_onclick = function() {
        if (ctrl.isMobile) {
          ctrl.openSelectCustomer();
          return false;
        } else {
          return true;
        }
      }

      ctrl.send_order_prepaid = function () {
        var order_data = {};
        order_data.id = ctrl.order.id;
        order_data.type = "send_prepaid";
        if( typeof(ctrl.form.customer) == "object" && ctrl.form.customer !== null) {
          order_data.customer = ctrl.form.customer.id;
        }

        $api.orders.save(order_data, function (response) {
          $tiff_page.stop_loading('save_order');
          if (response.status === "success") {
            $uibModalStack.dismissAll();
            swal({
              title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      }

      ctrl.send_order_sms = function () {
        swal({
            title: '',
            text: $translate.instant('CONFIRM_SEND_SMS'),
            type: "warning",
            showCancelButton: true,
            confirmButtonText: $translate.instant('OPTION_YES'),
            cancelButtonText: $translate.instant('OPTION_NO'),
        }).then(function (res) {
            if (res.value) {
                ctrl.send_order_sms_approved();
            }
        });
      }

      ctrl.send_order_sms_approved = function () {
        var order_data = JSON.parse(JSON.stringify(ctrl.form));
        order_data.date = moment(ctrl.form.date).format("YYYY-MM-DD HH:mm");
        if( typeof(order_data.customer) == "object" && order_data.customer !== null) {
          order_data.customer = order_data.customer.id;
          order_data.allow_sending = ctrl.allow_sending;
        }
        if(ctrl.order && ctrl.order.status == 4) {
          order_data.status = 0;
          order_data.booking_approved = true;
        }

        order_data.type = "send_sms";
        order_data.id = ctrl.order.id;

        $api.orders.save(order_data, function (response) {
          $tiff_page.stop_loading('save_order');
          if (response.status === "success") {
            $uibModalStack.dismissAll();
            swal({
              title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      }

      ctrl.send_approval_request = function () {
        $uibModal.open({
          templateUrl: "app/modules/approvalrequest/approvalrequest.view.html",
          controller: "ApprovalRequestController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal small-modal",
          resolve: {
            OrderId: ctrl.order.id
          }
        }).result.then(function (send_method) {
          if(typeof(send_method) != 'undefined'){
            ctrl.request_approval(send_method);
            $uibModalStack.dismissAll();
          }
        });
      }

      // Send request approval from customer
      ctrl.request_approval = function (send_method) {
        var send_method_name = "";
        // console.log("send_method", send_method);
        if (!send_method || send_method === null) return;
        switch (send_method) {
          case 1:
            send_method_name = "email";
            break;
          case 2:
            send_method_name = "sms";
            break;
          // case 3:
          //   send_method_name = "whatsapp";
          //   break;
        }
        $tiff_page.start_loading('request_approval');
        $api.orders.request_approval.get({
          order_id: ctrl.order.id,
          send_method: send_method,
          method_name: send_method_name,
          email: ctrl.form.email,
          phone: ctrl.form.phone,
          request_feedback: ctrl.form.request_feedback,
          hostname: window.location.hostname,
          customer_first_name: ctrl.form.customer ? ctrl.form.customer.firstname : ctrl.form.customer_name
        }, function (response) {
          $tiff_page.stop_loading('request_approval');
          if (response.status === "success") {
            swal({
              title: $translate.instant('SWAL_ORDERS_REQUEST_APPROVAL_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      }

        ctrl.delete_event = function () {
          if (ctrl.form.repeat) {
            swal({
              title: "",
              text: $translate.instant('ORDER_EVENT_DELETE_CONFIRMATION'),
              type: 'info',
              showCancelButton: true,
              confirmButtonText: $translate.instant('ORDER_EVENT_DELETE_CONFIRMATION_ALL'),
              cancelButtonText: $translate.instant('ORDER_EVENT_DELETE_CONFIRMATION_CURRENT'),
              confirmButtonClass: "btn-primary",
              cancelButtonClass: "btn-primary",
              closeOnConfirm: false,
              showLoaderOnConfirm: false
            }).then(function(result) {
              if (result.dismiss && result.dismiss == "overlay") {
                return;
              }
              ctrl.confirm_delete_event(result.value ? true : false);
            });
          } else {
            ctrl.confirm_delete_event(false);
          }

        };
      ctrl.confirm_delete_event = function (all) {
        $tiff_page.start_loading('delete_event');
        $api.events.single.delete({
            id: ctrl.event.id,
            all: all*1
        }, function (response) {
            $tiff_page.stop_loading('delete_event');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_DELETE_EVENT_TITLE'),
                    text: "",
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.confirm_delete_course = function () {
        $tiff_page.start_loading('delete_course');
        $api.courses.single.delete({
            id: ctrl.course.id
        }, function (response) {
            $tiff_page.stop_loading('delete_course');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_DELETE_COURSE_TITLE'),
                    text: "",
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.reminderText = function() {
        var text = '';
        var order_data = JSON.parse(JSON.stringify(ctrl.form));
        if (order_data.items) {
          order_data.date = moment(ctrl.form.date).format("DD-MM-YYYY");
          
          order_data.items.sort(compareTimes);
          var first_item = order_data.items[0];

          for (var i in order_data.items) {
            var $item = order_data.items[i];
            var type_current = $item.item_data && $item.item_data.item_type ? $item.item_data.item_type : $item.item_type;
            var type_first = first_item.item_data && first_item.item_data.item_type ? first_item.item_data.item_type : first_item.item_type;
            if (!first_item || type_first !== 'service' || 
              (type_current === 'service' && $item['start_time'] && 
              new Date($item['start_time']).getTime() < new Date(first_item['start_time']).getTime())) {
              first_item = $item;
            }
          }

          var m_data = {
            'start_date': order_data.date,
            'start_time': first_item.start_time,
            'customer_name': order_data.customer ? order_data.customer.firstname + " " + order_data.customer.lastname : order_data.customer_name,
            'item_name': first_item.item_data.name,
            'businesses_name': ctrl.business.name,
          };

          text = ctrl.replaceMessageText(ctrl.order.reminder_text, m_data);
        }
        return encodeURIComponent(text);
      }

      function compareTimes(a, b) {
        var timeA = a.start_time;
        var timeB = b.start_time;
        
        if (timeA < timeB) {
          return -1;
        }
        if (timeA > timeB) {
          return 1;
        }
        return 0;
      }

      ctrl.msg_placeholders = {
        'customer_name': "[the customer's name]",
        'item_name': "[Item description]",
        'start_date': "[date]",
        'start_time': "[time]",
        'datetime': "[datetime]",
        'businesses_name': "[name of the business]",
        'order_id': "[order ID]",
        'link': "[link]",
        'week_day': "[week day]",
        "customer_name|he": "[שם הלקוח]",
        "item_name|he": "[שם המוצר]",
        "item_name|he2": "[שם הטיפול]",
        "start_date|he": "[תאריך]",
        "start_time|he": "[שעה]",
        "businesses_name|he": "[שם בית העסק]",
        "order_id|he": "[סכום יתרה]",
        'link|he': "[קישור]",
        'datetime|he': "[תאריך ושעת השירות]",
        'week_day|he': "[יום בשבוע]",
      };

      ctrl.replaceMessageText = function(message, data) {
        if (typeof data.start_date !== 'undefined' && typeof data.start_time !== 'undefined') {
          data.datetime = data.start_date + ' ' + data.start_time;
        }

        var text = '';
        text = message;

        for (var key in ctrl.msg_placeholders) {
            if (ctrl.msg_placeholders.hasOwnProperty(key)) {
                var placeholder = ctrl.msg_placeholders[key];
                var replacedKey = key.replace('|he2', '').replace('|he', '');
        
                if (typeof data[replacedKey] !== 'undefined' && data[replacedKey] !== null) {
                  text = text.replace(placeholder, data[replacedKey]);
                }
            }
        }
      
        return text;
      }

      ctrl.waPhone = function() {
        var phone = ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone;
        var symbols = [' ', '-', '_', '(', ')', '+972', '+'];
        for (var s in symbols) {
          phone = phone.replace(symbols[s], '')
        }
        return '+972'+phone
      },

      $scope.$watch("ctrl.form.items", function () {
        if (ctrl.bu_type == 2) {
          for (var i in ctrl.form.items) {
            ctrl.motels_update_item_nights(i);
          }
        }
        ctrl.calculate_totals();
        ctrl.formItemsChangedNotSaved = angular.equals(ctrl.form.items, ctrl.originalFormItemsData) ? false : true;
      }, true);

      $scope.$watch("ctrl.form.request_feedback", function () {
        ctrl.formItemsChangedNotSaved = true;
      });

        /**
         * Load all customer's cards
         *
         * @param customer_id
         */
        ctrl.loadCustomersCards = function (customer_id) {
          ctrl.customerCards = $api.resolve("cards.customers@get", {"id": customer_id});
          $api.cards.customers.get({"id": customer_id}, function (response) {
              if (response.status == "success") {
                ctrl.customerCards = response.data;
                ctrl.matchCardsForItems();
              }
            }
          );
        }

        /**
         * Return Card for specific Item if customer has bought it
         *
         * @param item_id
         * @returns {boolean}
         */
        ctrl.getCustomerCardForItem = function (item_id) {
          var itemCard = false;
          if (ctrl.form.customer && angular.isArray(ctrl.customerCards)) {
            ctrl.customerCards.forEach(function (card) {
              if (card.item_id == item_id) {
                itemCard = card;
              }
            })
          }
          return itemCard;
        }

          /**
           * Check if customer has Card for particular Item with positive balance
           *
           * @param item_id
           * @returns {boolean}
           */
          ctrl.hasCustomerCardForItem = function(item_id) {
            var hasCard = false;
            var card = ctrl.getCustomerCardForItem(item_id);
            if(card && card.balance > 0) {
              if (card.expired) {
                hasCard = 'expired';
              } else {
                hasCard = true;
              }
            }
            return hasCard;
          }

          /**
           * Mark Item with card indicator property if customer has appropriate Card
           */
          ctrl.matchCardsForItems = function() {
            var updatedItems = [];
            ctrl.items.forEach(function (item) {
              var card = ctrl.getCustomerCardForItem(item.id);
              if(card && card.balance > 0) {
                item.customer_has_card = true;
              } else {
                item.customer_has_card = false;
              }
              updatedItems.push(item);
            });
            ctrl.items = undefined;
            $timeout(function () {ctrl.items = updatedItems;}) // in order to update chosen directive
          };

          /**
           * Add Card flag for Items that match Customer's Cards list
           *
           * @param item
           * @returns {string}
           */
          ctrl.addCardBadge = function(item) {
            var badge = ctrl.hasCustomerCardForItem(item.id);
            if(badge === true) {
              return  "<i class='las la-ticket-alt'></i> ";
            }
            if(badge === 'expired') {
              return  "<i class='las la-ticket-alt expired'></i> ";
            }

            return "";
          }

          ctrl.goToCashbox = function() {
            if(ctrl.formItemsChangedNotSaved) {
              ctrl.send_order_form(function (callBackFromCallback) {
                $state.go('app.cashbox.order', {orderID: ctrl.order.id}, {
                  reload: true
                });
                if(angular.isUndefined(callBackFromCallback)) {
                  callBackFromCallback();
                }
              });
            } else {
              $state.go('app.cashbox.order', {orderID: ctrl.order.id}, {
                reload: true
              });
            }
          }

          /**
           * Go to the previous location
            */
          ctrl.goBack = function() {
            if(ctrl.order && ctrl.is_edit && ctrl.order.status == 4) {
              $window.history.back();
            }
          }

      if (ctrl.is_edit || EventCopy) {
        ctrl.load_order_data();
      }


    // multiservice

    ctrl.toggleDropdown = function ($event) {
      $event.stopPropagation();
      ctrl.showMultiServiceDropdown = !ctrl.showMultiServiceDropdown;
    };

    ctrl.closeDropdown = function () {
      if (ctrl.showMultiServiceDropdown) {
        ctrl.multiServiceFilterText = '';
        ctrl.syncSelectedItems();
      }
      ctrl.showMultiServiceDropdown = false;
    };

    ctrl.toggleItem = function (item_id) {
      var index = ctrl.multiServiceSelectedItems.indexOf(item_id.toString());
      if (index === -1) {
        ctrl.multiServiceSelectedItems.push(item_id.toString());
      } else {
        ctrl.multiServiceSelectedItems.splice(index, 1);
      }
    };

    ctrl.isSelected = function (item_id) {
      return ctrl.multiServiceSelectedItems.indexOf(item_id.toString()) !== -1;
    };

    ctrl.syncSelectedItems = function () {
      var existed;

      // Add new items
      for (var i = 0; i < ctrl.multiServiceSelectedItems.length; i++) {
        existed = false;
        for (var j = 0; j < ctrl.form.items.length; j++) {
          var formItem = ctrl.form.items[j];

          if (!formItem.item_id) {
            ctrl.form.items[ctrl.form.items.length - 1].item_id = ctrl.multiServiceSelectedItems[i].toString();
            ctrl.order_item_resource_change(j);
            existed = true;
            break;
          } else if (formItem.item_id.toString() === ctrl.multiServiceSelectedItems[i].toString()) {
            existed = true;
            break;
          }
        }

        if (!existed) {
          ctrl.add_service_item();
          ctrl.form.items[ctrl.form.items.length - 1].item_id = ctrl.multiServiceSelectedItems[i].toString();
          ctrl.order_item_resource_change(ctrl.form.items.length - 1);
        }
      }

      // Remove items no longer selected
      for (var i = 0; i < ctrl.form.items.length; i++) {
        existed = false;
        for (var j = 0; j < ctrl.multiServiceSelectedItems.length; j++) {
          if (ctrl.form.items[i].item_id.toString() === ctrl.multiServiceSelectedItems[j].toString()) {
            existed = true;
            break;
          }
        }

        if (!existed) {
          if (ctrl.form.items.length > 1) {
            ctrl.remove_item_from_order(i);
            i--; // adjust index due to item removal
          } else {
            ctrl.form.items[i].item_id = null;
            ctrl.form.items[i].item = null;
            ctrl.form.items[i].duration = null;
            
          }
        }
      }
    };

    ctrl.copyId = function(id) {
      navigator.clipboard.writeText(id).then(function() {
          ctrl.copied = true;
          setTimeout(function() {
              ctrl.copied = false;
          }, 3000);
      }).catch(function(error) {
          console.error('Failed to copy URL: ', error);
      });
    };

    }]);
})();

(function() {

    angular.module("app.controllers").controller("StoreFilterController", function($scope, Data, $rootScope, $user, $api, $translate) {

        var ctrl = this;
        ctrl.form = {
          name: '',
          default: '',
          module: Data.module,
          data: Data.filter,
        };

        ctrl.submit = function() {

          $api.filters.save(ctrl.form,
            function(res){
              swal({
                title: $translate.instant('STORE_FILTER_STORED'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 1500
              });
              $user.getFilters();
              $scope.$close();
            },
          function (res) {            
          });
        }
    });

})();

(function () {
    angular.module("app.controllers").controller("TutorialsCenterController", function ($scope, $header, $state, $api, $rootScope, $http, $translate, $timeout, $uibModal, $sce) {
        if ($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $header.title = "NAV_TUTORIALS";
        $header.breadcrumbs.push({
            "title": "NAV_TUTORIALS"
        });

        var ctrl = this;
        
        ctrl.playlistId = 'PLCp_SGV306bi-J7b9ABOhXNr4Nd3bjxma';
        
        ctrl.loading = false;
        ctrl.error = null;
        ctrl.videos = [];
        
        ctrl.init = function() {
            ctrl.loadVideos();
        };
        
        ctrl.loadVideos = function() {
            ctrl.loading = true;
            ctrl.error = null;
            
            ctrl.fetchPlaylistVideos();
        };
        
        ctrl.fetchPlaylistVideos = function() {
            $api.tutorials.playlist.get({playlist_id: ctrl.playlistId}, function(response) {
                if (response.status === 'success' && response.data) {
                    ctrl.videos = response.data;
                } else {
                    ctrl.error = $translate.instant('TUTORIALS_CENTER_ERROR');
                }
                ctrl.loading = false;
            }, function(error) {
                ctrl.error = $translate.instant('TUTORIALS_CENTER_ERROR');
                ctrl.loading = false;
            });
        };
        
        ctrl.openVideo = function(video) {
            $uibModal.open({
                templateUrl: 'app/modules/tutorials_center/video.modal.html',
                controller: function($scope, $uibModalInstance, Video, $sce, $translate) {
                    var vm = this;
                    vm.video = Video;
                    vm.getEmbedUrl = function() {
                        return $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + vm.video.videoId + '?autoplay=1&rel=0');
                    };
                    vm.stopVideo = function() {
                        $uibModalInstance.close();
                    };
                    vm.close = function() { $uibModalInstance.close(); };
                },
                controllerAs: 'vm',
                windowTopClass: 'form-modal medium-modal video-modal',
                backdrop: 'static',
                keyboard: true,
                scope: $scope,
                resolve: {
                    Video: function() { return video; }
                }
            });
        };
        
        ctrl.init();
    });
})();
(function(){
    angular.module('app.controllers').controller('TermsOfUseController', function($api, $state, $location){

        var ctrl = this;
        console.log(ctrl);
    });
})();
(function(){
    angular.module('app.controllers').controller('SettingsController', function($header, $state, $window, $rootScope, Info){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $rootScope.bu_type = parseInt(Info.data.type);
        $header.title = "NAV_SETTINGS";

        $rootScope.second_resource = Info.data.second_resource;
        $rootScope.second_resource_name = Info.data.second_resource_name;

        $header.breadcrumbs.push({
            "title": "NAV_SETTINGS"
        });

        var ctrl = this;
        ctrl.settings = Info.data;
        
    });
})();
(function () {

    angular.module('app.controllers')

        .controller('ReviewController', function(Order, IsPreview, $header, $api, $scope, $uibModalInstance, $window, $translate) {
  
            var ctrl = this;
            ctrl.stars = 0;
            ctrl.service = 0;
            ctrl.level_service = 0;
            ctrl.level_cleanliness = 0;
            ctrl.feedback = '';
            ctrl.is_review = false;
            $scope.isMobile = (angular.element(document).width() < 769);
            $scope.orderItem = Order.data;
            $scope.isPreview = IsPreview ? true: false;        

            ctrl.mainTitle = "Main Title";

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "NAV_REVIEW";
            $header.breadcrumbs.push({
                "title": "NAV_REVIEW"
            });

            ctrl.submit = function(){
                if (ctrl.stars > 0) {
                    $api.review.save({
                        id: $scope.orderItem.id,
                        stars: ctrl.stars,
                        service: ctrl.service,
                        level_service: ctrl.level_service,
                        level_cleanliness: ctrl.level_cleanliness,
                        text: ctrl.feedback
                    }, function (response) {
                        ctrl.is_review = true;
                        if (response.status === "success") {
                            swal({
                                title: $translate.instant('SWAL_REVIEW_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    });
                }
            }
        });
})();
(function () {
    angular.module('app.controllers')
        .controller('ReportsController', function ($header, $api, $scope, $cfilter, dates, DTOptionsBuilder, Info, dataTablesHebrewProvider, $state, $stateParams, $rootScope, $uibModal, Resources, $translate, $timeout) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }
            $scope.showDownloadBtn = false;

            var ctrl = this;
            ctrl.customers = [];
            ctrl.start_date = moment().startOf('month');
            ctrl.end_date = moment();
            ctrl.mainMobile = true;
            ctrl.mobileDropdown = false;
            ctrl.tab = parseInt($stateParams.tab, 10) || 4;
            ctrl.mainTitle = "Reports";
            ctrl.smsMaxLength = 800;
            ctrl.sendMessage = false;

            $scope.datesProvider = dates;

            ctrl.dealer_type = Info.data ? Info.data.dealer_type : '';

            if(Resources && angular.isDefined(Resources.data)) {
              ctrl.resources = Resources.data;
            }

            $scope.$watch("ctrl.tab", function(newValue, oldValue) {
                window.scrollTo( 0, 0 );
            });

            ctrl.tabList = {
                ALL: 4,
                DEBTORS: 7,
                MESSAGE: 6
                // ... TODO: should be filled with other tabs
            };

            if (ctrl.tab == 9) {
                $cfilter.apply('reports', true);
            } else if (ctrl.tab == 12) {
                $cfilter.apply('sales', true);
            }

            ctrl.statusList = [
                { name: 'STATUS_OPEN', value: '0,2' },
                { name: 'STATUS_CANCELLED', value: 1 },
                // { name: 'STATUS_CLOSED', value: 2 },
                { name: 'STATUS_PAID', value: 3 },
                { name: 'STATUS_CUSTOMER_BOOKED', value: 4 },
                // { name: 'STATUS_BOOKING_DECLINED', value: 5 },
                // { name: 'STATUS_CANCELED_ONLINE', value: 6 },
                // { name: 'STATUS_PAID_LINK', value: 7 },
                // { name: 'STATUS_WAITING_ONLINE_PAYMENT', value: 8 },
            ];

            ctrl.selectedStatuses = ctrl.statusList.filter(function() {
                return true;
            });

            if(window.innerWidth < 768){
                ctrl.mainMobile = false;
                ctrl.mobileDropdown = true;
            }


            $scope.userConfig = {
                create: true
              };
            $scope.userConfig1 = {
                create: true,
                searchField: false,
                openOnFocus: false,
                hideSelected: true,
                onDropdownOpen: function(dropdown) {
                  dropdown.remove();
                }
              };
            ctrl.months = [];
            for( var i = 1 ;i < 25 ; i++) {
                month = {
                    'value': i,
                    'name': i+' months'
                };
                ctrl.months.push(month);
            }
            ctrl.tableData = [];

            ctrl.filter_table = function() {
                
                ctrl.tableData = [];
                ctrl.allTableData = [];

                if (ctrl.customers.length > 0) {
                    ctrl.fill_table_data();
                    return;
                }

                $api.customers.get(
                    {filter: ctrl.filter}
                    , function (result) {
                    if (result && result.data) {
                        ctrl.customers = result.data;
                        ctrl.fill_table_data();
                    }
                });

                
                // $.fn.DataTable.render;
            }

            ctrl.fill_table_data = function() {
                for(i in ctrl.customers) {
                    if((ctrl.tab != ctrl.tabList.DEBTORS) ||
                        (ctrl.tab == ctrl.tabList.DEBTORS && ctrl.customers[i].oncredit > 0)) {
                            ctrl.tableData.push(ctrl.customers[i]);
                    }
                }

                ctrl.allTableData = ctrl.tableData;
            }

            $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('searching', false)
                      .withOption('order', [[1, 'desc']]);
            $scope.dtOptions.searching = false;

            $scope.dtOptionsFeedback =
                DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    .withOption('scrollY', '500px')
                    .withOption('searching', false)
                    .withOption('order', [[6, 'desc']]);
            $scope.dtOptionsFeedback.searching = false;

            //ctrl.filter_table();

            ctrl.setTitle = function (newTab) {
                switch (newTab) {
                    case 4:
                        $api.test(false);
                        ctrl.mainTitle = "Reports";
                        break;
                    case 7:
                        ctrl.mainTitle = "CUSTOMERS_DEBTS_REPORT_TITLE";
                        break;
                    default:
                        $api.test(true);
                        ctrl.mainTitle = "Revenue";
                        break;
                }
            }

            ctrl.orderType = function(order){
                if(order === "income"){
                    $api.test(false);
                    ctrl.setTab(3);
                } else if(typeof order === 'undefined'){
                    ctrl.setTab(1);
                } else if(order === "everything"){
                    ctrl.setTab(4);
                } else if(order === "cancelled"){
                    ctrl.setTab(2);
                } else if(order === "financial"){
                    ctrl.setTab(5);
                } else if(order === "customers"){
                    ctrl.setTab(10);
                }

            };

            ctrl.goToTransactions = function() {
                $state.go('app.settings.logs');
            }

            ctrl.openOrderModal = function(id) {
                $state.go('app.calendar.order-edit', {id: id});
            }  

            ctrl.setTab = function(newTab){
                if (newTab == 9) {
                    $cfilter.apply('reports', true);
                } else if (newTab == 12) {
                    $cfilter.apply('sales', true);
                }

                ctrl.setTitle(newTab);
                switch (newTab) {
                    case 4: {
                        $scope.showBack = false;
                        $scope.$emit('someEvent', "test");
                        break;
                    }
                    case 5:
                        break;

                    case 7:
                        ctrl.tab = newTab;
                        ctrl.filter_table();
                        return;

                    default: {
                        $scope.showBack = true;
                        $scope.$emit('click', "test");
                    }
                }
                
                $scope.showTable = false;
                return ctrl.tab = newTab;
            };

            ctrl.isSet = function(tabNum){
                if(tabNum === 4) {
                    $scope.showBack = false;
                }else {
                    $scope.showBack = true;
                }
                return ctrl.tab === tabNum;
            };

            $scope.showTable = false;

            ctrl.form = {
                start: moment(ctrl.start_date).format("YYYY-MM-DD"),
                end: moment(ctrl.end_date).format("YYYY-MM-DD"),
                statuses: [],
            };

            ctrl.request_in_progress = false;
            ctrl.preview_in_progress = false;
            ctrl.download_in_progress = false;
            ctrl.send_in_progress = false;
            ctrl.report_is_finished = false;

            /**
             * Triggers when hiting one of the buttons on "Create New Report" form
             * @return void
             */
            ctrl.create_new_report = function(export_type) {
                //console.log(ctrl.form.order_type);
                $scope.showTable = false;

                if(export_type == "preview"){
                    ctrl.preview_in_progress = true;
                    ctrl.request_in_progress = true;
                    ctrl.report_is_finished = true;
                }
                // else if(export_type == "download")
                //     ctrl.download_in_progress = true;
                else if(export_type == "sendbymail") {
                    ctrl.send_in_progress = true;
                }

                ctrl.form.action = export_type;
                ctrl.form.start = moment(ctrl.start_date).format("YYYY-MM-DD");
                ctrl.form.end = moment(ctrl.end_date).format("YYYY-MM-DD");

                if( ctrl.form.order_type == "financial") {
                    var $request = {
                        start: ctrl.form.start,
                        end: ctrl.form.end,
                        step: "start"
                    };
                    $api.financial.get($request, function(response) {
                        setTimeout( function() {
                            ctrl.check_financial_report_status();
                        }, 300);
                    });
                }
                else if( ctrl.form.order_type == "workers_time" ){
                    $api.workers.employee_transactions.get(ctrl.form, function(response) {
                        //console.log(response)
                            swal({
                                title: $translate.instant('SWAL_WORKER_TRANSACTION_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });

                        ctrl.request_in_progress = false;
                        ctrl.preview_in_progress = false;
                        ctrl.download_in_progress = false;
                        ctrl.send_in_progress = false;

                        // ctrl.report_is_finished = false;
                    });
                }
                else {
                    var statusCodes = [];
                    for (var key in ctrl.selectedStatuses) {
                        statusCodes.push(ctrl.selectedStatuses[key].value);
                    }

                    if (statusCodes.length !== 0) {
                        ctrl.form.statuses = statusCodes.join(',');
                    }

                    if (ctrl.tab == 9) {
                        ctrl.form.filter = $rootScope.reports_filter
                    } else if (ctrl.tab == 12) {
                        ctrl.form.filter = $rootScope.sales_filter
                    }

                    $api.reports.get(ctrl.form, function(response) {
                        if(export_type == "sendbymail") {
                            swal({
                                title: $translate.instant('SWAL_REPORTS_GET_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        } else {
                            response.data.forEach(function(item){
                                item = ctrl.calculate_vat(item);
                                item['document_type'] = "DOCUMENT_" + item['document_type']
                            });
                            ctrl.tableData = response.data;
                            ctrl.allTableData = ctrl.tableData;
                            $scope.showTable = true;
                        }

                        ctrl.request_in_progress = false;
                        ctrl.preview_in_progress = false;
                        ctrl.download_in_progress = false;
                        ctrl.send_in_progress = false;

                        // ctrl.report_is_finished = false;
                    });
                }


            };

            ctrl.check_financial_report_status = function() {
                var $request = {
                    start: ctrl.form.start,
                    end: ctrl.form.end,
                    step: "status"
                };
                $api.financial.get($request, function(response) {
                    if(response.data.code == 2) {
                        ctrl.request_in_progress = false;
                        ctrl.preview_in_progress = false;
                        ctrl.download_in_progress = false;
                        ctrl.send_in_progress = false;
                        location.href = "http://dev.enm.co.il/tifulit/" + response.data.zip_link;
                        // window.open("http://dev.enm.co.il/tifulit/" + response.data.zip_link, "");
                    } else {
                        setTimeout( function() {
                            ctrl.check_financial_report_status();
                        }, 100);
                    }
                });
            }

            ctrl.calculate_vat = function(item) {
                var total = item.total_paid?item.total_paid:item.total;
                item.subtotal = parseFloat(total - item.vat).toFixed(2);
                item.vat = parseFloat(item.vat).toFixed(2);
                return item;
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "NAV_REPORTS";
            $header.breadcrumbs.push({
                "title": "NAV_REPORTS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[1, 'desc']]);

            $scope.dtOptionsFeedback =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[3, 'desc']]);
            
            $scope.dtOptionsSales =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[0, 'desc']]);

            $scope.dtOptionsCards =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[0, 'asc']]);
            /**
             * Show popup for sending reminder about debt
             * @param customerData
             */
            ctrl.remind_customer_debt = function (customerData) {
                $uibModal.open({
                    templateUrl: "app/modules/reports/popups/debt-remind.view.html",
                    controller: "DebtRemindController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal small-modal",
                    resolve: {
                        customerData: customerData
                    }
                });
            }

            ctrl.allTableData = [];
            ctrl.searchTableData = function() {
                //reset data
                ctrl.tableData = ctrl.allTableData;
                
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                    var found = false;
                    for (var k in ctrl.tableData[i]) {
                        if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                        found = true;
                        }
                    }

                    if (found) {
                        newData.push(ctrl.tableData[i]);
                    }
                    }

                    ctrl.tableData = newData;
                }
            }

            ctrl.calculateTotals = function() {
                var t = { qty: 0, total: 0 };
                for (var i = 0; i < ctrl.tableData.length; i++) {
                  t.qty   += ctrl.tableData[i].qty;
                  t.total += ctrl.tableData[i].total;
                }
                return t;
              };

            /**
             * Show customers details
             * @param customer_id
             */
            ctrl.showCustomersDetails = function(customer_id) {
                $state.transitionTo("app.customers.single", {
                    "id": customer_id
                });
            }

        });
})();

(function(){
    angular.module('app.controllers').controller('PrepaidController', function (Order, $header, $rootScope, $api, $scope, $uibModalInstance, $window, $sce, $translate){

        var ctrl = this;

        ctrl.form = {};
        
        $scope.orderItem = Order ? Order.data : false;
        $scope.channelHash = $rootScope.generateUniqueId();

        $scope.iframe = function(){
            if ($scope.orderItem) {
                var cardReader = false;
                var tamp = cardReader ? "9" : "6";
                var customer = $scope.orderItem.customer_name ? $scope.orderItem.customer_name : "לקוח לקוח";

                if ($scope.orderItem.business.cerdit_company == "1") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/yaad?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.business.prepaid + "&tmp=" + tamp + "&customer=" + customer + "&b_id=" + $scope.orderItem.business.id);
                } else if ($scope.orderItem.business.cerdit_company == "0") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/tranzila?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.business.prepaid);
                } else if ($scope.orderItem.business.cerdit_company == "2") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/pelecard?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&amount=" + $scope.orderItem.business.prepaid + "&reader=" + cardReader + "&b_id=" + $scope.orderItem.business.id);
                } else if ($scope.orderItem.business.cerdit_company == "3") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/zcredit?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&amount=" + $scope.orderItem.business.prepaid + "&b_id=" + $scope.orderItem.business.id + "&iframe=1");
                }
            }

            return "";
        };

        var channel = (!pusher.channel('business-'+$scope.orderItem.business.id)) ? pusher.subscribe('business-'+$scope.orderItem.business.id) : pusher.channel('business-'+$scope.orderItem.business.id);
        channel.bind('iframe-result-'+$scope.channelHash, function(response) {
            if (response) {
                if (response.result == 'success') {
                    swal({
                        title: $translate.instant('SWAL_PEL_PAY_TITLE'),
                        text: "",
                        type: "success",
                    });
                } else if (response.result == 'error') {
                    var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                    if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                        message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                    }

                    swal({
                        title: response.message ? response.message : message,
                        text: $translate.instant('SWAL_PEL_PAY_ERROR_TEXT'),
                        type: "warning",
                    });
                }
            }
        });

        $scope.$on('$messageIncoming', function (event, data){
            if(data.msg == "Ok"){
                swal({
                    title: $translate.instant('SWAL_PEL_PREPAID_TITLE'),
                    text: "",
                    type: "success",
                    //confirmButtonText: "אישור",
                });
            }
            else if(data.msg == "Error"){

                var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                }

                
                swal({
                    title: message,
                    text: $translate.instant('SWAL_PEL_PREPAID_ERROR_TEXT'),
                    type: "warning",
                    //confirmButtonText: "אישור",
                    //timer: 3000
                });
            }

        });

    });
})();

(function () {
  angular.module("app.controllers").controller("PdfPreviewController", function ($scope, pdfUrl, imageUrl, $rootScope, $state, $sce) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.pdfUrl = pdfUrl ? $sce.trustAsResourceUrl('https://docs.google.com/gview?embedded=true&chrome=true&url=' + pdfUrl) : '';
    ctrl.imageUrl = imageUrl ? $sce.trustAsResourceUrl(imageUrl) : '';
  });
})();

(function(){
    angular.module('app.controllers').controller('PayController', function (Order, $rootScope, $header, $api, $scope, $window, $sce, $translate){

            var ctrl = this;

            ctrl.form = {};

            $scope.orderItem = Order ? Order.data : false;
            $scope.channelHash = $rootScope.generateUniqueId();
            $scope.items = [];

            if ($scope.orderItem && $scope.orderItem.data && $scope.orderItem.data.items) {
                for (var i in $scope.orderItem.data.items) {
                    $scope.items.push($scope.orderItem.data.items[i]);
                }
            }

            $scope.iframe = function(){
                if ($scope.orderItem) {
                    var cardReader = false;
                    var tamp = cardReader ? "9" : "6";
                    var customer = $scope.orderItem.customer_name ? $scope.orderItem.customer_name : "לקוח לקוח";
                    var npay = $scope.orderItem.data.numberOfPaymentsEmv && $scope.orderItem.data.numberOfPaymentsEmv*1 > 1 ? $scope.orderItem.data.numberOfPaymentsEmv : false;

                    if ($scope.orderItem.business.cerdit_company == "1") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/yaad?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&tmp=" + tamp + "&customer=" + customer + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay);
                    } else if ($scope.orderItem.business.cerdit_company == "0") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/tranzila?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay);
                    } else if ($scope.orderItem.business.cerdit_company == "2") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/pelecard?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&reader=" + cardReader + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay);
                    } else if ($scope.orderItem.business.cerdit_company == "3") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/zcredit?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay + "&iframe=1");
                    }
                }

                return "";
            };

            if ($scope.orderItem) {
                var channel = (!pusher.channel('business-'+$scope.orderItem.business.id)) ? pusher.subscribe('business-'+$scope.orderItem.business.id) : pusher.channel('business-'+$scope.orderItem.business.id);
                channel.bind('iframe-result-'+$scope.channelHash, function(response) {
                    if (response) {
                        if (response.result == 'success') {
                            swal({
                                title: $translate.instant('SWAL_PEL_PAY_TITLE'),
                                text: "",
                                type: "success",
                            });
                        } else if (response.result == 'error') {
                            var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                            if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                                message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                            }

                            swal({
                                title: response.message ? response.message : message,
                                text: $translate.instant('SWAL_PEL_PAY_ERROR_TEXT'),
                                type: "warning",
                            });
                        }
                    }
                });
            }

            $scope.$on('$messageIncoming', function (event, data){
                if(data.msg == "Ok"){
                    swal({
                        title: $translate.instant('SWAL_PEL_PAY_TITLE'),
                        text: "",
                        type: "success",
                    });
                }
                else if(data.msg == "Error"){

                    var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                    if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                        message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                    }


                    swal({
                        title: message,
                        text: $translate.instant('SWAL_PEL_PAY_ERROR_TEXT'),
                        type: "warning",
                    });
                }

            });

        });
})();
(function () {
    angular.module('app.controllers')
        .controller('MarketingController', function ($header, $cfilter, $resource, $api, $scope, $tiff_page, dates, DTOptionsBuilder, dataTablesHebrewProvider, $state, $rootScope, $translate, $timeout, $cookies, $user) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.title = "NAV_MARKETING";
            $header.breadcrumbs.push({
                "title": "NAV_MARKETING"
            });

            var ctrl = this;
            ctrl.customers = [];
            ctrl.tab = '';
            ctrl.smsMaxLength = 800;
            ctrl.sendMessage = false;
            ctrl.message = '';
            ctrl.files = [];
            var fileElement = null;

            ctrl.wa_status = $cookies.get("wa_status");

            $scope.datesProvider = dates;

            $scope.$watch("ctrl.tab", function(newValue, oldValue) {
                window.scrollTo( 0, 0 );
            });

            ctrl.tableData = [];

            $scope.uploadFile = function(element){
                ctrl.files = element.files;
                fileElement = element;
                $scope.$apply();
            };

            ctrl.initDtOptions = function(){
            $scope.dtOptions =
                DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                .withLanguage(dataTablesHebrewProvider)
                .withOption('pageLength', 20)
                .withOption('order', false)
                .withOption('aaSorting', [])
                .withOption('searching', false)
                .withOption('ajax', ctrl.filter_table)
                .withOption('serverSide', true)
                .withDataProp('data');
            };

            ctrl.initDtOptions();

            ctrl.filter_table = function (data, callback) {
                callback({recordsTotal:0, recordsFiltered: 0, data: [], draw: data.draw+1});
                
                ctrl.tableData = [];
                ctrl.allTableData = [];
                var filter = $rootScope.marketing_filter || {};

                $api.customers.marketing.get(
                    {filter: filter, limit: data.length, offset: data.start}
                    , function (result) {
                        if (result && result.data) {

                        callback({
                            recordsTotal: result.recordsTotal,
                            recordsFiltered: result.recordsFiltered,
                            data: result.data,
                            draw: data.draw + 1
                        });
                    }
                });
            }
            
            ctrl.variables = {
                'customer_name' : "[the customer's name]",
                "customer_name|he" : "[שם הלקוח]",
            };
    
            ctrl.putVariable = function(code) {
                code = code || 'customer_name';
                code = $user.currentLanguage == 'hb_ISR' ? code+'|he' : code;
                var variable = ctrl.variables[code] ? ctrl.variables[code] : '['+code+']';
                ctrl.message += " "+variable; 
            };


            ctrl.send_message = function() {
                if (ctrl.sendMessage || (!ctrl.message && !(fileElement && fileElement.files[0]))) {
                    return;
                }
                
                if (ctrl.tab == 'wa' || ctrl.tab == 'sms') {
                    swal({
                        title: '',
                        text: $translate.instant('CONFIRM_MARKETING_SEND'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('OPTION_YES'),
                        cancelButtonText: $translate.instant('OPTION_NO'),
                    }).then(function (res) {
                        if (res.value) {
                            ctrl.send_message_request();
                        }
                    });
                } else {
                    ctrl.send_message_request();
                }
            }
            
            ctrl.send_message_request = function() {
                $tiff_page.start_loading('marketing');
                var data = {};
                data = angular.copy(ctrl, data);
                ctrl.sendMessage = true;

                var message_type = 2;
                var stop_text = "";
                switch (ctrl.tab) {
                    case 'sms': 
                        message_type = 2;
                        break;
                    case 'wa':
                        message_type = 3;
                        stop_text = $translate.instant('WA_STOP_TEXT');
                        break;
                    case 'email':
                        message_type = 1;
                        break;
                }

                var filter = $rootScope.marketing_filter || {};

                var send_data = {'filter_options': {
                                    'send_type': message_type,
                                    'filter': filter,
                                },
                                'message': data.message,
                                'stop_text': stop_text};

                var fdata = new FormData();
                if (fileElement) {
                    fdata.append("file", fileElement.files[0]);
                }
                fdata.append("filter_options", JSON.stringify(send_data.filter_options));
                fdata.append("message", send_data.message);
                fdata.append("stop_text", send_data.stop_text);

                $resource($api.baseURL + '/reports', {}, {
                    postWithFile: {
                        method: "POST",
                        params: fdata,
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined}
                    }
                }).postWithFile(fdata).$promise.then(function(response){
                    ctrl.sendMessage = false;
                    $tiff_page.stop_loading('marketing');
                    swal({
                            title: $translate.instant('SWAL_REPORT_SAVE_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    ctrl.setTab('');
                    ctrl.message = '';
                }, function(error){
                    $tiff_page.stop_loading('marketing');
                    ctrl.sendMessage = false;
                    if (error.data && error.data.message) {
                        swal({
                            title: '',
                            text: error.data.message,
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });
                    } else {
                        swal({
                            title: '',
                            text: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });
                    }
                });

                return;
            }

            ctrl.setTab = function(newTab){
                if (newTab == 'wa' && ctrl.wa_status != 'authorized') {
                    swal({
                        title: $translate.instant('SWAL_PLEASE_CONNECT_WA'),
                        text: "",
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 3000
                    });
                    
                    return;
                }
                
                if (newTab == 'wa' && $rootScope.$user.wa_block*1 >= 10) {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_WA_BLOCK_WARNING'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    }).then(function(result) {
                        if (result.value) {
                            ctrl.initDtOptions();
                            if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                                $('#cust_dt').DataTable().ajax.reload();
                            }
                            ctrl.tab = newTab;
                            $scope.$apply();
                            return;
                        }
                    });
                    
                    return;
                }
                

                if (newTab == 'wa') {
                    swal({
                        title: "",
                        html: $translate.instant('SWAL_WA_WARNING'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                        showCancelButton: true,
                    }).then(function(result) {
                        if (result.value) {
                            ctrl.initDtOptions();
                            if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                                $('#cust_dt').DataTable().ajax.reload();
                            }
                            ctrl.tab = newTab;
                            $scope.$apply();
                            return;
                        }
                    });
                    
                    return;
                }

                ctrl.initDtOptions();
                if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                    $('#cust_dt').DataTable().ajax.reload();
                }
                return ctrl.tab = newTab;
            };

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('searching', false)
                      .withOption('order', [[1, 'desc']]);
            $scope.dtOptions.searching = false;

            /**
             * Filter
            */
            $cfilter.apply('marketing');
            $scope.submit_filter = function() {
                $scope.find_customer();
            }

            $scope.find_customer = function() {
                ctrl.customers = [];
                ctrl.initDtOptions();
                if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                    $('#cust_dt').DataTable().ajax.reload();
                }
            }


            ctrl.dtColumns = [
                { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125 w-100',
                  render: function(data, type, full, meta) {
                    var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
                    var html = '<div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>';
                    html+= '<b>';
                    html+= data.firstname ? ' ' + data.firstname : '';
                    html+= data.lastname ? ' ' + data.lastname : '';
                    html+= '</b>';
                    return '<div class="flex nowrap">'+html+'</div>';
                  }
                },
                {name: 'last_visit', data: null, title: $translate('CUSTOMERS_LAST_VISIT'), class: 'customer-name',
                    render: function (data, type, full, meta) {
                        return data['last_visit'] != '01/01/1970' ? '<span>'+ (data['last_visit'] ? data['last_visit'] : '') +'</span>' : '';
                    }
                },
                { name: 'gender', data: null, title: $translate('CUSTOMERS_GENDER'), class: 'customer-gender',
                  render: function(data, type, full, meta) {
                    return data.gender == 0?$translate.instant("CUSTOMERS_GENDER_MALE"):data.gender==1?$translate.instant("CUSTOMERS_GENDER_FEMALE"):$translate.instant("CUSTOMERS_GENDER_NOT_SET");
                  }
                },
                { name: 'age', data: null, title: $translate('CUSTOMERS_AGE'), class: 'customer-age',
                  render: function(data, type, full, meta) {
                    return data.age;
                  }
                },
              ];

        });
})();

(function(){
    angular.module('app.controllers').controller('LoginController', function ($user, $scope, $state, $notify, $rootScope){

            var ctrl = this;

            ctrl.form = {};

            ctrl.login = function(){
                $rootScope.page_is_loading = true;

                $user.login(ctrl.form, function(success){

                    if(success){
                      $user.go_default_screen();
                    }
                    else {
                        $rootScope.page_is_loading = false;
                        $scope.loginForm.email.$setValidity('creds', false);
                        $scope.loginForm.password.$setValidity('creds', false);
                        $scope.loginForm.$setSubmitted();
                    }
                });
            };

            var resetCreds = function(newValue, oldValue){
                if(newValue != oldValue){
                    $scope.loginForm.email.$setValidity('creds', true);
                    $scope.loginForm.password.$setValidity('creds', true);
                    $scope.loginForm.$setSubmitted();
                }
            };
            $scope.$watch("ctrl.form.email", resetCreds);
            $scope.$watch("ctrl.form.password", resetCreds);
        });
})();

(function () {
  angular.module('app.controllers')
    .controller('PublicGiftCardController', function (GiftCard) {
      var ctrl = this;

      ctrl.settings = {};
      ctrl.values = {};
      ctrl.used = false

      if (GiftCard && GiftCard.data) {
        ctrl.used = GiftCard.data.used || false;
        
        ctrl.settings.page_bg_color = GiftCard.data.page_bg_color || '#EEF3FC';
        ctrl.settings.card_bg_color = GiftCard.data.card_bg_color || '#ffffff';
        ctrl.settings.primary_color = GiftCard.data.primary_color || '#275A7B';
        ctrl.settings.text_color = GiftCard.data.text_color || '#1A202C';
        ctrl.settings.logo = GiftCard.data.logo || '/assets/images/gift-card-logo.png';
        ctrl.settings.image = GiftCard.data.image || '/assets/images/gift-card-image.png';
        ctrl.settings.receiver = GiftCard.data.receiver;
        ctrl.settings.sender = GiftCard.data.sender;
        ctrl.settings.service = GiftCard.data.service;
        ctrl.settings.value = GiftCard.data.value;
        ctrl.settings.message = GiftCard.data.message;

        ctrl.values.number = GiftCard.data.number || '';
        ctrl.values.sender = GiftCard.data.sender_text || '';
        ctrl.values.receiver = GiftCard.data.gifted_to || '';
        ctrl.values.value = GiftCard.data.price || 0;
        ctrl.values.balance = GiftCard.data.balance || 0;
        ctrl.values.service = GiftCard.data.service_text || '';
        ctrl.values.message = GiftCard.data.message_text || '';
        ctrl.values.business = GiftCard.data.name || '';

        var address = [];
        if (GiftCard.data.city) {
          address.push(GiftCard.data.city);
        }
        if (GiftCard.data.address) {
          address.push(GiftCard.data.address);
        }
        if (GiftCard.data.home_number) {
          address.push(GiftCard.data.home_number);
        }
        ctrl.values.address = address.join(', ');
      }

      ctrl.getPhoneLink = function (phone) {
        if (!phone || phone == '') {
          return null;
        }

        return 'tel:' + phone;
      };

      ctrl.getFacebookLink = function (link) {
        if (!link || link == '') {
          return null;
        }

        return link;
      };

      ctrl.getWhatsAppLink = function (phone) {
        if (!phone || phone == '') {
          return null;
        }

        var raw = String(phone).trim();
        if (raw.charAt(0) === '+') {
          raw = raw.slice(1);
        }

        var digits = raw.replace(/\D+/g, '');
        if (digits.charAt(0) === '0' && digits.indexOf('972') !== 0) {
          digits = '972' + digits.slice(1);
        }

        return 'https://wa.me/' + digits;
      };

      ctrl.getWazeLink = function (address) {
        if (!address || address == '') {
          return null;
        }

        return 'https://waze.com/ul?q=' + encodeURIComponent(address);
      };

      ctrl.getInstagramLink = function (link) {
        if (!link || link == '') {
          return null;
        }

        return link;
      };

      ctrl.socials = {
        phone: (GiftCard && GiftCard.data) ? ctrl.getPhoneLink(GiftCard.data.phone) : null,
        facebook: (GiftCard && GiftCard.data) ? ctrl.getFacebookLink(GiftCard.data.facebook_review) : null,
        wa: (GiftCard && GiftCard.data) ? ctrl.getWhatsAppLink(GiftCard.data.phone) : null,
        waze: (GiftCard && GiftCard.data) ? ctrl.getWazeLink(ctrl.values.address) : null,
        instagram: (GiftCard && GiftCard.data) ? ctrl.getInstagramLink(GiftCard.data.instagram) : null
      };
    });
})();
(function(){
    angular.module('app.controllers').controller('ForgotPasswordConfirmController', function($api, $state, $location, $translate){

        var ctrl = this;

        ctrl.form = {};

        ctrl.form.token = $location.search().token ? $location.search().token : '';

        ctrl.submit = function(){
            delete ctrl.form.newPassword;
            $api.passwordconfirm.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_PASS_CONFIRM_TITLE'),
                        text: $translate.instant('SWAL_PASS_CONFIRM_TEXT'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("login", {}, {reload: true});
                }else{
                    $state.transitionTo("login", {}, {reload: true});
                }
            });
        }
    });
})();
(function(){
    angular.module('app.controllers').controller('ForgotPasswordController', function($api, $state){

        var ctrl = this;

        ctrl.form = {};

        ctrl.submit = function(){
            $api.forgot_password.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: "Thank you!",
                        text: "We will send you message on your email",
                        type: "success",
                        confirmButtonText: "OK",
                        timer: 2000
                    });
                    $state.transitionTo("login", {}, {reload: true});
                }
            });
        }
    });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsController', function(DigitalForm, $header, $api, $scope, $uibModalInstance, $window, $sce, $color, $translate) {
  
            var ctrl = this;
            
            $scope.DigitalForm = DigitalForm.data;
            $scope.business = DigitalForm.data.business;
            $scope.DigitalForm.data = DigitalForm.data && DigitalForm.data.data ? JSON.parse(DigitalForm.data.data) : [];
            $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';

            if ($scope.DigitalForm.data) {
                for (var i in $scope.DigitalForm.data) {
                    if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                        $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                    }
                }
            }

            if ($scope.business['favicon_path']) {
                $('#favicon').attr('href', $scope.business['favicon_path']+'favicon.ico');
                $('#favicon-16').attr('href', $scope.business['favicon_path']+'favicon-16.png');
                $('#favicon-32').attr('href', $scope.business['favicon_path']+'favicon-32.png');
                $('#favicon-64').attr('href', $scope.business['favicon_path']+'favicon-64.png');
            }

            ctrl.setBusinessSettings = function() {
                $scope.business.online_booking_data.online_color = $scope.business.online_booking_data.online_color ? $scope.business.online_booking_data.online_color : '#61B9A0';
                if ($scope.business.online_booking_data.online_color == 'purple') {
                    $scope.business.online_booking_data.online_color = '#8C60AE';
                }
                if ($scope.business.online_booking_data.online_color == 'turquoise') {
                    $scope.business.online_booking_data.online_color = '#61B9A0';
                }

                $scope.business.online_booking_data.background = $scope.business.online_booking_data && $scope.business.online_booking_data.background && $scope.business.online_booking_data.background != "" ? $scope.business.online_booking_data.background : ($scope.business.online_booking_data.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
                $scope.business.online_booking_data.online_logo = $scope.business.online_booking_data && $scope.business.online_booking_data.online_logo && $scope.business.online_booking_data.online_logo != "" ? ($scope.business.online_booking_data.online_logo == "removed" ? "" : $scope.business.online_booking_data.online_logo) : location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
                
                
                document.documentElement.style.setProperty('--menu-color', $scope.business.menu_color ? $scope.business.menu_color : '#216089');
                document.documentElement.style.setProperty('--online-color', $scope.business.online_booking_data.online_color);
                document.documentElement.style.setProperty('--online-text-color', $scope.business.online_booking_data.online_text_color);
                document.documentElement.style.setProperty('--back-color', $scope.business.back_color ? $scope.business.back_color : '#F2F6FF');
                document.documentElement.style.setProperty('--calendar-color', $scope.business.calendar_color != '#f2f2f2' ? $scope.business.calendar_color : '#fff');
                document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--calendar-stripe-color', $scope.business.calendar_stripe_color ? $scope.business.calendar_stripe_color : '#f7fafc');
                
            }

            ctrl.setBusinessSettings();
            
        
            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            ctrl.submit = function(){
                
                var required = false;
                for (var i in $scope.DigitalForm.data) {
                    if ($scope.DigitalForm.data[i].type == 'comment' || $scope.DigitalForm.data[i].type == 'map' || $scope.DigitalForm.data[i].type == 'business_signature') {
                        continue;
                    }

                    if (($scope.DigitalForm.data[i].type == 'signature')) {
                        $scope.DigitalForm.data[i].value = canvas[i].getLines();
                    }

                    if ($scope.DigitalForm.data[i].require || $scope.DigitalForm.data[i].required) {
                        if (($scope.DigitalForm.data[i].type != 'checkbox' && !$scope.DigitalForm.data[i].value)) {
                            required = true;
                            console.log('required', $scope.DigitalForm.data[i].name);
                        }

                        if (($scope.DigitalForm.data[i].type == 'checkbox' && $scope.DigitalForm.data[i].items && $scope.DigitalForm.data[i].items.length)) {
                            var check_for_checked = false;
                            for (var j in $scope.DigitalForm.data[i].items) {
                                if ($scope.DigitalForm.data[i].items[j].checked) {
                                    check_for_checked = true;
                                }
                            }

                            if (!check_for_checked) {
                                required = true;
                                console.log('required', $scope.DigitalForm.data[i].name);
                            }
                        }

                        if (($scope.DigitalForm.data[i].type == 'signature' && (!$scope.DigitalForm.data[i].value || !$scope.DigitalForm.data[i].value.length))) {
                            required = true;
                            console.log('required', $scope.DigitalForm.data[i].name);
                        }
                    }
                }

                if (required) {
                    swal({
                        title: $translate.instant('DIGITAL_FORM_REQUIRED'),
                        text: "",
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        //timer: 2000
                    });

                    return;
                }

                $api.customer_forms.save({
                    id: $scope.DigitalForm.id,
                    data: $scope.DigitalForm.data,
                    public: 1,
                }, function (response) {
                    if (response.status === "success") {
                        $scope.DigitalForm.fill_date = true;

                        swal({
                            title: $translate.instant('DIGITAL_FORM_FILLED'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });

                        ctrl.finished = true;
                    }
                });
            }

            var canvas = {};
            
            ctrl.init_signatures = function() {
                setTimeout( function() {
                    if ($scope.DigitalForm.data) {
                        for (var i in $scope.DigitalForm.data) {
                            if ($scope.DigitalForm.data[i].type == 'signature') {
                                var el = document.getElementById('can'+i);
                                if (el) {
                                    canvas[i] = new PortrayCanvas(el, {
                                        lineWidth: 2,
                                        period: 5,
                                        disabled: !!$scope.DigitalForm.fill_date,
                                        lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                                    });

                                    canvas[i].canvas.addEventListener("touchstart",  function(event) {event.preventDefault()})
                                    canvas[i].canvas.addEventListener("touchmove",   function(event) {event.preventDefault()})
                                    canvas[i].canvas.addEventListener("touchend",    function(event) {event.preventDefault()})
                                    canvas[i].canvas.addEventListener("touchcancel", function(event) {event.preventDefault()})
                                }
                            }
                        }
                    }
                }, 500);
            }

            ctrl.clearSign = function(index) {
                canvas[i].clear();
            }

            ctrl.init_signatures();
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalDocumentsController', function(DigitalDocument, $header, $api, $scope, $uibModalInstance, $window, $sce, $translate) {
  
            var ctrl = this;
            ctrl.sign = false;
            
            $scope.DigitalDocument = DigitalDocument.data;
            
            $scope.iframe = function(){
                return $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+$scope.DigitalDocument.url+'&embedded=true');
            };

            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.submit = function(){
                if (ctrl.sign) {
                    $api.customer_documents.save({
                        id: $scope.DigitalDocument.id,
                    }, function (response) {
                        if (response.status === "success") {
                            $scope.DigitalDocument.sign = true;

                            swal({
                                title: $translate.instant('DIGITAL_DOCUMENT_SIGNED'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    });
                }
            }
        });
})();
(function(){
    angular.module('app.controllers').controller('DashboardController', function (Customers, Info, Analytics, $api, $header, dataTablesHebrewProvider, DTOptionsBuilder, DTColumnDefBuilder, $scope, $rootScope, $translate, $state, $uibModal, uiCalendarConfig, $payment){
        $header.title = "ראשי";

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }
        var ctrl = this;
        $scope.isMobile = (angular.element(document).width() < 769);
        $scope.b_type = $rootScope.$user && $rootScope.$user ? $rootScope.$user.b_type : 1;
        $scope.showCalendar = $scope.b_type === 2;
        $scope.showIncomeByItem = $scope.b_type === 1;
        ctrl.tableOrdersData = null;
        $scope.currentDateTime = Date.now();
        var isRTL = langKey === 'hb_ISR' || langKey === 'ar_AR';
        ctrl.hide_prices = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices') ? true : false;

        ctrl.tableCustomersData = Customers ? Customers.data.map(function(row){
            var age = row.age.match(/([0-9]*)/)
            if(age.length > 1)
                row.age = age[1]
            return row
        }) : [];
        ctrl.capacityData = null;
        ctrl.apiRequest = null;

        ctrl.bar_start_date = moment().subtract(1, 'years')
        ctrl.bar_end_date = moment();
        ctrl.bar_filter = 'monthly';

        ctrl.pie_start_date = moment().subtract(1, 'months');
        ctrl.pie_end_date = moment();

        $scope.$watch('ctrl.bar_start_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsBar();
            }
        });

        $scope.$watch('ctrl.bar_end_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsBar();
            }
        });

        $scope.$watch('ctrl.pie_start_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsPie();
            }
        });

        $scope.$watch('ctrl.pie_end_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsPie();
            }
        });
        


        $scope.dtOptions =
                DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip') //.withDOM('Tgtip')
                .withOption('searching', false)
                .withLanguage(dataTablesHebrewProvider)
                //.withOption('order', [[1, 'asc']]);
                .withOption('columnDefs', [
                    { "orderable": false, "targets": 6 } 
                  ])
                .withOption('aaSorting', [])
        $scope.dtOptions.searching = false;

        $scope.dtOptionsBirth =
                DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip') //.withDOM('Tgtip')
                .withOption('searching', false)
                .withLanguage(dataTablesHebrewProvider)
                //.withOption('order', [[1, 'asc']]);
                .withOption('columnDefs', [
                    { "orderable": false, "targets": 4 } 
                  ])
                  .withOption("fnDrawCallback", function(oSettings){
                    if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                        $(oSettings.nTableWrapper).find('.dataTables_paginate, .dataTables_info').hide();
                    } else {
                         $(oSettings.nTableWrapper).find('.dataTables_paginate, .dataTables_info').show();
                    }
                })
                .withOption('aaSorting', [])
        $scope.dtOptionsBirth.searching = false;


        $scope.dtToddtOptionsyColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable()
        ];

        moment.locale("he");

        ctrl.settings = {
            resource: null,
            time: "daily",
            type: "orders",
            interval: Info ? Info.data.interval ? '00:' + String(Info.data.interval) + ':00' : '00:10:00' : '',
            date: moment(),
            datePickerView: "date",
            loading: false,
            loadingHolidays: false,
            bu_type: parseInt($rootScope.$user.b_type)
        };

        ctrl.yesterday = function() {
            return moment().subtract(1, 'days').format('DD.MM.YYYY')
        }

        ctrl.today = function() {
            return moment().format('DD.MM.YYYY')
        }

        ctrl.checkPercent = function(num1, num2) {
            if (num1 == num2)
                return 0;

            if (num2 == 0) 
                return 0;

            if (num1 == 0) {
                return 100;
            }

            var val = ((num2 - num1) / num1) * 100;

            return val ? Math.round(val) : 0;
        }

        $scope.getOptions = function(){
            return ctrl.defaults.options
        }
        $scope.getPaymentOptions = function(){
            return ctrl.paymentDefaults.options
        }

        ctrl.send_birthday_message = function(id) {
            today_birthday = {'id': id};
            btn = '.btn-birthday-' + id;
            $(btn).addClass('sending');
            $api.dashboard.get(today_birthday, function(response) {
                swal({
                  title: $translate.instant('SWAL_BIRTHDAY_MESSAGE_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $(btn).removeClass('sending');
                $(btn).remove();
            });
        };

        ctrl.extractLabels = function(labels) {
            for (var k in labels) {
                var text = labels[k];

                switch (labels[k]) {
                    case 1:
                        text = $translate.instant('CALENDAR_CASH_CASH');
                        break;
                    case 2:
                        text = $translate.instant('CALENDAR_CASH_CREDIT');
                        break;
                    case 3:
                        text = $translate.instant('CALENDAR_CASH_ON_CREDIT');
                        break;
                    case 4:
                        text = $translate.instant('CALENDAR_CASH_CHEQUE');
                        break;
                    case 5:
                        text = $translate.instant('CALENDAR_CASH_BANK_TRANS');
                        break;
                    case 6:
                        text = $translate.instant('CALENDAR_CASH_CREDIT_CARD_EXT');
                        break;
                    case 7:
                        text = $translate.instant('CALENDAR_CASH_PAY_CREDIT');
                        break;
                    case 8:
                        text = $translate.instant('CALENDAR_CASH_CREDIT');
                        break;
                    default:
                        text = k;
                }

                labels[k] = text;
            }

            return labels;
        };
        /**
         * Calendar Configuration
         */
        // $scope.calendarConfig = null;

        // if($scope.b_type == 2) {
        //     ctrl.prepare_motels_configuration();
        //     $scope.calendarConfig.nowIndicator = false;
        // }

        // charts

        ctrl.graphHeight = $scope.isMobile ? 200 : 160;
        ctrl.defaults = {
            options: {
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        stacked: true,
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        display: false
                    }
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.x) {
                        var barWidth = chart.scales.x.width / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                }
            },
        };

        ctrl.paymentDefaults = {
            options: {
                indexAxis: 'y',
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false
                        },
                    },
                    y: {
                        stacked: true,
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem) {
                                var index = tooltipItem.dataIndex;
                                var percentage = ctrl.paymentGraph.percentages[index] 
                                    ? ctrl.paymentGraph.percentages[index] 
                                    : null;
        
                                var label = tooltipItem.label || '';
                                var value = tooltipItem.raw;
        
                                return label + ': ' + value + ' (' + (percentage !== null ? percentage + '%' : '') + ')';
                            }
                        }
                    }
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.x) {
                        var barWidth = chart.scales.y.height / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                },
            },
        };

        ctrl.statsPie = {
            options: {
                responsive: true,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem) {
                                var dataset = tooltipItem.dataset;
                                var currentValue = dataset.data[tooltipItem.dataIndex];
                                var total = dataset.data.reduce(function(acc, val) {
                                    return acc + val;
                                }, 0);
                                var percentage = ((currentValue / total) * 100).toFixed();
                                return tooltipItem.label + ": " + currentValue + " (" + percentage + "%)";
                            }
                        }
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            generateLabels: function(chart) {
                                var data = chart.data;
                                return data.labels.map(function(label, index) {
                                    var value = data.datasets[0].data[index];
                                    var total = data.datasets[0].data.reduce(function(acc, val) {
                                        return acc + val;
                                    }, 0);
                                    var percentage = ((value / total) * 100).toFixed();
                                    return {
                                        text: label + " (" + percentage + "%)",
                                        fillStyle: data.datasets[0].backgroundColor[index],
                                        hidden: false,
                                        index: index,
                                    };
                                });
                            },
                            usePointStyle: true,
                        },
                        rtl: isRTL,
                    },
                },
                scales: {}
            },
        };

        ctrl.statsBar = {
            options: {
                responsive: true,
                scales: {
                    x: {
                        grid: {
                            display: false
                        }
                    },
                    y: {
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            generateLabels: function(chart) {
                                var data = chart.data;
                                return data.datasets.map(function(dataset, index) {
                                    return {
                                        text: dataset.label,
                                        fillStyle: dataset.backgroundColor,
                                        hidden: false,
                                        index: index,
                                    };
                                });
                            },
                            usePointStyle: true,
                        },
                        rtl: isRTL, 
                    },
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.x) {
                        var barWidth = chart.scales.x.width / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                },
            },
        };


        var menu_color = $rootScope.color_form && $rootScope.color_form.menu_color ? $rootScope.color_form.menu_color : '#006495';

        ctrl.paymentGraph = {
            type: "bar",
            title: "",
            category: "",
            payment_methods: $payment.methods,
            payment_method: '',
            data: {
                labels: ctrl.extractLabels(Analytics && Analytics.data && Analytics.data.paymentType ? Analytics.data.paymentType.labels : []),
                datasets: [{
                    label: '',
                    data: Analytics && Analytics.data && Analytics.data.paymentType ? Analytics.data.paymentType.values : [],
                    backgroundColor: menu_color,
                    maxBarThickness: 60,
                }],
            },
            percentages: Analytics && Analytics.data && Analytics.data.paymentType ? Analytics.data.paymentType.percentages : [],
            filter: "today",
            options: ctrl.paymentDefaults.options,
        };

        ctrl.incomeGraph = {
            type: "bar",
            title: "ניתוח הכנסות",
            category: "",
            categories: Analytics && Analytics.data ? Analytics.data.categories : [],
            resources: Analytics && Analytics.data ? Analytics.data.resources : [],
            payment_methods: $payment.methods,
            payment_method: '',
            data: {
                labels: Analytics && Analytics.data ? Analytics.data.income.labels : [],
                datasets: [{
                    label: 'הכנסות',
                    data: Analytics && Analytics.data ? Analytics.data.income.values : [],
                    backgroundColor: menu_color,
                }, {
                    label: $translate.instant("ANALYTIC_FORECAST"),
                    data: Analytics && Analytics.data ? Analytics.data.income.forecast : [],
                    backgroundColor: $rootScope.createDiagonalPattern(menu_color)
                }],
            },
            filter: "monthly",
            options: ctrl.defaults.options,
        };

        ctrl.statsPie = {
            type: "doughnut",
            data: {
                labels: Analytics && Analytics.data && Analytics.data.statsPie ? Analytics.data.statsPie.labels : [],
                datasets: [{
                    label: '',
                    data: Analytics && Analytics.data && Analytics.data.statsPie ? Analytics.data.statsPie.values : [],
                    backgroundColor: Analytics && Analytics.data && Analytics.data.statsPie ? Analytics.data.statsPie.colors : [],
                }],
            },
            options: ctrl.statsPie.options,
        };

        var datasetsBar = [];
        if (Analytics && Analytics.data && Analytics.data.statsBar && Analytics.data.statsBar.values) {
            for (var key in Analytics.data.statsBar.values) {
                datasetsBar.push({
                    label: Analytics.data.statsBar.values[key].name,
                    data: Analytics.data.statsBar.values[key].values,
                    backgroundColor: Analytics.data.statsBar.values[key].color || menu_color,
                    maxBarThickness: 60,
                });
            }
        }

        ctrl.statsBar = {
            type: "bar",
            data: {
                labels: Analytics && Analytics.data && Analytics.data.statsBar ? Analytics.data.statsBar.periods : [],
                datasets: datasetsBar,
            },
            options: ctrl.statsBar.options,
        };

        var items_values = Analytics && Analytics.data ? Analytics.data.daily_income_by_items.values : [];
        var items_labels = Analytics && Analytics.data ? Analytics.data.daily_income_by_items.labels : [];

        if(Analytics && Analytics.data && Analytics.data.daily_income_by_items.values.length>0) {
            for(var i=0; i<items_values.length-1;i++) {
                for( var j=i+1; j<items_values.length;j++){
                    if(items_values[i] < items_values[j]) {
                        var temp_label = items_labels[i];
                        items_labels[i] = items_labels[j];
                        items_labels[j] = temp_label;
                        var temp_value = items_values[i];
                        items_values[i] = items_values[j];
                        items_values[j] = temp_value;
                    }
                }
            }
        }
        ctrl.dailyIncomeByItemGraph = {
            // "title": "ניתוח הכנסות",
            type: "bar",
            data: {
                labels: items_labels,
                datasets: [{
                    label: 'הכנסות',
                    data: items_values,
                    backgroundColor: menu_color,
                    maxBarThickness: 60,
                }],
            },
            options: ctrl.defaults.options,
        }
        ctrl.dailyIncome = Analytics && Analytics.data ? Analytics.data.income.widget.daily : 0;
        ctrl.dailyOrders = Analytics && Analytics.data ? Analytics.data.orders.widget.daily : 0;
        ctrl.yesterdayIncome = Analytics && Analytics.data ? Analytics.data.income.widget.yesterday : 0;
        ctrl.yesterdayOrders = Analytics && Analytics.data ? Analytics.data.orders.widget.yesterday : 0;

        ctrl.loadAnalytics = function(dataType, filter) {
            if(filter) {
                ctrl.incomeGraph.filter = filter;
            }
            // build request body
            var request = {
                filter: ctrl.incomeGraph.filter,
                type: dataType
            }
            if(ctrl.incomeGraph.category && ctrl.incomeGraph.category != '') {
                request.category = ctrl.incomeGraph.category;
            }
            if(ctrl.incomeGraph.resource && ctrl.incomeGraph.resource != '') {
                request.resource = ctrl.incomeGraph.resource;
            }
            if(ctrl.incomeGraph.payment_method && ctrl.incomeGraph.payment_method != '') {
                request.payment_method = ctrl.incomeGraph.payment_method;
            }
            $api.analytics.get(request,
                function(response) {
                    ctrl.incomeGraph.data.labels = response.data[dataType].labels;
                    ctrl.incomeGraph.data.datasets[0].data = response.data[dataType].values;

                    if (response.data[dataType].forecast) {   
                        ctrl.incomeGraph.data.datasets[1].data = response.data[dataType].forecast;
                    }

                    ctrl.incomeGraph.options = angular.copy(ctrl.incomeGraph.options);
                });
        };

        ctrl.loadStatsBar = function() {
            var request = {
                type: 'statsBar',
                start: ctrl.bar_start_date.format('YYYY-MM-DD'),
                end: ctrl.bar_end_date.format('YYYY-MM-DD'),
                period: ctrl.bar_filter,
            };
            $api.analytics.get(request,
                function(response) {

                    var datasetsBar = [];
                    if (response.data.statsBar && response.data.statsBar.values) {
                        for (var key in response.data.statsBar.values) {
                            datasetsBar.push({
                                label: response.data.statsBar.values[key].name,
                                data: response.data.statsBar.values[key].values,
                                backgroundColor: response.data.statsBar.values[key].color || menu_color,
                                maxBarThickness: 60,
                            });
                        }
                    }

                    ctrl.statsBar.data.labels = response.data.statsBar.periods;
                    ctrl.statsBar.data.datasets = datasetsBar;

                    ctrl.statsBar.options = angular.copy(ctrl.statsBar.options);
                });
        };

        ctrl.loadStatsPie = function() {
            var request = {
                type: 'statsPie',
                start: ctrl.pie_start_date.format('YYYY-MM-DD'),
                end: ctrl.pie_end_date.format('YYYY-MM-DD'),
            };
            $api.analytics.get(request,
                function(response) {

                    ctrl.statsPie.data.labels = response.data.statsPie.labels;
                    ctrl.statsPie.data.datasets[0].data = response.data.statsPie.values;
                    ctrl.statsPie.data.datasets[0].backgroundColor = response.data.statsPie.colors;

                    ctrl.statsPie.options = angular.copy(ctrl.statsPie.options);
                });
        };

        ctrl.loadAnalyticsPaymentType = function() {
            dataType = 'paymentType';
            
            // build request body
            var request = {
                filter: ctrl.paymentGraph.filter,
                type: dataType
            }
            $api.analytics.get(request,
                function(response) {
                    ctrl.paymentGraph.data.labels = ctrl.extractLabels(response.data[dataType].labels);
                    ctrl.paymentGraph.data.datasets[0].data = response.data[dataType].values;
                    ctrl.paymentGraph.percentages = response.data[dataType].percentages;

                    ctrl.paymentGraph.options = angular.copy(ctrl.paymentGraph.options);
                });
        };

        $rootScope.$on('change-language', function(event, langKey){
            $scope.langKey = langKey
            if (uiCalendarConfig && uiCalendarConfig.calendars && uiCalendarConfig.calendars.mainCalendar) {
                uiCalendarConfig.calendars.mainCalendar.fullCalendar("option", "isRTL", langKey === 'hb_ISR' || langKey === 'ar_AR');
            }
        });

        $scope.$on('chart-create', function (event, chart) {
            chart.chart.height = 500;
            // console.log(chart.chart)
        });

        /**
         * Opens "Edit Order" form
         */
        ctrl.edit_order_form = function(order_id) {

            $uibModal.open({
                templateUrl: "app/modules/calendar/order/order.form.html",
                controller: "OrderFormController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                resolve: {
                    Items: function($api) {
                        return $api.resolve("items.items_with_duration@get");
                    },
                    Customers: function($api) {
                        return $api.resolve("customers@get");
                    },
                    Resources: function($api) {
                        return $api.resolve("resources@get");
                    },
                    SecondResources: function($api) {
                        return $api.resolve("second_resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Clubs: function($api) {
                        return $api.resolve("settings.clubs@get");
                    },
                    Customer: function($api) {
                        return null;
                    },
                    Order: function($api) {
                        return $api.resolve("orders.single@get", {
                            "id": order_id
                        });
                    },
                    Messages:  function($api) {
                        return $api.resolve("settings.messages@get");
                    },
                    CalendarCourse: null,
                    CalendarEvent: null,
                    EventCopy: false,
                    CoursesFields: ['$api', function ($api) {
                        return $api.resolve('coursesFields.lists@get');
                    }],
                }
            }).closed.then(function() {
                ctrl.tableOrdersData = null;
                ctrl.load_next_orders();
                ctrl.get_orders_capacity();
            });
        };

        /**
         * Loading next orders data
         */
        ctrl.load_next_orders = function() {
            return $api.orders.today_orders.get({},
                function(response) {
                    // duration = moment.duration(ctrl.form.items[itemIndex].end_time.diff(ctrl.form.items[itemIndex].start_time));
                    for (var i=0; i<response.data.length; i++) {
                        if($scope.b_type == 2) {
                            var start_time = moment(response.data[i].start_time);
                            var end_time = moment(response.data[i].end_time);
                            var duration = moment.duration(end_time.diff(start_time));
                            response.data[i].nights = Math.round(duration.asDays());
                            response.data[i].date = response.data[i].start_time;
                            response.data[i].start_time = moment(response.data[i].start_time).format('DD/MM/YYYY');
                        } else {
                            //response.data[i].start_time = moment(response.data[i].start_time).format('HH:mm');
                        }
                    }
                    ctrl.tableOrdersData = response.data;
                });
        }

        /**
         * Triggers when event is rendered on the calendar
         * @param {Object} event Event object
         * @param {jQuery} element  jQuery element
         * @return {void}
         */
        ctrl.event_render = function(event, element){
            if(event.order_status == 2){
                element.append('<i class="fa fa-clock-o"></i>');
            }else if(event.order_status == 3){
                element.append('<i class="fa fa-money"></i>');
                element.css('background-color', '#e4e4e4');
                element.addClass('calendar-order-completed');
            }
        };


        /**
         * Preparing neccesary configuration for the motels calendar UI
         * @return object
         */
        ctrl.prepare_motels_configuration = function(isRTL) {

            return {
                // resourceAreaWidth: 230,
                editable: true,
                aspectRatio: 1.5,
                scrollTime: '00:00',
                firstDay: 0,
                locale: 'he',
                defaultView: 'customWeek',
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                views: {
                    customWeek: {
                        type: 'timeline',
                        duration: { weeks: 1 },
                        slotDuration: { days: 1 }
                    }
                },
                height: 200,
                dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                dayNamesShort: ["'א", "'ב", "'ג", "'ד", "'ה", "'ו", "'ש"],
                isRTL: isRTL,
                events: [],
                axisFormat: 'HH:mm',
                resources: ctrl.uiResources,
                resourceLabelText: 'משאבים',
                eventResize: ctrl.handle_item_drag_resize,
                eventDrop: ctrl.handle_item_drag_resize,
                header: {
                    left: '',
                    center: '',
                    right: ''
                },
                dayRender: ctrl.day_render,
                eventRender: ctrl.event_render,
                // viewRender: function() {
                //     setTimeout(ctrl.timeline_view_hover, 200);
                // },
                // eventClick: function(event) {
                //     ctrl.edit_order_form(event.orderId);
                // },
                // dayClick: function(date, jsEvent, view, resourceObj) {
                //     if(ctrl.settings.time == "monthly") {
                //         ctrl.change_calendar_type("orders");
                //         ctrl.change_calendar_time("weekly");
                //         ctrl.settings.date = new Date(date.format());
                //         uiCalendarConfig.calendars.mainCalendar.fullCalendar("gotoDate", date);
                //     } else {
                //         if(resourceObj) {
                //             ctrl.open_order_form(date, resourceObj.id);
                //         } else {
                //             ctrl.open_order_form(date);
                //         }
                //     }
                // }
            };
        };


        /**
         * Triggers the API call to retreive capacity information
         * @return {void}
         */
        ctrl.get_orders_capacity = function() {
            //stop orders capacity
            return;
            
            var date = new Date(ctrl.settings.date);

            ctrl.settings.loading = true;

            if(ctrl.apiRequest != null)
                ctrl.apiRequest.$cancelRequest();

            ctrl.apiRequest = $api.orders.capcaity.get({
                date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
            }, function(response) {
                ctrl.settings.loading = false;
                ctrl.capacityData = response.data;
                ctrl.set_capacity_colors();
                ctrl.apiRequest = null;
            });
        };

        /**
         * Sets the color for each day according to its capacity
         */
        ctrl.set_capacity_colors = function() {
            var
                color,
                capacity_to_check,
                slots_string;

            for(var i in ctrl.capacityData) {

                if(ctrl.settings.resource)
                    capacity_to_check = ctrl.capacityData[i][parseInt(ctrl.settings.resource)];
                else
                    capacity_to_check = ctrl.capacityData[i]["global"];

                if(capacity_to_check.percentage < 75)
                    color = "green";
                else if(capacity_to_check.percentage < 90)
                    color = "orange";
                else
                    color = "red";

                slots_string = (capacity_to_check.total_slots - capacity_to_check.taken_slots) + "/" + (capacity_to_check.total_slots) + " (" + capacity_to_check.percentage + "% תפוסה)";

                $(".day-" + i).addClass("day-capacity-" + color).attr("data-slots", slots_string);
            }
        };

        ctrl.load_next_orders();
        ctrl.get_orders_capacity();

        ctrl.hexToRgbA = function(hex){
            var c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c= hex.substring(1).split('');
                if(c.length== 3){
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
            }
            return 'rgba(169,207,232,0.1)';
        }
    });


})();

(function () {

    angular.module('app.controllers')

        .controller('CalendarEventController', function(Order, $timeout, $header, $api, $scope, $window, $translate) {
  
            var ctrl = this;

            function compareTimes(a, b) {
                if (a.start_time < b.start_time) return -1;
                if (a.start_time > b.start_time) return 1;
                return 0;
            }

            ctrl.order = Order && Order.data ? Order.data : false
            ctrl.first_item = {};
            ctrl.start = '';
            ctrl.end = '';
            ctrl.tz = '';
            ctrl.utcOffset = '';

            if (ctrl.order && ctrl.order.items) {
                ctrl.order.items.sort(compareTimes);
                ctrl.first_item = ctrl.order.items[0];
                for (var i in ctrl.order.items) {
                    var $item = ctrl.order.items[i];
                    var type_current = $item.item_data && $item.item_data.item_type ? $item.item_data.item_type : $item.item_type;
                    var type_first = ctrl.first_item.item_data && ctrl.first_item.item_data.item_type ? ctrl.first_item.item_data.item_type : ctrl.first_item.item_type;
                    if (!ctrl.first_item || type_first !== 'service' || 
                        (type_current === 'service' && $item['start_time'] && 
                        new Date($item['start_time']).getTime() < new Date(ctrl.first_item['start_time']).getTime())) {
                        ctrl.first_item = $item;
                    }
                }
                ctrl.date = moment(ctrl.first_item.start_time).format('YYYY-MM-DD');
                ctrl.start = moment(ctrl.first_item.start_time).format('HH:mm');
                ctrl.end = moment(ctrl.first_item.end_time).format('HH:mm');
                ctrl.tz = moment(ctrl.first_item.start_time).tz();
                ctrl.utcOffset = moment(ctrl.first_item.start_time).format('Z');

                $timeout(function() { atcb_init(); }, 100);
            }
        });
        
})();
(function () {
    angular.module('app.controllers')

        .controller('CalendarController', function ($header, $interval, $scope, $rootScope, Info, Lflag, $date, $filter,
            Holidays, dates, Resources, Customer, $translate, uiCalendarConfig, $uibModal, $api, $color, $state, $stateParams, $timeout, $compile, HebrewDate) {
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            // It's Ugly, no need it for now
            // var tooltip = $('<div/>').qtip({
            //     id: 'fullcalendar',
            //     prerender: true,
            //     content: {
            //         text: ' ',
            //         title: ' '
            //     },
            //     position: {
            //         my: 'bottom center',
            //         at: 'top center',
            //         target: 'mouse',
            //         viewport: $('#fullcalendar'),
            //         adjust: {
            //             mouse: false,
            //             scroll: false
            //         }
            //     },
            //     show: false,
            //     hide: false,
            //     style: 'qtip-light'
            // }).qtip('api');
            if ($rootScope.userRole == 1) {
                $state.go('app.admin', {}, { reload: true });
                return;
            }

            $scope.clientEvents = []; // all Events
            $scope.isMobile = (angular.element(document).width() < 769);

            var ctrl = this;
            ctrl.showCapacityButton = true;
            ctrl.moved_order = false;
            ctrl.copied_order = false;
            ctrl.isSearching = false;
            ctrl.isExpanded = false;

            ctrl.activateSearch = function () {
                $timeout(function () {
                    ctrl.isSearching = true;

                    $timeout(function () {
                        var input = document.querySelector('.find-event-input');
                        if (input) {
                            input.focus();
                        }
                    });
                });
            };

            moment.locale("he");
            ctrl.settings = {
                resource: null,
                time: "daily",
                type: "orders",
                interval: Info.data.interval ? '00:' + String(Info.data.interval) + ':00' : '00:10:00',
                date: ($stateParams.date) ? moment($stateParams.date) : moment(),
                scrollTime: (($stateParams.date) ? moment($stateParams.date) : moment()).subtract(60, 'minutes').format("HH") + ":00:00",
                datePickerView: "date",
                view: ($stateParams.view && $stateParams.view == 'view'),
                loading: false,
                loadingHolidays: false,
                bu_type: parseInt(Info.data.type),
                allow_online_booking: parseInt(Info.data.allow_online_booking),
                minTime: Info.data.min_time ? Info.data.min_time : "07:00:00",
                maxTime: Info.data.max_time ? Info.data.max_time : "21:00:00",
                exist_bookings: Info.data.exist_bookings,
                holiday_color: Info.data.holiday_color,
                resource: [],
            };

            ctrl.apiRequest = null;

            if (parseInt(Info.data.interval) == 60) {
                ctrl.settings.interval = "01:00:00";
            }
            if (parseInt(Info.data.interval) == 90) {
                ctrl.settings.interval = "01:30:00";
            }
            if (ctrl.settings.bu_type == 1) {
                ctrl.showCapacityButton = false;
            }
            if (ctrl.settings.bu_type == 2) {
                ctrl.settings.interval = "24:00:00";
                // ctrl.settings.time = "monthly";
                ctrl.settings.time = "weekly";
            }

            if ($stateParams.date) {
                //ctrl.settings.date = moment($stateParams.date);

            }

            $scope.events = [];
            $scope.resources = Resources.data;
            $scope.todayCapacity = {};

            ctrl.uiResources = [];

            ctrl.capacityData = null;
            var orderById = true;

            for (var i in $scope.resources) {
                ctrl.uiResources.push({
                    id: $scope.resources[i].id,
                    title: $scope.resources[i].name,
                    avatar: $scope.resources[i].avatar
                });

                if ($scope.resources[i].order * 1) orderById = false;
            }

            if (orderById) {
                ctrl.uiResources.sort(function (a, b) {
                    return a['id'] - b['id'];
                });
            }

            $scope.$watch("ctrl.settings.date", function (newValue, oldValue) {
                if (document.activeElement) {
                    if (!document.querySelector('.inputs-wrapper .date-picker-date-time')) {
                        document.activeElement.blur();
                    }
                }
            });

            ctrl.holidays = {};
            var current_year = new Date().getFullYear();
            if (Holidays.data) {
                ctrl.holidays[current_year] = Holidays.data.holidays;
            } else {
                ctrl.holidays[current_year] = [];
            }
            for (var i in ctrl.holidays[current_year]) {
                if (ctrl.holidays[current_year][i].length == 0)
                    delete ctrl.holidays[current_year][i];
            }
            /**
             * Loading holidays dates and names for the current year to the "ctrl.holidays" object
             * @return {void}
             */

            ctrl.load_holidays = function () {

                var year = ctrl.settings.date.format("YYYY");

                if (!ctrl.holidays[year]) {

                    ctrl.settings.loadingHolidays = true;

                    $api.holidays.get({
                        year: year
                    }, function (response) {

                        ctrl.settings.loadingHolidays = false;

                        if (response.status == "success") {

                            ctrl.holidays[year] = response.data.holidays;
                            //$("#mainCalendar").fullCalendar("prev");
                            //$("#mainCalendar").fullCalendar("next");

                            ctrl.initDisplayDate(ctrl.settings.date);
                        }
                    });
                }
            };


            $('#header-wrapper').toggleClass('hide-header', ctrl.isExpanded);
            $('#wrapper').toggleClass('calendar-expanded', ctrl.isExpanded);
            ctrl.expandCalendar = function() {
                ctrl.isExpanded = !ctrl.isExpanded;
                $('#header-wrapper').toggleClass('hide-header', ctrl.isExpanded);
                $('#wrapper').toggleClass('calendar-expanded', ctrl.isExpanded);
            };


            //call modal

            if ($state.current.name == 'app.calendar.call') {

            }


            /**
             * Return holiday information of given date
             * @param {Moment} date Moment.js date
             */
            ctrl.get_date_holiday = function (date) {

                var
                    fullDate = date.format("YYYY-MM-DD"),
                    year = date.format("YYYY"),
                    isHoliday = false,
                    holidayName = null;

                if (ctrl.holidays[year]) {
                    if (ctrl.holidays[year][fullDate]) {
                        if (ctrl.holidays[year][fullDate][0] && ctrl.holidays[year][fullDate][0].name) {
                            isHoliday = true;
                            holidayName = $filter('hebrewHolidayName')(ctrl.holidays[year][fullDate][0].name);
                        }
                    }
                    else {
                        for (var i in ctrl.holidays[year]) {
                            if (ctrl.holidays[year][i][0] != undefined) {
                                var startDate = moment(ctrl.holidays[year][i][0].date),
                                    endDate = moment(ctrl.holidays[year][i][0].observed);

                                if (startDate.unix() <= date.unix() && date.unix() <= endDate.unix()) {
                                    isHoliday = true;
                                    holidayName = $filter('hebrewHolidayName')(ctrl.holidays[year][i][0].name);
                                }
                            }
                        }
                    }
                }

                if (isHoliday) {
                    var days = document.getElementsByClassName("fc-widget-content");
                    if (days) {
                        for (var i = 0; i < days.length; i++) {
                            if (days[i].dataset.date == fullDate) {
                                days[i].className += ' fc-holiday';
                                if (ctrl.settings.holiday_color) {
                                    days[i].style.background = ctrl.settings.holiday_color;
                                }
                            }
                        }
                    }
                }

                return {
                    isHoliday: isHoliday,
                    holidayName: holidayName
                };
            }

            /**
             * Triggers when event is been dragged across the calendar
             * @param {Object} event New event object
             * @param {Object} delta Previous event object
             * @param {Function} revertFunc Callback to abort dragging or resize
             */
            ctrl.handle_item_drag_resize = function (event, delta, revertFunc) {
                var originalEvent;
                for (var i = 0; i < $scope.clientEvents.length; i++) {
                    if ($scope.clientEvents[i].id == event.id) {
                        originalEvent = $scope.clientEvents[i];
                        break;
                    }
                }

                if (Info.data.update_order_notification == 2 && event.type != 'event' && event.type != 'course' && originalEvent.start && moment(event.start).format("YYYY-MM-DD HH:mm") != moment(originalEvent.start).format("YYYY-MM-DD HH:mm")) {
                    swal({
                        text: $translate.instant('CALENDAR_UPDATE_ORDER_NOTIFICATION'),
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('OPTION_YES'),
                        cancelButtonText: $translate.instant('OPTION_NO')
                    }).then(function (result) {
                        ctrl.submit_update_order(event, delta, revertFunc, result.value);
                    });
                } else {
                    ctrl.submit_update_order(event, delta, revertFunc);
                }
            };

            ctrl.submit_update_order = function (event, delta, revertFunc, send_notification) {
                var start = moment(event.start);
                var end = moment(event.end);
                
                if (event.type == 'event') {
                    var event_data = {};
                    event_data.start_date_time = start.format("YYYY-MM-DD HH:mm");
                    event_data.end_date_time = end.format("YYYY-MM-DD HH:mm");
                    event_data.resource_id = event.resourceId;

                    $api.events.single.save({
                        "id": event.eventId
                    }, event_data, function (response) {
                        if (response.status !== "success") {
                            revertFunc();
                        }
                    });
                } else if (event.type == 'course') {
                    var data = {};
                    data.start_date_time = start.format("YYYY-MM-DD HH:mm");
                    data.end_date_time = end.format("YYYY-MM-DD HH:mm");
                    data.resource_id = event.resourceId;
                    data.id = event.id;
                    data.type = "meeting";

                    $api.courses.single.save({
                        "id": event.courseId,
                    }, data, function (response) {
                        if (response.status !== "success") {
                            revertFunc();
                        }
                    });
                } else {
                    var difference = false;
                    if (event.merged) {
                        difference = moment(event.original_start_time).diff(start, 'minutes')*-1;
                        end = start.clone().add(event.duration, 'minutes');
                    }

                    $api.orders.single.save({
                        "id": event.orderId
                    }, {
                        "type": "item",
                        "start": start.format("YYYY-MM-DD HH:mm"),
                        "end": end.format("YYYY-MM-DD HH:mm"),
                        "item": event.id,
                        "resource": event.resourceId,
                        "send_notification": send_notification ? 1 : 0
                    }, function (response) {
                        if (response.status !== "success") {
                            revertFunc();
                        } else {
                            if (event.merged && difference) {
                                for (var i in event.merged) {
                                    var merged_event = event.merged[i];
                                    start = moment(merged_event.start_time).add(difference, 'minutes');
                                    end = moment(merged_event.end_time).add(difference, 'minutes');
            
                                    $api.orders.single.save({
                                        "id": event.orderId
                                    }, {
                                        "type": "item",
                                        "start": start.format("YYYY-MM-DD HH:mm"),
                                        "end": end.format("YYYY-MM-DD HH:mm"),
                                        "item": merged_event.id,
                                        "resource": event.resourceId,
                                        "send_notification": 0
                                    }, function (response) {
                                        if (response.status !== "success") {
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            };

            /**
             * Handles FullCalendar dayRender event
             * @param {Moment} date
             * @param {jQuery} cell
             * @return {void}
             */
            ctrl.day_render = function (date, cell) {

                if (cell) {
                    cell.addClass("day-" + date.date());
                }

                var fullDate = date.format("YYYY-MM-DD"), dateHoliday = ctrl.get_date_holiday(moment(date));

                if (dateHoliday.isHoliday) {

                    if (cell) {
                        if (ctrl.settings.time == "monthly") {
                            cell.addClass("is-holiday");
                        }
                    }
                    else {
                        // $('.fc-bg .fc-day[data-date="' + fullDate + '"]').addClass("is-holiday");
                    }

                    $('.fc-widget-header[data-date="' + fullDate + '"]').addClass("is-holiday");
                    $('.fc-day-top[data-date="' + fullDate + '"]').addClass("is-holiday-number");
                }

                if (ctrl.settings.time == "weekly") {

                    var dateText = date.format("<b>dd DD</b>");

                    if ($rootScope.display_hebrew_dates) {
                        dateText += "<small>"+HebrewDate.getHebrewFormatDateName(date.toDate())+"</small>";
                    } else {
                        dateText += "<br />";
                    }

                    if (dateHoliday.isHoliday)
                        dateText += "<small class='holiday-name'>" + dateHoliday.holidayName + "</small>";

                    // Motels
                    $('th.fc-widget-header[data-date="' + fullDate + '"] .fc-cell-content').html(dateText);

                    // Stores
                    $('th.fc-day-header[data-date="' + fullDate + '"] > span').html(dateText).addClass('flex-column');

                    return dateText;
                } else if (ctrl.settings.time == "monthly") {
                    $('.fc-day-top[data-date="' + fullDate + '"]').append($("<span/>").addClass("holiday-name").text(dateHoliday.holidayName));
                    $('span.fc-day-number').css('float', 'left');
                    $('span.holiday-name').css('float', 'right');
                } else {
                    $(".fc-resource-cell").each(function () {
                        if ($(this).data('resource-id')) {
                            for (var i in ctrl.uiResources) {
                                if (ctrl.uiResources[i].id == $(this).data('resource-id')) {
                                    $(this).prepend('<div class="customer-pic-wrapper calendar"><img src="' + (ctrl.uiResources[i].avatar ? ctrl.uiResources[i].avatar : "assets/images/avatar.jpg") + '" class="customer-pic"></div>');
                                    $(this).html('<div class="calendar-resourse">' + $(this).html() + '</div>');
                                }
                            }
                        }
                    });
                }

                if (cell) {
                    cell.mouseover(function (event) {
                        date = new Date(date);
                        $api.orders.calendar.get({
                            date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                            range: "weekly"
                        }, function (response) {
                            if (response.data.length > 0) {
                                var temp = '<p style="float:left;"><div style="width:8px;background-color:#2D9EE6;height:8px;float:left;border-radius:4px;margin-top:5px;"></div><h3 style="float:left;margin:0;font-size:14px;color:#14384F;">';
                                var content = '';
                                for (var i in response.data) {
                                    var eventName = '';
                                    if (response.data[i].order_customer) {
                                        eventName = response.data[i].order_customer_firstname;
                                        eventName += response.data[i].order_customer_lastname ? " " + response.data[i].order_customer_lastname : '';
                                    } else {
                                        // TODO: use translation
                                        eventName = "לקוח מזדמן";
                                    }
                                    content += temp + eventName + ', ' + (response.data[i].part ? response.data[i].item_data.name_second : response.data[i].item_data.name) + '</h3></p>';
                                }
                                // tooltip.set({
                                //     'content.text': content,
                                //     'content.title': monthNames[date.getMonth()]
                                // }).reposition(event).show(event);
                            }
                        });
                    });
                    cell.mouseleave(function () {
                        //tooltip.hide();
                    });
                }
            };

            ctrl.afterAllRender = function () {
                setTimeout(function () {
                    date = new Date();
                    $('.fc-customWeek-view table tbody  .fc-time-area').find('[data-resource-id]').each(function () {
                        $(this).find('div[class=temp-cells] div').eq(date.getDay()).addClass('today-color');
                    });

                }, 4000);
            };

            /**
             * Triggers when event is rendered on the calendar
             * @param {Object} event Event object
             * @param {jQuery} element  jQuery element
             * @return {void}
             */

            ctrl.event_render = function (event, element) {
                ctrl.scrollToTime();

                // Handle HTML in event title
                if (event.title && event.title.includes('<i class="las la-ticket-alt')) {
                    element.find('.fc-title').html('<span>'+event.title+'</span>');
                }

                var dataItem = ''
                if (event.type == 'event') {
                    dataItem = 'event-' + event.eventId;
                } else if (event.type == 'course') {
                    dataItem = 'course-' + event.courseId;
                } else {
                    dataItem = 'order-' + event.orderId;
                }

                if (dataItem != '') {
                    element.attr('data-item', dataItem);
                }

                var found_c = false;
                if (ctrl.settings.time === 'monthly') {
                    if (event.type = 'event') {
                        // For not an orders - Events
                        element.append('<i class="calendar-status-1"></i>');
                        element.css('background-color', '#f2f6ff');
                        element.addClass('calendar-order-completed');
                        found_c = true;
                    }
                } else {
                    if (event.type == 'event') {
                        // For not an orders - Events
                        //$(element).addClass('status-simple');
                        $(element).css('background-color', $rootScope.color_form.calendar_event_color);
                        $(element).css('border-color', $color.pSBC(-0.4, $rootScope.color_form.calendar_event_color));
                        found_c = true;
                    }
                }

                var top_icons = $('<div class="event-top-icons"></div>');
                var bottom_icons = $('<div class="event-bottom-icons"></div>');

                if (event.approved == 1) {
                    bottom_icons.append('<i class="las la-thumbs-up" style="color: red;"></i>');
                } else if (event.approved == 2) {
                    bottom_icons.append('<i class="las la-thumbs-up" style="color: green;"></i>');
                }
                if (event.order_status == 2) {
                    // element.append('<i class="fa fa-clock-o"></i>');
                } else if (event.order_status == 3) {
                    found_c = true;
                    if (!(event.pay_link && event.pay_link == 2)) {
                        top_icons.append('<i class="las la-money-bill"></i>');
                    }
                    element.css('background-color', '#e4e4e4');
                    element.addClass('calendar-order-completed');
                } else if (event.order_status == 4) {
                    found_c = true;
                    top_icons.append('<i class="fa fa-question-circle-o"></i>');
                    element.css('background-color', '#fff!important');
                    element.addClass('calendar-customer-booking');
                }

                if ((event.pay_link && (event.pay_link == 1 || event.pay_link == 2)) || (event.prepaid && event.order_price == event.prepaid)) {
                    var pay_link_color = 'red';
                    pay_link_color = event.pay_link == 2 || (event.prepaid && event.order_price == event.prepaid) ? 'green' : pay_link_color;
                    top_icons.append('<i class="las la-hand-holding-usd ' + (pay_link_color) + '"></i>');
                }

                if (event.feedback_id) {
                    top_icons.append('<i class="las la-star"><span>' + event.feedback_stars + '</span></i>');
                }

                if (event.order_notes && event.order_notes != '') {
                    bottom_icons.append('<span tooltip2-size="large" tooltip2="'+event.order_notes.replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/"/g, "&quot;")
                        .replace(/'/g, "&#39;")
                        .replace(/\n/g, "<br>")+'"><i class="las la-comment"></i></span>');
                }

                if (event.prepaid && event.prepaid * 1 > 0 && !(event.order_price == event.prepaid)) {
                    bottom_icons.append('<i class="las la-credit-card green"><span></span></i>');
                } else if (event.request_prepaid) {
                    bottom_icons.append('<i class="las la-credit-card red"><span></span></i>');
                }

                if (event.online && event.order_status != 4) {
                    top_icons.append('<i class="las la-mobile"><span></span></i>');
                }

                var time_card = '';

                if (event.card_balance && !event.merged) {
                    bottom_icons.append('<i class="las la-ticket-alt customers-has-chards' + (event.expired ? ' expired' : '') + '"><span></span></i>');
                }

                if ($rootScope.display_order_user && event.created_at && event.user_name) {
                    bottom_icons.append('<span tooltip2="'+event.user_name+' - '+event.created_at+'"><i class="las la-eye"></i></span>');
                }

                if (event.start && event.end) {
                    time_card += moment(event.start).format('H:mm') + ' - ' + moment(event.end).format('H:mm');
                }

                var duration = moment(event.end, "YYYY-MM-DD HH:mm:ss").diff(moment(event.start, "YYYY-MM-DD HH:mm:ss"), 'minutes');

                if (duration > Info.data.interval) {
                    element.append('<p class="c-event-time">' + time_card + '</p>');
                } else {
                    element.attr('tooltip', time_card);
                    element.addClass('have-tooltip');
                }

                if (!found_c) {
                    element.css("border-color", event.backgroundColor);
                    element.css("background", 'transparent linear-gradient(180deg, ' + pSBC(0.1, event.backgroundColor) + ' 0%, ' + pSBC(0.25, event.backgroundColor) + ' 100%) 0% 0% no-repeat padding-box').css("opacity", 1);
                }

                if (event.avatar) {
                    element.find('.fc-title').prepend('<div class="order-avatar" style="background-image: url(' + event.avatar + '); background-size: cover; background-repeat: no-repeat; background-position: center;"></div>');
                }

                if (event.type == 'course' && event.secondResourceTitle && event.secondResourceId) {
                    element.find('.fc-title').after('<div class="fc-second-resource">' + event.secondResourceTitle + ': ' + event.secondResourceName + '</div>');
                }

                if (event.approval_sent == 3) {
                    element.addClass("not-arrived");
                }

                //for make tooltip workable
                $compile(bottom_icons.contents())($scope);

                element.append(top_icons);
                element.append(bottom_icons);

                if (!event.part && !event.imported && event.type != 'course') {
                    var options = $('<div class="event-options"></div>');
                    options.append('<label for="itm-' + (event.id ? event.id : event.eventId) + '" class="event-options-dots"><i></i><i></i><i></i></label><input type="checkbox" id="itm-' + (event.id ? event.id : event.eventId) + '">');
                    var options_menu = $('<div class="event-options-menu"></div>');

                    options_menu.append('<span class="move-event"><i class="las la-arrows-alt"></i>' + $translate.instant('CALENDAR_EVENT_MOVE') + '</span>');
                    options_menu.append('<span class="copy-event"><i class="las la-copy"></i>' + $translate.instant('CALENDAR_EVENT_COPY') + '</span>');
                    if ($rootScope.cashbox_available && [3, 4].indexOf(event.status) === -1) {
                        options_menu.append('<span class="checkout-event"><i class="las la-hand-holding-usd"></i>' + $translate.instant('CALENDAR_EVENT_CHECKOUT') + '</span>');
                    }
                    options.append(options_menu);

                    element.append(options);
                }

                element.append('<span data-item="' + (event.id ? event.id : event.eventId) + '" class="fororder-' + event.orderId + '" class="hidden"></span>');
            };

            var pSBC = function (p, c0, c1, l) {
                var r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
                if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
                if (!this.pSBCr) this.pSBCr = function (d) {
                    var n = d.length, x = {};
                    if (n > 9) {
                        d = d.split(","), n = d.length;
                        r = d[0] ? d[0] : '';
                        g = d[1] ? d[1] : '';
                        b = d[2] ? d[2] : '';
                        a = d[3] ? d[3] : '';
                        if (n < 3 || n > 4) return null;
                        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
                    } else {
                        if (n == 8 || n == 6 || n < 4) return null;
                        if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
                        d = i(d.slice(1), 16);
                        if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
                        else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
                    } return x
                };
                h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
                if (!f || !t) return null;
                if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
                else r = m(Math.pow((P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2)), 0.5)), g = m(Math.pow((P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2)), 0.5)), b = m(Math.pow((P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2)), 0.5));
                a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
                if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
                else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
            };

            /**
             * Preparing neccesary configuration for the motels calendar UI
             * @return object Rooms
             */


            ctrl.prepare_motels_configuration = function (isRTL) {

                return {
                    // resourceAreaWidth: 230,
                    eventLimit: true,
                    editable: true,
                    aspectRatio: 1.5,
                    scrollTime: '00:00',
                    firstDay: 0,
                    locale: 'he',
                    defaultView: 'customWeek',
                    schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                    views: {
                        customWeek: {
                            type: 'timeline',
                            duration: { weeks: 1 },
                            slotDuration: { days: 1 }
                        },
                        month: {
                            eventLimit: 3,
                        }


                    },
                    height: $(window).height() - 100,
                    dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                    dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                    isRTL: isRTL,
                    events: [],
                    minTime: ctrl.settings.minTime,
                    maxTime: ctrl.settings.maxTime,
                    axisFormat: 'HH:mm',
                    resources: ctrl.uiResources,
                    resourceLabelText: 'משאבים',
                    eventResize: ctrl.handle_item_drag_resize,
                    eventDrop: ctrl.handle_item_drag_resize,
                    header: {
                        left: '',
                        center: '',
                        right: ''
                    },
                    dayRender: ctrl.day_render,
                    eventRender: ctrl.event_render,
                    viewRender: function () {
                        setTimeout(ctrl.timeline_view_hover, 200);
                    },
                    eventClick: function (event, e) {
                        if (e && e.target && ($(e.target).hasClass('event-options') || $(e.target).closest('.event-options').length)) {
                            if ($(e.target).hasClass('checkout-event') || $(e.target).closest('checkout-event').length) {
                                $state.go('app.cashbox.order', { orderID: event.orderId }, {
                                    reload: true
                                });
                            }
                            if ($(e.target).hasClass('copy-event') || $(e.target).closest('copy-event').length) {
                                ctrl.copy_order_form(event);
                            }
                            if ($(e.target).hasClass('move-event') || $(e.target).closest('move-event').length) {
                                ctrl.move_order(event);
                            }
                            return;
                        }

                        ctrl.edit_order_form(event);
                        //tooltip.hide();
                    },
                    dayClick: function (date, jsEvent, view, resourceObj) {
                        //tooltip.hide();

                        // Prevent dayClick when pinching
                        if (ctrl.pinchZoom && ctrl.pinchZoom.preventDayClick) {
                            return;
                        }

                        if (ctrl.moved_order) {
                            ctrl.move_confirm(date, resourceObj ? resourceObj.id : false);
                            return;
                        }
                        if (ctrl.copied_order) {
                            ctrl.copy_confirm(date, resourceObj ? resourceObj.id : false);
                            return;
                        }
                        if (ctrl.settings.time == "monthly") {
                            ctrl.change_calendar_type("orders");
                            ctrl.change_calendar_time("weekly");
                            ctrl.settings.date = new Date(date.format());
                            $("#mainCalendar").fullCalendar("gotoDate", date);
                        } else {
                            if (resourceObj) {
                                ctrl.open_order_form(date, resourceObj.id);
                            } else {
                                ctrl.open_order_form(date);
                            }
                        }
                    },
                };
            };

            if (window.innerWidth > 768) {
                ctrl.prepare_stores_configuration = function (isRTL) {
                    return {
                        eventLimit: true,
                        views: {
                            customWeek: {
                                type: 'timeline',
                                duration: { weeks: 1 },
                                slotDuration: { days: 1 }
                            },
                            month: {
                                eventLimit: 4,
                            }
                        },
                        defaultDate: ctrl.settings.date,
                        height: "auto",//200,//$(window).height() - 210,
                        editable: true,
                        defaultView: "agendaDay",
                        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                        allDaySlot: false,
                        slotDuration: ctrl.settings.interval,
                        slotLabelInterval: ctrl.settings.interval,
                        //groupByDateAndResource: false,
                        dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        isRTL: isRTL,
                        events: [],
                        minTime: ctrl.settings.minTime,
                        maxTime: ctrl.settings.maxTime,
                        axisFormat: 'HH:mm',
                        timeFormat: 'HH:mm',
                        slotLabelFormat: 'HH:mm',
                        resources: ctrl.uiResources,
                        columnHeaderHtml: function (mom) {
                            if (ctrl.settings.time == "monthly" || ctrl.settings.time == "daily") {
                                return mom.format('dddd');
                                return mom.format("dddd, DD/MM");
                            } else {
                                return mom.format('DD, dddd');
                                return mom.format("dddd, DD/MM");
                            }
                        },
                        header: {
                            left: '',
                            center: '',
                            right: ''
                        },
                        eventResize: ctrl.handle_item_drag_resize,
                        eventDrop: ctrl.handle_item_drag_resize,
                        dayRender: ctrl.day_render,
                        eventRender: function (event, element, view) {
                            ctrl.event_render(event, element);
                        },
                        viewRender: function () {
                            setTimeout(ctrl.agenda_view_hover, 800);

                            if (ctrl.settings.time == "daily") {
                                ctrl.day_render(moment(ctrl.settings.date), null);
                            } else if (ctrl.settings.time == "weekly") {
                                var day = moment($date.getSunday(new Date(ctrl.settings.date)));
                                for (var i = 0; i < 7; i++) {
                                    ctrl.day_render(moment(day), null);
                                    day = day.add(1, 'days');
                                }
                            }
                        },
                        eventClick: function (event, e) {
                            //tooltip.hide();

                            if (e && e.target && ($(e.target).hasClass('event-options') || $(e.target).closest('.event-options').length)) {
                                if ($(e.target).hasClass('checkout-event') || $(e.target).closest('checkout-event').length) {
                                    $state.go('app.cashbox.order', { orderID: event.orderId }, {
                                        reload: true
                                    });
                                }
                                if ($(e.target).hasClass('copy-event') || $(e.target).closest('copy-event').length) {
                                    ctrl.copy_order_form(event);
                                }
                                if ($(e.target).hasClass('move-event') || $(e.target).closest('move-event').length) {
                                    ctrl.move_order(event);
                                }
                                return;
                            }
                            $scope.new_order_date = event.start;
                            ctrl.edit_order_form(event);
                        },
                        dayClick: function (date, jsEvent, view, resourceObj) {
                            //tooltip.hide();

                            // Prevent dayClick when pinching
                            if (ctrl.pinchZoom && ctrl.pinchZoom.preventDayClick) {
                                return;
                            }
                            
                            if (ctrl.moved_order) {
                                ctrl.move_confirm(date, resourceObj ? resourceObj.id : false);
                                return;
                            }
                            if (ctrl.copied_order) {
                                ctrl.copy_confirm(date, resourceObj ? resourceObj.id : false);
                                return;
                            }
                            if (ctrl.settings.time == "monthly") {
                                ctrl.change_calendar_type("orders");
                                ctrl.change_calendar_time("daily");
                                ctrl.settings.date = new Date(date.format());
                                $("#mainCalendar").fullCalendar("gotoDate", date);
                            }
                            else {
                                if (!resourceObj && ctrl.settings.resource.length == 1) {
                                    resourceObj = {
                                        id: parseInt(ctrl.settings.resource[0].id)
                                    }
                                }
                                if (resourceObj)
                                    ctrl.open_order_form(date, resourceObj.id);
                                else
                                    ctrl.open_order_form(date);
                            }
                        }
                    };
                };
            } else {
                ctrl.prepare_stores_configuration = function (isRTL) {
                    return {
                        eventLimit: true,
                        views: {
                            customWeek: {
                                type: 'timeline',
                                duration: { weeks: 1 },
                                slotDuration: { days: 1 }
                            },
                            month: {
                                eventLimit: 4
                            }
                        },
                        height: 'auto',
                        editable: true,
                        defaultDate: ctrl.settings.date,
                        defaultView: "agendaDay",
                        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                        allDaySlot: false,
                        slotDuration: ctrl.settings.interval,
                        slotLabelInterval: ctrl.settings.interval,
                        //groupByDateAndResource: false,
                        dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        isRTL: isRTL,
                        events: [],
                        minTime: ctrl.settings.minTime,
                        maxTime: ctrl.settings.maxTime,
                        axisFormat: 'HH:mm',
                        timeFormat: 'HH:mm',
                        slotLabelFormat: 'HH:mm',
                        resources: ctrl.uiResources,
                        columnHeaderHtml: function (mom) {
                            if (ctrl.settings.time == "monthly" || ctrl.settings.time == "daily") {
                                return mom.format('dddd');
                                return mom.format("dddd, DD/MM");
                            } else {
                                return mom.format('DD, dddd');
                                return mom.format("dddd, DD/MM");
                            }

                        },
                        header: {
                            left: '',
                            center: '',
                            right: ''
                        },
                        eventResize: ctrl.handle_item_drag_resize,
                        eventDrop: ctrl.handle_item_drag_resize,
                        dayRender: ctrl.day_render,
                        eventRender: function (event, element, view) {
                            ctrl.event_render(event, element);
                        },
                        eventClick: function (event, e) {
                            //tooltip.hide();
                            if (e && e.target && ($(e.target).hasClass('event-options') || $(e.target).closest('.event-options').length)) {
                                if ($(e.target).hasClass('checkout-event') || $(e.target).closest('checkout-event').length) {
                                    $state.go('app.cashbox.order', { orderID: event.orderId }, {
                                        reload: true
                                    });
                                }
                                if ($(e.target).hasClass('copy-event') || $(e.target).closest('copy-event').length) {
                                    ctrl.copy_order_form(event);
                                }
                                if ($(e.target).hasClass('move-event') || $(e.target).closest('move-event').length) {
                                    ctrl.move_order(event);
                                }
                                return;
                            }
                            $scope.new_order_date = event.start;
                            ctrl.edit_order_form(event);
                        },
                        viewRender: function () {
                            setTimeout(ctrl.agenda_view_hover, 800);

                            if (ctrl.settings.time == "daily")
                                ctrl.day_render(moment(ctrl.settings.date), null);
                            else if (ctrl.settings.time == "weekly") {

                                var day = moment($date.getSunday(new Date(ctrl.settings.date)));

                                for (var i = 0; i < 7; i++) {
                                    ctrl.day_render(moment(day), null);
                                    day = day.add(1, 'days');
                                }
                            }
                        },
                        dayClick: function (date, jsEvent, view, resourceObj) {
                            //tooltip.hide();
                            
                            // Prevent dayClick when pinching
                            if (ctrl.pinchZoom && ctrl.pinchZoom.preventDayClick) {
                                return;
                            }
                            
                            var allDate = $scope.clientEvents;
                            var currentDate = moment(date).format("YYYY-MM-DD");
                            var selectedDate = [];

                            for (var i = 0; i < allDate.length; i++) {
                                if (moment(allDate[i].start).format("YYYY-MM-DD") == currentDate) {
                                    var datesArray = JSON.parse(JSON.stringify(allDate[i]));
                                    datesArray.start = moment(datesArray.start).format("YYYY-MM-DD");
                                    selectedDate.push(datesArray)
                                }
                            }

                            ctrl.selectedDate = selectedDate;

                            if (ctrl.settings.time == "monthly") {
                                ctrl.change_calendar_type("orders");
                                ctrl.change_calendar_time("daily");
                                ctrl.settings.date = new Date(date.format());
                                $("#mainCalendar").fullCalendar("gotoDate", date);
                            }
                            else {
                                if (ctrl.moved_order) {
                                    ctrl.move_confirm(date, resourceObj ? resourceObj.id : false);
                                    return;
                                }
                                if (ctrl.copied_order) {
                                    ctrl.copy_confirm(date, resourceObj ? resourceObj.id : false);
                                    return;
                                }

                                if (!resourceObj && ctrl.settings.resource.length == 1) {
                                    resourceObj = {
                                        id: parseInt(ctrl.settings.resource[0].id)
                                    }
                                }
                                if (resourceObj)
                                    ctrl.open_order_form(date, resourceObj.id);
                                else
                                    ctrl.open_order_form(date);
                            }
                        }
                    };
                };
            }
            /**
             * Calendar Configuration
             */
            $scope.calendarConfig = null;

            $rootScope.$on('change-language', function (event, langKey) {
                $("#mainCalendar").fullCalendar("option", "isRTL", langKey === 'hb_ISR' || langKey === 'ar_AR');
            });

            if (ctrl.settings.bu_type == 1) {
                default_screen = $scope.default_screen ? $scope.default_screen : '';

                if (default_screen == "Calendar-Weekly" && (Lflag == 1 || ctrl.settings.view)) {
                    ctrl.settings.time = "weekly";
                    $scope.calendarConfig = ctrl.prepare_stores_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = true;
                    $scope.calendarConfig.defaultView = "agendaWeek";
                } else if (default_screen == "Calendar-Monthly" && (Lflag == 1 || ctrl.settings.view)) {
                    ctrl.settings.time = "monthly";
                    $scope.calendarConfig = ctrl.prepare_stores_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = true;
                    $scope.calendarConfig.defaultView = "month";
                } else {
                    $scope.calendarConfig = ctrl.prepare_stores_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = true;
                    if ($rootScope.$user.calendar_default * 1 == 1) {
                        ctrl.settings.time = "weekly";
                        $scope.calendarConfig.defaultView = "agendaWeek";
                    }
                    if ($rootScope.$user.calendar_default * 1 == 2) {
                        ctrl.settings.time = "monthly";
                        $scope.calendarConfig.defaultView = "month";
                    }
                }

                if ($stateParams.date && ctrl.settings.scrollTime) {
                    $scope.calendarConfig.scrollTime = ctrl.settings.scrollTime;
                } else {
                    $scope.calendarConfig.scrollTime = moment().subtract(60, 'minutes').format("HH") + ":00:00";
                }

            } else if (ctrl.settings.bu_type == 2) {
                default_screen = $scope.default_screen ? $scope.default_screen : '';
                if (default_screen == "Calendar-Occupation" && (Lflag == 1 || ctrl.settings.view)) {
                    ctrl.settings.type = "capacity";
                    ctrl.settings.time = "monthly";
                    ctrl.settings.datePickerView = "month";
                    $scope.calendarConfig = ctrl.prepare_motels_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = false;
                    // ctrl.get_orders_capacity();
                    // ctrl.initDisplayDate(ctrl.settings.date);
                    setTimeout(function () {
                        ctrl.change_calendar_type('capacity');
                    }, 100);
                } else {
                    $scope.calendarConfig = ctrl.prepare_motels_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = false;
                }
            }

            ctrl.userChangedDate = false;
            ctrl.datePickerClicked = function() {
                ctrl.userChangedDate = true;
            };

            /**
             * Responsible for changes on the datepicker input
             */
            $scope.$watch("ctrl.settings.date", function (newValue, oldValue) {
                if (newValue != oldValue) {
                    newValue = new Date(newValue);
                    ctrl.initDisplayDate(newValue);
                    //ctrl.get_resources_capacity();

                    if (ctrl.settings.type == "orders") {
                        if (ctrl.userChangedDate) {
                            ctrl.resetFindSettings();
                        }

                        ctrl.refresh_calendar();
                    } else {
                        ctrl.get_orders_capacity();
                    }

                    ctrl.load_holidays();
                    ctrl.userChangedDate = false;
                }
            });

            ctrl.initDisplayDate = function (date) {
                var date = new Date(date);

                if (ctrl.settings.time == "weekly") {

                    var
                        Sunday = $date.getSunday(date),
                        Saturyday = $date.getSaturday(date);

                    ctrl.displayDate =
                        (Saturyday.getDate() < 10 ? ("0" + Saturyday.getDate()) : (Saturyday.getDate()))
                        + "/" +
                        ((Saturyday.getMonth() + 1) < 10 ? ("0" + (Saturyday.getMonth() + 1)) : ((Saturyday.getMonth() + 1)))
                        + "/" +
                        Saturyday.getFullYear();

                    ctrl.displayDate += " - ";

                    ctrl.displayDate +=
                        (Sunday.getDate() < 10 ? ("0" + Sunday.getDate()) : (Sunday.getDate()))
                        + "/" +
                        ((Sunday.getMonth() + 1) < 10 ? ("0" + (Sunday.getMonth() + 1)) : ((Sunday.getMonth() + 1)))
                        + "/" +
                        Sunday.getFullYear();
                }
                else if (ctrl.settings.time == "daily") {
                    var holidayData = ctrl.get_date_holiday(moment(date));

                    // Check if Hebrew dates should be displayed
                    if ($rootScope.display_hebrew_dates) {
                        ctrl.displayDate = HebrewDate.getHebrewFormatDateString(date);
                    } else {
                        ctrl.displayDate = "יום " + dates.daysNames[date.getDay()] + ", ";

                        ctrl.displayDate +=
                            (date.getDate() < 10 ? ("0" + date.getDate()) : (date.getDate()))
                            + "/" +
                            ((date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : ((date.getMonth() + 1)))
                            + "/" +
                            date.getFullYear();
                    }

                    if (holidayData.isHoliday)
                        ctrl.displayDate += ", " + holidayData.holidayName;
                }
                else if (ctrl.settings.time == "monthly")
                    ctrl.displayDate = dates.months[date.getMonth()] + " " + date.getFullYear();
                if (typeof uiCalendarConfig.calendars.mainCalendar !== typeof undefined) {
                    //uiCalendarConfig.calendars.mainCalendar.fullCalendar("gotoDate", date);
                    $("#mainCalendar").fullCalendar("gotoDate", date);
                }

                if (ctrl.settings.holiday_color) {
                    $('.is-holiday').css('background-color', ctrl.settings.holiday_color);
                    //load hook
                    setTimeout(function () {
                        $('.is-holiday').css('background-color', ctrl.settings.holiday_color);
                    }, 100);
                }
            };

            ctrl.displayDate = "";
            ctrl.initDisplayDate(ctrl.settings.date);

            /**
             * Triggers when clicked on next button in the datepicker
             */
            ctrl.datePickerPrev = function () {
                ctrl.resetFindSettings();

                if (ctrl.settings.time == "daily")
                    ctrl.settings.date = moment(ctrl.settings.date).add(-1, "days");
                else if (ctrl.settings.time == "weekly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(-7, "days");
                else if (ctrl.settings.time == "monthly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(-1, "month");
            };

            /**
             * Goto to today
             */
            ctrl.gotoToday = function () {
                ctrl.settings.date = moment();

                ctrl.resetFindSettings();
            }
            /**
             * Triggers when clicked on next button in the datepicker
             * @return {void}
             */
            ctrl.datePickerNext = function () {
                ctrl.resetFindSettings();

                if (ctrl.settings.time == "daily")
                    ctrl.settings.date = moment(ctrl.settings.date).add(1, "days");
                else if (ctrl.settings.time == "weekly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(7, "days");
                else if (ctrl.settings.time == "monthly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(1, "month");
            };

            /**
             * Triggers when resource checkbox is changed
             * @return {void}
             */
            ctrl.change_resource = function () {
                ctrl.resetFindSettings();

                if (!ctrl.settings.resource.length) {
                    $scope.calendarConfig.resources = ctrl.uiResources;
                }
                else {
                    $scope.calendarConfig.resources = [];
                    for (var i in ctrl.uiResources) {
                        for (var j in ctrl.settings.resource) {
                            if (ctrl.uiResources[i].id == ctrl.settings.resource[j].id) {
                                $scope.calendarConfig.resources.push(ctrl.uiResources[i]);
                            }
                        }
                    }
                }
                $("#mainCalendar").fullCalendar("option", "resources", $scope.calendarConfig.resources);
                $("#mainCalendar").fullCalendar("refetchResources", $scope.calendarConfig.resources);
                ctrl.set_working_hours();

                ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                if (ctrl.settings.type == "capacity")
                    ctrl.set_capacity_colors();
            };

            $scope.$watch(
                function () { return ctrl.settings.resource; },
                function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        ctrl.change_resource();
                    }
                },
                true // Set deep watch to detect changes in array elements
            );

            ctrl.getDefaultFindSettings = function () {
                return {
                    search: '',
                    noCustomers: true,
                    orderIds: [],
                    eventIds: [],
                    courseIds: [],
                    lastDate: null,
                    direction: null,
                    resourceIds: [],
                    currentId: null,
                    currentType: null,
                    isEnd: true,
                    loading: false
                };
            };

            ctrl.findSettings = ctrl.getDefaultFindSettings();

            ctrl.resetFindSettings = function(keepSearch) {
                var search = ctrl.findSettings.search;
                ctrl.findSettings = ctrl.getDefaultFindSettings();
                if (keepSearch) {
                    ctrl.findSettings.search = search;
                }
            };

            ctrl.isButtonDisabled = function (direction) {
                if (ctrl.findSettings.search == '' || ctrl.findSettings.noCustomers) {
                    return true;
                }

                if (direction === ctrl.findSettings.direction && ctrl.findSettings.isEnd) {
                    return true;
                }

                const idsCount = ctrl.findSettings.orderIds.length + ctrl.findSettings.eventIds.length + ctrl.findSettings.courseIds.length;
                if (direction === 'prev') {
                    if (ctrl.findSettings.direction == 'prev' && idsCount == 0) {
                        return true;
                    }

                    if (ctrl.findSettings.direction == 'next' && idsCount <= 1) {
                        return true;
                    }
                }

                return false;
            };

            var searchTimeout;
            $scope.$watch(function () {
                return ctrl.findSettings.search;
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    ctrl.resetFindSettings(true);
                    ctrl.clearHighlight();
                    
                    if (searchTimeout) {
                        $timeout.cancel(searchTimeout);
                    }

                    if (newVal && newVal.length >= 3) {
                        searchTimeout = $timeout(function () {
                            ctrl.findEvent('next');
                        }, 1000);
                    }
                }
            });

            ctrl.pad = function (num, size) {
                var s = num + '';
                while (s.length < size) s = '0' + s;
                return s;
            };

            ctrl.findEvent = function (direction) {
                ctrl.findSettings.loading = true;

                if (ctrl.findSettings.lastDate === null) {
                    ctrl.findSettings.lastDate = moment().format('YYYY-MM-DD HH:mm:ss');
                }

                ctrl.findSettings.direction = direction;
                ctrl.findSettings.resourceIds = ctrl.settings.resource.map(function (r) { return r.id });

                if (direction === 'prev' && ctrl.findSettings.currentId) {
                    if (ctrl.findSettings.currentType === 'order') {
                        var idxOrder = ctrl.findSettings.orderIds.indexOf(ctrl.findSettings.currentId);
                        if (idxOrder >= 0) {
                            ctrl.findSettings.orderIds.splice(idxOrder, 1);
                        }
                    } else if (ctrl.findSettings.currentType === 'event') {
                        var idxEvent = ctrl.findSettings.eventIds.indexOf(ctrl.findSettings.currentId);
                        if (idxEvent >= 0) {
                            ctrl.findSettings.eventIds.splice(idxEvent, 1);
                        }
                    } else if (ctrl.findSettings.currentType === 'course') {
                        var idxCourse = ctrl.findSettings.courseIds.indexOf(ctrl.findSettings.currentId);
                        if (idxCourse >= 0) {
                            ctrl.findSettings.courseIds.splice(idxCourse, 1);
                        }
                    }
                }

                $api.findEvents.save(ctrl.findSettings, function (response) {
                    ctrl.findSettings.loading = false;

                    if (response.data) {
                        ctrl.findSettings.isEnd = false;
                        ctrl.findSettings.noCustomers = false;
                        if (response.data.order) {
                            var orderId = response.data.order.id;
                            var idxOrder = ctrl.findSettings.orderIds.indexOf(orderId);
                            if (idxOrder >= 0) {
                                ctrl.findSettings.orderIds.splice(idxOrder, 1);
                            } else {
                                ctrl.findSettings.orderIds.push(orderId);
                            }

                            ctrl.findSettings.lastDate = response.data.order.start_time;
                            ctrl.findSettings.currentId = orderId;
                            ctrl.findSettings.currentType = 'order';
                        } else if (response.data.event) {
                            var eventId = response.data.event.id;
                            var idxEvent = ctrl.findSettings.eventIds.indexOf(eventId);
                            if (idxEvent >= 0) {
                                ctrl.findSettings.eventIds.splice(idxEvent, 1);
                            } else {
                                ctrl.findSettings.eventIds.push(eventId);
                            }

                            ctrl.findSettings.lastDate = response.data.event.start_time;
                            ctrl.findSettings.currentId = eventId;
                            ctrl.findSettings.currentType = 'event';
                        } else if (response.data.course) {
                            var courseId = response.data.course.id;
                            var idxCourse = ctrl.findSettings.courseIds.indexOf(courseId);
                            if (idxCourse >= 0) {
                                ctrl.findSettings.courseIds.splice(idxCourse, 1);
                            } else {
                                ctrl.findSettings.courseIds.push(courseId);
                            }

                            ctrl.findSettings.lastDate = response.data.course.start_time;
                            ctrl.findSettings.currentId = courseId;
                            ctrl.findSettings.currentType = 'course';
                        }

                        if (moment(ctrl.settings.date).isSame(moment(ctrl.findSettings.lastDate), 'day')) {
                            ctrl.scrollToEvent(ctrl.findSettings.currentId, ctrl.findSettings.currentType);
                        } else {
                            ctrl.settings.date = moment(ctrl.findSettings.lastDate);
                        }
                    } else {
                        ctrl.findSettings.isEnd = true;

                        var title = $translate.instant(ctrl.findSettings.direction == 'prev' ? 'SWAL_FIND_EVENTS_PREV_TITLE' : 'SWAL_FIND_EVENTS_NEXT_TITLE', { search: ctrl.findSettings.search });
                        if (response.code && response.code == 'no_customers') {
                            ctrl.findSettings.noCustomers = true;
                            title = $translate.instant('SWAL_FIND_EVENTS_NO_CUSTOMERS_TITLE', { search: ctrl.findSettings.search });
                        }

                        swal({
                            title: title,
                            text: "",
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        });
                    }
                });
            };

            ctrl.scrollToEvent = function (eventId, eventType) {
                $timeout(function () {
                    ctrl.clearHighlight();

                    var eventElements = document.querySelectorAll(".fc-event[data-item='" + eventType + "-" + eventId + "']");
                    if (eventElements && eventElements.length > 0) {
                        for (var i = 0; i < eventElements.length; i++) {
                            eventElements[i].classList.add('fc-glowing');
                            if (i == 0) {
                                eventElements[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }
                    }
                }, 0);
            };

            ctrl.clearHighlight = function () {
                var previousGlows = document.querySelectorAll('.fc-glowing');
                if (previousGlows && previousGlows.length > 0) {
                    for (var i = 0; i < previousGlows.length; i++) {
                        previousGlows[i].classList.remove('fc-glowing');
                    }
                }
            };

            ctrl.refresh_calendar = function () {
                ctrl.get_orders_data().$promise.then(function () {
                    ctrl.get_events_data().$promise.then(function () {
                        ctrl.get_courses_data().$promise.then(function () {
                            if (ctrl.findSettings.currentId != null && ctrl.findSettings.currentType != null) {
                                ctrl.scrollToEvent(ctrl.findSettings.currentId, ctrl.findSettings.currentType);
                            }
                        });
                    });
                });
            }


            /**
             * Trigger the API call to retrieve relevent orders from the server
             */
            ctrl.get_orders_data = function () {
                $scope.clientEvents = [];
                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }

                ctrl.apiRequest = $api.orders.calendar.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    range: ctrl.settings.time
                }, function (response) {
                    response.data = response.data.sort(function (a, b) { return a.resource_id > b.resource_id ? 1 : -1 })
                    $scope.todayCapacity = response.capacity;

                    if (ctrl.settings.bu_type == 2) {
                        var top = $(".fc-scroller-canvas .fc-rows").offset().top;
                        $(".calendar-wrapper").css('height', top).css('overflow', 'hidden');
                    } else {
                        setTimeout(function () { $(".fc-scroller").css('height', 'auto') }, 200);
                    }
                    if (response.data == null) {

                        $scope.clientEvents = [];

                    }

                    var mergedEvents = response.data;
                    if ($rootScope.display_one_block_services) {
                        mergedEvents = ctrl.mergeEvents(mergedEvents);
                    }

                    for (var i in mergedEvents) {
                        var eventName = "";
                        var event = mergedEvents[i];
                        if (event.order_customer) {
                            eventName = event.order_customer_firstname;

                            if (event.order_customer_lastname) {
                                if (!$scope.isMobile
                                    || ($scope.isMobile && ctrl.settings.time == 'daily')) {
                                    eventName += " " + event.order_customer_lastname;
                                }
                            }
                        } else {
                            //eventName = "לקוח מזדמן";
                            eventName = event.customer_name ? event.customer_name : '';
                        }

                        eventName += ", " + (event.part ? event.item_data.name_second : event.item_data.name);
                        
                        // Add ticket icon after first name if merged and has card_balance
                        if (event.merged && event.card_balance) {
                            eventName += ' <i class="las la-ticket-alt customers-has-chards' + (event.expired ? ' expired' : '') + '"><span></span></i>';
                        }
                        
                        var endTime = event.end_time;

                        if (event.merged) {
                            for (var j in event.merged) {
                                eventName += ", " + (event.merged[j].part ? event.merged[j].item_data.name_second : event.merged[j].item_data.name);
                                
                                // Add ticket icon after each merged name if has card_balance
                                if (event.merged[j].card_balance) {
                                    eventName += ' <i class="las la-ticket-alt customers-has-chards' + (event.merged[j].expired ? ' expired' : '') + '"><span></span></i>';
                                }
                                
                                endTime = event.merged[j].end_time;
                            }
                        }

                        var event = {
                            id: event.id,
                            title: eventName,
                            start: moment(event.start_time).format(),
                            end: endTime,
                            order_status: event.order_status,
                            feedback_id: event.feedback_id,
                            order_notes: event.order_notes,
                            prepaid: event.prepaid,
                            request_prepaid: event.request_prepaid,
                            card_balance: event.card_balance,
                            expired: event.expired,
                            feedback_stars: event.feedback_stars,
                            approved: 0,
                            online: event.online,
                            resourceId: event.resource_id,
                            orderId: event.order_id,
                            backgroundColor: event.item_data.bg_color,
                            pay_link: event.pay_link,
                            avatar: event.avatar,
                            approval_sent: event.approval_sent,
                            part: event.part,
                            imported: event.imported,
                            order_price: event.order_price,
                            user_name: event.user_name,
                            created_at: event.created_at,
                            merged: event.merged || false,
                            duration: moment(event.end_time).diff(moment(event.start_time), 'minutes'),
                            original_start_time: moment(event.start_time).valueOf(),
                            durationEditable: event.merged ? false : true,
                        }

                        if (event.order_status !== 3) {
                            event.approved = event.approval_sent;
                        }

                        if (ctrl.moved_order && ctrl.moved_order.id == event.id) continue;

                        $scope.clientEvents.push(event);
                    }

                    var seen = {};
                    //You can filter based on Id or Name based on the requirement
                    var uniqueStudents = $scope.clientEvents.filter(function (item) {
                        if (seen.hasOwnProperty(item.id)) {
                            return false;
                        } else {
                            seen[item.id] = true;
                            return true;
                        }
                    })

                    $scope.clientEvents = uniqueStudents;

                    ctrl.set_working_hours();
                    // Render events by resource id

                    ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));

                    ctrl.settings.loading = false;
                    ctrl.apiRequest = null;
                });
                return ctrl.apiRequest;
            };

            /**
             * Merge events that have same customer same resource and goes by each other
             */
            ctrl.mergeEvents = function (events) {
                var mergedEvents = [];
                events = events.sort(function (a, b) { return a.start_time > b.start_time ? 1 : -1 })
                events = events.sort(function (a, b) { return a.order_customer > b.order_customer ? 1 : -1 })
                events = events.sort(function (a, b) { return a.resource_id > b.resource_id ? 1 : -1 })
                
                for (var i = 0; i < events.length; i++) {
                    var currentEvent = events[i];
                    var endTime = currentEvent.end_time;
                    var j = i + 1;
                    
                    // Look for consecutive events that can be merged
                    while (j < events.length && 
                           moment(endTime).isSame(moment(events[j].start_time), 'minute') &&
                           currentEvent.order_customer == events[j].order_customer && 
                           currentEvent.resource_id == events[j].resource_id) {
                        // Merge the next event into the current one
                        endTime = events[j].end_time;
                        if (!currentEvent.merged) {
                            currentEvent.merged = [];
                        }
                        currentEvent.merged.push(events[j]);
                        j++;
                    }
                    
                    mergedEvents.push(currentEvent);
                    i = j - 1; // Skip the events that were merged
                }
                return mergedEvents;
            }


            /**
             * Trigger the API call to retrieve relevent orders from the server
             */
            ctrl.get_events_data = function () {

                $scope.clientEvents = $scope.clientEvents || [];
                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }

                ctrl.apiRequest = $api.events.calendar.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    range: ctrl.settings.time
                }, function (response) {
                    response.data = response.data.sort(function (a, b) {
                        return a.resource_id > b.resource_id ? 1 : -1
                    })

                    if (response.data == null) {
                        $scope.clientEvents = [];
                    }

                    var issetIds = [];
                    for (var i in $scope.clientEvents) {
                        issetIds.push($scope.clientEvents[i].eventId);
                    }

                    for (var i in response.data) {
                        var eventName = "";
                        if ($scope.isMobile && ctrl.settings.time == "weekly") {
                            //eventName = " ";
                            eventName = response.data[i].description;
                        } else {
                            eventName = response.data[i].description;
                        }
                        var event = {
                            eventId: response.data[i].id,
                            title: eventName,
                            type: 'event',
                            start: moment(response.data[i].start_date_time).format(),
                            end: moment(response.data[i].end_date_time).format(),
                            resourceId: response.data[i].resource_id,
                            backgroundColor: '#77889'
                        }
                        if (issetIds.indexOf(event.eventId) < 0) {
                            $scope.clientEvents.push(event);
                        }
                    }

                    ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                    ctrl.settings.loading = false;
                    ctrl.apiRequest = null;
                });

                return ctrl.apiRequest;
            };

            ctrl.get_courses_data = function () {

                $scope.clientEvents = $scope.clientEvents || [];
                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }

                ctrl.apiRequest = $api.courses.calendar.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    range: ctrl.settings.time
                }, function (response) {
                    response.data = response.data.sort(function (a, b) {
                        return a.resource_id > b.resource_id ? 1 : -1
                    })

                    if (response.data == null) {
                        $scope.clientEvents = [];
                    }

                    var issetIds = [];
                    for (var i in $scope.clientEvents) {
                        issetIds.push($scope.clientEvents[i].courseId);
                    }

                    for (var i in response.data) {
                        var course = {
                            id: response.data[i].id,
                            courseId: response.data[i].courseId,
                            title: response.data[i].item_data.name + " - " + response.data[i].name,
                            type: 'course',
                            start: moment(response.data[i].start_time).format(),
                            end: moment(response.data[i].end_time).format(),
                            resourceId: response.data[i].resource_id,
                            secondResourceId: response.data[i].second_resource_id,
                            secondResourceEnabled: response.data[i].second_resource_enabled,
                            secondResourceTitle: response.data[i].second_resource_title,
                            secondResourceName: response.data[i].second_resource_name,
                            backgroundColor: response.data[i].item_data.bg_color
                        }
                        if (issetIds.indexOf(course.courseId) < 0) {
                            $scope.clientEvents.push(course);
                        }
                    }

                    ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                    ctrl.settings.loading = false;
                    ctrl.apiRequest = null;
                });

                return ctrl.apiRequest;
            };

            ctrl.refresh_calendar();


            /**
             * Triggers the API call to retreive capacity information
             * @return {void}
             */
            ctrl.get_orders_capacity = function () {
                //stop orders capacity
                return;

                $(".calendar-wrapper").css('height', 'auto')

                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }


                ctrl.apiRequest = $api.orders.capcaity.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                }, function (response) {
                    ctrl.settings.loading = false;
                    ctrl.capacityData = response.data;
                    ctrl.set_capacity_colors();
                    ctrl.apiRequest = null;
                });
            };

            ctrl.get_resources_capacity = function () {
                var date = new Date(ctrl.settings.date.startOf('week'));

                $api.resources.capacity.all.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                }, function (response) {
                    $scope.resources = response.data;
                    ctrl.set_working_hours();
                });
            };

            /**
             * Sets the color for each day according to its capacity
             */
            ctrl.set_capacity_colors = function () {

                var
                    color,
                    capacity_to_check,
                    slots_string;

                for (var i in ctrl.capacityData) {

                    if (ctrl.settings.resource.length) {
                        //capacity_to_check = ctrl.capacityData[i][parseInt(ctrl.settings.resource)];
                    } else {
                        capacity_to_check = ctrl.capacityData[i]["global"];
                    }

                    slots_string = (capacity_to_check.total_slots - capacity_to_check.taken_slots);
                    if (capacity_to_check.taken_slots == 0)
                        color = "green";
                    else if (capacity_to_check.taken_slots == capacity_to_check.total_slots)
                        color = "red";
                    else
                        color = "orange";

                    //slots_string = (capacity_to_check.total_slots - capacity_to_check.taken_slots) + "/" + (capacity_to_check.total_slots) + " (" + capacity_to_check.percentage + "% תפוסה)";
                    $(".day-" + i).addClass("day-capacity-" + color).attr("data-slots", slots_string);
                    // if( capacity_to_check.taken_slots > 0 ) {
                    //     $(".day-" + i).find('.hoverEffect').remove();
                    //     $(".day-" + i).append("<span class='hoverEffect' style='display: none;'>This is hover"+capacity_to_check.taken_slots+"</span>");
                    // }
                }
            };

            /**
             * Sets two shifts of working hours by adding events to background on non-working hours
             */
            ctrl.set_working_hours = function () {
                // Only for stores business
                if (ctrl.settings.bu_type == 1) {
                    for (var i in $scope.resources) {
                        if (ctrl.settings.time == "daily") {
                            if ($scope.todayCapacity && $scope.todayCapacity[$scope.resources[i].id]) {
                                var shift = $scope.todayCapacity[$scope.resources[i].id];
                                var event = {
                                    resourceId: $scope.resources[i].id,
                                    id: $scope.resources[i].id, // empty 'id' should be here to fix overlapping work shifts
                                    rendering: 'inverse-background',
                                    className: 'fc-nonbusiness',
                                };


                                // First shift
                                if (shift.start_time !== undefined && shift.this_date !== undefined) {
                                    var first_shift_event = angular.copy(event);
                                    //var start_time = moment(shift.date).add(shift.start_time.split(':')[0], 'h')
                                    //    .add(shift.start_time.split(':')[1], 'm');
                                    //var end_time = moment.unix(shift.date).add(shift.end_time.split(':')[0], 'h')
                                    //    .add(shift.end_time.split(':')[1], 'm');
                                    var start_time = moment(shift.this_date + ' ' + shift.start_time, 'YYYY-MM-DD HH:mm:ss');
                                    var end_time = moment(shift.this_date + ' ' + shift.end_time, 'YYYY-MM-DD HH:mm:ss');

                                    // Check if shift starts and ends on the same day.
                                    if (moment(shift.end_time, "HH:mm:ss").isAfter(shift.start_time, "HH:mm:ss")) {
                                        end_time.add(1, 'd');
                                    }

                                    first_shift_event.start = start_time;
                                    first_shift_event.end = end_time;
                                    $scope.clientEvents.push(first_shift_event);

                                    // Second shift
                                    if (shift.shift2_end_time && shift.shift2_start_time) {

                                        var second_shift_event = angular.copy(event);
                                        // var shift2_start_time = moment.unix(shift.date).add(shift.shift2_start_time.split(":")[0], "h")
                                        //     .add(shift.shift2_start_time.split(":")[1], "m");
                                        // var shift2_end_time = moment.unix(shift.date).add(shift.shift2_end_time.split(":")[0], "h")
                                        //     .add(shift.shift2_end_time.split(":")[1], "m");

                                        var shift2_start_time = moment(shift.this_date + ' ' + shift.shift2_start_time, 'YYYY-MM-DD HH:mm:ss');
                                        var shift2_end_time = moment(shift.this_date + ' ' + shift.shift2_end_time, 'YYYY-MM-DD HH:mm:ss');

                                        if (moment(shift.shift2_end_time, "HH:mm:ss").isAfter(shift.shift2_start_time, "HH:mm:ss")) {
                                            shift2_end_time.add(1, 'd');
                                        }
                                        second_shift_event.start = shift2_start_time;
                                        second_shift_event.end = shift2_end_time;
                                        $scope.clientEvents.push(second_shift_event);
                                    }
                                }
                            }
                        } else {
                            //for (var s in $scope.resources[i].capacity) {
                            var capacity = $scope.resources[i].capacity;
                            if ($scope.todayCapacity && $scope.todayCapacity[$scope.resources[i].id] && Array.isArray($scope.todayCapacity[$scope.resources[i].id])) {
                                capacity = $scope.todayCapacity[$scope.resources[i].id];
                            }

                            for (var s in capacity) {
                                var shift = capacity[s];

                                var event = {
                                    resourceId: $scope.resources[i].id,
                                    id: '', // empty 'id' should be here to fix overlapping work shifts
                                    rendering: 'inverse-background',
                                    className: 'fc-nonbusiness',
                                };

                                // First shift
                                if (shift.start_time !== undefined && shift.this_date !== undefined) {

                                    var first_shift_event = angular.copy(event);
                                    // var start_time = moment.unix(shift.date).add(shift.start_time.split(':')[0], 'h')
                                    //     .add(shift.start_time.split(':')[1], 'm');
                                    // var end_time = moment.unix(shift.date).add(shift.end_time.split(':')[0], 'h')
                                    //     .add(shift.end_time.split(':')[1], 'm');
                                    var start_time = moment(shift.this_date + ' ' + shift.start_time, 'YYYY-MM-DD HH:mm:ss');
                                    var end_time = moment(shift.this_date + ' ' + shift.end_time, 'YYYY-MM-DD HH:mm:ss');
                                    // Check if shift starts and ends on the same day.
                                    if (moment(shift.end_time, "HH:mm:ss").isAfter(shift.start_time, "HH:mm:ss")) {
                                        end_time.add(1, 'd');
                                    }

                                    first_shift_event.start = start_time;
                                    first_shift_event.end = end_time;
                                    $scope.clientEvents.push(first_shift_event);

                                    // Second shift
                                    if (shift.shift2_end_time && shift.shift2_start_time) {

                                        var second_shift_event = angular.copy(event);
                                        // var shift2_start_time = moment.unix(shift.date).add(shift.shift2_start_time.split(":")[0], "h")
                                        //     .add(shift.shift2_start_time.split(":")[1], "m");
                                        // var shift2_end_time = moment.unix(shift.date).add(shift.shift2_end_time.split(":")[0], "h")
                                        //     .add(shift.shift2_end_time.split(":")[1], "m");
                                        var shift2_start_time = moment(shift.this_date + ' ' + shift.shift2_start_time, 'YYYY-MM-DD HH:mm:ss');
                                        var shift2_end_time = moment(shift.this_date + ' ' + shift.shift2_end_time, 'YYYY-MM-DD HH:mm:ss');
                                        if (moment(shift.shift2_end_time, "HH:mm:ss").isAfter(shift.shift2_start_time, "HH:mm:ss")) {
                                            shift2_end_time.add(1, 'd');
                                        }
                                        second_shift_event.start = shift2_start_time;
                                        second_shift_event.end = shift2_end_time;
                                        $scope.clientEvents.push(second_shift_event);
                                    }
                                }
                            }
                        }
                    }
                }
            };

            /**
             * Opens "New Order" form
             */
            ctrl.open_order_form = function (date, resourceID) {
                $scope.new_order_date = date;

                $scope.selected_resource = resourceID;

                $uibModal.open({
                    templateUrl: "app/modules/calendar/order/order.form.html",
                    controller: "OrderFormController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Items: function ($api) {
                            return $api.resolve("items.items_with_duration@get");
                        },
                        // Customers: function($api) {
                        //     return $api.resolve("customers@get");
                        // },
                        Resources: function ($api) {
                            return $api.resolve("resources@get");
                        },
                        SecondResources: function ($api) {
                            return $api.resolve("second_resources@get");
                        },
                        Info: function ($api) {
                            return $api.resolve("settings.info@get");
                        },
                        Clubs: function ($api) {
                            return $api.resolve("settings.clubs@get");
                        },
                        Customer: function ($api) {
                            if (Customer && Customer.data && Customer.data[0]) {
                                return Customer.data[0];
                            }
                            if (Customer && Customer.data && Customer.data.id) {
                                return Customer.data;
                            }
                            return null;
                        },
                        Order: null,
                        CalendarEvent: null,
                        CalendarCourse: null,
                        Messages: function ($api) {
                            return $api.resolve("settings.messages@get");
                        },
                        EventCopy: false,
                        CoursesFields: ['$api', function ($api) {
                            return $api.resolve('coursesFields.lists@get');
                        }],
                    }
                }).closed.then(function () {
                    if (ctrl.settings.type == "orders") {
                        ctrl.refresh_calendar();
                    }
                    else { ctrl.get_orders_capacity() };
                });
            };

            /**
             * Opens "Edit Order" form
             */
            ctrl.edit_order_form = function (event) {
                if (event.type == 'event') {
                    $state.go('app.calendar.event-edit', { id: event.eventId });
                } else if (event.type == 'course') {
                    $state.go('app.calendar.course-edit', { id: event.courseId });
                } else {
                    $state.go('app.calendar.order-edit', { id: event.orderId });
                }
            };

            ctrl.copy_order_form = function (event) {
                ctrl.copied_order = event;
                var event_object = $("#itm-" + event.id).closest('.fc-event');
                if (event_object.length) {
                    var clone = event_object.clone();
                    clone.css('height', event_object.height() + 8);
                    clone.addClass('copied-order');
                    $("#mainCalendar").addClass('coping-enabled').append(clone);
                    $('#itm-' + event.id).prop('checked', false);

                    var second_clone = {};
                    var second_diff = {};

                    $(".fororder-" + event.orderId).each(function () {
                        var itmId = $(this).data('item');
                        if (itmId == event.id) return;

                        second_event_object = $(this).closest('.fc-event');

                        if (second_event_object.length) {
                            var rect1 = event_object.get(0).getBoundingClientRect();
                            var rect2 = second_event_object.get(0).getBoundingClientRect();

                            second_diff[itmId] = rect2.top - rect1.top;

                            second_clone[itmId] = second_event_object.clone();
                            second_clone[itmId].css('height', second_event_object.height() + 8);
                            second_clone[itmId].addClass('copied-order');
                            $("#mainCalendar").addClass('moving-enabled').append(second_clone[itmId]);

                            second_clone[itmId].css('inset', "-100% 0 0 0");
                        }
                    });

                    clone.css('inset', "-100% 0 0 0");

                    $(document).off("click mousemove", "#mainCalendar");
                    $(document).on("click mousemove", "#mainCalendar", function (e) {
                        if (e.target && ($(e.target).hasClass('temp-cell') || $(e.target).hasClass('fc-day'))) {
                            var current_offset = $(e.target).offset();
                            var main_offset = $("#mainCalendar").offset();
                            $('.cursor-circle').css('left', (e.clientX - 15 - (langKey === 'hb_ISR' || langKey === 'ar_AR' ? 0 : 250)) + 'px')
                            $('.cursor-circle').css('top', (e.clientY - 15 - 70 + document.documentElement.scrollTop) + 'px');

                            if (current_offset && main_offset) {
                                var newposX = current_offset.left - main_offset.left + (langKey === 'hb_ISR' || langKey === 'ar_AR' ? 49 : 41);
                                var newposY = current_offset.top - main_offset.top;
                                var newposR = $(window).width() - current_offset.left - $(e.target).outerWidth() - (langKey === 'hb_ISR' || langKey === 'ar_AR' ? 273 : 18);

                                clone.css('inset', newposY + "px " + newposR + "px 0 " + newposX + "px");
                                if (second_clone) {
                                    for (var itmId in second_clone) {
                                        second_clone[itmId].css('inset', (newposY + second_diff[itmId]) + "px " + newposR + "px 0 " + newposX + "px");
                                    }
                                }
                            }
                        }
                    });

                    $(document).off("keydown");
                    $(document).on("keydown", function (event) {
                        if (event.key === "Escape" || event.keyCode === 27) {
                            ctrl.copy_cancel();
                        }
                    });
                }
            }

            ctrl.copy_confirm = function (date, resourceId) {

                if (ctrl.settings.datePickerView == "month") {
                    var hours = moment(ctrl.copied_order.start).hours();
                    var minutes = moment(ctrl.copied_order.start).minutes();

                    date.hours(hours).minutes(minutes);
                }

                var duration = ctrl.copied_order.duration;
                var end = date.clone().add(duration, 'minutes').format("YYYY-MM-DD HH:mm");
                var start = date.format("YYYY-MM-DD HH:mm");

                if (ctrl.copied_order.type == 'event') {
                    var event_data = {};
                    event_data.start_date_time = start;
                    event_data.end_date_time = end;
                    event_data.resource_id = resourceId;

                    $api.events.copy.save({
                        "id": ctrl.copied_order.eventId,
                        "action": "copy",
                        "resource": resourceId ? resourceId : ctrl.copied_order.resourceId
                    }, event_data, function (response) {
                        ctrl.copy_cancel();

                    });
                } else {
                    $api.orders.copy.save({
                        "id": ctrl.copied_order.orderId
                    }, {
                        "type": "item",
                        "action": "copy",
                        "start": start,
                        "end": end,
                        "item": ctrl.copied_order.id,
                        "resource": resourceId ? resourceId : ctrl.copied_order.resourceId
                    }, function (response) {
                        ctrl.copy_cancel();
                    });
                }
            }

            ctrl.copy_cancel = function () {
                ctrl.copied_order = false;
                $(".copied-order").remove();
                $("#mainCalendar").removeClass('coping-enabled');
                $('.cursor-circle').css('left', '-200%').css('top', '-200%');
                $(document).off("click mousemove", "#mainCalendar");
                ctrl.refresh_calendar();
            }

            ctrl.move_order = function (event) {
                ctrl.moved_order = event;
                var event_object = $("#itm-" + event.id).closest('.fc-event');
                if (event_object.length) {
                    var clone = event_object.clone();
                    clone.css('height', event_object.height() + 8);
                    clone.addClass('moved-order');
                    $("#mainCalendar").addClass('moving-enabled').append(clone);
                    $('#itm-' + event.id).prop('checked', false);

                    var second_clone = {};
                    var second_diff = {};

                    $(".fororder-" + event.orderId).each(function () {
                        var itmId = $(this).data('item');
                        if (itmId == event.id) return;
                        second_event_object = $(this).closest('.fc-event');

                        if (second_event_object.length) {
                            var rect1 = event_object.get(0).getBoundingClientRect();
                            var rect2 = second_event_object.get(0).getBoundingClientRect();

                            second_diff[itmId] = rect2.top - rect1.top;

                            second_clone[itmId] = second_event_object.clone();
                            second_clone[itmId].css('height', second_event_object.height() + 8);
                            second_clone[itmId].addClass('moved-order');
                            $("#mainCalendar").addClass('moving-enabled').append(second_clone[itmId]);
                            second_event_object.hide();

                            second_clone[itmId].css('inset', "-100% 0 0 0");
                        }
                    });

                    event_object.hide();

                    clone.css('inset', "-100% 0 0 0");

                    $(document).off("click mousemove", "#mainCalendar");
                    $(document).on("click mousemove", "#mainCalendar", function (e) {
                        if (e.target && ($(e.target).hasClass('temp-cell') || $(e.target).hasClass('fc-day'))) {
                            var current_offset = $(e.target).offset();
                            var main_offset = $("#mainCalendar").offset();
                            $('.cursor-circle').css('left', (e.clientX - 15 - (langKey === 'hb_ISR' ? 0 : 250)) + 'px')
                            $('.cursor-circle').css('top', (e.clientY - 15 - 70 + document.documentElement.scrollTop) + 'px');

                            if (current_offset && main_offset) {
                                var newposX = current_offset.left - main_offset.left + (langKey === 'hb_ISR' ? 49 : 41);
                                var newposY = current_offset.top - main_offset.top;
                                var newposR = $(window).width() - current_offset.left - $(e.target).outerWidth() - (langKey === 'hb_ISR' ? 273 : 18);

                                clone.css('inset', newposY + "px " + newposR + "px 0 " + newposX + "px");
                                if (second_clone) {
                                    for (var itmId in second_clone) {
                                        second_clone[itmId].css('inset', (newposY + second_diff[itmId]) + "px " + newposR + "px 0 " + newposX + "px");
                                    }
                                }
                            }
                        }
                    });

                    $(document).off("keydown");
                    $(document).on("keydown", function (event) {
                        if (event.key === "Escape" || event.keyCode === 27) {
                            ctrl.move_cancel();
                        }
                    });
                }
            }

            ctrl.move_confirm = function (date, resourceId) {

                if (ctrl.settings.datePickerView == "month") {
                    var hours = moment(ctrl.moved_order.start).hours();
                    var minutes = moment(ctrl.moved_order.start).minutes();

                    date.hours(hours).minutes(minutes);
                }
                var duration = ctrl.moved_order.duration;
                var end = date.clone().add(duration, 'minutes').format("YYYY-MM-DD HH:mm");
                var start = date.format("YYYY-MM-DD HH:mm");

                if (ctrl.moved_order.type == 'event') {
                    var event_data = {};
                    event_data.start_date_time = start;
                    event_data.end_date_time = end;
                    event_data.resource_id = resourceId;

                    $api.events.single.save({
                        "id": ctrl.moved_order.eventId
                    }, event_data, function (response) {
                        ctrl.move_cancel();

                    });
                } else {
                    if (Info.data.update_order_notification == 2 && moment(start).format("YYYY-MM-DD HH:mm") != moment(ctrl.moved_order.start).format("YYYY-MM-DD HH:mm")) {
                        swal({
                            text: $translate.instant('CALENDAR_UPDATE_ORDER_NOTIFICATION'),
                            type: 'question',
                            showCancelButton: true,
                            confirmButtonText: $translate.instant('OPTION_YES'),
                            cancelButtonText: $translate.instant('OPTION_NO')
                        }).then(function (result) {
                            $api.orders.single.save({
                                "id": ctrl.moved_order.orderId
                            }, {
                                "type": "item",
                                "action": "move",
                                "start": start,
                                "end": end,
                                "item": ctrl.moved_order.id,
                                "resource": resourceId ? resourceId : ctrl.moved_order.resourceId,
                                "send_notification": result.value ? 1 : 0
                            }, function (response) {
                                ctrl.move_cancel();
                            });
                        });
                    } else {
                        $api.orders.single.save({
                            "id": ctrl.moved_order.orderId
                        }, {
                            "type": "item",
                            "action": "move",
                            "start": start,
                            "end": end,
                            "item": ctrl.moved_order.id,
                            "resource": resourceId ? resourceId : ctrl.moved_order.resourceId
                        }, function (response) {
                            ctrl.move_cancel();
                        });
                    }
                }
            }

            ctrl.move_cancel = function () {
                ctrl.moved_order = false;
                $(".moved-order").remove();
                $("#mainCalendar").removeClass('moving-enabled');
                $('.cursor-circle').css('left', '-200%').css('top', '-200%');
                $(document).off("click mousemove", "#mainCalendar");
                ctrl.refresh_calendar();
            }



            $scope.$on('$stateChangeSuccess',
                function (event, toState, toParams, fromState, fromParams) {
                    if ((fromState.name == 'app.calendar.order-copy'
                        || fromState.name == 'app.calendar.order-edit'
                        || fromState.name == 'app.calendar.event-edit'
                        || fromState.name == 'app.calendar.course-edit')
                        && toState.name == 'app.calendar') {
                        ctrl.refresh_calendar();
                    } else {
                        ctrl.get_orders_capacity();
                    }
                })

            /**
             * Change the time range (which is basicly FullCalendar view types)
             */
            ctrl.change_calendar_time = function (time) {
                ctrl.scrolled = false;
                ctrl.resetFindSettings();

                $('.moved-order').css('inset', "-100% 0 0 0");

                ctrl.settings.time = time;
                if (time == "daily") {
                    ctrl.settings.datePickerView = "date";
                    $scope.calendarConfig.defaultView = "agendaDay";
                }
                else if (time == "weekly") {
                    ctrl.settings.datePickerView = "date";

                    if (ctrl.settings.bu_type == 1) {
                        $scope.calendarConfig.defaultView = "agendaWeek";
                    }
                    else if (ctrl.settings.bu_type == 2) {
                        ctrl.settings.type = "orders";
                        // $scope.calendarConfig.defaultView = "agendaWeek";
                        $scope.calendarConfig.defaultView = "customWeek";
                    }
                }
                else {
                    ctrl.settings.datePickerView = "month";
                    $scope.calendarConfig.defaultView = "month";

                    if (ctrl.settings.bu_type == 2)
                        ctrl.settings.type = "capacity";
                }

                ctrl.change_resource();
                ctrl.initDisplayDate(ctrl.settings.date);

                if (ctrl.settings.type == "orders") {
                    ctrl.refresh_calendar();
                }
                else
                    ctrl.get_orders_capacity();

            };

            /**
             * Change calendar view type (Capacity/Orders)
             */
            ctrl.change_calendar_type = function (type) {

                ctrl.settings.type = type;
                if (ctrl.settings.bu_type == 2) {

                    if (type == "orders") {
                        ctrl.change_calendar_time("weekly");
                    }
                    else {
                        ctrl.change_calendar_time("monthly");
                    }
                }
                else if (ctrl.settings.time != "monthly") {
                    ctrl.change_calendar_time("monthly");
                }

                if (ctrl.settings.type == "orders") {
                    ctrl.refresh_calendar();
                }
                else
                    ctrl.get_orders_capacity();
            };

            /**
             * Maniplute FullCalendar DOM so we can hover over time slots on agendaView
             */
            ctrl.agenda_view_hover = function () {

                if (ctrl.settings.time == "monthly" || $scope.isMobile)
                    return;

                $('.fc-widget-content').hover(function () {

                    if (!$(this).html()) {

                        var
                            parent = $(this).parent(),
                            time = parent.data("time");

                        timeParts = String(time).split(":");
                        time = timeParts[0] + ":" + timeParts[1];

                        var limit = (ctrl.settings.time == "daily") ? 1 : 7;

                        if (ctrl.settings.time == "daily" && !ctrl.settings.resource.length)
                            limit = ctrl.uiResources.length;

                        for (var i = 0; i < limit; i++)
                            $(this).append('<div class="temp-cell" style="border: 0px; width:' + (Number($('.fc-day').width()) + 2) + 'px">' + time + '</div>');
                    }
                });
            };

            /**
             * Maniplute FullCalendar DOM so we can hover over time slots on timelineView
             */
            ctrl.timeline_view_hover = function () {

                if (ctrl.settings.time == "monthly")
                    return;

                $('.fc-time-area .fc-rows .fc-widget-content > div').hover(function () {
                    if (!$(this).find(".temp-cells").length) {
                        $(this).append('<div class="temp-cells"></div>');
                        for (var i = 1; i <= 7; i++) {
                            var
                                headerWidth = $(".fc-time-area.fc-widget-header table th:nth-child(" + i + ") .fc-cell-content").width() + 9,
                                tempCell = $("<div/>").addClass("temp-cell").width(headerWidth);
                            $(this).find(".temp-cells").append(tempCell);
                        }
                    }
                });
            };

            /**
             * Render All events
             */
            ctrl.render_client_events = function (events) {

                $("#mainCalendar").fullCalendar('removeEvents');
                $("#mainCalendar").fullCalendar('renderEvents', events);
                //uiCalendarConfig.calendars.mainCalendar.fullCalendar('removeEvents');
                //uiCalendarConfig.calendars.mainCalendar.fullCalendar('renderEvents', events);
            };

            /**
             * Filter events by Resource id
             */
            ctrl.filter_client_events = function (resource_id) {
                // If no selected resource return all events
                if (!resource_id.length) {
                    return $scope.clientEvents;
                }
                var events = [];

                $scope.clientEvents.forEach(function (event) {
                    for (var i in resource_id) {
                        if (event.resourceId == resource_id[i].id) {
                            events.push(event);
                        }
                    }
                });

                return events;
            }

            ctrl.goToCustomersBookings = function () {
                $state.go('app.admin', {}, { reload: true });
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "יומן";
            $header.breadcrumbs.push({
                "title": "NAV_DAY"
            });

            ctrl.scrolled = false;
            ctrl.scrollToTime = function () {
                //no need with current styles
                //return;
                if (ctrl.scrolled) return;

                var el = document.querySelector('.fc-now-indicator.fc-now-indicator-line');

                if (el) {
                    ctrl.scrolled = true;
                    var scrollPosition = el.offsetTop - ($('#mainCalendar').height()/2) + 100;
                    $('.fc-view-container').animate({
                        scrollTop: scrollPosition
                    }, 200, 'swing');
                }
            }

            /**
             * Pinch-to-zoom functionality for changing slot duration
             */
            ctrl.pinchZoom = {
                initialDistance: 0,
                initialInterval: null,
                isPinching: false,
                minInterval: '00:05:00', // 5 minutes minimum
                maxInterval: '04:00:00',  // 4 hours maximum
                preventDayClick: false, // Flag to prevent dayClick during pinch
                pinchAccumulator: 0, // Track accumulated pinch distance
                lastZoomTime: 0, // Prevent too frequent zoom updates
                zoomThreshold: 0.08 // Minimum accumulated change to trigger zoom
            };

            // Available interval options for zoom
            ctrl.intervalOptions = [];
            for (var i = 5; i <= 240; i+=5) {
                ctrl.intervalOptions.push('00:' + i + ':00');
            }

            /**
             * Calculate distance between two touch points
             */
            ctrl.getTouchDistance = function(touch1, touch2) {
                var dx = touch1.clientX - touch2.clientX;
                var dy = touch1.clientY - touch2.clientY;
                return Math.sqrt(dx * dx + dy * dy);
            };

            /**
             * Get the closest interval option based on scale
             */
            ctrl.getClosestInterval = function(scale) {
                var currentIndex = ctrl.intervalOptions.indexOf(ctrl.settings.interval);
                if (currentIndex === -1) currentIndex = 2; // Default to 1 hour if not found
                
                var newIndex = Math.round(currentIndex + (scale - 1) * 3);
                newIndex = Math.max(0, Math.min(ctrl.intervalOptions.length - 1, newIndex));
                
                return ctrl.intervalOptions[newIndex];
            };

            /**
             * Update calendar slot duration
             */
            ctrl.updateSlotDuration = function(newInterval) {
                if (newInterval !== ctrl.settings.interval) {
                    // Calculate the current time being viewed based on scroll position
                    var currentScrollTop = $(".fc-view-container").scrollTop();
                    var currentSlotHeight = $(".fc-slats tr").first().height();
                    var currentSlotCount = currentScrollTop / currentSlotHeight; // Use exact division, not floor
                    var currentSlotDuration = moment.duration(ctrl.settings.interval).asMinutes();
                    var currentTime = moment().startOf('day').add(currentSlotCount * currentSlotDuration, 'minutes');
                    
                    ctrl.settings.interval = newInterval;
                    
                    // Update calendar configuration
                    $("#mainCalendar").fullCalendar('option', 'slotDuration', newInterval);
                    $("#mainCalendar").fullCalendar('option', 'slotLabelInterval', newInterval);

                    // Calculate new scroll position to maintain the same time in view
                    var newSlotDuration = moment.duration(newInterval).asMinutes();
                    var newSlotHeight = $(".fc-slats tr").first().height();
                    var newSlotCount = (currentTime.diff(moment().startOf('day'), 'minutes')) / newSlotDuration;
                    var newScrollTop = newSlotCount * newSlotHeight;
                    
                    $(".fc-view-container").scrollTop(newScrollTop);
                    
                    // Add visual feedback
                    ctrl.showZoomFeedback(newInterval);
                }
            };

            /**
             * Show visual feedback for zoom changes
             */
            ctrl.showZoomFeedback = function(interval) {
                var feedback = $('<div class="zoom-feedback">');
                var zoomPercentage = Math.round((moment.duration(interval).asMinutes() / Info.data.interval) * 100);
                feedback.text('Zoom: ' + zoomPercentage + '%');
                
                $('body').append(feedback);
                
                setTimeout(function() {
                    feedback.fadeOut(300, function() {
                        feedback.remove();
                    });
                }, 500);
            };

            /**
             * Touch event handlers for pinch gestures
             */
            ctrl.initPinchZoom = function() {
                var calendarElement = document.getElementById('mainCalendar');
                if (!calendarElement) return;

                calendarElement.addEventListener('touchstart', function(e) {
                    if (e.touches.length === 2) {
                        ctrl.pinchZoom.isPinching = true;
                        ctrl.pinchZoom.preventDayClick = true;
                        ctrl.pinchZoom.initialDistance = ctrl.getTouchDistance(e.touches[0], e.touches[1]);
                        ctrl.pinchZoom.initialInterval = ctrl.settings.interval;
                        ctrl.pinchZoom.pinchAccumulator = 0; // Reset accumulator
                        ctrl.pinchZoom.lastZoomTime = 0; // Reset zoom timer
                        
                        // Add visual feedback
                        $(calendarElement).addClass('pinching');
                        
                        e.preventDefault();
                    }
                }, { passive: false });

                calendarElement.addEventListener('touchmove', function(e) {
                    if (ctrl.pinchZoom.isPinching && e.touches.length === 2) {
                        var currentDistance = ctrl.getTouchDistance(e.touches[0], e.touches[1]);
                        var scale = currentDistance / ctrl.pinchZoom.initialDistance;
                        
                        // Accumulate the pinch change
                        ctrl.pinchZoom.pinchAccumulator += (scale - 1);
                        
                        var currentTime = Date.now();
                        var zoomDelay = 30; // Minimum time between zoom updates (ms)
                        
                        // Check if we should zoom based on accumulated distance and timing
                        if (Math.abs(ctrl.pinchZoom.pinchAccumulator) >= ctrl.pinchZoom.zoomThreshold && 
                            (currentTime - ctrl.pinchZoom.lastZoomTime) >= zoomDelay) {
                            
                            var currentIndex = ctrl.intervalOptions.indexOf(ctrl.settings.interval);
                            if (currentIndex === -1) currentIndex = 2; // Default to 1 hour if not found
                            
                            // Calculate how many steps to move based on accumulated pinch
                            // Invert the direction: pinch out (positive) should zoom in (decrease index)
                            var stepsToMove = Math.round(ctrl.pinchZoom.pinchAccumulator / ctrl.pinchZoom.zoomThreshold);
                            var newIndex = currentIndex - stepsToMove;
                            newIndex = Math.max(0, Math.min(ctrl.intervalOptions.length - 1, newIndex));
                            
                            if (newIndex !== currentIndex) {
                                var newInterval = ctrl.intervalOptions[newIndex];
                                ctrl.updateSlotDuration(newInterval);
                                
                                // Reset accumulator and update time
                                ctrl.pinchZoom.pinchAccumulator = 0;
                                ctrl.pinchZoom.lastZoomTime = currentTime;
                            }
                        }
                        
                        e.preventDefault();
                    }
                }, { passive: false });

                calendarElement.addEventListener('touchend', function(e) {
                    if (ctrl.pinchZoom.isPinching) {
                        ctrl.pinchZoom.isPinching = false;
                        ctrl.pinchZoom.initialDistance = 0;
                        ctrl.pinchZoom.initialInterval = null;
                        ctrl.pinchZoom.pinchAccumulator = 0; // Reset accumulator
                        ctrl.pinchZoom.lastZoomTime = 0; // Reset zoom timer
                        
                        // Remove visual feedback
                        $(calendarElement).removeClass('pinching');
                        
                        // Reset preventDayClick flag after a short delay
                        setTimeout(function() {
                            ctrl.pinchZoom.preventDayClick = false;
                        }, 100);
                    }
                });
            };

            /**
             * Mouse wheel zoom for desktop users
             */
            ctrl.initMouseWheelZoom = function() {
                var calendarElement = document.getElementById('mainCalendar');
                if (!calendarElement) return;

                var wheelAccumulator = 0;
                var wheelThreshold = 30; // Require more wheel movement
                var lastWheelTime = 0;
                var wheelDelay = 100; // Minimum time between zoom changes (ms)

                calendarElement.addEventListener('wheel', function(e) {
                    if (e.ctrlKey || e.metaKey) { // Ctrl/Cmd + wheel
                        e.preventDefault();
                        
                        var currentTime = Date.now();
                        if (currentTime - lastWheelTime < wheelDelay) {
                            return; // Too soon, ignore this wheel event
                        }
                        
                        wheelAccumulator += e.deltaY;
                        
                        // Only change if accumulated enough movement
                        if (Math.abs(wheelAccumulator) >= wheelThreshold) {
                            var delta = wheelAccumulator > 0 ? 1 : -1;
                            var currentIndex = ctrl.intervalOptions.indexOf(ctrl.settings.interval);
                            if (currentIndex === -1) currentIndex = 2;
                            
                            var newIndex = currentIndex + delta;
                            newIndex = Math.max(0, Math.min(ctrl.intervalOptions.length - 1, newIndex));
                            
                            var newInterval = ctrl.intervalOptions[newIndex];
                            ctrl.updateSlotDuration(newInterval);
                            
                            // Reset accumulator and update time
                            wheelAccumulator = 0;
                            lastWheelTime = currentTime;
                        }
                    }
                }, { passive: false });
            };

            // Initialize pinch zoom when calendar is ready
            $timeout(function() {
                ctrl.initPinchZoom();
                ctrl.initMouseWheelZoom();
            }, 1000);
        });


})();

(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('CalendarSyncController', function ($scope, $uibModalInstance, $api, GoogleCalendarService, CalendarSyncService, Resources, $translate, moment, $q) {
            
            var ctrl = this;
            
            ctrl.resources = Resources.data || [];
            ctrl.selectedResource = null;
            ctrl.selectedDate = moment().format('YYYY-MM-DD');
            ctrl.syncLoading = false;
            ctrl.syncResults = [];

            /**
             * Initialize Google Calendar integration
             */
            ctrl.initGoogleCalendar = function() {
                ctrl.syncLoading = true;
                
                GoogleCalendarService.initialize().then(function() {
                    if (!GoogleCalendarService.isSignedIn()) {
                        return GoogleCalendarService.signIn();
                    }
                    return $q.resolve();
                }).then(function() {
                    ctrl.syncLoading = false;
                    ctrl.googleInitialized = true;
                }).catch(function(error) {
                    ctrl.syncLoading = false;
                    console.error('Google Calendar initialization error:', error);
                    
                    var errorMessage = $translate.instant('GOOGLE_CALENDAR_INIT_ERROR');
                    
                    // Provide specific error messages for common OAuth issues
                    if (error && error.includes('verification')) {
                        errorMessage = 'Google Calendar access is currently restricted. The app needs to complete Google verification. Please contact your administrator or try again later.';
                    } else if (error && error.includes('popup')) {
                        errorMessage = 'Please allow popups for this site and try again.';
                    } else if (error && error.includes('cancelled')) {
                        errorMessage = 'Google Calendar sign-in was cancelled. Please try again.';
                    }
                    
                    swal({
                        title: $translate.instant('ERROR'),
                        text: errorMessage,
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            };

            /**
             * Sync calendar for selected resource and date
             */
            ctrl.syncCalendar = function() {
                if (!ctrl.selectedResource || !ctrl.selectedResource.google_calendar_email) {
                    swal({
                        title: $translate.instant('ERROR'),
                        text: $translate.instant('GOOGLE_CALENDAR_EMAIL_REQUIRED'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                    return;
                }

                ctrl.syncLoading = true;
                ctrl.syncResults = [];

                CalendarSyncService.syncResourceCalendar(
                    ctrl.selectedResource.id,
                    ctrl.selectedResource.google_calendar_email,
                    ctrl.selectedDate
                ).then(function(result) {
                    ctrl.syncLoading = false;
                    ctrl.syncResults.push({
                        resource: ctrl.selectedResource.name,
                        date: ctrl.selectedDate,
                        result: result,
                        timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
                    });

                    var message = $translate.instant('GOOGLE_CALENDAR_SYNC_SUCCESS') + '\n';
                    message += $translate.instant('CREATED') + ': ' + result.created + '\n';
                    message += $translate.instant('UPDATED') + ': ' + result.updated + '\n';
                    message += $translate.instant('DELETED') + ': ' + result.deleted;
                    
                    if (result.errors && result.errors.length > 0) {
                        message += '\n' + $translate.instant('ERRORS') + ': ' + result.errors.length;
                    }

                    swal({
                        title: $translate.instant('GOOGLE_CALENDAR_SYNC_COMPLETE'),
                        text: message,
                        type: result.errors && result.errors.length > 0 ? "warning" : "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error) {
                    ctrl.syncLoading = false;
                    console.error('Calendar sync error:', error);
                    
                    swal({
                        title: $translate.instant('ERROR'),
                        text: $translate.instant('GOOGLE_CALENDAR_SYNC_ERROR'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            };

            /**
             * Sync calendar for all resources with Google Calendar enabled
             */
            ctrl.syncAllCalendars = function() {
                var resourcesWithGoogleSync = ctrl.resources.filter(function(resource) {
                    return resource.google_calendar_sync == 1 && resource.google_calendar_email;
                });

                if (resourcesWithGoogleSync.length === 0) {
                    swal({
                        title: $translate.instant('NO_GOOGLE_SYNC_RESOURCES'),
                        text: $translate.instant('NO_GOOGLE_SYNC_RESOURCES_MESSAGE'),
                        type: "info",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                    return;
                }

                ctrl.syncLoading = true;
                ctrl.syncResults = [];

                var syncPromises = resourcesWithGoogleSync.map(function(resource) {
                    return CalendarSyncService.syncResourceCalendar(
                        resource.id,
                        resource.google_calendar_email,
                        ctrl.selectedDate
                    ).then(function(result) {
                        ctrl.syncResults.push({
                            resource: resource.name,
                            date: ctrl.selectedDate,
                            result: result,
                            timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
                        });
                        return result;
                    });
                });

                $q.all(syncPromises).then(function(results) {
                    ctrl.syncLoading = false;
                    
                    var totalCreated = 0;
                    var totalUpdated = 0;
                    var totalDeleted = 0;
                    var totalErrors = 0;

                    results.forEach(function(result) {
                        totalCreated += result.created;
                        totalUpdated += result.updated;
                        totalDeleted += result.deleted;
                        totalErrors += result.errors ? result.errors.length : 0;
                    });

                    var message = $translate.instant('BULK_SYNC_COMPLETE') + '\n';
                    message += $translate.instant('RESOURCES_SYNCED') + ': ' + resourcesWithGoogleSync.length + '\n';
                    message += $translate.instant('CREATED') + ': ' + totalCreated + '\n';
                    message += $translate.instant('UPDATED') + ': ' + totalUpdated + '\n';
                    message += $translate.instant('DELETED') + ': ' + totalDeleted;
                    
                    if (totalErrors > 0) {
                        message += '\n' + $translate.instant('ERRORS') + ': ' + totalErrors;
                    }

                    swal({
                        title: $translate.instant('BULK_SYNC_COMPLETE'),
                        text: message,
                        type: totalErrors > 0 ? "warning" : "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error) {
                    ctrl.syncLoading = false;
                    console.error('Bulk sync error:', error);
                    
                    swal({
                        title: $translate.instant('ERROR'),
                        text: $translate.instant('BULK_SYNC_ERROR'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            };

            /**
             * Close modal
             */
            ctrl.close = function() {
                $uibModalInstance.close();
            };

            /**
             * Cancel modal
             */
            ctrl.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };

            // Initialize Google Calendar on modal open
            ctrl.initGoogleCalendar();
        });
})();

(function () {

    angular.module('app.controllers')

        .controller('ApprovalRequestController', function($window, $header, $api, $scope, $state, $rootScope, $uibModalInstance, $uibModal, OrderId) {
  
            var ctrl = this;

            ctrl.form = {
                send_method: 1
            };

            ctrl.send = function() {
                $uibModalInstance.close(ctrl.form.send_method);
            }

            ctrl.viewRequest = function() {
                
                $uibModal.open({
                    templateUrl: "app/modules/approval/approval.view.html",
                    controller: "ApprovalController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Order: ['$api', '$rootScope', function ($api) {
                            return $api.resolve("approval@get", {"id": OrderId});
                        }],
                        IsPreview: ['$rootScope', function () {
                            return 1;
                        }]
                    }
                }).closed.then(function() {
                    
                });
                // var url = $api.baseURL.replace("/api/index.php/api", "/#/approval/" );
                // // var url = "http://localhost:3000/#/approval/"
                // url += OrderId;
                // url += "/1";
                // var winRef = $window.open(encodeURI(url), "_blank");
                // winRef.addEventListener('loadstop', function(event) {
                //     console.log('loadstop');     
                //     if (event.url.match("/#/approval/"+OrderId+"2")) {
                //         winRef.close();
                //     }
                // });
            }
            
        });
})();

(function () {

    angular.module('app.controllers')

        .controller('ApprovalController', function(Order, IsPreview, $header, $api, $scope, $color, $timeout, $uibModalInstance, $window, $translate) {
  
            var ctrl = this;
            ctrl.date = moment().format("DD/MM/YYYY");
            $scope.isMobile = (angular.element(document).width() < 769);
            $scope.orderItem = Order.data;
            $scope.business = Order.data ? Order.data.business_data : {};
            $scope.business.approval_text = $scope.business.approval_text ? $scope.business.approval_text.replace(/\n/g, '<br/>') : '';
            $scope.total = 0;
            $scope.tax = 0;
            $scope.subtotal = 0;
            $scope.isApproved = false;
            $scope.isPreview = IsPreview ? true: false;        
            $scope.isApproved = $scope.orderItem.approval_sent == 2;

            if($scope.orderItem.customer_data !== null) {
                $scope.orderItem.name = $scope.orderItem.customer_data.firstname + 
                    " " + $scope.orderItem.customer_data.lastname;
            }

            if($scope.orderItem.approved_date !== null){
                $scope.orderItem.approved_date = moment($scope.orderItem.approved_date).format("DD/MM/YYYY");
            }

            function compareTimes(a, b) {
                if (a.start_time < b.start_time) return -1;
                if (a.start_time > b.start_time) return 1;
                return 0;
            }
            
            ctrl.first_item = {};
            ctrl.start = '';
            ctrl.end = '';
            ctrl.tz = '';
            ctrl.utcOffset = '';

            if ($scope.orderItem && $scope.orderItem.items) {
                $scope.orderItem.items.sort(compareTimes);
                ctrl.first_item = $scope.orderItem.items[0];

                for (var i in $scope.orderItem.items) {
                    var $item = $scope.orderItem.items[i];
                    var type_current = $item.item_data && $item.item_data.item_type ? $item.item_data.item_type : $item.item_type;
                    var type_first = ctrl.first_item.item_data && ctrl.first_item.item_data.item_type ? ctrl.first_item.item_data.item_type : ctrl.first_item.item_type;
                    if (!ctrl.first_item || type_first !== 'service' || 
                        (type_current === 'service' && $item['start_time'] && 
                        new Date($item['start_time']).getTime() < new Date(ctrl.first_item['start_time']).getTime())) {
                        ctrl.first_item = $item;
                    }
                }

                
                ctrl.date = moment(ctrl.first_item.start_time).format('YYYY-MM-DD');
                ctrl.start = moment(ctrl.first_item.start_time).format('HH:mm');
                ctrl.end = moment(ctrl.first_item.end_time).format('HH:mm');
                ctrl.tz = moment(ctrl.first_item.start_time).tz();
                ctrl.utcOffset = moment(ctrl.first_item.start_time).format('Z');
                $scope.orderItem.order_date = moment(ctrl.first_item.start_time).format("HH:mm DD/MM/YYYY");

                $timeout(function() { atcb_init(); }, 100);
            }


            if ($scope.business['favicon_path']) {
                $('#favicon').attr('href', $scope.business['favicon_path']+'favicon.ico');
                $('#favicon-16').attr('href', $scope.business['favicon_path']+'favicon-16.png');
                $('#favicon-32').attr('href', $scope.business['favicon_path']+'favicon-32.png');
                $('#favicon-64').attr('href', $scope.business['favicon_path']+'favicon-64.png');
            }
            
            ctrl.update_item_nights = function (itemIndex) {
                if ($scope.orderItem.items[itemIndex].start_time && $scope.orderItem.items[itemIndex].end_time) {
                  var duration;
                  var start_time = moment($scope.orderItem.items[itemIndex].start_time);
                  $scope.orderItem.items[itemIndex].start_time = moment(start_time).format("DD/MM/YYYY");
                  var end_time = moment($scope.orderItem.items[itemIndex].end_time);
                  $scope.orderItem.items[itemIndex].end_time = moment(end_time).format("DD/MM/YYYY");
                  duration = moment.duration(end_time.diff(start_time));
                  $scope.orderItem.items[itemIndex].nights = Math.round(duration.asDays());
                } else {
                  $scope.orderItem.items[itemIndex].nights = null;
                }
            };

            ctrl.calculate_totals = function () {
                $scope.total = 0;
                $scope.tax = 0;
                $scope.subtotal = 0;
                for (var i in $scope.orderItem.items) {
                    if ($scope.orderItem.business_data.type == 1 && $scope.orderItem.items[i].price) {
                    $scope.total += $scope.orderItem.items[i].price;
                    } else if ($scope.orderItem.business_data.type == 2 && $scope.orderItem.items[i].nights > 0) {
                    $scope.total += $scope.orderItem.items[i].item_data.price * $scope.orderItem.items[i].nights;
                    }
                }
                if ($scope.orderItem.business_data.dealer_type === "licensed") {
                    $scope.subtotal = ($scope.total / (100 + parseFloat($scope.orderItem.business_data.vat))) * 100;
                    $scope.tax = $scope.total - $scope.subtotal;
                }
            };

            for (var i in $scope.orderItem.items) {
                ctrl.update_item_nights(i);
            }

            ctrl.mainTitle = "Main Title";

            ctrl.calculate_totals();

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "NAV_APPROVAL";
            $header.breadcrumbs.push({
                "title": "NAV_APPROVAL"
            });

            ctrl.submit = function(not_arrive){
                not_arrive = not_arrive ? 1 : 0;
                $api.approval.save({
                    id: $scope.orderItem.id,
                    not_arrive: not_arrive
                }, function (response) {
                    if (response.status === "success") {
                        if (not_arrive) {
                            $scope.isApproved = false;
                            $scope.orderItem.approval_sent = 3;
                            swal({
                                title: $translate.instant('SWAL_NOT_APPROVAL_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            
                        } else {
                            $scope.isApproved = true;
                            $scope.orderItem.approval_sent = 2;
                            swal({
                                title: $translate.instant('SWAL_APPROVAL_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    }
                });
            }

            ctrl.close = function() {
                $uibModalInstance.close();
            }

            ctrl.setBusinessSettings = function() {
                $scope.business.online_booking_data.online_color = $scope.business.online_booking_data.online_color ? $scope.business.online_booking_data.online_color : '#61B9A0';
                if ($scope.business.online_booking_data.online_color == 'purple') {
                    $scope.business.online_booking_data.online_color = '#8C60AE';
                }
                if ($scope.business.online_booking_data.online_color == 'turquoise') {
                    $scope.business.online_booking_data.online_color = '#61B9A0';
                }

                $scope.business.online_booking_data.background = $scope.business.online_booking_data && $scope.business.online_booking_data.background && $scope.business.online_booking_data.background != "" ? $scope.business.online_booking_data.background : ($scope.business.online_booking_data.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
                $scope.business.online_booking_data.online_logo = $scope.business.online_booking_data && $scope.business.online_booking_data.online_logo && $scope.business.online_booking_data.online_logo != "" ? ($scope.business.online_booking_data.online_logo == "removed" ? "" : $scope.business.online_booking_data.online_logo) : location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
                
                // less.modifyVars({
                //     '@menu-color': $scope.business.menu_color ? $scope.business.menu_color : '#216089',
                //     '@online-color': $scope.business.online_booking_data.online_color,
                //     '@online-text-color':  $scope.business.online_booking_data.online_text_color,
                //     '@back-color': $scope.business.back_color ? $scope.business.back_color : '#F2F6FF',
                //     '@calendar-color': $scope.business.calendar_color != '#f2f2f2' ? $scope.business.calendar_color : '#fff',
                // });

                document.documentElement.style.setProperty('--menu-color', $scope.business.menu_color ? $scope.business.menu_color : '#216089');
                document.documentElement.style.setProperty('--online-color', $scope.business.online_booking_data.online_color);
                document.documentElement.style.setProperty('--online-text-color', $scope.business.online_booking_data.online_text_color);
                document.documentElement.style.setProperty('--back-color', $scope.business.back_color ? $scope.business.back_color : '#F2F6FF');
                document.documentElement.style.setProperty('--calendar-color', $scope.business.calendar_color != '#f2f2f2' ? $scope.business.calendar_color : '#fff');
                document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--calendar-stripe-color', $scope.business.calendar_stripe_color ? $scope.business.calendar_stripe_color : '#f7fafc');
            }

            ctrl.setBusinessSettings();

            ctrl.waPhone = function(phone) {
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                return '+972'+phone;
            }
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('AnalyticsController', function ($header, $timeout, $translate, $scope, dates, Analytics, $api, $rootScope, $user, $state, $payment) {

            var showCapacityGraph = $rootScope.$user.b_type==2;
            
            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            var ctrl = this;
            
            ctrl.isMobile = (angular.element(document).width() < 769)
            ctrl.graphHeight = ctrl.isMobile? 200 : 80;
            $scope.datesProvider = dates;

            $scope.$watch('ctrl.graphs.statsBar.start', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsBar');
                }
            });
    
            $scope.$watch('ctrl.graphs.statsBar.end', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsBar');
                }
            });
    
            $scope.$watch('ctrl.graphs.statsPie.start', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsPie');
                }
            });
    
            $scope.$watch('ctrl.graphs.statsPie.end', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsPie');
                }
            });

            function formatDateToYMD(date) {
                if (!date) return null;
                var d = new Date(date);
                var year = d.getFullYear();
                var month = ('0' + (d.getMonth() + 1)).slice(-2);
                var day = ('0' + d.getDate()).slice(-2);
                return year + '-' + month + '-' + day;
            }

            ctrl.defaults = {
                options: {
                    responsive: true,
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            stacked: true,
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            display: false
                        },
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.x) {
                            var barWidth = chart.scales.x.width / chart.data.labels.length;
                            chart.options.borderRadius = barWidth / 5;
                            chart.update();
                        }
                    }
                },
                opacity_graph_options:{
                    responsive: true,
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            stacked: true,
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.x) {
                            var barWidth = chart.scales.x.width / chart.data.labels.length;
                            chart.options.borderRadius = barWidth / 5;
                            chart.update();
                        }
                    }
                },
                stats_pie_options: {
                    responsive: false,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(tooltipItem) {
                                    var dataset = tooltipItem.dataset;
                                    var currentValue = dataset.data[tooltipItem.dataIndex];
                                    var total = dataset.data.reduce(function(acc, val) {
                                        return acc + val;
                                    }, 0);
                                    var percentage = ((currentValue / total) * 100).toFixed();
                                    return tooltipItem.label + ": " + currentValue + " (" + percentage + "%)";
                                }
                            }
                        },
                        legend: {
                            labels: {
                                generateLabels: function(chart) {
                                    var data = chart.data;
                                    return data.labels.map(function(label, index) {
                                        var value = data.datasets[0].data[index];
                                        var total = data.datasets[0].data.reduce(function(acc, val) {
                                            return acc + val;
                                        }, 0);
                                        var percentage = ((value / total) * 100).toFixed();
                                        return {
                                            text: label + ": " + value + " (" + percentage + "%)",
                                            fillStyle: data.datasets[0].backgroundColor[index],
                                            hidden: false,
                                            index: index
                                        };
                                    });
                                }
                            }
                        }
                    },
                    scales: {}
                },
                stats_bar_options: {
                    responsive: true,
                    scales: {
                        x: {
                            grid: {
                                display: false
                            }
                        },
                        y: {
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.x) {
                            var barWidth = chart.scales.x.width / chart.data.labels.length;
                            chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                            chart.update();
                        }
                    }
                },
            };

            var datasetsBar = [];
            if (Analytics && Analytics.data && Analytics.data.statsBar && Analytics.data.statsBar.values) {
                for (var key in Analytics.data.statsBar.values) {
                    datasetsBar.push({
                        label: Analytics.data.statsBar.values[key].name,
                        data: Analytics.data.statsBar.values[key].values,
                        backgroundColor: Analytics.data.statsBar.values[key].color || menu_color,
                        maxBarThickness: 60,
                    });
                }
            }

            var menu_color = $rootScope.color_form && $rootScope.color_form.menu_color ? $rootScope.color_form.menu_color : '#006495';
            var analytics_graphs = {
                "income"    : {
                    category: "",
                    categories: Analytics.data.categories,
                    resources: Analytics.data.resources,
                    payment_methods: $payment.methods,
                    payment_method: '',
                    filter: "monthly",
                    type: 'bar',
                    options: ctrl.defaults.options,
                    title: "ניתוח הכנסות",
                    customer_filter: true,
                    widgets: [
                        {
                            "icon": "fa fa-ils",
                            "title": "ANALYTIC_MONTHLY_TRANSACTIONS_TOTAL",
                            "data": Analytics.data.income.widget.monthly,
                            "bgcolor": '006495'
                        },
                        {
                            "icon": "fa fa-ils",
                            "title": "ANALYTIC_YEARLY_TRANSACTIONS_TOTAL",
                            "data": Analytics.data.income.widget.yearly,
                            "bgcolor": '006495'
                        }
                    ],
                    data: {
                        labels: Analytics.data.income.labels,
                        datasets: [{
                            label: 'הכנסות',
                            data: Analytics.data.income.values,
                            backgroundColor: menu_color,
                        },
                        {
                            label: $translate.instant("ANALYTIC_FORECAST"),
                            data: Analytics.data.income.forecast,
                            backgroundColor:  $rootScope.createDiagonalPattern(menu_color),
                        }],
                    },
                    
                },
                "orders"    : {
                    type: 'bar',
                    title: "ניתוח הזמנות",
                    category: "",
                    categories: Analytics.data.categories,
                    resources: Analytics.data.resources,
                    filter: "monthly",
                    options: ctrl.defaults.opacity_graph_options,
                    customer_filter: true,
                    widgets: [
                        {
                            "icon": "fa fa-user",
                            "title": "ANALYTIC_MONTHLY_ORDERS_TOTAL",
                            "data": Analytics.data.orders.widget.monthly,
                            "bgcolor": '3c9933'
                        },
                        {
                            "icon": "fa fa-user",
                            "title": "ANALYTIC_YEARLY_ORDERS_TOTAL",
                            "data": Analytics.data.orders.widget.yearly,
                            "bgcolor": '3c9933'
                        }
                    ],
                    data: {
                        labels: Analytics.data.orders.labels,
                        datasets: [{
                            label: 'הכנסות',
                            data: Analytics.data.orders.values,
                            backgroundColor: "#3c9933",
                        }],
                    },
                },
                "statsPie": {
                    title: $translate.instant("CUSTOMERS_STATSPIE"),
                    type: "doughnut",
                    height: ctrl.isMobile? 200 : 500,
                    start: moment().subtract(1, 'months'),
                    end: moment(),
                    data: {
                        labels: Analytics && Analytics.data && Analytics.data.statsPie ? Analytics.data.statsPie.labels : [],
                        datasets: [{
                            label: '',
                            data: Analytics && Analytics.data && Analytics.data.statsPie ? Analytics.data.statsPie.values : [],
                            backgroundColor: Analytics && Analytics.data && Analytics.data.statsPie ? Analytics.data.statsPie.colors : [],
                        }],
                    },
                    options: ctrl.defaults.stats_pie_options,
                },
                "statsBar": {
                    title: $translate.instant("CUSTOMERS_STATSBAR"),
                    type: "bar",
                    filter: "monthly",
                    start: moment().subtract(1, 'years'),
                    end: moment(),
                    data: {
                        labels: Analytics && Analytics.data && Analytics.data.statsBar ? Analytics.data.statsBar.periods : [],
                        datasets: datasetsBar,
                    },
                    options: ctrl.defaults.stats_bar_options,
                },
            };

            if(showCapacityGraph) {
                analytics_graphs["capacity"] = {
                    "title": "ניתוח תפוסה",
                    "widgets": [
                        {
                            "icon": "fa fa-bed",
                            "title": "ANALYTIC_MONTHLY_OCCUPANCY_TOTAL",
                            "data": Analytics.data.capacity.widget.monthly + "%",
                            "bgcolor": '663399'
                        },
                        {
                            "icon": "fa fa-bed",
                            "title": "ANALYTIC_YEARLY_OCCUPANCY_TOTAL",
                            "data": Analytics.data.capacity.widget.yearly + "%",
                            "bgcolor": '663399'
                        }
                    ],
                    "data": [Analytics.data.capacity.values],
                    "labels": Analytics.data.capacity.labels,
                    "filter": "monthly",
                    "options": ctrl.defaults.opacity_graph_options,
                    "hover": ctrl.defaults.hover,
                    "colors": ['#663399'],
                    "series": ["תפוסה"]
                };
            }
            
            ctrl.graphs = analytics_graphs;

            ctrl.prepare_graph_labels = function(graph) {

                ctrl.graphs[graph].labels = [];

                switch(ctrl.graphs[graph].filter) {

                    case "monthly":

                        var
                            date = new Date(),
                            month = date.getMonth() + 1,
                            monthString = month;

                        if(month < 10)
                            monthString = "0" + month;

                        for(var i = 1; i <= date.getDate(); i++) {

                            var dayString = i;

                            if(i < 10)
                                dayString = "0" + i;

                            ctrl.graphs[graph].labels.push(dayString + "/" + monthString);
                            ctrl.graphs[graph].data[0].push(Math.floor((Math.random() * 1000000) + 1));
                        }

                        break;
                    case "daily":
                        break;
                    case "year":
                        break;
                }
            };

            ctrl.loadAnalytics = function(dataType, filter) {
                if(filter) {
                    ctrl.graphs[dataType].filter = filter;
                }
                // build request body
                var request = {
                    filter: ctrl.graphs[dataType].filter,
                    type: dataType,
                    filter_values: ctrl.filter[dataType],
                    period: ctrl.graphs[dataType].filter,
                    start: ctrl.graphs[dataType].start ? ctrl.graphs[dataType].start.format('YYYY-MM-DD') : null,
                    end: ctrl.graphs[dataType].end ? ctrl.graphs[dataType].end.format('YYYY-MM-DD') : null,
                }

                request.filter_values.created_from = formatDateToYMD(request.filter_values.created_from);
                request.filter_values.created_to = formatDateToYMD(request.filter_values.created_to);
                request.filter_values.lastvisit_from = formatDateToYMD(request.filter_values.lastvisit_from);
                request.filter_values.lastvisit_to = formatDateToYMD(request.filter_values.lastvisit_to);
                request.filter_values.visited_from = formatDateToYMD(request.filter_values.visited_from);
                request.filter_values.visited_to = formatDateToYMD(request.filter_values.visited_to);


                if(ctrl.graphs[dataType].category && ctrl.graphs[dataType].category != '') {
                    request.category = ctrl.graphs[dataType].category;
                }
                if(ctrl.graphs[dataType].resource && ctrl.graphs[dataType].resource != '') {
                    request.resource = ctrl.graphs[dataType].resource;
                }
                if(ctrl.graphs[dataType].payment_method && ctrl.graphs[dataType].payment_method != '') {
                    request.payment_method = ctrl.graphs[dataType].payment_method;
                }
                
                $api.analytics.get(request, 
                    function(response) {
                        if (dataType == 'statsPie') {
                            ctrl.graphs[dataType].data.labels = response.data.statsPie.labels;
                            ctrl.graphs[dataType].data.datasets[0].data = response.data.statsPie.values;
                            ctrl.graphs[dataType].data.datasets[0].backgroundColor = response.data.statsPie.colors;
                        } else if (dataType == 'statsBar') {
                            var datasetsBar = [];
                            if (response.data.statsBar && response.data.statsBar.values) {
                                for (var key in response.data.statsBar.values) {
                                    datasetsBar.push({
                                        label: response.data.statsBar.values[key].name,
                                        data: response.data.statsBar.values[key].values,
                                        backgroundColor: response.data.statsBar.values[key].color || menu_color,
                                        maxBarThickness: 60,
                                    });
                                }
                            }

                            ctrl.graphs[dataType].data.labels = response.data.statsBar.periods;
                            ctrl.graphs[dataType].data.datasets = datasetsBar;

                        } else {
                            ctrl.graphs[dataType].data.labels = response.data[dataType].labels;
                            ctrl.graphs[dataType].data.datasets[0].data = response.data[dataType].values;

                            if (response.data[dataType].forecast) {   
                                ctrl.graphs[dataType].data.datasets[1].data = response.data[dataType].forecast;
                            }
                        }

                        ctrl.graphs[dataType].options = angular.copy(ctrl.graphs[dataType].options);
                    });
            };

            $header.title = "ניתוחים עסקיים";
            $header.breadcrumbs.push({
                "title": "NAV_ANALYTIC"
            });



            ctrl.getFilterValues = function () {
                $api.customers.filter.get({}, function (result) {
                    if (result && result.data) {
                    ctrl.filter_values = result.data;
                    }
                });
            }
    
            ctrl.getFilterValues();

            ctrl.filter_values = {};
            ctrl.filter = {};
            ctrl.filterModal = {};

            ctrl.openFilter = function(graphID) {
                if (!ctrl.filterModal[graphID]) {
                    $timeout(function() {
                    ctrl.filterModal[graphID] = true;
                    $('#page-wrapper').addClass('with-filter');
                    });
                }
            }

            ctrl.closeFilter = function(graphID) {
                if (ctrl.filterModal[graphID]) {
                    ctrl.filterModal[graphID] = false;
                    $('#page-wrapper').removeClass('with-filter');
                }
            }

            ctrl.applyFilter = function(graphID) {
                ctrl.loadAnalytics(graphID);
                ctrl.closeFilter(graphID);
            }

            
            for (var graph in ctrl.graphs) {
                ctrl.filter[graph] = {
                    'item': [],
                    'category': [],
                    'resource': [],
                    'arrival_source': [],
                    'lastvisit_from': null,
                    'lastvisit_to': null,
                    'created_from': null,
                    'created_to': null,
                    'birthday': [],
                    'status': [],
                    'visited_from': null,
                    'visited_to': null,
                    'have_card': false,
                    'gender': ''
                };
                
            }

            ctrl.clearFilter = function(graphID) {
                ctrl.filter[graphID] = {
                    'item': [],
                    'category': [],
                    'resource': [],
                    'arrival_source': [],
                    'lastvisit_from': null,
                    'lastvisit_to': null,
                    'created_from': null,
                    'created_to': null,
                    'birthday': [],
                    'status': [],
                    'visited_from': null,
                    'visited_to': null,
                    'have_card': false,
                    'gender': ''
                };
                
                ctrl.loadAnalytics(graphID);
                ctrl.closeFilter(graphID);
            }
        });
})();

(function(){
    angular.module('app.controllers').controller('AdminController', function (
        Businesses, Variants, Settings, $business, $header, $api, $state, $translate, $rootScope, $scope, DTOptionsBuilder, dataTablesHebrewProvider
    ){

        if ($rootScope.userRole !== 1){
          $state.go('app.dashboard');
          return;
        }
        var ctrl = this;
        ctrl.search = "";

        $scope.getStatusByIndex = $business.getStatusByIndex;

        $header.title = "Businesses";
        $header.breadcrumbs.push({
            "title" : "Businesses"
        });

        if(Businesses){
            ctrl.businesses = Businesses.data;
        }else{
            ctrl.businesses = [];
        }

        ctrl.variants = [];

        if (Variants){
            ctrl.variants = Variants.data;
        }

        ctrl.filtered_businessess = function() {
            if (ctrl.search) {
                var res = ctrl.businesses.filter(function (o) { return ((o.address && o.address.indexOf(ctrl.search) >= 0) ||
                                                                (o.name && o.name.indexOf(ctrl.search) >= 0) ||
                                                                (o.agent && o.agent.indexOf(ctrl.search) >= 0) ||
                                                                (o.business_type_word && o.business_type_word.indexOf(ctrl.search) >= 0) ||
                                                                (o.city && o.city.indexOf(ctrl.search) >= 0) ||
                                                                (o.company_id && o.company_id.indexOf(ctrl.search) >= 0) ||
                                                                (o.email && o.email.indexOf(ctrl.search) >= 0) ||
                                                                (o.id == ctrl.search) ||
                                                                (o.wa_instance && o.wa_instance.indexOf(ctrl.search) >= 0) ||
                                                                (o.phone && o.phone.indexOf(ctrl.search) >= 0) ||
                                                                (o.credit_suplier && o.credit_suplier.indexOf(ctrl.search) >= 0) ||
                                                                (o.credit_yaad_key && o.credit_yaad_key.indexOf(ctrl.search) >= 0) ||
                                                                (o.emv_terminal_id && o.emv_terminal_id.indexOf(ctrl.search) >= 0) ||
                                                                (o.fax && o.fax.indexOf(ctrl.search) >= 0) ||
                                                                (o.home_number && o.home_number.indexOf(ctrl.search) >= 0) ||
                                                                (o.zip && o.zip.indexOf(ctrl.search) >= 0)); });
                return res;
            } else {
                return ctrl.businesses;
            }
        }

        ctrl.enabled_cron = Settings.data ? Settings.data.enabled_cron : false;

        ctrl.change_cron = function() {
            ctrl.enabled_cron = !ctrl.enabled_cron;
            swal({
                title: "Are you sure?",
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result && result.value) {
                    ctrl.enabled_cron = !ctrl.enabled_cron;
                    $api.admin.settings.save({enabled_cron: ctrl.enabled_cron}, function(response){

                    });
                }

                
            });
        }

        ctrl.changeAllVat = function() {
            swal({
                title: "Change VAT for all licenced businesses",
                input: 'number',
                inputPlaceholder: "Enter new VAT",
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result && result.value) {
                    if (result.value < 0 || result.value > 100) {
                        swal({
                            title: "VAT must be between 0 and 100",
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        return;
                    }

                    var vat = result.value
                    swal({
                        title: "Are you sure?",
                        text: "Are you sure you want to change VAT for all licenced businesses to "+result.value+"?",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                        confirmButtonClass: "btn-danger",
                        showLoaderOnConfirm: true
                    }).then(function(result) {
                        if (result.value) {
                            $api.businesses.change_all_vat.get({vat: vat}, function(response){
                                if (response && response.success) {
                                    $api.businesses.get(function(response){
                                        if (response && response.success) {
                                            ctrl.businesses = response.data;
                                            swal({
                                                title: "VAT changed successfully",
                                                type: "success",
                                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                                timer: 2000
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });


                }
            });

        }
    });
})();

(function() {
    
    angular.module("app.components").factory("$header", function(){
        
        var $header = this;
        
        /**
         * Holds the title of the current module
         * @type string
         */
        $header.title = null;
        
        /**
         * Holds the path to the current module
         * @type object[]
         */
        $header.breadcrumbs = null;
    
        /**
         * Reset the header variables to their defaults
         * @returns void
         */
        $header.reset = function() {
            
            $header.title = null;
            
            $header.breadcrumbs = [{
                "title": "DASHBOARD",
                "state": "app.dashboard"
            }];
        };
        
        $header.reset();
        
        return $header;
    });
})();
(function(){
    angular.module("app.controllers").controller("HeaderController", function($header, $user, $state, $scope, $cookies, $api, $business, $uibModal, $rootScope, $translate, $filter){
        var header = this;
        header.show_history_link = $state.current.name === 'app.cashbox' || $state.current.name === 'app.cashbox.order';
        header.title = $header.title;
        header.breadcrumbs = $header.breadcrumbs;

        header.dealer_name = $rootScope.$user && $rootScope.$user.dealer_name ? $rootScope.$user.dealer_name : '';
        header.wa_status = $cookies.get("wa_status");
        header.wa_instance = $rootScope.$user && $rootScope.$user.wa_instance ? $rootScope.$user.wa_instance : false;

        header.activeMessageModal = false;
        header.messages = $rootScope.b_messages;
        header.activeFilterModal = false;
        header.filters = $rootScope.filters;
        header.openedWaNotifications = false;
        header.notifications = {
            wa_list: [],
            wa_unread: 0,
        };

        header.is_ai_enabled = $business.is_ai_enabled;
        $scope.$watch(function(){ return $business.is_ai_enabled; }, function(next){
            header.is_ai_enabled = next;
        });

        header.stop_messages = $rootScope.$user && $rootScope.$user.stop_messages;
        var linkifyFilter = $filter('linkify');

        header.checkUnread = function () {
            for (var i in header.messages) {
            if (!header.messages[i].read_at) {
                $image = "";
                switch (header.messages[i].type) {
                    case 'info':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjU2IDU2QzE0NS43MiA1NiA1NiAxNDUuNzIgNTYgMjU2czg5LjcyIDIwMCAyMDAgMjAwIDIwMC04OS43MiAyMDAtMjAwUzM2Ni4yOCA1NiAyNTYgNTZabTAgODJhMjYgMjYgMCAxIDEtMjYgMjYgMjYgMjYgMCAwIDEgMjYtMjZabTQ4IDIyNmgtODhhMTYgMTYgMCAwIDEgMC0zMmgyOHYtODhoLTE2YTE2IDE2IDAgMCAxIDAtMzJoMzJhMTYgMTYgMCAwIDEgMTYgMTZ2MTA0aDI4YTE2IDE2IDAgMCAxIDAgMzJaIiBmaWxsPSIjZjBhZDRlIiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48L3N2Zz4=";
                        break;
                    case 'error':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjU2IDQ4QzE0MS4zMSA0OCA0OCAxNDEuMzEgNDggMjU2czkzLjMxIDIwOCAyMDggMjA4IDIwOC05My4zMSAyMDgtMjA4UzM3MC42OSA0OCAyNTYgNDhabTc1LjMxIDI2MC42OWExNiAxNiAwIDEgMS0yMi42MiAyMi42MkwyNTYgMjc4LjYzbC01Mi42OSA1Mi42OGExNiAxNiAwIDAgMS0yMi42Mi0yMi42MkwyMzMuMzcgMjU2bC01Mi42OC01Mi42OWExNiAxNiAwIDAgMSAyMi42Mi0yMi42MkwyNTYgMjMzLjM3bDUyLjY5LTUyLjY4YTE2IDE2IDAgMCAxIDIyLjYyIDIyLjYyTDI3OC42MyAyNTZaIiBmaWxsPSIjZDk1MzRmIiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48L3N2Zz4=";
                        break;
                    case 'success':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjU2IDQ4QzE0MS4zMSA0OCA0OCAxNDEuMzEgNDggMjU2czkzLjMxIDIwOCAyMDggMjA4IDIwOC05My4zMSAyMDgtMjA4UzM3MC42OSA0OCAyNTYgNDhabTEwOC4yNSAxMzguMjktMTM0LjQgMTYwYTE2IDE2IDAgMCAxLTEyIDUuNzFoLS4yN2ExNiAxNiAwIDAgMS0xMS44OS01LjNsLTU3LjYtNjRhMTYgMTYgMCAxIDEgMjMuNzgtMjEuNGw0NS4yOSA1MC4zMiAxMjIuNTktMTQ1LjkxYTE2IDE2IDAgMCAxIDI0LjUgMjAuNThaIiBmaWxsPSIjM2NhYjM1IiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48L3N2Zz4=";
                        break;
                    case 'warning':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNDQ5LjA3IDM5OS4wOCAyNzguNjQgODIuNThjLTEyLjA4LTIyLjQ0LTQ0LjI2LTIyLjQ0LTU2LjM1IDBMNTEuODcgMzk5LjA4QTMyIDMyIDAgMCAwIDgwIDQ0Ni4yNWgzNDAuODlhMzIgMzIgMCAwIDAgMjguMTgtNDcuMTdabS0xOTguNi0xLjgzYTIwIDIwIDAgMSAxIDIwLTIwIDIwIDIwIDAgMCAxLTIwIDIwWm0yMS43Mi0yMDEuMTUtNS43NCAxMjJhMTYgMTYgMCAwIDEtMzIgMGwtNS43NC0xMjEuOTVhMjEuNzMgMjEuNzMgMCAwIDEgMjEuNS0yMi42OWguMjFhMjEuNzQgMjEuNzQgMCAwIDEgMjEuNzMgMjIuN1oiIGZpbGw9IiNmOGJiODYiIGNsYXNzPSJmaWxsLTAwMDAwMCI+PC9wYXRoPjwvc3ZnPg==";
                        break;
                }
                var html = "";
                var title = "";
                if (header.messages[i].title) {
                    html += "<p style='text-align: start; font-size: 125%;'><b>"+header.messages[i].title+"</b></p>";
                    title = $translate.instant('NOTIFICATION_TITLE');
                }
                html += "<p style='text-align: start;'>"+linkifyFilter(header.messages[i].message)+"</p>";

                swal({
                    title: title,
                    html: html,
                    imageUrl: $image,
                    imageWidth: 100,
                    imageHeight: 100,
                    confirmButtonText: $translate.instant('SETTINGS_OK'),
                    showCancelButton: false,
                }).then(function(result) {
                    if (result.value) {
                        $api.b_messages.read.get({id: header.messages[i].id}, function (response) {
                            if (response.status == "success") {
                                $rootScope.b_messages = response.data;
                                header.messages = $rootScope.b_messages;
                                header.checkUnread();
                            }
                        });
                    }
                });

                break;
            }
          }
        }

        header.removeMessage = function (id) {
            $api.b_messages.remove.get({id: id}, function (response) {
                if (response.status == "success") {
                    $rootScope.b_messages = response.data;
                    header.messages = $rootScope.b_messages;
                    header.checkUnread();
                }
            });
        }

        header.removeFilter = function (id) {
            swal({
                title: $translate.instant('STORE_FILTER_DELETE_CONFIRM'),
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value) {
                    $api.filters.single.remove({id: id}, function (response) {
                        if (response.status == "success") {
                            swal({
                                title: $translate.instant('STORE_FILTER_DELETED'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 1500
                            });

                            $user.getFilters();
                        }
                    });
                }
            }); 
        }

        header.goFilter = function (filter) {
            switch (filter.module) {
                case 'customers':
                    $rootScope.customers_filter = filter.data;
                    $state.go('app.customers', {}, {reload: true});
                    break;
                case 'leads':
                    $rootScope.leads_filter = filter.data;
                    $state.go('app.leads', {}, {reload: true});
                    break;
                case 'reports':
                    $rootScope.reports_filter = filter.data;
                    $state.go('app.reports', {tab: 9}, {reload: true});
                    break;
                case 'sales':
                    $rootScope.sales_filter = filter.data;
                    $state.go('app.reports', {tab: 12}, {reload: true});
                    break;
            }
        }

        header.openFeedbackModal = function () {
            $uibModal.open({
                templateUrl: "app/components/feedback/feedback.form.html",
                controller: "FeedbackController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "tif-modal form-modal medium-modal"
            })
        }

        header.menuToggle = function () {
            angular.element('body').toggleClass('mini-navbar');
            if (!angular.element('.menuBackDrop').length) {
                angular.element('body').append("<div class='menuBackDrop' onclick='menuBackDropMinimaze()'></div>");
            }
        }

        function onBMessagesUpdated() {
            header.messages = $rootScope.b_messages;
            header.checkUnread();
        }

        function onFiltersUpdated() {
            header.filters = $rootScope.filters;
        }

        function onNotificationsUpdated() {
            header.notifications.wa_list = $rootScope.notification_list && $rootScope.notification_list.wa_list ? $rootScope.notification_list.wa_list : [];
            header.notifications.wa_unread = $rootScope.notification_list && $rootScope.notification_list.wa_unread ? $rootScope.notification_list.wa_unread : 0;
        }

        header.waStatusInterval = false;
        header.getQrCode = function() {
            if (header.wa_instance) {
                if (header.wa_status != 'authorized') {
                    $api.wa.qr_code.get({}, function (response) {
                        if (response.status == "success" && response.response && response.response.message) {
                            header.waQrCode = response.response.message;

                            swal({
                                imageUrl: "data:image/png;base64,"+header.waQrCode,
                                imageWidth: 300,
                                imageHeight: 300,
                                confirmButtonText: $translate.instant('SETTINGS_OK'),
                            });

                            clearInterval(header.waStatusInterval);
                            header.waStatusInterval = setInterval(function() {
                                header.checkWaStatus();
                            }, 3000);
                        }
                    });
                } else {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_WA_LOGOUT'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                        confirmButtonClass: "btn-danger",
                        showLoaderOnConfirm: true
                    }).then(function(result) {
                        if(result.value) {
                            $api.wa.logout.get({}, function (response) {
                                if (response.status == "success") {
                                    header.waQrCode = false;
                                    header.wa_status = 'notAuthorized';
                                    $cookies.put("wa_status", 'notAuthorized');
                                    clearInterval(header.waStatusInterval);
                                }
                            });
                        }
                    });
                }
            } else {
                swal({
                    title: "",
                    text: $translate.instant('WA_MESSAGE'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('WA_CONTACT'),
                    cancelButtonText: $translate.instant('WA_CLOSE'),
                    confirmButtonClass: "btn-wa",
                    cancelButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: false
                  }).then(function(result) {
                    if (result.value) {
                        window.open("https://wa.me/+972506177762", "_blank");
                    }
                  });
            }
        }

        header.checkWaStatus = function() {
            if (header.waQrCode) {
                $api.wa.status.get({}, function (response) {
                    if (response.status == "success" && response.response == 'authorized') {
                        clearInterval(header.waStatusInterval);
                        header.waQrCode = false;
                        header.wa_status = 'authorized';
                        $cookies.put("wa_status", 'authorized');
                    }
                });
                
            } else {
                clearInterval(header.waStatusInterval);
            }
        }

        header.clickNotification = function (notification) {
            header.removeNotification(notification);
            if (notification.customer_id) {
                $state.go('app.customers.single', {id: notification.customer_id});
            }
        }

        header.removeNotification = function (notification) {
            $api.notifications.remove.get({id: notification.id}, function (response) {
                if (response.status == "success") {
                    $user.getNotifications();
                }
            });
        }

        header.goAllNotifications = function (wa) {
            $state.go('app.notifications');
        }

        header.removeAllNotifications = function (type) {
            $api.notifications.removeAll.delete({type: type}, function (response) {
                if (response.status == "success") {
                    $user.getNotifications();
                }
            });
        }

        $rootScope.initStatus = false;
        initWaStatus = function() {
            $rootScope.initStatus = true;
            $api.wa.status.get({}, function (response) {
                if (response.status == "success" && response.response == 'authorized') {
                    header.waQrCode = false;
                    header.wa_status = 'authorized';
                    $cookies.put("wa_status", 'authorized');
                } else {
                    header.waQrCode = false;
                    header.wa_status = 'notAuthorized';
                    $cookies.put("wa_status", 'notAuthorized');
                }
            });
        }    

        if (!$rootScope.initStatus) {
            initWaStatus();
        }
    
        // Listen for the event when $rootScope.b_messages is updated
        $scope.$on('b_messages_updated', onBMessagesUpdated);
        $scope.$on('filters_updated', onFiltersUpdated);
        $scope.$on('notifications_updated', onNotificationsUpdated);
    
        // Initial call to checkUnread
        onBMessagesUpdated();
        onFiltersUpdated();
        onNotificationsUpdated();
    });
})();
(function () {
  'use strict';

  angular.module('app.controllers').controller('GiftCardController', function ($translate, $color) {
    var ctrl = this;

    var DEFAULT_SETTINGS = {
      page_bg_color: '#EEF3FC',
      card_bg_color: '#ffffff',
      primary_color: '#275A7B',
      text_color: '#1A202C',
      logo: '/assets/images/gift-card-logo.png',
      image: '/assets/images/gift-card-image.png',
      receiver: true,
      sender: true,
      service: true,
      value: true,
      message: true,
    };

    var DEFAULT_VALUES = {
      number: $translate.instant('DEFAULT_GIFT_CARD_NUMBER'),
      business: $translate.instant('DEFAULT_GIFT_CARD_BUSINESS'),
      address: $translate.instant('DEFAULT_GIFT_CARD_ADDRESS'),
      service: $translate.instant('DEFAULT_GIFT_CARD_SERVICE'),
      receiver: $translate.instant('DEFAULT_GIFT_CARD_RECEIVER'),
      value: $translate.instant('DEFAULT_GIFT_CARD_VALUE'),
      message: $translate.instant('DEFAULT_GIFT_CARD_MESSAGE'),
      sender: $translate.instant('DEFAULT_GIFT_CARD_SENDER'),
    };

    function computeGradient(base) {
      if ($color.gradientLR) {
        return $color.gradientLR(base, 0.50, -0.20);
      }

      var from = $color.pSBC(0.50, base, null, true);
      var to = $color.pSBC(-0.20, base, null, true);
      return 'linear-gradient(90deg,' + from + ' 0%,' + to + ' 100%)';
    }

    ctrl.$onInit = function () {
      ctrl.size = (ctrl.size || 'normal').toLowerCase();
      ctrl.view = (ctrl.view || 'desktop').toLowerCase();
      ctrl.settings = angular.merge({}, DEFAULT_SETTINGS, ctrl.settings || {});
      ctrl.values = angular.merge({}, DEFAULT_VALUES, ctrl.values || {});
      ctrl.card_bg_gradient = computeGradient(ctrl.settings.card_bg_color);
    };

    ctrl.$onChanges = function (changes) {
      if (changes.settings && !changes.settings.isFirstChange()) {
        ctrl.settings = angular.merge({}, DEFAULT_SETTINGS, changes.settings.currentValue || {});
        ctrl.card_bg_gradient = computeGradient(ctrl.settings.card_bg_color);
      }
      if (changes.values && !changes.values.isFirstChange()) {
        ctrl.values = angular.merge({}, DEFAULT_VALUES, changes.values.currentValue || {});
      }

      if (changes.size && changes.size.currentValue) {
        ctrl.size = String(changes.size.currentValue).toLowerCase();
      }

      if (changes.view && changes.view.currentValue) {
        ctrl.view = String(changes.view.currentValue).toLowerCase();
      }
    };

    ctrl.classes = function () {
      return {
        'gift-card--mobile': ctrl.view === 'mobile',
        'gift-card--zoom-on-hover': ctrl.zoomOnHover,
        'gift-card--sm': ctrl.size === 'small',
        'gift-card--lg': ctrl.size === 'large',
        'gift-card--md': ctrl.size === 'normal' || !ctrl.size,
      };
    };
  });
})();

(function () {
  'use strict';

  angular.module('app.components').component('giftCard', {
      bindings: {
        settings: '<',
        values: '<',
        size: '@?', // size: "small" | "normal" | "large"
        view: '@?', // view: "desktop" | "mobile"
        zoomOnHover: '<?' // boolean (optional, one-way binding)
      },
      controllerAs: 'ctrl',
      templateUrl: 'app/components/gift_card/gift_card.view.html',
      controller: 'GiftCardController',
    });
})();
(function(){
    angular.module('app.controllers').controller('FeedbackController', function ($header, $rootScope, $state, $scope, $api, $uibModalStack, $filter){
        if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        $scope.isModal = true;

        this.submit = function() {
            /**
             * Send feedback to backend to be sent to admin
             */
            $api.feedback.save(ctrl.feedback, function(response){
                if(response.status == "success") {
                    $uibModalStack.dismissAll();
                    var title = $filter('translate')('FEEDBACK_REQUEST_SUCCESS');
                    var type = 'success';
                } else {
                    var title = $filter('translate')('FEEDBACK_REQUEST_ERROR');
                    var type = 'warning';
                }
                swal({
                    title: title,
                    type: type,
                    confirmButtonText: "OK",
                    timer: 3000
                });

            });
        }

    });
})();

(function() {
    
    angular.module("app.components").factory("$cfilter", function($rootScope){
        
        var $cfilter = this;
        $cfilter.values = {};
        $cfilter.module = null;
        $cfilter.store = false;
        
        $cfilter.apply = function(module, store) {
            $cfilter.values = $rootScope[module+'_filter'] || {};
            $cfilter.module = module;
            $cfilter.store = store || false;
        };

        return $cfilter;
    });
})();

(function(){
    angular.module("app.controllers").controller("CfilterController", function($rootScope, $cfilter, $customFields, $scope, $api, $timeout, $uibModal, $translate){
        var cfilter = this;
        cfilter.filter_values = {};
        cfilter.module = $cfilter.module;
        cfilter.store = $cfilter.store;

        cfilter.openFilter = function() {
            if (!cfilter.filterModal) {
              $timeout(function() {
                cfilter.filterModal = true;
                $('#page-wrapper').addClass('with-filter');
              });
            }
        }

        cfilter.closeFilter = function() {
          if (cfilter.filterModal) {
            cfilter.filterModal = false;
            $('#page-wrapper').removeClass('with-filter');
          }
        }

        cfilter.storeFilter = function() {
          $uibModal.open({
            templateUrl: "app/components/cfilter/store-filter/store-filter.html",
            controller: "StoreFilterController",
            controllerAs: "ctrl",
            windowTopClass: "form-modal small-modal",
            scope: $scope,
            resolve: {
              Data: cfilter
            }
          }).closed.then(function() {
            cfilter.applyFilter();
          });
        }

        cfilter.applyFilter = function() {
          var filter = cfilter.filter;

          function formatDateToYMD(date) {
            if (!date) return null;
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + d.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
          }

          function formatDateToYMDHM(date) {
            if (!date) return null;
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + d.getDate()).slice(-2);
            var hours = ('0' + d.getHours()).slice(-2);
            var minutes = ('0' + d.getMinutes()).slice(-2);
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
          }

          // convert only specific fields to "YYYY-MM-DD"
          filter.created_from = formatDateToYMD(filter.created_from);
          filter.created_to = formatDateToYMD(filter.created_to);
          filter.lastvisit_from = formatDateToYMD(filter.lastvisit_from);
          filter.lastvisit_to = formatDateToYMD(filter.lastvisit_to);
          filter.visited_from = formatDateToYMD(filter.visited_from);
          filter.visited_to = formatDateToYMD(filter.visited_to);

          if (filter.custom_fields && cfilter.filter_values.custom_fields) {
            angular.forEach(filter.custom_fields, function(value, fieldId) {
              var def = cfilter.filter_values.custom_fields.find(function(f) {
                return f.id == fieldId;
              });

              if (!def) return;

              if (def.type === 'date') {
                // for a plain date → YYYY-MM-DD
                filter.custom_fields[fieldId] = formatDateToYMD(value);
              }
              // else if (def.type === 'datetime') {
              //   // for date+time → YYYY-MM-DD HH:mm
              //   filter.custom_fields[fieldId] = formatDateToYMDHM(value);
              // }
            });
          }

          $rootScope[cfilter.module + '_filter'] = filter;

          if ($scope.submit_filter) {
            $scope.submit_filter();
          }

          cfilter.closeFilter();
        };

        cfilter.clearFilter = function() {

          cfilter.filter = {
            'item': [],
            'category': [],
            'resource': [],
            'arrival_source': [],
            'lastvisit_from': null,
            'lastvisit_to': null,
            'created_from': null,
            'created_to': null,
            'birthday': [],
            'status': [],
            'visited_from': null,
            'visited_to': null,
            'have_card': false,
            'gender': ''
          };
          
          $rootScope[cfilter.module+'_filter'] = cfilter.filter;

          if ($scope.submit_filter) {
            $scope.submit_filter();
          }
          cfilter.closeFilter();
        }

        if ($cfilter.values) {
          cfilter.filter = $cfilter.values;
        }

        cfilter.getFilterValues = function () {
          $api.customers.filter.get({}, function (result) {
            if (result && result.data) {
              cfilter.filter_values = result.data;
              cfilter.filter_values.statuses.unshift({id: '', name: $translate.instant('FILTER_STATUS_EMPTY')});

              cfilter.filter_values.types = [
                {id: 'customer', name: $translate.instant('FILTER_TYPE_CUSTOMER')},
                {id: 'lead', name: $translate.instant('FILTER_TYPE_LEAD')}
              ];

              if (cfilter.filter_values.custom_fields) {
                cfilter.filter_values.custom_fields.filter(function(field) {
                  field.name = $customFields.getCurrentName(field.name);

                  if (field.type === 'list') {
                    if (!Array.isArray(field.values)) {
                      return false;
                    }

                    field.values = field.values.filter(function(v) {
                      return v.active === true;
                    });

                    return field.values.length > 0;
                  }

                  return true;
                });
              }

              function syncSelectedWithSource(selectedArray, sourceArray) {
                if (!angular.isArray(selectedArray) || !angular.isArray(sourceArray)) return [];
                var synced = [];
                for (var i = 0; i < selectedArray.length; i++) {
                  var sel = selectedArray[i];
                  var found = null;
                  for (var j = 0; j < sourceArray.length; j++) {
                    if (sourceArray[j].id === sel.id) {
                      found = sourceArray[j];
                      break;
                    }
                  }
                  synced.push(found || sel);
                }
                return synced;
              }

              if (cfilter.filter) {
                cfilter.filter.item = syncSelectedWithSource(cfilter.filter.item, cfilter.filter_values.items);
                cfilter.filter.category = syncSelectedWithSource(cfilter.filter.category, cfilter.filter_values.categories);
                cfilter.filter.resource = syncSelectedWithSource(cfilter.filter.resource, cfilter.filter_values.resources);
                cfilter.filter.arrival_source = syncSelectedWithSource(cfilter.filter.arrival_source, cfilter.filter_values.arrival_sources);
                cfilter.filter.status = syncSelectedWithSource(cfilter.filter.status, cfilter.filter_values.statuses);
                cfilter.filter.interested = syncSelectedWithSource(cfilter.filter.interested, cfilter.filter_values.interested);

                if (cfilter.filter.custom_fields && cfilter.filter_values.custom_fields) {
                  angular.forEach(cfilter.filter.custom_fields, function(val, key) {
                    var field = null;
                    for (var i = 0; i < cfilter.filter_values.custom_fields.length; i++) {
                      var f = cfilter.filter_values.custom_fields[i];
                      if (f.id == key && f.type === 'list') {
                        field = f;
                        break;
                      }
                    }
                    if (field) {
                      cfilter.filter.custom_fields[key] = syncSelectedWithSource(val, field.values);
                    }
                  });
                }
              }
            }
          });
        }

        cfilter.getFilterValues();
      
    });
})();
(function () {

    angular.module("app", [

        "app.providers",

        "app.services",

        "app.components",

        "app.filters",

        "app.controllers",

        "app.modules",

        'pusher-angular',

        "pascalprecht.translate",

        "selectize",

        "ngjsColorPicker",

        "socialLogin",

        "ngSanitize"

    ]).config(function ($stateProvider, $urlRouterProvider, chosenProvider, $translateProvider, socialProvider){
        var time = new Date().getTime();
        //socialProvider.setFbKey({appId: "882336122999637", apiVersion: "v17.0"});


        var d = document, fbJs, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
        fbJs = d.createElement('script'); 
        fbJs.id = id; 
        fbJs.async = true;
        fbJs.src = "//connect.facebook.net/en_US/sdk.js";

        fbJs.onload = function() {
            FB.init({ 
                appId: "334220589223415",
                status: false, 
                cookie: true, 
                xfbml: true,
                version: "v18.0"
            });
        };

        ref.parentNode.insertBefore(fbJs, ref);


        $translateProvider.useStaticFilesLoader({
            prefix: '/app/translations/lang_',
            suffix: '.json?'+time
        });
        $translateProvider.preferredLanguage(localStorage.getItem('language') ? localStorage.getItem('language') : 'hb_ISR');
        $stateProvider.state('app', {
            abstract: true,
            url: "",
            templateUrl: "app/components/common/content.html"
        });
        $urlRouterProvider.otherwise('/');
        chosenProvider.setOption({
            rtl: true
        });
    }).run(function ($rootScope, $state, $user, $header, $webview) {
        $webview.handshake()

        $rootScope.$state = $state;

        $rootScope.availableLocales = ['hb_ISR', 'en_US', 'ar_AR', 'ja_JP', 'ru_RU'];

        $rootScope.page_is_loading = true;

        $rootScope.langKey = localStorage.getItem('language') ? localStorage.getItem('language') : 'hb_ISR';

        window.langKey = $rootScope.langKey;

        $rootScope.$on('change-language', function(event, langKey){
            window.langKey = langKey;

            if((window.langKey === 'hb_ISR' || window.langKey === 'ar_AR') && !document.getElementById('bootstrap-rtl-id')){
                var link = document.createElement('link');
                link.id = 'bootstrap-rtl-id';
                link.rel = 'stylesheet';
                link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css';
                document.head.appendChild(link);
            }else{
                if(window.langKey !== 'hb_ISR' && document.getElementById('bootstrap-rtl-id')){
                    document.getElementById("bootstrap-rtl-id").remove();
                }
            }
        });

        function isCustomerSingle(name) {
            return !!name && name.indexOf('app.customers.single') === 0;
        }

        $rootScope.$on('$stateChangeSuccess', function(evt, to, toP, from, fromParams) {
            if (!from || !from.name) return;

            if (from.name === 'app.calendar.order-edit' && isCustomerSingle(to && to.name)) {
                var payload = {
                    name: from.name,
                    params: fromParams || {}
                };

                try {
                    sessionStorage.setItem('backTarget', JSON.stringify(payload));
                } catch (e) {
                    // ignore storage errors
                }
            }

            var fromIsSingle = isCustomerSingle(from && from.name);
            var toIsSingle   = isCustomerSingle(to && to.name);
            if (fromIsSingle && !toIsSingle) {
                try {
                    sessionStorage.removeItem('backTarget');
                } catch (e) {
                    // ignore storage errors
                }
            }
        });

        $rootScope.logout = $user.logout;

        $rootScope.changeLanguage = $user.changeLanguage;

        $rootScope.currentLanguage = $user.currentLanguage;


        if((window.langKey === 'hb_ISR' || window.langKey === 'ar_AR') && !document.getElementById('bootstrap-rtl-id')){
            var link = document.createElement('link');
            link.id = 'bootstrap-rtl-id';
            link.rel = 'stylesheet';
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css';
            document.head.appendChild(link);
        }else{
            if(window.langKey !== 'hb_ISR' && window.langKey !== 'ar_AR' && document.getElementById('bootstrap-rtl-id')){
                document.getElementById("bootstrap-rtl-id").remove();
            }
        }

        $rootScope.$on("$stateChangeStart", function (event, toState) {
            if($rootScope.userRole == 1) {
              if (toState.name === 'app.dashboard' || toState.name === 'login') {
                  $state.go("app.admin");
                  event.preventDefault();
                  return;
              }
            }

            $rootScope.wrapperClasses = "wrapper wrapper-content animated fadeInLeft";

            $header.reset();

            //Check on server if user still active
            $user.isAuth(function (isAuth) {
                $rootScope.isAuth = isAuth;

                if(!isAuth && toState.name !== "login" && toState.name !== "approval" && toState.name !== "order" && toState.name !== "review" && toState.name !== "document" && toState.name !== "form" && toState.name !== "prepaid" && toState.name !== "login.forgot_password" && toState.name !== "forgotpassword" && toState.name !== "login.termsofuse" && toState.name !== "e" && toState.name !== "pay" && toState.name !== "customers_public_form" && toState.name !== "gift_card" && toState.name !== "cardrequest"){
                    $state.go("login");
                }
                else if (isAuth && toState.name === "login"){
                  $user.go_default_screen();
                }
            });
        });

        $rootScope.$on('$stateChangeSuccess', function() {
            $rootScope.page_is_loading = false;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            window.scrollTo(0, 0);
        });

        $rootScope.$on('$viewContentLoaded', function(){
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            window.scrollTo(0, 0);
        });

        $rootScope.getInitials = function(name) {
            // Logic to extract initials from the user name
            var initials = name.match(/\b\w/g) || [];
            return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        };

        $rootScope.lightenColor = function(color, percent) {
            var num = parseInt(color.replace('#', ''), 16),
                amt = Math.round(2.55 * percent),
                R = (num >> 16) + amt,
                G = (num >> 8 & 0x00FF) + amt,
                B = (num & 0x0000FF) + amt;
            return '#' + (
                0x1000000 + 
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + 
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + 
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            ).toString(16).slice(1).toUpperCase();
        };

        $rootScope.createDiagonalPattern = function(color) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
        
            var size = 8;
            var stroke = 3;
            var strokeOffset = stroke / 2;
            canvas.width = size;
            canvas.height = size;
        
            context.strokeStyle = color; // 'rgba(0, 0, 0, 1)';
            context.lineWidth = stroke;
        
            // The offset is needed because of antialiasing. We always want to draw outside the edge
            context.moveTo(size / 2 - strokeOffset, -strokeOffset);
            context.lineTo(size + strokeOffset, size / 2 + strokeOffset);
            context.moveTo(-strokeOffset, size / 2 - strokeOffset);
            context.lineTo(size / 2 + strokeOffset, size + strokeOffset);
            context.stroke();
        
            return context.createPattern(canvas, 'repeat');
        }

    });


})();

(function () {
  'use strict';

  angular.module('app').controller('AiRenderController', AiRenderController);

  AiRenderController.$inject = ['$state', '$location', '$window', '$api'];
  function AiRenderController($state, $location, $window, $api) {
    var vm = this;

    vm.hasChart = function () { return !!$window.Chart; };

    /* ==================== TABLE HELPERS ==================== */

    vm.TABLE_LIMIT = 20;

    vm.cell = function (rowArray, colIndex) {
      return (Array.isArray(rowArray) ? rowArray[colIndex] : null);
    };

    vm.normalizeRows = function (block) {
      var cols = block.columns || [];
      var colKeys = cols.map(function (c) {
        return c.key;
      });

      var rows = block.rows || [];
      if (!Array.isArray(rows)) {
        return [];
      }

      return rows.map(function (r) {
        if (Array.isArray(r)) {
          if (r.length < cols.length) {
            return r.concat(Array(cols.length - r.length).fill(null));
          }

          if (r.length > cols.length) {
            return r.slice(0, cols.length);
          }

          return r;
        } else if (r && typeof r === 'object') {
          return colKeys.map(function (k) {
            return Object.prototype.hasOwnProperty.call(r, k) ? r[k] : null;
          });
        }

        return Array(cols.length).fill(null);
      });
    };

    vm.visibleRows = function (block) {
      var norm = vm.normalizeRows(block);
      return norm.slice(0, vm.TABLE_LIMIT);
    };

    vm.isCustomersTable = function (block) {
      return !!(
        block &&
        block.type === 'table' &&
        block.row_link &&
        block.row_link.type === 'navigate' &&
        block.row_link.target === 'customer_detail' &&
        block.row_link.param_map &&
        typeof block.row_link.param_map.id === 'string'
      );
    };

    vm.formatCell = function (val, col) {
      var fmt = (col && col.format) || 'text';
      if (val == null) return '';
      switch (fmt) {
        case 'number':
          return formatNumber(val);
        case 'percent':
          return formatPercent(val);
        case 'currency':
          return formatCurrency(val, (col && col.currency) || null);
        case 'date':
          return formatDate(val);
        case 'datetime':
          return formatDateTime(val);
        default:
          return String(val);
      }
    };

    function formatNumber(x) {
      var n = Number(x);
      if (!isFinite(n)) {
        return String(x);
      }

      return n.toLocaleString();
    }

    function formatPercent(x) {
      var n = Number(x);
      if (!isFinite(n)) {
        return String(x);
      }

      return n.toLocaleString(undefined, { maximumFractionDigits: 2 }) + '%';
    }
    
    function formatCurrency(x, ccy) {
      var n = Number(x);
      if (!isFinite(n)) {
        return String(x);
      }

      try {
        return n.toLocaleString(undefined, { style: 'currency', currency: ccy || 'USD' });
      } catch (_) {
        return n.toLocaleString() + (ccy ? (' ' + ccy) : '');
      }
    }

    function formatDate(iso) {
      try {
        return new Date(iso).toLocaleDateString();
      } catch (_) {
        return String(iso);
      }
    }
    
    function formatDateTime(iso) {
      try {
        return new Date(iso).toLocaleString();
      } catch (_) {
        return String(iso);
      }
    }

    vm.onRowClick = function (block, rowArr) {
      if (!block || !block.row_link || block.row_link.type !== 'navigate') {
        return;
      }

      var cols = block.columns || [];
      var colIndexByKey = {};
      cols.forEach(function (c, i) {
        colIndexByKey[c.key] = i;
      });

      var params = {};
      var map = block.row_link.param_map || {};
      Object.keys(map).forEach(function (appParam) {
        var colKey = map[appParam];
        var idx = colIndexByKey[colKey];
        if (idx != null) {
          params[appParam] = rowArr[idx];
        }
      });

      navigate(block.row_link.target, params);
    };

    vm.extractAllIds = function (block) {
      try {
        var cols = block.columns || [];
        var idKey = (block.row_link && block.row_link.param_map && block.row_link.param_map.id) || 'id';
        var idIndex = cols.findIndex(function (c) { return c.key === idKey; });
        if (idIndex < 0) {
          return [];
        }

        var normAll = vm.normalizeRows(block);
        return normAll
          .map(function (row) { return row[idIndex]; })
          .filter(function (v) { return v != null && v !== ''; });
      } catch (e) {
        return [];
      }
    };

    vm.openCustomersList = function (block) {
      var ids = vm.extractAllIds(block);
      if (!ids.length) {
        navigate('customers', {});
        return;
      }

      navigate('customers', { ids: ids.join(',') });
    };

    /* ==================== ACTIONS ==================== */

    vm.onAction = function (a) {
      if (!a || a.type !== 'navigate') {
        return;
      }

      navigate(a.target, a.params || {});
    };

    var TARGET_TO_STATE = {
      customer_detail: { state: 'app.customers.single', params: ['id'] },
      customers: { state: 'app.customers', params: [] }
    };

    function navigate(target, params) {
      if (!target) {
        return;
      }

      var route = TARGET_TO_STATE[target];

      if (route && route.state) {
        var picked = {};
        (route.params || []).forEach(function (k) {
          if (params && params[k] != null) {
            picked[k] = params[k];
          }
        });

        $state.transitionTo(route.state, Object.keys(picked).length ? picked : params || {}, {
          reload: false
        });
        return;
      }

      if ($state && typeof $state.go === 'function') {
        $state.go(target, params || {});
        return;
      }

      var path = '/' + encodeURIComponent(target);
      $location.path(path).search(params || {});
    }

    /* ==================== LIST HELPERS ==================== */

    vm.safeHref = function (href) {
      if (typeof href !== 'string') {
        return null;
      }

      var ok = /^(https?:\/\/|mailto:|tel:|\/)/i.test(href);
      return ok ? href : null;
    };

    /* ==================== OTHER HELPERS ==================== */

    vm.onRate = function (value) {
      vm.meta.rating = value;
      $api.ai.feedback.save({ run_id: vm.meta.run_id, rating: value });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').service('AiDialog', AiDialog);

  AiDialog.$inject = ['$rootScope', '$window', '$injector'];

  function AiDialog($rootScope, $window, $injector) {
    var $business = $injector.get('$business');

    var STORAGE_KEY = 'ai_dialog_state_v1';
    var MIN_POS = { insetInlineEnd: 24, bottom: 24 };

    var defaults = {
      visible: false,
      minimized: false,
      position: { insetInlineEnd: 24, bottom: 24 },
      size: { width: 380, height: 520 },
      _restore: null
    };

    var aiEnabled = !!$business.is_ai_enabled;
    var state = aiEnabled ? (load() || angular.copy(defaults)) : angular.copy(defaults);
    var hasInteracted = false;

    if ($business.is_ai_enabled === null) {
      var unwatch = $rootScope.$watch(function () { return $business.is_ai_enabled; }, function (val) {
        if (val === true && !aiEnabled) {
          aiEnabled = true;

          if (!hasInteracted) {
            var persisted = load();
            if (persisted) {
              state = persisted;
              notify(true);
            }
          }
        }

        if (!val) {
          aiEnabled = false;
          state = angular.copy(defaults);
        }
      });
    }

    function save() {
      if (!aiEnabled) {
        return;
      }

      try {
        $window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (e) {}
    }

    function load() {
      try {
        var raw = $window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }
    
    function notify(skipSave) {
      $rootScope.$broadcast('AiDialog:change', angular.copy(state));

      if (!skipSave) {
        save();
      }
    }

    return {
      getState: function () {
        return angular.copy(state);
      },

      open: function () {
        state.visible = true;
        state.minimized = false;
        notify();
      },

      close: function () {
        state.visible = false;
        notify();
      },

      toggleMinimize: function () {
        if (!state.visible) {
          return;
        }

        if (!state.minimized) {
          state._restore = { position: angular.copy(state.position) };
          state.minimized = true;
          state.position = angular.copy(MIN_POS);
        } else {
          state.minimized = false;
          if (state._restore && state._restore.position) {
            state.position = state._restore.position;
          }
          state._restore = null;
        }
        notify();
      },

      setSize: function (w, h) {
        state.size = { width: w, height: h };
        notify();
      },

      setPosition: function (pos) {
        state.position = pos;
        notify();
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('app')
    .directive('aiDialogOpen', aiDialogOpen)
    .directive('aiDialogToggleMin', aiDialogToggleMin)
    .directive('scrollBottom', scrollBottom)
    .directive('aiDialogDragResize', aiDialogDragResize)
    .directive('aiRender', aiRender)
    .directive('aiChart', aiChart);

  aiDialogOpen.$inject = ['AiDialog'];
  function aiDialogOpen(AiDialog) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        el.on('click', function () {
          scope.$applyAsync(function () { AiDialog.open(); });
        });
      }
    };
  }

  aiDialogToggleMin.$inject = ['AiDialog'];
  function aiDialogToggleMin(AiDialog) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        el.on('click', function () {
          scope.$applyAsync(function () { AiDialog.toggleMinimize(); });
        });
      }
    };
  }

  scrollBottom.$inject = ['$timeout'];
  function scrollBottom($timeout) {
    return {
      restrict: 'A',
      scope: {
        scrollBottom: '=',
        scrollBottomTrigger: '=?'
      },
      link: function (scope, el) {
        function doScroll() {
          $timeout(function () {
            var node = el[0];
            node.scrollTop = node.scrollHeight;

            $timeout(function () {
              node.scrollTop = node.scrollHeight;
            }, 50, false);
          }, 0, false);
        }

        scope.$watchCollection('scrollBottom', function () {
          doScroll();
        });

        scope.$watch('scrollBottomTrigger', function () {
          doScroll();
        });

        doScroll();
      }
    };
  }

  aiDialogDragResize.$inject = ['$window', '$document', 'AiDialog'];
  function aiDialogDragResize($window, $document, AiDialog) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        var node = el[0];
        var header = node.querySelector('.ai-dialog__header');
        var resizer = node.querySelector('.ai-dialog__resize');

        function getDir() {
          var doc = $document[0];
          var body = doc && doc.body;
          if (body) {
            if (body.classList.contains('rtls')) {
              return 'rtl';
            }

            if (body.classList.contains('ltrs')) {
              return 'ltr';
            }
          }

          var htmlDir = (doc && doc.documentElement && doc.documentElement.getAttribute('dir')) || '';
          htmlDir = htmlDir.toLowerCase();
          if (htmlDir === 'rtl' || htmlDir === 'ltr') {
            return htmlDir;
          }

          return 'rtl';

        }

        function getState() {
          return AiDialog.getState();
        }

        function clamp(v, min, max) {
          return Math.max(min, Math.min(max, v));
        }

        var dragging = false, startX = 0, startY = 0, startInset = 0, startBottom = 0;

        function onDragStart(e) {
          var s = getState();
          if (!s.visible || s.minimized) {
            return;
          }
          dragging = true;

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          startX = evt.clientX;
          startY = evt.clientY;
          startInset = +s.position.insetInlineEnd || 0;
          startBottom = +s.position.bottom || 0;

          $document.on('mousemove', onDragMove);
          $document.on('mouseup', onDragEnd);
          $document.on('touchmove', onDragMove, { passive: false });
          $document.on('touchend', onDragEnd);
          node.classList.add('ai-dialog--dragging');
          e.preventDefault();
        }

        function onDragMove(e) {
          if (!dragging) {
            return;
          }

          var s = getState();
          var size = s.minimized ? { width: 56, height: 56 } : s.size;

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          var dx = evt.clientX - startX;
          var dy = evt.clientY - startY;

          var vw = $window.innerWidth;
          var vh = $window.innerHeight;

          var dir = getDir();
          var inset = (dir === 'ltr') ? (startInset - dx) : (startInset + dx);
          var bottom = startBottom - dy;

          var minInset = 8;
          var minBottom = 8;
          var maxInset = Math.max(minInset, vw - size.width - 8);
          var maxBottom = Math.max(minBottom, vh - size.height - 8);

          inset = Math.max(minInset, Math.min(maxInset, inset));
          bottom = Math.max(minBottom, Math.min(maxBottom, bottom));

          AiDialog.setPosition({ insetInlineEnd: Math.round(inset), bottom: Math.round(bottom) });
          e.preventDefault();
        }

        function onDragEnd() {
          if (!dragging) {
            return;
          }
          dragging = false;
          $document.off('mousemove', onDragMove);
          $document.off('mouseup', onDragEnd);
          $document.off('touchmove', onDragMove);
          $document.off('touchend', onDragEnd);
          node.classList.remove('ai-dialog--dragging');
        }

        if (header) {
          header.addEventListener('mousedown', onDragStart);
          header.addEventListener('touchstart', onDragStart, { passive: false });
        }

        var resizing = false, rStartX = 0, rStartY = 0, rStartW = 0, rStartH = 0, rStartInset = 0, rStartBottom = 0;

        function onResizeStart(e) {
          var s = getState();
          if (!s.visible || s.minimized) {
            return;
          }

          resizing = true;

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          rStartX = evt.clientX;
          rStartY = evt.clientY;

          rStartW = +s.size.width || 380;
          rStartH = +s.size.height || 520;
          rStartInset = +s.position.insetInlineEnd || 24;
          rStartBottom = +s.position.bottom || 24;

          $document.on('mousemove', onResizeMove);
          $document.on('mouseup', onResizeEnd);
          $document.on('touchmove', onResizeMove, { passive: false });
          $document.on('touchend', onResizeEnd);
          node.classList.add('ai-dialog--resizing');
          e.preventDefault();
        }

        function onResizeMove(e) {
          if (!resizing) {
            return;
          }

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          var dx = evt.clientX - rStartX;
          var dy = evt.clientY - rStartY;

          var dir = getDir();

          var deltaInlineStart = (dir === 'ltr') ? -dx : dx;
          var deltaBlockStart = -dy;

          var newW = rStartW + deltaInlineStart;
          var newH = rStartH + deltaBlockStart;

          var vw = $window.innerWidth, vh = $window.innerHeight;

          var gapInlineStart = 8;
          var gapBlockStart = 8;
          var maxW = vw - rStartInset  - gapInlineStart;
          var maxH = vh - rStartBottom - gapBlockStart;

          var minW = 280, minH = 280;

          newW = Math.max(minW, Math.min(maxW, newW));
          newH = Math.max(minH, Math.min(maxH, newH));

          AiDialog.setSize(Math.round(newW), Math.round(newH));

          e.preventDefault();
        }

        function onResizeEnd() {
          if (!resizing) {
            return;
          }
          resizing = false;
          $document.off('mousemove', onResizeMove);
          $document.off('mouseup', onResizeEnd);
          $document.off('touchmove', onResizeMove);
          $document.off('touchend', onResizeEnd);
          node.classList.remove('ai-dialog--resizing');
        }

        if (resizer) {
          resizer.addEventListener('mousedown', onResizeStart);
          resizer.addEventListener('touchstart', onResizeStart, { passive: false });
        }

        scope.$on('$destroy', function () {
          if (header) {
            header.removeEventListener('mousedown', onDragStart);
            header.removeEventListener('touchstart', onDragStart);
          }

          if (resizer) {
            resizer.removeEventListener('mousedown', onResizeStart);
            resizer.removeEventListener('touchstart', onResizeStart);
          }

          onDragEnd();
          onResizeEnd();
        });
      }
    };
  }

  aiRender.$inject = [];
  function aiRender() {
    return {
      restrict: 'E',
      scope: { data: '=', meta: '=' },
      templateUrl: 'app/components/ai-dialog/ai-render.view.html',
      controller: 'AiRenderController',
      controllerAs: 'vm',
      bindToController: true
    };
  }

  aiChart.$inject = ['$window', '$timeout'];
  function aiChart($window, $timeout) {
    return {
      restrict: 'A',
      scope: { block: '=' },
      link: function (scope, element) {
        var canvas = element[0];
        var buildTimer = null;

        function getExistingChart() {
          if ($window.Chart && typeof $window.Chart.getChart === 'function') {
            return $window.Chart.getChart(canvas) || canvas.__chartInstance || null;
          }
          return canvas.__chartInstance || null;
        }

        function safeDestroy() {
          try {
            var existing = getExistingChart();
            if (existing && typeof existing.destroy === 'function') {
              existing.destroy();
            }
          } catch (e) { /* noop */ }
          canvas.__chartInstance = null;
        }

        function makePalette(n, base) {
          if (!n || n <= 0) {
            return [];
          }

          if (n === 1) {
            return [base || '#006495'];
          }

          var arr = [base || '#006495'];
          for (var i = 1; i < n; i++) {
            var hue = Math.floor((360 / n) * i);
            arr.push('hsl(' + hue + ' 60% 50%)');
          }
          return arr;
        }

        function blockToConfig(block) {
          var menu_color = ($window.appMenuColor || '#006495');
          var isRTL = ($window.langKey === 'hb_ISR' || $window.langKey === 'ar_AR');

          var kind = (block.kind || 'bar').toLowerCase();
          var xKey = block.xKey || null;
          var yKeys = Array.isArray(block.yKeys) && block.yKeys.length ? block.yKeys : null;
          var rows = Array.isArray(block.data) ? block.data : [];

          // ===== PIE / DOUGHNUT =====
          if (kind === 'pie') {
            var labels = [];
            var values = [];
            rows.forEach(function (r) {
              labels.push(String(xKey ? r[xKey] : r.label || ''));
              var val = 0;
              if (yKeys && yKeys.length) {
                val = Number(r[yKeys[0]] || 0);
              } else {
                Object.keys(r || {}).some(function (k) {
                  if (k === xKey) {
                    return false;
                  }
                  var n = Number(r[k]);
                  if (!isNaN(n)) {
                    val = n;
                    return true;
                  }
                  return false;
                });
              }
              values.push(val);
            });

            var colors = makePalette(values.length, menu_color);
            return {
              type: 'doughnut',
              data: {
                labels: labels,
                datasets: [{ label: '', data: values, backgroundColor: colors }]
              },
              options: {
                responsive: true,
                plugins: {
                  legend: {
                    position: 'bottom',
                    labels: { usePointStyle: true },
                    rtl: isRTL
                  },
                  tooltip: {
                    callbacks: {
                      label: function (ctx) {
                        var dataset = ctx.dataset;
                        var val = dataset.data[ctx.dataIndex];
                        var total = dataset.data.reduce(function (a, v) { return a + v; }, 0);
                        var pct = total ? ((val / total) * 100).toFixed() : 0;
                        return (ctx.label || '') + ': ' + val + ' (' + pct + '%)';
                      }
                    }
                  }
                }
              }
            };
          }

          // ===== BAR / LINE =====
          var labelsBL = [];
          if (xKey) {
            labelsBL = rows.map(function (r) { return String(r[xKey]); });
          } else {
            labelsBL = rows.map(function (_, i) { return String(i + 1); });
          }

          if (!yKeys) {
            var numericKeys = {};
            rows.forEach(function (r) {
              Object.keys(r || {}).forEach(function (k) {
                if (k === xKey) {
                  return;
                }
                var n = Number(r[k]);
                if (!isNaN(n)) {
                  numericKeys[k] = true;
                }
              });
            });
            yKeys = Object.keys(numericKeys);
            if (!yKeys.length) {
              yKeys = ['value'];
            }
          }

          var palette = makePalette(yKeys.length, menu_color);
          var isLine = (kind === 'line');
          var datasets = yKeys.map(function (yk, i) {
            return {
              label: yk,
              data: rows.map(function (r) { return Number(r[yk] || 0); }),
              backgroundColor: isLine ? 'transparent' : palette[i],
              borderColor: palette[i],
              maxBarThickness: isLine ? undefined : 60,
              type: isLine ? 'line' : 'bar',
              tension: isLine ? 0.3 : 0
            };
          });

          var baseOptions = {
            responsive: true,
            scales: {
              x: { grid: { display: false } },
              y: {}
            },
            borderRadius: isLine ? 0 : 6,
            plugins: {
              legend: {
                position: 'bottom',
                labels: { usePointStyle: true },
                rtl: isRTL
              },
              tooltip: {}
            }
          };

          return {
            type: isLine ? 'line' : 'bar',
            data: { labels: labelsBL, datasets: datasets },
            options: baseOptions
          };
        }

        function buildChart() {
          if (buildTimer) {
            $timeout.cancel(buildTimer);
          }

          buildTimer = $timeout(function () {
            if (!$window.Chart || !scope.block || !Array.isArray(scope.block.data)) {
              safeDestroy();
              return;
            }

            safeDestroy();

            var cfg = blockToConfig(scope.block);
            var ctx = canvas.getContext('2d');
            var chart = new $window.Chart(ctx, cfg);
            canvas.__chartInstance = chart;
          }, 0);
        }

        scope.$watch('block', buildChart, true);

        scope.$on('$destroy', function () {
          if (buildTimer) {
            $timeout.cancel(buildTimer);
          }
          safeDestroy();
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').controller('AiDialogController', AiDialogController);

  AiDialogController.$inject = ['$scope', '$api', '$window', 'AiDialog'];

  function AiDialogController($scope, $api, $window, AiDialog) {
    var $ctrl = this;

    $ctrl.mounted = false;

    $ctrl.state = AiDialog.getState();
    $ctrl.close = AiDialog.close;
    $ctrl.toggleMinimize = AiDialog.toggleMinimize;

    var unbind = $scope.$on('AiDialog:change', function (e, next) {
      $ctrl.state = next;
      $scope.$evalAsync();
    });
    $ctrl.$onDestroy = function () { unbind && unbind(); };

    $ctrl.messages = [];
    $ctrl.input = '';

    var LS_KEY = 'aiChatSessionId';
    $ctrl.ensureSessionId = function () {
      var id = $window.localStorage.getItem(LS_KEY);
      if (!id) {
        id = ($window.crypto && $window.crypto.randomUUID) ? $window.crypto.randomUUID() : (Date.now() + '-' + Math.random());
        $window.localStorage.setItem(LS_KEY, id);
      }
      return id;
    }
    var SESSION_ID = $ctrl.ensureSessionId();

    $ctrl.loadHistory = function () {
      $api.ai.history.get({ session_id: SESSION_ID }, function (res) {
        if (res && res.success && res.data && Array.isArray(res.data.messages)) {
          $ctrl.messages = res.data.messages.map(function (m) {
            return m;
          });

          if ($ctrl.messages.length === 0) {
            $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
          }
        } else {
          if (!$ctrl.messages.length) {
            $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
          }
        }

        $scope.$applyAsync();
      }, function(){
        if (!$ctrl.messages.length) {
          $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
        }
      });
    }
    $ctrl.loadHistory();

    $scope.$evalAsync(function () {
      $ctrl.mounted = true;
    });

    $ctrl.loading = false;

    $ctrl.send = function () {
      if ($ctrl.loading) {
        return;
      }

      if (!$ctrl.input.trim()) {
        return;
      }

      $ctrl.loading = true;
      $ctrl.messages.push({ role: 'user', text: $ctrl.input });

      var userText = $ctrl.input;
      $ctrl.input = '';
      $api.ai.customers.save({ prompt: userText, session_id: SESSION_ID }, function (res) {
        if (res.success) {
          $ctrl.messages.push({ role: 'assistant', render: res.data.render, meta: res.data.meta });
          $scope.$applyAsync();
        }

        $ctrl.loading = false;
      }, function() {
        $ctrl.loading = false;
      });
    };

    $ctrl.onTextareaKeydown = function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        if (!e.shiftKey) {
          e.preventDefault();

          if ($ctrl.loading) {
            return;
          }

          if (($ctrl.input || '').trim()) {
            $ctrl.send();
          }
        }
      }
    };

    $ctrl.resetSession = function () {
      $window.localStorage.removeItem(LS_KEY);
      SESSION_ID = $ctrl.ensureSessionId();
      $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
    }
  }
})();

(function () {
  'use strict';

  angular.module('app').component('aiDialog', {
    templateUrl: 'app/components/ai-dialog/ai-dialog.view.html',
    controller: 'AiDialogController'
  });
})();

angular.module("app.services").factory('$webview', ['$window', '$log', '$q', '$timeout', function($window, $log, $q, $timeout) {
  var pending = {};
  var listeners = {};
  var idCounter = 1;
  var DEFAULT_TIMEOUT = 15000;

  function post(msg) {
    var s = JSON.stringify(msg);
    if ($window.ReactNativeWebView && $window.ReactNativeWebView.postMessage) {
      try {
        $window.ReactNativeWebView.postMessage(s);
      } catch(e) {
        $log.warn('postMessage failed', e);
      }
    } else {
      if ($window._handleNativeMessage) {
        $log.warn('No ReactNativeWebView.postMessage available');
      }
    }
  }

  $window._handleNativeMessage = function(raw) {
    try {
      var msg = (typeof raw === 'string') ? JSON.parse(raw) : raw;
    } catch(e) {
      $log.warn('Invalid native message', raw);
      return;
    }

    if (msg.type === 'response') {
      var p = pending[msg.id];
      if (p) {
        $timeout.cancel(p.timer);
        if (msg.ok) {
          p.deferred.resolve(msg.data);
        } else {
          p.deferred.reject(msg.error || 'error');
        }
        delete pending[msg.id];
      }
      return;
    }

    if (msg.type === 'event' || msg.type === 'command') {
      var arr = listeners[msg.action] || [];
      arr.forEach(function(cb) {
        try {
          cb(msg.data);
        } catch(e) {
          $log.warn(e)
        }
      });
      return;
    }

    if (msg.type === 'request') {
      var handlerArr = listeners['__request__' + msg.action] || [];
      if (handlerArr.length) {
        try {
          var res = handlerArr[0](msg.data);
          $q.when(res).then(function(result) {
            post({ type:'response', action: msg.action, id: msg.id, ok: true, data: result });
          }, function(err){
            post({ type:'response', action: msg.action, id: msg.id, ok: false, error: (err && err.message)?err.message:String(err) });
          });
        } catch(err) {
          post({ type:'response', action: msg.action, id: msg.id, ok: false, error: (err && err.message)?err.message:String(err) });
        }
      } else {
        post({ type:'response', action: msg.action, id: msg.id, ok: false, error: 'no_handler' });
      }
      return;
    }
  };

  function request(action, data, timeout) {
    if (!detect()) {
      return $q.reject('not_webview');
    }
    var id = String(Date.now()) + '_' + (idCounter++);
    var deferred = $q.defer();
    var timer = $timeout(function() {
      delete pending[id];
      deferred.reject('timeout');
    }, timeout || DEFAULT_TIMEOUT);

    pending[id] = { deferred: deferred, timer: timer };
    post({ type: 'request', action: action, id: id, data: data });
    return deferred.promise;
  }

  function emit(action, data) {
    if (!detect()) {
      return;
    }

    post({ type: 'event', action: action, data: data });
  }

  function command(action, data) {
    if (!detect()) {
      return;
    }

    post({ type: 'command', action: action, data: data });
  }

  function onEvent(action, cb) {
    if (!listeners[action]) {
      listeners[action] = [];
    }

    listeners[action].push(cb);
    return function off() {
      listeners[action] = listeners[action].filter(function(x) {
        return x !== cb
      });
    }
  }

  function onRequest(action, cb) {
    var key = '__request__' + action;
    if (!listeners[key]) listeners[key] = [];
    listeners[key].push(cb);
    return function off() {
      listeners[key] = listeners[key].filter(function(x){ return x !== cb });
    }
  }

  function handshake() {
    if (detect()) {
      request('app:handshake').then(function(res) {
        console.log('Handshake response:', res);
      }).catch(function(e){ console.warn('No native app', e) });
    }
  }

  function localPush(title, body, data) {
    request('app:showLocalPush', {
      title: title,
      body: body,
      data: data
    }).then(function(res){
      console.log('[WEB] push shown:', res);
    }).catch(function(err){
      console.warn('[WEB] push failed:', err);
    });
  }

  function detect() {
    var ua = $window.navigator.userAgent || '';

    // RN WebView JS bridge
    if ($window.ReactNativeWebView) {
      return true;
    }

    // Android WebView has “; wv)” in its UA
    var isAndroidWV = /Android/.test(ua) && /; wv\)/.test(ua);

    // iOS WebView has AppleWebKit but NO Safari token
    var isIosWV =
      (/iPhone|iPad|iPod/.test(ua)) &&
      (/AppleWebKit/.test(ua)) &&
      !(/Safari/.test(ua));

    return isAndroidWV || isIosWV;
  }

  function isPdfUrl(url) {
    if (typeof url !== 'string') return false;

    var path = url.split(/[?#]/)[0].toLowerCase();
    return path.substr(path.length - 4) === '.pdf';
  }

  function isImageUrl(url) {
    if (typeof url !== 'string') return false;

    var path = url.split(/[?#]/)[0].toLowerCase();
    return /\.(png|jpg|jpeg|gif|webp|ico|avif|heic|heif|jfif|jxl|apng)$/.test(path);
  }

  return {
    isWebView: function() {
      return detect();
    },

    isPdfUrl: function (url) {
      return isPdfUrl(url);
    },

    isImageUrl: function (url) {
      return isImageUrl(url);
    },

    handshake: handshake,
    localPush: localPush,
    request: request,
    emit: emit,
    command: command,
    onEvent: onEvent,
    onRequest: onRequest
  };
}]);

(function(){
  
    angular.module("app.services").factory("$user", function ($rootScope, $api, $color, $cookies, $timeout, $state, $translate, $business, $webview){
      
        var $user = this;
        $rootScope.userRole = $cookies.get("role_id");
        $rootScope.version = null;
        $rootScope.isSidebarCollapsed = $cookies.get("isSidebarCollapsed") === "true" || false;
        window.isSidebarCollapsed = $rootScope.isSidebarCollapsed;

        // choosing Interface language
        // TODO: change to English for worldwide use
        $user.currentLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : 'hb_ISR';

        $rootScope.toggleSidebar = function() {
          $rootScope.isSidebarCollapsed = !$rootScope.isSidebarCollapsed;
          $cookies.put("isSidebarCollapsed", $rootScope.isSidebarCollapsed);
          window.isSidebarCollapsed = $rootScope.isSidebarCollapsed;
        };

        $user.getMessages = function() {
          $api.b_messages.get(function (response) {
              if (response.status == "success") {
                $rootScope.b_messages = response.data;
                $rootScope.$broadcast('b_messages_updated');

                if (response.version) {
                  if (!$rootScope.version) {
                    $rootScope.version = response.version;
                  } else if ($rootScope.version != response.version) {
                    location.reload(true);
                  }
                }
              }
            });
        }

        $user.getNotifications = function() {
          $api.notifications.dashboard.get(function (response) {
              if (response.status == "success") {
                $rootScope.notification_list = response.data;
                $rootScope.$broadcast('notifications_updated');
              }
            });
        }

        $user.getFilters = function() {
          $api.filters.get({}, function (response) {
              if (response.status == "success") {
                $rootScope.filters = response.data;
                for (var i in $rootScope.filters) {
                  if ($rootScope.filters[i].def) {
                    $rootScope[$rootScope.filters[i].module+'_filter'] = $rootScope.filters[i].data;
                  }
                }
                $rootScope.$broadcast('filters_updated');
              }
          });
        }

        $user.getLeadsCount = function() {
          $api.customers.leads_count.get({}, function (response) {
              if (response.status == "success") {

                if ($rootScope.leads_count != response.data) {
                  $rootScope.isBouncingLead = true;
                  $rootScope.leads_count = response.data;
                  $timeout(function() {
                    $rootScope.isBouncingLead = false;
                  }, 500);
                }
              }
          });
        }

        $user.updateDfAlertLastTime = function() {
          $api.digital_forms.update_last_time.save({ id: $rootScope.$user['b_id'] });
        }

        $user.getUncheckedFilledDfs = function() {
          $api.digital_forms.unchecked.save({ id: $rootScope.$user['b_id'] }, function (response) {
              if (response.status == "success" && response.data.length) {
                var html = '';
                for (key in response.data) {
                  var item = response.data[key];
                  html += '<div style="text-align: left;">' + $translate.instant('FORM_SHORT_FILLED_MESSAGE').replace(':name', item.name).replace(':customer_name', item.customer_name) + '</div>';
                }

                swal({
                  title: $translate.instant('FORM_FILLED_TITLE'),
                  html: html,
                  type: "success",
                });
              }
          });
        }

        $rootScope.generateUniqueId = function() {
            var randomPart = Math.random().toString(36).substr(2, 5);
            var timestampPart = new Date().getTime().toString(36);
            return randomPart + timestampPart;
        };

        $rootScope.listenPaymentIframe = function(hash) {
          var channel = (!pusher.channel('business-'+$rootScope.$user['b_id'])) ? pusher.subscribe('business-'+$rootScope.$user['b_id']) : pusher.channel('business-'+$rootScope.$user['b_id']);
          channel.bind('iframe-result-'+hash, function(response) {
            if (response) {
              if (response.result == 'success') {
                swal({
                  title: $translate.instant('SWAL_TRANSACTIONS_SAVE_TITLE'),
                  html: response.message ? response.message : '',
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 1500
                });
  
              } else if (response.result == 'error') {
                var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');
  
                if (response.code && (response.code == "010" || response.code == "550" || response.code == "500" || response.code == "004" || response.code == "006")) {
                  message = $translate.instant('PELACARD_MESSAGE_'+response.code);
                }
  
                swal({
                    title: response.message ? response.message : message,
                    text: $translate.instant('SWAL_PELECARD_MESSAGE_TEXT'),
                    type: "warning",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 3000
                });
              }
            }
  
          });
        }

        $rootScope.menuHide = function () {
          if (angular.element(document).width() < 769) {
            angular.element('body').addClass('mini-navbar');
          }
        }

        $rootScope.submitColors = function() {
          if ($rootScope.colorTimeout) {
            clearTimeout($rootScope.colorTimeout);
          }

          if ($rootScope.blockedColors) return;
        
          $rootScope.colorTimeout = setTimeout(function() {
            $rootScope.blockedColors = true;

            $api.settings.colors.save($rootScope.color_form, function(response){
              if(response.status === "success"){
                // less.modifyVars({
                //   '@menu-color': $rootScope.color_form.menu_color,
                //   '@online-color': $rootScope.color_form.online_color,
                //   '@online-text-color': $rootScope.color_form.online_text_color,
                //   '@back-color': $rootScope.color_form.back_color,
                //   //'@font-style': $user.currentLanguage != 'hb_ISR' ? "Manrope" : "Assistant",
                // });
                $rootScope.blockedColors = false;

                document.documentElement.style.setProperty('--menu-color', $rootScope.color_form.menu_color);
                document.documentElement.style.setProperty('--online-color', $rootScope.color_form.online_color);
                document.documentElement.style.setProperty('--online-text-color', $rootScope.color_form.online_text_color);
                document.documentElement.style.setProperty('--back-color', $rootScope.color_form.back_color);
                document.documentElement.style.setProperty('--calendar-color', $rootScope.color_form.calendar_color || '#fff');
                document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $rootScope.color_form.back_color));
                document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.back_color));
                document.documentElement.style.setProperty('--calendar-stripe-color', $rootScope.color_form.calendar_stripe_color ? $rootScope.color_form.calendar_stripe_color : '#f7fafc');
              }
            });
          }, 50);
        }

        $rootScope.color_form = {
          back_color: '#F2F6FF',
          menu_color: '#216089',
          online_color: '#61B9A0',
          online_text_color: '#FFFFFF',
          switch_colors: false
        };

        function finalCallback(cb, result) {
          if (result) {
            $business.ai_fetch();
            $webview.request('app:getPushToken').then(function(response) {
              if (response && response.fcm_token) {
                $api.userDevices.save(response, function(res) {
                  console.log(res)
                }, function(res) {
                  console.log(res)
                });
              }
            });
          }
          cb(result);
        }

        $user.isAuth = function (callback) {
          //need to check this new condition, because every time check isAuth not nice solution
          if ($rootScope.isAuth) {
            return finalCallback(callback, true);
          }

          $api.auth.get({}, function (response) {
            if (response.user) {
              $rootScope.$user = response.user;
              $rootScope.$user.user_acl = response.user_acl;
              $rootScope.default_screen = response.user.default_screen;

              $rootScope.color_form.back_color = response.user.back_color && response.user.back_color != '#D5DEFE' ? response.user.back_color : $rootScope.color_form.back_color;
              $rootScope.color_form.menu_color = response.user.menu_color ? response.user.menu_color : $rootScope.color_form.menu_color;
              $rootScope.color_form.online_color = response.user.online_color ? response.user.online_color : $rootScope.color_form.online_color;
              $rootScope.color_form.online_text_color = response.user.online_text_color ? response.user.online_text_color : $rootScope.color_form.online_text_color;
              $rootScope.color_form.switch_colors = response.user.switch_colors ? response.user.switch_colors : $rootScope.color_form.switch_colors;
              $rootScope.color_form.calendar_color = response.user.calendar_color && response.user.calendar_color != '#f2f2f2' ? response.user.calendar_color : '#fff';
              $rootScope.color_form.calendar_stripe_color = response.user.calendar_stripe_color ? response.user.calendar_stripe_color : '#f7fafc';
              $rootScope.color_form.calendar_event_color = response.user.calendar_event_color ? response.user.calendar_event_color : '#778899';


              document.documentElement.style.setProperty('--menu-color', $rootScope.color_form.menu_color);
              document.documentElement.style.setProperty('--online-color', $rootScope.color_form.online_color);
              document.documentElement.style.setProperty('--online-text-color', $rootScope.color_form.online_text_color);
              document.documentElement.style.setProperty('--back-color', $rootScope.color_form.back_color);
              document.documentElement.style.setProperty('--calendar-color', $rootScope.color_form.calendar_color || '#fff');
              document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $rootScope.color_form.back_color));
              document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.back_color));
              document.documentElement.style.setProperty('--calendar-stripe-color', $rootScope.color_form.calendar_stripe_color);

              //temporary place for subscribe
              if (!pusher.channel('business-' + $rootScope.$user['b_id'])) {
                // If not subscribed, subscribe to the channel
                channel = pusher.subscribe('business-' + $rootScope.$user['b_id']);

                var isWebView = $webview.isWebView();

                if (!isWebView) {
                  channel.bind('call-event', function(data) {
                    if (data.customer) {
                      swal({
                          title: "<b style='font-size: 20px'>"+$translate.instant('CALL_INCOMING')+"</b><br/>",
                          html: "<b style='font-size: 1.875em;'>"+data.customer.name+"</b><br />"+data.customer.phone,
                          imageUrl: '/assets/images/phone.png',
                          imageWidth: 100,
                          imageHeight: 100,
                          confirmButtonText: $translate.instant('CALL_ORDER'),
                          cancelButtonText: $translate.instant('CALL_CANCEL'),
                          showCancelButton: true,
                      }).then(function(result) {
                          if (result.value) {
                            $state.transitionTo("app.dashboard.load", {}, {reload: false})
                              .then(function() {
                                $state.transitionTo("app.calendar.call", {phone: data.customer.phone}, {reload: true});
                              });
                          } else {
                            
                          }
                      });
                    }
                  });
                }

                
                channel.bind('message-event', function(data) {
                  //double check
                  if (data && data.b_id == $rootScope.$user['b_id']) {
                    $user.getMessages();
                  }
                });

                channel.bind('notifications-event', function(data) {
                  //double check
                  if (data && data.b_id == $rootScope.$user['b_id']) {
                    $user.getNotifications();
                  }
                });

                channel.bind('leads-count-event', function(data) {
                  if (data && data.b_id == $rootScope.$user['b_id']) {
                    $user.getLeadsCount();
                  }
                });

                
                channel.bind('form-filled-v2', function(response) {
                    console.log('form-filled-v2', response);
                    if (response) {
                      if (response.result == 'success') {
                        if (!isWebView) {
                          swal({
                              title: response.customer_name,
                              text: $translate.instant(response.type.toUpperCase() + '_FILLED_MESSAGE').replace(':name', response.name),
                              type: "success",
                              timer: 5000,
                          });
                        }

                        $user.updateDfAlertLastTime();
                      }
                    }
                });
              }

              if ($rootScope.$user['favicon_path']) {
                $('#favicon').attr('href', $rootScope.$user['favicon_path']+'favicon.ico');
                $('#favicon-16').attr('href', $rootScope.$user['favicon_path']+'favicon-16.png');
                $('#favicon-32').attr('href', $rootScope.$user['favicon_path']+'favicon-32.png');
                $('#favicon-64').attr('href', $rootScope.$user['favicon_path']+'favicon-64.png');
              }

              //bug
              if ($rootScope.$user) {
                $rootScope.userRole = response.user.role;
                if(angular.isDefined(response.user.cashbox_available)) {
                  $rootScope.cashbox_available = response.user.cashbox_available;
                }
                if(angular.isDefined(response.user.permissions)) {
                  $rootScope.employee_permissions = response.user.permissions;
                }
                if(angular.isDefined(response.user.manage_leads)) {
                  $rootScope.manage_leads = response.user.manage_leads;
                }
                if(angular.isDefined(response.user.show_notes_page)) {
                  $rootScope.show_notes_page = response.user.show_notes_page;
                }
                if(angular.isDefined(response.user.show_digital_forms_page)) {
                  $rootScope.show_digital_forms_page = response.user.show_digital_forms_page;
                }
                if(angular.isDefined(response.user.customer_wa_chat)) {
                  $rootScope.customer_wa_chat = response.user.customer_wa_chat;
                }
                if(angular.isDefined(response.user.cashbox_discount)) {
                  $rootScope.cashbox_discount = response.user.cashbox_discount;
                }
                if(angular.isDefined(response.user.lead_appearence)) {
                  $rootScope.lead_appearence = response.user.lead_appearence;
                }
                if(angular.isDefined(response.user.display_order_user)) {
                  $rootScope.display_order_user = response.user.display_order_user;
                }
                if(angular.isDefined(response.user.display_one_block_services)) {
                  $rootScope.display_one_block_services = response.user.display_one_block_services;
                }

                if(angular.isDefined(response.user.display_hebrew_dates)) {
                  $rootScope.display_hebrew_dates = response.user.display_hebrew_dates;
                }
              }
              //end-bug
            } else {
              $cookies.remove("email");
              $cookies.remove("pass");
              $cookies.remove("hash");
              $cookies.remove("role_id");
              $cookies.remove("token");
              localStorage.removeItem('tiffulit-user-role');
              $rootScope.$user = undefined;
              $rootScope.userRole = undefined;
            }
            $rootScope.isAuth = response.is_auth;

            if (response.status == "success" && response.is_auth) {
              return $user.getAllACLs(function () {
                $user.getUncheckedFilledDfs();
                finalCallback(callback, true);
              });
            }

            return finalCallback(callback, false);
          });
        };

        $user.login = function (creds, callback) {
            $api.auth.save(creds, function (response) {
                if(response.status == "success"){
                  if (response.is_auth) {
                    var options = {};
                    options.expires = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
                    //$cookies.put("email", response.email, options);
                    //$cookies.put("pass", response.pass, options);
                    //$cookies.put("hash", response.hash, options);
                    $cookies.put("token", response.token, options);
                    $cookies.put("role_id", response.role_id, options);
                    $rootScope.userRole = response.role_id;
                    $rootScope.employee_permissions = response.permissions ? response.permissions : false
                    $rootScope.cashbox_available = response.cashbox_available;
                    $rootScope.manage_leads = response.manage_leads;
                    $rootScope.show_notes_page = response.show_notes_page;
                    $rootScope.show_digital_forms_page = response.show_digital_forms_page;
                    $rootScope.default_screen = response.default_screen;
                    $rootScope.display_order_user = response.display_order_user;
                    $rootScope.display_one_block_services = response.display_one_block_services;
                    $rootScope.display_hebrew_dates = response.display_hebrew_dates;
                    if(response.language_code) {
                        $rootScope.changeLanguage(response.language_code);
                    }
                    //$user.getMessages();
                    //$user.getFilters();
                  } else {
                    $cookies.remove("email");
                    $cookies.remove("pass");
                    $cookies.remove("hash");
                    $cookies.remove("role_id");
                    $cookies.remove("token");
                    localStorage.removeItem('tiffulit-user-role');
                    $rootScope.isAuth = false;
                    $rootScope.$user = undefined;
                    $rootScope.userRole = undefined;
                  }
                    
                  return $user.getAllACLs(function () { finalCallback(callback, response.is_auth) });
                }
                return finalCallback(callback, false);
            });
        };

        $user.logout = function(){
          $webview.request('app:revokePushToken').then(function(res){
            if (res && res.fcm_token) {
              $api.userDevices.revoke.save({ fcm_token: res.fcm_token }, function(){}, function(){});
            }
          }).catch(function(){ }).finally(function(){
              if ($rootScope && $rootScope.$user && $rootScope.$user['b_id']) {
                if (pusher.channel('business-'+$rootScope.$user['b_id'])) {
                  pusher.unsubscribe('business-'+$rootScope.$user['b_id']);
                }
              }
              $api.auth.logout.save({}, function (response) {
                $cookies.remove("email");
                $cookies.remove("pass");
                $cookies.remove("hash");
                $cookies.remove("role_id");
                $cookies.remove("token");
                localStorage.removeItem('tiffulit-user-role');
                $rootScope.isAuth = false;
                $rootScope.$user = undefined;
                $rootScope.userRole = undefined;
                $state.go("login");
              });

              $business.ai_reset();
            });
        };

        $user.changeLanguage = function(langKey){
            $translate.use(langKey);
            $rootScope.currentLanguage = langKey;
            $rootScope.langKey = langKey;
            window.langKey = langKey;
            $rootScope.$emit('change-language', langKey);
            localStorage.setItem('language', langKey);
        };

      /**
       * Get all Access Control List for users
       *
       * @param callback
       */
        $user.getAllACLs = function (callback) {
          $api.all_acls.get(function (response) {
            if (response.status == "success") {
              $rootScope.users_acl = response.roles_acls;
              callback();
            }
          });

          if ($rootScope.$user && $rootScope.$user['b_id']) {
            $user.getMessages();
            $user.getFilters();
            $user.getLeadsCount();
            $user.getNotifications();
          }
        }

      /**
       * Redirects User to appropriate login screen
       */
      $user.go_default_screen = function () {
          if($rootScope.default_screen == "Dashboard")
            $timeout(function() { $state.go("app.dashboard"); });
          else if($rootScope.default_screen == "Calendar")
            $timeout(function() { $state.go("app.calendar"); });
          else if($rootScope.default_screen == "Calendar-Daily")
            $timeout(function() { $state.go("app.calendar.login", {view: 'view'}); });
          else if($rootScope.default_screen == "Calendar-Weekly")
            $timeout(function() { $state.go("app.calendar.login", {view: 'view'}); });
          else if($rootScope.default_screen == "Calendar-Monthly")
            $timeout(function() { $state.go("app.calendar.login"); });
          else if($rootScope.default_screen == "Calendar-Orders")
            $timeout(function() { $state.go("app.calendar.login"); });
          else if($rootScope.default_screen == "Calendar-Occupation")
            $timeout(function() { $state.go("app.calendar.login"); });
          else if($rootScope.default_screen == "Businesses")
            $timeout(function() { $state.go("app.admin"); });
          else if($rootScope.default_screen == "Cashbox")
            $timeout(function() { $state.go("app.cashbox"); });
          else if($rootScope.default_screen == "Customers")
            $timeout(function() { $state.go("app.customers"); });
          else if($rootScope.default_screen == "Leads")
            $timeout(function() { $state.go("app.leads"); });
          else if($rootScope.default_screen == "Marketing")
            $timeout(function() { $state.go("app.marketing"); });
          else if($rootScope.default_screen == "Business Analysis")
            $timeout(function() { $state.go("app.analytics"); });
          else if($rootScope.default_screen == "Reports")
            $timeout(function() { $state.go("app.reports"); });
          else if($rootScope.default_screen == "Workers")
            $timeout(function() { $state.go("app.workers"); });
          else if($rootScope.default_screen == "Business Settings")
            $timeout(function() { $state.go("app.settings"); });
        }

      /**
       * Verifies if user has permission to view the section
       *
       * @param section
       * @returns {boolean}
       */
        $rootScope.isUserAllowedAccess = function (section) {
          var is_allowed = false;
          if($rootScope && $rootScope !== undefined && $rootScope.users_acl !== undefined && $rootScope.users_acl[section] !== undefined) {
            var section_key = $rootScope.users_acl[section].key;
            var permissions = $rootScope.$user ? $rootScope.$user.user_acl : {};
            if (angular.isDefined(permissions.allowed)) {
              permissions.allowed.forEach(function (permission) {
                if (permission['key'] === section_key) {
                  is_allowed = true;
                }
              });
            } else if (angular.isDefined(permissions.forbidden)) {
              is_allowed = true;
              permissions.forbidden.forEach(function (permission) {
                if (permission['key'] === section_key) {
                  is_allowed = false;
                }
              });
            }
          } else {
            is_allowed = true;
          }


          // when allowed check also employee permissions
          if (is_allowed) {
            if ($rootScope.userRole == 3) {
              if ($rootScope.employee_permissions && $rootScope.employee_permissions[section]) {
                is_allowed = $rootScope.employee_permissions[section].enabled;
              } else {
                is_allowed = false;
              }
            }
          }

          return is_allowed;
        }


        return $user;
    });
})();

(function() {

  angular.module("app.services").factory("$tiff_page", function() {
    var srv = this;

    srv.loading_stack = [];

    /**
     * Start loading with special key
     * @param loading_name
     */
    srv.start_loading = function (loading_name) {
      if(srv.loading_stack.length == 0) {
        angular.element(document.querySelector( 'body' )).addClass('loading_foreground');
      }
      srv.loading_stack.push(loading_name);
    }

    /**
     * Stop showing loading foreground if all loading stack is empty.
     * Or just remove one of key from loading stack
     * @param loading_name
     */
    srv.stop_loading = function (loading_name) {
      var index = srv.loading_stack.indexOf(loading_name);
      if(index !== -1) {
        srv.loading_stack.splice(index, 1);
      }
      if(srv.loading_stack.length == 0) {
        angular.element(document.querySelector( 'body' )).removeClass('loading_foreground');
      }
    }

    return srv;
  });

})();

(function() {

    angular.module("app.services").factory("$payment", function() {

        /**
         * Return all payment method that can be use in cashbox.
         *
         * @type {{credit_card: {code: number, label: string}, bank_transfer: {code: number, label: string}, cheque: {code: number, label: string}, credit_card_external: {code: number, label: string}, oncredit: {code: number, label: string}, cash: {code: number, label: string}}}
         */
        this.methods = {
            oncredit: {label: 'CALENDAR_CASH_ON_CREDIT', code: 3},
            cash: {label: 'CALENDAR_CASH_CASH', code: 1},
            cheque: {label: 'CALENDAR_CASH_CHEQUE', code: 4},
            credit_card_external: {label: 'CALENDAR_CASH_CREDIT_CARD_EXT', code: 6},
            bank_transfer: {label: 'CALENDAR_CASH_BANK_TRANS', code: 5},
            credit_card: {label: 'ADMIN_CREDIT_CARD', code: 2},
            credit_card_env: {label: 'CREDIT_CARD_ENV', code: 7},
            pay_link: {label: 'CALENDAR_PAY_LINK', code: 9},
        };

        return this;
    });

})();

(function() {
    
    angular.module("app.services").factory("$notify", function(notify) {
        
        return function(message, type) {
            
            return notify({ 
                message: message, 
                classes: 'alert-' + type, 
                templateUrl: "app/components/common/notify.html"
            });
        };
    });
    
})();
(function() {
    'use strict';

    angular.module('app.services')
        .service('HebrewDate', function() {
            
            // Hebrew month names
            var hebrewMonths = [
                'תשרי', 'חשון', 'כסלו', 'טבת', 'שבט', 'אדר',
                'ניסן', 'אייר', 'סיון', 'תמוז', 'אב', 'אלול'
            ];

            // English transliterations of Hebrew month names
            var englishHebrewMonths = [
                'Tishri', 'Cheshvan', 'Kislev', 'Tevet', 'Shevat', 'Adar',
                'Nisan', 'Iyar', 'Sivan', 'Tammuz', 'Av', 'Elul'
            ];

            // Hebrew day names
            var hebrewDays = [
                'ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'
            ];

            // Hebrew numerals for days
            var hebrewNumerals = [
                '', 'א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ז׳', 'ח׳', 'ט׳', 'י׳',
                'י״א', 'י״ב', 'י״ג', 'י״ד', 'י״ה', 'י״ו', 'י״ז', 'י״ח', 'י״ט', 'כ׳',
                'כ״א', 'כ״ב', 'כ״ג', 'כ״ד', 'כ״ה', 'כ״ו', 'כ״ז', 'כ״ח', 'כ״ט', 'ל׳'
            ];

            // Check if jewish-date library is available
            var jewishDateLib = null;
            
            // Try to access the library from different possible locations
            if (typeof window !== 'undefined') {
                if (window.jewishDate) {
                    jewishDateLib = window.jewishDate;
                } else if (window.jewishDateLib) {
                    jewishDateLib = window.jewishDateLib;
                }
            }

            // Accurate Hebrew date conversion using the jewish-date library
            function accurateGregorianToHebrew(gregorianDate) {
                // Try to use the jewish-date library if available
                if (jewishDateLib && typeof jewishDateLib.toJewishDate === 'function') {
                    try {
                        // Use the proper jewish-date library
                        var jewishDate = jewishDateLib.toJewishDate(gregorianDate);
                        
                        // Map the library's month names to our internal format
                        var monthName = jewishDate.monthName;
                        var monthIndex = englishHebrewMonths.indexOf(monthName);
                        
                        return {
                            year: jewishDate.year,
                            month: monthIndex + 1, // Convert to 1-based index
                            day: jewishDate.day,
                            monthName: hebrewMonths[monthIndex] || monthName,
                            dayName: hebrewDays[gregorianDate.getDay()]
                        };
                    } catch (error) {
                        console.warn('Error using jewish-date library, falling back to approximation:', error);
                    }
                }
                
                // Fallback to simple approximation if library is not available
                return gregorianToHebrew(gregorianDate);
            }

            // Simple Hebrew date conversion (fallback approximation)
            function gregorianToHebrew(gregorianDate) {
                var year = gregorianDate.getFullYear();
                var month = gregorianDate.getMonth() + 1;
                var day = gregorianDate.getDate();
                
                // This is a simplified conversion - for production use, 
                // a proper Hebrew calendar library like jewish-date should be used
                var hebrewYear = year + 3760; // Approximate conversion
                
                // Calculate Hebrew month and day (simplified)
                var hebrewMonth = month;
                var hebrewDay = day;
                
                // Adjust for Hebrew calendar differences
                if (month >= 9) {
                    hebrewMonth = month - 8;
                } else {
                    hebrewMonth = month + 4;
                }
                
                return {
                    year: hebrewYear,
                    month: hebrewMonth,
                    day: hebrewDay,
                    monthName: hebrewMonths[hebrewMonth - 1],
                    dayName: hebrewDays[gregorianDate.getDay()]
                };
            }

            // English day names
            var englishDays = [
                'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
            ];

            // Get English date string with Hebrew month name
            function getEnglishDateString(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);
                var englishDayName = englishDays[gregorianDate.getDay()];
                var gregorianDateStr = (gregorianDate.getDate() < 10 ? '0' : '') + gregorianDate.getDate() + 
                                    '/' + 
                                    ((gregorianDate.getMonth() + 1) < 10 ? '0' : '') + (gregorianDate.getMonth() + 1) + 
                                    '/' + 
                                    gregorianDate.getFullYear();
                
                // Use English transliteration of Hebrew month name
                var englishHebrewMonthName = englishHebrewMonths[hebrewDate.month - 1];
                
                // Format: English day name, Gregorian date / English Hebrew month name
                return englishDayName + ', ' + gregorianDateStr + ' / ' + englishHebrewMonthName;
            }

            // Get Hebrew date string in the requested format
            function getHebrewDateString(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);
                var hebrewDayName = hebrewDays[gregorianDate.getDay()];
                var gregorianDateStr = (gregorianDate.getDate() < 10 ? '0' : '') + gregorianDate.getDate() + 
                                    '/' + 
                                    ((gregorianDate.getMonth() + 1) < 10 ? '0' : '') + (gregorianDate.getMonth() + 1) + 
                                    '/' + 
                                    gregorianDate.getFullYear();
                
                // Get Hebrew numeral for the day
                var hebrewDayNumeral = hebrewNumerals[hebrewDate.day] || hebrewDate.day;
                
                // Format: Hebrew day name, Gregorian date / Hebrew day numeral + Hebrew month name
                return hebrewDayName + ', ' + gregorianDateStr + ' / ' + hebrewDayNumeral + ' ' + hebrewDate.monthName;
            }

            function getEnglishDateName(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);

                // Use English transliteration of Hebrew month name
                var englishHebrewMonthName = englishHebrewMonths[hebrewDate.month - 1];
                
                // Format: English day name, Gregorian date / English Hebrew month name
                return englishHebrewMonthName;
            }

            function getHebrewDateName(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);
                var hebrewDayNumeral = hebrewNumerals[hebrewDate.day] || hebrewDate.day;
                
                return hebrewDayNumeral + ' ' + hebrewDate.monthName;
            }

            // Get Hebrew format date string - detects language and returns appropriate format
            function getHebrewFormatDateString(gregorianDate) {
                // Check if we're in Hebrew language
                if (window.langKey === 'hb_ISR') {
                    return getHebrewDateString(gregorianDate);
                } else {
                    return getEnglishDateString(gregorianDate);
                }
            }

            function getHebrewFormatDateName(gregorianDate) {
                if (window.langKey === 'hb_ISR') {
                    return getHebrewDateName(gregorianDate);
                } else {
                    return getEnglishDateName(gregorianDate);
                }
            }

            return {
                gregorianToHebrew: gregorianToHebrew,
                accurateGregorianToHebrew: accurateGregorianToHebrew,
                getEnglishDateString: getEnglishDateString,
                getHebrewDateString: getHebrewDateString,
                getHebrewFormatDateString: getHebrewFormatDateString,
                getHebrewFormatDateName: getHebrewFormatDateName,
                hebrewMonths: hebrewMonths,
                englishHebrewMonths: englishHebrewMonths,
                hebrewDays: hebrewDays,
                hebrewNumerals: hebrewNumerals
            };
        });

})();

(function () {
    'use strict';

    angular.module('app.services')
        .service('GoogleCalendarService', ['$q', '$window', '$http', '$api', '$rootScope', function ($q, $window, $http, $api, $rootScope) {
            var service = this;
            // Google Calendar API configuration - will be loaded from user config
            var CLIENT_ID = null;
            var DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';
            var SCOPES = null;
            var GOOGLE_API_SCRIPT = 'https://apis.google.com/js/api.js';
            var GOOGLE_GIS_SCRIPT = 'https://accounts.google.com/gsi/client';
            
            // Development configuration
            var isDevelopment = $window.location.hostname === 'localhost' || $window.location.hostname === '127.0.0.1';

            var gapi = null;
            var google = null;
            var isInitialized = false;
            var isGisLoaded = false;

            /**
             * Load configuration from user data
             */
            function loadConfiguration() {
                if ($rootScope.$user && $rootScope.$user.google_calendar_config) {
                    CLIENT_ID = $rootScope.$user.google_calendar_config.client_id;
                    SCOPES = $rootScope.$user.google_calendar_config.scopes.join(' ');
                    return true;
                }
                return false;
            }

            /**
             * Initialize Google API with new Google Identity Services
             */
            service.initialize = function () {
                var deferred = $q.defer();
                
                if (isInitialized) {
                    deferred.resolve();
                    return deferred.promise;
                }

                // Load configuration first
                if (!loadConfiguration()) {
                    return deferred.reject('Google Calendar configuration not found');
                }

                // Load Google Identity Services first
                loadGoogleIdentityServices().then(function() {
                    // Then load Google API client
                    return loadGoogleApiClient();
                }).then(function() {
                    isInitialized = true;
                    console.log('Google API initialized successfully with new Google Identity Services');
                    deferred.resolve();
                }).catch(function(error) {
                    console.error('Error initializing Google API:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Load Google Identity Services
             */
            function loadGoogleIdentityServices() {
                var deferred = $q.defer();
                
                if (isGisLoaded && $window.google) {
                    google = $window.google;
                    deferred.resolve();
                    return deferred.promise;
                }

                // Load Google Identity Services script
                var script = document.createElement('script');
                script.src = GOOGLE_GIS_SCRIPT;
                script.onload = function() {
                    google = $window.google;
                    isGisLoaded = true;
                    console.log('Google Identity Services loaded');
                    deferred.resolve();
                };
                script.onerror = function() {
                    deferred.reject('Failed to load Google Identity Services');
                };
                document.head.appendChild(script);

                return deferred.promise;
            }

            /**
             * Load Google API Client
             */
            function loadGoogleApiClient() {
                var deferred = $q.defer();
                
                if (typeof $window.gapi !== 'undefined') {
                    gapi = $window.gapi;
                    initializeGapiClient();
                } else {
                    // Load Google API script
                    var script = document.createElement('script');
                    script.src = GOOGLE_API_SCRIPT;
                    script.onload = function() {
                        gapi = $window.gapi;
                        initializeGapiClient();
                    };
                    script.onerror = function() {
                        deferred.reject('Failed to load Google API');
                    };
                    document.head.appendChild(script);
                }

                function initializeGapiClient() {
                    gapi.load('client', function () {
                        gapi.client.init({
                            discoveryDocs: [DISCOVERY_DOC]
                        }).then(function () {
                            console.log('Google API client initialized');
                            deferred.resolve();
                        }).catch(function (error) {
                            console.error('Error initializing Google API client:', error);
                            deferred.reject(error);
                        });
                    });
                }

                return deferred.promise;
            }

            /**
             * Check if user is signed in
             */
            service.isSignedIn = function () {
                // Check if we have a stored token response and it's not expired
                if (!window.googleTokenResponse || !window.googleTokenResponse.access_token) {
                    return false;
                }
                
                // Check if token is expired (Google tokens typically expire in 1 hour)
                var tokenResponse = window.googleTokenResponse;
                if (tokenResponse.expires_in) {
                    var now = new Date().getTime();
                    var tokenTime = tokenResponse.token_time || 0;
                    var expiresIn = tokenResponse.expires_in * 1000; // Convert to milliseconds
                    
                    // Add 5 minute buffer to prevent edge cases
                    var bufferTime = 5 * 60 * 1000; // 5 minutes in milliseconds
                    
                    if (now - tokenTime > (expiresIn - bufferTime)) {
                        // Token expired or about to expire, clear it
                        window.googleTokenResponse = null;
                        return false;
                    }
                }
                
                return true;
            };

            /**
             * Sign in user and request permissions using Google Identity Services
             */
            service.signIn = function () {
                var deferred = $q.defer();
                
                if (!google || !google.accounts) {
                    deferred.reject('Google Identity Services not initialized');
                    return deferred.promise;
                }

                // Initialize the OAuth2 token client first
                var codeClient = google.accounts.oauth2.initCodeClient({
                    client_id: CLIENT_ID,
                    scope: SCOPES,
                    ux_mode: 'popup',
                    access_type: 'offline',
                    prompt: 'consent',
                    callback: function (response) {
                      // response.code must be exchanged on backend for tokens
                      exchangeCodeForToken(response.code).then(function(tokenResponse) {
                        tokenResponse.token_time = Date.now();
                        window.googleTokenResponse = tokenResponse;
                        return fetchUserInfo(tokenResponse.access_token, tokenResponse.id_token);
                      }).then(function(userInfo) {
                        deferred.resolve({ user: userInfo, accessToken: window.googleTokenResponse.access_token });
                      }).catch(function(err) {
                        deferred.reject('Failed to complete authentication: ' + err);
                      });
                    },
                    error_callback: function(err) {
                      deferred.reject(err.message || 'Popup error');
                    }
                });
                
                codeClient.requestCode();

                return deferred.promise;
            };


            /**
             * Sign out user
             */
            service.signOut = function () {
                var deferred = $q.defer();
                
                if (!google || !google.accounts) {
                    deferred.reject('Google Identity Services not initialized');
                    return deferred.promise;
                }

                // Get token before clearing it
                var tokenToRevoke = window.googleTokenResponse;
                
                // Clear stored token
                window.googleTokenResponse = null;

                // Revoke the token if it exists
                if (tokenToRevoke && tokenToRevoke.access_token) {
                    google.accounts.oauth2.revoke(tokenToRevoke.access_token, function() {
                        console.log('User signed out successfully');
                        deferred.resolve();
                    });
                } else {
                    console.log('User signed out successfully');
                    deferred.resolve();
                }

                return deferred.promise;
            };

            /**
             * Get user's Google Calendar list
             */
            service.getCalendarList = function () {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                gapi.client.calendar.calendarList.list().then(function (response) {
                    deferred.resolve(response.result.items);
                }).catch(function (error) {
                    console.error('Error fetching calendar list:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Exchange authorization code for access token
             */
            function exchangeCodeForToken(code) {
                var deferred = $q.defer();
                // Make a request to your backend to exchange the code for tokens
                $api.googlecalendar.token.save({
                    code: code,
                }, function(response) {
                    if (response.success && response.data && response.data.access_token) {
                        // Ensure refresh_token is properly included in the response
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject('Invalid token response from server: ' + (response.message || 'Unknown error'));
                    }
                }, function(error) {
                    console.error('Error exchanging code for token:', error);
                    deferred.reject('Failed to exchange code for token: ' + (error.data ? error.data.message : error.message));
                });
                
                return deferred.promise;
            }

            /**
             * Refresh access token using refresh token
             */
            function refreshAccessToken(refreshToken) {
                var deferred = $q.defer();
                
                // Make a request to your backend to refresh the token
                $api.googlecalendar.token.save({
                    refresh_token: refreshToken,
                }, function(response) {
                    if (response.success && response.data && response.data.access_token) {
                        response.data.token_time = Date.now();
                        window.googleTokenResponse = response.data;
                        deferred.resolve(response.data);
                    } else {
                        console.error('Failed to refresh token:', response);
                        window.googleTokenResponse = null;
                        deferred.reject('Failed to refresh token: ' + (response.message || 'Unknown error'));
                    }
                }, function(error) {
                    console.error('Error refreshing token:', error);
                    window.googleTokenResponse = null;
                    deferred.reject('Failed to refresh token: ' + (error.data ? error.data.message : error.message));
                });
                
                return deferred.promise;
            }

            /**
             * Get user info from token response
             */
            function fetchUserInfo(accessToken, idToken) {
                // First try to decode the ID token if available
                if (idToken) {
                    try {
                        // Decode the JWT ID token to get user info
                        var payload = JSON.parse(atob(idToken.split('.')[1]));
                        if (payload.email) {
                            return $q.resolve({
                                getId: function() { return payload.sub || ''; },
                                getName: function() { return payload.name || ''; },
                                getEmail: function() { return payload.email || ''; },
                                getImageUrl: function() { return payload.picture || ''; },
                                getAccessToken: function() { return accessToken || ''; },
                                getRefreshToken: function() { return window.googleTokenResponse ? window.googleTokenResponse.refresh_token || '' : ''; },
                                getTokenExpiresAt: function() { return payload.exp || ''; },
                                raw: payload
                            });
                        }
                    } catch (e) {
                        console.warn('Could not decode ID token:', e);
                    }
                }
                
                // Fallback to API call if ID token is not available or invalid
                return $http.get('https://www.googleapis.com/oauth2/v2/userinfo', {
                    headers: { 
                        'Authorization': 'Bearer ' + accessToken,
                        'Content-Type': 'application/json'
                    }
                }).then(function(resp) {
                    var data = resp.data || {};
                    return {
                        getId: function() { return data.id || ''; },
                        getName: function() { return data.name || ''; },
                        getEmail: function() { return data.email || ''; },
                        getImageUrl: function() { return data.picture || ''; },
                        getAccessToken: function() { return accessToken || ''; },
                        getRefreshToken: function() { return window.googleTokenResponse ? window.googleTokenResponse.refresh_token || '' : ''; },
                        getTokenExpiresAt: function() { return window.googleTokenResponse ? window.googleTokenResponse.expires_in || '' : ''; },
                        raw: data
                    };
                }).catch(function(error) {
                    console.error('Error fetching user info:', error);
                    if (error.status === 401) {
                        // Try to refresh the token if we have a refresh token
                        if (window.googleTokenResponse && window.googleTokenResponse.refresh_token) {
                            return refreshAccessToken(window.googleTokenResponse.refresh_token).then(function(newTokenResponse) {
                                // Retry the user info request with the new token
                                return $http.get('https://www.googleapis.com/oauth2/v2/userinfo', {
                                    headers: { 
                                        'Authorization': 'Bearer ' + newTokenResponse.access_token,
                                        'Content-Type': 'application/json'
                                    }
                                }).then(function(resp) {
                                    var data = resp.data || {};
                                    return {
                                        getId: function() { return data.id || ''; },
                                        getName: function() { return data.name || ''; },
                                        getEmail: function() { return data.email || ''; },
                                        getImageUrl: function() { return data.picture || ''; },
                                        getAccessToken: function() { return newTokenResponse.access_token || ''; },
                                        getRefreshToken: function() { return newTokenResponse.refresh_token || ''; },
                                        raw: data
                                    };
                                });
                            }).catch(function(refreshError) {
                                console.error('Failed to refresh token:', refreshError);
                                window.googleTokenResponse = null;
                                throw new Error('Token expired and could not be refreshed. Please sign in again.');
                            });
                        } else {
                            window.googleTokenResponse = null;
                            throw new Error('Token expired or invalid. Please sign in again.');
                        }
                    }
                    throw error;
                });
            }

            /**
             * Set authorization header for API requests
             */
            function setAuthHeader() {
                if (window.googleTokenResponse && window.googleTokenResponse.access_token) {
                    // Check if token is expired
                    var tokenResponse = window.googleTokenResponse;
                    if (tokenResponse.expires_in) {
                        var now = new Date().getTime();
                        var tokenTime = tokenResponse.token_time || 0;
                        var expiresIn = tokenResponse.expires_in * 1000;
                        
                        if (now - tokenTime > expiresIn) {
                            // Token expired, clear it
                            window.googleTokenResponse = null;
                            return false;
                        }
                    }
                    
                    // Store the access token for use in API calls
                    gapi.client.setToken(window.googleTokenResponse);
                    return true;
                }
                return false;
            }

            /**
             * Force re-authentication when token is expired
             */
            service.forceReAuth = function() {
                window.googleTokenResponse = null;
                return service.signIn();
            };

            /**
             * Check and refresh token if needed
             */
            service.checkAndRefreshToken = function() {
                if (!service.isSignedIn()) {
                    return $q.reject('User not signed in or token expired');
                }
                
                // Check if token is about to expire (within 5 minutes)
                var tokenResponse = window.googleTokenResponse;
                if (tokenResponse.expires_in) {
                    var now = new Date().getTime();
                    var tokenTime = tokenResponse.token_time || 0;
                    var expiresIn = tokenResponse.expires_in * 1000;
                    var timeUntilExpiry = expiresIn - (now - tokenTime);
                    var fiveMinutes = 5 * 60 * 1000;
                    
                    if (timeUntilExpiry < fiveMinutes && tokenResponse.refresh_token) {
                        // Try to refresh the token
                        return refreshAccessToken(tokenResponse.refresh_token);
                    }
                }
                
                return $q.resolve(window.googleTokenResponse);
            };

            /**
             * Get user info using stored token
             */
            service.getUserInfo = function() {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                var tokenResponse = window.googleTokenResponse;
                fetchUserInfo(tokenResponse.access_token, tokenResponse.id_token).then(function(userInfo) {
                    deferred.resolve(userInfo);
                }).catch(function(error) {
                    console.error('Error getting user info:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Create a new event in Google Calendar
             */
            service.createEvent = function (calendarId, eventData) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var event = {
                    'summary': eventData.summary,
                    'description': eventData.description || '',
                    'start': {
                        'dateTime': eventData.startDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    },
                    'end': {
                        'dateTime': eventData.endDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    }
                };

                // Add attendees if provided
                if (eventData.attendees && eventData.attendees.length > 0) {
                    event.attendees = eventData.attendees;
                }

                gapi.client.calendar.events.insert({
                    'calendarId': calendarId,
                    'resource': event
                }).then(function (response) {
                    deferred.resolve(response.result);
                }).catch(function (error) {
                    console.error('Error creating event:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Update an existing event in Google Calendar
             */
            service.updateEvent = function (calendarId, eventId, eventData) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var event = {
                    'summary': eventData.summary,
                    'description': eventData.description || '',
                    'start': {
                        'dateTime': eventData.startDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    },
                    'end': {
                        'dateTime': eventData.endDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    }
                };

                // Add attendees if provided
                if (eventData.attendees && eventData.attendees.length > 0) {
                    event.attendees = eventData.attendees;
                }

                gapi.client.calendar.events.update({
                    'calendarId': calendarId,
                    'eventId': eventId,
                    'resource': event
                }).then(function (response) {
                    deferred.resolve(response.result);
                }).catch(function (error) {
                    console.error('Error updating event:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Delete an event from Google Calendar
             */
            service.deleteEvent = function (calendarId, eventId) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                gapi.client.calendar.events.delete({
                    'calendarId': calendarId,
                    'eventId': eventId
                }).then(function () {
                    deferred.resolve();
                }).catch(function (error) {
                    console.error('Error deleting event:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Get events from Google Calendar
             */
            service.getEvents = function (calendarId, timeMin, timeMax) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var request = {
                    'calendarId': calendarId,
                    'timeMin': timeMin,
                    'timeMax': timeMax,
                    'showDeleted': false,
                    'singleEvents': true,
                    'orderBy': 'startTime'
                };

                gapi.client.calendar.events.list(request).then(function (response) {
                    deferred.resolve(response.result.items || []);
                }).catch(function (error) {
                    console.error('Error fetching events:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Create a new calendar
             */
            service.createCalendar = function (calendarData) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var calendar = {
                    'summary': calendarData.summary,
                    'description': calendarData.description || '',
                    'timeZone': calendarData.timeZone || 'UTC'
                };

                gapi.client.calendar.calendars.insert({
                    'resource': calendar
                }).then(function (response) {
                    deferred.resolve(response.result);
                }).catch(function (error) {
                    console.error('Error creating calendar:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            return service;
        }]);
})();

(function() {
    
    angular.module("app.services").factory("$date", function() {
            
        var $date = this;

        /**
         * Return the date of Sunday at the same week
         * @param {Date} date 
         */
        $date.getSunday = function(date) {
            
            var 
                day = date.getDay(),
                time = date.getTime();

            return new Date(time - (day * 3600 * 24 * 1000));
        };

        /**
         * Return the date of Saturday at the same week
         * @param {Date} date 
         */
        $date.getSaturday = function(date) {
            
            var
                day = date.getDay(),
                time = date.getTime(),
                difference = 6 - day;

            return new Date(time + (difference * 3600 * 24 * 1000));
        };

        return $date;
    });
    
})();
(function () {
  angular.module('app.services')
    .factory('$customFields', function ($rootScope, $translate) {
      return {
        getTypes: function () {
          return [
            { key: '', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_SELECT_TYPE') },
            { key: 'text', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_TEXT') },
            { key: 'date', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_DATE') },
            { key: 'datetime', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_DATETIME') },
            { key: 'list', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_LIST') },
          ];
        },

        getCurrentName: function (names) {
          var currentLocale = $rootScope.currentLanguage ? $rootScope.currentLanguage : 'en_US';
          var data;
          try {
            data = JSON.parse(names);
          } catch (e) {
            return names;
          }
  
          var result = data[currentLocale];
          if (!data[currentLocale]) {
            var values = Object.keys(data).map(function (key) {
              return data[key];
            });
  
            for (var i = 0; i < values.length; i++) {
              if (values[i] && values[i].trim()) {
                result = values[i];
                break;
              }
            }
          }
          return result;
        },
      };
    });
})();

(function () {
  angular.module('app.services')
    .factory('$color', function () {
      function pSBC(p,c0,c1,l) {
        var r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
        if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
        if(!this.pSBCr)this.pSBCr=function(d) {
            var n=d.length,x={};
            if(n>9){
                d=d.split(","),n=d.length;
                r = d[0] ? d[0] : '';
                g = d[1] ? d[1] : '';
                b = d[2] ? d[2] : '';
                a = d[3] ? d[3] : '';
                if(n<3||n>4)return null;
                x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
            }else{
                if(n==8||n==6||n<4)return null;
                if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
                d=i(d.slice(1),16);
                if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
                else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
            }return x};
        h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
        if(!f||!t)return null;
        if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
        else r=m(Math.pow((P*Math.pow(f.r,2)+p*Math.pow(t.r,2)),0.5)),g=m(Math.pow((P*Math.pow(f.g,2)+p*Math.pow(t.g,2)),0.5)),b=m(Math.pow((P*Math.pow(f.b,2)+p*Math.pow(t.b,2)),0.5));
        a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
        if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
        else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
      }
      
      var svc = {
        pSBC: pSBC,

        // lighten by pct (0..1). linear=true for linear blend; false uses gamma blend (default of pSBC).
        lighten: function (c, pct, linear) {
          return this.pSBC(Math.abs(pct || 0), c, null, !!linear);
        },

        // darken by pct (0..1)
        darken: function (c, pct, linear) {
          return this.pSBC(-Math.abs(pct || 0), c, null, !!linear);
        },

        // mix two colors by pct (0..1) toward c1
        mix: function (c0, c1, pct, linear) {
          return this.pSBC(Math.max(0, Math.min(1, pct || 0)), c0, c1, !!linear);
        },

        // quick gradient helpers
        gradientLR: function (base, lightPct, darkPct, linear) {
          // defaults: 25% lighter → 20% darker
          lightPct = (lightPct == null) ? 0.25 : lightPct;
          darkPct  = (darkPct  == null) ? -0.20 : darkPct;
          var from = this.pSBC(lightPct, base, null, !!linear);
          var to   = this.pSBC(darkPct,  base, null, !!linear);
          return 'linear-gradient(90deg,' + from + ' 0%,' + to + ' 100%)';
        },

        gradientTB: function (base, lightPct, darkPct, linear) {
          lightPct = (lightPct == null) ? 0.25 : lightPct;
          darkPct  = (darkPct  == null) ? -0.20 : darkPct;
          var from = this.pSBC(lightPct, base, null, !!linear);
          var to   = this.pSBC(darkPct,  base, null, !!linear);
          return 'linear-gradient(180deg,' + from + ' 0%,' + to + ' 100%)';
        }
      };

      return svc;
    });
})();

(function () {
    'use strict';

    angular.module('app.services')
        .service('CalendarSyncService', ['$q', '$http', '$api', 'GoogleCalendarService', function ($q, $http, $api, GoogleCalendarService) {
            var service = this;

            /**
             * Synchronize calendar events for a specific resource
             */
            service.syncResourceCalendar = function (resourceId, resourceEmail, calendarDate) {
                var deferred = $q.defer();

                // First, get the resource's Google Calendar ID
                GoogleCalendarService.getCalendarList().then(function (calendars) {
                    var targetCalendar = null;
                    
                    // Look for a calendar that matches the resource email
                    for (var i = 0; i < calendars.length; i++) {
                        if (calendars[i].id === resourceEmail || 
                            calendars[i].primary === true ||
                            calendars[i].summary.toLowerCase().includes(resourceEmail.toLowerCase())) {
                            targetCalendar = calendars[i];
                            break;
                        }
                    }

                    if (!targetCalendar) {
                        // Create a new calendar for this resource
                        return GoogleCalendarService.createCalendar({
                            summary: 'Tiffulit - ' + resourceEmail,
                            description: 'Calendar for Tiffulit resource: ' + resourceEmail,
                            timeZone: moment.tz.guess()
                        });
                    } else {
                        return $q.resolve(targetCalendar);
                    }
                }).then(function (calendar) {
                    // Get Tiffulit events for the resource on the specified date
                    return getTiffulitEvents(resourceId, calendarDate).then(function(tiffulitEvents) {
                        return {
                            calendar: calendar,
                            tiffulitEvents: tiffulitEvents
                        };
                    });
                }).then(function (data) {
                    // Get existing Google Calendar events for the same date
                    var startOfDay = moment(calendarDate).startOf('day').toISOString();
                    var endOfDay = moment(calendarDate).endOf('day').toISOString();
                    
                    return GoogleCalendarService.getEvents(data.calendar.id, startOfDay, endOfDay).then(function(googleEvents) {
                        return {
                            calendar: data.calendar,
                            tiffulitEvents: data.tiffulitEvents,
                            googleEvents: googleEvents
                        };
                    });
                }).then(function (data) {
                    // Process synchronization
                    return processSync(data.tiffulitEvents, data.googleEvents, data.calendar.id);
                }).then(function (result) {
                    deferred.resolve(result);
                }).catch(function (error) {
                    console.error('Error synchronizing calendar:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Get Tiffulit events for a specific resource and date
             */
            function getTiffulitEvents(resourceId, date) {
                var deferred = $q.defer();

                $api.orders.calendar.get({
                    date: moment(date).format('YYYY-MM-DD'),
                    range: 'daily'
                }, function (response) {
                    if (response.status === 'success') {
                        // Filter events by resource ID
                        var filteredEvents = (response.data || []).filter(function(event) {
                            return event.resource_id == resourceId;
                        });
                        deferred.resolve(filteredEvents);
                    } else {
                        deferred.reject('Failed to fetch Tiffulit events');
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            /**
             * Process synchronization between Tiffulit and Google Calendar events
             */
            function processSync(tiffulitEvents, googleEvents, calendarId) {
                var deferred = $q.defer();
                var promises = [];
                var syncResult = {
                    created: 0,
                    updated: 0,
                    deleted: 0,
                    errors: []
                };

                // Create/Update events from Tiffulit
                for (var i = 0; i < tiffulitEvents.length; i++) {
                    var tiffulitEvent = tiffulitEvents[i];
                    var existingGoogleEvent = findExistingGoogleEvent(googleEvents, tiffulitEvent);

                    if (existingGoogleEvent) {
                        // Update existing event
                        var updatePromise = updateGoogleEvent(calendarId, existingGoogleEvent.id, tiffulitEvent);
                        updatePromise.then(function () {
                            syncResult.updated++;
                        }).catch(function (error) {
                            syncResult.errors.push('Failed to update event: ' + error);
                        });
                        promises.push(updatePromise);
                    } else {
                        // Create new event
                        var createPromise = createGoogleEvent(calendarId, tiffulitEvent);
                        createPromise.then(function () {
                            syncResult.created++;
                        }).catch(function (error) {
                            syncResult.errors.push('Failed to create event: ' + error);
                        });
                        promises.push(createPromise);
                    }
                }

                // Delete Google events that don't exist in Tiffulit
                for (var j = 0; j < googleEvents.length; j++) {
                    var googleEvent = googleEvents[j];
                    var existsInTiffulit = findExistingTiffulitEvent(tiffulitEvents, googleEvent);

                    if (!existsInTiffulit) {
                        var deletePromise = GoogleCalendarService.deleteEvent(calendarId, googleEvent.id);
                        deletePromise.then(function () {
                            syncResult.deleted++;
                        }).catch(function (error) {
                            syncResult.errors.push('Failed to delete event: ' + error);
                        });
                        promises.push(deletePromise);
                    }
                }

                $q.all(promises).then(function () {
                    deferred.resolve(syncResult);
                }).catch(function () {
                    deferred.resolve(syncResult); // Still resolve with partial results
                });

                return deferred.promise;
            }

            /**
             * Find existing Google event that matches Tiffulit event
             */
            function findExistingGoogleEvent(googleEvents, tiffulitEvent) {
                for (var i = 0; i < googleEvents.length; i++) {
                    var googleEvent = googleEvents[i];
                    // Match by start time and customer name
                    var googleStart = moment(googleEvent.start.dateTime || googleEvent.start.date);
                    var tiffulitStart = moment(tiffulitEvent.start_time);
                    
                    if (googleStart.isSame(tiffulitStart, 'minute') && 
                        googleEvent.summary.includes(getCustomerName(tiffulitEvent))) {
                        return googleEvent;
                    }
                }
                return null;
            }

            /**
             * Find existing Tiffulit event that matches Google event
             */
            function findExistingTiffulitEvent(tiffulitEvents, googleEvent) {
                for (var i = 0; i < tiffulitEvents.length; i++) {
                    var tiffulitEvent = tiffulitEvents[i];
                    var googleStart = moment(googleEvent.start.dateTime || googleEvent.start.date);
                    var tiffulitStart = moment(tiffulitEvent.start_time);
                    
                    if (googleStart.isSame(tiffulitStart, 'minute') && 
                        googleEvent.summary.includes(getCustomerName(tiffulitEvent))) {
                        return tiffulitEvent;
                    }
                }
                return null;
            }

            /**
             * Create a new Google Calendar event from Tiffulit event
             */
            function createGoogleEvent(calendarId, tiffulitEvent) {
                var eventData = formatTiffulitEventForGoogle(tiffulitEvent);
                return GoogleCalendarService.createEvent(calendarId, eventData);
            }

            /**
             * Update an existing Google Calendar event from Tiffulit event
             */
            function updateGoogleEvent(calendarId, eventId, tiffulitEvent) {
                var eventData = formatTiffulitEventForGoogle(tiffulitEvent);
                return GoogleCalendarService.updateEvent(calendarId, eventId, eventData);
            }

            /**
             * Format Tiffulit event data for Google Calendar
             */
            function formatTiffulitEventForGoogle(tiffulitEvent) {
                var customerName = getCustomerName(tiffulitEvent);
                var startDateTime = moment(tiffulitEvent.start_time).format();
                var endDateTime = moment(tiffulitEvent.end_time).format();
                
                // Calculate accumulated duration for multiple services
                var duration = calculateAccumulatedDuration(tiffulitEvent);
                var description = '';

                // Add service details to description
                if (tiffulitEvent.merged && tiffulitEvent.merged.length > 0) {
                    description = 'Services: ';
                    for (var i = 0; i < tiffulitEvent.merged.length; i++) {
                        if (i > 0) description += ', ';
                        description += tiffulitEvent.merged[i].item_data.name;
                    }
                } else {
                    description = 'Service: ' + tiffulitEvent.item_data.name;
                }

                if (tiffulitEvent.order_notes) {
                    description += '\nNotes: ' + tiffulitEvent.order_notes;
                }

                return {
                    summary: customerName,
                    description: description,
                    startDateTime: startDateTime,
                    endDateTime: endDateTime,
                    timeZone: moment.tz.guess()
                };
            }

            /**
             * Get customer name from Tiffulit event
             */
            function getCustomerName(tiffulitEvent) {
                if (tiffulitEvent.order_customer) {
                    var name = tiffulitEvent.order_customer_firstname;
                    if (tiffulitEvent.order_customer_lastname) {
                        name += ' ' + tiffulitEvent.order_customer_lastname;
                    }
                    return name;
                } else {
                    return tiffulitEvent.customer_name || 'Unknown Customer';
                }
            }

            /**
             * Calculate accumulated duration for multiple services
             */
            function calculateAccumulatedDuration(tiffulitEvent) {
                var totalDuration = moment(tiffulitEvent.end_time).diff(moment(tiffulitEvent.start_time), 'minutes');
                
                // If there are merged events, calculate total duration
                if (tiffulitEvent.merged && tiffulitEvent.merged.length > 0) {
                    totalDuration = 0;
                    for (var i = 0; i < tiffulitEvent.merged.length; i++) {
                        var mergedEvent = tiffulitEvent.merged[i];
                        totalDuration += moment(mergedEvent.end_time).diff(moment(mergedEvent.start_time), 'minutes');
                    }
                }
                
                return totalDuration;
            }

            /**
             * Initialize Google Calendar integration for a resource
             */
            service.initializeResourceSync = function (resourceId, resourceEmail) {
                var deferred = $q.defer();

                GoogleCalendarService.initialize().then(function () {
                    if (!GoogleCalendarService.isSignedIn()) {
                        // User needs to sign in
                        deferred.resolve({
                            needsAuth: true,
                            message: 'Please sign in to Google to enable calendar synchronization'
                        });
                    } else {
                        // User is already signed in, check if calendar exists
                        GoogleCalendarService.getCalendarList().then(function (calendars) {
                            var hasCalendar = false;
                            for (var i = 0; i < calendars.length; i++) {
                                if (calendars[i].id === resourceEmail || 
                                    calendars[i].summary.toLowerCase().includes(resourceEmail.toLowerCase())) {
                                    hasCalendar = true;
                                    break;
                                }
                            }
                            
                            deferred.resolve({
                                needsAuth: false,
                                hasCalendar: hasCalendar,
                                message: hasCalendar ? 'Calendar synchronization ready' : 'Calendar will be created on first sync'
                            });
                        }).catch(function (error) {
                            deferred.reject(error);
                        });
                    }
                }).catch(function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            return service;
        }]);
})();

(function() {

    angular.module("app.services").factory("$business", function($translate, $api) {

        var $business = this,

        // The order in array is important;
        businesses_statuses = ["ADMIN_BUSINESS_STATUS_ACTIVE", "ADMIN_BUSINESS__STATUS_TRIAL", "ADMIN_BUSINESS_STATUS_INACTIVE"],
        businesses_credit = ["TRANZILA", "YAAD_SARIG", "PELECARD", "ZCREDIT"];


        // The order in array is important;
        $business.businesses_msg_channels = [
            {name: "SETTINGS_MSG_CHANNEL_NO", index: 0},
            {name: "SETTINGS_MSG_CHANNEL_EMAIL", index: 1},
            {name: "SETTINGS_MSG_CHANNEL_SMS", index: 2},

            //WhatsApp is not an option till the official API release
            {name: "SETTINGS_MSG_CHANNEL_WHATSAPP", index: 3},

            {name: "SETTINGS_MSG_CHANNEL_PRINT", index: 4}
        ];

        //Customer notifications channels;
        $business.customers_notifications_channels = [
          {name: "SETTINGS_MSG_CHANNEL_NO", value: 0},
          {name: "SETTINGS_MSG_CHANNEL_EMAIL", value: 1},
          {name: "SETTINGS_MSG_CHANNEL_SMS", value: 2},
          {name: "SETTINGS_MSG_CHANNEL_WHATSAPP", value: 3}
        ];

        //Reminder sending time before scheduled order;
        $business.reminder_send_times = [
          {name: "SETTINGS_USER_REMINDER_NO", value: 0},
          {name: "SETTINGS_USER_REMINDER_2_HOURS", value: 2},
          {name: "SETTINGS_USER_REMINDER_4_HOURS", value: 4},
          {name: "SETTINGS_USER_REMINDER_24_HOURS", value: 24},
          {name: "SETTINGS_USER_REMINDER_48_HOURS", value: 48},
          {name: "SETTINGS_USER_REMINDER_72_HOURS", value: 72},
          {name: "SETTINGS_USER_REMINDER_168_HOURS", value: 168}
        ];

        $business.laser_categories = [
            {
                id: 1,
                name: $translate.instant('LF_SETTINGS_CATEGORY_1')
            },
            {
                id: 2,
                name: $translate.instant('LF_SETTINGS_CATEGORY_2')
            },
            {
                id: 3,
                name: $translate.instant('LF_SETTINGS_CATEGORY_3')
            }
        ];

        $business.getStatusByIndex = function($i) {
            return businesses_statuses[$i];
        };

        $business.getAllStatuses = function() {
            return businesses_statuses;
        }

        $business.getCreditCompByIndex = function($i) {
            return businesses_credit[$i];
        };

        $business.getAllCreditComp = function() {
            return businesses_credit;
        }

        /**
         * Return message channel type by it's index from the above list 'businesses_msg_channels'
         * @param $i
         * @returns {string}
         */
        $business.getMsgChannelByIndex = function($i) {
            return $business.businesses_msg_channels[$i];
        };

        /**
         * Return all types of message channels
         *
         * @returns {string[]}
         */
        $business.getMsgChannels = function() {
            return $business.businesses_msg_channels;
        }

        $business.is_ai_enabled = null;
        $business.ai_fetch = function() {
            if ($business.is_ai_enabled == null) {
                $api.settings.ai.get(function (response) {
                    if (response && response.data) {
                        $business.is_ai_enabled = response.data;
                    }
                });
            }
        }

        $business.ai_reset = function() {
            $business.is_ai_enabled = null;
        }

        return $business;
    });

})();

(function() {
    'use strict';

    /**
     * Audio Recorder Service
     * 
     * Provides audio recording functionality with speech-to-text conversion.
     * Uses a single state variable to prevent UI overlap issues.
     * 
     * States:
     * - 'idle': Ready to record (shows microphone icon)
     * - 'recording': Currently recording audio (shows stop icon)
     * - 'processing': Sending audio to AI for transcription (shows spinner with gradient)
     */
    angular.module('app.services').factory('AudioRecorderService', function($translate, $cookies, $timeout) {

        var service = {
            state: 'idle',  // 'idle' | 'recording' | 'processing'
            activeInstanceId: null,  // Track which directive instance is currently active
            mediaRecorder: null,
            audioChunks: [],
            callbacks: {}
        };

        /**
         * Start recording audio from microphone
         * @param {Object} callbacks - { onStart, onStop, onSuccess, onError, instanceId }
         */
        service.startRecording = function(callbacks) {
            service.callbacks = callbacks || {};
            service.activeInstanceId = callbacks.instanceId || null;

            // Check if browser supports getUserMedia
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                var errorMsg = $translate.instant('AUDIO_NOT_SUPPORTED');
                if (service.callbacks.onError) {
                    service.callbacks.onError(errorMsg);
                }
                swal({
                    title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                    text: errorMsg,
                    type: 'error',
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                return;
            }

            // Request microphone access
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(function(stream) {
                    service.audioChunks = [];
                    
                    // Create MediaRecorder instance
                    service.mediaRecorder = new MediaRecorder(stream);
                    
                    // Collect audio data chunks
                    service.mediaRecorder.ondataavailable = function(event) {
                        if (event.data.size > 0) {
                            service.audioChunks.push(event.data);
                        }
                    };
                    
                    // Handle recording stop
                    service.mediaRecorder.onstop = function() {
                        // Stop all tracks to release microphone
                        stream.getTracks().forEach(function(track) {
                            track.stop();
                        });
                        
                        if (service.callbacks.onStop) {
                            service.callbacks.onStop();
                        }
                    };
                    
                    // Start recording
                    service.mediaRecorder.start();
                    
                    $timeout(function() {
                        service.state = 'recording';
                        
                        if (service.callbacks.onStart) {
                            service.callbacks.onStart();
                        }
                    });
                })
                .catch(function(error) {
                    console.error('Error accessing microphone:', error);
                    var errorMsg = $translate.instant('MICROPHONE_ACCESS_DENIED');

                    $timeout(function() {
                        service.state = 'idle';
                        service.activeInstanceId = null;
                        
                        if (service.callbacks.onError) {
                            service.callbacks.onError(errorMsg);
                        }
                    });
                    
                    swal({
                        title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                        text: errorMsg,
                        type: 'error',
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                });
        };

        /**
         * Stop recording
         */
        service.stopRecording = function() {
            if (service.mediaRecorder && service.mediaRecorder.state !== 'inactive') {
                service.mediaRecorder.stop();
            }
        };

        /**
         * Send recorded audio to backend for speech-to-text conversion
         * @param {string} apiBaseURL - Base URL for API
         * @param {Function} onSuccess - Callback with transcribed text
         * @param {Function} onError - Error callback
         */
        service.sendAudioToBackend = function(apiBaseURL, onSuccess, onError) {
            if (service.audioChunks.length === 0) {
                console.error('No audio data recorded');
                if (onError) {
                    onError('No audio data recorded');
                }
                return;
            }

            // Create audio blob from chunks
            var audioBlob = new Blob(service.audioChunks, { type: 'audio/webm' });
            
            // Update state to processing
            $timeout(function() {
                service.state = 'processing';
            });
            
            // Create FormData to send file
            var formData = new FormData();
            formData.append('audio_file', audioBlob, 'recording.webm');

            // Send to backend using XMLHttpRequest
            var xhr = new XMLHttpRequest();
            xhr.open('POST', apiBaseURL + '/ai/action/speach_to_text', true);
            
            // Add authorization header
            var token = $cookies.get('token');
            if (token) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            }

            xhr.onload = function() {
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        
                        if (response.status === 'success') {
                            $timeout(function() {
                                service.state = 'idle';
                                service.activeInstanceId = null;
                                if (onSuccess) {
                                    onSuccess(response.data);
                                }
                            });
                        } else {
                            $timeout(function() {
                                service.state = 'idle';
                                service.activeInstanceId = null;
                            });
                            var errorMsg = response.message || 'Failed to convert audio to text';
                            if (onError) {
                                onError(errorMsg);
                            }
                            
                            swal({
                                title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                                text: errorMsg,
                                type: 'error',
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    } catch (e) {
                        $timeout(function() {
                            service.state = 'idle';
                            service.activeInstanceId = null;
                        });
                        
                        console.error('Error parsing response:', e);
                        var errorMsg = $translate.instant('AUDIO_PROCESSING_ERROR');
                        
                        if (onError) {
                            onError(errorMsg);
                        }
                        
                        swal({
                            title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                            text: errorMsg,
                            type: 'error',
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    }
                } else {
                    $timeout(function() {
                        service.state = 'idle';
                        service.activeInstanceId = null;
                    });
                    console.error('Request failed with status:', xhr);
                    var response = xhr && xhr.responseText ? JSON.parse(xhr.responseText) : {};
                    var errorMsg = response.message || $translate.instant('AUDIO_UPLOAD_ERROR');
                    
                    if (onError) {
                        onError(errorMsg);
                    }
                    
                    swal({
                        title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                        text: errorMsg,
                        type: 'error',
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }
            };

            xhr.onerror = function() {
                $timeout(function() {
                    service.state = 'idle';
                    service.activeInstanceId = null;
                });
                
                console.error('Network error occurred');
                var errorMsg = $translate.instant('NETWORK_ERROR');
                
                if (onError) {
                    onError(errorMsg);
                }
                
                swal({
                    title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                    text: errorMsg,
                    type: 'error',
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            };

            xhr.send(formData);
        };

        /**
         * Toggle recording on/off
         * @param {Object} options - { apiBaseURL, instanceId, onSuccess, onError, onStart, onStop }
         */
        service.toggleRecording = function(options) {
            if (service.state === 'processing') {
                return; // Prevent multiple clicks while processing
            }

            if (service.state !== 'recording') {
                // Start recording
                service.startRecording({
                    instanceId: options.instanceId,
                    onStart: options.onStart,
                    onStop: function() {
                        if (options.onStop) {
                            options.onStop();
                        }
                        // Process and send audio after stopping
                        service.sendAudioToBackend(
                            options.apiBaseURL,
                            options.onSuccess,
                            options.onError
                        );
                    },
                    onError: options.onError
                });
            } else {
                // Stop recording
                service.stopRecording();
            }
        };

        /**
         * Reset the service state
         */
        service.reset = function() {
            $timeout(function() {
                service.state = 'idle';
                service.activeInstanceId = null;
                service.mediaRecorder = null;
                service.audioChunks = [];
                service.callbacks = {};
            });
        };

        return service;
    });

})();


/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function () {

    angular.module("app.services").factory("$api", function ($header, $q, $log, $resource, $state) {
        var
            $api = this,
            baseURL = "https://app.tiffulit.co.il/api";
            if (window.location.hostname == 'localhost' || window.location.hostname == '192.168.68.115') {
                baseURL = window.location.port == 3002 ? "http://" + window.location.hostname + "/index.php/api" : "http://tiffulit.my/back-end/index.php/api";
            }
            // baseURL = "http://192.168.68.112/index.php/api";
            // baseURL = "http://tiffulit-api.project-release.info/index.php/api";
            // baseURL = "http://tiffulit.api.loc/index.php/api";
            // baseURL = "http://tiffulit-env-dev.eu-west-1.elasticbeanstalk.com/api/index.php/api";
            // baseURL = "http://localhost/Tiffulit_Israel_API/index.php/api";
            // baseURL = "https://stage.tiffulit.co.il/api";


        /**
         * Contain all the api available routes
         */
        $api = {};
        $api.baseURL = baseURL;

        /**
         * Authentication
         */
        $api.auth = $resource(baseURL + "/auth");

        $api.auth.check_password = $resource(baseURL + "/auth/action/check_password");

        $api.auth.logout = $resource(baseURL + "/auth/action/logout");

        $api.forgot_password = $resource(baseURL + "/ForgotPassword");

        $api.passwordconfirm = $resource(baseURL + "/PasswordConfirm");

        $api.all_acls = $resource(baseURL + "/UserACL/all");

        /**
         * Customers
         */
        $api.customers = $resource(baseURL + "/customers");
        $api.customers.single = $resource(baseURL + "/customers/id/:id", {id: "@id"});
        $api.customers.list = $resource(baseURL + "/customers/action/list"); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.customers.download = $resource(baseURL + "/customers/action/download", {}, { download: { method: 'GET', responseType: 'arraybuffer', headers: { 'Accept': 'text/csv' }, transformResponse: [],       // don’t try to JSON.parse
            interceptor: {
              response: function(response) {
                return {
                  data:    response.data,
                  headers: response.headers
                };
              }
            }} }); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.customers.marketing = $resource(baseURL + "/customers/action/marketing");
        $api.customers.update = $resource(baseURL + "/customers/action/update");
        $api.customers.today_birthday = $resource(baseURL + "/customers/action/today_birthday");
        $api.customers.filter = $resource(baseURL + "/customers/action/filter_values");
        $api.customers.find = $resource(baseURL + "/customers/action/search/str/:str", {str: "@str"});
        $api.customers.request_review = $resource(baseURL + "/customers/action/request_review", { id: "@id", type: "@type"});
        $api.customers.social_link = $resource(baseURL + "/customers/action/social_link/id/:id", { id: "@id"});
        $api.customers.remove = $resource(baseURL + "/customers/id/:id/confirm/:confirm", {id: "@id", confirm: "@confirm"});
        $api.customers.recover = $resource(baseURL + "/customers/action/recover/id/:id", {id: "@id"});
        $api.customers.movelead = $resource(baseURL + "/customers/action/movelead/id/:id", {id: "@id"});
        $api.customers.leads_count = $resource(baseURL + "/customers/action/leads_count");
        $api.customers.tab_info = $resource(baseURL + "/customers/action/tab_info/tab/:tab/id/:id", {tab: "@tab", id: "@id"});
        $api.customers.request_card = $resource(baseURL + "/customers/action/request_card/id/:id", {id: "@id"});
        $api.customers.credit_cards = $resource(baseURL + "/customers/action/credit_cards/id/:id", {id: "@id"});
        $api.customers.request_card_iframe = $resource(baseURL + "/customercards/action/request/id/:id", {id: "@id"});

        /**
         * Customers coloring
         */
        $api.coloring = $resource(baseURL + "/coloring");
        $api.coloring.single = $resource(baseURL + "/coloring/id/:id", {id: "@id"});

        /**
         * Customers laser file
         */
        $api.laser_file = $resource(baseURL + "/laserFiles");

        /**
         * Customers bookings
         */
        $api.customers_bookings = $resource(baseURL + "/bookings");
        $api.customers_bookings.list = $resource(baseURL + "/bookings/action/list"); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.customers_bookings.waiting_list = $resource(baseURL + "/bookings/action/waiting_list");
        $api.customers_bookings.remove_waiting_list = $resource(baseURL + "/bookings/action/remove_waiting_list");
        $api.customers_bookings.find = $resource(baseURL + "/bookings/action/search/str/:str", {str: "@str"});


        /**
         * FB auth
         */
        $api.fb_auth = $resource(baseURL + "/FBAuth/authorize");

        /**
         * WA
         */
        $api.wa = $resource(baseURL + "/whatsapp");
        $api.wa.qr_code = $resource(baseURL + "/whatsapp/action/qr_code");
        $api.wa.status = $resource(baseURL + "/whatsapp/action/status");
        $api.wa.logout = $resource(baseURL + "/whatsapp/action/logout");

        /**
         * Resources
         */
        $api.resources = $resource(baseURL + "/resources");
        $api.resources.freeSlots = $resource(baseURL + "/resources/filter/free-slots/start_date/:start_date/end_date/:end_date/order_id/:order_id", {
            start_date: "@start_date",
            end_date: "@end_date",
            order_id: "@order_id"
        });
        $api.resources.single = $resource(baseURL + "/resources/id/:id", {id: "@id"});
        $api.resources.permissions = $resource(baseURL + "/resources/action/permissions/id/:id", {id: "@id"});
        $api.resources.capacity = $resource(baseURL + "/capacity/id/:id/date/:date/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.resources.capacity.single = $resource(baseURL + "/capacity/id/:id/date/:date/single/1/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.resources.capacity.all = $resource(baseURL + "/capacity/action/resources_with_capacity", {date: "@date"});

        /**
         * SecondResources
         */
        $api.second_resources = $resource(baseURL + "/secondresources");
        $api.second_resources.freeSlots = $resource(baseURL + "/secondresources/filter/free-slots/start_date/:start_date/end_date/:end_date/order_id/:order_id", {
            start_date: "@start_date",
            end_date: "@end_date",
            order_id: "@order_id"
        });
        $api.second_resources.single = $resource(baseURL + "/secondresources/id/:id", {id: "@id"});
        $api.second_resources.capacity = $resource(baseURL + "/capacity/second/1/id/:id/date/:date/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.second_resources.capacity.single = $resource(baseURL + "/capacity/second/1/id/:id/date/:date/single/1/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.second_resources.capacity.all = $resource(baseURL + "/capacity/second/true/action/resources_with_capacity", {date: "@date"});

        /**
         * Categories
         */
        $api.categories = $resource(baseURL + "/categories");
        $api.categories.single = $resource(baseURL + "/categories/id/:id", {id: "@id"});

        /**
         * Statuses
         */
        $api.statuses = $resource(baseURL + "/statuses");
        $api.statuses.single = $resource(baseURL + "/statuses/id/:id", {id: "@id"});


        /**
         * Interested in
         */
        $api.interested = $resource(baseURL + "/interested");
        $api.interested.single = $resource(baseURL + "/interested/id/:id", {id: "@id"});

        /**
         * Items
         */
        $api.items = $resource(baseURL + "/items");
        $api.items_list = $resource(baseURL + "/items?list=1");
        $api.items.single = $resource(baseURL + "/items/id/:id", {id: "@id"});
        $api.items.items_with_duration = $resource(baseURL + "/items/type/duration");
        $api.items.transactions = $resource(baseURL + "/items/action/get_transactions/item_id/:item_id", {item_id: "@item_id"});


        /**
         * Automations
         */
        $api.automations = $resource(baseURL + "/automations");
        $api.automations.recommendations = $resource(baseURL + "/automations/action/recommendations");
        $api.automations.recommendations.send = $resource(baseURL + "/automations/action/send/id/:id", {id: "@id"});
        $api.automations.recommendations.single = $resource(baseURL + "/automations/action/recommendations/id/:id", {id: "@id"});
        $api.automations.activations = $resource(baseURL + "/automations/action/activations/id/:id", {id: "@id"});
        $api.automations.single = $resource(baseURL + "/automations/id/:id", {id: "@id"});


        /**
         * Notes
         */
        $api.notes = $resource(baseURL + "/notes");
        $api.notes.single = $resource(baseURL + "/notes/id/:id", {id: "@id"});


        /**
         * Medical Notes
         */
        $api.medical_notes = $resource(baseURL + "/medicalnotes");
        $api.medical_notes.single = $resource(baseURL + "/medicalnotes/id/:id", {id: "@id"});
        $api.medical_notes.log = $resource(baseURL + "/medicalnotes/id/:id/action/log", {id: "@id"});

        /**
         * Files
         */
        $api.files = $resource(baseURL + "/files");
        $api.files.single = $resource(baseURL + "/files/id/:id", {id: "@id"});

        /**
         * Digital Forms
         */
        $api.digital_forms = $resource(baseURL + "/digitalforms");
        $api.digital_forms.send = $resource(baseURL + "/digitalforms/action/send");
        $api.digital_forms.single = $resource(baseURL + "/digitalforms/id/:id", {id: "@id"});
        $api.digital_forms.preview = $resource(baseURL + "/digitalforms/action/preview/id/:id", {id: "@id"});
        $api.digital_forms.templates_list = $resource(baseURL + "/digitalforms/action/templates_list");
        $api.digital_forms.update_last_time = $resource(baseURL + "/digitalforms/action/update_last_time");
        $api.digital_forms.unchecked = $resource(baseURL + "/digitalforms/action/unchecked");
        $api.digital_forms.all = $resource(baseURL + "/digitalforms/action/all");

        /**
         * Call Logs
         */
        $api.call_logs = $resource(baseURL + "/callLogs");

        /**
         * Sms Logs
         */
        $api.sms_logs = $resource(baseURL + "/sms");

        /**
         * Cards
         */
        $api.cards = $resource(baseURL + "/cards");
        $api.cards.single = $resource(baseURL + "/cards/id/:id", {id: "@id"});
        $api.cards.customers = $resource(baseURL + "/cards/action/get_cards/customer_id/:id", {id: "@id"});
        $api.cards.for_order = $resource(baseURL + "/cards/action/get_cards/order_id/:id", {id: "@id"});
        $api.cards.transactions = $resource(baseURL + "/cards/action/get_transactions/card_id/:card_id", {card_id: "@card_id"});


        /**
         * Business Messages
         */
        $api.b_messages = $resource(baseURL + "/messages");
        $api.b_messages.list = $resource(baseURL + "/messages/action/list");
        $api.b_messages.read = $resource(baseURL + "/messages/action/read/id/:id", {id: "@id"});
        $api.b_messages.remove = $resource(baseURL + "/messages/action/remove/id/:id", {id: "@id"});


        /**
         * Notifications
         */
        $api.notifications = {};
        $api.notifications.list = $resource(baseURL + "/notifications/action/list");
        $api.notifications.dashboard = $resource(baseURL + "/notifications/action/dashboard");
        $api.notifications.remove = $resource(baseURL + "/notifications/action/remove/id/:id", {id: "@id"});
        $api.notifications.removeAll = $resource(baseURL + "/notifications/action/removeAll/type/:type", {type: "@type"});

        /**
         * Users
         */
        $api.users = $resource(baseURL + "/users");
        $api.users.single = $resource(baseURL + "/users/id/:id", {id: "@id"});

        /**
         * User Devices
         */
        $api.userDevices = $resource(baseURL + "/userdevices");
        $api.userDevices.revoke = $resource(baseURL + "/userdevices/action/revoke");

        /**
         * Custom Fields
         */
        $api.customFields = $resource(baseURL + "/customfields");
        $api.customFields.single = $resource(baseURL + "/customfields/id/:id", {id: "@id"});
        $api.customFields.lists = $resource(baseURL + "/customfields/action/lists");
        $api.customFields.list = $resource(baseURL + "/customfields/action/single/id/:id", {id: "@id"});
        $api.customFields.value = {
            add: $resource(baseURL + "/customfields/action/valueAdd/id/:id/", {id: "@id"}),
            update: $resource(baseURL + "/customfields/action/valueUpdate/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            get: $resource(baseURL + "/customfields/action/valueGet/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            remove: $resource(baseURL + "/customfields/action/valueRemove/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
        };
        $api.customFields.all = $resource(baseURL + "/customfields/action/all");


        /**
         * Courses Fields
         */
        $api.coursesFields = $resource(baseURL + "/coursesfields");
        $api.coursesFields.single = $resource(baseURL + "/coursesfields/id/:id", {id: "@id"});
        $api.coursesFields.lists = $resource(baseURL + "/coursesfields/action/lists");
        $api.coursesFields.list = $resource(baseURL + "/coursesfields/action/single/id/:id", {id: "@id"});
        $api.coursesFields.value = {
            add: $resource(baseURL + "/coursesfields/action/valueAdd/id/:id/", {id: "@id"}),
            update: $resource(baseURL + "/coursesfields/action/valueUpdate/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            get: $resource(baseURL + "/coursesfields/action/valueGet/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            remove: $resource(baseURL + "/coursesfields/action/valueRemove/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
        };
        $api.coursesFields.all = $resource(baseURL + "/coursesfields/action/all");


        /**
         * Photos Stock
         */
        $api.photosStock = $resource(baseURL + "/photosstock", {}, {
            upload: {
                method: "POST",
                url: baseURL + "/photosstock/upload",
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
        });
        $api.photosStock.delete = $resource(baseURL + "/photosstock/id/:id", {id: "@id"});


        /**
         * Gift Card Templates
         */
        $api.giftCardTemplate = $resource(baseURL + "/giftcardtemplates");
        $api.giftCardTemplate.single = $resource(baseURL + "/giftcardtemplates/id/:id", {id: "@id"});


        /**
         * Gift Cards
         */
        $api.giftCard = $resource(baseURL + "/giftcards");
        $api.giftCard.single = $resource(baseURL + "/giftcards/id/:id", {id: "@id"});
        $api.giftCard.transactions = $resource(baseURL + "/giftcards/action/transactions");
        $api.giftCard.transactions.single = $resource(baseURL + "/giftcards/action/transactions/id/:id", {id: "@id"});
        $api.giftCard.balance = $resource(baseURL + "/giftcards/action/change_balance/id/:id", {id: "@id"});

        /**
         * Public Gift Cards
         */
        $api.publicGiftCard = $resource(baseURL + "/giftcardspublic");
        $api.publicGiftCard.single = $resource(baseURL + "/giftcardspublic/id/:id", {id: "@id"});

        /**
         * AI
         */
        $api.ai = $resource(baseURL + "/ai");
        $api.ai.customers = $resource(baseURL + "/ai/action/customers");
        $api.ai.feedback = $resource(baseURL + "/ai/action/feedback");
        $api.ai.history = $resource(baseURL + "/ai/action/history");
        $api.ai.speach_to_text = $resource(baseURL + "/ai/action/speach_to_text");


        /**
         * Find
         */
        $api.findEvents = $resource(baseURL + "/findEvents");

        /**
         * Workers
         */
        $api.workers = $resource(baseURL + "/employees");
        $api.workers.single = $resource(baseURL + "/employees/id/:id", {id: "@id"});
        $api.workers.recover = $resource(baseURL + "/employees/action/recover/id/:id", {id: "@id"});
        $api.workers.list = $resource(baseURL + "/employees/action/list"); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.workers.find = $resource(baseURL + "/employees/action/search/str/:str", {str: "@str"});
        $api.workers.employee_transactions = $resource(baseURL + "/employeeTransactions");
        $api.workers.employee_transactions.single = $resource(baseURL + "/employeeTransactions/password/:password/id/:id", {password: "@password",id: "@password"});
        /**
         * Workers Times
         */
        $api.employeeTransactions = $resource(baseURL + "/employeeTransactions");
        /**
         * SMS
         */
        $api.sms = $resource(baseURL + "/sms");

        /**
         * Dashboard
         */
        $api.dashboard = $resource(baseURL + "/dashboard");


        /**
         * Whatsapp
         */
        $api.whatsapp = $resource(baseURL + "/whatsapp");
        $api.whatsapp.avatar = $resource(baseURL + "/whatsapp/action/avatar");
        $api.whatsapp.wachat = $resource(baseURL + "/whatsapp/action/wachat/id/:id", {id: "@id"});

        /**
         * Transactions
         */
        $api.transactions = $resource(baseURL + "/transactions");
        $api.transactions.single = $resource(baseURL + "/transactions/id/:id", {id: "@id"});
        $api.transactions.pending = $resource(baseURL + "/transactions/action/pending");
        $api.transactions.retainers = $resource(baseURL + "/transactions/action/retainers");
        $api.transactions.retainer = $resource(baseURL + "/transactions/action/retainer/id/:id", {id: "@id"});
        $api.transactions.prepare = $resource(baseURL + "/transactions/action/prepare");
        $api.transactions.remove = $resource(baseURL + "/transactions/action/remove/id/:id", {id: "@id"});
        $api.transactions.remove_retainer = $resource(baseURL + "/transactions/action/remove_retainer/id/:id", {id: "@id"});
        $api.transactions.send_sms_invoice = $resource(baseURL + "/transactions/action/smsinvoice/id/:id", {id: "@id"});
        $api.transactions.resetzcredit = $resource(baseURL + "/transactions/action/resetzcredit");

        /**
         * ZCredit
         */
        $api.zcredit = $resource(baseURL + "/zcredit/amount/:amount/b_id/:b_id", {amount: "@amount", b_id: "@b_id"});

        /**
         * Analytics
         */
        $api.analytics = $resource(baseURL + "/analytics");

        /**
         * Settings
         */
        $api.settings = {};
        $api.settings.info = $resource(baseURL + "/settings/section/info");
        $api.settings.mass_customers = $resource(baseURL + "/settings/section/mass_customers");
        $api.settings.colors = $resource(baseURL + "/settings/section/colors");
        $api.settings.online = $resource(baseURL + "/settings/section/online");
        $api.settings.online.isAliasTaken = $resource(baseURL + "/settings/section/is_alias_taken");
        $api.settings.landing = $resource(baseURL + "/settings/section/landing");
        $api.settings.landing.isAliasTaken = $resource(baseURL + "/settings/section/is_landing_alias_taken");
        $api.settings.landing.edit_page = $resource(baseURL + "/settings/section/edit_page");
        $api.settings.messages = $resource(baseURL + "/settings/section/messages");
        $api.settings.bu_types = $resource(baseURL + "/settings/section/bu_types");
        $api.settings.clubs = $resource(baseURL + "/settings/section/clubs");
        $api.settings.documents = $resource(baseURL + "/settings/section/documents/lang/:lang", {lang: "@lang"});
        $api.settings.digital_documents = $resource(baseURL + "/DigitalDocuments");
        $api.settings.digital_documents.single = $resource(baseURL + "/DigitalDocuments/remove/id/:id", {id: "@id"});
        $api.settings.menuorder = $resource(baseURL + "/settings/section/menuorder");
        $api.settings.ai = $resource(baseURL + "/settings/section/ai");


        $api.settings.laser_file = $resource(baseURL + "/settings/section/laser_file");
        $api.settings.laser_file_field = $resource(baseURL + "/settings/section/laser_file_field");
        $api.settings.laser_file_field.single = $resource(baseURL + "/settings/section/laser_file_field/id/:id", {id: "@id"});


        /**
         * Social routes
         */
        $api.social = {};
        $api.social.customer = $resource(baseURL + "/social/action/customer/id/:id", {id: "@id"});
        $api.social.customer_post = $resource(baseURL + "/social/action/customer_post/id/:id", {id: "@id"});

        
        /**
         * Tax Files
         */
        $api.settings.tax_files = $resource(baseURL + "/settings/section/taxfiles");
        $api.settings.tax_files_check = $resource(baseURL + "/settings/section/taxfiles_check");
        $api.settings.lead_settings = $resource(baseURL + "/settings/section/lead_settings");
        


        $api.customer_documents = $resource(baseURL + "/CustomerDocuments/sign/id/:id", {id: "@id"});
        $api.customer_forms = $resource(baseURL + "/customerforms/id/:id", {id: "@id"});
        $api.customer_forms.new = $resource(baseURL + "/customerforms/action/new/id/:id", {id: "@id"});
        $api.customer_forms.pdf = $resource(baseURL + "/customerforms/action/pdf/id/:id", {id: "@id"});
        
        /**
         * Orders
         */
        $api.orders = $resource(baseURL + "/orders");
        $api.orders.calendar = $resource(baseURL + "/orders/date/:date/type/orders/range/:range", {date: "@date", range: "@range"});
        $api.orders.capcaity = $resource(baseURL + "/orders/date/:date/type/capacity", {date: "@date"});
        $api.orders.customer_history = $resource(baseURL + "/orders/type/history/filter-status/:filter_status/customer-id/:id", {id: '@id',filter_status: "@filter_status"});
        $api.orders.single = $resource(baseURL + "/orders/id/:id", {id: "@id"});
        $api.orders.copy = $resource(baseURL + "/orders/action/copy/id/:id", {id: "@id"});
        $api.orders.approval = $resource(baseURL + "/orders/action/approval/id/:id", {id: "@id"});
        $api.orders.request_approval = $resource(baseURL + "/orders/action/request_approval/order_id/:id", {id: "@order_id"});
        $api.orders.today_orders = $resource(baseURL + "/orders/action/today_orders");
        // $api.orders.send = $resource(baseURL + "/orders/action/:action/id/:id", {action: "@action",id: "@id"});

        /**
         * Events
         */
        $api.events = $resource(baseURL + "/events");
        $api.events.single = $resource(baseURL + "/events/id/:id/all/:all", {id: "@id", all: "@all"});
        $api.events.copy = $resource(baseURL + "/events/action/copy/id/:id/all/:all", {id: "@id", all: "@all"});
        $api.events.calendar = $resource(baseURL + "/events/date/:date/type/events/range/:range", {date: "@date", range: "@range"});


        /**
         * Courses
         */
        $api.courses = $resource(baseURL + "/courses");
        $api.courses.single = $resource(baseURL + "/courses/id/:id", {id: "@id"});
        $api.courses.calendar = $resource(baseURL + "/courses/date/:date/type/courses/range/:range", {date: "@date", range: "@range"});
        $api.courses.cashbox = $resource(baseURL + "/courses/action/cashbox/id/:id", {id: "@id"});


        /**
         * Filters
         */
        $api.filters = $resource(baseURL + "/filters");
        $api.filters.single = $resource(baseURL + "/filters/id/:id", {id: "@id"});

        /**
         * Reports
         */
        $api.reports = $resource(baseURL + "/reports");

        /**
         * Holidays
         */
        $api.holidays = $resource(baseURL + "/holidays/year/:year", {year: "@year"});

        /**
         * Messages
         */

        $api.messages  = $resource(baseURL + "/settings/messages");

        /**
         * Mailer
         */
        $api.mails =  $resource(baseURL + "/mails");

        /**
         * Admin
         */
        $api.businesses = $resource(baseURL + "/businesses");
        $api.businesses.types = $resource(baseURL + "/btypes");
        $api.businesses.variants = $resource(baseURL + "/variants");
        $api.businesses.single = $resource(baseURL + "/businesses/id/:id", {id: "@id"});
        $api.businesses.message = $resource(baseURL + "/businesses/action/message");
        $api.businesses.check_import = $resource(baseURL + "/businesses/action/check_import/id/:id", {id: "@id"});
        $api.businesses.change_all_vat = $resource(baseURL + "/businesses/action/change_all_vat");
        $api.businesses.resources = $resource(baseURL + "/businesses/action/resources/id/:id", {id: "@id"});

        $api.admin = {};
        $api.admin.settings = $resource(baseURL + "/admin/action/settings");

        /**
         * Logs
         */
        $api.logs = $resource(baseURL + "/admin/action/logs");


        // $api.orders.calendar = $resource(baseURL + "/orders/date/:date/type/orders/range/:range", {date: "@date", range: "@range"});
        // $api.orders.capcaity = $resource(baseURL + "/orders/date/:date/type/capacity", {date: "@date"});
        // $api.orders.single = $resource(baseURL + "/orders/id/:id", {id: "@id"});
        $api.showHideButton = false;
        $api.test = function (data) {
            $api.showHideButton = data;
        }

        /**
         * Approval
         */
        $api.approval = $resource(baseURL + "/approval/id/:id", {id: "@id"});

        /**
         * Calendar event
         */
        $api.calendar_event = $resource(baseURL + "/calendarev/id/:id", {id: "@id"});


        /**
         * Review
         */
        $api.review = $resource(baseURL + "/review/id/:id", {id: "@id"});

        /**
         * Prepaid
         */
        $api.prepaid = $resource(baseURL + "/prepaid/id/:id", {id: "@id"});

        /**
         * Pay
         */
        $api.pay = $resource(baseURL + "/prepaid/action/pay/id/:id", {id: "@id"});

        /**
         * Feedback sending
         */
        $api.feedback = $resource(baseURL + "/feedback");

        /**
         * Tutorials
         */
        $api.tutorials = {};
        $api.tutorials.playlist = $resource(baseURL + "/tutorials/action/playlist/playlist_id/:playlist_id", {playlist_id: "@playlist_id"});

        /**
         * Google Calendar
         */
        $api.googlecalendar = $resource(baseURL + "/googlecalendar");
        $api.googlecalendar.single = $resource(baseURL + "/googlecalendar/id/:id", {id: "@id"});
        $api.googlecalendar.active = $resource(baseURL + "/googlecalendar/action/active/id/:id", {id: "@id"});
        $api.googlecalendar.resources = $resource(baseURL + "/googlecalendar/action/resources/id/:id", {id: "@id"});
        $api.googlecalendar.token = $resource(baseURL + "/googlecalendar/action/token");

        /*
        *   Financial report
        */
        $api.financial = $resource(baseURL + "/financial/start/:start/end/:end");

        /**
         * apiResolver for async api calls
         * Used mostly for the states resolve parameters
         */
        var resolver = function(action, parameters) {

            var
                actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if (!resource || !method) {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if (!apiObject) {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else {
                apiObject[method](params,

                    // Success
                    function (response) {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response) {
                      if(response.status === 403) {
                        $state.go("login");
                      }
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        };

        /**
         * Determine the api resource object by the resource string
         * @param string Resource string
         * @returns api resource object
         */
        var getApiObject = function(resource) {

            // Split the resource in case if we have a dot notated object
            var
                resourceParts = resource.split('.'),
                apiObject = $api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for (var l = 0; l < resourceParts.length; l++) {
                if (angular.isUndefined(apiObject[resourceParts[l]])) {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if (!apiObject) {
                return false;
            }

            return apiObject;
        };

        $api.resolve = resolver;

        return $api;

    }).service("ResourceHeaders", function ($cookies) {

        this.request = function (config) {

            //var email = $cookies.get("email"), pass = $cookies.get("pass"), hash = $cookies.get("hash");
            // if(email !== ""){
            //     config.headers["API-Email"] = email;
            //     config.headers["API-Pass"] = pass;
            //     config.headers["API-Hash"] = hash;
            // }

            //new way with bearer token
            var token = $cookies.get("token");
            if (token !== "") {
                config.headers["Authorization"] = "Bearer " + token;
            }

            return config;
        };

    }).config(function ($httpProvider, $locationProvider) {
        $httpProvider.interceptors.push("ResourceHeaders");
        $locationProvider.html5Mode(true);
    });

})();

(function () {

    angular.module("app.providers").provider('modalState', function ($stateProvider){

        var provider = this;

        var modalResult;

        this.$get = function () {
            return provider;
        };

        this.state = function (stateName, options) {

            var modalInstance;

            $stateProvider.state(stateName, {

                url: options.url,

                onEnter: function ($uibModal, $state, $stateParams, $rootScope) {

                    options.windowTopClass = "form-modal";

                    if(options.smallModal){
                        options.windowTopClass += " small-modal";
                    }

                    if(options.mediumModal){
                        options.windowTopClass += " medium-modal";
                    }

                    options.backdrop = "static";
                    options.keyboard = false;

                    $rootScope.$stateParams = $stateParams;

                    modalInstance = $uibModal.open(options);

                    modalInstance.result.then(function (result) {
                        modalResult = result;
                    }).finally(function(){
                        if (modalResult){
                            $state.get('^').modalResult = modalResult;
                        }
                        modalInstance = modalResult = null;
                        if ($state.$current.name === stateName){
                            $state.go('^');
                        }
                    });
                },
                onExit: function(){
                    if(modalInstance){
                        modalInstance.close();
                    }
                }
            });
            return provider;
        };
    });

})();
(function (){
    angular.module("app.providers").provider("dates", function(){

        var provider = this, currentYear = new Date().getFullYear();

        this.$get = function () {
            return provider;
        };

        this.days = [];

        for(var i = 1; i <= 31; i++){
            this.days.push(i);
        }

        this.months = [
            "ינואר",
            "פברואר",
            "מרץ",
            "אפריל",
            "מאי",
            "יוני",
            "יולי",
            "אוגוסט",
            "ספטמבר",
            "אוקטובר",
            "נובמבר",
            "דצמבר"
        ];

        this.years = [];

        for(var i = currentYear; i >= 1900; i--){
            this.years.push(i);
        }

        this.daysNames = [
            "ראשון",
            "שני",
            "שלישי",
            "רביעי",
            "חמישי",
            "שישי",
            "שבת"
        ];

        this.hours = [];
        for(var h = 0, m = 0; h != 23 || m != 60; m += 5){
            if(m == 60) {
                m = 0;
                h++;
            }

            this.hours.push((h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m));
        }

        this.duration = [];

        var minutesLabel, hoursLabel;

        for(var h = 0, m = 5; h <= 10 && m < 60; m+= 5){
            minutesLabel = "";
            hoursLabel = "";
            if(m > 0){
                minutesLabel = m + " דקות";
            }

            if(h == 1){
                hoursLabel = "שעה";
            }else if(h == 2){
                hoursLabel = "שעתיים";
            }else if(h > 2){
                hoursLabel = h + " שעות";
            }

            if(minutesLabel != "" && hoursLabel != ""){
                hoursLabel = hoursLabel + " ו-";
            }

            this.duration.push({
                duration: (h * 60) + m,
                label: hoursLabel + minutesLabel 
            });

            if(m == 55){
                m = -5;
                h++;
            }
        }
    });
})();
(function () {

    angular.module("app.providers").value("dataTablesHebrewProvider", {
        "processing": "מעבד...",
        "lengthMenu": "הצג _MENU_ פריטים",
        "zeroRecords": "לא נמצאו רשומות מתאימות",
        "emptyTable": "לא נמצאו רשומות מתאימות",
        "info": "_START_ עד _END_ מתוך _TOTAL_ רשומות",
        "infoEmpty": "0 עד 0 מתוך 0 רשומות",
        "infoFiltered": "(מסונן מסך _MAX_  רשומות)",
        "infoPostFix": "",
        "search": "",
        "searchPlaceholder": "חפש...",
        "url": "",
        "paginate": {
            "first": "ראשון",
            "previous": "קודם",
            "next": "הבא",
            "last": "אחרון"
        }
    });

})();
/*
*  AngularJs Fullcalendar Wrapper for the JQuery FullCalendar
*  API @ http://arshaw.com/fullcalendar/
*
*  Angular Calendar Directive that takes in the [eventSources] nested array object as the ng-model and watches it deeply changes.
*       Can also take in multiple event urls as a source object(s) and feed the events per view.
*       The calendar will watch any eventSource array and update itself when a change is made.
*
*/
angular.module('ui.calendar', [])

    .constant('uiCalendarConfig', {
        calendars : {}
    })
    .controller('uiCalendarCtrl', ['$scope', '$locale',
        function ($scope, $locale) {

            var sources = $scope.eventSources;
            var extraEventSignature = $scope.calendarWatchEvent ? $scope.calendarWatchEvent : angular.noop;

            var wrapFunctionWithScopeApply = function (functionToWrap) {
                return function () {
                    // This may happen outside of angular context, so create one if outside.
                    if ($scope.$root.$$phase) {
                        return functionToWrap.apply(this, arguments);
                    }

                    var args = arguments;
                    var that = this;
                    return $scope.$root.$apply(
                        function () {
                            return functionToWrap.apply(that, args);
                        }
                    );
                };
            };

            var eventSerialId = 1;
            // @return {String} fingerprint of the event object and its properties
            this.eventFingerprint = function (e) {
                if (!e._id) {
                    e._id = eventSerialId++;
                }

                var extraSignature = extraEventSignature({
                    event : e
                }) || '';
                var start = moment.isMoment(e.start) ? e.start.unix() : (e.start ? moment(e.start).unix() : '');
                var end = moment.isMoment(e.end) ? e.end.unix() : (e.end ? moment(e.end).unix() : '');

                // This extracts all the information we need from the event. http://jsperf.com/angular-calendar-events-fingerprint/3
                return [e._id, e.id || '', e.title || '', e.url || '', start, end, e.allDay || '', e.className || '', extraSignature].join('');
            };

            var sourceSerialId = 1;
            var sourceEventsSerialId = 1;
            // @return {String} fingerprint of the source object and its events array
            this.sourceFingerprint = function (source) {
                var fp = '' + (source.__id || (source.__id = sourceSerialId++));
                var events = angular.isObject(source) && source.events;

                if (events) {
                    fp = fp + '-' + (events.__id || (events.__id = sourceEventsSerialId++));
                }
                return fp;
            };

            // @return {Array} all events from all sources
            this.allEvents = function () {
                return Array.prototype.concat.apply(
                    [],
                    (sources || []).reduce(
                        function (previous, source) {
                            if (angular.isArray(source)) {
                                previous.push(source);
                            } else if (angular.isObject(source) && angular.isArray(source.events)) {
                                var extEvent = Object.keys(source).filter(
                                    function (key) {
                                        return (key !== '_id' && key !== 'events');
                                    }
                                );

                                source.events.forEach(
                                    function (event) {
                                        angular.extend(event, extEvent);
                                    }
                                );

                                previous.push(source.events);
                            }
                            return previous;
                        },
                        []
                    )
                );
            };

            // Track changes in array of objects by assigning id tokens to each element and watching the scope for changes in the tokens
            // @param {Array|Function} arraySource array of objects to watch
            // @param tokenFn {Function} that returns the token for a given object
            // @return {Object}
            //  subscribe: function(scope, function(newTokens, oldTokens))
            //    called when source has changed. return false to prevent individual callbacks from firing
            //  onAdded/Removed/Changed:
            //    when set to a callback, called each item where a respective change is detected
            this.changeWatcher = function (arraySource, tokenFn) {
                var self;

                var getTokens = function () {
                    return ((angular.isFunction(arraySource) ? arraySource() : arraySource) || []).reduce(
                        function (rslt, el) {
                            var token = tokenFn(el);
                            map[token] = el;
                            rslt.push(token);
                            return rslt;
                        },
                        []
                    );
                };

                // @param {Array} a
                // @param {Array} b
                // @return {Array} elements in that are in a but not in b
                // @example
                //  subtractAsSets([6, 100, 4, 5], [4, 5, 7]) // [6, 100]
                var subtractAsSets = function (a, b) {
                    var obj = (b || []).reduce(
                        function (rslt, val) {
                            rslt[val] = true;
                            return rslt;
                        },
                        Object.create(null)
                    );
                    return (a || []).filter(
                        function (val) {
                            return !obj[val];
                        }
                    );
                };

                // Map objects to tokens and vice-versa
                var map = {};

                // Compare newTokens to oldTokens and call onAdded, onRemoved, and onChanged handlers for each affected event respectively.
                var applyChanges = function (newTokens, oldTokens) {
                    var i;
                    var token;
                    var replacedTokens = {};
                    var removedTokens = subtractAsSets(oldTokens, newTokens);
                    for (i = 0; i < removedTokens.length; i++) {
                        var removedToken = removedTokens[i];
                        var el = map[removedToken];
                        delete map[removedToken];
                        var newToken = tokenFn(el);
                        // if the element wasn't removed but simply got a new token, its old token will be different from the current one
                        if (newToken === removedToken) {
                            self.onRemoved(el);
                        } else {
                            replacedTokens[newToken] = removedToken;
                            self.onChanged(el);
                        }
                    }

                    var addedTokens = subtractAsSets(newTokens, oldTokens);
                    for (i = 0; i < addedTokens.length; i++) {
                        token = addedTokens[i];
                        if (!replacedTokens[token]) {
                            self.onAdded(map[token]);
                        }
                    }
                };

                self = {
                    subscribe : function (scope, onArrayChanged) {
                        scope.$watch(getTokens, function (newTokens, oldTokens) {
                            var notify = !(onArrayChanged && onArrayChanged(newTokens, oldTokens) === false);
                            if (notify) {
                                applyChanges(newTokens, oldTokens);
                            }
                        }, true);
                    },
                    onAdded : angular.noop,
                    onChanged : angular.noop,
                    onRemoved : angular.noop
                };
                return self;
            };

            this.getFullCalendarConfig = function (calendarSettings, uiCalendarConfig) {
                var config = {};

                angular.extend(config, uiCalendarConfig);
                angular.extend(config, calendarSettings);

                angular.forEach(config, function (value, key) {
                    if (typeof value === 'function') {
                        config[key] = wrapFunctionWithScopeApply(config[key]);
                    }
                });

                return config;
            };

            this.getLocaleConfig = function (fullCalendarConfig) {
                if (!fullCalendarConfig.lang && !fullCalendarConfig.locale || fullCalendarConfig.useNgLocale) {
                    // Configure to use locale names by default
                    var tValues = function (data) {
                        // convert {0: "Jan", 1: "Feb", ...} to ["Jan", "Feb", ...]
                        return (Object.keys(data) || []).reduce(
                            function (rslt, el) {
                                rslt.push(data[el]);
                                return rslt;
                            },
                            []
                        );
                    };

                    var dtf = $locale.DATETIME_FORMATS;
                    return {
                        monthNames : tValues(dtf.MONTH),
                        monthNamesShort : tValues(dtf.SHORTMONTH),
                        dayNames : tValues(dtf.DAY),
                        dayNamesShort : tValues(dtf.SHORTDAY)
                    };
                }

                return {};
            };
        }
    ])
    .directive('uiCalendar', ['uiCalendarConfig',
        function (uiCalendarConfig) {

            return {
                restrict : 'A',
                scope : {
                    eventSources : '=ngModel',
                    calendarWatchEvent : '&'
                },
                controller : 'uiCalendarCtrl',
                link : function (scope, elm, attrs, controller) {
                    var sources = scope.eventSources;
                    var sourcesChanged = false;
                    var calendar;
                    var eventSourcesWatcher = controller.changeWatcher(sources, controller.sourceFingerprint);
                    var eventsWatcher = controller.changeWatcher(controller.allEvents, controller.eventFingerprint);
                    var options = null;

                    function getOptions () {
                        var calendarSettings = attrs.uiCalendar ? scope.$parent.$eval(attrs.uiCalendar) : {};
                        var fullCalendarConfig = controller.getFullCalendarConfig(calendarSettings, uiCalendarConfig);
                        var localeFullCalendarConfig = controller.getLocaleConfig(fullCalendarConfig);
                        angular.extend(localeFullCalendarConfig, fullCalendarConfig);
                        options = {
                            eventSources : sources
                        };
                        angular.extend(options, localeFullCalendarConfig);
                        //remove calendars from options
                        options.calendars = null;

                        var options2 = {};
                        for (var o in options) {
                            if (o !== 'eventSources') {
                                options2[o] = options[o];
                            }
                        }
                        return JSON.stringify(options2);
                    }

                    scope.destroyCalendar = function () {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('destroy');
                        }
                        if (attrs.calendar) {
                            calendar = uiCalendarConfig.calendars[attrs.calendar] = angular.element(elm).html('');
                        } else {
                            calendar = angular.element(elm).html('');
                        }
                    };

                    scope.initCalendar = function () {
                        if (!calendar) {
                            calendar = $(elm).html('');
                        }
                        calendar.fullCalendar(options);
                        if (attrs.calendar) {
                            uiCalendarConfig.calendars[attrs.calendar] = calendar;
                        }
                    };

                    scope.$on('$destroy', function () {
                        scope.destroyCalendar();
                    });

                    eventSourcesWatcher.onAdded = function (source) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar(options);
                            if (attrs.calendar) {
                                uiCalendarConfig.calendars[attrs.calendar] = calendar;
                            }
                            calendar.fullCalendar('addEventSource', source);
                            sourcesChanged = true;
                        }
                    };

                    eventSourcesWatcher.onRemoved = function (source) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('removeEventSource', source);
                            sourcesChanged = true;
                        }
                    };

                    eventSourcesWatcher.onChanged = function () {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('refetchEvents');
                            sourcesChanged = true;
                        }
                    };

                    eventsWatcher.onAdded = function (event) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('renderEvent', event, !!event.stick);
                        }
                    };

                    eventsWatcher.onRemoved = function (event) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('removeEvents', event._id);
                        }
                    };

                    eventsWatcher.onChanged = function (event) {
                        if (calendar && calendar.fullCalendar) {
                            var clientEvents = calendar.fullCalendar('clientEvents', event._id);
                            for (var i = 0; i < clientEvents.length; i++) {
                                var clientEvent = clientEvents[i];
                                clientEvent = angular.extend(clientEvent, event);
                                calendar.fullCalendar('updateEvent', clientEvent);
                            }
                        }
                    };

                    eventSourcesWatcher.subscribe(scope);
                    eventsWatcher.subscribe(scope, function () {
                        if (sourcesChanged === true) {
                            sourcesChanged = false;
                            // return false to prevent onAdded/Removed/Changed handlers from firing in this case
                            return false;
                        }
                    });

                    scope.$watch(getOptions, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            
                            newValue = JSON.parse(newValue);
                            oldValue = JSON.parse(oldValue);

                            if(newValue.defaultView != oldValue.defaultView)
                                calendar.fullCalendar("changeView", newValue.defaultView);
                                
                        } else if ((newValue && angular.isUndefined(calendar))) {
                            scope.initCalendar();
                        }
                    });
                }
            };
        }
    ]
);
!function(e,a){"object"==typeof exports&&"object"==typeof module?module.exports=a(require("moment"),require("fullcalendar")):"function"==typeof define&&define.amd?define(["moment","fullcalendar"],a):"object"==typeof exports?a(require("moment"),require("fullcalendar")):a(e.moment,e.FullCalendar)}("undefined"!=typeof self?self:this,function(e,a){return function(e){function a(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,a),r.l=!0,r.exports}var t={};return a.m=e,a.c=t,a.d=function(e,t,n){a.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,a){return Object.prototype.hasOwnProperty.call(e,a)},a.p="",a(a.s=434)}([function(a,t){a.exports=e},function(e,t){e.exports=a},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(66);var n=t(1);n.datepickerLocale("af","af",{closeText:"Selekteer",prevText:"Vorige",nextText:"Volgende",currentText:"Vandag",monthNames:["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],monthNamesShort:["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],dayNames:["Sondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrydag","Saterdag"],dayNamesShort:["Son","Maa","Din","Woe","Don","Vry","Sat"],dayNamesMin:["So","Ma","Di","Wo","Do","Vr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("af",{buttonText:{year:"Jaar",month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayHtml:"Heeldag",eventLimitText:"Addisionele",noEventsMessage:"Daar is geen gebeurtenisse nie"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"vm":"VM":t?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[Môre om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(68);var n=t(1);n.datepickerLocale("ar-dz","ar-DZ",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["جانفي","فيفري","مارس","أفريل","ماي","جوان","جويلية","أوت","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-dz",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-dz",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"أح_إث_ثلا_أر_خم_جم_سب".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(70);var n=t(1);n.datepickerLocale("ar-kw","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-kw",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-kw",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(72);var n=t(1);n.datepickerLocale("ar-ly","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-ly",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},t=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},n={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},r=function(e){return function(a,r,s,d){var i=t(a),o=n[e][t(a)];return 2===i&&(o=o[r?0:1]),o.replace(/%d/i,a)}},s=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];return e.defineLocale("ar-ly",{months:s,monthsShort:s,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:r("s"),ss:r("s"),m:r("m"),mm:r("m"),h:r("h"),hh:r("h"),d:r("d"),dd:r("d"),M:r("M"),MM:r("M"),y:r("y"),yy:r("y")},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(74);var n=t(1);n.datepickerLocale("ar-ma","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-ma",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(76);var n=t(1);n.datepickerLocale("ar-sa","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-sa",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},t={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"};return e.defineLocale("ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:0,doy:6}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(78);var n=t(1);n.datepickerLocale("ar-tn","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-tn",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(80);var n=t(1);n.datepickerLocale("ar","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},t={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},n=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},r={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},s=function(e){return function(a,t,s,d){var i=n(a),o=r[e][n(a)];return 2===i&&(o=o[t?0:1]),o.replace(/%d/i,a)}},d=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];return e.defineLocale("ar",{months:d,monthsShort:d,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:s("s"),ss:s("s"),m:s("m"),mm:s("m"),h:s("h"),hh:s("h"),d:s("d"),dd:s("d"),M:s("M"),MM:s("M"),y:s("y"),yy:s("y")},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(82);var n=t(1);n.datepickerLocale("bg","bg",{closeText:"затвори",prevText:"&#x3C;назад",nextText:"напред&#x3E;",nextBigText:"&#x3E;&#x3E;",currentText:"днес",monthNames:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Яну","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Нов","Дек"],dayNames:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"],dayNamesShort:["Нед","Пон","Вто","Сря","Чет","Пет","Съб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Съ"],weekHeader:"Wk",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("bg",{buttonText:{month:"Месец",week:"Седмица",day:"Ден",list:"График"},allDayText:"Цял ден",eventLimitText:function(e){return"+още "+e},noEventsMessage:"Няма събития за показване"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[В изминалата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[В изминалия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",ss:"%d секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дни",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-ев":0===t?e+"-ен":t>10&&t<20?e+"-ти":1===a?e+"-ви":2===a?e+"-ри":7===a||8===a?e+"-ми":e+"-ти"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(84);var n=t(1);n.datepickerLocale("bs","bs",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Januar","Februar","Mart","April","Maj","Juni","Juli","August","Septembar","Oktobar","Novmbar","Decembar"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNames:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Sed",dateFormat:"dd.mm.yy.",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("bs",{buttonText:{prev:"Prošli",next:"Sljedeći",month:"Mjesec",week:"Sedmica",day:"Dan",list:"Raspored"},allDayText:"Cijeli dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nema događaja za prikazivanje"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){var n=e+" ";switch(t){case"ss":return n+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return n+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return n+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return n+=1===e?"dan":"dana";case"MM":return n+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return n+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}return e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:a,m:a,mm:a,h:a,hh:a,d:"dan",dd:a,M:"mjesec",MM:a,y:"godinu",yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(86);var n=t(1);n.datepickerLocale("ca","ca",{closeText:"Tanca",prevText:"Anterior",nextText:"Següent",currentText:"Avui",monthNames:["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre"],monthNamesShort:["gen","feb","març","abr","maig","juny","jul","ag","set","oct","nov","des"],dayNames:["diumenge","dilluns","dimarts","dimecres","dijous","divendres","dissabte"],dayNamesShort:["dg","dl","dt","dc","dj","dv","ds"],dayNamesMin:["dg","dl","dt","dc","dj","dv","ds"],weekHeader:"Set",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ca",{buttonText:{month:"Mes",week:"Setmana",day:"Dia",list:"Agenda"},allDayText:"Tot el dia",eventLimitText:"més",noEventsMessage:"No hi ha esdeveniments per mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ca",{months:{standalone:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,a){var t=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return"w"!==a&&"W"!==a||(t="a"),e+t},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(88);var n=t(1);n.datepickerLocale("cs","cs",{closeText:"Zavřít",prevText:"&#x3C;Dříve",nextText:"Později&#x3E;",currentText:"Nyní",monthNames:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],monthNamesShort:["led","úno","bře","dub","kvě","čer","čvc","srp","zář","říj","lis","pro"],dayNames:["neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota"],dayNamesShort:["ne","po","út","st","čt","pá","so"],dayNamesMin:["ne","po","út","st","čt","pá","so"],weekHeader:"Týd",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("cs",{buttonText:{month:"Měsíc",week:"Týden",day:"Den",list:"Agenda"},allDayText:"Celý den",eventLimitText:function(e){return"+další: "+e},noEventsMessage:"Žádné akce k zobrazení"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e>1&&e<5&&1!=~~(e/10)}function t(e,t,n,r){var s=e+" ";switch(n){case"s":return t||r?"pár sekund":"pár sekundami";case"ss":return t||r?s+(a(e)?"sekundy":"sekund"):s+"sekundami";case"m":return t?"minuta":r?"minutu":"minutou";case"mm":return t||r?s+(a(e)?"minuty":"minut"):s+"minutami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?s+(a(e)?"hodiny":"hodin"):s+"hodinami";case"d":return t||r?"den":"dnem";case"dd":return t||r?s+(a(e)?"dny":"dní"):s+"dny";case"M":return t||r?"měsíc":"měsícem";case"MM":return t||r?s+(a(e)?"měsíce":"měsíců"):s+"měsíci";case"y":return t||r?"rok":"rokem";case"yy":return t||r?s+(a(e)?"roky":"let"):s+"lety"}}var n="leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),r="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_");return e.defineLocale("cs",{months:n,monthsShort:r,monthsParse:function(e,a){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp("^"+e[t]+"$|^"+a[t]+"$","i");return n}(n,r),shortMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(r),longMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(n),weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(90);var n=t(1);n.datepickerLocale("da","da",{closeText:"Luk",prevText:"&#x3C;Forrige",nextText:"Næste&#x3E;",currentText:"Idag",monthNames:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNames:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],dayNamesShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayNamesMin:["Sø","Ma","Ti","On","To","Fr","Lø"],weekHeader:"Uge",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("da",{buttonText:{month:"Måned",week:"Uge",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"flere",noEventsMessage:"Ingen arrangementer at vise"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"på dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(92);var n=t(1);n.datepickerLocale("de-at","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("de-at",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}return e.defineLocale("de-at",{
months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(94);var n=t(1);n.datepickerLocale("de-ch","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("de-ch",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}return e.defineLocale("de-ch",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(96);var n=t(1);n.datepickerLocale("de","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("de",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}return e.defineLocale("de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(98);var n=t(1);n.datepickerLocale("el","el",{closeText:"Κλείσιμο",prevText:"Προηγούμενος",nextText:"Επόμενος",currentText:"Σήμερα",monthNames:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],monthNamesShort:["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],dayNames:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"],dayNamesShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],dayNamesMin:["Κυ","Δε","Τρ","Τε","Πε","Πα","Σα"],weekHeader:"Εβδ",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("el",{buttonText:{month:"Μήνας",week:"Εβδομάδα",day:"Ημέρα",list:"Ατζέντα"},allDayText:"Ολοήμερο",eventLimitText:"περισσότερα",noEventsMessage:"Δεν υπάρχουν γεγονότα για να εμφανιστεί"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}return e.defineLocale("el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(e,a){return e?"string"==typeof a&&/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(e,a,t){return e>11?t?"μμ":"ΜΜ":t?"πμ":"ΠΜ"},isPM:function(e){return"μ"===(e+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[το προηγούμενο] dddd [{}] LT";default:return"[την προηγούμενη] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,t){var n=this._calendarEl[e],r=t&&t.hours();return a(n)&&(n=n.apply(t)),n.replace("{}",r%12==1?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",ss:"%d δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},dayOfMonthOrdinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(100);var n=t(1);n.datepickerLocale("en-au","en-AU",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("en-au")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(102),t(1).locale("en-ca")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(104);var n=t(1);n.datepickerLocale("en-gb","en-GB",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("en-gb")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(106),t(1).locale("en-ie")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(108);var n=t(1);n.datepickerLocale("en-nz","en-NZ",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("en-nz")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(110);var n=t(1);n.datepickerLocale("es-do","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("es-do",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],r=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;return e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(112);var n=t(1);n.datepickerLocale("es-us","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("es-us",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_");return e.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsParseExact:!0,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"MMMM [de] D [de] YYYY",LLL:"MMMM [de] D [de] YYYY h:mm A",LLLL:"dddd, MMMM [de] D [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:0,doy:6}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(114);var n=t(1);n.datepickerLocale("es","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("es",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],r=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;return e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(116);var n=t(1);n.datepickerLocale("et","et",{closeText:"Sulge",prevText:"Eelnev",nextText:"Järgnev",currentText:"Täna",monthNames:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],monthNamesShort:["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],dayNames:["Pühapäev","Esmaspäev","Teisipäev","Kolmapäev","Neljapäev","Reede","Laupäev"],dayNamesShort:["Pühap","Esmasp","Teisip","Kolmap","Neljap","Reede","Laup"],dayNamesMin:["P","E","T","K","N","R","L"],weekHeader:"näd",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("et",{buttonText:{month:"Kuu",week:"Nädal",day:"Päev",list:"Päevakord"},allDayText:"Kogu päev",eventLimitText:function(e){return"+ veel "+e},noEventsMessage:"Kuvamiseks puuduvad sündmused"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={s:["mõne sekundi","mõni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["ühe minuti","üks minut"],mm:[e+" minuti",e+" minutit"],h:["ühe tunni","tund aega","üks tund"],hh:[e+" tunni",e+" tundi"],d:["ühe päeva","üks päev"],M:["kuu aja","kuu aega","üks kuu"],MM:[e+" kuu",e+" kuud"],y:["ühe aasta","aasta","üks aasta"],yy:[e+" aasta",e+" aastat"]};return a?r[t][2]?r[t][2]:r[t][1]:n?r[t][0]:r[t][1]}return e.defineLocale("et",{months:"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[Täna,] LT",nextDay:"[Homme,] LT",nextWeek:"[Järgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s pärast",past:"%s tagasi",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:"%d päeva",M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(118);var n=t(1);n.datepickerLocale("eu","eu",{closeText:"Egina",prevText:"&#x3C;Aur",nextText:"Hur&#x3E;",currentText:"Gaur",monthNames:["urtarrila","otsaila","martxoa","apirila","maiatza","ekaina","uztaila","abuztua","iraila","urria","azaroa","abendua"],monthNamesShort:["urt.","ots.","mar.","api.","mai.","eka.","uzt.","abu.","ira.","urr.","aza.","abe."],dayNames:["igandea","astelehena","asteartea","asteazkena","osteguna","ostirala","larunbata"],dayNamesShort:["ig.","al.","ar.","az.","og.","ol.","lr."],dayNamesMin:["ig","al","ar","az","og","ol","lr"],weekHeader:"As",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("eu",{buttonText:{month:"Hilabetea",week:"Astea",day:"Eguna",list:"Agenda"},allDayHtml:"Egun<br/>osoa",eventLimitText:"gehiago",noEventsMessage:"Ez dago ekitaldirik erakusteko"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(120);var n=t(1);n.datepickerLocale("fa","fa",{closeText:"بستن",prevText:"&#x3C;قبلی",nextText:"بعدی&#x3E;",currentText:"امروز",monthNames:["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["يکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"],dayNamesShort:["ی","د","س","چ","پ","ج","ش"],dayNamesMin:["ی","د","س","چ","پ","ج","ش"],weekHeader:"هف",dateFormat:"yy/mm/dd",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fa",{buttonText:{month:"ماه",week:"هفته",day:"روز",list:"برنامه"},allDayText:"تمام روز",eventLimitText:function(e){return"بیش از "+e},noEventsMessage:"هیچ رویدادی به نمایش"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},t={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"};return e.defineLocale("fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,a,t){return e<12?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چند ثانیه",ss:"ثانیه d%",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},dayOfMonthOrdinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(122);var n=t(1);n.datepickerLocale("fi","fi",{closeText:"Sulje",prevText:"&#xAB;Edellinen",nextText:"Seuraava&#xBB;",currentText:"Tänään",monthNames:["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kesäkuu","Heinäkuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"],monthNamesShort:["Tammi","Helmi","Maalis","Huhti","Touko","Kesä","Heinä","Elo","Syys","Loka","Marras","Joulu"],dayNamesShort:["Su","Ma","Ti","Ke","To","Pe","La"],dayNames:["Sunnuntai","Maanantai","Tiistai","Keskiviikko","Torstai","Perjantai","Lauantai"],dayNamesMin:["Su","Ma","Ti","Ke","To","Pe","La"],weekHeader:"Vk",dateFormat:"d.m.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fi",{buttonText:{month:"Kuukausi",week:"Viikko",day:"Päivä",list:"Tapahtumat"},allDayText:"Koko päivä",eventLimitText:"lisää",noEventsMessage:"Ei näytettäviä tapahtumia"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,n,r){var s="";switch(n){
case"s":return r?"muutaman sekunnin":"muutama sekunti";case"ss":return r?"sekunnin":"sekuntia";case"m":return r?"minuutin":"minuutti";case"mm":s=r?"minuutin":"minuuttia";break;case"h":return r?"tunnin":"tunti";case"hh":s=r?"tunnin":"tuntia";break;case"d":return r?"päivän":"päivä";case"dd":s=r?"päivän":"päivää";break;case"M":return r?"kuukauden":"kuukausi";case"MM":s=r?"kuukauden":"kuukautta";break;case"y":return r?"vuoden":"vuosi";case"yy":s=r?"vuoden":"vuotta"}return s=t(e,r)+" "+s}function t(e,a){return e<10?a?r[e]:n[e]:e}var n="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),r=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",n[7],n[8],n[9]];return e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(124);var n=t(1);n.datepickerLocale("fr-ca","fr-CA",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"yy-mm-dd",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fr-ca",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(126);var n=t(1);n.datepickerLocale("fr-ch","fr-CH",{closeText:"Fermer",prevText:"&#x3C;Préc",nextText:"Suiv&#x3E;",currentText:"Courant",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sm",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fr-ch",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("fr-ch",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(128);var n=t(1);n.datepickerLocale("fr","fr",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fr",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(130);var n=t(1);n.datepickerLocale("gl","gl",{closeText:"Pechar",prevText:"&#x3C;Ant",nextText:"Seg&#x3E;",currentText:"Hoxe",monthNames:["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],monthNamesShort:["Xan","Feb","Mar","Abr","Mai","Xuñ","Xul","Ago","Set","Out","Nov","Dec"],dayNames:["Domingo","Luns","Martes","Mércores","Xoves","Venres","Sábado"],dayNamesShort:["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"],dayNamesMin:["Do","Lu","Ma","Mé","Xo","Ve","Sá"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("gl",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Axenda"},allDayHtml:"Todo<br/>o día",eventLimitText:"máis",noEventsMessage:"Non hai eventos para amosar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),weekdaysShort:"dom._lun._mar._mér._xov._ven._sáb.".split("_"),weekdaysMin:"do_lu_ma_mé_xo_ve_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"ás":"á")+"] LT"},nextDay:function(){return"[mañá "+(1!==this.hours()?"ás":"á")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"ás":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"á":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"ás":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(132);var n=t(1);n.datepickerLocale("he","he",{closeText:"סגור",prevText:"&#x3C;הקודם",nextText:"הבא&#x3E;",currentText:"היום",monthNames:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],monthNamesShort:["ינו","פבר","מרץ","אפר","מאי","יוני","יולי","אוג","ספט","אוק","נוב","דצמ"],dayNames:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת"],dayNamesShort:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],dayNamesMin:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("he",{buttonText:{month:"חודש",week:"שבוע",day:"יום",list:"סדר יום"},allDayText:"כל היום",eventLimitText:"אחר",noEventsMessage:"אין אירועים להצגה",weekNumberTitle:"שבוע"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY HH:mm",LLLL:"dddd, D [ב]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",ss:"%d שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(e){return 2===e?"שעתיים":e+" שעות"},d:"יום",dd:function(e){return 2===e?"יומיים":e+" ימים"},M:"חודש",MM:function(e){return 2===e?"חודשיים":e+" חודשים"},y:"שנה",yy:function(e){return 2===e?"שנתיים":e%10==0&&10!==e?e+" שנה":e+" שנים"}},meridiemParse:/אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,a,t){return e<5?"לפנות בוקר":e<10?"בבוקר":e<12?t?'לפנה"צ':"לפני הצהריים":e<18?t?'אחה"צ':"אחרי הצהריים":"בערב"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(134);var n=t(1);n.datepickerLocale("hi","hi",{closeText:"बंद",prevText:"पिछला",nextText:"अगला",currentText:"आज",monthNames:["जनवरी ","फरवरी","मार्च","अप्रेल","मई","जून","जूलाई","अगस्त ","सितम्बर","अक्टूबर","नवम्बर","दिसम्बर"],monthNamesShort:["जन","फर","मार्च","अप्रेल","मई","जून","जूलाई","अग","सित","अक्ट","नव","दि"],dayNames:["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],dayNamesShort:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],dayNamesMin:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],weekHeader:"हफ्ता",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("hi",{buttonText:{month:"महीना",week:"सप्ताह",day:"दिन",list:"कार्यसूची"},allDayText:"सभी दिन",eventLimitText:function(e){return"+अधिक "+e},noEventsMessage:"कोई घटनाओं को प्रदर्शित करने के लिए"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},t={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};return e.defineLocale("hi",{months:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm बजे",LLLL:"dddd, D MMMM YYYY, A h:mm बजे"},calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",ss:"%d सेकंड",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return t[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,a){return 12===e&&(e=0),"रात"===a?e<4?e:e+12:"सुबह"===a?e:"दोपहर"===a?e>=10?e:e+12:"शाम"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"रात":e<10?"सुबह":e<17?"दोपहर":e<20?"शाम":"रात"},week:{dow:0,doy:6}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(136);var n=t(1);n.datepickerLocale("hr","hr",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],monthNamesShort:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],dayNames:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Tje",dateFormat:"dd.mm.yy.",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("hr",{buttonText:{prev:"Prijašnji",next:"Sljedeći",month:"Mjesec",week:"Tjedan",day:"Dan",list:"Raspored"},allDayText:"Cijeli dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nema događaja za prikaz"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){var n=e+" ";switch(t){case"ss":return n+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return n+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return n+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return n+=1===e?"dan":"dana";case"MM":return n+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return n+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}return e.defineLocale("hr",{months:{format:"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:a,m:a,mm:a,h:a,hh:a,d:"dan",dd:a,M:"mjesec",MM:a,y:"godinu",yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(138);var n=t(1);n.datepickerLocale("hu","hu",{closeText:"bezár",prevText:"vissza",nextText:"előre",currentText:"ma",monthNames:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],monthNamesShort:["Jan","Feb","Már","Ápr","Máj","Jún","Júl","Aug","Szep","Okt","Nov","Dec"],dayNames:["Vasárnap","Hétfő","Kedd","Szerda","Csütörtök","Péntek","Szombat"],dayNamesShort:["Vas","Hét","Ked","Sze","Csü","Pén","Szo"],dayNamesMin:["V","H","K","Sze","Cs","P","Szo"],weekHeader:"Hét",dateFormat:"yy.mm.dd.",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),n.locale("hu",{buttonText:{month:"Hónap",week:"Hét",day:"Nap",list:"Napló"},allDayText:"Egész nap",eventLimitText:"további",noEventsMessage:"Nincs megjeleníthető események"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r=e;switch(t){case"s":return n||a?"néhány másodperc":"néhány másodperce";case"ss":return r+(n||a)?" másodperc":" másodperce";case"m":return"egy"+(n||a?" perc":" perce");case"mm":return r+(n||a?" perc":" perce");case"h":return"egy"+(n||a?" óra":" órája");case"hh":return r+(n||a?" óra":" órája");case"d":return"egy"+(n||a?" nap":" napja");case"dd":return r+(n||a?" nap":" napja");case"M":return"egy"+(n||a?" hónap":" hónapja");case"MM":return r+(n||a?" hónap":" hónapja");case"y":return"egy"+(n||a?" év":" éve");case"yy":return r+(n||a?" év":" éve")}return""}function t(e){return(e?"":"[múlt] ")+"["+n[this.day()]+"] LT[-kor]"}var n="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");return e.defineLocale("hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,t){return e<12?!0===t?"de":"DE":!0===t?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return t.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return t.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(140);var n=t(1);n.datepickerLocale("id","id",{closeText:"Tutup",prevText:"&#x3C;mundur",nextText:"maju&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","Nopember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agus","Sep","Okt","Nop","Des"],dayNames:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"],dayNamesShort:["Min","Sen","Sel","Rab","kam","Jum","Sab"],dayNamesMin:["Mg","Sn","Sl","Rb","Km","jm","Sb"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("id",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayHtml:"Sehari<br/>penuh",eventLimitText:"lebih",noEventsMessage:"Tidak ada acara untuk ditampilkan"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?e>=11?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(142);var n=t(1);n.datepickerLocale("is","is",{closeText:"Loka",prevText:"&#x3C; Fyrri",nextText:"Næsti &#x3E;",currentText:"Í dag",monthNames:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],dayNames:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"],dayNamesShort:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"],dayNamesMin:["Su","Má","Þr","Mi","Fi","Fö","La"],weekHeader:"Vika",dateFormat:"dd.mm.yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("is",{buttonText:{month:"Mánuður",week:"Vika",day:"Dagur",list:"Dagskrá"},allDayHtml:"Allan<br/>daginn",eventLimitText:"meira",noEventsMessage:"Engir viðburðir til að sýna"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e%100==11||e%10!=1}function t(e,t,n,r){var s=e+" ";switch(n){case"s":return t||r?"nokkrar sekúndur":"nokkrum sekúndum";case"ss":return a(e)?s+(t||r?"sekúndur":"sekúndum"):s+"sekúnda";case"m":return t?"mínúta":"mínútu";case"mm":return a(e)?s+(t||r?"mínútur":"mínútum"):t?s+"mínúta":s+"mínútu";case"hh":return a(e)?s+(t||r?"klukkustundir":"klukkustundum"):s+"klukkustund";case"d":return t?"dagur":r?"dag":"degi";case"dd":return a(e)?t?s+"dagar":s+(r?"daga":"dögum"):t?s+"dagur":s+(r?"dag":"degi");case"M":return t?"mánuður":r?"mánuð":"mánuði";case"MM":return a(e)?t?s+"mánuðir":s+(r?"mánuði":"mánuðum"):t?s+"mánuður":s+(r?"mánuð":"mánuði");case"y":return t||r?"ár":"ári";case"yy":return a(e)?s+(t||r?"ár":"árum"):s+(t||r?"ár":"ári")}}return e.defineLocale("is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:t,ss:t,m:t,mm:t,h:"klukkustund",hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(144);var n=t(1);n.datepickerLocale("it","it",{closeText:"Chiudi",prevText:"&#x3C;Prec",nextText:"Succ&#x3E;",currentText:"Oggi",monthNames:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthNamesShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],dayNames:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],dayNamesShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayNamesMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("it",{buttonText:{month:"Mese",week:"Settimana",day:"Giorno",list:"Agenda"},allDayHtml:"Tutto il<br/>giorno",eventLimitText:function(e){return"+altri "+e},noEventsMessage:"Non ci sono eventi da visualizzare"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(146);var n=t(1);n.datepickerLocale("ja","ja",{closeText:"閉じる",prevText:"&#x3C;前",nextText:"次&#x3E;",currentText:"今日",monthNames:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthNamesShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayNames:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],dayNamesShort:["日","月","火","水","木","金","土"],dayNamesMin:["日","月","火","水","木","金","土"],weekHeader:"週",dateFormat:"yy/mm/dd",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),n.locale("ja",{buttonText:{month:"月",week:"週",day:"日",list:"予定リスト"},allDayText:"終日",eventLimitText:function(e){return"他 "+e+" 件"},noEventsMessage:"イベントが表示されないように"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ja",{months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日 HH:mm dddd",l:"YYYY/MM/DD",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日 HH:mm dddd"},meridiemParse:/午前|午後/i,isPM:function(e){return"午後"===e},meridiem:function(e,a,t){return e<12?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:"[来週]dddd LT",lastDay:"[昨日] LT",lastWeek:"[前週]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}日/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"数秒",ss:"%d秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(148);var n=t(1);n.datepickerLocale("ka","ka",{closeText:"დახურვა",prevText:"წინა",nextText:"შემდეგი",currentText:"დღეს",monthNames:["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],monthNamesShort:["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],dayNames:["კვირა","ორშაბათი","სამშაბათი","ოთხშაბათი","ხუთშაბათი","პარასკევი","შაბათი"],dayNamesShort:["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"],dayNamesMin:["კვ","ორ","სა","ოთ","ხუ","პა","შა"],weekHeader:"კვ",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ka",{buttonText:{month:"თვე",week:"კვირა",day:"დღე",list:"დღის წესრიგი"},allDayText:"მთელი დღე",eventLimitText:function(e){return"+ კიდევ "+e},noEventsMessage:"ღონისძიებები არ არის"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ka",{months:{standalone:"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),format:"იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს".split("_")},monthsShort:"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),weekdays:{standalone:"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),format:"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),weekdaysMin:"კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[დღეს] LT[-ზე]",nextDay:"[ხვალ] LT[-ზე]",lastDay:"[გუშინ] LT[-ზე]",nextWeek:"[შემდეგ] dddd LT[-ზე]",lastWeek:"[წინა] dddd LT-ზე",sameElse:"L"},relativeTime:{future:function(e){return/(წამი|წუთი|საათი|წელი)/.test(e)?e.replace(/ი$/,"ში"):e+"ში"},past:function(e){return/(წამი|წუთი|საათი|დღე|თვე)/.test(e)?e.replace(/(ი|ე)$/,"ის უკან"):/წელი/.test(e)?e.replace(/წელი$/,"წლის უკან"):void 0},s:"რამდენიმე წამი",ss:"%d წამი",m:"წუთი",mm:"%d წუთი",h:"საათი",hh:"%d საათი",d:"დღე",dd:"%d დღე",M:"თვე",MM:"%d თვე",y:"წელი",yy:"%d წელი"},dayOfMonthOrdinalParse:/0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,ordinal:function(e){return 0===e?e:1===e?e+"-ლი":e<20||e<=100&&e%20==0||e%100==0?"მე-"+e:e+"-ე"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(150);var n=t(1);n.datepickerLocale("kk","kk",{closeText:"Жабу",prevText:"&#x3C;Алдыңғы",nextText:"Келесі&#x3E;",currentText:"Бүгін",monthNames:["Қаңтар","Ақпан","Наурыз","Сәуір","Мамыр","Маусым","Шілде","Тамыз","Қыркүйек","Қазан","Қараша","Желтоқсан"],
monthNamesShort:["Қаң","Ақп","Нау","Сәу","Мам","Мау","Шіл","Там","Қыр","Қаз","Қар","Жел"],dayNames:["Жексенбі","Дүйсенбі","Сейсенбі","Сәрсенбі","Бейсенбі","Жұма","Сенбі"],dayNamesShort:["жкс","дсн","ссн","срс","бсн","жма","снб"],dayNamesMin:["Жк","Дс","Сс","Ср","Бс","Жм","Сн"],weekHeader:"Не",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("kk",{buttonText:{month:"Ай",week:"Апта",day:"Күн",list:"Күн тәртібі"},allDayText:"Күні бойы",eventLimitText:function(e){return"+ тағы "+e},noEventsMessage:"Көрсету үшін оқиғалар жоқ"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={0:"-ші",1:"-ші",2:"-ші",3:"-ші",4:"-ші",5:"-ші",6:"-шы",7:"-ші",8:"-ші",9:"-шы",10:"-шы",20:"-шы",30:"-шы",40:"-шы",50:"-ші",60:"-шы",70:"-ші",80:"-ші",90:"-шы",100:"-ші"};return e.defineLocale("kk",{months:"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),monthsShort:"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),weekdays:"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),weekdaysShort:"жек_дүй_сей_сәр_бей_жұм_сен".split("_"),weekdaysMin:"жк_дй_сй_ср_бй_жм_сн".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгін сағат] LT",nextDay:"[Ертең сағат] LT",nextWeek:"dddd [сағат] LT",lastDay:"[Кеше сағат] LT",lastWeek:"[Өткен аптаның] dddd [сағат] LT",sameElse:"L"},relativeTime:{future:"%s ішінде",past:"%s бұрын",s:"бірнеше секунд",ss:"%d секунд",m:"бір минут",mm:"%d минут",h:"бір сағат",hh:"%d сағат",d:"бір күн",dd:"%d күн",M:"бір ай",MM:"%d ай",y:"бір жыл",yy:"%d жыл"},dayOfMonthOrdinalParse:/\d{1,2}-(ші|шы)/,ordinal:function(e){var t=e%10,n=e>=100?100:null;return e+(a[e]||a[t]||a[n])},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(152);var n=t(1);n.datepickerLocale("ko","ko",{closeText:"닫기",prevText:"이전달",nextText:"다음달",currentText:"오늘",monthNames:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],monthNamesShort:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayNames:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],dayNamesShort:["일","월","화","수","목","금","토"],dayNamesMin:["일","월","화","수","목","금","토"],weekHeader:"주",dateFormat:"yy. m. d.",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"년"}),n.locale("ko",{buttonText:{month:"월",week:"주",day:"일",list:"일정목록"},allDayText:"종일",eventLimitText:"개",noEventsMessage:"일정이 없습니다"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h:mm",LLLL:"YYYY년 MMMM D일 dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY년 MMMM D일",lll:"YYYY년 MMMM D일 A h:mm",llll:"YYYY년 MMMM D일 dddd A h:mm"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",ss:"%d초",m:"1분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"},dayOfMonthOrdinalParse:/\d{1,2}(일|월|주)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"일";case"M":return e+"월";case"w":case"W":return e+"주";default:return e}},meridiemParse:/오전|오후/,isPM:function(e){return"오후"===e},meridiem:function(e,a,t){return e<12?"오전":"오후"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(154);var n=t(1);n.datepickerLocale("lb","lb",{closeText:"Fäerdeg",prevText:"Zréck",nextText:"Weider",currentText:"Haut",monthNames:["Januar","Februar","Mäerz","Abrëll","Mee","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mäe","Abr","Mee","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonndeg","Méindeg","Dënschdeg","Mëttwoch","Donneschdeg","Freideg","Samschdeg"],dayNamesShort:["Son","Méi","Dën","Mët","Don","Fre","Sam"],dayNamesMin:["So","Mé","Dë","Më","Do","Fr","Sa"],weekHeader:"W",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("lb",{buttonText:{month:"Mount",week:"Woch",day:"Dag",list:"Terminiwwersiicht"},allDayText:"Ganzen Dag",eventLimitText:"méi",noEventsMessage:"Nee Evenementer ze affichéieren"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?r[t][0]:r[t][1]}function t(e){return r(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e}function n(e){return r(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e}function r(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var a=e%10,t=e/10;return r(0===a?t:a)}if(e<1e4){for(;e>=10;)e/=10;return r(e)}return e/=1e3,r(e)}return e.defineLocale("lb",{months:"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mé_Dë_Më_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[Gëschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:t,past:n,s:"e puer Sekonnen",ss:"%d Sekonnen",m:a,mm:"%d Minutten",h:a,hh:"%d Stonnen",d:a,dd:"%d Deeg",M:a,MM:"%d Méint",y:a,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(156);var n=t(1);n.datepickerLocale("lt","lt",{closeText:"Uždaryti",prevText:"&#x3C;Atgal",nextText:"Pirmyn&#x3E;",currentText:"Šiandien",monthNames:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],monthNamesShort:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],dayNames:["sekmadienis","pirmadienis","antradienis","trečiadienis","ketvirtadienis","penktadienis","šeštadienis"],dayNamesShort:["sek","pir","ant","tre","ket","pen","šeš"],dayNamesMin:["Se","Pr","An","Tr","Ke","Pe","Še"],weekHeader:"SAV",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),n.locale("lt",{buttonText:{month:"Mėnuo",week:"Savaitė",day:"Diena",list:"Darbotvarkė"},allDayText:"Visą dieną",eventLimitText:"daugiau",noEventsMessage:"Nėra įvykių rodyti"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){return a?"kelios sekundės":n?"kelių sekundžių":"kelias sekundes"}function t(e,a,t,n){return a?r(t)[0]:n?r(t)[1]:r(t)[2]}function n(e){return e%10==0||e>10&&e<20}function r(e){return d[e].split("_")}function s(e,a,s,d){var i=e+" ";return 1===e?i+t(e,a,s[0],d):a?i+(n(e)?r(s)[1]:r(s)[0]):d?i+r(s)[1]:i+(n(e)?r(s)[1]:r(s)[2])}var d={ss:"sekundė_sekundžių_sekundes",m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"};return e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:a,ss:s,m:t,mm:s,h:t,hh:s,d:t,dd:s,M:t,MM:s,y:t,yy:s},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(158);var n=t(1);n.datepickerLocale("lv","lv",{closeText:"Aizvērt",prevText:"Iepr.",nextText:"Nāk.",currentText:"Šodien",monthNames:["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],monthNamesShort:["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],dayNames:["svētdiena","pirmdiena","otrdiena","trešdiena","ceturtdiena","piektdiena","sestdiena"],dayNamesShort:["svt","prm","otr","tre","ctr","pkt","sst"],dayNamesMin:["Sv","Pr","Ot","Tr","Ct","Pk","Ss"],weekHeader:"Ned.",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("lv",{buttonText:{month:"Mēnesis",week:"Nedēļa",day:"Diena",list:"Dienas kārtība"},allDayText:"Visu dienu",eventLimitText:function(e){return"+vēl "+e},noEventsMessage:"Nav notikumu"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){return t?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function t(e,t,n){return e+" "+a(s[n],e,t)}function n(e,t,n){return a(s[n],e,t)}function r(e,a){return a?"dažas sekundes":"dažām sekundēm"}var s={ss:"sekundes_sekundēm_sekunde_sekundes".split("_"),m:"minūtes_minūtēm_minūte_minūtes".split("_"),mm:"minūtes_minūtēm_minūte_minūtes".split("_"),h:"stundas_stundām_stunda_stundas".split("_"),hh:"stundas_stundām_stunda_stundas".split("_"),d:"dienas_dienām_diena_dienas".split("_"),dd:"dienas_dienām_diena_dienas".split("_"),M:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),MM:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};return e.defineLocale("lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"pēc %s",past:"pirms %s",s:r,ss:t,m:n,mm:t,h:n,hh:t,d:n,dd:t,M:n,MM:t,y:n,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(160);var n=t(1);n.datepickerLocale("mk","mk",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Денес",monthNames:["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],dayNames:["Недела","Понеделник","Вторник","Среда","Четврток","Петок","Сабота"],dayNamesShort:["Нед","Пон","Вто","Сре","Чет","Пет","Саб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Са"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("mk",{buttonText:{month:"Месец",week:"Недела",day:"Ден",list:"График"},allDayText:"Цел ден",eventLimitText:function(e){return"+повеќе "+e},noEventsMessage:"Нема настани за прикажување"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("mk",{months:"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),monthsShort:"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),weekdays:"недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),weekdaysShort:"нед_пон_вто_сре_чет_пет_саб".split("_"),weekdaysMin:"нe_пo_вт_ср_че_пе_сa".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Денес во] LT",nextDay:"[Утре во] LT",nextWeek:"[Во] dddd [во] LT",lastDay:"[Вчера во] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Изминатата] dddd [во] LT";case 1:case 2:case 4:case 5:return"[Изминатиот] dddd [во] LT"}},sameElse:"L"},relativeTime:{future:"после %s",past:"пред %s",s:"неколку секунди",ss:"%d секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дена",M:"месец",MM:"%d месеци",y:"година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-ев":0===t?e+"-ен":t>10&&t<20?e+"-ти":1===a?e+"-ви":2===a?e+"-ри":7===a||8===a?e+"-ми":e+"-ти"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(162);var n=t(1);n.datepickerLocale("ms-my","ms",{closeText:"Tutup",prevText:"&#x3C;Sebelum",nextText:"Selepas&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthNamesShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],dayNames:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],dayNamesShort:["Aha","Isn","Sel","Rab","kha","Jum","Sab"],dayNamesMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ms-my",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayText:"Sepanjang hari",eventLimitText:function(e){return"masih ada "+e+" acara"},noEventsMessage:"Tiada peristiwa untuk dipaparkan"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(164);var n=t(1);n.datepickerLocale("ms","ms",{closeText:"Tutup",prevText:"&#x3C;Sebelum",nextText:"Selepas&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthNamesShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],dayNames:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],dayNamesShort:["Aha","Isn","Sel","Rab","kha","Jum","Sab"],dayNamesMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ms",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayText:"Sepanjang hari",eventLimitText:function(e){return"masih ada "+e+" acara"},noEventsMessage:"Tiada peristiwa untuk dipaparkan"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(166);var n=t(1);n.datepickerLocale("nb","nb",{closeText:"Lukk",prevText:"&#xAB;Forrige",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["søn","man","tir","ons","tor","fre","lør"],dayNames:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],dayNamesMin:["sø","ma","ti","on","to","fr","lø"],weekHeader:"Uke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nb",{buttonText:{month:"Måned",week:"Uke",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"til",noEventsMessage:"Ingen hendelser å vise"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"sø._ma._ti._on._to._fr._lø.".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en måned",MM:"%d måneder",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(168);var n=t(1);n.datepickerLocale("nl-be","nl-BE",{closeText:"Sluiten",prevText:"←",nextText:"→",currentText:"Vandaag",monthNames:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNamesShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],dayNames:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayNamesShort:["zon","maa","din","woe","don","vri","zat"],dayNamesMin:["zo","ma","di","wo","do","vr","za"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nl-be",{buttonText:{month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayText:"Hele dag",eventLimitText:"extra",noEventsMessage:"Geen evenementen om te laten zien"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),t="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),n=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],r=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;return e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(170);var n=t(1);n.datepickerLocale("nl","nl",{closeText:"Sluiten",prevText:"←",nextText:"→",currentText:"Vandaag",monthNames:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNamesShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],dayNames:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayNamesShort:["zon","maa","din","woe","don","vri","zat"],dayNamesMin:["zo","ma","di","wo","do","vr","za"],weekHeader:"Wk",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nl",{buttonText:{year:"Jaar",month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayText:"Hele dag",eventLimitText:"extra",noEventsMessage:"Geen evenementen om te laten zien"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),t="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),n=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],r=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;return e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(172);var n=t(1);n.datepickerLocale("nn","nn",{closeText:"Lukk",prevText:"&#xAB;Førre",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["sun","mån","tys","ons","tor","fre","lau"],dayNames:["sundag","måndag","tysdag","onsdag","torsdag","fredag","laurdag"],dayNamesMin:["su","må","ty","on","to","fr","la"],weekHeader:"Veke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nn",{buttonText:{month:"Månad",week:"Veke",day:"Dag",list:"Agenda"},allDayText:"Heile dagen",eventLimitText:"til",noEventsMessage:"Ingen hendelser å vise"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"sun_mån_tys_ons_tor_fre_lau".split("_"),weekdaysMin:"su_må_ty_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I går klokka] LT",lastWeek:"[Føregåande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",M:"ein månad",MM:"%d månader",y:"eit år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(174);var n=t(1);n.datepickerLocale("pl","pl",{closeText:"Zamknij",prevText:"&#x3C;Poprzedni",nextText:"Następny&#x3E;",currentText:"Dziś",monthNames:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthNamesShort:["Sty","Lu","Mar","Kw","Maj","Cze","Lip","Sie","Wrz","Pa","Lis","Gru"],dayNames:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],dayNamesShort:["Nie","Pn","Wt","Śr","Czw","Pt","So"],dayNamesMin:["N","Pn","Wt","Śr","Cz","Pt","So"],weekHeader:"Tydz",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("pl",{buttonText:{month:"Miesiąc",week:"Tydzień",day:"Dzień",list:"Plan dnia"},allDayText:"Cały dzień",eventLimitText:"więcej",noEventsMessage:"Brak wydarzeń do wyświetlenia"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function t(e,t,n){var r=e+" ";switch(n){case"ss":return r+(a(e)?"sekundy":"sekund");case"m":return t?"minuta":"minutę";case"mm":return r+(a(e)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return r+(a(e)?"godziny":"godzin");case"MM":return r+(a(e)?"miesiące":"miesięcy");case"yy":return r+(a(e)?"lata":"lat")}}var n="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),r="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_");return e.defineLocale("pl",{months:function(e,a){return e?""===a?"("+r[e.month()]+"|"+n[e.month()]+")":/D MMMM/.test(a)?r[e.month()]:n[e.month()]:n},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedzielę o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W środę o] LT";case 6:return"[W sobotę o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:t,m:t,mm:t,h:t,hh:t,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:t,y:"rok",yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(176);var n=t(1);n.datepickerLocale("pt-br","pt-BR",{closeText:"Fechar",prevText:"&#x3C;Anterior",nextText:"Próximo&#x3E;",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("pt-br",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Compromissos"},allDayText:"dia inteiro",eventLimitText:function(e){return"mais +"+e},noEventsMessage:"Não há eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("pt-br",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",
LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº"})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(178);var n=t(1);n.datepickerLocale("pt","pt",{closeText:"Fechar",prevText:"Anterior",nextText:"Seguinte",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sem",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("pt",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Agenda"},allDayText:"Todo o dia",eventLimitText:"mais",noEventsMessage:"Não há eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("pt",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(180);var n=t(1);n.datepickerLocale("ro","ro",{closeText:"Închide",prevText:"&#xAB; Luna precedentă",nextText:"Luna următoare &#xBB;",currentText:"Azi",monthNames:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],monthNamesShort:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"],dayNamesShort:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],dayNamesMin:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],weekHeader:"Săpt",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ro",{buttonText:{prev:"precedentă",next:"următoare",month:"Lună",week:"Săptămână",day:"Zi",list:"Agendă"},allDayText:"Toată ziua",eventLimitText:function(e){return"+alte "+e},noEventsMessage:"Nu există evenimente de afișat"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){var n={ss:"secunde",mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"},r=" ";return(e%100>=20||e>=100&&e%100==0)&&(r=" de "),e+r+n[t]}return e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",ss:a,m:"un minut",mm:a,h:"o oră",hh:a,d:"o zi",dd:a,M:"o lună",MM:a,y:"un an",yy:a},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(182);var n=t(1);n.datepickerLocale("ru","ru",{closeText:"Закрыть",prevText:"&#x3C;Пред",nextText:"След&#x3E;",currentText:"Сегодня",monthNames:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthNamesShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],dayNames:["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"],dayNamesShort:["вск","пнд","втр","срд","чтв","птн","сбт"],dayNamesMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Нед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ru",{buttonText:{month:"Месяц",week:"Неделя",day:"День",list:"Повестка дня"},allDayText:"Весь день",eventLimitText:function(e){return"+ ещё "+e},noEventsMessage:"Нет событий для отображения"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function t(e,t,n){var r={ss:t?"секунда_секунды_секунд":"секунду_секунды_секунд",mm:t?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",MM:"месяц_месяца_месяцев",yy:"год_года_лет"};return"m"===n?t?"минута":"минуту":e+" "+a(r[n],+e)}var n=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i];return e.defineLocale("ru",{months:{format:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),standalone:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")},monthsShort:{format:"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),standalone:"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")},weekdays:{standalone:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),format:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),isFormat:/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/},weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:n,longMonthsParse:n,shortMonthsParse:n,monthsRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsShortRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., H:mm",LLLL:"dddd, D MMMM YYYY г., H:mm"},calendar:{sameDay:"[Сегодня в] LT",nextDay:"[Завтра в] LT",lastDay:"[Вчера в] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В следующее] dddd [в] LT";case 1:case 2:case 4:return"[В следующий] dddd [в] LT";case 3:case 5:case 6:return"[В следующую] dddd [в] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",ss:t,m:t,mm:t,h:"час",hh:t,d:"день",dd:t,M:"месяц",MM:t,y:"год",yy:t},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,a,t){return e<4?"ночи":e<12?"утра":e<17?"дня":"вечера"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-й";case"D":return e+"-го";case"w":case"W":return e+"-я";default:return e}},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(184);var n=t(1);n.datepickerLocale("sk","sk",{closeText:"Zavrieť",prevText:"&#x3C;Predchádzajúci",nextText:"Nasledujúci&#x3E;",currentText:"Dnes",monthNames:["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],monthNamesShort:["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],dayNames:["nedeľa","pondelok","utorok","streda","štvrtok","piatok","sobota"],dayNamesShort:["Ned","Pon","Uto","Str","Štv","Pia","Sob"],dayNamesMin:["Ne","Po","Ut","St","Št","Pia","So"],weekHeader:"Ty",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sk",{buttonText:{month:"Mesiac",week:"Týždeň",day:"Deň",list:"Rozvrh"},allDayText:"Celý deň",eventLimitText:function(e){return"+ďalšie: "+e},noEventsMessage:"Žiadne akcie na zobrazenie"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e>1&&e<5}function t(e,t,n,r){var s=e+" ";switch(n){case"s":return t||r?"pár sekúnd":"pár sekundami";case"ss":return t||r?s+(a(e)?"sekundy":"sekúnd"):s+"sekundami";case"m":return t?"minúta":r?"minútu":"minútou";case"mm":return t||r?s+(a(e)?"minúty":"minút"):s+"minútami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?s+(a(e)?"hodiny":"hodín"):s+"hodinami";case"d":return t||r?"deň":"dňom";case"dd":return t||r?s+(a(e)?"dni":"dní"):s+"dňami";case"M":return t||r?"mesiac":"mesiacom";case"MM":return t||r?s+(a(e)?"mesiace":"mesiacov"):s+"mesiacmi";case"y":return t||r?"rok":"rokom";case"yy":return t||r?s+(a(e)?"roky":"rokov"):s+"rokmi"}}var n="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),r="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");return e.defineLocale("sk",{months:n,monthsShort:r,weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 4:case 5:return"[minulý] dddd [o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(186);var n=t(1);n.datepickerLocale("sl","sl",{closeText:"Zapri",prevText:"&#x3C;Prejšnji",nextText:"Naslednji&#x3E;",currentText:"Trenutni",monthNames:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],dayNames:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"],dayNamesShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],dayNamesMin:["Ne","Po","To","Sr","Če","Pe","So"],weekHeader:"Teden",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sl",{buttonText:{month:"Mesec",week:"Teden",day:"Dan",list:"Dnevni red"},allDayText:"Ves dan",eventLimitText:"več",noEventsMessage:"Ni dogodkov za prikaz"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r=e+" ";switch(t){case"s":return a||n?"nekaj sekund":"nekaj sekundami";case"ss":return r+=1===e?a?"sekundo":"sekundi":2===e?a||n?"sekundi":"sekundah":e<5?a||n?"sekunde":"sekundah":"sekund";case"m":return a?"ena minuta":"eno minuto";case"mm":return r+=1===e?a?"minuta":"minuto":2===e?a||n?"minuti":"minutama":e<5?a||n?"minute":"minutami":a||n?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return r+=1===e?a?"ura":"uro":2===e?a||n?"uri":"urama":e<5?a||n?"ure":"urami":a||n?"ur":"urami";case"d":return a||n?"en dan":"enim dnem";case"dd":return r+=1===e?a||n?"dan":"dnem":2===e?a||n?"dni":"dnevoma":a||n?"dni":"dnevi";case"M":return a||n?"en mesec":"enim mesecem";case"MM":return r+=1===e?a||n?"mesec":"mesecem":2===e?a||n?"meseca":"mesecema":e<5?a||n?"mesece":"meseci":a||n?"mesecev":"meseci";case"y":return a||n?"eno leto":"enim letom";case"yy":return r+=1===e?a||n?"leto":"letom":2===e?a||n?"leti":"letoma":e<5?a||n?"leta":"leti":a||n?"let":"leti"}}return e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prejšnjo] [nedeljo] [ob] LT";case 3:return"[prejšnjo] [sredo] [ob] LT";case 6:return"[prejšnjo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"pred %s",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(188);var n=t(1);n.datepickerLocale("sq","sq",{closeText:"mbylle",prevText:"&#x3C;mbrapa",nextText:"Përpara&#x3E;",currentText:"sot",monthNames:["Janar","Shkurt","Mars","Prill","Maj","Qershor","Korrik","Gusht","Shtator","Tetor","Nëntor","Dhjetor"],monthNamesShort:["Jan","Shk","Mar","Pri","Maj","Qer","Kor","Gus","Sht","Tet","Nën","Dhj"],dayNames:["E Diel","E Hënë","E Martë","E Mërkurë","E Enjte","E Premte","E Shtune"],dayNamesShort:["Di","Hë","Ma","Më","En","Pr","Sh"],dayNamesMin:["Di","Hë","Ma","Më","En","Pr","Sh"],weekHeader:"Ja",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sq",{buttonText:{month:"Muaj",week:"Javë",day:"Ditë",list:"Listë"},allDayHtml:"Gjithë<br/>ditën",eventLimitText:function(e){return"+më tepër "+e},noEventsMessage:"Nuk ka evente për të shfaqur"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),weekdays:"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),weekdaysShort:"Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_Më_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,a,t){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot në] LT",nextDay:"[Nesër në] LT",nextWeek:"dddd [në] LT",lastDay:"[Dje në] LT",lastWeek:"dddd [e kaluar në] LT",sameElse:"L"},relativeTime:{future:"në %s",past:"%s më parë",s:"disa sekonda",ss:"%d sekonda",m:"një minutë",mm:"%d minuta",h:"një orë",hh:"%d orë",d:"një ditë",dd:"%d ditë",M:"një muaj",MM:"%d muaj",y:"një vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(190);var n=t(1);n.datepickerLocale("sr-cyrl","sr",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Данас",monthNames:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthNamesShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],dayNames:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],dayNamesShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],dayNamesMin:["Не","По","Ут","Ср","Че","Пе","Су"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sr-cyrl",{buttonText:{prev:"Претходна",next:"следећи",month:"Месец",week:"Недеља",day:"Дан",list:"Планер"},allDayText:"Цео дан",eventLimitText:function(e){return"+ још "+e},noEventsMessage:"Нема догађаја за приказ"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={words:{ss:["секунда","секунде","секунди"],m:["један минут","једне минуте"],mm:["минут","минуте","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],dd:["дан","дана","дана"],MM:["месец","месеца","месеци"],yy:["година","године","година"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,t,n){var r=a.words[n];return 1===n.length?t?r[0]:r[1]:e+" "+a.correctGrammaticalCase(e,r)}};return e.defineLocale("sr-cyrl",{months:"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),monthsShort:"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),monthsParseExact:!0,weekdays:"недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),weekdaysShort:"нед._пон._уто._сре._чет._пет._суб.".split("_"),weekdaysMin:"не_по_ут_ср_че_пе_су".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){return["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",ss:a.translate,m:a.translate,mm:a.translate,h:a.translate,hh:a.translate,d:"дан",dd:a.translate,M:"месец",MM:a.translate,y:"годину",yy:a.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(192);var n=t(1);n.datepickerLocale("sr","sr-SR",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],dayNames:["Nedelja","Ponedeljak","Utorak","Sreda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sre","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Sed",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sr",{buttonText:{prev:"Prethodna",next:"Sledeći",month:"Mеsеc",week:"Nеdеlja",day:"Dan",list:"Planеr"},allDayText:"Cеo dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nеma događaja za prikaz"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,t,n){var r=a.words[n];return 1===n.length?t?r[0]:r[1]:e+" "+a.correctGrammaticalCase(e,r)}};return e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){return["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:a.translate,m:a.translate,mm:a.translate,h:a.translate,hh:a.translate,d:"dan",dd:a.translate,M:"mesec",MM:a.translate,y:"godinu",yy:a.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(194);var n=t(1);n.datepickerLocale("sv","sv",{closeText:"Stäng",prevText:"&#xAB;Förra",nextText:"Nästa&#xBB;",currentText:"Idag",monthNames:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNamesShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"],dayNames:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"],dayNamesMin:["Sö","Må","Ti","On","To","Fr","Lö"],weekHeader:"v. ",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sv",{buttonText:{month:"Månad",week:"Vecka",day:"Dag",list:"Program"},allDayText:"Heldag",eventLimitText:"till",noEventsMessage:"Inga händelser att visa"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"[På] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"e":1===a?"a":2===a?"a":"e")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(196);var n=t(1);n.datepickerLocale("th","th",{closeText:"ปิด",prevText:"&#xAB;&#xA0;ย้อน",nextText:"ถัดไป&#xA0;&#xBB;",currentText:"วันนี้",monthNames:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],monthNamesShort:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],dayNames:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์","เสาร์"],dayNamesShort:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],dayNamesMin:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("th",{buttonText:{month:"เดือน",week:"สัปดาห์",day:"วัน",list:"แผนงาน"},allDayText:"ตลอดวัน",eventLimitText:"เพิ่มเติม",noEventsMessage:"ไม่มีกิจกรรมที่จะแสดง"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),monthsParseExact:!0,weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H:mm",LLLL:"วันddddที่ D MMMM YYYY เวลา H:mm"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return"หลังเที่ยง"===e},meridiem:function(e,a,t){return e<12?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",ss:"%d วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(198);var n=t(1);n.datepickerLocale("tr","tr",{closeText:"kapat",prevText:"&#x3C;geri",nextText:"ileri&#x3e",currentText:"bugün",monthNames:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthNamesShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],dayNames:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],dayNamesShort:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],dayNamesMin:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],weekHeader:"Hf",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("tr",{buttonText:{next:"ileri",month:"Ay",week:"Hafta",day:"Gün",list:"Ajanda"},allDayText:"Tüm gün",eventLimitText:"daha fazla",noEventsMessage:"Herhangi bir etkinlik görüntülemek için"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"};return e.defineLocale("tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinal:function(e,t){switch(t){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'ıncı";var n=e%10,r=e%100-n,s=e>=100?100:null;return e+(a[n]||a[r]||a[s])}},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(200);var n=t(1);n.datepickerLocale("uk","uk",{closeText:"Закрити",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Сьогодні",monthNames:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],monthNamesShort:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],dayNames:["неділя","понеділок","вівторок","середа","четвер","п’ятниця","субота"],dayNamesShort:["нед","пнд","вів","срд","чтв","птн","сбт"],dayNamesMin:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Тиж",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("uk",{buttonText:{month:"Місяць",week:"Тиждень",day:"День",list:"Порядок денний"},allDayText:"Увесь день",eventLimitText:function(e){return"+ще "+e+"..."},noEventsMessage:"Немає подій для відображення"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function t(e,t,n){var r={ss:t?"секунда_секунди_секунд":"секунду_секунди_секунд",mm:t?"хвилина_хвилини_хвилин":"хвилину_хвилини_хвилин",hh:t?"година_години_годин":"годину_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"};return"m"===n?t?"хвилина":"хвилину":"h"===n?t?"година":"годину":e+" "+a(r[n],+e)}function n(e,a){var t={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")};return e?t[/(\[[ВвУу]\]) ?dddd/.test(a)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(a)?"genitive":"nominative"][e.day()]:t.nominative}function r(e){return function(){return e+"о"+(11===this.hours()?"б":"")+"] LT"}}return e.defineLocale("uk",{months:{format:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),standalone:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")},monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:n,weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., HH:mm",LLLL:"dddd, D MMMM YYYY р., HH:mm"},calendar:{sameDay:r("[Сьогодні "),nextDay:r("[Завтра "),lastDay:r("[Вчора "),nextWeek:r("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return r("[Минулої] dddd [").call(this);case 1:case 2:case 4:return r("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",ss:t,m:t,mm:t,h:"годину",hh:t,d:"день",dd:t,M:"місяць",MM:t,y:"рік",yy:t},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,a,t){return e<4?"ночі":e<12?"ранку":e<17?"дня":"вечора"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-й"
;case"D":return e+"-го";default:return e}},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(202);var n=t(1);n.datepickerLocale("vi","vi",{closeText:"Đóng",prevText:"&#x3C;Trước",nextText:"Tiếp&#x3E;",currentText:"Hôm nay",monthNames:["Tháng Một","Tháng Hai","Tháng Ba","Tháng Tư","Tháng Năm","Tháng Sáu","Tháng Bảy","Tháng Tám","Tháng Chín","Tháng Mười","Tháng Mười Một","Tháng Mười Hai"],monthNamesShort:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayNames:["Chủ Nhật","Thứ Hai","Thứ Ba","Thứ Tư","Thứ Năm","Thứ Sáu","Thứ Bảy"],dayNamesShort:["CN","T2","T3","T4","T5","T6","T7"],dayNamesMin:["CN","T2","T3","T4","T5","T6","T7"],weekHeader:"Tu",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("vi",{buttonText:{month:"Tháng",week:"Tuần",day:"Ngày",list:"Lịch biểu"},allDayText:"Cả ngày",eventLimitText:function(e){return"+ thêm "+e},noEventsMessage:"Không có sự kiện để hiển thị"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),monthsParseExact:!0,weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"sa":"SA":t?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần rồi lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",ss:"%d giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(204);var n=t(1);n.datepickerLocale("zh-cn","zh-CN",{closeText:"关闭",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),n.locale("zh-cn",{buttonText:{month:"月",week:"周",day:"日",list:"日程"},allDayText:"全天",eventLimitText:function(e){return"另外 "+e+" 个"},noEventsMessage:"没有事件显示"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah点mm分",LLLL:"YYYY年M月D日ddddAh点mm分",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),"凌晨"===a||"早上"===a||"上午"===a?e:"下午"===a||"晚上"===a?e+12:e>=11?e:e+12},meridiem:function(e,a,t){var n=100*e+a;return n<600?"凌晨":n<900?"早上":n<1130?"上午":n<1230?"中午":n<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|周)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"周";default:return e}},relativeTime:{future:"%s内",past:"%s前",s:"几秒",ss:"%d 秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(206);var n=t(1);n.datepickerLocale("zh-tw","zh-TW",{closeText:"關閉",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy/mm/dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),n.locale("zh-tw",{buttonText:{month:"月",week:"週",day:"天",list:"活動列表"},allDayText:"整天",eventLimitText:"顯示更多",noEventsMessage:"没有任何活動"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),"凌晨"===a||"早上"===a||"上午"===a?e:"中午"===a?e>=11?e:e+12:"下午"===a||"晚上"===a?e+12:void 0},meridiem:function(e,a,t){var n=100*e+a;return n<600?"凌晨":n<900?"早上":n<1130?"上午":n<1230?"中午":n<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})})},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(e,a,t){t(65),t(67),t(69),t(71),t(73),t(75),t(77),t(79),t(81),t(83),t(85),t(87),t(89),t(91),t(93),t(95),t(97),t(99),t(101),t(103),t(105),t(107),t(109),t(111),t(113),t(115),t(117),t(119),t(121),t(123),t(125),t(127),t(129),t(131),t(133),t(135),t(137),t(139),t(141),t(143),t(145),t(147),t(149),t(151),t(153),t(155),t(157),t(159),t(161),t(163),t(165),t(167),t(169),t(171),t(173),t(175),t(177),t(179),t(181),t(183),t(185),t(187),t(189),t(191),t(193),t(195),t(197),t(199),t(201),t(203),t(205),e.exports=t(435)},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0});var n=t(0),r=t(1);n.locale("en"),r.locale("en"),window.jQuery.datepicker&&window.jQuery.datepicker.setDefaults(window.jQuery.datepicker.regional[""])}])});
(function() {
    'use strict';

    /**
     * Audio Recorder Directive
     * 
     * Usage:
     * Add 'audio-recorder' attribute to any form-group with a textarea
     * Add 'audio-model' with the path to the model in the scope
     * Example:
     * <div class="form-group" audio-recorder audio-model="ctrl.form.text">
     *   <label>Notes</label>
     *   <textarea ng-model="ctrl.form.text" class="form-control"></textarea>
     * </div>
     */
    angular.module('app').directive('audioRecorder', audioRecorder);

    audioRecorder.$inject = ['AudioRecorderService', '$api', '$compile', '$parse'];
    function audioRecorder(AudioRecorderService, $api, $compile, $parse) {
        var instanceCounter = 0;
        
        return {
            restrict: 'A',
            scope: false,
            link: function(scope, element, attrs) {
                
                // Generate unique instance ID (using underscores to avoid Angular expression issues)
                var instanceId = 'audioRecorder_' + (++instanceCounter) + '_' + Date.now();
                
                // Add the 'with-audio' class to the parent element
                element.addClass('with-audio');

                // Get the model from attribute
                var audioModelPath = attrs.audioModel;

                // Simple state variable on scope - scoped to this instance
                var stateVarName = 'audioRecState_' + instanceId;
                
                // Initialize state to idle
                scope[stateVarName] = 'idle';
                
                // Ensure service is in idle state if no active instance
                if (!AudioRecorderService.activeInstanceId && AudioRecorderService.state !== 'idle') {
                    AudioRecorderService.state = 'idle';
                }

                // Watch service state and update scope when it changes - only for this instance
                scope.$watch(function() {
                    return {
                        state: AudioRecorderService.state,
                        activeInstanceId: AudioRecorderService.activeInstanceId
                    };
                }, function(newVal) {
                    // Ensure we have valid values
                    var currentState = newVal.state || 'idle';
                    var currentActiveId = newVal.activeInstanceId;
                    
                    // Only update state if this instance is active or if service is idle
                    if (currentActiveId === instanceId || currentState === 'idle') {
                        scope[stateVarName] = currentState;
                        
                        // Add/remove ai-processing class to form-group for border animation
                        if (currentState === 'processing' && currentActiveId === instanceId) {
                            element.addClass('ai-processing');
                        } else {
                            element.removeClass('ai-processing');
                        }
                    } else {
                        // Reset to idle if another instance is active
                        scope[stateVarName] = 'idle';
                        element.removeClass('ai-processing');
                    }
                }, true);

                // Create the audio container HTML - ONE icon and ONE label that change based on state
                var audioContainerHTML = 
                    '<div class="audio-container">' +
                        '<div class="audio-icon" ' +
                             'ng-click="recordAudioFn_' + instanceId + '()" ' +
                             'ng-class="{\'recording\': ' + stateVarName + ' === \'recording\', \'processing\': ' + stateVarName + ' === \'processing\'}" ' +
                             'ng-disabled="' + stateVarName + ' === \'processing\'">' +
                            '<i ng-class="{' +
                                '\'las la-stop\': ' + stateVarName + ' === \'recording\',' +
                                '\'las la-spinner la-spin\': ' + stateVarName + ' === \'processing\'' +
                            '}"></i>' +
                        '</div>' +
                        '<span class="audio-state-label" ' +
                              'ng-class="{\'recording-label\': ' + stateVarName + ' === \'recording\', \'processing-label\': ' + stateVarName + ' === \'processing\'}" ' +
                              'ng-show="' + stateVarName + ' !== \'idle\'">' +
                            '{{' + stateVarName + ' === \'recording\' ? ("RECORDING" | translate) : ("PROCESSING" | translate)}}' +
                        '</span>' +
                    '</div>';

                // Compile and append the audio container
                var compiled = $compile(audioContainerHTML)(scope);
                element.append(compiled);

                // Recording function - instance specific
                scope['recordAudioFn_' + instanceId] = function() {
                    var baseURL = attrs.apiBaseUrl || $api.baseURL;
                    
                    AudioRecorderService.toggleRecording({
                        apiBaseURL: baseURL,
                        instanceId: instanceId,
                        onSuccess: function(transcribedText) {
                            // Append or replace text using $parse to access the model
                            var model = $parse(audioModelPath);
                            var currentValue = model(scope);
                            
                            if (currentValue) {
                                model.assign(scope, currentValue + ' ' + transcribedText);
                            } else {
                                model.assign(scope, transcribedText);
                            }
                        }
                    });
                };

                // Cleanup on destroy - only stop if this instance is active
                scope.$on('$destroy', function() {
                    if (AudioRecorderService.state === 'recording' && AudioRecorderService.activeInstanceId === instanceId) {
                        AudioRecorderService.stopRecording();
                    }
                    // Clean up the instance-specific scope variables
                    delete scope[stateVarName];
                    delete scope['recordAudioFn_' + instanceId];
                });
            }
        };
    }

})();


/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
        angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeight = angular.element('nav.navbar-default').height();
        var wrapperHeight = angular.element('#page-wrapper').height();

        if (navbarHeight > wrapperHeight) {
            angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
        }

        if (navbarHeight < wrapperHeight) {
            angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
        }

        if (angular.element('body').hasClass('fixed-nav')) {
            if (navbarHeight > wrapperHeight) {
                angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
            } else {
                angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
            }
        }

    }

    angular.element(window).bind("load resize scroll", function () {
        if (!angular.element("body").hasClass('body-small')) {
            //fix_height();
        }
    });

    // Move right sidebar top after scroll
    angular.element(window).scroll(function () {
        if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
            angular.element('#right-sidebar').addClass('sidebar-top');
        } else {
            angular.element('#right-sidebar').removeClass('sidebar-top');
        }
    });

    $timeout(function () {
        //fix_height();
    });

    // Minimalize menu when screen is less than 768px
    angular.element(window).bind("load resize", function () {
        if (angular.element(document).width() < 769) {
          angular.element('body').addClass('body-small')
          angular.element('body').addClass('mini-navbar')
        } else {
         angular.element('body').removeClass('body-small')
        }
    })



});

(function() {
    'use strict';
    angular.module('inspinia', [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'ui.bootstrap',
        'ui.bootstrap.modal',
        'ui.calendar',
        'ui.sortable',
        'ui.select',
        'cgNotify',
        'NgSwitchery',
        'datePicker',
        'datatables',
        'datatables.buttons',
        'localytics.directives',
        'ovh-angular-input-number-spinner',
        'chart.js',
        'app'
    ]);
})();
(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log){
    $log.debug('runBlock end');
  }

})();
(function () {

    angular.module("app.filters", [])

        /**
         * Returns a parsed float number
         */
        .filter("hebrewHolidayName", function() {

            var holidayNames = {
                "Erev Purim" : "ערב פורים",
                "Purim (Tel Aviv)" : "פורים",
                "Shushan Purim (Jerusalem)" : "שושן פורים",
                "Erev Pesach" : "ערב פסח",
                "Pesach I" : "פסח",
                "Pesach II" : "פסח",
                "Pesach III" : "פסח",
                "Pesach IV" : "פסח",
                "Pesach V" : "פסח",
                "Pesach VI" : "פסח",
                "Pesach VII" : "פסח",
                "Yom Ha'atzmaut" : "יום העצמאות",
                "Yom Ha'shoah" : "יום השואה",
                "Yom Ha'zikaron" : "יום הזכרון",
                "Yom Yerushalayim" : "יום ירושלים",
                "Erev Shavuot" : "ערב שבועות",
                "Shavuot" : "שבועות",
                "Erev Tisha B'Av" : "ערב תשעה באב",
                "Tisha B'Av" : "תשעה באב",
                "Erev Rosh Hashanah" : "ערב ראש השנה",
                "Rosh Hashanah" : "ראש השנה",
                "Rosh Hashanah II" : "ראש השנה",
                "Yom Kippur" : "יום כיפור",
                "Erev Sukkot" : "ערב סוכות",
                "Sukkot I" : "סוכות",
                "Sukkot II" : "סוכות",
                "Sukkot III" : "סוכות",
                "Sukkot IV" : "סוכות",
                "Sukkot V" : "סוכות",
                "Sukkot VI" : "סוכות",
                "Sukkot VII" : "סוכות",
                "Simchat Torah" : "שמחת תורה",
                "Hanukkah I" : "חנוכה",
                "Hanukkah II" : "חנוכה",
                "Hanukkah III" : "חנוכה",
                "Hanukkah IV" : "חנוכה",
                "Hanukkah V" : "חנוכה",
                "Hanukkah VI" : "חנוכה",
                "Hanukkah VII" : "חנוכה",
                "Hanukkah VIII" : "חנוכה"
            };

            return function(input) {

                if(holidayNames[input])
                    return holidayNames[input];

                return input;
            }
        })

        /**
         * Returns a parsed float number
         */
        .filter("parseFloat", function(dates) {
            return function(input) {
                return parseFloat(parseFloat(input).toFixed(2));
            }
        })

        /**
         * Returns a label of duration in minutes and hours
         */
        .filter("duration", function(dates) {
            return function(input) {

                for(var i in dates.duration)
                    if(dates.duration[i].duration == input)
                        return dates.duration[i].label;

                return input;
            }
        })

        /**
         * Retreive a formated decimal number for displaying price
         */
        .filter("price", function() {
            return function(input, ltr, numeric) {
                input = parseFloat(input).toFixed(2);

                if(numeric === true)
                    return input;

                // var decimalPoint = String(input).split(".")[1];

                if(ltr) {
                    // return Number(parseInt(input)).toLocaleString('en-US') + "." + decimalPoint + "₪";
                    return Number(parseInt(input)).toLocaleString('en-US') + "₪";
                }

                return "₪" + Number(parseInt(input)).toLocaleString('en-US');
            }
        })

        .filter("priceFloat", function() {
            return function(input, ltr, numeric) {
                var parsedInput = parseFloat(input).toFixed(2);

                if(isNaN(parsedInput))
                    parsedInput = 0;

                if(numeric === true)
                    return parsedInput;

                if(ltr) {
                    return Number(parsedInput).toLocaleString('en-US') + "₪";
                }

                return "₪" + Number(parsedInput).toLocaleString('en-US');
            }
        })

        .filter('thousands', function () {
            return function (input) {
                if (input == null) return '';
                // turn into string
                var str = input.toString();
                // split off any decimal part
                var parts = str.split('.');
                // insert commas in the integer part
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                // reassemble (will drop the dot if no fractional part)
                return parts.join('.');
            };
        })

        /**
         * Retrieve the default avatar in case the given url is empty
         */
        .filter("hourAndMinute", function () {

            return function (input) {

                input = input.split(":");

                return input[0] + ":" + input[1];
            };

        })

        /**
         * Return time with leading zeros
         */
        .filter("hourAndMinuteWithZeros", function () {
          return function (input) {
            input = input.split(":");
            input.forEach(function (val, index) {
              if (val.length < 2) {
                input[index] = '0' + val;
              }
            })
            return input[0] + ":" + input[1];
          };
        })

        /**
         * Retrieve the default avatar in case the given url is empty
         */
        .filter("defaultProfilePicture", function () {

            var defaultPictureURL = "assets/images/avatar.jpg";

            return function (input) {
                if (input == null)
                    return defaultPictureURL;

                return input;
            };

        })

        /**
         * Turns empty values into (---) for more aesthetic look
         */
        .filter("emptyValue", function () {

            return function(input) {

                if(input == "" || input == null)
                    return "---";

                return input;
            };
        })

        /**
         * Converts numeric represenation of gender to its text definiton
         */
        .filter("gender", function() {

            var genders = {
                "-1": "לא מוגדר",
                "0" : "זכר",
                "1" : "נקבה"
            };

            return function(input) {

                if(typeof genders[input] !== typeof undefined)
                    return genders[input];

                return input;
            };
        })

        /**
         * Converts numeric represenation of notifications type to its text definiton
         */
        .filter("notificationTypes", function() {

            var types = {
                "0": "SETTINGS_USER_REMINDER_NO",
                "1": "CUSTOMER_SETTING_EMAIL",
                "2": "CUSTOMERS_SMS",
                "3": "CUSTOMERS_WHATSAPP"
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })

        /**
         * Converts numeric represenation of send notifications type to its text definiton
         */
        .filter("notificationSendTypes", function() {

            var types = {
                "0": "OPTION_NO",
                "1": "OPTION_YES"
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })

        /**
         * Converts numeric represenation of send notifications type to its text definiton
         */
        .filter("sendReminderTypes", function() {

            var types = {
                "0": "SETTINGS_USER_REMINDER_NO",
                "2": "SETTINGS_USER_REMINDER_2_HOURS",
                "4": "SETTINGS_USER_REMINDER_4_HOURS",
                "24": "SETTINGS_USER_REMINDER_24_HOURS",
                "48": "SETTINGS_USER_REMINDER_48_HOURS",
                "72": "SETTINGS_USER_REMINDER_72_HOURS",
                "168": "SETTINGS_USER_REMINDER_168_HOURS"
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })

        /**
         * Converts numeric representation of send documents type to its text definition
         */
        .filter("sendDocumentsTypes", function() {

            var types = {
                "0": "SETTINGS_USER_REMINDER_NO",
                "1": "CUSTOMER_SETTING_EMAIL",
                "2": "CUSTOMERS_SMS",
                "3": "CUSTOMERS_WHATSAPP",
                "4": "CUSTOMERS_PRINT",
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })


        /**
         * Converts to Unix timestamp
         */
        .filter("toUnixTimestamp", function () {
            
            return function (timeString) {
                if (!timeString) {
                    return timeString;
                }
        
                // Define an array of possible date formats
                var dateFormats = [
                    'DD/MM/YYYY', // day/month/year
                    'MM/DD/YYYY', // month/day/year
                    'D/M/YYYY',   // day/month/year
                    'YYYY-MM-DD', // Year-month-day
                    'DD-MM-YYYY', // day-month-year
                    'DD/MM/YYYY', // day/month/year
                    'MM/DD/YYYY', // month/day/year
                    'D/M/YYYY',   // day/month/year
                    'YYYY/MM/DD', // Year/month/day
                    'HH:mm DD/MM/YYYY', // 24-hour time with day/month/year
                    'HH:mm MM/DD/YYYY', // 24-hour time with month/day/year
                    'HH:mm D/M/YYYY',   // 24-hour time with single-digit day/month/year
                    'YYYY-MM-DD HH:mm', // Year-month-day with 24-hour time
                    'YYYY-MM-DDTHH:mm', // Year-month-day with T separator
                    'YYYY/MM/DD HH:mm', // Year/month/day with 24-hour time
                    'YYYY/MM/DDTHH:mm', // Year/month/day with T separator
                    'HH:mm:ss DD/MM/YYYY', // 24-hour time with day/month/year
                    'HH:mm:ss MM/DD/YYYY', // 24-hour time with month/day/year
                    'HH:mm:ss D/M/YYYY',   // 24-hour time with single-digit day/month/year
                    'YYYY-MM-DD HH:mm:ss', // Year-month-day with 24-hour time
                    'YYYY-MM-DDTHH:mm:ss', // Year-month-day with T separator
                    'YYYY/MM/DD HH:mm:ss', // Year/month/day with 24-hour time
                    'YYYY/MM/DDTHH:mm:ss', // Year/month/day with T separator
                ];
        
                var inputTime = moment(timeString, dateFormats, 'he', true);
        
                if (!inputTime.isValid()) {
                    console.error('Invalid date format:', timeString);
                    return timeString; // Return the original string if parsing fails
                }
        
                return inputTime.format('x');
            };

            //old version
            return function (timeString) {
                if(!timeString) { return timeString; }

                if(timeString.indexOf('/') > -1) {
                    //timeString = timeString.split('/').join('-');
                    var dateParts = timeString.split('/');
                    // If the year is in the end the date parts should be reversed before joining
                    // to be parsed like a date.
                    if (dateParts[dateParts.length -1].length == 4) {
                        dateParts = dateParts.reverse()
                    }
                    timeString = dateParts.join('-');
                }
                moment.locale("he");
                var inputTime = moment(timeString);
                return inputTime.format('x');
            };
        })

        .filter('notEmptyCountFilter', function() {
            return function(filter) {
              var count = 0;
              for (var key in filter) {
                if (
                  filter[key] !== null &&
                  filter[key] !== false &&
                  filter[key] !== '' &&
                  !(Array.isArray(filter[key]) && filter[key].length === 0)
                ) {
                  count++;
                }
              }
              return count;
            };
        })


        /**
         * Convert boolean values to yes or no strings
         */
        .filter("booleanText", function() {

            return function(input, yes, no) {

                if(!yes)
                    yes = "כן";

                if(!no)
                    no = "לא";

                if(Boolean(input))
                    return yes;

                return no;
            }
        })

        .filter("nl2br", function($sce) {
            return function(input) {
                if (input) {
                    // Strip all HTML tags
                    var textOnly = input.replace(/<\/?[^>]+(>|$)/g, "");
                    // Replace newlines with <br />
                    var result = textOnly.replace(/\n/g, "<br />");
                    return $sce.trustAsHtml(result);
                }
                return input;
            };
        })

        /**
         * Convert URLs in text to clickable links
         * Returns plain HTML string for use in swal() or other HTML contexts
         * For template use with ng-bind-html, use the linkifyHtml filter
         */
        .filter("linkify", function() {
            return function(input) {
                if (!input) return input;
                var urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
                return input.replace(urlRegex, function(url) {
                    var href = url;
                    if (!url.match(/^https?:\/\//i)) {
                        href = 'http://' + url;
                    }
                    return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
                });
            };
        })

        /**
         * Convert URLs in text to clickable links for use in templates with ng-bind-html
         */
        .filter("linkifyHtml", function($sce) {
            return function(input) {
                if (!input) return input;
                var urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
                var result = input.replace(urlRegex, function(url) {
                    var href = url;
                    if (!url.match(/^https?:\/\//i)) {
                        href = 'http://' + url;
                    }
                    return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
                });
                return $sce.trustAsHtml(result);
            };
        })

        /**
         * Convert Gregorian date to Hebrew date format
         */
        .filter("hebrewDate", function(HebrewDate) {
            return function(input) {
                if (!input) return input;
                
                var date;
                if (input instanceof Date) {
                    date = input;
                } else if (typeof input === 'string') {
                    date = new Date(input);
                } else {
                    return input;
                }
                
                if (isNaN(date.getTime())) {
                    return input;
                }
                
                return HebrewDate.getHebrewDateString(date);
            };
        });

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')

  .directive("formControl", function () {

    var inputCount = 0;

    return {
      restrict: "C",

      link: function (scope, element, attrs) {

        if ((element.is('input') || element.is("textarea")) && element.closest(".form-group").find(">label").length) {

          inputCount++;

          if (!element.attr("id")) {
            element.attr("id", "input-id-" + inputCount);
            element.closest(".form-group").find("> label").attr("for", "input-id-" + inputCount);
          }

          //element.attr("placeholder", "");

          element.closest(".form-group").addClass("form-input");

          element.on("focus", function () {
            element.closest(".form-group").find(">label").addClass("is-focused");
          });

          element.on("blur", function () {
            element.closest(".form-group").find(">label").removeClass("is-focused");
          });

          var inputUpdate = function () {
            if ($.trim(element.val()).length)
              element.closest(".form-group").find(">label").addClass("has-value");
            else
              element.closest(".form-group").find(">label").removeClass("has-value");
          };

          element.on("input", inputUpdate);
          element.on("load", inputUpdate);
          scope.$watch(attrs.ngModel, inputUpdate);
        }
      }
    };
  })
  // .directive('sideNavigation', function ($timeout) {
  //     return {
  //         restrict: 'A',
  //         link: function (scope, element) {
  //             // Call metsi to build when user signup
  //             scope.$watch('authentication.user', function () {
  //                 $timeout(function () {
  //                     element.metisMenu();
  //                 });
  //             });

  //             // Colapse menu in mobile mode after click on element
  //             setTimeout(
  //                 function(){
  //                     var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
  //                     menuElement.click(function () {
  //                         if (angular.element(window).width() < 769) {
  //                             angular.element("body").toggleClass("mini-navbar");

  //                         }
  //                     });
  //                 },
  //                 1000
  //             );

  //             // Enable initial fixed sidebar
  //             if (angular.element("body").hasClass('fixed-sidebar')) {
  //                 var sidebar = element.parent();
  //                 sidebar.slimScroll({
  //                     height: '100%',
  //                     railOpacity: 0.9
  //                 });
  //             }
  //         }
  //     };
  // })
  // .directive('minimalizaSidebar', function ($timeout) {
  //     return {
  //         restrict: 'A',
  //         template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary2 " href="" ng-click="minimalize()"><img src="assets/images/backburger.svg" ></i></a>',
  //        // template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
  //         controller: function ($scope) {

  //             if (angular.element('body').hasClass('body-small')) {
  //                 // angular.element('body').toggleClass('mini-navbar'); navbar popup fix
  //             }

  //             $scope.minimalize = function () {
  //                 angular.element('body').toggleClass('mini-navbar');
  //                 if (!angular.element('body').hasClass('mini-navbar')) {
  //                     // Hide menu in order to smoothly turn on when maximize menu
  //                     angular.element('#side-menu').hide();
  //                     // For smoothly turn on menu
  //                     $timeout(function () {
  //                         angular.element('#side-menu').fadeIn(400);
  //                     }, 200);
  //                 } else {
  //                     // Remove all inline style from jquery fadeIn function to reset menu state
  //                     // angular.element('body').toggleClass('mini-navbar');
  //                     if (angular.element('body').hasClass('body-small')) {
  //                         angular.element('body').toggleClass('mini-navbar');
  //                         angular.element('.menuBackDrop').remove();
  //                     } else {
  //                         angular.element('#side-menu').removeAttr('style');
  //                     }
  //                 }
  //             };
  //         }
  //     };
  // })
  .directive("fileread", [function () {
    return {
      scope: {
        fileread: "="
      },
      link: function (scope, element, attributes) {
        element.bind("change", function (changeEvent) {
          var reader = new FileReader();
          reader.onload = function (loadEvent) {
            scope.$apply(function () {
              scope.fileread = loadEvent.target.result;
            });
          };
          reader.readAsDataURL(changeEvent.target.files[0]);
        });
      }
    }
  }])
angular.module('app').directive('autoExpand', function ($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var minHeight = element[0].offsetHeight;

      // Create a mirror textarea to measure the content
      var $shadow = angular.element('<div></div>').css({
        position: 'absolute',
        top: -10000,
        left: -10000,
        fontSize: element.css('fontSize'),
        fontFamily: element.css('fontFamily'),
        lineHeight: element.css('lineHeight'),
        resize: 'none',
        'word-wrap': 'break-word'
      });
      angular.element(document.body).append($shadow);

      var update = function () {
        if (element[0].offsetWidth === 0) return;

        // Read padding values dynamically each time to account for CSS changes
        var paddingLeft = parseInt(element.css('paddingLeft') || 0);
        var paddingRight = parseInt(element.css('paddingRight') || 0);

        var times = function (string, number) {
          return Array(number + 1).join(string);
        };

        var val = element.val().replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/&/g, '&amp;')
          .replace(/\n$/, '<br/>&nbsp;')
          .replace(/\n/g, '<br/>')
          .replace(/ {2,}/g, function (space) {
            return times('&nbsp;', space.length - 1) + ' ';
          });

        $shadow.css('width', element[0].offsetWidth - paddingLeft - paddingRight + 'px');
        $shadow.html(val);

        var newHeight = Math.max($shadow[0].offsetHeight + 20 /* the "threshold" */, minHeight);
        element.css('height', newHeight + 'px');
      };

      element.bind('input', update);

      // Trigger update on initialization
      scope.$watch(function () {
        return element.val();
      }, function () {
        $timeout(update, 350); // Wait for Bootstrap collapse animation (default: 350ms)
      });

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.target.offsetHeight > 0) {
            $timeout(update, 10); // Recalculate after becoming visible
          }
        });
      });

      var parent = element.closest('div');
      if (parent.length) {
        observer.observe(parent[0], { attributes: true, childList: true, subtree: true });
      }

      // Initialize the directive
      $timeout(update, 350);
    }
  };
})
  .directive('toggleSelect', function () {
    return {
      require: 'uiSelect',
      link: function (scope, element, attrs, $select) {
        var toggleSelectedItem = function (item) {
          var selectedItems = $select.selected;
          var idx = selectedItems.indexOf(item);
          //selectedItems like
          //0: {name: 'Women service', id: 7, $$hashKey: 'object:485'}
          //1: {name: 'גברים', id: 63, $$hashKey: 'object:486'}
          if (idx > -1) {
            // Item is already selected, remove it
            $select.selected.splice(idx, 1);
            $select.close();
            // To reflect changes in the view
            scope.$apply();
          }
        };

        element.on('click', '.ui-select-choices-row', function (e) {

          var itemScope = angular.element(e.target).scope();
          if (itemScope && itemScope.$id) {
            toggleSelectedItem(itemScope.$id);
          }
        });
      }
    };
  })
  .directive('toggleSelection', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var getModel = $parse(attrs.ngModel);
        var valueAttr = attrs.toggleSelection;

        // Listen for select event
        var clickedItem = false;
        scope.$on('uis:select', function (event, item) {
          clickedItem = item;
        });

        element.on('click', function (event) {
          event.stopPropagation(); // Still useful to prevent double handling
          var modelArray = getModel(scope) || [];
          var el = angular.element(event.target).scope();
          var item = el.$parent[valueAttr];

          if (clickedItem) {
            clickedItem = false;
            return;
          }
          if (!item) return;

          var idx = modelArray.indexOf(item);
          if (idx > -1) {
            modelArray.splice(idx, 1); // Remove item
          }

          getModel.assign(scope, modelArray);
          scope.$apply();
        });
      }
    };
  }])
  .directive('clickOutside', function ($document) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        var onClick = function (event) {
          var isOutside = (element[0] !== event.target) && !element[0].contains(event.target);
          if (isOutside) {
            scope.$apply(attr.clickOutside);
          }
        };

        $document.on('click', onClick);

        scope.$on('$destroy', function () {
          $document.off('click', onClick);
        });
      }
    };
  }).directive('chartJs', ['$rootScope', '$window', function ($rootScope, $window) {
    return {
      restrict: 'A',
      scope: {
        chartData: '=',
        chartOptions: '=',
        chartType: '='
      },
      link: function (scope, element) {
        var ctx = element[0].getContext('2d');
        var chart;

        Chart.register({
          id: 'gradientPlugin',
          beforeRender: function (chart) {
            var datasets = chart.config.data.datasets;
            var ctx = chart.ctx;
            var chartArea = chart.chartArea;

            // Use a traditional for loop for better compatibility
            for (var i = 0; i < datasets.length; i++) {
              var dataset = datasets[i];
              var originalColor = dataset.backgroundColor;

              // Check if originalColor is a string
              if (typeof originalColor !== 'string') {
                continue; // Skip if not a string
              }

              // Use the lightenColor method from $rootScope
              var lighterColor = $rootScope.lightenColor(originalColor, 10);

              // Create gradient
              var gradient = chart.config.options.indexAxis == 'y' ? ctx.createLinearGradient(0, chartArea.left, 0, chartArea.right) : ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
              gradient.addColorStop(0, originalColor);
              gradient.addColorStop(1, lighterColor);

              dataset.backgroundColor = gradient;
            }
          }
        });

        function renderChart() {
          if (chart) {
            chart.destroy();
          }

          var data = scope.chartData;
          var options = scope.chartOptions;
          var type = scope.chartType || 'line';

          if (data) {
            chart = new Chart(ctx, {
              type: type,
              data: data,
              options: options
            });
          }
        }

        // Watch for changes to data or type
        scope.$watchGroup(['chartData', 'chartOptions', 'chartType'], function (newValues) {
          renderChart();
        });

        var resizeHandler = function () {
          renderChart();
        };

        angular.element($window).on('resize', resizeHandler);

        scope.getChartInstance = function () {
          return chart;
        };
      }
    };
  }])
  .directive('tooltip2', [
    '$window', '$document', '$compile', '$timeout',
    function ($window, $document, $compile, $timeout) {
      return {
        restrict: 'A',
        scope: {
          tooltip2: '@',
          tooltip2Placement: '@', // expected values: top, bottom, left, right
          tooltip2Container: '@', // selector for container element
          tooltip2Size: '@'       // expected values: small, medium, large, content-fit, target-fit; you can pass "desktop,mobile"
        },
        link: function (scope, element, attrs) {
          var tooltipElement, container;
          var placement = scope.tooltip2Placement || 'top';

          container = $document.find('body');
          if (scope.tooltip2Container) {
            var found = $document[0].querySelector(scope.tooltip2Container);
            if (found) {
              container = angular.element(found);
            }
          }

          var sizeClassDesktop = '';
          var sizeClassMobile = '';
          if (scope.tooltip2Size) {
            var sizes = scope.tooltip2Size.split(',');
            sizeClassDesktop = sizes[0].trim();
            sizeClassMobile = sizes.length > 1 ? sizes[1].trim() : sizeClassDesktop;
          }

          var isMobile = 'ontouchstart' in $window;
          var appliedSizeClass = isMobile ? sizeClassMobile : sizeClassDesktop;

          var isHoveringTarget = false;
          var isHoveringTooltip = false;

          function createTooltip() {
            tooltipElement = angular.element('<div class="tooltip2"></div>');
            tooltipElement.append(scope.tooltip2.replace(/\n/gi, '<br />'));
            if (appliedSizeClass && appliedSizeClass !== 'target-fit') {
              tooltipElement.addClass(appliedSizeClass);
            }
            container.append(tooltipElement);
            $compile(tooltipElement)(scope);
          }

          function positionTooltip() {
            if (!tooltipElement) return;

            var targetRect = element[0].getBoundingClientRect();
            tooltipElement.css('display', 'block');

            if (appliedSizeClass === 'target-fit') {
              tooltipElement.css('width', targetRect.width + 'px');
            } else {
              tooltipElement.css('width', '');
            }

            var tooltipRect = tooltipElement[0].getBoundingClientRect();

            var top, left;

            switch (placement) {
              case 'bottom':
                top = targetRect.bottom;
                left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
                break;
              case 'left':
                top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
                left = targetRect.left - tooltipRect.width;
                break;
              case 'right':
                top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
                left = targetRect.right;
                break;
              case 'top':
              default:
                top = targetRect.top - tooltipRect.height;
                left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
            }

            top += $window.pageYOffset;
            left += $window.pageXOffset;

            var windowWidth = $window.innerWidth,
                windowHeight = $window.innerHeight;

            if (top < $window.pageYOffset) {
              top = targetRect.bottom + $window.pageYOffset;
            }
            if (top + tooltipRect.height > $window.pageYOffset + windowHeight) {
              top = targetRect.top - tooltipRect.height + $window.pageYOffset;
            }
            if (left < $window.pageXOffset) {
              left = targetRect.left + $window.pageXOffset;
            }
            if (left + tooltipRect.width > $window.pageXOffset + windowWidth) {
              left = targetRect.right - tooltipRect.width + $window.pageXOffset;
            }

            tooltipElement.css({ top: top + 'px', left: left + 'px' });
          }

          function showTooltip() {
            if (!tooltipElement) {
              createTooltip();
            }

            tooltipElement.css('display', 'block');
            $timeout(positionTooltip);

            // Tooltip hover tracking
            tooltipElement.on('mouseenter', function () {
              isHoveringTooltip = true;
            });
            tooltipElement.on('mouseleave', function () {
              isHoveringTooltip = false;
              checkHideTooltip();
            });

            angular.element($window).on('scroll.tooltip resize.tooltip', function () {
              var targetRect = element[0].getBoundingClientRect();
              if (targetRect.bottom < 0 || targetRect.top > $window.innerHeight) {
                hideTooltip();
              } else {
                positionTooltip();
              }
            });
          }

          function hideTooltip() {
            if (tooltipElement) {
              tooltipElement.css('display', 'none');
              tooltipElement.off('mouseenter');
              tooltipElement.off('mouseleave');
            }
            angular.element($window).off('scroll.tooltip resize.tooltip');
          }

          function checkHideTooltip() {
            $timeout(function () {
              if (!isHoveringTarget && !isHoveringTooltip) {
                hideTooltip();
              }
            }, 100);
          }

          // Hover tracking for target element
          element.on('mouseenter', function () {
            isHoveringTarget = true;
            showTooltip();
          });
          element.on('mouseleave', function () {
            isHoveringTarget = false;
            checkHideTooltip();
          });

          // Mobile support
          if (isMobile) {
            element.on('click', function (event) {
              event.stopPropagation();
              event.preventDefault();
              if (tooltipElement && tooltipElement.css('display') === 'block') {
                hideTooltip();
              } else {
                showTooltip();
              }
            });

            $document.on('click', function () {
              hideTooltip();
            });
          }

          scope.$on('$destroy', function () {
            if (tooltipElement) {
              tooltipElement.remove();
            }
            element.off('mouseenter mouseleave click');
            angular.element($window).off('scroll.tooltip resize.tooltip');
            $document.off('click');
          });
        }
      };
    }
  ]).directive('fixDatepickerPosition', function($timeout, $window, $document) {
    return {
        link: function(scope, element) {
            var wrapper = null;
            var repositionHandler = null;

            function findWrapper() {
                wrapper = $document[0].querySelector('[date-picker-wrapper]');
                if (wrapper) {
                    // Move wrapper to BODY → KEY step!
                    $document[0].body.appendChild(wrapper);
                }
            }

            function adjustPosition() {
              if (!wrapper) return;

              wrapper.style.position = 'absolute';
              wrapper.style.zIndex = 999999;

              var inputRect = element[0].getBoundingClientRect();

              var offsetY = window.innerWidth < 768 ? -60 : -40;
              var wrapperWidth = 290;
              var wrapperHeight = wrapper.scrollHeight > 0 ? wrapper.scrollHeight : 280;

              // Detect RTL
              var isRTL = window.getComputedStyle(element[0]).direction === 'rtl';

              if (isRTL) {
                  wrapper.style.left = ''; // clear left

                  var right = window.innerWidth - inputRect.right - window.scrollX;

                  if (right + wrapperWidth > window.innerWidth) {
                      right = window.innerWidth - wrapperWidth - 20;
                  }

                  if (right < 10) {
                      right = 10;
                  }

                  wrapper.style.right = right + 'px';
              } else {
                  // LTR → use LEFT
                  wrapper.style.right = ''; // clear right
                  var left = inputRect.left + window.scrollX;
                  if (left + wrapperWidth > window.innerWidth + window.scrollX) {
                      left = inputRect.right + window.scrollX - wrapperWidth;
                      if (left < 10) left = 10;
                  }
                  wrapper.style.left = left + 'px';
              }

              // Vertical position (unchanged)
              var spaceBelow = window.innerHeight + window.scrollY - (inputRect.bottom + window.scrollY) - offsetY;
              var spaceAbove = inputRect.top + window.scrollY;

              var top;

              if (spaceBelow >= wrapperHeight + Math.abs(offsetY)) {
                  top = inputRect.bottom + window.scrollY + offsetY;
              } else if (spaceAbove >= wrapperHeight + Math.abs(offsetY)) {
                  top = inputRect.top + window.scrollY - wrapperHeight - offsetY;
              } else {
                  top = inputRect.bottom + window.scrollY + offsetY;
              }

              wrapper.style.top = top + 'px';
            }

            function moveAndAdjust() {
                findWrapper();

                // Wait for wrapper to become visible
                var tries = 0;
                function waitForVisible() {
                    wrapper = $document[0].querySelector('[date-picker-wrapper]');
                    if (wrapper && wrapper.offsetParent !== null && wrapper.offsetWidth > 0) {
                        adjustPosition();

                        // Add resize/scroll listeners once
                        if (!repositionHandler) {
                            repositionHandler = function() {
                                adjustPosition();
                            };
                            $window.addEventListener('resize', repositionHandler);
                            $window.addEventListener('scroll', repositionHandler, true); // capture phase for nested scrolls
                        }
                    } else {
                        if (tries < 10) {
                            tries++;
                            $timeout(waitForVisible, 50);
                        }
                    }
                }

                waitForVisible();
            }

            // On input click or focus
            element.on('click focus', function() {
                $timeout(moveAndAdjust, 50);
            });

            // Cleanup on destroy
            scope.$on('$destroy', function() {
                if (repositionHandler) {
                    $window.removeEventListener('resize', repositionHandler);
                    $window.removeEventListener('scroll', repositionHandler, true);
                    repositionHandler = null;
                }
            });
        }
    };
  }).directive('forceCloseUiSelectOnOutsideClick', function ($document, $timeout) {
    return {
      restrict: 'A',
      require: 'uiSelect',
      link: function (scope, element, attrs, uiSelect) {
        $timeout(function () {
          function isInAnyOpenDropdown(target) {
            var nodes = document.querySelectorAll('.ui-select-choices, .ui-select-dropdown');
            for (var i = 0; i < nodes.length; i++) {
              var n = nodes[i];
              if (n.offsetParent !== null && n.contains(target)) return true;
            }
            return false;
          }

          function handler(e) {
            if (!uiSelect.open) return;
            if (element[0].contains(e.target)) return;
            if (isInAnyOpenDropdown(e.target)) return;

            scope.$evalAsync(function () {
              uiSelect.close();
            });
          }

          document.addEventListener('mousedown', handler, true);
          document.addEventListener('touchstart', handler, true);

          scope.$on('$destroy', function () {
            document.removeEventListener('mousedown', handler, true);
            document.removeEventListener('touchstart', handler, true);
          });
        });
      }
    };
  })
  .directive('linkify', ['$filter', function($filter) {
    return {
      restrict: 'A',
      scope: {
        linkify: '='
      },
      link: function(scope, element, attrs) {
        var linkifyFilter = $filter('linkifyHtml');
        
        scope.$watch('linkify', function(newValue) {
          if (newValue) {
            element.html(linkifyFilter(newValue));
          }
        });
      }
    };
  }])
  .directive('linkifyText', ['$filter', function($filter) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var linkifyFilter = $filter('linkifyHtml');
        
        var updateContent = function() {
          var text = element.text();
          if (text) {
            element.html(linkifyFilter(text));
          }
        };
        
        scope.$watch(function() {
          return element.text();
        }, function() {
          updateContent();
        });
        
        updateContent();
      }
    };
  }]);
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.users - Main users table state
             * app.settings.users.new - New users form state
             * app.settings.users.edit - Edit users form state
             */
            $stateProvider.state('app.admin.users', {
                url: "/users",
                views: {
                    "content@app": {
                        controller: "UsersListController as ctrl",
                        templateUrl: "app/modules/admin/modules/users/modules/users-list/users.list.html"
                    }
                },
                resolve: {
                    Users: function ($api) {
                        return $api.resolve("users@get");
                    }
                }
            });

            modalStateProvider.state("app.admin.users.new", {
                url: "/new",
                controller: "UsersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/admin/modules/users/modules/users-form/users.form.html",
                smallModal: true,
                resolve: {
                    Businesses: ['$api', function ($api) {
                      return $api.resolve("businesses@get");
                    }],
                    User: null
                }
            });

            modalStateProvider.state('app.admin.users.edit', {
                url: "/:id",
                controller: "UsersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/admin/modules/users/modules/users-form/users.form.html",
                smallModal: true,
                resolve: {
                    Businesses: ['$api', function ($api) {
                      return $api.resolve("businesses@get");
                    }],
                    User: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("users.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.admin.logs', {
                url: "/logs",
                views: {
                    "content@app": {
                        controller: "LogsListController as ctrl",
                        templateUrl: "app/modules/admin/modules/logs/modules/logs-list/logs.list.html"
                    }
                },
                resolve: {
                    Logs: function ($api) {
                        return [];
                    }
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      /**
       * Defining the following custom fields module routes:
       * app.admin.custom-fields - Main custom fields table state
       * app.admin.custom-fields.new - New custom field form state
       * app.admin.custom-fields.edit - Edit custom field form state
       */
      $stateProvider.state('app.admin.custom-fields', {
        url: '/custom-fields',
        views: {
          'content@app': {
            controller: 'CustomFieldsListController as ctrl',
            templateUrl: 'app/modules/admin/modules/custom-fields/modules/custom-fields-list/custom-fields.list.html'
          }
        },
        resolve: {
          CustomFields: function ($api) {
            return $api.resolve('customFields@get');
          }
        }
      });

      modalStateProvider.state('app.admin.custom-fields.new', {
        url: '/new',
        controller: 'CustomFieldsFormController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/admin/modules/custom-fields/modules/custom-fields-form/custom-fields.form.html',
        smallModal: true,
        resolve: {
          Businesses: ['$api', function ($api) {
            return $api.resolve('businesses@get');
          }],
          CustomField: null
        }
      });

      modalStateProvider.state('app.admin.custom-fields.edit', {
        url: '/:id',
        controller: 'CustomFieldsFormController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/admin/modules/custom-fields/modules/custom-fields-form/custom-fields.form.html',
        smallModal: true,
        resolve: {
          Businesses: ['$api', function ($api) {
            return $api.resolve("businesses@get");
          }],
          CustomField: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customFields.single@get', { 'id': $rootScope.$stateParams.id });
          }]
        }
      });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.sms_logs', {
                url: "/sms_logs",
                views: {
                    "content@app": {
                        controller: "SmsLogsController as ctrl",
                        templateUrl: "app/modules/settings/sms_logs/modules/sms_logs/sms_logs.html"
                    }
                },
                resolve: {
                    Logs: ['$api', function ($api) {
                        return $api.resolve("sms_logs@get");
                    }],
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.second_resources', {
                url: "/second_resources",
                views: {
                    "content@app": {
                        controller: "SecondResourcesListController as ctrl",
                        templateUrl: "app/modules/settings/second_resources/modules/second-resources-list/second_resources.list.html"
                    }
                },
                resolve: {
                    SecondResources: function ($api) {
                        return $api.resolve("second_resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    }
                }
            });

            modalStateProvider.state('app.settings.second_resources.single', {
                url: "/single/:id",
                controller: "SecondResourcesSingleController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-single/second_resources.single.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    SecondResource: ['$api', '$stateParams', '$rootScope', function ($api, $stateParams, $rootScope) {
                        var id = $rootScope.$stateParams && $rootScope.$stateParams.id ? $rootScope.$stateParams.id : $stateParams.id;
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("second_resources.single@get", {"id": id});
                    }],
                    Info: ['$api', function ($api) {
                      return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.second_resources.edit', {
                url: "/edit/:id",
                controller: "SecondResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-form/second_resources.form.html",
                smallModal: true,
                resolve: {
                    SecondResource: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("second_resources.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state("app.settings.second_resources.new", {
                url: "/new",
                controller: "SecondResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-form/second_resources.form.html",
                smallModal: true,
                resolve: {
                    SecondResource: null,
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state('app.settings.second_resources.capacity', {
                url: "/capacity/:id",
                controller: "SecondResourcesCapacityController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-capacity/second_resources.capacity.html",
                smallModal: true,
                resolve: {
                    CapacityData: ['$api', '$rootScope', '$state', function ($api, $rootScope, $state) {
                        if(typeof $rootScope.$stateParams.id === typeof undefined || $rootScope.$stateParams.id == null) {
                            return null;
                        }
                        return $api.resolve("second_resources.capacity.single@get", {
                            "id": $rootScope.$stateParams.id,
                            "date": $rootScope.capacityDate,
                            "capacity_type": $rootScope.capacityType
                        });
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.resources - Main resources table state
             * app.settings.resources.new - New resource form state
             * app.settings.resources.edit - Edit resource form state
             */
            $stateProvider.state('app.settings.resources', {
                url: "/resources",
                views: {
                    "content@app": {
                        controller: "ResourcesListController as ctrl",
                        templateUrl: "app/modules/settings/resources/modules/resources-list/resources.list.html"
                    }
                },
                resolve: {
                    Resources: function ($api) {
                        return $api.resolve("resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    }
                }
            });

            modalStateProvider.state('app.settings.resources.single', {
                url: "/single/:id",
                controller: "ResourcesSingleController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-single/resources.single.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Resource: ['$api', '$stateParams', '$rootScope', function ($api, $stateParams, $rootScope) {
                        var id = $rootScope.$stateParams && $rootScope.$stateParams.id ? $rootScope.$stateParams.id : $stateParams.id;
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("resources.single@get", {"id": id});
                    }],
                    Info: ['$api', function ($api) {
                      return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.resources.edit', {
                url: "/edit/:id",
                controller: "ResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-form/resources.form.html",
                smallModal: true,
                resolve: {
                    Resource: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state("app.settings.resources.new", {
                url: "/new",
                controller: "ResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-form/resources.form.html",
                smallModal: true,
                resolve: {
                    Resource: null,
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state('app.settings.resources.edit_permissions', {
                url: "/edit_permissions/:id",
                controller: "ResourcesPermissionsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-permissions/resources.permissions.html",
                smallModal: true,
                resolve: {
                    Resource: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state('app.settings.resources.capacity', {
                url: "/capacity/:id",
                controller: "ResourcesCapacityController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-capacity/resources.capacity.html",
                smallModal: true,
                resolve: {
                    CapacityData: ['$api', '$rootScope', '$state', function ($api, $rootScope, $state) {
                        if(typeof $rootScope.$stateParams.id === typeof undefined || $rootScope.$stateParams.id == null) {
                            return null;
                        }
                        return $api.resolve("resources.capacity.single@get", {
                            "id": $rootScope.$stateParams.id,
                            "date": $rootScope.capacityDate,
                            "capacity_type": $rootScope.capacityType
                        });
                    }]
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.settings.photos_stock', {
        url: '/photos_stock',
        views: {
          'content@app': {
            controller: 'PhotosStockSettingsController as ctrl',
            templateUrl: 'app/modules/settings/photos_stock/photos_stock.html'
          }
        },
        resolve: {
          PhotosStock: ['$api', function ($api) {
            return $api.resolve('photosStock@get');
          }]
        }
      });
    });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            // Business online state
            $stateProvider.state('app.settings.online', {
                url: "/online",
                views: {
                    "content@app": {
                        controller: "OnlineSettingsController as ctrl",
                        templateUrl: "app/modules/settings/online/settings.online.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

             // Messages settings
             $stateProvider.state('app.settings.messages', {
                url: "/messages",
                views: {
                    "content@app": {
                        controller: "MessagesSettingsController as ctrl",
                        templateUrl: "app/modules/settings/messages/settings.messages.html",
                    }
                },
                resolve: {
                    Messages: ['$api', function ($api) {
                        return $api.resolve("settings.messages@get");
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following logs module routes:
             * app.settings.logs - Main logs table state
             * app.settings.logs.info - New logs form state
             */
            $stateProvider.state('app.settings.logs', {
                url: "/logs",
                views: {
                    "content@app": {
                        controller: "LogsController as ctrl",
                        templateUrl: "app/modules/settings/logs/modules/logs-list/logs.list.html"
                    }
                }
            });

            modalStateProvider.state('app.settings.logs.info', {
                url: "/:id",
                controller: "LogsInfoController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/logs/modules/logs-info/logs.info.html",
                smallModal: true,
                resolve: {
                    Transaction: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("transactions.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.leads', {
                url: "/leads",
                views: {
                    "content@app": {
                        controller: "LeadsSettingsController as ctrl",
                        templateUrl: "app/modules/settings/leads/modules/leads-settings/leads.settings.html"
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            $stateProvider.state('app.settings.leads.statuses', {
                url: "/statuses",
                views: {
                    "content@app": {
                        controller: "LeadsStatusesController as ctrl",
                        templateUrl: "app/modules/settings/leads/modules/leads-statuses/leads.statuses.html"
                    }
                },
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                }
            });

            modalStateProvider.state("app.settings.leads.facebook", {
                url: "/facebook",
                controller: "LeadsFacebookController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-facebook/leads.facebook.html",
                smallModal: true,
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state("app.settings.leads.webhook", {
                url: "/webhook",
                controller: "LeadsWebhookController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-webhook/leads.webhook.html",
                smallModal: true,
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state("app.settings.leads.whatsapp", {
                url: "/whatsapp",
                controller: "LeadsWhatsappController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-whatsapp/leads.whatsapp.html",
                smallModal: true,
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state("app.settings.leads.statuses.new", {
                url: "/new",
                controller: "LeadsStatusesNewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-statuses-new/leads.statuses.new.html",
                smallModal: true,
                resolve: {
                    Status: null
                }
            });

            modalStateProvider.state("app.settings.leads.statuses.edit", {
                url: "/:id",
                controller: "LeadsStatusesNewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-statuses-new/leads.statuses.new.html",
                smallModal: true,
                resolve: {
                    Status: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("statuses.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.laser_file', {
                url: "/laser_file",
                views: {
                    "content@app": {
                        controller: "LaserFileSettingsController as ctrl",
                        templateUrl: "app/modules/settings/laser_file/settings.laser_file.html",
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.laser_file@get");
                    }]
                }
            });

            
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            // Business landing state
            $stateProvider.state('app.settings.landing', {
                url: "/landing",
                views: {
                    "content@app": {
                        controller: "LandingSettingsController as ctrl",
                        templateUrl: "app/modules/settings/landing/settings.landing.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.items - Main items table state
             * app.settings.items.new - New items form state
             * app.settings.items.edit - Edit items form state
             */
            $stateProvider.state('app.settings.items', {
                url: "/items",
                views: {
                    "content@app": {
                        controller: "ItemsListController as ctrl",
                        templateUrl: "app/modules/settings/items/modules/items-list/items.list.html"
                    }
                },
                resolve: {
                    Items: ['$api', function ($api) {
                        return $api.resolve("items_list@get");
                    }],
                    Categories: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories@get");
                    }]
                }
            });

            $stateProvider.state('app.settings.items.stock_log', {
                url: "/stock_log/{item_id:int}",
                views: {
                    "content@app": {
                        controller: "ItemsStockLogController as ctrl",
                        templateUrl: "app/modules/settings/items/stock_log/items.stock_log.html"
                    }
                },
                resolve: {
                    Item: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("items.single@get", {"id": $stateParams.item_id});
                    },
                    StockTransactions: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("items.transactions@get", {"item_id": $stateParams.item_id});
                    }
                }
            });

            modalStateProvider.state("app.settings.items.new", {
                url: "/new",
                controller: "ItemsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/items/modules/items-form/items.form.html",
                smallModal: true,
                resolve: {
                    Item: null,
                    Items: ['$api', function ($api) {
                        return $api.resolve("items@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    Categories: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories@get");
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    Resources: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources@get");
                    }],
                }
            });

            modalStateProvider.state('app.settings.items.edit', {
                url: "/:id",
                controller: "ItemsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/items/modules/items-form/items.form.html",
                smallModal: true,
                resolve: {
                    Item: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("items.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    Items: ['$api', function($api) {
                        return $api.resolve("items@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    Categories: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories@get");
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    Resources: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources@get");
                    }],
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.info', {
                url: "/info",
                views: {
                    "content@app": {
                        controller: "InfoSettingsController as ctrl",
                        templateUrl: "app/modules/settings/info/info.view.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.google_calendar', {
                url: "/google_calendar",
                views: {
                    "content@app": {
                        controller: "GoogleCalendarController as ctrl",
                        templateUrl: 'app/modules/settings/google_calendar/google_calendar.view.html'
                    }
                },
                resolve: {
                    GoogleCalendarAccounts: function ($api) {
                        return $api.resolve("googlecalendar@get");
                    },
                }
            });

        });

})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      $stateProvider.state('app.settings.gift_cards', {
        url: "/gift_cards",
        views: {
          "content@app": {
            controller: "GiftCardsListSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/list/list.view.html",
          }
        },
        resolve: {
          GiftCards: ['$api', function ($api) {
            return $api.resolve("giftCard@get");
          }]
        }
      });

      $stateProvider.state('app.settings.gift_cards.templates', {
        url: "/templates",
        views: {
          "content@app": {
            controller: "GiftCardsTemplatesSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/templates/templates.view.html",
          }
        },
        resolve: {
          GiftCardsTemplates: ['$api', function ($api) {
            return $api.resolve("giftCardTemplate@get");
          }]
        }
      });

      $stateProvider.state('app.settings.gift_cards.single', {
        url: "/:id",
        views: {
          "content@app": {
            controller: "GiftCardsSingleSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/single/single.view.html",
          }
        },
        resolve: {
          GiftCard: ['$api', '$stateParams', function ($api, $stateParams) {
            return $api.resolve("giftCard.single@get", { id: $stateParams.id });
          }],
          Transactions: ['$api', '$stateParams', function ($api, $stateParams) {
            return $api.resolve("giftCard.transactions.single@get", { id: $stateParams.id });
          }],
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
        }
      });

      $stateProvider.state('app.settings.gift_cards.templates.new', {
        url: "/new",
        views: {
          "content@app": {
            controller: "GiftCardsTemplateSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/template/template.view.html",
          }
        },
        resolve: {
          GiftCardsTemplate: [function () { return null; }],
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
        }
      });

      $stateProvider.state('app.settings.gift_cards.templates.single', {
        url: "/:id",
        views: {
          "content@app": {
            controller: "GiftCardsTemplateSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/template/template.view.html",
          }
        },
        resolve: {
          GiftCardsTemplate: ['$api', '$stateParams', function ($api, $stateParams) {
            return $api.resolve("giftCardTemplate.single@get", { id: $stateParams.id });
          }],
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
        }
      });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            modalStateProvider.state('app.settings.documents_he', {
                url: "/documents/he",
                controller: "DocumentSettingsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/documents/documents.view.html",
                smallModal: true,
                resolve: {
                    Language: function() {
                        return "he";
                    },
                    Settings: ['$api', function($api) {
                        return $api.resolve("settings.documents@get", {
                            "lang" : "he"
                        })
                    }]
                }
            });

            modalStateProvider.state('app.settings.documents_en', {
                url: "/documents/en",
                controller: "DocumentSettingsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/documents/documents.view.html",
                smallModal: true,
                resolve: {
                    Language: function() {
                        return "en";
                    },
                    Settings: ['$api', function($api) {
                        return $api.resolve("settings.documents@get", {
                            "lang" : "en"
                        })
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.digital_forms', {
                url: "/digital_forms",
                views: {
                    "content@app": {
                        controller: "DigitalFormsListController as ctrl",
                        templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-list/digital_forms.list.html"
                    }
                },
                resolve: {
                    DigitalForms: ['$api', function ($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                }
            });
            

            modalStateProvider.state('app.settings.digital_forms.preview', {
                url: "/formpreview/:id",
                controller: "DigitalFormsPreviewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-preview/digital_forms.preview.html",
                resolve: {
                    DForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms.preview@get", {"id": $rootScope.$stateParams.id});
                    }],
                }
            });

            modalStateProvider.state('app.settings.digital_forms.templates', {
                url: "/formtemplates",
                controller: "DigitalFormsTemplatesController",
                controllerAs: "ctrl",
                smallModal: true,
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-templates/digital_forms.templates.html",
                resolve: {
                    TemplatesList: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms.templates_list@get");
                    }],
                }
            });

            modalStateProvider.state("app.settings.digital_forms.new", {
                url: "/new",
                controller: "DigitalFormsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html",
                smallModal: true,
                resolve: {
                    DigitalForm: null,
                    DigitalForms: ['$api', function ($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    PhotosStock: ['$api', function ($api) {
                        return $api.resolve("photosStock@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.digital_forms.edit', {
                url: "/:id",
                controller: "DigitalFormsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html",
                smallModal: true,
                resolve: {
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    PhotosStock: ['$api', function ($api) {
                        return $api.resolve("photosStock@get");
                    }]  

                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

             // Digital documents settings
             $stateProvider.state('app.settings.digital_documents', {
                url: "/digital_documents",
                views: {
                    "content@app": {
                        controller: "DigitalDocumentsSettingsController as ctrl",
                        templateUrl: "app/modules/settings/digital_documents/settings.digital_documents.html",
                    }
                },
                resolve: {
                    DigitalDocuments: ['$api', function ($api) {
                        return $api.resolve("settings.digital_documents@get");
                    }]
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.settings.custom_fields', {
        url: '/custom_fields',
        views: {
          'content@app': {
            controller: 'CustomFieldsSettingsController as ctrl',
            templateUrl: 'app/modules/settings/custom_fields/custom_fields.html'
          }
        },
        resolve: {
          CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customFields.lists@get');
          }]
        }
      });

      $stateProvider.state('app.settings.custom_fields.single', {
        url: '/:id',
        views: {
          'content@app': {
            controller: 'CustomFieldsSingleSettingsController as ctrl',
            templateUrl: 'app/modules/settings/custom_fields/modules/custom_fields_single/custom_fields.single.html'
          }
        },
        resolve: {
          CustomField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('customFields.list@get', { id: $stateParams.id });
          }],
        }
      });

      modalStateProvider.state('app.settings.custom_fields.single.new', {
        url: '/new',
        controller: 'CustomFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/custom_fields/modules/custom_fields_form/custom_fields.form.html',
        smallModal: true,
        resolve: {
          CustomFieldValue: null
        }
      });

      modalStateProvider.state('app.settings.custom_fields.single.edit', {
        url: '/:vid',
        controller: 'CustomFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/custom_fields/modules/custom_fields_form/custom_fields.form.html',
        smallModal: true,
        resolve: {
          CustomFieldValue: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customFields.value.get@get', { id: $rootScope.$stateParams.id, vid: $rootScope.$stateParams.vid });
          }],
        }
      });
    });
})();
(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.settings.courses_fields', {
        url: '/courses_fields',
        views: {
          'content@app': {
            controller: 'CoursesFieldsSettingsController as ctrl',
            templateUrl: 'app/modules/settings/courses_fields/courses_fields.html'
          }
        },
        resolve: {
          CoursesFields: ['$api', function ($api) {
            return $api.resolve('coursesFields.lists@get');
          }]
        }
      });

      $stateProvider.state('app.settings.courses_fields.single', {
        url: '/:id',
        views: {
          'content@app': {
            controller: 'CoursesFieldsSingleSettingsController as ctrl',
            templateUrl: 'app/modules/settings/courses_fields/modules/courses_fields_single/courses_fields.single.html'
          }
        },
        resolve: {
          CoursesField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('coursesFields.list@get', { id: $stateParams.id });
          }],
        }
      });

      modalStateProvider.state('app.settings.courses_fields.single.new', {
        url: '/new',
        controller: 'CoursesFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/courses_fields/modules/courses_fields_form/courses_fields.form.html',
        smallModal: true,
        resolve: {
          CoursesFieldValue: null,
          CoursesField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('coursesFields.list@get', { id: $stateParams.id });
          }],
        }
      });

      modalStateProvider.state('app.settings.courses_fields.single.edit', {
        url: '/:vid',
        controller: 'CoursesFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/courses_fields/modules/courses_fields_form/courses_fields.form.html',
        smallModal: true,
        resolve: {
          CoursesFieldValue: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('coursesFields.value.get@get', { id: $rootScope.$stateParams.id, vid: $rootScope.$stateParams.vid });
          }],
          CoursesField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('coursesFields.list@get', { id: $stateParams.id });
          }],
        }
      });
    });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            // Business color state
            $stateProvider.state('app.settings.color', {
                url: "/color",
                views: {
                    "content@app": {
                        controller: "ColorSettingsController as ctrl",
                        templateUrl: "app/modules/settings/color/settings.color.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.categories - Main resources table state
             * app.settings.categories.new - New resource form state
             * app.settings.categories.edit - Edit resource form state
             */
            $stateProvider.state('app.settings.categories', {
                url: "/categories",
                views: {
                    "content@app": {
                        controller: "CategoriesListController as ctrl",
                        templateUrl: "app/modules/settings/categories/modules/categories-list/categories.list.html"
                    }
                },
                resolve: {
                    Categories: function ($api) {
                        return $api.resolve("categories@get");
                    }
                }
            });

            modalStateProvider.state("app.settings.categories.new", {
                url: "/new",
                controller: "CategoriesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/categories/modules/categories-form/categories.form.html",
                smallModal: true,
                resolve: {
                    Category: null
                }
            });

            modalStateProvider.state('app.settings.categories.edit', {
                url: "/:id",
                controller: "CategoriesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/categories/modules/categories-form/categories.form.html",
                smallModal: true,
                resolve: {
                    Category: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.call_logs', {
                url: "/call_logs",
                views: {
                    "content@app": {
                        controller: "CallLogsController as ctrl",
                        templateUrl: "app/modules/settings/call_logs/modules/call_logs/call_logs.html"
                    }
                },
                resolve: {
                    CallLogs: ['$api', function ($api) {
                        return $api.resolve("call_logs@get");
                    }],
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.additional_fields', {
                url: "/additional_fields",
                views: {
                    "content@app": {
                        controller: "AdditionalFieldsSettingsController as ctrl",
                        templateUrl: "app/modules/settings/additional_fields/additional_fields.html"
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],

                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.lists@get");
                    }]
                }
            });

            $stateProvider.state('app.settings.additional_fields.interested', {
                url: "/interested",
                views: {
                    "content@app": {
                        controller: "InterestedController as ctrl",
                        templateUrl: "app/modules/settings/additional_fields/modules/interested/interested.html"
                    }
                },
                resolve: {
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                }
            });

            modalStateProvider.state("app.settings.additional_fields.interested.new", {
                url: "/new",
                controller: "InterestedFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/additional_fields/modules/interested-form/interested-form.html",
                smallModal: true,
                resolve: {
                    Interested: null
                }
            });

            modalStateProvider.state("app.settings.additional_fields.interested.edit", {
                url: "/:id",
                controller: "InterestedFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/additional_fields/modules/interested-form/interested-form.html",
                smallModal: true,
                resolve: {
                    Interested: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("interested.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        $stateProvider.state('app.marketing.recommendations', {
            url: "/recommendations",
            views: {
                "content@app": {
                    controller: "RecommendationsController as ctrl",
                    templateUrl: "app/modules/marketing/recommendations/recommendations.view.html"
                }
            },
            resolve: {
                Recommendations: ['$api', function ($api) {
                    return $api.resolve("automations.recommendations@get");
                }],
            }
        });
    });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        $stateProvider.state('app.marketing.automations', {
            url: "/automations",
            views: {
                "content@app": {
                    controller: "AutomationsController as ctrl",
                    templateUrl: "app/modules/marketing/automations/automations.view.html"
                }
            },
            resolve: {
                Automations: ['$api', function ($api) {
                    return $api.resolve("automations@get");
                }],
            }
        });

        modalStateProvider.state("app.marketing.automations.new", {
            url: "/new",
            controller: "AutomationsFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/marketing/automations/form/automations.form.html",
            mediumModal: true,
            resolve: {
                Automation: null,
                DigitalForms: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("digital_forms@get");
                }],
                CustomerStatuses: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("statuses@get");
                }],
            }
        });

        modalStateProvider.state('app.marketing.automations.edit', {
            url: "/:id",
            controller: "AutomationsFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/marketing/automations/form/automations.form.html",
            mediumModal: true,
            resolve: {
                Automation: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("automations.single@get", {"id": $rootScope.$stateParams.id});
                }],
                DigitalForms: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("digital_forms@get");
                }],
                CustomerStatuses: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("statuses@get");
                }],
            }
        });
    });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.workers', {
                url: "/workers",
                views: {
                    "content@app": {
                        controller: "WorkersListController as ctrl",
                        templateUrl: "app/modules/workers/modules/workers-list/workers.list.html"
                    }
                }
            });

            $stateProvider.state('app.workers.single', {
                url: "/{id:int}",
                views: {
                    "content@app": {
                        controller: "WorkersSingleController as ctrl",
                        templateUrl: "app/modules/workers/modules/workers-single/workers.single.html"
                    }
                },
                resolve: {
                    Worker: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("workers.single@get", {"id": $stateParams.id});
                    }
                }
            });

            

            modalStateProvider.state("app.workers.new", {
                url: "/new",
                controller: "WorkersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/workers/modules/workers-form/workers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Worker: null,
                    isModal: false,
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state('app.workers.single.edit', {
                url: "/edit",
                controller: "WorkersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/workers/modules/workers-form/workers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Worker: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("workers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    isModal: false,
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.tutorials_center', {
                url: "/tutorials_center",
                views: {
                    "content@app": {
                        controller: "TutorialsCenterController as ctrl",
                        templateUrl: "app/modules/tutorials_center/tutorials_center.html"
                    }
                }
            });
    });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the main abstract settings state (app.settings)
             */
            $stateProvider.state('app.settings', {
                url: "/settings",
                views: {
                    "content@app": {
                        controller: "SettingsController as ctrl",
                        templateUrl: "app/modules/settings/settings.view.html"
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

            /**
             * app.reports - Main state of the reports module
             */
            $stateProvider.state('app.reports', {
                url: "/reports?tab",
                views: {
                    "content@app": {
                        controller: "ReportsController as ctrl",
                        templateUrl: "app/modules/reports/reports.view.html"
                    }
                },
                params: {
                    tab: { value: '4', squash: true }
                },
                resolve: {
                    //Customers: function ($api) {
                    //    return $api.resolve("customers@get");
                    //},
                    Resources: function ($api) {
                      return $api.resolve("resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                }
            });

            // Tax files
            modalStateProvider.state('app.reports.tax_files', {
                url: "/tax_files",
                controller: "TaxFilesReportsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/reports/tax_files/reports.tax_files.html",
                smallModal: true,
                resolve: {
                }
            });
        });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      modalStateProvider.state('app.pdf-preview', {
        controller: "PdfPreviewController",
        controllerAs: "ctrl",
        templateUrl: "app/modules/pdf-preview/pdf-preview.view.html",
        smallModal: true,
        resolve: {
          pdfUrl: function ($pdfUrl) {
            return $pdfUrl;
          },
          imageUrl: function ($imageUrl) {
            return $imageUrl;
          }

        }
      });
    });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        
        $stateProvider.state('pay', {
            url: "/pay/{id}",
            controller: "PayController as ctrl",
            templateUrl: "app/modules/pay/pay.view.html",
            resolve: {
                Order: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("pay@get", {"id": $rootScope.$stateParams.id});
                },
            }
        });
    });

        
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.notifications', {
                url: "/notifications",
                views: {
                    "content@app": {
                        controller: "NotificationsListController as ctrl",
                        templateUrl: "app/modules/notifications/modules/notifications_list/notifications_list.html"
                    }
                },
                resolve: {
                    Notifications: ['$api', function ($api) {
                        return $api.resolve("notifications.list@get");
                    }],
                }
            });
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.notes', {
                url: "/notes",
                views: {
                    "content@app": {
                        controller: "NotesListController as ctrl",
                        templateUrl: "app/modules/notes/modules/notes-list/notes.list.html"
                    }
                }
            });            
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            
        });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        $stateProvider.state('app.marketing', {
            url: "/marketing",
            views: {
                "content@app": {
                    controller: "MarketingController as ctrl",
                    templateUrl: "app/modules/marketing/marketing.view.html"
                }
            },
            resolve: {
            }
        });
    });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){
        $stateProvider.state('login', {
            url: "/login",
            controller: "LoginController as ctrl",
            templateUrl: "app/modules/login/login.html",
            data: {
                specialClass: 'gray-bg login-page'
            }
        });
        modalStateProvider.state('login.forgot_password', {
            url: "/forgot_password",
            controller: "ForgotPasswordController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/forgot_password/forgot_password.html",
            smallModal: true
        });
        modalStateProvider.state('forgotpassword', {
            url: "/forgotpassword",
            controller: "ForgotPasswordConfirmController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/forgot_password_confirm/forgot_password_confirm.html",
            smallModal: true
        });
        modalStateProvider.state('login.termsofuse', {
            url: "/termsofuse",
            controller: "TermsOfUseController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/terms-of-use/terms-of-use.html",
            smallModal: true
        });
        modalStateProvider.state('approval', {
            url: "/approval/{id}",
            controller: "ApprovalController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/approval/approval.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("approval@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: null
            }
        });
        modalStateProvider.state('order', {
            url: "/order/{id}",
            controller: "ApprovalController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/approval/approval.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("approval@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: true
            }
        });
        modalStateProvider.state('review', {
            url: "/review/{id}",
            controller: "ReviewController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/review/review.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("review@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: null
            }
        });
        modalStateProvider.state('document', {
            url: "/document/{id}",
            controller: "DigitalDocumentsController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/digital_documents/digital_documents.view.html",
            resolve: {
                DigitalDocument: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("customer_documents@get", {"id": $rootScope.$stateParams.id});
                }],
            }
        });
        modalStateProvider.state('form', {
            url: "/form/{id}",
            controller: "DigitalFormsController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/digital_forms/digital_forms.view.html",
            resolve: {
                DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("customer_forms@get", {"id": $rootScope.$stateParams.id});
                }],
            }
        });
        modalStateProvider.state('view_approval', {
            url: "/approval/{id}/{view:int}",
            controller: "ApprovalController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/approval/approval.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("approval@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: ['$rootScope', function ($rootScope) {
                    return $rootScope.$stateParams.view;
                }]
            }
        });
        modalStateProvider.state('prepaid', {
            url: "/prepaid/{id}",
            controller: "PrepaidController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/prepaid/prepaid.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("prepaid@get", {"id": $rootScope.$stateParams.id});
                }],
            }
        });
        $stateProvider.state('gift_card', {
            url: "/gift_card/{id}",
            controller: "PublicGiftCardController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/gift_card/gift_card.view.html",
            resolve: {
                GiftCard: ['$api', '$stateParams', function ($api, $stateParams) {
                    return $api.resolve("publicGiftCard.single@get", { id: $stateParams.id });
                }],
            }
        });

        modalStateProvider.state('cardrequest', {
            url: "/cardrequest/{id}",
            controller: "PublicCardRequestController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/customers/modules/customers-card-request/customers.card_request.html",
            resolve: {
                Info: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("customers.request_card_iframe@get", { id: $rootScope.$stateParams.id });
                }],
            }
        });
    });
})();
(function(){
  angular.module('app.modules').config(function ($stateProvider, modalStateProvider){
    $stateProvider.state('app.digital_forms', {
      url: "/digital_forms",
      views: {
        "content@app": {
          controller: "DigitalFormsAllListController as ctrl",
          templateUrl: "app/modules/digital_forms/modules/digital-forms-list/digital-forms.list.html"
        }
      }
    });
  });
})();
(function(){
    angular.module('app.modules').config(function( $stateProvider ){
        $stateProvider.state('app.dashboard', {
            url: "/",
            views: {
                "content@app": {
                    controller  : "DashboardController as ctrl",
                    templateUrl : "app/modules/dashboard/dashboard.html"
                }
            },
            resolve: {
                // Orders: function ($api) {
                //     return $api.orders.today_orders.get();
                // },
                Customers: function ($api) {
                  return $api.resolve('customers.today_birthday@get');
                },
                Info: function ($api) {
                    return $api.resolve("settings.info@get");
                },
                Analytics: function($api) {
                    return $api.resolve("analytics@get", {
                        "type": "income",
                        "filter": "monthly",
                        "getAll": true
                    });
                },
            }
        });

        $stateProvider.state('app.dashboard.load', {
            url: "load",
            views: {
                "content@app": {
                    controller  : "DashboardController as ctrl",
                    templateUrl : "app/modules/dashboard/dashboard_load.html"
                }
            },
            resolve: {
                Customers: function ($api) {
                    return null;
                },
                Info: function ($api) {
                    return null;
                },
                Analytics: function($api) {
                    return null
                },
            }
          });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * app.orders - Main state of the customers_bookings module
             */
            $stateProvider.state('app.customers_bookings', {
                url: "/customers_bookings",
                views: {
                    "content@app": {
                        controller: "CustomersBookingsController as ctrl",
                        templateUrl: "app/modules/customers_bookings/list/list.view.html"
                    }
                }
            });

        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.customers', {
                url: "/customers",
                views: {
                    "content@app": {
                        controller: "CustomersListController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-list/customers.list.html"
                    }
                }
            });

            $stateProvider.state('app.leads', {
                url: "/leads",
                views: {
                    "content@app": {
                        controller: "LeadsListController as ctrl",
                        templateUrl: "app/modules/customers/modules/leads-list/leads.list.html"
                    }
                },
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Resources: ['$api', function ($api) {
                        return $api.resolve("resources@get");
                    }],
                }
            });

            $stateProvider.state('app.customers.single', {
                url: "/{id:int}",
                views: {
                    "content@app": {
                        controller: "CustomersSingleController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-single/customers.single.html"
                    }
                },
                resolve: {
                    Customer: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("customers.single@get", {"id": $stateParams.id});
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    LaserInfo: function ($api) {
                        return $api.resolve("settings.laser_file@get");
                    },
                    CustomFields: function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    },
                }
            });

            $stateProvider.state('app.leads.single', {
                url: "/{id:int}",
                views: {
                    "content@app": {
                        controller: "CustomersSingleController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-single/customers.single.html"
                    }
                },
                resolve: {
                    Customer: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("customers.single@get", {"id": $stateParams.id});
                    },
                    Cards: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("cards.customers@get", {"id": $stateParams.id});
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },

                    LaserFields: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("laser_file@get", {"customer_id": $stateParams.id});
                    },
                    LaserInfo: function ($api) {
                        return $api.resolve("settings.laser_file@get");
                    },
                    CustomFields: function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    },
                }
            });
            
            modalStateProvider.state('customers_public_form', {
                url: "/cform/{id}",
                controller: "CustomersPublicFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-public-form/customers.public.form.html",
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("social.customer@get", {"id": $rootScope.$stateParams.id});
                    }],
                }
            });

            $stateProvider.state('app.customers.card_transactions', {
                url: "/{id:int}/card_transactions/{card_id:int}",
                views: {
                    "content@app": {
                        controller: "CustomersCardTransactionsController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-single/cards/transactions.list.html"
                    }
                },
                resolve: {
                    Customer: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("customers.single@get", {"id": $stateParams.id});
                    },
                    Card: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("cards.single@get", {"id": $stateParams.card_id});
                    },
                    CardsTransactions: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("cards.transactions@get", {"card_id": $stateParams.card_id});
                    }
                }
            });

            modalStateProvider.state("app.customers.new", {
                url: "/new",
                controller: "CustomersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Customer: null,
                    isModal: false,
                    Lead: false,
                    Info: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("settings.info@get");
                    }],
                    Resources: ['$api', function ($api) {
                      return $api.resolve("resources@get");
                    }],
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    }],
                    Phone: null,
                }
            });

            modalStateProvider.state("app.leads.new_lead", {
                url: "/new_lead",
                controller: "CustomersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Customer: null,
                    isModal: false,
                    Lead: true,
                    Info: ['$api', '$rootScope', function ($api, $rootScope) {
                        console.log($rootScope);
                        return $api.resolve("settings.info@get");
                    }],
                    Resources: ['$api', function ($api) {
                      return $api.resolve("resources@get");
                    }],
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    }],
                    Phone: null,
                }
            });

            modalStateProvider.state('app.customers.single.edit', {
                url: "/edit",
                controller: "CustomersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    isModal: false,
                    Lead: false,
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    Resources: ['$api', function ($api) {
                      return $api.resolve("resources@get");
                    }],
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    }],
                    Phone: null,
                }
            });

            modalStateProvider.state('app.customers.single.sms', {
                url: "/sms",
                controller: "CustomersSMSController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-sms/customers.sms.html",
                smallModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });

            modalStateProvider.state('app.customers.single.dd', {
                url: "/dd",
                controller: "CustomersDDController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-dd/customers.dd.html",
                smallModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });

            modalStateProvider.state('app.customers.single.df', {
                url: "/df",
                controller: "CustomersDFController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-df/customers.df.html",
                smallModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });

            modalStateProvider.state('app.customers.single.customers_digital_form', {
                url: "/customer-form/{form_id:int}",
                controller: "CustomersDigitalFormsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
                windowTopClass: "form-modal medium-modal laser-file-modal",
                mediumModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customer_forms@get", {"id": $rootScope.$stateParams.form_id});
                    }],
                    DigitalForms: null,
                    Order: null,
                    Business: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                }
            });

            modalStateProvider.state('app.customers.single.customers_digital_form_print', {
                url: "/customer-form-print/{form_id:int}",
                controller: "CustomersDigitalFormsPrintController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html",
                mediumModal: true,
                windowTopClass: "form-modal medium-modal laser-file-modal print-form-modal",
                resolve: {
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customer_forms@get", {"id": $rootScope.$stateParams.form_id});
                    }],
                }
            });

            modalStateProvider.state('app.customers.single.customers_digital_form_add', {
                url: "/customer-form-add",
                controller: "CustomersDigitalFormsAddController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                mediumModal: true,
                windowTopClass: "form-modal medium-modal laser-file-modal",
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    OrderForm: false,
                    DigitalForm: null,
                    Order: null,
                }
            });
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider){
        $stateProvider.state('app.cashbox', {
            url: "/cashbox",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Resources: function($api) {
                    return $api.resolve("resources@get");
                },
                Customer: function() {
                    return null;
                },
                Transaction: function() {
                    return null
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.credit', {
            url: "/cashbox/credit/:transaction",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function() {
                    return null;
                },
                Transaction: function($api, $stateParams) {
                    return $api.resolve("transactions.single@get", {"id": $stateParams.transaction});
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.closedebt', {
            url: "/cashbox/closedebt/:customer",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function($api, $stateParams) {
                    return $api.resolve("customers.single@get",  {"id": $stateParams.customer});
                },
                Transaction: function() {
                    return null
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.order', {
            url: "/cashbox/order/:orderID",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function($api){
                    return $api.resolve("categories@get");
                },
                Items: function($api){
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function(){
                    return null;
                },
                Order: function($api, $stateParams) {
                    return $api.resolve("orders.single@get", {"id": $stateParams.orderID});
                },
                Transaction: function(){
                    return null;
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function($api, $stateParams){
                  return $api.resolve("cards.for_order@get", {"id": $stateParams.orderID});
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.retainer', {
            url: "/cashbox/retainer/:retainerID",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function($api){
                    return $api.resolve("categories@get");
                },
                Items: function($api){
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function(){
                    return null;
                },
                Order: function($api, $stateParams) {
                    return null;
                },
                Transaction: function(){
                    return null;
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function($api, $stateParams){
                  return null;
                },
                Retainer: function($api, $stateParams){
                  return $api.resolve("transactions.retainer@get", {"id": $stateParams.retainerID});
                },
            }
        });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

          $stateProvider.state('e', {
            url: "/e/{id}",
            controller: "CalendarEventController as ctrl",
            templateUrl: "app/modules/calendar_event/calendar_event.view.html",
            resolve: {
                Order: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("calendar_event@get", {"id": $rootScope.$stateParams.id});
                },
            }
          });

        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * app.orders - Main state of the orders module
             */
            $stateProvider.state('app.calendar', {
                url: "/calendar",
                views: {
                    "content@app": {
                        controller: "CalendarController as ctrl",
                        templateUrl: "app/modules/calendar/calendar.view.html"
                    }
                },
                resolve: {
                    Resources: function($api) {
                        return $api.resolve("resources.capacity.all@get");

                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Lflag: function ($api) {
                        return 0;
                    },
                    Holidays: function($api) {
                        return $api.resolve("holidays@get", {
                            "year" : new Date().getFullYear()
                        });
                    },
                    Customer: function($api) {
                      return null;
                    }
                }
            });


            $stateProvider.state('app.calendar.date', {
              url: "/:date",
              views: {
                  "content@app": {
                      controller: "CalendarController as ctrl",
                      templateUrl: "app/modules/calendar/calendar.view.html"
                  }
              },
              resolve: {
                  Resources: function($api) {
                      return $api.resolve("resources.capacity.all@get");

                  },
                  Info: function ($api) {
                      return $api.resolve("settings.info@get");
                  },
                  Lflag: function ($api) {
                      return 0;
                  },
                  Holidays: function($api) {
                      return $api.resolve("holidays@get", {
                          "year" : new Date().getFullYear()
                      });
                  },
                  Customer: function($api) {
                    return null;
                  }
              }
          });


            $stateProvider.state('app.calendar.call', {
              url: "/call/:phone",
              views: {
                  "content@app": {
                      controller: "CalendarController as ctrl",
                      templateUrl: "app/modules/calendar/calendar.view.html"
                  }
              },
              resolve: {
                Resources: function($api) {
                    return $api.resolve("resources.capacity.all@get");

                },
                Info: function ($api) {
                    return $api.resolve("settings.info@get");
                },
                Lflag: function ($api) {
                    return 0;
                },
                Holidays: function($api) {
                    return $api.resolve("holidays@get", {
                        "year" : new Date().getFullYear()
                    });
                },
                Customer: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("customers.find@get", {"str": $stateParams.phone});
                }
              }
            });

            $stateProvider.state('app.calendar.customer', {
              url: "/customer/:id",
              views: {
                  "content@app": {
                      controller: "CalendarController as ctrl",
                      templateUrl: "app/modules/calendar/calendar.view.html"
                  }
              },
              resolve: {
                Resources: function($api) {
                    return $api.resolve("resources.capacity.all@get");

                },
                Info: function ($api) {
                    return $api.resolve("settings.info@get");
                },
                Lflag: function ($api) {
                    return 0;
                },
                Holidays: function($api) {
                    return $api.resolve("holidays@get", {
                        "year" : new Date().getFullYear()
                    });
                },
                Customer: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("customers.single@get", {"id": $stateParams.id});
                }
              }
            });

            $stateProvider.state('app.calendar.login', {
                url: "/type/:view",
                views: {
                    "content@app": {
                        controller: "CalendarController as ctrl",
                        templateUrl: "app/modules/calendar/calendar.view.html"
                    }
                },
                resolve: {
                    Resources: function($api) {
                        return $api.resolve("resources.capacity.all@get");

                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Lflag: function ($api) {
                        return 1;
                    },
                    Holidays: function($api) {
                        return $api.resolve("holidays@get", {
                            "year" : new Date().getFullYear()
                        });
                    },
                    Customer: function($api) {
                      return null;
                    },
                }
            });

            modalStateProvider.state('app.calendar.order-edit', {
              url: "/order/:id",
              controller: "OrderFormController",
              controllerAs: "ctrl",
              templateUrl: "app/modules/calendar/order/order.form.html",
              windowClass: "form-modal medium-modal order-edit-modal side-modal",
              resolve: {
                Items: ['$api', function ($api) {
                  return $api.resolve("items.items_with_duration@get");
                }],
                Resources: ['$api', function ($api) {
                  return $api.resolve("resources@get");
                }],
                SecondResources: ['$api', function ($api) {
                  return $api.resolve("second_resources@get");
                }],
                Info: ['$api', function ($api) {
                  return $api.resolve("settings.info@get");
                }],
                Clubs: ['$api', function ($api) {
                  return $api.resolve("settings.clubs@get");
                }],
                Messages: ['$api', function ($api) {
                  return $api.resolve("settings.messages@get");
                }],
                Customer: [function () {
                  return null;
                }],
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                  return $api.resolve("orders.single@get", {
                    "id": $rootScope.$stateParams.id
                  });
                }],
                CalendarEvent: [function () {
                  return null;
                }],
                CalendarCourse: [function () {
                  return null;
                }],
                EventCopy: [function () {
                  return false;
                }],
                CoursesFields: ['$api', function ($api) {
                  return $api.resolve('coursesFields.lists@get');
                }],
              },
              onExit: function() {
                console.log('client: onExit');
              }
            });

            modalStateProvider.state('app.calendar.order-copy', {
              url: "/copy/:id",
              controller: "OrderFormController",
              controllerAs: "ctrl",
              templateUrl: "app/modules/calendar/order/order.form.html",
              windowClass: "form-modal medium-modal order-edit-modal side-modal",
              resolve: {
                Items: ['$api', function ($api) {
                  return $api.resolve("items.items_with_duration@get");
                }],
                Resources: ['$api', function ($api) {
                  return $api.resolve("resources@get");
                }],
                SecondResources: ['$api', function ($api) {
                  return $api.resolve("second_resources@get");
                }],
                Info: ['$api', function ($api) {
                  return $api.resolve("settings.info@get");
                }],
                Clubs: ['$api', function ($api) {
                  return $api.resolve("settings.clubs@get");
                }],
                Messages: ['$api', function ($api) {
                  return $api.resolve("settings.messages@get");
                }],
                Customer: [function () {
                  return null;
                }],
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                  return $api.resolve("orders.single@get", {
                    "id": $rootScope.$stateParams.id
                  });
                }],
                CalendarEvent: [function () {
                  return null;
                }],
                CalendarCourse: [function () {
                  return null;
                }],
                EventCopy: [function () {
                  return true;
                }],
                CoursesFields: ['$api', function ($api) {
                  return $api.resolve('coursesFields.lists@get');
                }],
              },
              onExit: function() {
                console.log('client: onExit');
              }
            });

          modalStateProvider.state('app.calendar.event-edit', {
            url: "/event/:id",
            controller: "OrderFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/calendar/order/order.form.html",
            windowClass: "form-modal medium-modal order-edit-modal side-modal",
            resolve: {
              Items: ['$api', function ($api) {
                return $api.resolve("items.items_with_duration@get");
              }],
              Resources: ['$api', function ($api) {
                return $api.resolve("resources@get");
              }],
              SecondResources: ['$api', function ($api) {
                return $api.resolve("second_resources@get");
              }],
              Info: ['$api', function ($api) {
                return $api.resolve("settings.info@get");
              }],
              Clubs: ['$api', function ($api) {
                return $api.resolve("settings.clubs@get");
              }],
              Messages: ['$api', function ($api) {
                return $api.resolve("settings.messages@get");
              }],
              Customer: [function () {
                return null;
              }],
              Order: [function () {
                return null;
              }],
              CalendarEvent: ['$api', '$rootScope', function($api, $rootScope) {
                return $api.resolve("events.single@get", {
                  "id": $rootScope.$stateParams.id
                });
              }],
              CalendarCourse: [function () {
                return null;
              }],
              EventCopy: [function () {
                return false;
              }],
              CoursesFields: ['$api', function ($api) {
                return $api.resolve('coursesFields.lists@get');
              }],
            }
          });


          modalStateProvider.state('app.calendar.course-edit', {
            url: "/course/:id",
            controller: "OrderFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/calendar/order/order.form.html",
            windowClass: "form-modal medium-modal order-edit-modal side-modal",
            resolve: {
              Items: ['$api', function ($api) {
                return $api.resolve("items.items_with_duration@get");
              }],
              Resources: ['$api', function ($api) {
                return $api.resolve("resources@get");
              }],
              SecondResources: ['$api', function ($api) {
                return $api.resolve("second_resources@get");
              }],
              Info: ['$api', function ($api) {
                return $api.resolve("settings.info@get");
              }],
              Clubs: ['$api', function ($api) {
                return $api.resolve("settings.clubs@get");
              }],
              Messages: ['$api', function ($api) {
                return $api.resolve("settings.messages@get");
              }],
              Customer: [function () {
                return null;
              }],
              Order: [function () {
                return null;
              }],
              CalendarEvent: [function () {
                return null;
              }],
              CalendarCourse: ['$api', '$rootScope', function($api, $rootScope) {
                return $api.resolve("courses.single@get", {
                  "id": $rootScope.$stateParams.id
                });
              }],
              EventCopy: [function () {
                return false;
              }],
              CoursesFields: ['$api', function ($api) {
                return $api.resolve('coursesFields.lists@get');
              }],
            }
          });

        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.businesses - Main resources table state
             * app.businesses.new - New resource form state
             * app.businesses.edit - Edit resource form state
             */
            $stateProvider.state('app.businesses', {
                url: "/businesses",
                views: {
                    "content@app": {
                        controller: "BusinessesListController as ctrl",
                        templateUrl: "app/modules/settings/businesses/modules/businesses-list/businesses.list.html"
                    }
                },
                resolve: {
                    Businesses: function ($api) {
                        return $api.resolve("businesses@get");
                    }
                }
            });

            modalStateProvider.state("app.businesses.new", {
                url: "/new",
                controller: "BusinessesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/businesses/modules/businesses-form/businesses.form.html",
                smallModal: true,
                resolve: {
                    Business: null
                }
            });

            modalStateProvider.state('app.businesses.edit', {
                url: "/:id",
                controller: "BusinessesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/businesses/modules/businesses-form/businesses.form.html",
                smallModal: true,
                resolve: {
                    Business: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("businesses.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * app.analytics - Main state of the cashbox module
             */
            $stateProvider.state('app.analytics', {
                url: "/analytics",
                views: {
                    "content@app": {
                        controller: "AnalyticsController as ctrl",
                        templateUrl: "app/modules/analytics/analytics.view.html"
                    }
                },
                resolve: {
                    Analytics: function($api) {
                        return $api.resolve("analytics@get", {
                            "type": "all",
                            "filter": "monthly"
                        });
                    }
                }
            });
        });
})();
(function(){
  angular.module('app.modules').config(function($stateProvider, modalStateProvider){
    $stateProvider.state('app.admin', {
      url: "/super",
      views: {
        "content@app": {
          controller  : "AdminController as ctrl",
          templateUrl : "app/modules/admin/admin.view.html"
        }
      },
      resolve: {
        Businesses: ['$api', function ($api) {
          return $api.resolve("businesses@get");
        }],
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
        Settings: ['$api', function ($api) {
          return $api.resolve("admin.settings@get");
        }],
      }
    });

    $stateProvider.state('app.admin.single-business', {
      url: "/business/:id",
      views: {
        "content@app": {
          controller  : "BusinessSingleController as ctrl",
          templateUrl : "app/modules/admin/modules/business-single/business.single.html"
        }
      },
      resolve: {
        Business: function ($api, $stateParams, $rootScope) {
          $rootScope.$stateParams = $stateParams;
          return $api.resolve("businesses.single@get", {"id": $rootScope.$stateParams.id});
        },
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
      }
    });

    modalStateProvider.state("app.admin.new", {
      url: "/new-business",
      controller: "BusinessFormController",
      controllerAs: "ctrl",
      templateUrl: "app/modules/admin/modules/business-form/business.form.html",
      resolve: {
        Types: ['$api', function ($api) {
          return $api.resolve("businesses.types@get");
        }],
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
        Business: null,
        Resources: null
      }
    });

    modalStateProvider.state("app.admin.copy", {
      url: "/new-business-copy",
      controller: "BusinessCopyController",
      controllerAs: "ctrl",
      smallModal: true,
      templateUrl: "app/modules/admin/modules/business-copy/business.copy.html",
      resolve: {
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
      }
    });

    modalStateProvider.state("app.admin.message", {
      url: "/message-business",
      controller: "BusinessMessageController",
      controllerAs: "ctrl",
      smallModal: true,
      templateUrl: "app/modules/admin/modules/business-message/business.message.html",
      resolve: {
        Types: ['$api', function ($api) {
          return $api.resolve("businesses.types@get");
        }],
        Business: null,
        Resources: null
      }
    });

    // modalStateProvider.state('app.admin.editbusiness', {
    modalStateProvider.state('app.admin.single-business.edit', {
      url: "/edit",
      controller: "BusinessFormController",
      controllerAs: "ctrl",
      templateUrl: "app/modules/admin/modules/business-form/business.form.html",
      resolve: {
        Business: ['$api', '$rootScope', function ($api, $rootScope) {
          return $api.resolve("businesses.single@get", {"id": $rootScope.$stateParams.id});
        }],
        Types: ['$api', function ($api) {
          return $api.resolve("businesses.types@get");
        }],
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
        Resources: ['$api', '$rootScope', function ($api, $rootScope) {
          return $api.resolve("resources@get", {"b_id": $rootScope.$stateParams.id});
        }]
      }
    });
  });
})();

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/ai-dialog/ai-dialog.view.html","<div class=\"ai-dialog\" ng-cloak=\"\" ai-dialog-drag-resize=\"\" ng-class=\"{\'is-mounted\': $ctrl.mounted, \'is-visible\': $ctrl.state.visible, \'ai-dialog--min\': $ctrl.state.minimized}\" ng-style=\"{insetInlineEnd: $ctrl.state.position.insetInlineEnd + \'px\', bottom: $ctrl.state.position.bottom + \'px\', width: $ctrl.state.size.width + \'px\', height: $ctrl.state.size.height + \'px\'}\"><div class=\"ai-dialog__header\" role=\"toolbar\"><div class=\"ai-dialog__title\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewbox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z\"></path></svg>AI Assistant</div><div class=\"ai-dialog__actions\"><button type=\"button\" class=\"ai-dialog__btn\" ng-click=\"$ctrl.toggleMinimize()\" title=\"Minimize\"><i class=\"las la-minus\"></i></button> <button type=\"button\" class=\"ai-dialog__btn\" ng-click=\"$ctrl.close()\" title=\"Close\"><i class=\"las la-times\"></i></button></div></div><div class=\"ai-dialog__body\" ng-if=\"!$ctrl.state.minimized\"><button ng-if=\"$ctrl.messages.length > 1\" type=\"button\" class=\"ai-dialog__button-new\" ng-click=\"$ctrl.resetSession()\"><i class=\"las la-edit\"></i></button><div class=\"ai-dialog__messages\" scroll-bottom=\"$ctrl.messages\" scroll-bottom-trigger=\"$ctrl.state.visible + \'-\' + $ctrl.state.minimized\"><div ng-repeat=\"m in $ctrl.messages track by $index\" class=\"ai-dialog__msg\" ng-class=\"{\'ai-dialog__msg--user\': m.role === \'user\'}\"><ai-render ng-if=\"m.render\" data=\"m.render\" meta=\"m.meta\" style=\"width: 100%\"></ai-render><div ng-if=\"!m.render\" class=\"ai-dialog__bubble\" ng-bind=\"m.text\"></div></div><div ng-if=\"$ctrl.loading\" class=\"ai-dialog__msg\"><div class=\"ai-dialog__bubble\"><i class=\"las la-spinner la-spin\"></i> Thinking...</div></div></div><form class=\"ai-dialog__input\" ng-submit=\"$ctrl.send()\"><textarea ng-model=\"$ctrl.input\" class=\"form-control\" auto-expand=\"\" placeholder=\"Write your request\" ng-keydown=\"$ctrl.onTextareaKeydown($event)\"></textarea> <button ng-if=\"!$ctrl.loading\" type=\"submit\" ng-disabled=\"$ctrl.loading\"><i class=\"las la-arrow-circle-up\"></i></button> <button ng-if=\"$ctrl.loading\" type=\"button\" ng-disabled=\"$ctrl.loading\"><i class=\"las la-spinner la-spin\"></i></button></form></div><div class=\"ai-dialog__minimized\" ng-if=\"$ctrl.state.minimized\" ng-click=\"$ctrl.toggleMinimize()\" tabindex=\"0\" role=\"button\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewbox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z\"></path></svg></div><div class=\"ai-dialog__resize\"></div></div>");
$templateCache.put("app/components/ai-dialog/ai-render.view.html","<div class=\"ai-render\"><div class=\"ai-render__summary\" ng-if=\"vm.data.summary\">{{ vm.data.summary }}</div><div class=\"ai-render__block\" ng-repeat=\"b in vm.data.blocks track by $index\" ng-switch=\"b.type\"><div ng-switch-when=\"table\" class=\"ai-render__table\"><table class=\"ai-render__tbl\" role=\"table\" aria-label=\"{{ b.title || \'table\' }}\"><thead><tr><th ng-repeat=\"c in b.columns track by $index\">{{ c.label || c.key }}</th></tr></thead><tbody><tr ng-repeat=\"row in b._rowsNorm = vm.visibleRows(b) track by $index\" ng-class=\"{clickable: !!b.row_link}\" ng-click=\"vm.onRowClick(b, row)\"><td ng-repeat=\"c in b.columns track by $index\">{{ vm.formatCell(vm.cell(row, $index), c) }}</td></tr></tbody></table></div><div ng-switch-when=\"note\" class=\"ai-render__note\" ng-class=\"\'ai-render__note--\' + (b.style || \'info\')\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__text\">{{ b.text }}</div></div><div ng-switch-when=\"list\" class=\"ai-render__list\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><ul><li ng-repeat=\"it in (b.items || []) track by $index\"><a ng-if=\"vm.safeHref(it.href)\" ng-href=\"{{ vm.safeHref(it.href) }}\">{{ it.text }}</a> <span ng-if=\"!vm.safeHref(it.href)\">{{ it.text }}</span></li></ul></div><div ng-switch-when=\"stat\" class=\"ai-render__stats\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__stats-grid\"><div class=\"ai-render__stat\" ng-repeat=\"s in (b.stats || []) track by $index\"><div class=\"ai-render__stat-label\">{{ s.label }}</div><div class=\"ai-render__stat-value\">{{ (s.value === true ? \'Yes\' : (s.value === false ? \'No\' : s.value)) }} <span class=\"ai-render__stat-unit\" ng-if=\"s.unit\">{{ s.unit }}</span></div></div></div></div><div ng-switch-when=\"chart\" class=\"ai-render__chart\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__chart-canvas\" ng-if=\"vm.hasChart()\"><canvas width=\"400\" height=\"240\" ai-chart=\"\" block=\"b\"></canvas></div><div class=\"ai-render__chart-fallback\" ng-if=\"!vm.hasChart()\"><table class=\"ai-render__tbl\"><thead><tr><th>{{ b.xKey || \'Category\' }}</th><th ng-repeat=\"yk in (b.yKeys || []) track by $index\">{{ yk }}</th></tr></thead><tbody><tr ng-repeat=\"r in (b.data || []) track by $index\"><td>{{ r[(b.xKey || \'\')] }}</td><td ng-repeat=\"yk in (b.yKeys || []) track by $index\">{{ r[yk] }}</td></tr></tbody></table></div></div><div ng-switch-default=\"\" class=\"ai-render__unknown\">Unsupported block: {{ b.type }}</div></div><div class=\"ai-render__rate\"><div class=\"ai-render__rate-thumb ai-render__rate-good\" ng-class=\"{active: vm.meta.rating == true}\" ng-click=\"vm.onRate(true)\"><i class=\"las la-thumbs-up\"></i></div><div class=\"ai-render__rate-thumb ai-render__rate-bad\" ng-class=\"{active: vm.meta.rating == false}\" ng-click=\"vm.onRate(false)\"><i class=\"las la-thumbs-down\"></i></div></div></div>");
$templateCache.put("app/components/cfilter/button.html","<div ng-controller=\"CfilterController as cfilter\"><div class=\"filter-button\"><button type=\"button\" class=\"btn icon default\" ng-click=\"cfilter.openFilter()\"><span ng-show=\"(cfilter.filter | notEmptyCountFilter) > 0\" class=\"filter-count\">{{cfilter.filter | notEmptyCountFilter}}</span><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal\': true, \'active\': cfilter.filterModal}\" ng-click=\"event.stopPropagation();\"><div><div><div class=\"form-group form-select\"><label>{{\"FILTER_ITEMS\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.item\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_ITEMS\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"item\" ng-model=\"cfilter.filter.item\" repeat=\"item in cfilter.filter_values.items | filter:$select.search\"><span class=\"multicheck\"></span>{{item.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_CATEGORY\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.category\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"category\" ng-model=\"cfilter.filter.category\" repeat=\"category in cfilter.filter_values.categories | filter:$select.search track by category.id\"><span class=\"multicheck\"></span>{{category.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_RESOURCE\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.resource\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"resource\" ng-model=\"cfilter.filter.resource\" repeat=\"resource in cfilter.filter_values.resources | filter:$select.search track by resource.id\"><span class=\"multicheck\"></span>{{resource.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_ARRIVAL_SOURCE\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.arrival_source\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_ARRIVAL_SOURCE\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"source\" ng-model=\"cfilter.filter.arrival_source\" repeat=\"source in cfilter.filter_values.arrival_sources | filter:$select.search\"><span class=\"multicheck\"></span>{{source.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_INTERESTED_IN\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.interested\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_INTERESTED_IN\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"interested\" ng-model=\"cfilter.filter.interested\" repeat=\"interested in cfilter.filter_values.interested | filter:$select.search\"><span class=\"multicheck\"></span>{{interested.name}}</ui-select-choices></ui-select></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.lastvisit_from || cfilter.filter.lastvisit_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.lastvisit_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.lastvisit_to || cfilter.filter.lastvisit_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.lastvisit_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.created_from || cfilter.filter.created_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.created_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.created_to || cfilter.filter.created_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.created_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_BIRTHDAY\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.birthday\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_BIRTHDAY\" | translate}}\'>{{$item.value}}</ui-select-match><ui-select-choices toggle-selection=\"monthName\" ng-model=\"cfilter.filter.birthday\" repeat=\"(month, monthName) in datesProvider.months | filter:$select.search\"><span class=\"multicheck\"></span>{{monthName.value}}</ui-select-choices></ui-select></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.visited_from || cfilter.filter.visited_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.visited_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.visited_to || cfilter.filter.visited_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.visited_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div><div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"cfilter.filter.have_card\">{{\"FILTER_HAVE_CARDS\" | translate}}</label></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_GENDER\" | translate}}</label><select class=\"form-control\" ng-model=\"cfilter.filter.gender\"><option value=\"\">{{\"FILTER_GENDER\" | translate}}</option><option value=\"0\">{{\"CUSTOMERS_GENDER_MALE\" | translate}}</option><option value=\"1\">{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</option></select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_STATUS\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.status\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_STATUS\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"source\" ng-model=\"cfilter.filter.status\" repeat=\"source in cfilter.filter_values.statuses | filter:$select.search\"><span class=\"multicheck\"></span>{{source.name}}</ui-select-choices></ui-select></div></div></div><div ng-if=\"cfilter.module == \'marketing\'\"><div class=\"form-group form-select\"><label>{{\"FILTER_TYPE\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.type\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_TYPE\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"source\" ng-model=\"cfilter.filter.status\" repeat=\"source in cfilter.filter_values.types | filter:$select.search\"><span class=\"multicheck\"></span>{{source.name}}</ui-select-choices></ui-select></div></div></div><div class=\"not-select\"><div><div class=\"form-group form-select\"><label>{{\"FILTER_CAMPAIGN_NAME\" | translate}}</label><select class=\"form-control\" ng-model=\"cfilter.filter.campaign\"><option value=\"\">{{\"FILTER_CAMPAIGN_NAME\" | translate}}</option><option ng-repeat=\"item in cfilter.filter_values.campaigns\" value=\"{{item.id}}\">{{item.name}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_AD_NAME\" | translate}}</label><select class=\"form-control\" ng-model=\"cfilter.filter.ad\"><option value=\"\">{{\"FILTER_AD_NAME\" | translate}}</option><option ng-repeat=\"item in cfilter.filter_values.ads\" value=\"{{item.id}}\">{{item.name}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_ADSET_NAME\" | translate}}</label><select class=\"form-control\" ng-model=\"cfilter.filter.adset\"><option value=\"\">{{\"FILTER_ADSET_NAME\" | translate}}</option><option ng-repeat=\"item in cfilter.filter_values.adsets\" value=\"{{item.id}}\">{{item.name}}</option></select></div></div><div ng-if=\"cfilter.filter_values.custom_fields.length > 0\"><div ng-repeat=\"field in cfilter.filter_values.custom_fields\"><div ng-if=\"field.type == \'date\' || field.type == \'datetime\'\" class=\"form-group\"><label>{{field.name | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.custom_fields[field.id] || cfilter.filter.custom_fields[field.id] == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.custom_fields[field.id]\" view=\"date\" min-view=\"{{ field.type == \'date\' ? \'date\' : \'minutes\' }}\" format=\"{{ field.type == \'date\' ? \'DD/MM/YYYY\' : \'DD/MM/YYYY HH:mm\' }}\" readonly=\"readonly\"></div><div ng-if=\"field.type == \'list\'\" class=\"form-group form-select\"><label>{{field.name | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"cfilter.filter.custom_fields[field.id]\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\"{{field.name | translate}}\">{{$item.value}}</ui-select-match><ui-select-choices toggle-selection=\"value\" ng-model=\"cfilter.filter.custom_fields[field.id]\" repeat=\"value in field.values | filter:$select.search track by value.id\"><span class=\"multicheck\"></span>{{value.value}}</ui-select-choices></ui-select></div></div></div></div></div></div><div class=\"flex nowrap gap-16 between\"><a ng-click=\"cfilter.clearFilter()\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a><div class=\"flex nowrap gap-16\"><a ng-if=\"cfilter.store\" ng-click=\"cfilter.storeFilter()\" class=\"btn text large\">{{\"STORE_FILTER\" | translate}}</a> <a ng-if=\"!cfilter.store\" ng-click=\"cfilter.closeFilter()\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"cfilter.applyFilter()\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/components/common/bottomnavbar.html","<nav class=\"bottom-nav\" role=\"navigation\"><ul class=\"nav\" id=\"bottom-menu\"><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'dashboard\')\"><a ui-sref=\"app.dashboard\"><i class=\"las la-home\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'calendar\')\"><a ui-sref=\"app.calendar\"><i class=\"las la-calendar\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\')\"><a ui-sref=\"app.customers\"><i class=\"las la-users\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><a ui-sref=\"app.cashbox\"><i class=\"las la-dollar-sign\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings\"><i class=\"las la-cog\"></i></a></li></ul></nav>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\" ng-if=\"isAuth\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"content\"></div></div><div ng-include=\"\'app/components/common/bottomnavbar.html\'\" ng-if=\"isAuth\"></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">10GB of <strong>250GB</strong> Free.</div><div><strong>Copyright</strong> Example Company &copy; 2015-2016</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav ng-class=\"{\'navbar-default navbar-static-side sidebar-mainnav\': true, \'admin-page\': ($user && $user.role == \'1\')}\" role=\"navigation\"><div class=\"sidebar-collapse\"><div class=\"head-logo\"><a href=\"/\"><img ng-if=\"!color_form.switch_colors\" src=\"assets/images/logonew-white.svg\" class=\"main-logo img-responsive\"> <img ng-if=\"color_form.switch_colors\" src=\"assets/images/logonew.svg\" class=\"main-logo img-responsive\"></a><div class=\"side-menu-collapse\" ng-click=\"toggleSidebar()\"><i ng-if=\"isSidebarCollapsed\" class=\"las la-angle-right\"></i> <i ng-if=\"!isSidebarCollapsed\" class=\"las la-angle-left\"></i></div></div><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"row\"><div class=\"col-xs-12 header-sidebar\"><div><span minimaliza-sidebar=\"\"></span></div><div style=\"margin-right:-50px;\"><ol class=\"breadcrumb\"><li ng-repeat=\"(index, page) in header.breadcrumbs\"><a ui-sref=\"{{page.state}}\" ng-if=\"page.state\">{{page.title | translate}}</a> <span ng-if=\"!page.state && index === header.breadcrumbs.length-1\"><strong>{{page.title | translate}}</strong></span> <span ng-if=\"!page.state && index !== header.breadcrumbs.length-1\">{{page.title | translate}}</span></li></ol></div></div></div></li><li ui-sref-active-eq=\"active\" ng-if=\"isUserAllowedAccess(\'businesses\')\"><a ui-sref=\"app.admin\" class=\"WhiteBg\"><i class=\"las la-briefcase\"></i> <span class=\"nav-label\">{{\"NAV_BUSINESSES\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'users\')\"><a ui-sref=\"app.admin.users\" class=\"WhiteBg\"><i class=\"las la-user\"></i> <span class=\"nav-label\">{{\"NAV_USERS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'custom_fields\')\"><a ui-sref=\"app.admin.custom-fields\" class=\"WhiteBg\"><i class=\"las la-user-edit\"></i> <span class=\"nav-label\">{{\"NAV_CUSTOM_FIELDS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'logs\')\"><a ui-sref=\"app.admin.logs\" class=\"WhiteBg\"><i class=\"las la-file-code\"></i> <span class=\"nav-label\">{{\"NAV_LOGS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'dashboard\')\"><a ui-sref=\"app.dashboard\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-home\"></i> <span class=\"nav-label\">{{\"DASHBOARD\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'calendar\')\"><a ui-sref=\"app.calendar\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-calendar\"></i> <span class=\"nav-label\">{{\"NAV_DAY\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><a ui-sref=\"app.cashbox\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-dollar-sign\"></i> <span class=\"nav-label\">{{\"NAV_CASH\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\')\"><a ui-sref=\"app.customers\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-users\"></i> <span class=\"nav-label\">{{\"NAV_CUSTOMERS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'leads\') && manage_leads\"><a ui-sref=\"app.leads\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-star\"></i> <span class=\"nav-label\">{{\"NAV_LEADS\" | translate}}</span> <span ng-class=\"{\'gelatine\': isBouncingLead}\" ng-if=\"leads_count\" class=\"nav-mark\">{{leads_count}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\') && show_notes_page\"><a ui-sref=\"app.notes\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-sticky-note\"></i> <span class=\"nav-label\">{{\"NAV_NOTES\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\') && show_digital_forms_page\"><a ui-sref=\"app.digital_forms\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-file-alt\"></i> <span class=\"nav-label\">{{\"NAV_DIGITAL_FORMS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'workers\')\"><a ui-sref=\"app.workers\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-briefcase\"></i> <span class=\"nav-label\">{{\"WORKERS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'marketing\')\"><a ui-sref=\"app.marketing\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-bullhorn\"></i> <span class=\"nav-label\">{{\"NAV_MARKETING\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'business_analysis\')\"><a ui-sref=\"app.analytics\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-chart-area\"></i> <span class=\"nav-label\">{{\"NAV_ANALYTIC\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'reports\')\"><a ui-sref=\"app.reports\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-clipboard\"></i> <span class=\"nav-label\">{{\"NAV_REPORTS\" | translate}}</span></a></li><li ng-if=\"$state.includes(\'app.dashboard\') && !isSidebarCollapsed\" class=\"menu-color-settings\"><div class=\"flex form nowrap\"><div><div class=\"form-group form-color flex column\"><label class=\"thin\">{{\"ADMIN_BACK_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"color_form.back_color\" ng-change=\"submitColors()\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color flex column\"><label class=\"thin\">{{\"ADMIN_MENU_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"color_form.menu_color\" ng-change=\"submitColors()\" name=\"name\" class=\"form-control\"></div></div></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-model=\"color_form.switch_colors\" ng-change=\"submitColors()\">{{\"SWITCH_MENU_COLORS\" | translate}}</label></div></li><li ng-if=\"isUserAllowedAccess(\'tutorials_center\')\" ng-class=\"{active: $state.includes(\'app.tutorials_center\'), ondashboard: $state.includes(\'app.dashboard\') && !isSidebarCollapsed, tobottom: true}\"><a ui-sref=\"app.tutorials_center\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-video\"></i> <span class=\"nav-label\">{{\"NAV_TUTORIALS\" | translate}}</span></a></li><li ng-class=\"{active: $state.includes(\'app.settings\')}\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-cog\"></i> <span class=\"nav-label\">{{\"NAV_SETTINGS\" | translate}}</span></a></li><li><a ng-click=\"menuHide(); logout()\" class=\"WhiteBg\"><i class=\"las la-sign-out-alt\"></i> <span class=\"nav-label\">{{\"HEADER_LOGOUT\" | translate}}</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/notify.html","<div class=\"cg-notify-message inspinia-notify cg-notify-message-center\" ng-class=\"$classes\"><div class=\"p-lg\"><div ng-show=\"!$messageTemplate\">{{$message}}</div><div ng-show=\"$messageTemplate\" class=\"cg-notify-message-template\"></div><button type=\"button\" class=\"cg-notify-close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span> <span class=\"cg-notify-sr-only\">Close</span></button></div></div>");
$templateCache.put("app/components/common/topnavbar.html","");
$templateCache.put("app/components/feedback/feedback.form.html","<div ng-controller=\"FeedbackController as ctrl\"><div class=\"modal-head\"><h3 class=\"modal-title\">{{\"FEEDBACK_SENDING_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\" ng-if=\"isModal\">&times;</a></div><form name=\"feedbackForm\" ng-submit=\"ctrl.submit()\"><div class=\"modal-body\" style=\"background: white;\"><div class=\"flex form fill\"><div class=\"form-group\"><textarea class=\"feedback-question form-control\" rows=\"5\" required=\"\" ng-model=\"ctrl.feedback.question\" placeholder=\'{{\"FEEDBACK_SENDING_MSG_PLACEHOLDER\" | translate}}\'></textarea></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\" ng-if=\"isModal\">{{\"FEEDBACK_SENDING_MSG_CLOSE\" | translate}}</button> <button type=\"submit\" ng-disabled=\"feedbackForm.$invalid || feedbackForm.$pristine\" class=\"btn text primary large\">{{\"FEEDBACK_SENDING_MSG_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/components/gift_card/gift_card.view.html","<div class=\"gift-card\" ng-class=\"ctrl.classes()\" ng-attr-style=\"--gc-page-bg-color: {{ctrl.settings.page_bg_color}}; --gc-card-bg-color: {{ctrl.settings.card_bg_color}}; --gc-primary-color: {{ctrl.settings.primary_color}}; --gc-text-color: {{ctrl.settings.text_color}}; --gc-card-bg-gradient: {{ctrl.card_bg_gradient}};\"><div class=\"gift-card__bow\"></div><div class=\"gift-card__image\" ng-style=\"{\'background-image\': \'url(\' + ctrl.settings.image + \')\'}\"></div><div class=\"gift-card__image-mobile\" ng-style=\"{\'background-image\': \'url(\' + ctrl.settings.image + \')\'}\"></div><div class=\"gift-card__content\"><div class=\"gift-card__content-title\">{{ \"GIFT_CARD\" | translate }}</div><div class=\"gift-card__content-number\">{{ \"GIFT_CARD_NUMBER\" | translate }} #{{ctrl.values.number}}</div><div class=\"gift-card__content-business\"><div class=\"gift-card__content-business__logo\"><img ng-if=\"ctrl.settings.logo != \'\'\" ng-src=\"{{ctrl.settings.logo}}\" alt=\"\"></div><div class=\"gift-card__content-business__info\"><p class=\"gift-card__content-business__info-name\">{{ctrl.values.business}}</p><p class=\"gift-card__content-business__info-address\"><svg width=\"17\" height=\"17\" viewbox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.91797 6.2002C8.08954 6.2002 7.41797 6.87177 7.41797 7.7002C7.41797 8.52862 8.08954 9.2002 8.91797 9.2002C9.7464 9.2002 10.418 8.52862 10.418 7.7002C10.418 6.87177 9.7464 6.2002 8.91797 6.2002ZM6.41797 7.7002C6.41797 6.31948 7.53726 5.2002 8.91797 5.2002C10.2987 5.2002 11.418 6.31948 11.418 7.7002C11.418 9.08091 10.2987 10.2002 8.91797 10.2002C7.53726 10.2002 6.41797 9.08091 6.41797 7.7002Z\" fill=\"#434343\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.91793 2.86707C7.962 2.86707 7.02753 3.15053 6.2327 3.68161C5.43787 4.21269 4.81837 4.96754 4.45254 5.8507C4.08671 6.73387 3.99098 7.70568 4.17745 8.64324C4.36392 9.58079 4.82421 10.442 5.50011 11.1179C5.50009 11.1179 5.50013 11.118 5.50011 11.1179L8.32931 13.9465C8.48556 14.1026 8.6974 14.1903 8.91826 14.1903C9.13913 14.1903 9.35097 14.1026 9.50722 13.9465L12.3357 11.118C13.0116 10.442 13.4719 9.58081 13.6584 8.64324C13.8449 7.70567 13.7492 6.73387 13.3833 5.8507C13.0175 4.96754 12.398 4.21269 11.6032 3.68161C10.8083 3.15053 9.87386 2.86707 8.91793 2.86707ZM13.0428 11.8251C13.8586 11.0093 14.4141 9.96986 14.6392 8.83831C14.8643 7.70677 14.7487 6.53389 14.3072 5.46801C13.8657 4.40212 13.118 3.4911 12.1587 2.85014C11.1994 2.20918 10.0716 1.86707 8.91793 1.86707C7.76422 1.86707 6.63642 2.20918 5.67714 2.85014C4.71786 3.4911 3.97018 4.40212 3.52866 5.46801C3.08714 6.53389 2.97161 7.70677 3.19666 8.83831C3.42172 9.96986 3.97726 11.0093 4.79303 11.8251L7.62242 14.6538C7.96618 14.9972 8.43235 15.1903 8.91826 15.1903C9.40417 15.1903 9.87021 14.9974 10.214 14.6539L13.0428 11.8251Z\" fill=\"#434343\"></path></svg>{{ctrl.values.address}}</p></div></div><div ng-if=\"ctrl.settings.service && ctrl.values.service\" class=\"gift-card__content-service\"><p class=\"gift-card__content-service__label\">{{ \"GIFT_CARD_SERVICE\" | translate }}:</p><p class=\"gift-card__content-service__value\">{{ ctrl.values.service }}</p></div><div ng-if=\"ctrl.settings.receiver && ctrl.values.receiver\" class=\"gift-card__content-receiver\"><p class=\"gift-card__content-receiver__label\">{{ \"GIFT_CARD_GIFTED_TO\" | translate }}</p><p class=\"gift-card__content-receiver__value\">{{ ctrl.values.receiver }}</p></div><div ng-if=\"ctrl.settings.value && ctrl.values.value\" class=\"gift-card__content-value\"><p class=\"gift-card__content-value__label\">{{ \"GIFT_CARD_VALUE\" | translate }}:</p><p class=\"gift-card__content-value__value\">₪{{ (ctrl.values.value * 1).toFixed(2) }}</p><b ng-if=\"ctrl.values.balance !== undefined && ctrl.values.balance !== null && ctrl.values.balance !== \'\' && ctrl.values.balance !== ctrl.values.value\" class=\"gift-card__content-value__label\">/</b><p ng-if=\"ctrl.values.balance !== undefined && ctrl.values.balance !== null && ctrl.values.balance !== \'\' && ctrl.values.balance !== ctrl.values.value\" class=\"gift-card__content-value__label\">{{ \"GIFT_CARD_BALANCE\" | translate }}:</p><p ng-if=\"ctrl.values.balance !== undefined && ctrl.values.balance !== null && ctrl.values.balance !== \'\' && ctrl.values.balance !== ctrl.values.value\" class=\"gift-card__content-value__value\">₪{{ (ctrl.values.balance * 1).toFixed(2) }}</p></div><div ng-if=\"ctrl.settings.message && ctrl.values.message\" class=\"gift-card__content-message\"><span class=\"start\"><svg width=\"14\" height=\"14\" viewbox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.276 0.480021L12.9692 2.71917C12.1717 2.65782 11.5889 2.82141 11.2209 3.20993C10.8528 3.59846 10.6279 4.11991 10.5461 4.77427C10.4643 5.42863 10.4438 6.13411 10.4847 6.89072H13.276V13.3628H8.03086V5.66379C8.03086 3.7825 8.50118 2.37153 9.44182 1.43089C10.4029 0.490246 11.681 0.173289 13.276 0.480021ZM5.48498 0.480021L5.17825 2.71917C4.38075 2.65782 3.79796 2.82141 3.42988 3.20993C3.0618 3.59846 2.83686 4.11991 2.75507 4.77427C2.67327 5.42863 2.65283 6.13411 2.69372 6.89072H5.48498V13.3628H0.239868V5.66379C0.239868 3.7825 0.71019 2.37153 1.65083 1.43089C2.61193 0.490246 3.88998 0.173289 5.48498 0.480021Z\" fill=\"currentColor\"></path></svg></span> {{ ctrl.values.message }} <span class=\"end\"><svg width=\"14\" height=\"14\" viewbox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.560089 13.0471L0.866821 10.808C1.66432 10.8693 2.24711 10.7058 2.61519 10.3172C2.98327 9.9287 3.20821 9.40726 3.29 8.7529C3.3718 8.09853 3.39225 7.39305 3.35135 6.63645L0.560089 6.63645L0.560088 0.164403L5.8052 0.164403L5.8052 7.86337C5.8052 9.74466 5.33488 11.1556 4.39424 12.0963C3.43314 13.0369 2.15509 13.3539 0.560089 13.0471ZM8.35108 13.0471L8.65781 10.808C9.45531 10.8693 10.0381 10.7058 10.4062 10.3172C10.7743 9.9287 10.9992 9.40725 11.081 8.75289C11.1628 8.09853 11.1832 7.39305 11.1423 6.63645L8.35108 6.63645L8.35108 0.164402L13.5962 0.164402L13.5962 7.86337C13.5962 9.74466 13.1259 11.1556 12.1852 12.0963C11.2241 13.0369 9.94608 13.3539 8.35108 13.0471Z\" fill=\"currentColor\"></path></svg></span></div><div ng-if=\"ctrl.settings.sender && ctrl.values.sender\" class=\"gift-card__content-sender\"><p class=\"gift-card__content-sender__label\">{{ \"GIFT_CARD_GIFTED_BY\" | translate }}</p><p class=\"gift-card__content-sender__value\">{{ ctrl.values.sender }}</p></div></div></div>");
$templateCache.put("app/components/header/header.html","<div ng-controller=\"HeaderController as header\" id=\"header-wrapper\"><div class=\"mobile-head-logo\"><button class=\"btn icon simple mobile-menu-toggle\" ng-click=\"header.menuToggle()\"><i class=\"las la-bars\"></i></button> <a href=\"/\"><img src=\"assets/images/logonew.svg\" class=\"main-logo img-responsive\"></a></div><div class=\"wrapper white-bg page-heading\" ng-class=\"isMobile ? \'application\' : \'\'\"><div class=\"header-sidebar\"><div><div ng-if=\"header.stop_messages\" class=\"header-red-alert\">{{\"MESSAGES_STOPED_ALERT\" | translate}}</div><ol class=\"breadcrumb\"><li ng-repeat=\"(index, page) in header.breadcrumbs\"><a ui-sref=\"{{page.state}}\" ng-if=\"page.state\" class=\"bread-menu\">{{page.title | translate}}</a> <span ng-if=\"!page.state && index === header.breadcrumbs.length-1\"><strong>{{page.title | translate}}</strong></span> <span ng-if=\"!page.state && index !== header.breadcrumbs.length-1\">{{page.title | translate}}</span> {{header.dealer_name ? \' - \'+header.dealer_name : \'\'}}</li></ol></div></div><div class=\"header-buttons\"><div ng-if=\"header.wa_status\" ng-class=\"{\'wa-status-block\': true, \'open\': header.openedWaNotifications}\"><div ng-class=\"{\'btn icon wa-icon\': true, \'green-bg\': header.wa_status == \'authorized\', \'red-bg\': header.wa_status != \'authorized\'}\" ng-click=\"header.openedWaNotifications = !header.openedWaNotifications\"><i class=\"la la-whatsapp\"></i> <span ng-if=\"header.notifications.wa_unread > 0\" class=\"wa-status__counter\">{{header.notifications.wa_unread}}</span></div><div class=\"wa-status__dropdown\"><div class=\"wa-status__results\"><div ng-if=\"header.notifications.wa_unread == 0\" class=\"wa-status__empty\">{{\"NOTIFICATIONS_EMPTY\" | translate}}</div><div ng-repeat=\"item in header.notifications.wa_list\" class=\"wa-status__result\"><div class=\"wa-status__cell\" ng-click=\"header.clickNotification(item)\"><div class=\"wa-status__preview color-green\"><i class=\"la la-whatsapp\"></i></div></div><div class=\"wa-status__cell\" ng-click=\"header.clickNotification(item)\"><div class=\"wa-status__title\">{{item.title ? item.title+\' - \' : \'\'}}<span>{{item.date}}</span></div><div class=\"wa-status__text\"><div ng-if=\"item.text\">{{item.text}}</div><span ng-if=\"!item.text\">{{\"NOTIFICATIONS_WA_MESSAGE\" | translate}}</span></div></div><div class=\"wa-status__cell\"><button ng-click=\"event.stopPropagation(); header.removeNotification(item)\" class=\"btn icon circle\"><i class=\"las la-trash-alt\"></i></button></div></div></div><div class=\"wa-status__all\"><button ng-if=\"header.wa_status == \'authorized\'\" class=\"btn text primary\" ng-click=\"header.goAllNotifications(\'wa\')\">{{\"NOTIFICATIONS_SHOW_ALL\" | translate}}</button> <button ng-class=\"{\'btn text\': true, \'error\': header.wa_status == \'authorized\', \'success\': header.wa_status != \'authorized\'}\" ng-click=\"header.getQrCode()\">{{header.wa_status == \'authorized\' ? \"WA_DISCONNECT\" : \"WA_CONNECT\" | translate}}</button> <button ng-if=\"header.wa_status == \'authorized\'\" class=\"btn text border-red\" ng-click=\"header.removeAllNotifications(\'wa\')\">{{\"NOTIFICATIONS_REMOVE_ALL\" | translate}}</button></div></div><div ng-click=\"header.openedWaNotifications = false;\" class=\"wa-status__backdrop\"></div><span class=\"wa-status-test\" ng-if=\"header.wa_status == \'authorized\'\">{{\"WA_CONNECTED\" | translate}}</span> <span class=\"wa-status-test\" ng-if=\"header.wa_status != \'authorized\'\">{{\"WA_DISCONNECTED\" | translate}}</span></div><div ng-if=\"header.filters && header.filters.length\"><div><div ng-click=\"header.activeFilterModal = true;\" ng-class=\"{\'btn icon m-6\': true, \'active\': header.activeFilterModal}\"><i class=\"las la-filter\"></i></div><div ng-click=\"header.activeFilterModal = false;\" ng-class=\"{\'filters-list-backdrop\': true, \'active\': header.activeFilterModal}\"></div><div ng-class=\"{\'filters-list\': true, \'active\': header.activeFilterModal}\"><div class=\"filters-list-header\"><span>{{\"FILTERS_POPUP_TITLE\" | translate}}</span><div class=\"btn icon simple\" ng-click=\"header.activeFilterModal = false;\"><i class=\"las la-times\"></i></div></div><div class=\"filters-list-inner\"><div class=\"filters-list-item\" ng-repeat=\"filter in header.filters\"><div class=\"filters-list-item-inner\"><div class=\"filters-list-item-content\"><div class=\"filters-list-item-content-inner\"><div class=\"filters-list-item-content-type\"><button ng-if=\"filter.module == \'customers\'\" ng-click=\"header.goFilter(filter)\" class=\"btn icon bordered primary\"><i class=\"las la-users\"></i></button> <button ng-if=\"filter.module == \'leads\'\" ng-click=\"header.goFilter(filter)\" class=\"btn icon bordered primary\"><i class=\"las la-star\"></i></button></div><div class=\"filters-list-item-content-text\"><div ng-click=\"header.goFilter(filter)\">{{filter.name}}</div><button class=\"btn icon filters-list-item-content-remove\" ng-click=\"header.removeFilter(filter.id);\"><i class=\"las la-trash-alt\"></i></button></div></div></div></div></div></div></div></div></div><div ng-if=\"header.messages && header.messages.length\"><div><div ng-click=\"header.activeMessageModal = true;\" ng-class=\"{\'btn icon m-6\': true, \'red\': header.messages.length, \'active\': header.activeMessageModal}\"><i class=\"las la-bell\"></i></div><div class=\"b-messages-icon\"><span class=\"b-messages-count\"></span></div><div ng-click=\"header.activeMessageModal = false;\" ng-class=\"{\'b-messages-list-backdrop\': true, \'active\': header.activeMessageModal}\"></div><div ng-class=\"{\'b-messages-list\': true, \'active\': header.activeMessageModal}\"><div class=\"b-messages-list-header\"><span>{{\"MESSAGES_TITLE\" | translate}}</span><div class=\"btn icon simple\" ng-click=\"header.activeMessageModal = false;\"><i class=\"las la-times\"></i></div></div><div class=\"b-messages-list-inner\"><div class=\"b-messages-list-item\" ng-repeat=\"message in header.messages\"><div class=\"b-messages-list-item-inner\"><div class=\"b-messages-list-item-content\"><a href=\"javascript:void(0);\" class=\"b-messages-list-item-content-inner\"><div class=\"b-messages-list-item-content-type {{message.type}}\"><i ng-if=\"message.type == \'info\'\" class=\"las la-info-circle\"></i> <i ng-if=\"message.type == \'success\'\" class=\"las la-check-circle\"></i> <i ng-if=\"message.type == \'error\'\" class=\"las la-exclamation-circle\"></i></div><div class=\"b-messages-list-item-content-text\"><div ng-if=\"message.customer_id\" ui-sref=\"app.customers.single({id: {{message.customer_id}}})\">{{message.title ? message.title : \'Tiffulit\'}}</div><div ng-if=\"!message.customer_id\">{{message.title ? message.title : \'Tiffulit\'}}<span ng-if=\"message.date != \'\'\">- {{message.date}}</span></div><div><span ng-bind-html=\"message.message\"></span></div><button class=\"btn text simple\" ng-click=\"header.removeMessage(message.id);\">{{\"MESSAGES_DELETE\" | translate}}</button></div></a></div></div></div></div></div></div></div><div class=\"btn icon m-6\" ng-controller=\"FeedbackController\" ng-click=\"header.openFeedbackModal()\" ng-if=\"$user.role != 1\"><i class=\"las la-comment\"></i></div><div ng-if=\"header.is_ai_enabled\" class=\"btn icon m-6\" ai-dialog-open=\"\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewbox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z\"></path></svg></div><div class=\"profile-element\" uib-dropdown=\"\"><div class=\"user-detail-top\"><img alt=\"image\" class=\"user-profile-picture\" ng-src=\"{{$user.profile | defaultProfilePicture}}\"> <a uib-dropdown-toggle=\"\" href=\"\" class=\"user-options-dropdown\"><span class=\"username-box\"><strong>{{$user.name}}</strong> <i class=\"las la-angle-down\"></i></span></a></div><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a ng-click=\"logout()\" class=\"logout-button\">{{\"NAV_LOGOUT\" | translate}}</a></li></ul></div></div><button ng-if=\"header.show\" class=\"btn btn-nostyle report-back-btn\"><i class=\"fa fa-angle-right fa-2x\"></i></button></div></div>");
$templateCache.put("app/modules/admin/admin.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\" style=\"display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 12px;\"><button class=\"btn text primary large\" ui-sref=\"app.admin.new\">{{\"NEW_BUSINESS\" | translate}}</button> <button class=\"btn text border-orange large\" ui-sref=\"app.admin.copy\">{{\"ADMIN_ADD_BUSINESS_FROM_TEMPLATE\" | translate}}</button> <button class=\"btn text border-green large\" ui-sref=\"app.admin.message\">{{\"BUSINESS_MESSAGE\" | translate}}</button><div class=\"admin-search\"><label><input type=\"search\" class=\"form-control input-sm\" ng-model=\"ctrl.search\"></label></div><div class=\"form-switch form-group first last pull-end\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_cron()\" ng-model=\"ctrl.enabled_cron\">{{\"ADMIN_CHANGE_CRON\" | translate}}</label></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example\" dt-options=\"dtOptions\"><thead><tr><th>{{\"ADMIN_BUSINESS_STATUS\" | translate}}</th><th>{{\"ADMIN_BUSINESS_NAME\" | translate}}</th><th>{{\"ADMIN_CONTACT_PERSON\" | translate}}</th><th>{{\"ADMIN_BUSINESS_TYPE\" | translate}}</th><th>{{\"DEALER_TYPE\" | translate}}</th><th>{{\"ADMIN_BUSINESS_VAT\" | translate}}</th><th>{{\"ADMIN_CASHBOX\" | translate}}</th><th>{{\"ADMIN_CITY\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"business in ctrl.filtered_businessess()\" ui-sref=\"app.admin.single-business({id: {{business.id}}})\"><td>{{getStatusByIndex(business.status) | translate}}</td><td>{{business.name | emptyValue}}</td><td>{{business.agent | emptyValue}}</td><td>{{ctrl.variants[business.variant] | translate | emptyValue}}</td><td>{{business.dealer_type | emptyValue}}</td><td>{{business.vat | emptyValue}}</td><td>{{business.cashbox ? \"Y\" : \"N\" }}</td><td>{{business.city | emptyValue}}</td></tr></tbody></table></div></div></div></div><div class=\"settings-block\"><ul style=\"list-style-type: none;font-size: 16px;text-align: center; padding: 5px; background: #fff;\"><li><a ui-sref=\"app.admin.users\" id=\"users-list-link\"><h6 style=\"font-weight: 400; font-size: 16px\">{{\"SETTINGS_USERS\" | translate}}</h6><p>{{\"SETTINGS_USERS_MANAGE\" | translate}}</p></a></li></ul></div></div></div></div>");
$templateCache.put("app/modules/analytics/analytics.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} page-wrapper-main\" id=\"analytics\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"cloud mb-24 analytics-repeat-block\" ng-repeat=\"(graphID, graph) in ctrl.graphs\"><div class=\"window-header analytic\"><div class=\"block-title\" ng-class=\"graphID == \'income\' ? \'blue\' : graphID == \'orders\' ? \'green\' : \'blue\'\"><div class=\"btn icon small\"><i class=\"las la-chart-line\"></i></div><span>{{graph.title}}</span></div><div ng-if=\"graph.widgets\" class=\"chart-widgets-block\"><div class=\"chart-widget-block\" ng-repeat=\"(widgetID, widget) in graph.widgets\"><div class=\"flex gap-16\"><div class=\"widget-title\">{{widget.title | translate}}</div><div class=\"widget-data\">{{widget.data}}</div></div></div></div><div class=\"flex gap-16\"><div class=\"filter-button\"><button class=\"btn icon default\" ng-click=\"ctrl.openFilter(graphID)\"><span ng-show=\"(ctrl.filter[graphID] | notEmptyCountFilter) > 0\" class=\"filter-count\">{{ctrl.filter[graphID] | notEmptyCountFilter}}</span><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal\': true, \'active\': ctrl.filterModal[graphID]}\" ng-click=\"event.stopPropagation();\"><div><div><div class=\"form-group form-select\"><label>{{\"FILTER_ITEMS\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.filter[graphID].item\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_ITEMS\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"item\" ng-model=\"ctrl.filter[graphID].item\" repeat=\"item in ctrl.filter_values.items | filter:$select.search\"><span class=\"multicheck\"></span>{{item.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_CATEGORY\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.filter[graphID].category\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"category\" ng-model=\"ctrl.filter[graphID].category\" repeat=\"category in ctrl.filter_values.categories | filter:$select.search track by category.id\"><span class=\"multicheck\"></span>{{category.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_RESOURCE\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.filter[graphID].resource\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"resource\" ng-model=\"ctrl.filter[graphID].resource\" repeat=\"resource in ctrl.filter_values.resources | filter:$select.search track by resource.id\"><span class=\"multicheck\"></span>{{resource.name}}</ui-select-choices></ui-select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_ARRIVAL_SOURCE\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.filter[graphID].arrival_source\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_ARRIVAL_SOURCE\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"source\" ng-model=\"ctrl.filter[graphID].arrival_source\" repeat=\"source in ctrl.filter_values.arrival_sources | filter:$select.search\"><span class=\"multicheck\"></span>{{source.name}}</ui-select-choices></ui-select></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].lastvisit_from || ctrl.filter[graphID].lastvisit_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].lastvisit_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].lastvisit_to || ctrl.filter[graphID].lastvisit_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].lastvisit_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].created_from || ctrl.filter[graphID].created_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].created_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].created_to || ctrl.filter[graphID].created_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].created_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_BIRTHDAY\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.filter[graphID].birthday\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_BIRTHDAY\" | translate}}\'>{{$item.value}}</ui-select-match><ui-select-choices toggle-selection=\"monthName\" ng-model=\"ctrl.filter[graphID].birthday\" repeat=\"(month, monthName) in datesProvider.months | filter:$select.search\"><span class=\"multicheck\"></span>{{monthName.value}}</ui-select-choices></ui-select></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.visited_from || ctrl.filter.visited_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].visited_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.visited_to || ctrl.filter.visited_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].visited_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div><div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.filter[graphID].have_card\">{{\"FILTER_HAVE_CARDS\" | translate}}</label></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_GENDER\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.filter[graphID].gender\"><option value=\"\">{{\"FILTER_GENDER\" | translate}}</option><option value=\"0\">{{\"CUSTOMERS_GENDER_MALE\" | translate}}</option><option value=\"1\">{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</option></select></div></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_STATUS\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.filter[graphID].status\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_STATUS\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"source\" ng-model=\"ctrl.filter[graphID].status\" repeat=\"source in ctrl.filter_values.statuses | filter:$select.search\"><span class=\"multicheck\"></span>{{source.name}}</ui-select-choices></ui-select></div></div></div><div class=\"not-select\"><div><div class=\"form-group form-select\"><label>{{\"FILTER_CAMPAIGN_NAME\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.filter[graphID].campaign\"><option value=\"\">{{\"FILTER_CAMPAIGN_NAME\" | translate}}</option><option ng-repeat=\"item in ctrl.filter_values.campaigns\" value=\"{{item.id}}\">{{item.name}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_AD_NAME\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.filter[graphID].ad\"><option value=\"\">{{\"FILTER_AD_NAME\" | translate}}</option><option ng-repeat=\"item in ctrl.filter_values.ads\" value=\"{{item.id}}\">{{item.name}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"FILTER_ADSET_NAME\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.filter[graphID].adset\"><option value=\"\">{{\"FILTER_ADSET_NAME\" | translate}}</option><option ng-repeat=\"item in ctrl.filter_values.adsets\" value=\"{{item.id}}\">{{item.name}}</option></select></div></div></div></div><div class=\"flex nowrap gap-16\"><a ng-click=\"ctrl.closeFilter(graphID)\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"ctrl.clearFilter(graphID)\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a> <a ng-click=\"ctrl.applyFilter(graphID)\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div><div ng-if=\"graph.customer_filter\" class=\"form-group last\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalytics(graphID)\" ng-if=\"graph.categories\" ng-model=\"graph.category\"><option value=\"\">{{\"ANALYTICS_ALL_CATEGORIES\" | translate}}</option><option value=\"{{category.id}}\" ng-repeat=\"(catID, category) in graph.categories\">{{category.name}}</option><option value=\"0\">{{\"ANALYTICS_NO_CATEGORY\" | translate}}</option></select></div></div><div ng-if=\"graph.customer_filter\" class=\"form-group last\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalytics(graphID)\" ng-if=\"graph.resources\" ng-model=\"graph.resource\"><option value=\"\">{{\"CALENDAR_RESOURCES\" | translate}}</option><option value=\"{{resource.id}}\" ng-repeat=\"(resID, resource) in graph.resources\">{{resource.name}}</option></select></div></div><div ng-if=\"graph.customer_filter || graphID == \'statsBar\'\" class=\"form-group last\"><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.loadAnalytics(graphID, \'daily\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].filter == \'daily\'}\">{{\"ANALYTIC_SELECT_1\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(graphID, \'weekly\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].filter == \'weekly\'}\">{{\"ANALYTIC_SELECT_2\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(graphID, \'monthly\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].filter == \'monthly\'}\">{{\"ANALYTIC_SELECT_3\" | translate}}</button></div></div><div ng-if=\"!graph.customer_filter\" class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"pie-start-date\" required=\"\" ng-model=\"graph.start\" view=\"date\" fix-datepicker-position=\"\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" class=\"form-control background-white\" id=\"pie-end-date\" required=\"\" ng-model=\"graph.end\" view=\"date\" fix-datepicker-position=\"\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div></div><div class=\"chart-wrapper\"><div class=\"chart-body\"><div class=\"chart-canvas\"><canvas chart-js=\"\" chart-data=\"graph.data\" chart-options=\"graph.options\" chart-type=\"graph.type\" height=\"{{graph.height ? graph.height : ctrl.graphHeight}}\"></canvas></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/approval/approval.view.html","<div class=\"modal-form-inner modal-approval\"><div class=\"modal-head modal-head-online\"><div class=\"background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: contain;\"><div class=\"logo-container\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><h1 class=\"business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"business-address\">{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}</h2></div></div><div class=\"modal-head\"><h3 ng-if=\"!isPreview\" class=\"form-title no-padding-x\">{{\"NAV_APPROVAL\" | translate}} # {{orderItem.number}}</h3><h3 ng-if=\"isPreview\" class=\"form-title no-padding-x\">{{\"NAV_APPROVAL_PREVIEW\" | translate}}</h3><h2 class=\"form-title no-padding-x\">{{orderItem.order_date}}</h2></div><div ng-if=\"business.type*1 == 1\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"add-to-caledar-buttons\"><div class=\"atcb\" style=\"display:none;\">{ \"name\":\"{{ctrl.first_item.item_data.name}}\", \"description\":\"\", \"startDate\":\"{{ctrl.date}}\", \"endDate\":\"{{ctrl.date}}\", \"startTime\":\"{{ctrl.start}}\", \"endTime\":\"{{ctrl.end}}\", \"location\":\"{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}\", \"label\":\"{{\"EXPORT_TO_CALENDAR\" | translate}}\", \"options\":[ \"Apple\", \"Google\", \"Microsoft365\", \"Outlook.com\", \"Yahoo\" ], \"timeZone\":\"{{ctrl.tz}}\", \"timeZoneOffset\":\"{{ctrl.utcOffset}}\", \"trigger\":\"click\", \"iCalFileName\":\"Reminder-Event\" }</div></div><div class=\"arrive-buttons\" ng-if=\"!isPreview\"><a ng-if=\"!isApproved\" class=\"btn text large border-green\" ng-click=\"ctrl.submit()\">{{\"ARRIVE_APPROVAL\" | translate}} 😊</a> <a ng-if=\"business.not_arrive_option && orderItem.approval_sent != 3\" class=\"btn text large border-red\" ng-click=\"ctrl.submit(true)\">{{\"NOT_ARRIVE_APPROVAL\" | translate}}</a></div><div ng-if=\"business.approval_text && !isPreview\" class=\"approval-text\" ng-bind-html=\"business.approval_text\"></div><div class=\"online-buttons\"><a class=\"btn icon circle large bordered blue\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{(business.online_booking_data.phone != \'\' ? \'tel:\'+business.online_booking_data.phone : \'tel:\'+business.phone)}}\"><i class=\"las la-phone\"></i></a> <a class=\"btn icon circle large bordered green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{(business.online_booking_data.phone != \'\' ? \'https://wa.me/\'+ctrl.waPhone(business.online_booking_data.phone) : \'https://wa.me/\'+ctrl.waPhone(business.phone))}}\"><i class=\"lab la-whatsapp\"></i></a> <a class=\"btn icon circle large bordered waze\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://waze.com/ul?q={{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}\"><i class=\"lab la-waze\"></i></a> <a class=\"btn icon circle large bordered facebook\" nf-if=\"business.online_booking_data.facebook\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.facebook}}\"><i class=\"lab la-facebook-f\"></i></a> <a class=\"btn icon circle large bordered instagram\" nf-if=\"business.online_booking_data.instagram\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.instagram}}\"><i class=\"lab la-instagram\"></i></a> <a class=\"btn icon circle large bordered linkedin\" nf-if=\"business.online_booking_data.linkedin\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.linkedin}}\"><i class=\"lab la-linkedin-in\"></i></a> <a class=\"btn icon circle large bordered twitter\" nf-if=\"business.online_booking_data.twitter\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.twitter}}\"><i class=\"lab la-twitter\"></i></a></div></div></div></div><form class=\"modal-form_f\" name=\"forgotPasswordForm\" novalidate=\"\" ng-if=\"business.type*1==2\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"col-md-12 order-wrapper\"><div class=\"row\"><div class=\"col-md-4 col-xs-6\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\">{{orderItem.name}}</div></div></div><div class=\"col-md-4\" ng-if=\"!isMobile\"><div class=\"form-group\"><label>&nbsp;</label><br></div></div><div class=\"col-md-4 col-xs-6\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_DATE\" | translate}}</label><div>{{ctrl.date}}</div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PHONE\" | translate}}</label><div>{{orderItem.phone}}</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_EMAIL\" | translate}}</label><div>{{orderItem.email}}</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>&nbsp;</label><div>&nbsp;</div></div></div></div><div class=\"order-item\" ng-repeat=\"($orderItemIndex, orderItem) in orderItem.items\"><div class=\"row\"><div class=\"col-md-4 col-xs-8 item-wrapper\"><label>{{\"CALENDAR_ORDER_SERVICE\" | translate}}</label><br>{{orderItem.item_data.name}}</div><div class=\"col-md-4 col-xs-4 resource-wrapper\"><label>{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</label><br>{{orderItem.resource_data.name}}</div><div class=\"col-md-4 col-xs-12 guest-name-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_NAME_GUEST\" | translate}}</label><div>&nbsp;</div></div></div><div class=\"col-md-4 col-xs-6 start-time-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ENTRY_DATE\" | translate}}</label><div>{{orderItem.start_time}}</div></div></div><div class=\"col-md-4 col-xs-6 duration-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_RELEASE_DATE\" | translate}}</label><div>{{orderItem.end_time}}</div></div></div><div class=\"col-md-4 col-xs-6 price-wrapper\"><label>{{\"CALENDAR_NIGHTS_NUMBER\" | translate}}</label><div>{{orderItem.nights}} לילות</div></div><div class=\"col-md-4 col-xs-6 price-wrapper\"><label>{{\"CALENDAR_ORDER_PRICE\" | translate}}</label><div>{{orderItem.order_price}}</div></div><div class=\"col-md-12 col-xs-12 notes-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_REMARKS\" | translate}}</label><div>{{orderItem.notes}}</div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4 number-wrapper adults-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ADULTS\" | translate}}</label><div>{{orderItem.adults}}</div></div></div><div class=\"col-md-4 col-xs-4 number-wrapper kids-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_CHILDREN\" | translate}}</label><div>{{orderItem.kids}}</div></div></div><div class=\"col-md-4 col-xs-4 number-wrapper babies-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_BABIES\" | translate}}</label><div>{{orderItem.babies}}</div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"item-summary\" ng-if=\"orderItem.nights > 0\"><b>סה\"כ: {{orderItem.item_data.price * orderItem.nights | price}}</b></div></div></div></div><div class=\"form-group\" style=\"margin-top: 20px;\"><label>&nbsp; {{\"APPROVAL_NOTE\" | translate}}</label><div>{{orderItem.note_order_approval}}</div></div><div class=\"form-group\" style=\"margin-top: 20px;\"><label>&nbsp; {{\"CALENDAR_ORDER_SECURITY\" | translate}}</label><div></div></div></div><div class=\"order-summary\"><div class=\"inner\"><div class=\"price-line\" ng-if=\"orderItem.business_data.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_BEFORE\" | translate}}</span> <span class=\"price\">{{subtotal | price}}</span></div><div class=\"price-line\" ng-if=\"orderItem.business_data.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_VAT\" | translate}} (%{{ctrl.dealer_vat}})</span> <span class=\"price\">{{tax | price}}</span></div><div class=\"price-line\"><span class=\"title\">{{\"CALENDAR_ORDER_TOTAL\" | translate}}</span> <span class=\"price\">{{total | price}}</span></div></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-if=\"orderItem.approved_date == null && !isPreview\" ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn btn-w-m btn-primary\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button ng-if=\"isPreview\" class=\"btn btn-w-m btn-primary\" ng-click=\"ctrl.close()\">{{\"SETTINGS_LOG_CLOSED\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/approvalrequest/approvalrequest.view.html","<div id=\"customers-form\" class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!ctrl.is_edit\">{{\"APPROVAL_SEND_METHOD_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"orderForm\" ng-submit=\"ctrl.send_order_form()\" novalidate=\"\"><div ng-if=\"!ctrl.confirm_delete\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"settings_label\">{{\"APPROVAL_SEND_METHOD\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"1\"> <label>{{\"SETTINGS_USER_MAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"$close();\" class=\"btn btn-w-m btn-white\">{{\"CALENDAR_ORDER_RETURN\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.viewRequest();\" class=\"btn btn-w-m btn-white\">{{\"CALENDAR_ORDER_VIEW_APPROVE\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send();\" class=\"btn btn-w-m btn-primary\">{{\"CALENDAR_ORDER_SEND_APPROVE\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/calendar_event/calendar_event.view.html","<div class=\"create-event-container\" ng-if=\"ctrl.order\"><div class=\"business-head\"><img ng-if=\"ctrl.order.business.image\" src=\"{{ctrl.order.business.image}}\"><div><div class=\"business-head-name\">{{ctrl.order.business.name}}</div><div class=\"business-head-address\">{{ctrl.order.business.address}}</div></div></div><div class=\"calendar-event-title\">{{ctrl.first_item.item_data.name}}</div><div class=\"calendar-event-time\">{{ctrl.date}}</div><div class=\"calendar-event-time\">{{ctrl.start}} - {{ctrl.end}}</div><div class=\"atcb\" style=\"display:none;\">{ \"name\":\"{{ctrl.first_item.item_data.name}}\", \"description\":\"\", \"startDate\":\"{{ctrl.date}}\", \"endDate\":\"{{ctrl.date}}\", \"startTime\":\"{{ctrl.start}}\", \"endTime\":\"{{ctrl.end}}\", \"location\":\"{{ctrl.order.business.address}}\", \"label\":\"{{\"EXPORT_TO_CALENDAR\" | translate}}\", \"options\":[ \"Apple\", \"Google\", \"iCal\", \"Microsoft365\", \"Outlook.com\", \"Yahoo\" ], \"timeZone\":\"{{ctrl.tz}}\", \"timeZoneOffset\":\"{{ctrl.utcOffset}}\", \"trigger\":\"click\", \"iCalFileName\":\"Reminder-Event\" }</div></div>");
$templateCache.put("app/modules/dashboard/dashboard.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} page-wrapper-main\" ng-if=\"isUserAllowedAccess(\'dashboard\')\" id=\"dashboard-main\"><div class=\"dashboard-buttons\"><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings.logs\"><i class=\"las la-file\"></i> <span>{{\"NAV_INVOICES\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'reports\')\"><a ui-sref=\"app.reports\"><i class=\"las la-paste\"></i> <span>{{\"NAV_REPORTS\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings\"><i class=\"las la-cog\"></i> <span>{{\"NAV_SETTINGS\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'calendar\')\"><a ui-sref=\"app.calendar\"><i class=\"las la-calendar\"></i> <span>{{\"NAV_DAY\" | translate}}</span></a></div><div class=\"dashboard-button\"><a ui-sref=\"app.marketing\"><i class=\"las la-bullhorn\"></i> <span>{{\"NAV_MARKETING\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'business_analysis\')\"><a ui-sref=\"app.analytics\"><i class=\"las la-chart-area\"></i> <span>{{\"NAV_ANALYTIC\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'customers\')\"><a ui-sref=\"app.customers\"><i class=\"las la-users\"></i> <span>{{\"NAV_CUSTOMERS\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><a ui-sref=\"app.cashbox\"><i class=\"las la-dollar-sign\"></i> <span>{{\"NAV_CASH\" | translate}}</span></a></div><div class=\"dashboard-button\"><a ui-sref=\"app.leads\" ng-if=\"isUserAllowedAccess(\'customers\') && manage_leads\"><i class=\"las la-star\"></i> <span>{{\"NAV_LEADS\" | translate}}</span></a> <a ui-sref=\"app.workers\" ng-if=\"!(isUserAllowedAccess(\'customers\') && manage_leads) && isUserAllowedAccess(\'workers\')\"><i class=\"las la-briefcase\"></i> <span>{{\"WORKERS\" | translate}}</span></a></div></div><div class=\"widgets-row\" style=\"margin-left:0;margin-right: 0;display: flex;justify-content: space-around\" ng-if=\"isMobile\"><div ng-hide=\"ctrl.hide_prices\" class=\"col-xs-5 align-center data-widget income mobile\"><div class=\"text title\">{{\"DASHBOARD_DAILY_INCOME\" | translate}}</div><div class=\"price\">{{ctrl.dailyIncome}}<span class=\"currency\">שח</span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome)}}%</span> &#x2022 {{ctrl.today()}}</div></div><div class=\"col-xs-5 align-center data-widget orders mobile\" style=\"width:50%\"><div class=\"text title\">{{\"DASHBOARD_DAILY_ORDERS\" | translate}}</div><div class=\"price\">{{ctrl.dailyOrders}}<span class=\"currency\"></span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders)}}%</span> &#x2022 {{ctrl.today()}}</div></div></div><div class=\"row dashboard-row\"><div class=\"col-xs-12 col-md-7 col-lg-6\"><div class=\"mobile-second bg-white data-table\"><div class=\"window-header\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-dollar-sign\"></i></div><span ng-if=\"b_type==2\">{{\"DASHBOARD_WEEKS_ORDERS\" | translate}}</span> <span ng-if=\"b_type==1\">{{\"DASHBOARD_TODAYS_ORDERS\" | translate}}</span></div><div><a ui-sref=\"app.calendar\" class=\"btn text special\"><span class=\"hidden-xs\">{{\"VIEW_ALL\" | translate}}</span> <i class=\"las la-angle-left rotatable\"></i></a></div></div><div><div class=\"dashboard-orders-widget\"><div class=\"table-holder\"><div class=\"table-responsive\" id=\"today_order_tb\"><table ng-if=\"ctrl.tableOrdersData\" datatable=\"\" dt-column-defs=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th class=\"hide\"></th><th class=\"hidden-xs\" ng-if=\"b_type==2\">{{\"REPORT_ORDER_DATE\" | translate}}</th><th class=\"hidden-xs\" ng-if=\"b_type==1\">{{\"DASHBOARD_TIME\" | translate}}</th><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th>{{\"SETTINGS_ITEM\" | translate}}</th><th ng-hide=\"ctrl.hide_prices\">{{\"REPORT_ITEM_PRICE\" | translate}}</th><th>{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</th><th ng-if=\"b_type==2\">{{\"CALENDAR_NIGHTS_NUMBER\" | translate}}</th><th><span class=\"hidden-xs\">{{\"CALENDAR_ORDER_ACTION\" | translate}}</span></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableOrdersData\" ng-click=\"ctrl.edit_order_form(row.order_id)\"><td class=\"hide\"></td><td class=\"hidden-xs\" ng-if=\"b_type==2\"><span ng-hide=\"true\">{{row.start_time | toUnixTimestamp }}</span> <span class=\"time-txt\" ng-class=\"{\'expired_order_widget\' : currentDateTime > (row.start_time | toUnixTimestamp)}\">{{row.start_time | toUnixTimestamp | date:\"dd/MM/yyyy\"}} <i ng-if=\"currentDateTime > (row.start_time | toUnixTimestamp)\" class=\"las la-exclamation-triangle\"></i></span></td><td class=\"hidden-xs\" ng-if=\"b_type==1\"><span ng-hide=\"true\">{{row.start_time | toUnixTimestamp }}</span> <span class=\"time-txt\" ng-class=\"{\'expired_order_widget\' : currentDateTime > (row.start_time | toUnixTimestamp)}\">{{row.start_time | toUnixTimestamp | date:\"H:mm\"}} <i ng-if=\"currentDateTime > (row.start_time | toUnixTimestamp)\" class=\"las la-exclamation-triangle\"></i></span></td><td><b>{{row.customer}}</b><div class=\"visible-xs time-txt\" ng-class=\"{\'expired_order_widget\' : currentDateTime > (row.start_time | toUnixTimestamp)}\">{{row.start_time | toUnixTimestamp | date:\"H:mm\"}} <i ng-if=\"currentDateTime > (row.start_time | toUnixTimestamp)\" class=\"las la-exclamation-triangle\"></i></div></td><td><span class=\"btn btn-primary btn-xs category-item\" style=\"background-color: {{ctrl.hexToRgbA(row.item_data.bg_color)}};\">{{row.item_data.name}}</span></td><td ng-hide=\"ctrl.hide_prices\"><b>{{row.item_data.price}}</b></td><td><span>{{row.resource}}</span></td><td ng-if=\"b_type==2\"><span>{{row.nights}}</span></td><td><a ng-click=\"$event.stopPropagation();\" ui-sref=\"app.cashbox.order({orderID: {{row.id}}})\" class=\"btn icon\"><i class=\"las la-hand-holding-usd\"></i></a></td></tr></tbody></table></div></div></div></div></div><div ng-hide=\"ctrl.hide_prices\" class=\"block-title-green bg-white data-table mobile-four\" ng-if=\"!page_is_loading\"><div class=\"window-header\"><div class=\"block-title blue\"><div class=\"btn icon small\"><i class=\"las la-chalkboard\"></i></div><span>{{\"CUSTOMERS_REV\" | translate}}</span></div><div class=\"d-flex flex-end\"><div class=\"d-flex gap-16\"><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.loadAnalytics(\'income\', \'daily\')\" ng-class=\"{\'btn-primary\': ctrl.incomeGraph.filter == \'daily\', \'btn-default\': ctrl.incomeGraph.filter != \'daily\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_1\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(\'income\', \'weekly\')\" ng-class=\"{\'btn-primary\': ctrl.incomeGraph.filter == \'weekly\', \'btn-default\': ctrl.incomeGraph.filter != \'weekly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_2\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(\'income\', \'monthly\')\" ng-class=\"{\'btn-primary\': ctrl.incomeGraph.filter == \'monthly\', \'btn-default\': ctrl.incomeGraph.filter != \'monthly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_3\" | translate}}</button></div><div class=\"hidden-xs\" style=\"width: 130px\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalytics(\'income\')\" ng-if=\"ctrl.incomeGraph.categories\" ng-model=\"ctrl.incomeGraph.category\"><option value=\"\">{{\"ANALYTICS_ALL_CATEGORIES\" | translate}}</option><option value=\"{{category.id}}\" ng-repeat=\"(catID, category) in ctrl.incomeGraph.categories\">{{category.name}}</option><option value=\"0\">{{\"ANALYTICS_NO_CATEGORY\" | translate}}</option></select></div></div><div class=\"hidden-xs\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalytics(\'income\')\" ng-if=\"ctrl.incomeGraph.resources\" ng-model=\"ctrl.incomeGraph.resource\"><option value=\"\">{{\"CALENDAR_RESOURCES\" | translate}}</option><option value=\"{{resource.id}}\" ng-repeat=\"(catID, resource) in ctrl.incomeGraph.resources\">{{resource.name}}</option></select></div></div></div></div></div><div class=\"visible-xs\"><div class=\"window-header-second\"><div class=\"m-4\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalytics(\'income\')\" ng-if=\"ctrl.incomeGraph.categories\" ng-model=\"ctrl.incomeGraph.category\"><option value=\"\">{{\"ANALYTICS_ALL_CATEGORIES\" | translate}}</option><option value=\"{{category.id}}\" ng-repeat=\"(catID, category) in ctrl.incomeGraph.categories\">{{category.name}}</option><option value=\"0\">{{\"ANALYTICS_NO_CATEGORY\" | translate}}</option></select></div></div><div class=\"m-4\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalytics(\'income\')\" ng-if=\"ctrl.incomeGraph.resources\" ng-model=\"ctrl.incomeGraph.resource\"><option value=\"\">{{\"CALENDAR_RESOURCES\" | translate}}</option><option value=\"{{resource.id}}\" ng-repeat=\"(catID, resource) in ctrl.incomeGraph.resources\">{{resource.name}}</option></select></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"chart-wrapper\"><div class=\"chart-body\"><div class=\"income income-dashboard\"><canvas chart-js=\"\" chart-data=\"ctrl.incomeGraph.data\" chart-options=\"ctrl.incomeGraph.options\" chart-type=\"ctrl.incomeGraph.type\" height=\"{{ctrl.graphHeight}}\"></canvas></div></div></div></div></div></div><div class=\"block-title-green bg-white data-table mobile-seven\" ng-if=\"!page_is_loading\"><div class=\"window-header\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-chart-pie\"></i></div><span>{{\"CUSTOMERS_STATSPIE\" | translate}}</span></div><div class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"pie-start-date\" required=\"\" ng-model=\"ctrl.pie_start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"pie-end-date\" required=\"\" ng-model=\"ctrl.pie_end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div><div><div class=\"chart-wrapper\"><div class=\"chart-body\"><div class=\"stats statspie-dashboard\"><canvas chart-js=\"\" chart-data=\"ctrl.statsPie.data\" chart-options=\"ctrl.statsPie.options\" chart-type=\"ctrl.statsPie.type\"></canvas></div></div></div></div></div></div><div class=\"col-xs-12 col-md-5 col-lg-6\"><div ng-hide=\"ctrl.hide_prices\" class=\"flex-container mobile-first\" ng-if=\"!isMobile\"><div class=\"\"><div class=\"data-widget income\"><div class=\"text title\">{{\"DASHBOARD_DAILY_INCOME\" | translate}}</div><div class=\"price\">{{ctrl.dailyIncome}}<span class=\"currency\">שח</span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome)}}%</span> &#x2022 {{ctrl.today()}}</div></div></div><div class=\"\"><div class=\"data-widget orders\"><div class=\"text title\">{{\"DASHBOARD_DAILY_ORDERS\" | translate}}</div><div class=\"price\">{{ctrl.dailyOrders}}<span class=\"currency\"></span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders)}}%</span> &#x2022 {{ctrl.today()}}</div></div></div></div><div ng-if=\"!page_is_loading\" class=\"mobile-three\"><div class=\"block-title-red data-table bg-white\"><div class=\"window-header\"><div class=\"block-title pink\"><div class=\"btn icon small\"><i class=\"las la-gift\"></i></div><span>{{\"DASHBOARD_TODAY_BDAYS\" | translate}}</span></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.tableCustomersData\" datatable=\"\" dt-options=\"dtOptionsBirth\" class=\"table table-striped table-bordered table-hover dataTables-example\" id=\"birthday_tb\"><thead><tr><th>{{\"CUSTOMERS_LAST_VISIT\" | translate}}</th><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th class=\"customer-shows\">{{\"CUSTOMERS_AGE\" | translate}}</th><th class=\"hidden-xs customer-income\">{{\"CUSTOMER_GIFT_CARD\" | translate}}</th><th class=\"customer-send\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableCustomersData\"><td><span class=\"expired_order_widget\">{{row.last_date}}</span></td><td><b>{{row.firstname}} {{row.lastname}}</b></td><td class=\"customer-shows\">{{row.age}}</td><td class=\"hidden-xs customer-income\">{{CUSTOMER_GIFT_CARD_SEND | translate}}</td><td class=\"customer-send\"><button ng-if=\"!row.flag\" class=\"btn text primary btn-birthday-{{row.id}}\" ng-click=\"ctrl.send_birthday_message(row.id)\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div></div><div ng-hide=\"ctrl.hide_prices\" ng-if=\"showIncomeByItem\" class=\"mobile-six\"><div class=\"bg-white block-title-green data-table\"><div class=\"window-header\"><div class=\"block-title orange\"><div class=\"btn icon small\"><i class=\"las la-chart-bar\"></i></div><span>{{\"DASHBOARD_DAILY_INCOME_BY_ITEM\" | translate}}</span></div><div><a ui-sref=\"app.analytics\" class=\"btn text special\"><span class=\"hidden-xs\">{{\"VIEW_ALL\" | translate}}</span> <i class=\"las la-angle-left rotatable\"></i></a></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"chart-body\"><div class=\"chart-canvas\"><canvas chart-js=\"\" chart-data=\"ctrl.dailyIncomeByItemGraph.data\" chart-options=\"ctrl.dailyIncomeByItemGraph.options\" chart-type=\"ctrl.dailyIncomeByItemGraph.type\"></canvas></div></div></div></div></div></div><div ng-hide=\"ctrl.hide_prices\" ng-if=\"!page_is_loading\" class=\"mobile-five\"><div class=\"block-title-green bg-white data-table\"><div class=\"window-header\"><div class=\"block-title purple\"><div class=\"btn icon small\"><i class=\"lab la-cc-mastercard\"></i></div><span>{{\"DASHBOARD_DAILY_INCOME_BY_PAYMENT_TYPE\" | translate}}</span></div><div><div class=\"form-inline flex-end\"><div class=\"styled-select small\"><select class=\"form-control small\" ng-change=\"ctrl.loadAnalyticsPaymentType()\" ng-model=\"ctrl.paymentGraph.filter\"><option value=\"today\">{{\"ANALYTIC_PAYMENT_SELECT_1\" | translate}}</option><option value=\"week\">{{\"ANALYTIC_PAYMENT_SELECT_5\" | translate}}</option><option value=\"month\">{{\"ANALYTIC_PAYMENT_SELECT_2\" | translate}}</option><option value=\"year\">{{\"ANALYTIC_PAYMENT_SELECT_3\" | translate}}</option><option value=\"lastyear\">{{\"ANALYTIC_PAYMENT_SELECT_4\" | translate}}</option></select></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"chart-body\"><div class=\"payment-canvas\"><canvas chart-js=\"\" chart-data=\"ctrl.paymentGraph.data\" chart-options=\"ctrl.paymentGraph.options\" chart-type=\"ctrl.paymentGraph.type\"></canvas></div></div></div></div></div></div><div ng-if=\"showCalendar\"><div class=\"bg-white data-table\"><div class=\"row\"><div class=\"col-xs-8\"><div class=\"data-table-title\"><div class=\"data-table-icon occupation-icon\"></div><div class=\"title-text\">{{\"DASHBOARD_TONNAGE\" | translate}}</div></div></div><div class=\"col-xs-4 btn-holder\"><button class=\"btn btn-primary light-green btn-long\" ui-sref=\"app.calendar\">{{\"NAV_DAY\" | translate}}</button></div></div><div class=\"row\"><div ng-if=\"calendarConfig\" ui-calendar=\"calendarConfig\" ng-model=\"events\" calendar=\"mainCalendar\" class=\"calendar\"></div></div></div></div><div class=\"block-title-green bg-white data-table mobile-seven\" ng-if=\"!page_is_loading\"><div class=\"window-header\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-chart-bar\"></i></div><span>{{\"CUSTOMERS_STATSBAR\" | translate}}</span></div><div class=\"flex gap-8\"><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.bar_filter = \'daily\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_filter == \'daily\', \'btn-default\': ctrl.bar_filter != \'daily\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_1\" | translate}}</button> <button ng-click=\"ctrl.bar_filter = \'weekly\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_filter == \'weekly\', \'btn-default\': ctrl.bar_filter != \'weekly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_2\" | translate}}</button> <button ng-click=\"ctrl.bar_filter = \'monthly\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_filter == \'monthly\', \'btn-default\': ctrl.bar_filter != \'monthly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_3\" | translate}}</button></div><div class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"bar-start-date\" required=\"\" ng-model=\"ctrl.bar_start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"bar-end-date\" required=\"\" ng-model=\"ctrl.bar_end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div></div><div><div class=\"chart-wrapper\"><div class=\"chart-body\"><div class=\"stats statspie-dashboard\"><canvas chart-js=\"\" chart-data=\"ctrl.statsBar.data\" chart-options=\"ctrl.statsBar.options\" chart-type=\"ctrl.statsBar.type\"></canvas></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/dashboard/dashboard_load.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div id=\"page-loading\" class=\"ibox-content sk-loading\"><style>\n        .sk-spinner-fading-circle.sk-spinner {\n          width: 80px;\n          height: 80px;\n          margin: 0 auto;\n          position: relative;\n        }\n        .sk-spinner-fading-circle .sk-circle {\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          left: 0;\n          top: 0;\n        }\n        .sk-spinner-fading-circle .sk-circle:before {\n          content: \'\';\n          display: block;\n          margin: 0 auto;\n          width: 18%;\n          height: 18%;\n          background-color: #337ab7;\n          border-radius: 100%;\n          -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out;\n          animation: sk-circleFadeDelay 1.2s infinite ease-in-out;\n          -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n        }\n        .sk-spinner-fading-circle .sk-circle2 {\n          -webkit-transform: rotate(30deg);\n          -ms-transform: rotate(30deg);\n          transform: rotate(30deg);\n        }\n        .sk-spinner-fading-circle .sk-circle3 {\n          -webkit-transform: rotate(60deg);\n          -ms-transform: rotate(60deg);\n          transform: rotate(60deg);\n        }\n        .sk-spinner-fading-circle .sk-circle4 {\n          -webkit-transform: rotate(90deg);\n          -ms-transform: rotate(90deg);\n          transform: rotate(90deg);\n        }\n        .sk-spinner-fading-circle .sk-circle5 {\n          -webkit-transform: rotate(120deg);\n          -ms-transform: rotate(120deg);\n          transform: rotate(120deg);\n        }\n        .sk-spinner-fading-circle .sk-circle6 {\n          -webkit-transform: rotate(150deg);\n          -ms-transform: rotate(150deg);\n          transform: rotate(150deg);\n        }\n        .sk-spinner-fading-circle .sk-circle7 {\n          -webkit-transform: rotate(180deg);\n          -ms-transform: rotate(180deg);\n          transform: rotate(180deg);\n        }\n        .sk-spinner-fading-circle .sk-circle8 {\n          -webkit-transform: rotate(210deg);\n          -ms-transform: rotate(210deg);\n          transform: rotate(210deg);\n        }\n        .sk-spinner-fading-circle .sk-circle9 {\n          -webkit-transform: rotate(240deg);\n          -ms-transform: rotate(240deg);\n          transform: rotate(240deg);\n        }\n        .sk-spinner-fading-circle .sk-circle10 {\n          -webkit-transform: rotate(270deg);\n          -ms-transform: rotate(270deg);\n          transform: rotate(270deg);\n        }\n        .sk-spinner-fading-circle .sk-circle11 {\n          -webkit-transform: rotate(300deg);\n          -ms-transform: rotate(300deg);\n          transform: rotate(300deg);\n        }\n        .sk-spinner-fading-circle .sk-circle12 {\n          -webkit-transform: rotate(330deg);\n          -ms-transform: rotate(330deg);\n          transform: rotate(330deg);\n        }\n        .sk-spinner-fading-circle .sk-circle2:before {\n          -webkit-animation-delay: -1.1s;\n          animation-delay: -1.1s;\n        }\n        .sk-spinner-fading-circle .sk-circle3:before {\n          -webkit-animation-delay: -1s;\n          animation-delay: -1s;\n        }\n        .sk-spinner-fading-circle .sk-circle4:before {\n          -webkit-animation-delay: -0.9s;\n          animation-delay: -0.9s;\n        }\n        .sk-spinner-fading-circle .sk-circle5:before {\n          -webkit-animation-delay: -0.8s;\n          animation-delay: -0.8s;\n        }\n        .sk-spinner-fading-circle .sk-circle6:before {\n          -webkit-animation-delay: -0.7s;\n          animation-delay: -0.7s;\n        }\n        .sk-spinner-fading-circle .sk-circle7:before {\n          -webkit-animation-delay: -0.6s;\n          animation-delay: -0.6s;\n        }\n        .sk-spinner-fading-circle .sk-circle8:before {\n          -webkit-animation-delay: -0.5s;\n          animation-delay: -0.5s;\n        }\n        .sk-spinner-fading-circle .sk-circle9:before {\n          -webkit-animation-delay: -0.4s;\n          animation-delay: -0.4s;\n        }\n        .sk-spinner-fading-circle .sk-circle10:before {\n          -webkit-animation-delay: -0.3s;\n          animation-delay: -0.3s;\n        }\n        .sk-spinner-fading-circle .sk-circle11:before {\n          -webkit-animation-delay: -0.2s;\n          animation-delay: -0.2s;\n        }\n        .sk-spinner-fading-circle .sk-circle12:before {\n          -webkit-animation-delay: -0.1s;\n          animation-delay: -0.1s;\n        }\n        @-webkit-keyframes sk-circleFadeDelay {\n          0%, 39%, 100% {\n            opacity: 0;\n          }\n          40% {\n            opacity: 1;\n          }\n        }\n        @keyframes sk-circleFadeDelay {\n          0%, 39%, 100% {\n            opacity: 0;\n          }\n          40% {\n            opacity: 1;\n          }\n        }\n        .ibox-content > .sk-spinner {\n          display: none;\n        }\n        .ibox-content.sk-loading {\n          position: relative;\n        }\n        .ibox-content.sk-loading:after {\n          content: \'\';\n          background-color: rgba(255, 255, 255, 0.7);\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n        }\n        .ibox-content.sk-loading > .sk-spinner {\n          display: block;\n          position: absolute;\n          top: 40%;\n          left: 0;\n          right: 0;\n          z-index: 2000;\n        }\n    </style><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div>");
$templateCache.put("app/modules/digital_documents/digital_documents.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h1 ng-if=\"!DigitalDocument.sign\" class=\"text-center\">{{\"PLEASE_SIGN_DOCUMENT\" | translate}}</h1><h1 ng-if=\"DigitalDocument.sign\" class=\"text-center\">{{\"DIGITAL_DOCUMENT_ALREADY_SIGNED\" | translate}}</h1></div><form class=\"modal-form_f\" name=\"signForm\" novalidate=\"\" ng-if=\"DigitalDocument.id\"><div class=\"modal-body\"><div class=\"panel-body\"><iframe ng-src=\"{{iframe()}}\" style=\"width:100%; height:100%; min-height: 500px;\" frameborder=\"0\"></iframe></div></div><div class=\"modal-footer modal-footer-align-center\" ng-if=\"!DigitalDocument.sign\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.sign\" ng-disabled=\"ctrl.is_edit\">{{\"ACCEPT_DIGITAL_DOCUMENT\" | translate}}</label></div><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/forgot_password/forgot_password.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"LOGIN_FORGOT_PASS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"forgotPasswordForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"LOGIN_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"forgotPasswordForm.email.$error\" class=\"ng-messages\" ng-show=\"forgotPasswordForm.email.$dirty\"><div ng-message=\"email\">{{\"SETTINGS_INFO_EMAIL_VALID\" | translate}}</div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/forgot_password_confirm/forgot_password_confirm.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">Create New password</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"forgotPasswordConfirmForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"LOGIN_PASS\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.password\" name=\"password\" placeholder=\"new password\" class=\"form-control\"><div ng-messages=\"forgotPasswordConfirmForm.password.$error\" class=\"ng-messages\" ng-show=\"forgotPasswordConfirmForm.password.$dirty\"><div ng-message=\"password\">{{\"SETTINGS_INFO_PASSWORD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"LOGIN_PASS_REPEAT\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.newPassword\" name=\"password\" placeholder=\"new password\" class=\"form-control\"><div ng-messages=\"forgotPasswordConfirmForm.password.$error\" class=\"ng-messages\" ng-show=\"forgotPasswordConfirmForm.newPassword.$dirty\"><div ng-message=\"newPassword\">{{\"SETTINGS_INFO_PASSWORD_VALID\" | translate}}</div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"forgotPasswordConfirmForm.$invalid || forgotPasswordConfirmForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/calendar/calendar-sync.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GOOGLE_CALENDAR_SYNC\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.cancel()\">&times;</a></div><div class=\"modal-body\"><div class=\"form-group\" ng-if=\"!ctrl.googleInitialized\"><div class=\"alert alert-info\"><i class=\"fa fa-info-circle\"></i> {{\"GOOGLE_CALENDAR_INIT_REQUIRED\" | translate}}</div><button type=\"button\" ng-click=\"ctrl.initGoogleCalendar()\" class=\"btn text primary large\" ng-disabled=\"ctrl.syncLoading\"><span ng-if=\"ctrl.syncLoading\">{{\"INITIALIZING\" | translate}}...</span> <span ng-if=\"!ctrl.syncLoading\">{{\"INITIALIZE_GOOGLE_CALENDAR\" | translate}}</span></button></div><div ng-if=\"ctrl.googleInitialized\"><div class=\"form-group\"><label>{{\"SELECT_DATE\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.selectedDate\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"SELECT_RESOURCE\" | translate}}</label><select ng-model=\"ctrl.selectedResource\" class=\"form-control\"><option value=\"\">{{\"SELECT_RESOURCE_PLACEHOLDER\" | translate}}</option><option ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.google_calendar_sync == 1 && resource.google_calendar_email\" ng-value=\"resource\">{{resource.name}} ({{resource.google_calendar_email}})</option></select></div><div class=\"form-group\"><button type=\"button\" ng-click=\"ctrl.syncCalendar()\" class=\"btn text primary large\" ng-disabled=\"ctrl.syncLoading || !ctrl.selectedResource\"><span ng-if=\"ctrl.syncLoading\">{{\"SYNCING\" | translate}}...</span> <span ng-if=\"!ctrl.syncLoading\">{{\"SYNC_SELECTED_RESOURCE\" | translate}}</span></button> <button type=\"button\" ng-click=\"ctrl.syncAllCalendars()\" class=\"btn text border-primary large\" ng-disabled=\"ctrl.syncLoading\"><span ng-if=\"ctrl.syncLoading\">{{\"SYNCING_ALL\" | translate}}...</span> <span ng-if=\"!ctrl.syncLoading\">{{\"SYNC_ALL_RESOURCES\" | translate}}</span></button></div><div class=\"form-group\" ng-if=\"ctrl.syncResults.length > 0\"><h4>{{\"SYNC_RESULTS\" | translate}}</h4><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>{{\"RESOURCE\" | translate}}</th><th>{{\"DATE\" | translate}}</th><th>{{\"CREATED\" | translate}}</th><th>{{\"UPDATED\" | translate}}</th><th>{{\"DELETED\" | translate}}</th><th>{{\"ERRORS\" | translate}}</th><th>{{\"TIMESTAMP\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"result in ctrl.syncResults\"><td>{{result.resource}}</td><td>{{result.date}}</td><td><span class=\"badge badge-success\" ng-if=\"result.result.created > 0\">{{result.result.created}}</span> <span ng-if=\"result.result.created == 0\">0</span></td><td><span class=\"badge badge-info\" ng-if=\"result.result.updated > 0\">{{result.result.updated}}</span> <span ng-if=\"result.result.updated == 0\">0</span></td><td><span class=\"badge badge-warning\" ng-if=\"result.result.deleted > 0\">{{result.result.deleted}}</span> <span ng-if=\"result.result.deleted == 0\">0</span></td><td><span class=\"badge badge-danger\" ng-if=\"result.result.errors && result.result.errors.length > 0\">{{result.result.errors.length}}</span> <span ng-if=\"!result.result.errors || result.result.errors.length == 0\">0</span></td><td>{{result.timestamp}}</td></tr></tbody></table></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.cancel()\" class=\"btn text border-primary large\">{{\"CLOSE\" | translate}}</button></div></div>");
$templateCache.put("app/modules/calendar/calendar.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"calendar\" ng-if=\"isUserAllowedAccess(\'calendar\')\" ng-class=\"{\'loading\': ctrl.settings.loading || ctrl.settings.loadingHolidays, \'motels-calendar\': ctrl.settings.bu_type == 2}\"><div class=\"calendar-options desktop\"><div class=\"calendar-options-column\"><div class=\"datepicker-column datepicker-column-wrap\"><div class=\"date-picker date-picker--width-auto\"><div class=\"input-group date-picker--input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerPrev();\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div style=\"width:100px;\"></div><div class=\"inputs-wrapper\"><input style=\"width: 100%\" type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"date\" min-view=\"date\" ng-if=\"ctrl.settings.datePickerView == \'date\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\" ng-click=\"ctrl.datePickerClicked()\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"month\" min-view=\"month\" ng-if=\"ctrl.settings.datePickerView == \'month\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\" ng-click=\"ctrl.datePickerClicked()\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerNext();\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div><button type=\"button\" ng-click=\"ctrl.gotoToday();\" class=\"btn text\">{{\"CALENDAR_TODAY\" | translate}}</button></div><div class=\"datepicker-column\"><div class=\"styled-select small calendar-resources\" ng-if=\"ctrl.settings.bu_type == 1\"><ui-select force-close-ui-select-on-outside-click=\"\" multiple=\"\" ng-model=\"ctrl.settings.resource\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"CALENDAR_RESOURCES\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"item\" ng-model=\"ctrl.settings.resource\" repeat=\"item in resources | filter:$select.search\"><span class=\"multicheck\"></span>{{item.name}}</ui-select-choices></ui-select></div><div class=\"btn-group\" ng-if=\"ctrl.showCapacityButton\"><button class=\"btn\" title=\"Header\" data-toggle=\"popover\" data-placement=\"right\" data-content=\"Content\" ng-click=\"ctrl.change_calendar_type(\'orders\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'orders\', \'btn-default\': ctrl.settings.type != \'orders\'}\">{{\"CALENDAR_INVITATIONS\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_type(\'capacity\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'capacity\', \'btn-default\': ctrl.settings.type != \'capacity\'}\">{{\"CALENDAR_TONNAGE\" | translate}}</button></div><div class=\"btn-group\"><button class=\"btn\" ng-if=\"ctrl.settings.bu_type == 1\" ng-click=\"ctrl.change_calendar_time(\'daily\');\" ng-disabled=\"ctrl.settings.type == \'capacity\'\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'daily\', \'btn-default\': ctrl.settings.time != \'daily\'}\">{{\"CALENDAR_DAILY\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_time(\'weekly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-disabled=\"ctrl.settings.type == \'capacity\' && ctrl.settings.type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'weekly\', \'btn-default\': ctrl.settings.time != \'weekly\'}\">{{\"CALENDAR_WEEKLY\" | translate}}</button> <button class=\"btn hidden-xs\" ng-click=\"ctrl.change_calendar_time(\'monthly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'monthly\', \'btn-default\': ctrl.settings.time != \'monthly\'}\">{{\"CALENDAR_MONTHLY\" | translate}}</button></div></div><div ng-if=\"ctrl.settings.type == \'orders\'\" ng-switch=\"ctrl.isSearching\"><div ng-switch-when=\"true\" class=\"input-group date-picker--input-group find-event\"><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'prev\')\" ng-click=\"ctrl.findEvent(\'prev\');\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div class=\"find-event-input-container\"><input type=\"text\" ng-model=\"ctrl.findSettings.search\" class=\"form-control find-event-input\" placeholder=\"{{\'CALENDAR_FIND_EVENTS_PLACEHOLDER\' | translate}}\"><div class=\"find-event-input-icon\" ng-if=\"!ctrl.findSettings.loading && ctrl.findSettings.search != \'\'\" ng-click=\"ctrl.resetFindSettings()\"><i class=\"las la-times\"></i></div><div class=\"find-event-input-icon\" ng-if=\"ctrl.findSettings.loading\"><i class=\"las la-spinner la-spin\"></i></div></div><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'next\')\" ng-click=\"ctrl.findEvent(\'next\');\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div><div ng-switch-when=\"false\" class=\"search-button\" ng-click=\"ctrl.activateSearch()\"><i class=\"las la-search\"></i></div></div></div></div><div ng-if=\"ctrl.settings.exist_bookings\"><a class=\"btn text\" ui-sref=\"app.customers_bookings\" ng-class=\"{\'exist-bookings\': ctrl.settings.exist_bookings}\"><span class=\"btn-number\">{{ctrl.settings.exist_bookings}}</span> {{\"CALENDAR_ORDERS_PENDING\" | translate}} <i class=\"las la-angle-left rotatable\"></i></a></div></div><div class=\"calendar-options mobile\"><div class=\"datepicker-column\"><div class=\"date-picker\"><div class=\"input-group date-picker--input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerPrev();\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div style=\"width:100px;\"></div><div class=\"inputs-wrapper\"><input style=\"width: 100%\" type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"date\" min-view=\"date\" ng-if=\"ctrl.settings.datePickerView == \'date\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"month\" min-view=\"month\" ng-if=\"ctrl.settings.datePickerView == \'month\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerNext();\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div></div><div ng-if=\"ctrl.settings.exist_bookings && !ctrl.isExpanded\"><a class=\"btn text\" ui-sref=\"app.customers_bookings\" ng-class=\"{\'exist-bookings\': ctrl.settings.exist_bookings}\"><span class=\"btn-number\">{{ctrl.settings.exist_bookings}}</span> {{\"CALENDAR_ORDERS_PENDING_MOBILE\" | translate}} <i class=\"las la-angle-left rotatable\"></i></a></div></div><div ng-if=\"!ctrl.isExpanded\" ng-class=\"{\'cal-types-wrapper\': true, \'wrapped\': ctrl.isSearching}\"><div class=\"cal-types\"><div class=\"styled-select small calendar-resources\" ng-if=\"ctrl.settings.bu_type == 1\"><ui-select force-close-ui-select-on-outside-click=\"\" multiple=\"\" ng-model=\"ctrl.settings.resource\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"CALENDAR_RESOURCES\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"item\" ng-model=\"ctrl.settings.resource\" repeat=\"item in resources | filter:$select.search\"><span class=\"multicheck\"></span>{{item.name}}</ui-select-choices></ui-select></div><button type=\"button\" ng-click=\"ctrl.gotoToday();\" class=\"btn text\">{{\"CALENDAR_TODAY\" | translate}}</button><div class=\"btn-group\" ng-if=\"ctrl.showCapacityButton\"><button class=\"btn\" title=\"Header\" data-toggle=\"popover\" data-placement=\"right\" data-content=\"Content\" ng-click=\"ctrl.change_calendar_type(\'orders\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'orders\', \'btn-default\': ctrl.settings.type != \'orders\'}\">{{\"CALENDAR_INVITATIONS\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_type(\'capacity\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'capacity\', \'btn-default\': ctrl.settings.type != \'capacity\'}\">{{\"CALENDAR_TONNAGE\" | translate}}</button></div><div class=\"btn-group\"><button class=\"btn\" ng-if=\"ctrl.settings.bu_type == 1\" ng-click=\"ctrl.change_calendar_time(\'daily\');\" ng-disabled=\"ctrl.settings.type == \'capacity\'\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'daily\', \'btn-default\': ctrl.settings.time != \'daily\'}\">{{\"CALENDAR_DAILY\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_time(\'weekly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-disabled=\"ctrl.settings.type == \'capacity\' && ctrl.settings.type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'weekly\', \'btn-default\': ctrl.settings.time != \'weekly\'}\">{{\"CALENDAR_WEEKLY\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_time(\'monthly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'monthly\', \'btn-default\': ctrl.settings.time != \'monthly\'}\">{{\"CALENDAR_MONTHLY\" | translate}}</button></div></div><div ng-if=\"ctrl.settings.type == \'orders\'\" ng-switch=\"ctrl.isSearching\" class=\"cal-search\"><div ng-switch-when=\"true\" class=\"input-group date-picker--input-group find-event\"><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'prev\')\" ng-click=\"ctrl.findEvent(\'prev\');\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div class=\"find-event-input-container\"><input type=\"text\" ng-model=\"ctrl.findSettings.search\" class=\"form-control find-event-input\" placeholder=\"{{\'CALENDAR_FIND_EVENTS_PLACEHOLDER\' | translate}}\"><div class=\"find-event-input-icon\" ng-if=\"!ctrl.findSettings.loading && ctrl.findSettings.search != \'\'\" ng-click=\"ctrl.resetFindSettings()\"><i class=\"las la-times\"></i></div><div class=\"find-event-input-icon\" ng-if=\"ctrl.findSettings.loading\"><i class=\"las la-spinner la-spin\"></i></div></div><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'next\')\" ng-click=\"ctrl.findEvent(\'next\');\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div><div ng-switch-when=\"false\" class=\"search-button\" ng-click=\"ctrl.activateSearch()\"><i class=\"las la-search\"></i></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"calendar-wrapper height-100\" ng-class=\"{\'calendar-capacity\': ctrl.settings.type == \'capacity\',\'calendar-non-capacity\': ctrl.settings.type != \'capacity\'}\"><div id=\"mainCalendar\" ng-if=\"calendarConfig\" ui-calendar=\"calendarConfig\" ng-model=\"events\" calendar=\"mainCalendar\" class=\"calendar height-100\"></div><div class=\"cursor-circle\"></div><div class=\"calendar-expand-button\" ng-click=\"ctrl.expandCalendar()\"><i ng-if=\"!ctrl.isExpanded\" class=\"las la-expand\"></i> <i ng-if=\"ctrl.isExpanded\" class=\"las la-compress\"></i></div></div></div></div></div>");
$templateCache.put("app/modules/cashbox/cashbox.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"cashbox\" ng-if=\"isUserAllowedAccess(\'cashbox\')\"><div class=\"main-title ng-binding\"><div class=\"flex fill gap-24 gap-24-m-8\" ng-if=\"!ctrl.isCreditTransaction && !ctrl.form.retainer_id\"><button class=\"btn text primary large hidden-sm visible-xs\" ng-click=\"ctrl.openSelectItem()\"><i class=\"las la-plus\"></i> {{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}</button> <button class=\"btn text primary large hidden-sm visible-xs\" ng-click=\"ctrl.openSelectCustomer()\"><i class=\"las la-plus\"></i> {{\"CALENDAR_CASH_SELECT_C\" | translate}}</button></div></div><div class=\"cashbox-row\"><div class=\"col-md-12 col-lg-7 cashbox-items-box\" ng-if=\"!isMobile\"><div id=\"cashbox-top-options\"><div class=\"flex between\"><div id=\"cashbox-top-options-title\"><strong class=\"main-title\">מוצרים</strong></div><div class=\"form-group last icon-prepend\"><i class=\"las la-search\"></i> <input id=\"calendarCashSearch\" type=\"text\" ng-model=\"ctrl.searchItem\" class=\"form-control\" placeholder=\'{{\"CALENDAR_CASH_SEARCH\" | translate}}\' ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction\"></div></div></div><div id=\"catalog\" ng-class=\"{\'disabled\': ctrl.isDebtTransaction || ctrl.isCreditTransaction}\"><ul id=\"categories\"><li ng-class=\"{\'active\': ctrl.categoryFilter == -1}\"><a ng-click=\"ctrl.filterCategory(-1)\">{{\"CALENDAR_CASH_ALL_PROD\" | translate}}</a></li><li ng-class=\"{\'active\': ctrl.categoryFilter == category.id}\" ng-repeat=\"(index, category) in ctrl.categories\"><a ng-click=\"ctrl.filterCategory(category.id)\">{{category.name}}</a></li></ul><div id=\"items\"><div class=\"row\"><div class=\"col-md-12 products\"><div class=\"row\" style=\"display: flex; flex-wrap: wrap;\"><div class=\"product col-lg-4 col-md-3 col-sm-4 col-xs-12\" ng-repeat=\"(index, product) in ctrl.products\"><a ng-click=\"ctrl.addItem(product)\"><div ng-if=\"product.item_image\" class=\"item-pic-wrapper cashbox\"><img src=\"{{product.item_image}}\" alt=\"Image\" class=\"item-pic\"></div>{{product.name}} <small class=\"price\" ng-if=\"!ctrl.hide_prices\">({{product.price | price}})</small></a></div><div class=\"not-found\" ng-if=\"!ctrl.products.length\"><h5 class=\"title\">{{\"CALENDAR_CASH_NO_ITEMS\" | translate}}</h5><p class=\"desc\">{{\"CALENDAR_CASH_NO_ITEMS_SENTENCE\" | translate}}</p></div></div></div></div></div></div></div><div class=\"col-md-12 col-lg-5 no-padding\"><div id=\"summary\" class=\"ibox-content\" ng-class=\"{\'sk-loading\': ctrl.cashboxLoading}\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"row\"><div class=\"form-group last col-md-12 customer-select-wrapper\"><div ng-if=\"!ctrl.isCreditTransaction\" class=\"flex gap-16 cashbox-options\"><div ng-if=\"!ctrl.isOrderTransaction\" class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-disabled=\"ctrl.form.retainer_id\" ng-model=\"ctrl.occ_customer\" value=\"1\" ng-change=\"ctrl.remove_customer();\">{{\"CALENDAR_ORDER_OCC\" | translate}}</label></div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.show_discount\" value=\"1\">{{\"SHOW_CASHBOX_DISCOUNT\" | translate}}</label></div><div ng-if=\"!ctrl.isOrderTransaction\" class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-disabled=\"ctrl.form.retainer_id\" ng-model=\"ctrl.form.quotation\" value=\"1\">{{\"CASHBOX_QUOTATION\" | translate}}</label></div></div><div ng-if=\"!ctrl.occ_customer && !ctrl.form.customer && !isMobile\" class=\"customer-select\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id\" ng-model=\"ctrl.customer_search_name\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div><div ng-if=\"ctrl.occ_customer\" class=\"occ_customer flex form v-start fill\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id\" ng-model=\"ctrl.form.customer_occ_name\" ng-class=\"{\'red\': !ctrl.form.customer_occ_name, \'form-control\': true}\"></div><div class=\"form-group\"><label>{{\"CUSTOMERS_PHONE\" | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id\" ng-model=\"ctrl.form.customer_occ_phone\" ng-class=\"{\'red\': !ctrl.form.customer_occ_phone, \'form-control\': true}\"></div></div></div></div><div class=\"flex\" ng-if=\"(ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_name))\"><div class=\"cashbox-customer-container\"><table class=\"cashbox-customer-details\"><thead><tr><td>{{\"CUSTOMER_FULL_NAME\" | translate}}</td><td>{{\"CUSTOMERS_PHONE\" | translate}}</td></tr></thead><tbody><tr ng-if=\"!ctrl.occ_customer && (ctrl.form.customer || ctrl.form.name)\"><td><div class=\"customer-pic-wrapper\" ng-if=\"ctrl.customerData.avatar\"><img ng-src=\"{{ctrl.customerData.avatar}}\" alt=\"User Profile\" class=\"customer-pic\"></div><b class=\"cashbox-full-name\">{{ctrl.form.name}}</b> <i ng-if=\"ctrl.customerData.oncredit > 0\" class=\"las la-dollar-sign\" aria-hidden=\"true\"></i></td><td><b>{{ctrl.form.phone}}</b></td></tr><tr ng-if=\"ctrl.occ_customer\"><td><b class=\"cashbox-full-name\">{{ctrl.form.customer_occ_name}}</b></td><td><b>{{ctrl.form.customer_occ_phone}}</b></td></tr></tbody></table></div><div class=\"cashbox-customer-remove\"><button type=\"button\" class=\"btn icon simple red\" ng-click=\"ctrl.remove_customer();\" ng-if=\"ctrl.form.customer && !(ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id)\"><i class=\"las la-times\"></i></button> <button type=\"button\" class=\"btn icon simple red\" ng-click=\"ctrl.remove_customer();\" ng-if=\"ctrl.form.customer_occ_name && !(ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id)\"><i class=\"las la-times\"></i></button></div></div><div class=\"empty flex\" ng-if=\"ctrl.items.length == 0\"><div><i class=\"las la-shopping-bag\"></i></div><div><h4 class=\"title\">{{\"CALENDAR_CASH_EMPTY\" | translate}}</h4><p class=\"text\">{{\"CALENDAR_CASH_EMPTY_SENTENCE\" | translate}}</p></div></div><div class=\"items\" ng-if=\"ctrl.items.length > 0\"><div class=\"item\" ng-class=\"{\'have-discount\': ctrl.show_discount}\" ng-repeat=\"(index, item) in ctrl.items track by $index\"><div class=\"item-col-qty\"><div class=\"item-inputs form-group last\"><label><i ng-if=\"item.isGiftCard\" class=\"las la-gift\"></i> {{item.name || (item.item_type == \'gift_card\' ? (\"GIFT_CARD\" | translate) : \'&nbsp;\')}}</label><input-number-spinner ng-if=\"item.item_type != \'gift_card\'\" data-ng-disabled=\"ctrl.isDebtTransaction || item.quantityDisabled || ctrl.items[index].item_type == \'card\'\" data-ng-model=\"ctrl.items[index].quantity\" data-input-number-spinner-min=\"1\"></input-number-spinner><div ng-if=\"item.item_type == \'gift_card\'\" class=\"cachbox-gc-number\"><i class=\"las la-gift customers-has-chards\"></i> <span>{{item.number}}</span></div></div></div><div class=\"item-col-employee\" ng-if=\"ctrl.businessInfo.data.manage_employee && item.item_type != \'prepaid\' && item.item_type != \'gift_card\'\"><div class=\"form-group form-select last\"><label>{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</label><select class=\"form-control\" name=\"resource\" required=\"\" data-ng-model=\"ctrl.items[index].resource\"><option value=\"\">{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</option><option ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.sales_active\" value=\"{{resource.id}}\">{{resource.name}}</option></select></div></div><div class=\"item-col-card card-item-match\" ng-if=\"ctrl.hasCustomerCardForItem(item.id) && !item.isCard\"><span>{{ ctrl.items[index].card_balance_used || \'0\' }}/{{ ctrl.getCustomerCardForItem(item.id)[\'balance\'] }} <i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': ctrl.hasCustomerCardForItem(item.id) === \'expired\'}\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-click=\"ctrl.useCardPopup(item)\"></i></span></div><div class=\"item-col-price price-spinner-data relative\" ng-hide=\"ctrl.hide_prices\"><div class=\"flex nowrap gap-8\"><div class=\"form-group last\" ng-if=\"item.item_type == \'gift_card\'\"><label>{{\"GIFT_CARD_BALANCE\" | translate}}</label><div class=\"original-price\">{{item.balance | price}}</div></div><div class=\"form-group last\" ng-if=\"ctrl.show_discount\"><label>{{\"CASHBOX_ORIGINAL_PRICE_LABEL\" | translate}}</label><div class=\"original-price\">{{item.original_price | price}}</div></div><div class=\"form-group last\" ng-if=\"ctrl.show_discount\"><label>{{\"CASHBOX_DISCOUNT_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"discount-input-{{$index}}\" class=\"form-control discount-input\" ng-model=\"item.discount\" ng-change=\"ctrl.changePercentage({{$index}})\"></div><div class=\"form-group last\"><label>{{\"CASHBOX_NET_PRICE_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"price-input-{{$index}}\" class=\"form-control price-input\" ng-model=\"item.price\" ng-change=\"ctrl.changePrice({{$index}})\"></div><div tooltip=\'{{\"MAKE_CARD_TOOLTIP\" | translate}}\' ng-if=\"item.item_type == \'service\' && ctrl.form.customer && (!item.card_balance_used || item.card_balance_used == 0) && !ctrl.checkAlreadyExistCard(index)\" class=\"have-tooltip make-cards{{item.isCard ? \' active\' : \'\'}}\" ng-click=\"ctrl.makeCard(index)\"><i class=\"las la-plus\"></i><i class=\"las la-ticket-alt customers-has-chards\" aria-hidden=\"true\"></i></div><div tooltip=\'{{\"GIFT_CARD_TOOLTIP\" | translate}}\' ng-if=\"item.item_type == \'service\' && ctrl.form.customer\" class=\"have-tooltip make-cards\" ng-click=\"ctrl.openGiftCardDetails(index)\"><i ng-if=\"!item.isGiftCard\" class=\"las la-plus\"></i><i ng-if=\"item.isGiftCard\" class=\"las la-cog\"></i><i class=\"las la-gift customers-has-chards\" aria-hidden=\"true\"></i></div></div></div><div class=\"td-middle\"><button type=\"button\" class=\"btn icon simple red\" ng-click=\"ctrl.removeItem(index)\" ng-disabled=\"ctrl.isDebtTransaction\"><i class=\"las la-times\"></i></button></div><div class=\"course\" ng-if=\"item.courses\"><div class=\"form-group form-select last\"><label>{{\"CALENDAR_ORDER_COURSES\" | translate}}</label><select chosen=\"\" name=\"course_id\" ng-model=\"ctrl.items[index].course_id\" required=\"\" data-placeholder=\'{{\"CALENDAR_ORDER_COURSES\" | translate}}\'><option value=\"\">{{\"CALENDAR_ORDER_COURSES\" | translate}}</option><option value=\"{{index}}\" ng-repeat=\"(index, course) in item.courses\">{{course}}</option></select></div></div></div></div><table class=\"table cashbox-summary-table\" ng-if=\"ctrl.items.length > 0\"><tfoot class=\"checkout\" ng-if=\"isMobile || (!isMobile && ctrl.items.length > 0)\"><tr class=\"total\" ng-hide=\"ctrl.hide_prices\"><td><h6 class=\"title\" ng-if=\"!ctrl.isCreditTransaction\">{{\"CALENDAR_CASH_TOTAL\" | translate}}</h6></td><td style=\"vertical-align: middle; text-align: center;\"><div ng-if=\"ctrl.prepaid\"><b>{{\"CASHBOX_PREPAID_TITLE\" | translate}} {{ctrl.prepaid}}</b></div><div ng-if=\"ctrl.giftCardTotal() > 0\"><i class=\"las la-gift\"></i> <b>{{\"GIFT_CARD\" | translate}} {{ctrl.giftCardTotal()}}₪</b></div></td><td></td><td width=\"100px\"><div ng-if=\"ctrl.show_discount\"><div class=\"form-group last\"><label>{{\"CASHBOX_DISCOUNT_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"discount-input\" class=\"form-control discount-input\" ng-model=\"ctrl.total_discount\" ng-change=\"ctrl.changeTotalPercentage()\"></div><span class=\"price\">&nbsp;</span></div></td><td width=\"100px\"><div ng-if=\"ctrl.show_discount\"><div class=\"form-group last\"><label>{{\"CASHBOX_NET_PRICE_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"discount-input\" class=\"form-control discount-input\" ng-model=\"ctrl.cashboxTotal\" ng-change=\"ctrl.changeTotalSum()\"></div></div><h6 class=\"title\" ng-if=\"ctrl.isCreditTransaction\">{{\"CALENDAR_CASH_TOTAL_CREDIT\" | translate}}</h6><span class=\"price\">{{ctrl.cashboxTotal | priceFloat:true}}</span></td></tr><tr class=\"methods\" ng-if=\"!ctrl.isAllPayedByCard() && !ctrl.isAllPayedByGiftCards() && !ctrl.form.quotation\"><td colspan=\"5\" ng-class=\"{\'debt-transaction\': !(!ctrl.isDebtTransaction && (!ctrl.isCreditTransaction || ctrl.customerData.oncredit))}\"><div class=\"flex cashbox-buttons\"><a ng-click=\"ctrl.choosePayMethod(\'cash\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.cash.active, \'disabled\': ctrl.methods.cash.disabled}\">{{\"CALENDAR_CASH_CASH\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'credit_card\')\" class=\"btn text border-primary large\" ng-if=\"ctrl.businessInfo && ctrl.businessInfo.data.credit_card && (!ctrl.isCreditTransaction || ctrl.isCreditCreditCard)\" ng-class=\"{\'active\': ctrl.methods.credit_card.active, \'disabled\': ctrl.methods.credit_card.disabled}\">{{\"ADMIN_CREDIT_CARD\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'oncredit\')\" class=\"btn text border-primary large\" ng-if=\"!ctrl.isDebtTransaction && (!ctrl.isCreditTransaction || ctrl.customerData.oncredit)\" ng-class=\"{\'active\': ctrl.methods.oncredit.active, \'disabled\': ctrl.methods.oncredit.disabled}\">{{\"CALENDAR_CASH_ON_CREDIT\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'cheque\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.cheque.active, \'disabled\': ctrl.methods.cheque.disabled}\">{{\"CALENDAR_CASH_CHEQUE\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'bank_transfer\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.bank_transfer.active, \'disabled\': ctrl.methods.bank_transfer.disabled}\">{{\"CALENDAR_CASH_BANK_TRANS\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'credit_card_external\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.credit_card_external.active, \'disabled\': ctrl.methods.credit_card_external.disabled}\">{{\"CALENDAR_CASH_CREDIT_CARD_EXT\" | translate}}</a> <a ng-if=\"(ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_phone)) && ctrl.businessInfo.data && ctrl.businessInfo.data.paid_link && !ctrl.isCreditTransaction\" ng-click=\"ctrl.choosePayMethod(\'pay_link\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.pay_link.active, \'disabled\': ctrl.methods.pay_link.disabled}\">{{\"CALENDAR_PAY_LINK\" | translate}}</a> <a ng-click=\"ctrl.openGiftCardModal()\" class=\"btn text border-primary large\" ng-class=\"{\'disabled\': ctrl.methods.retainer.active}\">{{\"GIFT_CARD\" | translate}}</a> <a ng-if=\"ctrl.customerCreditCards && ctrl.customerCreditCards.length > 0 && !ctrl.isCreditTransaction\" ng-click=\"ctrl.choosePayMethod(\'retainer\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.retainer.active, \'disabled\': ctrl.methods.retainer.disabled || ctrl.form.retainer_id}\">{{\"RETAINER_PAYMENT_TYPE\" | translate}}</a></div></td></tr><tr><td class=\"payments-col\" colspan=\"5\"><div class=\"form-group form-select last credit-card-select\" ng-if=\"ctrl.customerCreditCards && ctrl.customerCreditCards.length > 0 && !ctrl.isCreditTransaction && (ctrl.methods[\'credit_card\'].active || ctrl.methods[\'retainer\'].active)\"><label>{{\'ZCREDIT_CARD_SELECT\' | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.creditCardId\"><option value=\"\">{{\'ZCREDIT_CARD_SELECT\' | translate}}</option><option ng-repeat=\"card in ctrl.customerCreditCards\" value=\"{{card.id}}\">{{card.number}}</option></select></div><div class=\"col-xs-12 btn-nostyle no-padding retainer-form\" ng-if=\"ctrl.methods[\'retainer\'].active\"><div class=\"flex gap-16\"><div class=\"form-group last\"><label>{{\'RETAINER_START_DATETIME\' | translate}}</label> <input type=\"datetime-local\" class=\"form-control\" ng-model=\"ctrl.form.retainer_start_date\"></div><div class=\"form-group form-select last\"><label>{{\'RETAINER_PERIOD\' | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.retainer_period\"><option value=\"monthly\">{{\'RETAINER_PERIOD_MONTHLY\' | translate}}</option><option value=\"weekly\">{{\'RETAINER_PERIOD_WEEKLY\' | translate}}</option></select></div></div><div class=\"flex gap-16\"><div class=\"form-group last\"><label>{{\'RETAINER_COUNT\' | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.form.retainer_count\" ng-disabled=\"ctrl.form.retainer_infinity\"></div><div class=\"form-switch form-group last\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.retainer_infinity\">{{\"RETAINER_INFINITY\" | translate}}</label></div></div></div><div class=\"col-xs-12 btn-nostyle no-padding\"><div class=\"form-switch form-group last\" ng-if=\"(ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_phone)) && ctrl.msg_channel_inv_link*1 > 0\"><label><input type=\"checkbox\" ng-model=\"ctrl.sendInvoice\">{{\"CASHBOX_SEND_INVOICE\" | translate}}</label></div></div><div class=\"col-xs-12 btn-nostyle no-padding\"><div class=\"form-switch form-group last\" ng-if=\"ctrl.cerdit_company != 2 && ctrl.cerdit_company != 3 && ctrl.businessHasCardReader && ctrl.methods[\'credit_card\'].active\"><label><input type=\"checkbox\" ng-model=\"ctrl.useCardReader\">{{\"CASHBOX_CARD_READEAR_SWITCHER\" | translate}}</label></div></div><div class=\"col-xs-12 btn-nostyle no-padding\" ng-if=\"ctrl.cerdit_company == 3 && ctrl.methods[\'credit_card\'].active && !ctrl.isCreditTransaction\"><div class=\"form-switch form-group\" ng-if=\"!ctrl.creditCardId\"><label><input type=\"checkbox\" ng-model=\"ctrl.useIframe\" ng-change=\"ctrl.numberOfPaymentsEmv = 1; ctrl.creditDeal = false;\">{{\"ZCREDIT_IFRAME_CHECKBOX\" | translate}}</label></div><div class=\"form-switch form-group\" ng-if=\"ctrl.z_credit_credit_deal && !ctrl.useIframe && ctrl.cashboxTotal >= 75\"><label><input type=\"checkbox\" ng-model=\"ctrl.creditDeal\">{{\"ZCREDIT_CHECKBOX_CREDIT_DEAL\" | translate}}</label></div><div class=\"form-group\" ng-if=\"!ctrl.useIframe\"><label style=\"display:block\">{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}</label> <input type=\"text\" value=\"1\" placeholder=\"{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}\" class=\"form-control\" ng-model=\"ctrl.numberOfPaymentsEmv\"></div></div><div class=\"col-xs-12 btn-nostyle no-padding\" ng-if=\"(ctrl.cerdit_company == 3 || ctrl.cerdit_company == 2 || ctrl.cerdit_company == 1) && ctrl.methods[\'pay_link\'].active\"><div class=\"form-group\"><label style=\"display:block\">{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}</label> <input type=\"text\" value=\"1\" placeholder=\"{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}\" class=\"form-control\" ng-model=\"ctrl.numberOfPaymentsEmv\"></div></div></td></tr><tr><td colspan=\"5\"><div class=\"payment-buttons\"><button id=\"checkout\" class=\"btn text primary large\" ng-if=\"!ctrl.isAllPayedByCard() && !ctrl.isAllPayedByGiftCards()\" ng-click=\"ctrl.resetPayment(); ctrl.completePayment();\" ng-disabled=\"ctrl.isDisabledPaymentBtn() || ctrl.cashboxLoading\">{{\"CALENDAR_CASH_FOR_PAYMENT\" | translate}}</button> <button id=\"checkout\" class=\"btn text primary large\" ng-if=\"ctrl.isAllPayedByCard() || ctrl.isAllPayedByGiftCards()\" ng-disabled=\"ctrl.cashboxLoading\" ng-click=\"ctrl.resetPayment(); ctrl.completePayment();\">{{\"CASHBOX_CONFIRM_PAYMENT_BTN\" | translate}}</button></div><div class=\"mt-24\"><textarea placeholder=\'{{\"CASHBOX_COMMENT\" | translate}}\' auto-expand=\"\" class=\"form-control\" ng-model=\"ctrl.form.comment\"></textarea></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/modules/marketing/marketing.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'marketing\')\"><div class=\"cloud mb-24\" ng-if=\"ctrl.tab != \'\'\"><div class=\"cloud-head\"><button class=\"btn icon default\" ng-click=\"ctrl.tab = \'\';\"><i class=\"las la-angle-right rotatable\"></i></button><h3 ng-if=\"ctrl.tab == \'sms\'\">{{ \"MARKETING_SMS\" | translate }}</h3><h3 ng-if=\"ctrl.tab == \'wa\'\">{{ \"MARKETING_WA\" | translate }}</h3><h3 ng-if=\"ctrl.tab == \'email\'\">{{ \"MARKETING_EMAIL\" | translate }}</h3></div><div><form action=\"\" method=\"\" name=\"reportsForm\" class=\"generate-report bg-white panel-rounded\" autocomplete=\"off\"><div class=\"\" ng-if=\"ctrl.tab == \'sms\' || ctrl.tab == \'wa\' || ctrl.tab == \'email\'\" id=\"reports-table\"><div class=\"tb-div\" ng-app=\"tabApp\"><div class=\"flex form fill fill-m\"><div class=\"flex form\"><div ng-include=\"\'app/components/cfilter/button.html\'\"></div><div><div class=\"actions\"><button type=\"button\" ng-click=\"ctrl.send_message();\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></div></div><div class=\"flex form fill fill-m\"><div class=\"mt-24\"><div class=\"form-group last with_upload\"><label>{{\"CUSTOMERS_CONTENT_MESSAGE\" | translate}}</label> <span ng-if=\"ctrl.tab == \'wa\'\" class=\"upload_file_paperclip\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"> <i class=\"la la-paperclip\"></i> <span ng-if=\"ctrl.files && ctrl.files.length\" class=\"remove\"><i class=\"las la-times\"></i></span></span> <button type=\"button\" style=\"margin: 0 10px; height: 24px;\" ng-click=\"ctrl.putVariable();\" class=\"btn text border-primary small\">{{\"MARKETING_PUT_CUSTOMER_NAME\" | translate}}</button> <textarea class=\"form-control\" maxlength=\"{{ctrl.smsMaxLength}}\" type=\"text\" name=\"message\" ng-model=\"ctrl.message\"></textarea></div></div></div></div></div></form></div></div><div class=\"cloud\" ng-if=\"ctrl.tab == \'sms\' || ctrl.tab == \'wa\' || ctrl.tab == \'email\'\"><div class=\"table-responsive\"><table id=\"cust_dt\" ng-table=\"ctrl.tableCustomers\" datatable=\"\" dt-instance=\"dtInstanceCustomers\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" class=\"table table-striped table-bordered table-hover dataTables-example reports-table customers-table\"></table></div></div><div class=\"cloud\" id=\"settings\" ng-if=\"ctrl.tab === \'\'\"><div class=\"all-reports--container\"><div class=\"all-reports--inner blue\"><div ng-click=\"ctrl.setTab(\'sms\')\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_SMS\" | translate }}</p></div></div><div class=\"all-reports--inner green\"><div ng-click=\"ctrl.setTab(\'wa\')\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-whatsapp\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_WA\" | translate }}</p></div></div><div class=\"all-reports--inner red\"><div ng-click=\"ctrl.setTab(\'email\')\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_EMAIL\" | translate }}</p></div></div><a ui-sref=\"app.marketing.automations\" class=\"all-reports--inner blue\"><div><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-magic\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_AUTOMATIONS\" | translate }}</p></div></a> <a ui-sref=\"app.marketing.recommendations\" class=\"all-reports--inner green\"><div><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-lightbulb\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_RECOMMENDATIONS\" | translate }}</p></div></a></div></div></div>");
$templateCache.put("app/modules/digital_forms/digital_forms.view.html","<div class=\"modal-form-inner digital_form_modal\" ng-if=\"!ctrl.finished\"><div class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name ? DigitalForm.name : \"&nbsp;\"}}</h2></div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group form-select\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><select class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"><option value=\"\">{{field.name}}</option><option value=\"{{item.value}}\" ng-repeat=\"(i, item) in field.items\">{{item.name}}</option></select></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"date\" min=\"1900-01-01\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><span ng-click=\"ctrl.clearSign(index)\" ng-if=\"!DigitalForm.fill_date\"><i class=\"las la-trash\"></i></span><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div></div></div></div></div></div></div><div class=\"modal-footer modal-footer-align-center\" ng-if=\"!DigitalForm.fill_date && !DigitalForm.text_form\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/pay/pay.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h1 ng-if=\"!orderItem\" class=\"text-center\">{{\"ORDER_NOT_EXIST\" | translate}}</h1><h1 ng-if=\"orderItem && !orderItem.already_paid\" class=\"text-center\">{{\"ORDER_PAY_TITLE\" | translate}} {{orderItem.data.payments.pay_link.amount}}</h1><h1 ng-if=\"orderItem && orderItem.already_paid\" class=\"text-center\">{{\"ORDER_ALREADY_PAY\" | translate}}</h1></div><form class=\"modal-form_f\" name=\"signForm\" novalidate=\"\" ng-if=\"orderItem && !orderItem.already_paid\"><div class=\"modal-body\"><div class=\"panel-body pay-form\"><table class=\"table\" ng-if=\"items.length > 0\"><thead><tr><td>{{\"CUSTOMER_TRANSACTIONS_ITEM_DESC\" | translate}}</td><td>{{\"CUSTOMER_TRANSACTIONS_QUANTITY\" | translate}}</td><td></td><td>מחיר</td></tr></thead><tbody class=\"items\"><tr class=\"item\" ng-repeat=\"item in items\"><td><div class=\"item-inputs form-group last\"><label>{{item.name}}</label></div></td><td>{{item.quantity}}</td><td width=\"1%\" class=\"card-item-match\"><span ng-if=\"item.card_balance_used\"><i class=\"las la-ticket-alt\"></i></span></td><td class=\"price-spinner-data relative\"><div class=\"form-group last\">{{item.price}}</div></td></tr></tbody><tfoot class=\"checkout\"><tr><td><label>{{\"CALENDAR_CASH_TOTAL\" | translate}}</label></td><td></td><td></td><td><b>{{orderItem.data.payments.pay_link.amount | price:true}}</b></td></tr></tfoot></table><iframe ng-src=\"{{iframe()}}\" style=\"width:100%; height:100%; min-height: 700px;\" frameborder=\"0\"></iframe></div></div></form></div>");
$templateCache.put("app/modules/pdf-preview/pdf-preview.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\"></h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div ng-if=\"ctrl.pdfUrl\" class=\"modal-body document-buttons\"><div class=\"pdf-preview\"><iframe ng-src=\"{{ctrl.pdfUrl}}\" style=\"width: 100%; height: calc(100vh - 68px); border: none;\"></iframe></div></div><div ng-if=\"ctrl.imageUrl\" class=\"modal-body\"><div class=\"image-preview\"><img ng-src=\"{{ctrl.imageUrl}}\" style=\"width: 100%; height: auto; border: none;\"></div></div></div>");
$templateCache.put("app/modules/prepaid/prepaid.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h1 ng-if=\"!orderItem\" class=\"text-center\">{{\"ORDER_NOT_EXIST\" | translate}}</h1><h1 ng-if=\"orderItem && !orderItem.already_paid\" class=\"text-center\">{{\"ORDER_PREPAID_TITLE\" | translate}} {{orderItem.business.prepaid}}</h1><h1 ng-if=\"orderItem && orderItem.already_paid\" class=\"text-center\">{{\"ORDER_ALREADY_PREPAID\" | translate}}</h1></div><form class=\"modal-form_f\" name=\"signForm\" novalidate=\"\" ng-if=\"orderItem && !orderItem.already_paid\"><div class=\"modal-body\"><div class=\"panel-body\"><iframe ng-src=\"{{iframe()}}\" style=\"width:100%; height:100%; min-height: 700px;\" frameborder=\"0\"></iframe></div></div></form></div>");
$templateCache.put("app/modules/reports/reports.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'reports\')\"><div class=\"cloud mb-24\" ng-if=\"ctrl.tab != 4\"><div class=\"cloud-head\"><button class=\"btn icon default\" ng-click=\"ctrl.tab = 4;ctrl.form.order_type = \'\';ctrl.report_is_finished=false;\"><i class=\"las la-angle-right rotatable\"></i></button><h3 ng-if=\"ctrl.tab == 2\">{{ \"REPORTS_CANCELED_ORDERS_HISTORY_LBL\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 3\">{{ \"REPORTS_INCOME_LBL\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 7\">{{\"CUSTOMERS_DEBTS_REPORT_TITLE\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 9\">{{\"REPORT_ORDERS_LBL\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 8\">{{\"WORKERS_TIME_REPORT\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 10\">{{ \"REPORTS_CUSTOMERS_TITLE\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 11\">{{ \"REPORTS_FEEDBACK_TITLE\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 12\">{{\"REPORT_SALES\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 13\">{{\"REPORT_CARDS\" | translate}}</h3></div><div><form action=\"\" method=\"\" name=\"reportsForm\" class=\"generate-report bg-white panel-rounded\" autocomplete=\"off\"><div class=\"fields\" ng-if=\"ctrl.tab !== 7\"><div class=\"test\" ng-app=\"tabApp\" ng-model=\"ctrl.form.order_type\"><div class=\"flex form fill-m\" ng-if=\"ctrl.tab == 10\"><div><div class=\"form-group form-select\"><label>{{\"CUSTOMERS_GENDER\" | translate}}</label><select class=\"form-control\" ng-disabled=\"ctrl.request_in_progress\" ng-model=\"ctrl.form.gender\"><option value=\"\">{{\"REPORT_OPTION_ALL\" | translate}}</option><option value=\"0\">{{\"CUSTOMERS_GENDER_MALE\" | translate}}</option><option value=\"1\">{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"REPORT_CUSTOMERS_FIELDS_CARD_EXIST\" | translate}}</label><select class=\"form-control\" ng-disabled=\"ctrl.request_in_progress\" ng-model=\"ctrl.form.card_exist\"><option value=\"\">{{\"REPORT_OPTION_ALL\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option><option value=\"0\">{{\"OPTION_NO\" | translate}}</option></select></div></div><div><div class=\"form-group\"><label>{{\"REPORT_CUSTOMERS_FIELDS_LAST_VISIT\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-disabled=\"ctrl.request_in_progress\" ng-model=\"ctrl.form.last_visit\"></div></div><div><div class=\"form-group form-select\"><label>{{\"REPORT_CUSTOMERS_FIELDS_SELF_ORDER\" | translate}}</label><select class=\"form-control\" ng-disabled=\"ctrl.request_in_progress\" ng-model=\"ctrl.form.self_order\"><option value=\"\">{{\"REPORT_OPTION_ALL\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option><option value=\"0\">{{\"OPTION_NO\" | translate}}</option></select></div></div></div><div class=\"flex form fill-m\" ng-if=\"ctrl.tab !== 4 && ctrl.tab !== 10 && ctrl.tab !== 13\"><div ng-if=\"ctrl.tab == 9 || ctrl.tab === 3 || ctrl.tab === 12\"><div class=\"form-group form-select\"><label>{{\"REPORT_TYPE\" | translate}}</label><select class=\"form-control\" ng-disabled=\"ctrl.request_in_progress\" ng-model=\"ctrl.form.report_type\" required=\"\"><option value=\"\">{{\"REPORT_TYPE\" | translate}}</option><option value=\"detailed\">{{\"REPORT_TYPE_DETAIL\" | translate}}</option><option value=\"summary\">{{\"REPORT_TYPE_SUMMERY\" | translate}}</option></select></div></div><div ng-if=\"ctrl.tab == 9 || ctrl.tab == 12\" ng-include=\"\'app/components/cfilter/button.html\'\"></div><div><div class=\"form-group icon-append\"><label for=\"report-start-date\">{{\"REPORT_FROM\" | translate}}</label> <input type=\"datetime\" date-time=\"\" auto-close=\"true\" fix-datepicker-position=\"\" ng-disabled=\"ctrl.request_in_progress\" class=\"form-control background-white\" id=\"report-start-date\" required=\"\" ng-model=\"ctrl.start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div ng-if=\"ctrl.tab !== 4 && ctrl.tab !== 13\"><div class=\"form-group icon-append\"><label for=\"report-end-date\">{{\"REPORT_UNTIL\" | translate}}</label> <input type=\"datetime\" date-time=\"\" ng-disabled=\"ctrl.request_in_progress\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"report-end-date\" required=\"\" ng-model=\"ctrl.end_date\" auto-close=\"true\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div ng-if=\"ctrl.tab == 9 && ctrl.form.report_type == \'summary\'\"><div class=\"form-group form-select\"><label>{{\"FILTER_STATUSES\" | translate}}</label><div class=\"form-control\" style=\"width: 300px\"><ui-select multiple=\"\" ng-model=\"ctrl.selectedStatuses\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"FILTER_STATUSES_PLACEHOLDER\" | translate}}\'>{{(\"ORDER_\" + $item.name) | translate}}</ui-select-match><ui-select-choices toggle-selection=\"status\" ng-model=\"ctrl.selectedStatuses\" repeat=\"status in ctrl.statusList | filter:$select.search\"><span class=\"multicheck\"></span>{{(\"ORDER_\" + status.name) | translate}}</ui-select-choices></ui-select></div></div></div><div ng-if=\"ctrl.tab == 12\"><div class=\"flex form fill-m\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.fields_customer\">{{\"SALES_REPORT_FIELD_CUSTOMER\" | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.fields_category\">{{\"SALES_REPORT_FIELD_CATEGORY\" | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.fields_resource\">{{\"SALES_REPORT_FIELD_RESOURCE\" | translate}}</label></div></div></div><div ng-if=\"ctrl.tab == 3 || ctrl.tab == 12 || ctrl.tab == 8\"><div class=\"flex form fill-m\"><div class=\"form-group\"><label>{{\"REPORT_EMAILS_LIST\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.emails_list\"></div></div></div><div ng-if=\"ctrl.tab == 3 && ctrl.dealer_type == \'licensed\'\"><div class=\"flex form fill-m\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.export_excel\">{{\"REPORT_EXPORT_EXCEL\" | translate}}</label></div></div></div></div></div><div class=\"flex gap-24\" ng-if=\"ctrl.tab !== 4\"><button type=\"button\" ng-click=\"ctrl.create_new_report(\'download\');\" ng-if=\"showDownloadBtn\" ng-disabled=\"reportsForm.$invalid || ctrl.request_in_progress || ctrl.tab === 1\" class=\"btn text border-green large\" ng-class=\"{\'loading\': ctrl.download_in_progress}\">{{\"REPORT_DOWNLOAD\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.create_new_report(\'preview\');\" ng-disabled=\"reportsForm.$invalid || ctrl.request_in_progress || ctrl.tab === 1\" ng-if=\"ctrl.tab !== 8\" class=\"btn text border-primary large\" ng-class=\"{\'loading\': ctrl.preview_in_progress}\">{{\"REPORT_PREVIEW\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.create_new_report(\'sendbymail\');\" ng-if=\"ctrl.tab != 11\" ng-disabled=\"reportsForm.$invalid || ctrl.request_in_progress || ctrl.tab === 1\" class=\"btn text primary large\" ng-class=\"{\'loading\': ctrl.send_in_progress}\">{{\"REPORT_SEND_MAIL\" | translate}}</button></div></div><div class=\"\" ng-if=\"ctrl.tab == 7\" id=\"reports-table\"><div class=\"tb-div\" ng-app=\"tabApp\"><div><div><div class=\"table-responsive\"><table ng-if=\"ctrl.tableData\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover reports-table customers-debtors-table\"><thead><tr><th class=\"customer-name\">{{\"CUSTOMERS_NAME\" | translate}}</th><th class=\"customer-debt-header\">{{\"CUSTOMERS_DEBT_AMOUNT_TITLE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.showCustomersDetails(row.id)\"><td class=\"customer-name\"><div class=\"customer-pic-wrapper\"><img ng-src=\"{{row.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{row.firstname}} {{row.lastname}}</td><td class=\"customer-debt-cell\">{{row.oncredit | thousands}}</td><td><button type=\"button\" ng-click=\"ctrl.remind_customer_debt(row);$event.stopPropagation()\" class=\"btn text border-primary\">{{\"SEND_DEBTORS_MSG_BTN\" | translate}}</button> <a ui-sref=\"app.cashbox.closedebt({customer: {{row.id}}})\" class=\"close-debt btn text primary\">{{\"CUSTOMERS_OV_COV\" | translate}}</a></td></tr></tbody></table></div></div></div><div class=\"row\"></div></div></div></form></div></div><div class=\"cloud\" id=\"settings\" ng-if=\"ctrl.tab === 4\"><div class=\"all-reports--container\"><div class=\"all-reports--inner\"><div ng-click=\"ctrl.goToTransactions()\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-dollar-sign\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_TRANSACTIONS_HISTORY_LBL\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(2);ctrl.form.order_type=\'cancelled\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-times\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_CANCELED_ORDERS_HISTORY_LBL\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(3);ctrl.form.order_type=\'income\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-chart-bar\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_INCOME_LBL\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(7)\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-money-bill\"></i></span><p class=\"all-reports--title\">{{\"CUSTOMERS_DEBTS_REPORT_TITLE\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(9);ctrl.form.order_type=\'items\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-alt\"></i></span><p class=\"all-reports--title\">{{\"REPORT_ORDERS_LBL\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(8);ctrl.form.order_type=\'workers_time\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-alt\"></i></span><p class=\"all-reports--title\">{{\"WORKERS_TIME_REPORT\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(10);ctrl.form.order_type=\'customers\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-user-friends\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_CUSTOMERS_TITLE\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(11);ctrl.form.order_type=\'feedbacks\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-user-edit\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_FEEDBACK_TITLE\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(12);ctrl.form.order_type=\'sales\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-chart-line\"></i></span><p class=\"all-reports--title\">{{\"REPORT_SALES\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(13);ctrl.form.order_type=\'cards\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-credit-card\"></i></span><p class=\"all-reports--title\">{{\"REPORT_CARDS\" | translate}}</p></div></div><div class=\"all-reports--inner\" ui-sref=\"app.reports.tax_files\"><div><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-invoice-dollar\"></i></span><p class=\"all-reports--title\">{{\"SETTINGS_TAX_FILES\" | translate}}</p></div></div></div></div><div class=\"cloud\" ng-if=\"ctrl.report_is_finished\"><div class=\"flex form\"><div><div class=\"form-group icon-prepend\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.searchTableData()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\" ng-if=\"showTable\"><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'cancelled\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_ORDER_DATE\" | translate}}</th><th>{{\"REPORT_CANCEL_DATE\" | translate}}</th><th>{{\"REPORT_CANCEL_REASON\" | translate}}</th><th>{{\"REPORT_CLIENT\" | translate}}</th><th>{{\"REPORT_ITEM\" | translate}}</th><th>{{\"REPORT_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.order_date}}</td><td>{{row.cancel_date}}</td><td>{{row.cancel_reason}}</td><td>{{row.order_customer_firstname}} {{row.order_customer_lastname}}</td><td>{{row.item_data.name}}</td><td>{{row.order_price | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'sales\' && ctrl.tableData\" dt-options=\"dtOptionsSales\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-show=\"ctrl.form.fields_customer\">{{\"SALES_REPORT_FIELD_CUSTOMER\" | translate}}</th><th ng-show=\"ctrl.form.report_type == \'detailed\'\">{{\"SALES_REPORT_FIELD_DATE\" | translate}}</th><th ng-show=\"ctrl.form.fields_category\">{{\"SALES_REPORT_FIELD_CATEGORY\" | translate}}</th><th ng-show=\"ctrl.form.fields_resource\">{{\"SALES_REPORT_FIELD_RESOURCE\" | translate}}</th><th>{{\"SALES_REPORT_FIELD_ITEM\" | translate}}</th><th>{{\"SALES_REPORT_FIELD_QTY\" | translate}}</th><th>{{\"SALES_REPORT_FIELD_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td ng-show=\"ctrl.form.fields_customer\">{{row.customer_name}}</td><td ng-show=\"ctrl.form.report_type == \'detailed\'\">{{row.date}}</td><td ng-show=\"ctrl.form.fields_category\">{{row.category}}</td><td ng-show=\"ctrl.form.fields_resource\">{{row.resource}}</td><td>{{row.item}}</td><td>{{row.qty}}</td><td>{{row.total | thousands}}</td></tr></tbody><tfoot><tr class=\"gradeX\"><td ng-show=\"ctrl.form.fields_customer\"></td><td ng-show=\"ctrl.form.report_type == \'detailed\'\"></td><td ng-show=\"ctrl.form.fields_category\"></td><td ng-show=\"ctrl.form.fields_resource\"></td><td></td><td><b>{{ctrl.calculateTotals().qty}}</b></td><td><b>{{ctrl.calculateTotals().total | thousands}}</b></td></tr></tfoot></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'income\' && ctrl.form.report_type == \'detailed\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_DOCUMENT_DATE\" | translate}}</th><th>{{\"REPORT_DOCUMENT_TYPE\" | translate}}</th><th>{{\"REPORT_DOCUMENT_NUMBER\" | translate}}</th><th>{{\"REPORT_TOTAL_BEFORE_VAT\" | translate}}</th><th>{{\"REPORT_VAT\" | translate}}</th><th>{{\"REPORT_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.document_date}}</td><td>{{row.document_type | translate}}</td><td>{{row.number}}</td><td>{{row.subtotal}}</td><td>{{row.vat}}</td><td>{{row.total | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'income\' && ctrl.form.report_type == \'summary\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_DOCUMENT_TYPE\" | translate}}</th><th>{{\"REPORT_QUANTITY\" | translate}}</th><th>{{\"REPORT_TOTAL_BEFORE_VAT\" | translate}}</th><th>{{\"REPORT_VAT\" | translate}}</th><th>{{\"REPORT_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.document_type | translate}}</td><td>{{row.qty}}</td><td>{{row.subtotal | thousands}}</td><td>{{row.vat | thousands}}</td><td>{{row.total | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'customers\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th>{{\"CUSTOMERS_LAST_VISIT\" | translate}}</th><th>{{\"CUSTOMERS_SHOWS\" | translate}}</th><th>{{\"CUSTOMERS_YEAR_INCOME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar ? row.avatar : \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{(row.firstname != null ? row.firstname : \'\')+\' \'+(row.lastname != null ? row.lastname : \'\')}}</td><td><span ng-hide=\"{{row.last_visit == \'01/01/1970\'}}\">{{row.last_visit}}</span></td><td>{{row.number_of_shows}}</td><td>{{row.current_year_income | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'items\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_ORDERS_RES_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"SALES_REPORT_FIELD_CUSTOMER\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'detailed\'\">{{\"REPORT_ORDERS_ITEMS_AMOUNT_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_ORDER_STATUS_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_ITEM_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"REPORT_ORDERS_DATE_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"REPORT_ORDERS_START_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"REPORT_ORDERS_END_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_HOURS_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_PRICE_COL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.resource_name | translate}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.customer_name}}</td><td ng-if=\"ctrl.form.report_type != \'detailed\'\">{{row.items_amount | translate}}</td><td>{{row.order_status_ttl}}</td><td>{{row.item_name}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.order_date}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.item_start_time}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.item_end_time}}</td><td>{{row.item_duration | hourAndMinuteWithZeros}}</td><td>{{row.item_price | thousands}}</td></tr></tbody><tfoot ng-if=\"ctrl.tableData[0].total_items_duration\"><tr class=\"gradeX\"><td></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td ng-if=\"ctrl.form.report_type != \'detailed\'\">{{ctrl.tableData[0].total_items_amount}}</td><td></td><td></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td>{{ctrl.tableData[0].total_items_duration}}</td><td>{{ctrl.tableData[0].total_items_price}}</td></tr></tfoot></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'feedbacks\' && ctrl.tableData\" dt-options=\"dtOptionsFeedback\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_CUSTOMER\" | translate}}</th><th>{{\"REPORT_STARS\" | translate}}</th><th>{{\"REPORT_SERVICE\" | translate}}</th><th>{{\"REPORT_SERVICE_LEVEL\" | translate}}</th><th>{{\"REPORT_CLEAN_LEVEL\" | translate}}</th><th>{{\"REPORT_TEXT\" | translate}}</th><th>{{\"REPORT_DATE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.openOrderModal(row.order_id)\"><td>{{row.c_customer_name}}{{row.o_customer_name}}</td><td>{{row.stars}}</td><td>{{row.service}}</td><td>{{row.level_service}}</td><td>{{row.level_cleanliness}}</td><td>{{row.text}}</td><td>{{row.feedback_date}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'cards\' && ctrl.tableData\" dt-options=\"dtOptionsCards\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_CARDS_CUSTOMER\" | translate}}</th><th>{{\"REPORT_CARDS_NAME\" | translate}}</th><th>{{\"REPORT_CARDS_BALANCE\" | translate}}</th><th>{{\"REPORT_CARDS_DATE_UPDATED\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.firstname}} {{row.lastname}}</td><td>{{row.name}}</td><td>{{row.balance | thousands}}</td><td>{{row.date_updated}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/gift_card/gift_card.view.html","<div ng-if=\"ctrl.settings && ctrl.settings.page_bg_color\" class=\"public-gc-page\" ng-style=\"{ backgroundColor: ctrl.settings.page_bg_color }\"><div class=\"public-gc-waves\"></div><div class=\"public-gc-container\"><gift-card settings=\"ctrl.settings\" values=\"ctrl.values\" size=\"large\" view=\"mobile\"></gift-card><div ng-if=\"ctrl.used\" class=\"public-gc-used\"><div class=\"stamp\">{{ \'GIFT_CARD_USED\' | translate }}</div></div></div><div class=\"public-gc-socials\"><a ng-href=\"{{ ctrl.socials.phone }}\" target=\"_blank\" ng-if=\"ctrl.socials.phone\"><img src=\"/assets/images/phone-icon.png\" alt=\"Phone\"></a> <a ng-href=\"{{ ctrl.socials.facebook }}\" target=\"_blank\" ng-if=\"ctrl.socials.facebook\"><img src=\"/assets/images/facebook-icon.png\" alt=\"Facebook\"></a> <a ng-href=\"{{ ctrl.socials.wa }}\" target=\"_blank\" ng-if=\"ctrl.socials.wa\"><img src=\"/assets/images/whatsapp-icon.png\" alt=\"WhatsApp\"></a> <a ng-href=\"{{ ctrl.socials.waze }}\" target=\"_blank\" ng-if=\"ctrl.socials.waze\"><img src=\"/assets/images/waze-icon.png\" alt=\"Waze\"></a> <a ng-href=\"{{ ctrl.socials.instagram }}\" target=\"_blank\" ng-if=\"ctrl.socials.instagram\"><img src=\"/assets/images/instagram-icon.png\" alt=\"Instagram\"></a></div><div class=\"public-gc-powered\"><span>{{\"GIFT_CARD_POWERED_BY\" | translate}}</span> <a href=\"https://tiffulit.co.il\" target=\"_blank\" rel=\"noopener noreferrer\">{{\"GIFT_CARD_TIFFULIT_CRM\" | translate}}</a></div></div><div ng-if=\"!ctrl.settings.page_bg_color\" class=\"public-gc-page\"><h1>{{ \"GIFT_CARD_EMPTY\" | translate }}</h1></div>");
$templateCache.put("app/modules/review/review.view.html","<div class=\"modal-form-inner\" id=\"order\"><div class=\"modal-head\" ng-if=\"orderItem.id\"><div class=\"text-center\"><div class=\"business_logo\"><img height=\"100px\" src=\"{{orderItem.business_data.logo}}\"></div><div class=\"business_name\">{{orderItem.business_data.name}}</div><div class=\"business_address\">{{orderItem.business_data.address}}, {{orderItem.business_data.city}}</div></div></div><form class=\"modal-form_f\" name=\"feedbackForm\" novalidate=\"\" ng-if=\"orderItem.id && !ctrl.is_review\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"col-md-24 order-wrapper text-center\"><div class=\"feedback_title\">היי {{orderItem.customer_data.fullname}} נשמח לקבל דירוג ומשוב לשירות {{orderItem.services}} שקיבלת ב {{orderItem.order_date}} תודה {{orderItem.business_data.name}}</div><p>{{\"REQUEST_FEEDBACK_SERVICE\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.service >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 1\"></span> <span class=\"fa fa-star {{ctrl.service >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 2\"></span> <span class=\"fa fa-star {{ctrl.service >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 3\"></span> <span class=\"fa fa-star {{ctrl.service >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 4\"></span> <span class=\"fa fa-star {{ctrl.service >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 5\"></span></div><p>{{\"REQUEST_FEEDBACK_LEVEL_SERVICE\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.level_service >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 1\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 2\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 3\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 4\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 5\"></span></div><p>{{\"REQUEST_FEEDBACK_LEVEL_CLEANLINESS\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.level_cleanliness >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 1\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 2\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 3\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 4\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 5\"></span></div><p>{{\"REQUEST_FEEDBACK_SUMMARY\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.stars >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 1\"></span> <span class=\"fa fa-star {{ctrl.stars >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 2\"></span> <span class=\"fa fa-star {{ctrl.stars >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 3\"></span> <span class=\"fa fa-star {{ctrl.stars >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 4\"></span> <span class=\"fa fa-star {{ctrl.stars >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 5\"></span></div><div class=\"feedback_text\"><textarea class=\"feedback_input\" rows=\"5\" required=\"\" ng-model=\"ctrl.feedback\" placeholder=\'{{\"REQUEST_FEEDBACK_PLACEHOLDER\" | translate}}\'></textarea></div></div></div></div><div class=\"modal-footer modal-footer-align-center feedback-footer\"><button ng-if=\"ctrl.stars > 0 && ctrl.service > 0 && ctrl.level_service > 0 && ctrl.level_cleanliness > 0\" ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn btn-w-m btn-primary\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form><div ng-if=\"ctrl.is_review\"><div class=\"modal-body\"><div class=\"panel-body\"><h1 class=\"text-center\">{{\"REQUEST_FEEDBACK_THANKS\" | translate}}</h1></div></div><div class=\"modal-footer modal-footer-align-center\"></div></div><div ng-if=\"!orderItem.id\"><div class=\"modal-body\"><div class=\"panel-body\"><h1 class=\"text-center\">{{\"REQUEST_FEEDBACK_EXIST\" | translate}}</h1></div></div><div class=\"modal-footer modal-footer-align-center\"></div></div></div>");
$templateCache.put("app/modules/settings/settings.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><div class=\"cloud\"><div class=\"settings-block\"><h3 class=\"title\">{{\"SETTINGS_GENERAL\" | translate}}</h3><ul><li ng-if=\"isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.info\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-cog\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_DET\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_EDIT\" | translate}}</p></div></a></li><li ng-if=\"isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.color\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-tv\"></i></span><div><h6>{{\"SETTINGS_COLOR_DET\" | translate}}</h6><p>{{\"SETTINGS_COLOR_EDIT\" | translate}}</p></div></a></li><li ng-if=\"isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.online\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-calendar\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_ONLINE_DET\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_ONLINE_EDIT\" | translate}}</p></div></a></li><li ng-if=\"false && isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.landing\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-desktop\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_LANDING_DET\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_LANDING_EDIT\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.resources\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-user-tie\"></i></span><div><h6 ng-if=\"bu_type == 2\">{{\"SETTINGS_RESOURCE\" | translate}}</h6><p ng-if=\"bu_type == 2\">{{\"SETTINGS_RESOURCE_EDIT\" | translate}}</p><h6 ng-if=\"bu_type == 1\">{{\"SETTINGS_STAFF\" | translate}}</h6><p ng-if=\"bu_type == 1\">{{\"SETTINGS_STAFF_EDIT\" | translate}}</p></div></a></li><li ng-if=\"second_resource\"><a ui-sref=\"app.settings.second_resources\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-user-tie\"></i></span><div><h6>{{second_resource_name}} {{\"SETTINGS_SECOND_STAFF\" | translate}}</h6><p>{{second_resource_name}} {{\"SETTINGS_SECOND_STAFF_EDIT\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.items\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-cube\"></i></span><div><h6>{{\"SETTINGS_ITEMS\" | translate}}</h6><p>{{\"SETTINGS_ITEMS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.categories\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-th-large\"></i></span><div><h6>{{\"SETTINGS_CAT\" | translate}}</h6><p>{{\"SETTINGS_CAT_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.digital_documents\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-book\"></i></span><div><h6>{{\"SETTINGS_DIGITAL_DOCUMENTS\" | translate}}</h6><p>{{\"SETTINGS_DIGITAL_DOCUMENTS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.digital_forms\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-alt\"></i></span><div><h6>{{\"SETTINGS_DIGITAL_FORMS\" | translate}}</h6><p>{{\"SETTINGS_DIGITAL_FORMS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.laser_file\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-wrench\"></i></span><div><h6>{{\"SETTINGS_LASER_FILE\" | translate}}</h6><p>{{\"SETTINGS_LASER_FILE_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.call_logs\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-phone\"></i></span><div><h6>{{\"SETTINGS_CALL_LOGS\" | translate}}</h6><p>{{\"SETTINGS_CALL_LOGS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.sms_logs\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><div><h6>{{\"SETTINGS_SMS_LOGS\" | translate}}</h6><p>{{\"SETTINGS_SMS_LOGS_MANAGE\" | translate}}</p></div></a></li><li ng-if=\"manage_leads\"><a ui-sref=\"app.settings.leads\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-star\"></i></span><div><h6>{{\"SETTINGS_LEADS\" | translate}}</h6><p>{{\"SETTINGS_LEADS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.additional_fields\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{\"SETTINGS_ADDITIONAL_FIELDS\" | translate}}</h6><p>{{\"SETTINGS_ADDITIONAL_FIELDS_MANAGE\" | translate}}</p></div></a></li><li ng-if=\"ctrl.settings.courses\"><a ui-sref=\"app.settings.courses_fields\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{\"SETTINGS_COURSES_FIELDS\" | translate}}</h6><p>{{\"SETTINGS_COURSES_FIELDS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.photos_stock\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-images\"></i></span><div><h6>{{\"SETTINGS_PHOTOS_STOCK\" | translate}}</h6><p>{{\"SETTINGS_PHOTOS_STOCK_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.gift_cards\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-gift\"></i></span><div><h6>{{\"SETTINGS_GIFT_CARDS\" | translate}}</h6><p>{{\"SETTINGS_GIFT_CARDS_DESCRIPTION\" | translate}}</p></div></a></li></ul></div><div class=\"settings-block\"><h3 class=\"title\">{{\"SETTINGS_DOC_MESS\" | translate}}</h3><ul><li><a ui-sref=\"app.settings.logs\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{\"SETTINGS_TRANSACTIONS\" | translate}}</h6><p>{{\"SETTINGS_TRANSACTION_VIEW\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.messages\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><div><h6>{{\"SETTINGS_NOT_SET\" | translate}}</h6><p>{{\"SETTINGS_MES_SET\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/login/login.html","<div class=\"loginscreen animated fadeInDown\" translate-cloak=\"loginscreen\"><div class=\"login-data-form\"><div class=\"login-form-logo-holder\"><div class=\"logo\"></div></div><div class=\"login-form-holder\"><form class=\"modal-form_f\" name=\"loginForm\" ng-submit=\"ctrl.login()\" novalidate=\"\"><div class=\"heading text-center mb-4\">{{\"LOGIN_FORM_TITLE\" | translate}}</div><div class=\"form-group\"><div class=\"login-input-row\"><input type=\"email\" name=\"email\" ng-model=\"ctrl.form.email\" class=\"form-control\" required=\"\" placeholder=\'{{\"LOGIN_EMAIL\" | translate}}\'></div><div ng-messages=\"loginForm.email.$error\" class=\"ng-messages\" ng-show=\"loginForm.email.$dirty\" style=\"margin-right: 28px;\"><div ng-message=\"email\">{{\"LOGIN_EMAIL_VALID\" | translate}}</div><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group icon-append\"><div class=\"login-input-row\"><input id=\"login-input\" type=\"password\" name=\"password\" ng-model=\"ctrl.form.password\" class=\"form-control\" required=\"\" placeholder=\'{{\"LOGIN_PASS\" | translate}}\'></div><i class=\"las la-low-vision\"></i><div ng-messages=\"loginForm.password.$error\" class=\"ng-messages\" ng-show=\"loginForm.password.$dirty\" style=\"margin-right: 28px;\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div><div ng-message=\"creds\">{{\"LOGIN_INCORRECT\" | translate}}</div></div></div><div class=\"forgot-link\"><div class=\"form-check\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.remember\">{{\"LOGIN_REMEMBER\" | translate}}</label></div><a ui-sref=\"login.forgot_password\">{{\"LOGIN_FORGOT_PASS\" | translate}}</a></div><button type=\"submit\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" class=\"btn new full-width btn-login\">{{\"LOGIN_LOGIN\" | translate}}</button></form></div></div><div class=\"login-data-image\"></div></div>");
$templateCache.put("app/modules/terms-of-use/terms-of-use.html","<h1>TERMS OF USE (MOBILE APP)</h1><h2>1. TERMS OF USE</h2><p>By downloading, browsing, accessing or using this Sample Store mobile application (“Mobile Application”), you agree to be bound by these Terms and Conditions of Use. We reserve the right to amend these terms and conditions at any time. If you disagree with any of these Terms and Conditions of Use, you must immediately discontinue your access to the Mobile Application and your use of the services offered on the Mobile Application. Continued use of the Mobile Application will constitute acceptance of these Terms and Conditions of Use, as may be amended from time to time.</p><h2>2. DEFINITIONS</h2><p>In these Terms and Conditions of Use, the following capitalised terms shall have the following meanings, except where the context otherwise requires: \"Account\" means an account created by a User on the Mobile Application as part of Registration. \"Merchant\" refers to any entity whose products or Samples can be purchased and/or redeemed (as the case may be) via the Mobile Application. \"Privacy Policy\" means the privacy policy set out in Clause 14 of these Terms and Conditions of Use. \"Redeem\" means to redeem a Merchant’s products or Samples on these Terms and Conditions of Use and \"Redemption\" means the act of redeeming such products or Samples. \"Register\" means to create an Account on the Mobile Application and \"Registration\" means the act of creating such an Account. \"Samples\" means samples of Merchant’s products and/or Merchant’s services, including without limitation, any vouchers for the redemption of such services, and \"Sample\" means any one of them. \"Services\" means all the services provided by Tiffulit smart management systems via the Mobile Application to Users, and \"Service\" means any one of them, \"Users\" means users of the Mobile Application, including you and \"User\" means any one of them.</p><h2>3. GENERAL ISSUES ABOUT THE MOBILE APPLICATION AND THE SERVICES</h2><p>3.1 Applicability of terms and conditions: The use of any Services and/or the Mobile Application and the making of any Redemptions are subject to these Terms and Conditions of Use.3.2 Location: The Mobile Application, the Services and any Redemptions are intended solely for use by Users who access the Mobile Application worldwide. 3.3 Scope: The Mobile Application, the Services and any Redemptions are for your non- commercial, personal use only and must not be used for business purposes. 3.4 Prevention on use: We reserve the right to prevent you using the Mobile Application and the Service (or any part of them) and to prevent you from making any Redemptions. 3.5 Equipment and Networks: The provision of the Services and the Mobile Application does not include the provision of a mobile telephone or handheld device or other necessary equipment to access the Mobile Application or the Services or make any Redemptions. To use the Mobile Application or Services or to make Redemptions, you will require Internet connectivity and appropriate telecommunication links. You acknowledge that the terms of agreement with your respective mobile network provider (\"Mobile Provider\") will continue to apply when using the Mobile Application. As a result, you may be charged by the Mobile Provider for access to network connection services for the duration of the connection while accessing the Mobile Application or any such third party charges as may arise. You accept responsibility for any such charges that arise. 3.6 Permission to use Mobile Application: If you are not the bill payer for the mobile telephone or handheld device being used to access the Mobile Application, you will be assumed to have received permission from the bill payer for using the Mobile Application. 3.7 License to Use Material: By submitting any text or images (including photographs) (“Material”) via the Application, you represent that you are the owner of the Material, or have proper authorization from the owner of the Material to use, reproduce and distribute it. You hereby grant us a worldwide, royalty-free, non-exclusive license to use the Material to promote any products or services.</p><h2>4. REDEMPTIONS</h2><p>4.1 Need for registration: You must Register to make a Redemption from the Mobile Application. 4.2 Application of these Terms and Conditions of Use: By making any Redemption, you acknowledge that the Redemption is subject to these Terms and Conditions of Use. 4.3 Redemption: Any attempted Redemption not consistent with these Terms and Conditions of Use may be disallowed or rendered void at our or the relevant Merchant’s discretion. 4.4 Responsibility for Redemptions of perishable products of Samples: Each Merchant shall be responsible to ensure that any of its products or Samples for Redemption that are perishable has not expired. 4.5 Restrictions: (a) Reproduction, sale, resale or trading of any products or Samples or Redeemed products is prohibited. (b) If any product or Sample is Redeemed for less than its face value, there is no entitlement to a credit, cash or Sample equal to the difference between the face value and the amount Redeemed. (c) Redemption of products or Samples is subject toavailability of the relevant Merchants’ stocks. 4.6 SingPost Not Liable: For the avoidance of doubt, shall not be liable for any losses or damages suffered by you resulting from a failure by the relevant Merchant to fulfil any Redemptions in accordance with Clause 4.4 or for a failure by us to deliver any products or Samples to you due to the unavailability of such products or Samples pursuant to Clause 4.5(c). 4.7 Lost/stolen Samples: Neither we nor any Merchant shall be responsible for lost or stolen Samples or products that have been Redeemed.</p><h2>5. LOCATION ALERTS AND NOTIFICATIONS</h2><p>5.1 You agree to receive pre-programmed notifications (“Location Alerts”) on the Mobile Application from Merchants if you have turned on locational services on your mobile telephone or other handheld devices (as the case may be).</p>6. YOUR OBLIGATIONS<p>6.1 Merchant terms: You agree to (and shall) abide by the terms and conditions of the relevant Merchant for which your Redemption relates to, as may be amended from time to time. 6.2 Accurate information: You warrant that all information provided on Registration and contained as part of your Account is true, complete and accurate and that you will promptly inform us of any changes to such information by updating the information in your Account. 6.3 Content on the Mobile Application and Service: It is your responsibility to ensure that any products, Samples or information available through the Mobile Application or the Services meet your specific requirements before making any Redemption. 6.4 Prohibitions in relation to usage of Services or Mobile Application: Without limitation, you undertake not to use or permit anyone else to use the Services or Mobile Application:- 6.4.1 to send or receive any material which is not civil or tasteful 6.4.2 to send or receive any material which is threatening, grossly offensive, of an indecent, obscene or menacing character, blasphemous or defamatory of any person, in contempt of court or in breach of confidence, copyright, rights of personality, publicity or privacy or any other third party rights; 6.4.3 to send or receive any material for which you have not obtained all necessary licences and/ or approvals (from us or third parties); or which constitutes or encourages conduct that would be considered a criminal offence, give rise to civil liability, or otherwise be contrary to the law of or infringe the rights of any third party in any country in the world; 6.4.4 to send or receive any material which is technically harmful (including computer viruses, logic bombs, Trojan horses, worms, harmful components, corrupted data or other malicious software or harmful data); 6.4.5 to cause annoyance, inconvenience or needless anxiety;6.4.6 to intercept or attempt to intercept any communications transmitted by way of a telecommunications system; 6.4.7 for a purpose other than which we have designed them or intended them to be used; 6.4.8 for any fraudulent purpose; 6.4.9 other than in conformance with accepted Internet practices and practices of any connected networks; 6.4.10 in any way which is calculated to incite hatred against any ethnic, religious or any other minority or is otherwise calculated to adversely affect any individual, group or entity; or 6.4.11 in such a way as to, or commit any act that would or does, impose an unreasonable or disproportionately large load on our infrastructure. 6.5 Prohibitions in relation to usage of Services, Mobile Application: Without limitation, you further undertake not to or permit anyone else to:- 6.5.1 resell any products or Samples ; 6.5.2 furnish false data including false names, addresses and contact details and fraudulently use credit/debit card numbers; 6.5.3 attempt to circumvent our security or network including to access data not intended for you, log into a server or account you are not expressly authorised to access, or probe the security of other networks (such as running a port scan); 6.5.4 execute any form of network monitoring which will intercept data not intended for you; 6.5.5 enter into fraudulent interactions or transactions with us or a Merchant (including interacting or transacting purportedly on behalf of a third party where you have no authority to bind that third party or you are pretending to be a third party); 6.5.6 extract data from or hack into the Mobile Application; 6.5.7 use the Services or Mobile Application in breach of these Terms and Conditions of Use; 6.5.8 engage in any unlawful activity in connection with the use of the Mobile Application or the Services; or 6.5.9 engage in any conduct which, in our exclusive reasonable opinion, restricts or inhibits any other customer from properly using or enjoying the Mobile Application or Services.</p><h2>7. RULES ABOUT USE OF THE SERVICE AND THE MOBILE APPLICATION</h2><p>7.1 We will use reasonable endeavours to correct any errors or omissions as soon as practicableafter being notified of them. However, we do not guarantee that the Services or the Mobile Application will be free of faults, and we do not accept liability for any such faults, errors or omissions. In the event of any such error, fault or omission, you should report it by contacting us at +972-48803377. 7.2 We do not warrant that your use of the Services or the Mobile Application will be uninterrupted and we do not warrant that any information (or messages) transmitted via the Services or the Mobile Application will be transmitted accurately, reliably, in a timely manner or at all. Notwithstanding that we will try to allow uninterrupted access to the Services and the Mobile Application, access to the Services and the Mobile Application may be suspended, restricted or terminated at any time. 7.3 We do not give any warranty that the Services and the Mobile Application are free from viruses or anything else which may have a harmful effect on any technology. 7.4 We reserve the right to change, modify, substitute, suspend or remove without notice any information or Services on the Mobile Application from time to time. Your access to the Mobile Application and/or the Services may also be occasionally restricted to allow for repairs, maintenance or the introduction of new facilities or services. We will attempt to restore such access as soon as we reasonably can. For the avoidance of doubt, we reserve the right to withdraw any information or Services from the Mobile Application at any time. 7.5 We reserve the right to block access to and/or to edit or remove any material which in our reasonable opinion may give rise to a breach of these Terms and Conditions of Use.</p><h2>8. SUSPENSION AND TERMINATION</h2><p>8.1 If you use (or anyone other than you, with your permission uses) the Mobile Application, any Services in contravention of these Terms and Conditions of Use, we may suspend your use of the Services and/or Mobile Application. 8.2 If we suspend the Services or Mobile Application, we may refuse to restore the Services or Mobile Application for your use until we receive an assurance from you, in a form we deem acceptable, that there will be no further breach of the provisions of these Terms and Conditions of Use. 8.3 Tiffulit smart management systems Ltd shall fully co-operate with any law enforcement authorities or court order requesting or directing Tiffulit smart management systems Ltd to disclose the identity or locate anyone in breach of these Terms and Conditions of Use. 8.4 Without limitation to anything else in this Clause 8, we shall be entitled immediately or at any time (in whole or in part) to: (a) suspend the Services and/or Mobile Application; (b) suspend your use of the Services and/or Mobile Application; and/or (c) suspend the use of the Services and/or Mobile Application for persons we believe to be connected (in whatever manner) to you, if: 8.4.1 you commit any breach of these Terms and Conditions of Use;8.4.2 we suspect, on reasonable grounds, that you have, might or will commit a breach of these Terms and Conditions of Use; or 8.4.3 we suspect, on reasonable grounds, that you may have committed or be committing any fraud against us or any person. 8.5 Our rights under this Clause 8 shall not prejudice any other right or remedy we may have in respect of any breach or any rights, obligations or liabilities accrued prior to termination.</p><h2>9. DISCLAIMER AND EXCLUSION OF LIABILITY</h2><p>9.1 The Mobile Application, the Services, the information on the Mobile Application and use of all related facilities are provided on an \"as is, as available\" basis without any warranties whether express or implied. 9.2 To the fullest extent permitted by applicable law, we disclaim all representations and warranties relating to the Mobile Application and its contents, including in relation to any inaccuracies or omissions in the Mobile Application, warranties of merchantability, quality, fitness for a particular purpose, accuracy, availability, non-infringement or implied warranties from course of dealing or usage of trade. 9.3 We do not warrant that the Mobile Application will always be accessible, uninterrupted, timely, secure, error free or free from computer virus or other invasive or damaging code or that the Mobile Application will not be affected by any acts of God or other force majeure events, including inability to obtain or shortage of necessary materials, equipment facilities, power or telecommunications, lack of telecommunications equipment or facilities and failure of information technology or telecommunications equipment or facilities. 9.4 While we may use reasonable efforts to include accurate and up-to-date information on the Mobile Application, we make no warranties or representations as to its accuracy, timeliness or completeness. 9.5 We shall not be liable for any acts or omissions of any third parties howsoever caused, and for any direct, indirect, incidental, special, consequential or punitive damages, howsoever caused, resulting from or in connection with the mobile application and the services offered in the mobile application, your access to, use of or inability to use the mobile application or the services offered in the mobile application, reliance on or downloading from the mobile application and/or services, or any delays, inaccuracies in the information or in its transmission including but not limited to damages for loss of business or profits, use, data or other intangible, even if we have been advised of the possibility of such damages. 9.6 We shall not be liable in contract, tort (including negligence or breach of statutory duty) or otherwise howsoever and whatever the cause thereof, for any indirect, consequential, collateral, special or incidental loss or damage suffered or incurred by you in connection with the Mobile Application and these Terms and Conditions of Use. For the purposes of these Terms and Conditions of Use, indirect or consequential loss or damage includes, without limitation, loss of revenue, profits, anticipated savings or business, loss of data or goodwill, loss of use or value of any equipment including software, claims of third parties, and all associated and incidental costsand expenses. 9.7 The above exclusions and limitations apply only to the extent permitted by law. None of your statutory rights as a consumer that cannot be excluded or limited are affected. 9.8 Notwithstanding our efforts to ensure that our system is secure, you acknowledge that all electronic data transfers are potentially susceptible to interception by others. We cannot, and do not, warrant that data transfers pursuant to the Mobile Application, or electronic mail transmitted to and from us, will not be monitored or read by others.</p><h2>10. INDEMNITY</h2><p>You agree to indemnify and keep us indemnified against any claim, action, suit or proceeding brought or threatened to be brought against us which is caused by or arising out of (a) your use of the Services, (b) any other party’s use of the Services using your user ID, verification PIN and/ or any identifier number allocated by Tiffulit smart management systems Ltd, and/or (c) your breach of any of these Terms and Conditions of Use, and to pay us damages, costs and interest in connection with such claim, action, suit or proceeding.</p><h2>11. INTELLECTUAL PROPERTY RIGHTS</h2><p>11.1 All editorial content, information, photographs, illustrations, artwork and other graphic materials, and names, logos and trade marks on the Mobile Application are protected by copyright laws and/or other laws and/or international treaties, and belong to us and/or our suppliers, as the case may be. These works, logos, graphics, sounds or images may not be copied, reproduced, retransmitted, distributed, disseminated, sold, published, broadcasted or circulated whether in whole or in part, unless expressly permitted by us and/or our suppliers, as the case may be. 11.2 Nothing contained on the Mobile Application should be construed as granting by implication, estoppel, or otherwise, any license or right to use any trademark displayed on the Mobile Application without our written permission. Misuse of any trademarks or any other content displayed on the Mobile Application is prohibited. 11.3 We will not hesitate to take legal action against any unauthorised usage of our trade marks, name or symbols to preserve and protect its rights in the matter. All rights not expressly granted herein are reserved. Other product and company names mentioned herein may also be the trade marks of their respective owners.</p><h2>12. AMENDMENTS</h2><p>12.1 We may periodically make changes to the contents of the Mobile Application, including to the descriptions and prices of goods and services advertised, at any time and without notice. We assume no liability or responsibility for any errors or omissions in the content of the Mobile Application. 12.2 We reserve the right to amend these Terms and Conditions of Use from time to time without notice. The revised Terms and Conditions of Use will be posted on the Mobile Application and shall take effect from the date of such posting. You are advised to review these terms and conditions periodically as they are binding upon you.</p><h2>13. APPLICABLE LAW AND JURISDICTION</h2><p>13.1 The Mobile Application can be accessed from all countries around the world where the local technology permits. As each of these places have differing laws, by accessing the Mobile Application both you and we agree that the laws of the Republic of Singapore, without regard to the conflicts of laws principles thereof, will apply to all matters relating to the use of the Mobile Application. 13.2 You accept and agree that both you and we shall submit to the exclusive jurisdiction of the courts of the state of Israel in respect of any dispute arising out of and/or in connection with these Terms and Conditions of Use.</p><h2>14. PRIVACY POLICY</h2><p>14.1 Access to the Mobile Application and use of the Services offered on the Mobile Application Tiffulit smart management systems Ltd and/or its group of companies is subject to this Privacy Policy. By accessing the Mobile Application and by continuing to use the Services offered, you are deemed to have accepted this Privacy Policy, and in particular, you are deemed to have consented to our use and disclosure of your personal information in the manner prescribed in this Privacy Policy and for the purposes set out in Clauses 3.7 and/or 4.1. We reserve the right to amend this Privacy Policy from time to time. If you disagree with any part of this Privacy Policy, you must immediately discontinue your access to the Mobile Application and your use of the Services. 14.2 As part of the normal operation of our Services, we collect, use and, in some cases, disclose information about you to third parties. Accordingly, we have developed this Privacy Policy in order for you to understand how we collect, use, communicate and disclose and make use of your personal information when you use the Services on the Mobile Application:- (a) Before or at the time of collecting personal information, we will identify the purposes for which information is being collected. (b) We will collect and use of personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned or as required by law. (c) We will only retain personal information as long as necessary for the fulfillment of those purposes. (d) We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned. (e) Personal information should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date. (f) We will protect personal information by reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.</p>");
$templateCache.put("app/modules/tutorials_center/tutorials_center.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"tutorials_center\"><div class=\"cloud\"><div class=\"settings-block\"><div class=\"tutorials-container\"><div ng-if=\"ctrl.loading\" class=\"loading-container\"><div class=\"spinner\"></div></div><div ng-if=\"ctrl.error\" class=\"error-container\"><i class=\"las la-exclamation-triangle\"></i><p>{{ctrl.error}}</p><button class=\"btn text large border-red\" ng-click=\"ctrl.loadVideos()\">{{\"TUTORIALS_CENTER_RETRY\" | translate}}</button></div><div ng-if=\"!ctrl.loading && !ctrl.error\" class=\"videos-grid\"><div ng-repeat=\"video in ctrl.videos\" class=\"video-card\" ng-click=\"ctrl.openVideo(video)\"><div class=\"video-thumbnail\"><img ng-src=\"{{video.thumbnail}}\" alt=\"{{video.title}}\" class=\"thumbnail-image\"><div class=\"play-overlay\"><i class=\"las la-play\"></i></div></div><div class=\"video-info\"><h3 class=\"video-title\">{{video.title}}</h3></div></div></div><div ng-if=\"!ctrl.loading && !ctrl.error && ctrl.videos.length === 0\" class=\"empty-state\"><i class=\"las la-video\"></i><h3>{{\"TUTORIALS_CENTER_NO_VIDEOS\" | translate}}</h3><p>{{\"TUTORIALS_CENTER_NO_VIDEOS_TEXT\" | translate}}</p></div></div></div></div></div>");
$templateCache.put("app/modules/tutorials_center/video.modal.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\"><i class=\"las la-play-circle\"></i> {{vm.video.title}}</h3><a class=\"close\" ng-click=\"vm.close();\">&times;</a></div><div class=\"modal-body\"><div class=\"video-embed-wrapper\"><iframe width=\"100%\" height=\"400\" ng-src=\"{{vm.getEmbedUrl()}}\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div><p class=\"video-description\" ng-if=\"vm.video.description\">{{vm.video.description}}</p></div><div class=\"modal-footer\"><button class=\"btn text large\" ng-click=\"vm.close()\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <a class=\"btn text large primary\" ng-click=\"vm.stopVideo();\" target=\"_blank\" ng-href=\"https://www.youtube.com/watch?v={{vm.video.videoId}}\">{{\"OPEN_ON_YOUTUBE\" | translate}}</a></div></div>");
$templateCache.put("app/components/cfilter/store-filter/store-filter.html","<div class=\"modal-form-inner\" id=\"store-filter\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"STORE_FILTER_MODAL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"STORE_FILTER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\"></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.default\" \"=\"\">{{\"STORE_FILTER_DEFAULT\" | translate}}</label></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/modules/customers/popup/customers.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_SELECT_C\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'CUSTOMER_ENTER_NAME\' | translate}}\" ng-change=\"find_customer()\" ng-model=\"ctrl.customer_name\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.customers && ctrl.customers.length>0\"><table class=\"sorted-table\"><thead><tr><th>{{\"CUSTOMERS_NAME\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in ctrl.customers\" ng-click=\"ctrl.selectCustomer(row)\"><td class=\"customer-name with-pic\"><div class=\"customer-pic-wrapper\"><img ng-src=\"{{row.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic mobile\"></div>{{row.firstname}} {{row.lastname}} <span class=\"customer-search-notes\" ng-if=\"row.notes\" title=\"{{row.notes}}\">{{row.notes}}</span></td></tr></tbody></table></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/customers_bookings/list/list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'customers\')\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.calendar\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"NAV_CUSTOMERS_BOOKINGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div><button class=\"btn text large\" ng-class=\"{\'primary\': activeTab === \'pending\'}\" ng-click=\"ctrl.changeTab(\'pending\')\">{{\"NAV_CUSTOMERS_PENDING\" | translate}}</button> <button class=\"btn text large\" ng-class=\"{\'primary\': activeTab === \'waiting\'}\" ng-click=\"ctrl.changeTab(\'waiting\')\">{{\"NAV_CUSTOMERS_WAITING\" | translate}}</button></div><div class=\"table-holder customer-table-holder\" ng-if=\"activeTab === \'pending\'\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div><div class=\"table-holder customer-table-holder\" ng-if=\"activeTab === \'waiting\'\"><div class=\"table-responsive\"><table id=\"cust_dt_waitings\" datatable=\"\" dt-options=\"dtOptionsWaitings\" dt-columns=\"ctrl.dtColumnsWaitingList\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div>");
$templateCache.put("app/modules/cashbox/methods/card.popup.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"MAKE_CARD\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"form flex\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-qty\">{{\"MAKE_CARD_QTY\" | translate}}</label> <input type=\"number\" id=\"card-qty\" required=\"\" ng-model=\"ctrl.cardQtyModel\" class=\"form-control\" ng-change=\"ctrl.changeCardQty()\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-price\">{{\"MAKE_CARD_PRICE\" | translate}}</label> <input type=\"number\" id=\"card-price\" required=\"\" ng-model=\"ctrl.cardPrice\" class=\"form-control\" ng-change=\"ctrl.changeCardPrice()\"></div></div></div><div class=\"form flex\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-price\">{{\"MAKE_CARD_PRICE_PER_ITEM\" | translate}}</label> <input type=\"number\" id=\"card-price\" required=\"\" ng-model=\"ctrl.cardPerItemModel\" class=\"form-control\" ng-change=\"ctrl.changeCardPerItem()\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-expired\">{{\"MAKE_CARD_EXPIRED_DATE\" | translate}}</label> <input type=\"date\" id=\"card-expired\" class=\"form-control\" ng-model=\"ctrl.expired_at\"></div></div></div></div><div class=\"modal-footer end\"><button ng-click=\"ctrl.makeCardAccept();\" type=\"button\" class=\"btn large text primary\">{{\"MAKE_CARD_CONFIRM\" | translate}}</button></div></div>");
$templateCache.put("app/modules/cashbox/methods/credit.view.html","<div class=\"modal-form-inner payment-method\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_PAY_BY_CREDIT\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.resetPayment(); $close()\">&times;</a></div><form class=\"modal-form_f\" name=\"paymentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><iframe class=\"iframe-tranzila\" ng-src=\"{{iframe}}\" width=\"100%\" height=\"400px\" frameborder=\"0\"></iframe></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"flex between full\"><div class=\"flex gap-24\"><button type=\"button\" ng-click=\"ctrl.resetPayment(); $close();\" class=\"btn text large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-show=\"showContinue\" ng-disabled=\"paymentForm.$invalid\" ng-click=\"ctrl.completePayment();\" class=\"btn text large primary\">{{\"CALENDAR_CASH_CONTINUE\" | translate}}</button></div><span class=\"cash-left\"><p>{{\"CALENDAR_CASH_LEFT_PAY\" | translate}}</p><b>{{ctrl.cashboxTotal - (ctrl.totalPaid ? ctrl.totalPaid : 0) | price}}</b></span></div></div></form></div>");
$templateCache.put("app/modules/cashbox/methods/credit_zcard.view.html","<div class=\"modal-form-inner payment-method\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_PAY_BY_CREDIT\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.resetPayment(); ctrl.resetZCredit(); $close()\">&times;</a></div><form class=\"\" name=\"paymentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><div class=\"waiting-pay\"><img src=\"assets/images/emv_icon.png\" class=\"swal2-image\" style=\"display: flex;\"> {{\"CASHBOX_WAITING_FOR_PAY\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"flex between full\"><div class=\"flex gap-24\"><button type=\"button\" ng-click=\"ctrl.resetPayment(); ctrl.resetZCredit(); $close();\" class=\"btn text large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-show=\"showContinue\" ng-disabled=\"paymentForm.$invalid\" ng-click=\"ctrl.completePayment();\" class=\"btn text large primary\">{{\"CALENDAR_CASH_CONTINUE\" | translate}}</button></div><span class=\"cash-left\"><p>{{\"CALENDAR_CASH_LEFT_PAY\" | translate}}</p><b>{{ctrl.cashboxTotal - (ctrl.totalPaid ? ctrl.totalPaid : 0) | price}}</b></span></div></div></form></div>");
$templateCache.put("app/modules/cashbox/methods/emv.popup.html","<div id=\"bank-select-mob\" aria-labelledby=\"swal2-title\" aria-describedby=\"swal2-content\" class=\"swal2-popup swal2-modal swal2-show\" tabindex=\"-1\" role=\"dialog\" aria-live=\"assertive\" aria-modal=\"true\" style=\"display: flex; width: 100%;\"><div class=\"swal2-header\"><img src=\"assets/images/emv_icon.png\" class=\"swal2-image\" style=\"display: flex;\"><h2 class=\"swal2-title\" id=\"swal2-title\" style=\"display: flex;\">{{statusShow}}</h2><button type=\"button\" class=\"swal2-close\" ng-click=\"$close();\">×</button></div><div class=\"swal2-content\"></div></div>");
$templateCache.put("app/modules/cashbox/methods/payment.view.html","<div class=\"modal-form-inner payment-method\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"method == \'cash\'\">{{\"CALENDAR_CASH_PAY_CASH\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'oncredit\'\">{{\"CALENDAR_CASH_PAY_CREDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'cheque\'\">{{\"CASHBOX_PAY_CHEQUE\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'bank_transfer\'\">{{\"CASHBOX_PAY_BANK_TRANSFER\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'credit_card_external\'\">{{\"CASHBOX_PAY_CREDIT_CARD_EXT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'pay_link\'\">{{\"CALENDAR_PAY_LINK\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.resetPayment(); $close();\">&times;</a></div><form class=\"modal-form_f\" name=\"paymentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"form-group\"><label ng-if=\"method == \'cash\'\">{{\"CALENDAR_CASH_HOW_MUCH\" | translate}}<br><small><b>{{\"CALENDAR_CASH_NOTE\" | translate}}</b> {{\"CALENDAR_CASH_ABOUT\" | translate}}</small></label> <label ng-if=\"method == \'oncredit\'\">{{\"CALENDAR_CASH_HOW_MUCH2\" | translate}}</label> <label ng-if=\"method == \'cheque\'\">{{\"CASHBOX_HOW_MUCH_CHEQUE\" | translate}}</label> <label ng-if=\"method == \'bank_transfer\'\">{{\"CASHBOX_HOW_MUCH_BANK_TRANSFER\" | translate}}</label> <label ng-if=\"method == \'credit_card_external\'\">{{\"CASHBOX_HOW_MUCH_EXT_CREDIT_CARD\" | translate}}</label> <label ng-if=\"method == \'pay_link\'\">{{\"CALENDAR_PAY_LINK\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.methods[method].amount\" ng-disabled=\"method == ctrl.lastMethod\" min=\"0\" required=\"\" max=\"{{ctrl.cashboxTotal - ctrl.totalPaid}}\" class=\"form-control\"></div><div class=\"flex form\" ng-if=\"method == \'cheque\'\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-cheque-number\">{{\"CASHBOX_CHEQUE_NUM_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-cheque-number\" required=\"\" pattern=\"[0-9 ]{1,20}\" ng-model=\"ctrl.methods[method].payment_details.cheque_number\" class=\"form-control\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-due-date\">{{\"CASHBOX_DUE_DATE_LABEL\" | translate}}</label> <input type=\"date-time\" id=\"input-due-date\" class=\"form-control\" auto-close=\"true\" date-time=\"\" ng-model=\"ctrl.methods[method].payment_details.cheque_due_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div><div class=\"flex form\" ng-if=\"method == \'cheque\' || method == \'bank_transfer\'\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-bank-number-mobile\">{{\"CASHBOX_BANK_NUM_LABEL\" | translate}}</label> <input type=\"text\" readonly=\"true\" id=\"input-bank-number-mobile\" required=\"\" ng-if=\"isMobile\" ng-model=\"ctrl.methods[method].payment_details.bank_name\" class=\"form-control\" ng-click=\"ctrl.showBankList()\"><select chosen=\"\" ng-model=\"ctrl.methods[method].payment_details.bank_number\" ng-if=\"!isMobile\" id=\"input-bank-number\"><option value=\"\">{{\'CASHBOX_BANK_NUM_LABEL\' | translate}}</option><option class=\"select-bank-option\" value=\"{{bank.bank_number}}\" ng-repeat=\"bank in ctrl.BanksList\" style=\"background-image:url(\'{{bank.img_url}}\');\"><img ng-if=\"bank.img_url\" ng-src=\"{{bank.img_url}}\" width=\"20\" height=\"20\"> {{bank.name}}</option></select></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-branch\">{{\"CASHBOX_BRANCH_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-branch\" pattern=\"[0-9 ]{1,20}\" ng-required=\"method == \'cheque\'\" ng-model=\"ctrl.methods[method].payment_details.branch_number\" class=\"form-control\"></div></div></div><div class=\"flex form\" ng-if=\"method == \'cheque\' || method == \'bank_transfer\'\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-account-number\">{{\"CASHBOX_ACCOUNT_NUM_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-account-number\" pattern=\"[0-9 ]{1,20}\" ng-model=\"ctrl.methods[method].payment_details.bank_account_number\" class=\"form-control\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"></div></div></div><div class=\"flex form\" ng-if=\"method == \'credit_card_external\'\"><div class=\"form-group\"><label for=\"input-credit-card-ext\">{{\"CASHBOX_CREDIT_CARD_EXT_4_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-credit-card-ext\" ng-maxlength=\"4\" required=\"\" pattern=\"[0-9]{4,4}\" ng-model=\"ctrl.methods[method].payment_details.credit_card_ext_number\" class=\"form-control\"></div></div><p ng-if=\"method == \'credit_card_external\'\" class=\"text-center color-red\">{{\"CASHBOX_PAY_CREDIT_CARD_EXT_NOTE\" | translate}}</p></div></div><div class=\"modal-footer\"><div class=\"flex between full\"><div class=\"flex gap-24\"><button type=\"button\" ng-click=\"ctrl.resetPayment(); $close();\" class=\"btn text large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"paymentForm.$invalid || ctrl.paymentDetailsInvalid() || ctrl.cashboxLoading\" ng-click=\"ctrl.completePayment();\" class=\"btn text large primary\">{{\"CALENDAR_CASH_CONTINUE\" | translate}}</button></div><span class=\"cash-left\"><p>{{\"CALENDAR_CASH_LEFT_PAY\" | translate}}</p><b>{{ctrl.cashboxTotal - (ctrl.totalPaid ? ctrl.totalPaid : 0) | price}}</b></span></div></div></form></div>");
$templateCache.put("app/modules/cashbox/popup/bank.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"bank-select-mob\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CASHBOX_BANK_NUM_SELECT_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'ITEM_ENTER_NAME\' | translate}}\" ng-change=\"find_item()\" ng-model=\"ctrl.item_name\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.banks\"><table datatable=\"\" dt-options=\"dtOptions\" id=\"res_dt\" class=\"table table-striped table-bordered table-hover dataTables-example banks-select-table\"><thead><tr><th>{{\"BANK_NAME_HEADER\" | translate}}</th><th>{{\"BANK_NUMBER_HEADER\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectBank($index)\" ng-repeat=\"row in ctrl.banks\"><td><img ng-if=\"row.img_url\" ng-src=\"{{row.img_url}}\" width=\"20\" height=\"20\"> {{row.name}}</td><td><span ng-hide=\"row.bank_number.indexOf(\'service\') === 0\">{{row.bank_number}}</span></td></tr></tbody></table></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/cashbox/popup/use-card.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CASHBOX_USE_CARD_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"editForm\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><div class=\"form-group\"><label>{{\"CASHBOX_CARD_USE_AMOUNT\" | translate}}</label><div class=\"item-inputs\"><input-number-spinner data-ng-model=\"ctrl.form.card_balance_used\" data-input-number-spinner-min=\"0\" data-input-number-spinner-max=\"ctrl.card.balance > ctrl.item.quantity ? ctrl.item.quantity : ctrl.card.balance\" data-input-number-spinner-required=\"true\"></input-number-spinner></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><br><label>{{\"CARD_CURRENT_BALANCE\" | translate}}: {{ ctrl.card.balance }}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid\" ng-click=\"ctrl.saveForm()\" class=\"btn text primary large\">{{\"CARD_CHANGE_BALANCE_SAVE_BTN\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/marketing/recommendations/recommendations.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.marketing\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"MARKETING_RECOMMENDATIONS\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyOrdersSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th>{{\"RECOMMENDATIONS_NAME\" | translate}}</th><th>{{\"RECOMMENDATIONS_CUSTOMER\" | translate}}</th><th>{{\"RECOMMENDATIONS_TEXT\" | translate}}</th><th>{{\"RECOMMENDATIONS_CREATED_AT\" | translate}}</th><th></th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.name}}</td><td>{{row.customer}}</td><td>{{row.text}}</td><td>{{row.created_at}}</td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.send(row.id)\">{{\"RECOMMENDATIONS_SEND\" | translate}}</button></td><td width=\"1%\"><button ng-click=\"ctrl.delete(row.id)\" class=\"btn icon red\"><i class=\"las la-trash-alt\"></i></button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/calendar/order/order.form.html","<div id=\"order\" class=\"modal-form-inner\"><div class=\"modal-head\"><a class=\"btn icon default\" ng-click=\"$close();\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\" ng-if=\"!ctrl.is_edit && !ctrl.event\">{{\"CALENDAR_NEW_ORDER\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"ctrl.is_edit && !ctrl.event\">{{(ctrl.order ? ctrl.order.number : \'\')}} # {{\"CALENDAR_ORDER_NUM\" | translate}} {{ctrl.course ? ctrl.course.id : \'\'}}<a ng-if=\"ctrl.course && ctrl.course.id\" href=\"javascript:;\" ng-click=\"ctrl.copyId(ctrl.course.id)\" class=\"btn icon\"><i class=\"las la-copy\"></i></a></h3><h3 class=\"form-title\" ng-if=\"ctrl.is_edit && ctrl.event\">{{ctrl.order.number}} # {{\"CALENDAR_EVENT_FORM_LABEL\" | translate}}</h3><div class=\"form-sub-title\" ng-if=\"ctrl.order && ctrl.bu_type == 2 && ctrl.is_edit && ctrl.approved_date != null\">{{\"CALENDAR_APPROVED_ORDER\" | translate}} <span class=\"form-approved-date\">{{ctrl.approved_date}}</span></div><div class=\"form-sub-title\" ng-if=\"ctrl.order && ctrl.order.prepaid && !ctrl.business.stop_messages\">{{\"ORDER_MODAL_PREPAID_TITLE\" | translate}} {{ctrl.order.prepaid}}</div></div></div><form name=\"orderForm\" ng-submit=\"ctrl.send_order_form()\"><div ng-if=\"!ctrl.confirm_delete\"><div class=\"modal-body\" id=\"order-modal-body\" ng-class=\"{\'two-btns-only\': !ctrl.is_edit}\"><div class=\"panel-body\"><div ng-if=\"ctrl.bu_type == 1 && !ctrl.form.isCourse\" ng-include=\"\'app/modules/calendar/order/order.stores.form.html\'\"></div><div ng-if=\"ctrl.bu_type == 2\" ng-include=\"\'app/modules/calendar/order/order.motels.form.html\'\"></div><div ng-if=\"ctrl.bu_type == 1 && ctrl.form.isCourse\" ng-include=\"\'app/modules/calendar/order/order.stores_course.form.html\'\"></div><div class=\"order-summary\" ng-if=\"!ctrl.hide_prices && !ctrl.form.isEvent && !ctrl.form.isCourse\"><div class=\"inner\"><div class=\"price-line\" ng-if=\"ctrl.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_BEFORE\" | translate}}</span> <span class=\"price\">{{ctrl.form.subtotal | price}}</span></div><div class=\"price-line\" ng-if=\"ctrl.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_VAT\" | translate}} (%{{ctrl.dealer_vat}})</span> <span class=\"price\">{{ctrl.form.tax | price}}</span></div><div class=\"price-line\"><span class=\"title\">{{\"CALENDAR_ORDER_TOTAL\" | translate}}</span> <span class=\"price\">{{ctrl.form.total | price}}</span></div></div></div></div></div><div class=\"modal-footer order-modal-buttons\"><div class=\"flex gap-8 nowrap\"><span ng-repeat=\"document in ctrl.order.documents\" ng-if=\"ctrl.order && ctrl.order.status == 3 && ctrl.order.documents\"><a ng-href=\"{{document[\'document_invoice_receipt\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_invoice_receipt\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV_TAX\" | translate}}</a> <a ng-href=\"{{document[\'document_invoice\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_invoice\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV\" | translate}}</a> <a ng-href=\"{{document[\'document_receipt\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_receipt\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_ACC\" | translate}}</a> <a ng-href=\"{{document[\'document_proforma_invoice\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_proforma_invoice\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV_TR\" | translate}}</a> <a ng-href=\"{{document[\'document_credit\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_credit\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV_CR\" | translate}}</a> <a ng-href=\"{{document[\'document_cards-document\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_cards-document\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_CARD_TR\" | translate}}</a></span></div><div ng-if=\"([1, 6].indexOf(ctrl.order.status) === -1)\" class=\"flex gap-8 nowrap\"><button type=\"button\" ng-click=\"ctrl.decline_order();$close();\" ng-if=\"ctrl.order.status == 4\" class=\"btn text large border-red\">{{\"CALENDAR_ORDER_DECLINE_BOOKING\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.delete_event();\" ng-if=\"ctrl.is_edit && ctrl.event\" class=\"btn text large border-red\">{{\"CALENDAR_EVENT_DELETE_BTN\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send_order_prepaid();\" ng-if=\"ctrl.is_prepaid && ctrl.order && ctrl.form.phone && ([3, 4, 7].indexOf(ctrl.order.status) === -1) && ! ctrl.order.prepaid\" class=\"btn text large border-pink\">{{\"CALENDAR_ORDER_PREPAID\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send_order_sms();\" ng-if=\"ctrl.order && ctrl.form.phone && ctrl.order.status == 0\" class=\"btn text large border-blue\">{{\"CALENDAR_ORDER_SMS\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send_approval_request();\" ng-if=\"ctrl.bu_type == 2 && ctrl.is_edit\" class=\"btn text large border-primary\">{{\"CALENDAR_ORDER_APPROVE\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.goToCashbox();\" ng-if=\"ctrl.order && cashbox_available && ctrl.is_edit && ([3, 4, 7].indexOf(ctrl.order.status) === -1) && !ctrl.is_full_prepaid\" class=\"btn text large border-orange\">{{\"CALENDAR_ORDER_CHECKOUT\" | translate}}</button> <a ng-click=\"ctrl.completeOrder(ctrl.order.id, (ctrl.order.status == 7 || ctrl.is_full_prepaid))\" ng-if=\"ctrl.is_edit && ([3, 4].indexOf(ctrl.order.status) === -1) && !ctrl.event && !ctrl.course\" class=\"btn text large border-green\">{{ctrl.order.status == 7 || ctrl.is_full_prepaid ? \"CALENDAR_ORDER_CLOSE_PAID\" : \"CALENDAR_ORDER_COMPLETED\" | translate}}</a></div><div ng-if=\"ctrl.is_edit && ctrl.form.isCourse && ctrl.form.meetings.length <= 1\" class=\"flex gap-8 nowrap\"><button type=\"button\" ng-click=\"ctrl.deleteCourse()\" class=\"btn text large border-red\">{{\"CALENDAR_COURSE_DELETE\" | translate}}</button></div><div class=\"flex gap-8 nowrap\"><button type=\"button\" ng-click=\"ctrl.confirm_delete = true\" ng-if=\"showCancelBtn\" class=\"btn text large border-red\">{{\"CALENDAR_ORDER_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.goBack();$close();\" class=\"btn text large border-primary\">{{\"CALENDAR_ORDER_RETURN\" | translate}}</button> <button type=\"submit\" ng-click=\"\" ng-if=\"!(ctrl.order && [1, 6, 3, 4].indexOf(ctrl.order.status) !== -1) || ctrl.allow_edit\" class=\"btn text large primary\" ng-disabled=\"orderForm.$invalid\">{{\"CALENDAR_ORDER_SAVE\" | translate}}</button> <button type=\"submit\" ng-click=\"\" ng-if=\"ctrl.order && ctrl.order.status == 4\" class=\"btn text large border-primary\" ng-disabled=\"orderForm.$invalid\">{{\"CALENDAR_ORDER_APPROVE_BOOKING\" | translate}}</button></div></div></div><div class=\"message-wrapper order-cancel-wrapper\" ng-if=\"ctrl.confirm_delete\"><div class=\"modal-body\"><div class=\"panel-body\"><p>{{\"CALENDAR_ORDER_CANCEL_SENTENCE_START\" | translate}} <b>{{ctrl.order.id}}</b>?<br><b>{{\"CALENDAR_ORDER_CANCEL_SENTENCE_CENTER\" | translate}}</b>{{\"CALENDAR_ORDER_CANCEL_SENTENCE_END\" | translate}}. <i class=\"fa fa-info\"></i></p><div class=\"row cancel-reason\"><div class=\"col-md-5\"><div class=\"form-group form-select last\"><label>{{\"CALENDAR_ORDER_CANCEL_REASON\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"ctrl.form.cancelReason\"><option value=\"\">{{\"CALENDAR_ORDER_CANCEL_REASON_SELECT\" | translate}}</option><option value=\"לקוח ביטל\">{{\"CALENDAR_ORDER_CANCEL_REASON_1\" | translate}}</option><option value=\"אי הופעת לקוח\">{{\"CALENDAR_ORDER_CANCEL_REASON_2\" | translate}}</option><option value=\'ביטול ע\"י העסק\'>{{\"CALENDAR_ORDER_CANCEL_REASON_3\" | translate}}</option></select></div><div ng-if=\"ctrl.form.repeat_id\" class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.all_repeatable\">{{\'CALENDAR_ORDER_CANCEL_ALL_REPEATABLE\' | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.discardSms\">{{\'CALENDAR_ORDER_CANCEL_SMS\' | translate}}</label></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"ctrl.confirm_delete = false\" class=\"btn text large primary\">{{\"CALENDAR_ORDER_CANCEL_PREV\" | translate}}</button> <button type=\"button\" ng-disabled=\"orderForm.$invalid\" ng-click=\"ctrl.cancel_order();\" class=\"btn text large border-red\">{{\"CALENDAR_ORDER_CANCEL_OK\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/calendar/order/order.motels.form.html","<div class=\"row\" ng-click=\"containerClicked()\"><div class=\"col-md-12 order-wrapper\" ng-class=\"{\'disabled\': ([1, 6, 3].indexOf(ctrl.order.status) !== -1)}\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-8 no-padding\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select\"><div class=\"customer-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectCustomer()\"></div><div class=\"customer-pic-wrapper\" ng-if=\"ctrl.form.customer.id\" ui-sref=\"app.customers.single({id: {{ctrl.form.customer.id}}})\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-required=\"!ctrl.form.randomCustomer\" class=\"form-control customer-input\"><ul id=\"searchResult\"><li ng-click=\"chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul><button type=\"button\" ng-click=\"ctrl.addNewCustomer();\" class=\"btn btn-primary add-new-customer\" ng-if=\"!ctrl.form.randomCustomer && !ctrl.is_edit\"><i class=\"las la-user-plus\"></i></button></div></div></div><div class=\"col-md-4 col-xs-4 no-padding\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.randomCustomer\" ng-change=\"ctrl.random_customer_changed();\" value=\"1\">{{\'CALENDAR_ORDER_OCC\' | translate}}</label></div></div><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.order_date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-xs-6 no-padding\" ng-if=\"ctrl.isMobile && ctrl.form.phone && ctrl.business.id == 1\"><div class=\"form-group\"><a href=\"{{ \'tel:\' + ctrl.form.phone }}\" class=\"btn btn-w-m btn-success\">{{\"CALENDAR_ORDER_CALL_BTN\" | translate}} <span class=\"glyphicon glyphicon-earphone\"></span></a></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label>{{\"CUSTOMER_FULL_NAME\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.customer_name\" ng-required=\"ctrl.form.randomCustomer\"></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-4 no-padding\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PHONE\" | translate}}</label> <input type=\"tel\" class=\"form-control\" ng-model=\"ctrl.form.phone\" ng-required=\"ctrl.form.randomCustomer\"> <span ng-if=\"ctrl.form.randomCustomer\"><input type=\"checkbox\" ng-model=\"ctrl.allow_sending\"> {{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</span></div></div><div class=\"col-md-4 col-xs-4 no-padding\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_EMAIL\" | translate}}</label> <input type=\"email\" class=\"form-control\" placeholder=\"example@gmail.com\" ng-model=\"ctrl.form.email\"></div></div><div class=\"col-md-4 col-xs-4 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_CLUB\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.club\"><option value=\"\">בחר</option><option ng-repeat=\"club in ctrl.clubs\" value=\"{{club.id}}\">{{club.name}}</option></select></div></div></div><div class=\"order-item\" ng-repeat=\"($orderItemIndex, orderItem) in ctrl.form.items\"><h3 ng-if=\"orderItem.item_type == \'service\'\" class=\"item-type-h3\">{{\"SERVICE\" | translate}}</h3><h3 ng-if=\"orderItem.item_type == \'sale\'\" class=\"item-type-h3\">{{\"SALE\" | translate}}</h3><input type=\"number\" style=\"display: none;\" ng-model=\"orderItem.nights\" ng-required=\"orderItem.item==\'service\'\" min=\"1\"> <a ng-click=\"ctrl.remove_item_from_order($orderItemIndex)\" ng-hide=\"ctrl.form.items.length == 1\" class=\"remove-item\"><i class=\"fa fa-remove\"></i></a><div class=\"flex form\"><div class=\"col-md-4 col-xs-8 no-padding item-wrapper\"><div class=\"items-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectItem($orderItemIndex, orderItem)\"></div><label>{{\"CALENDAR_ORDER_SERVICE\" | translate}} <i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': ctrl.hasCustomerCardForItem(orderItem.item_id) === \'expired\'}\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-if=\"ctrl.hasCustomerCardForItem(orderItem.item_id) && ctrl.isMobile\"></i></label><select chosen=\"\" name=\"item_resource\" ng-model=\"orderItem.item_id\" ng-if=\"ctrl.items\" ng-change=\"ctrl.order_item_resource_change($orderItemIndex)\" required=\"\" ng-class=\"orderItem.item_id ? \'invalid-element\' : \'\'\" data-placeholder=\"בחר פריט לשיוך\"><option value=\"\"></option><option ng-if=\"orderItem.item_type == item.item_type\" class=\"\" value=\"{{item.id}}\" ng-repeat=\"item in ctrl.items\" ng-bind-html=\"ctrl.addCardBadge(item) + (item.name) + \' (\' + (item.price | price) + \')\'\"></option></select></div><div class=\"col-md-4 col-xs-4 no-padding resource-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><label>{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" name=\"item_resource_1\" data-placeholder=\"בחר משאב\" required=\"\" class=\"col-xs-12 no-padding\" ng-model=\"orderItem.resource\"><option value=\"\"></option><option value=\"{{resource.id}}\" ng-repeat=\"resource in ctrl.resources\">{{resource.name}}</option></select></div><div class=\"col-md-4 col-xs-12 no-padding guest-name-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_NAME_GUEST\" | translate}}</label> <input type=\"text\" ng-model=\"orderItem.name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12 no-padding start-time-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ENTRY_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control hide-input\" ng-click=\"ctrl.setNightsType(0)\" ng-change=\"ctrl.motels_update_item_nights($orderItemIndex)\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"orderItem.start_time\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-xs-12 no-padding duration-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_RELEASE_DATE\" | translate}}</label> <input type=\"datetime\" id=\"order_check_out\" ng-change=\"ctrl.motels_update_item_nights($orderItemIndex)\" auto-close=\"true\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"orderItem.end_time\" view=\"date\" min-view=\"date\" ng-click=\"ctrl.setNightsType(0)\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-xs-6 no-padding price-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-12 col-xs-12 no-padding number-wrapper\"><div class=\"form-group\" ng-class=\"orderItem.nights === 0 ? \'notvalid\' : \'\'\"><label>{{\"CALENDAR_NIGHTS_NUMBER\" | translate}}</label><input-number-spinner ng-mouseenter=\"ctrl.setNightsType(1)\" data-ng-model=\"orderItem.nights\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div></div><div class=\"col-md-4 col-xs-6 no-padding price-wrapper\"><label>{{\"CALENDAR_ORDER_PRICE\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"orderItem.item.price\" ng-required=\"orderItem.item_type == \'sale\'\"></div><div class=\"col-md-4 col-xs-6 no-padding number-wrapper\" ng-if=\"orderItem.item_type == \'sale\'\"><label>{{\"CALENDAR_ORDER_QUANTITY\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.item.quantity\" ng-required=\"orderItem.item_type == \'sale\'\" data-input-number-spinner-min=\"0\"></input-number-spinner></div><div class=\"col-md-12 col-xs-12 no-padding notes-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_REMARKS\" | translate}}</label> <textarea class=\"form-control\" ng-model=\"orderItem.notes\" placeholder=\"כאן תוכל להכניס מידע הרלוונטי לפריט זה\"></textarea></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-4 col-xs-4 no-padding number-wrapper adults-wrapper\"><div class=\"form-group\" ng-class=\"orderItem.adults === 0 ? \'notvalid\' : \'\'\"><label>{{\"CALENDAR_ORDER_ADULTS\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.adults\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div><div class=\"col-md-4 col-xs-4 no-padding number-wrapper kids-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_CHILDREN\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.kids\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div><div class=\"col-md-4 col-xs-4 no-padding number-wrapper babies-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_BABIES\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.babies\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-12 no-padding\"><div class=\"item-summary\" ng-if=\"orderItem.item && orderItem.nights > 0\"><b>סה\"כ: {{orderItem.item.price * orderItem.nights | price}}</b></div></div></div></div><button type=\"button\" ng-click=\"ctrl.add_service_item();\" class=\"btn btn-nostyle\" ng-if=\"!ctrl.form.randomCustomer\"><span class=\"btn-plus inline-icon-btn\"></span> {{\"CALENDAR_ORDER_SERVICE_ADD\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.add_sales_item();\" class=\"btn btn-nostyle\" ng-if=\"!ctrl.form.randomCustomer\"><span class=\"btn-plus inline-icon-btn\"></span> {{\"CALENDAR_ORDER_SALES_ADD\" | translate}}</button><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.credit_card\">{{\'CALENDAR_ORDER_SECURITY\' | translate}}</label></div></div></div>");
$templateCache.put("app/modules/calendar/order/order.stores.form.html","<div class=\"row\" ng-click=\"containerClicked()\"><div class=\"order-wrapper\" ng-class=\"{\'disabled\': ([1, 6, 3].indexOf(ctrl.order.status) !== -1)}\"><div class=\"event-order-switch flex form\"><div ng-if=\"!ctrl.is_edit\"><div class=\"form-group last\" style=\"margin-bottom: 10px;\"><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"0\"> <label>{{\"ORDER_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"1\"> <label>{{\"EVENT_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div ng-if=\"ctrl.business.courses\" class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"2\"> <label>{{\"COURSE_ORDER_SWITCHER_LABEL\" | translate}}</label></div></div></div><div ng-if=\"ctrl.form.isEvent\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.all_day\" ng-disabled=\"ctrl.is_edit\">{{\"EVENT_ORDER_ALL_DAY_LABEL\" | translate}}</label></div></div><div ng-if=\"((ctrl.form.isEvent) || (!ctrl.form.isEvent && !ctrl.is_edit))\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.repeat\" ng-disabled=\"ctrl.is_edit\">{{ctrl.form.isEvent ? \"EVENT_ORDER_REPEAT_LABEL\" : \"ORDER_REPEAT_LABEL\" | translate}}</label></div></div><div ng-if=\"!ctrl.form.isEvent && ctrl.form.repeat\" class=\"form-group\"><label>{{\"CALENDAR_ORDER_REPEAT_PERIOD\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"{{\'CALENDAR_ORDER_REPEAT_PERIOD\' | translate}}\" ng-model=\"ctrl.form.period\" ng-disabled=\"ctrl.is_edit\" ng-required=\"ctrl.form.repeat\"><option value=\"7\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_7\" | translate}}</option><option value=\"14\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_14\" | translate}}</option><option value=\"21\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_21\" | translate}}</option><option value=\"28\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_28\" | translate}}</option><option value=\"35\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_35\" | translate}}</option><option value=\"42\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_42\" | translate}}</option><option value=\"49\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_49\" | translate}}</option><option value=\"56\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_56\" | translate}}</option><option value=\"63\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_63\" | translate}}</option><option value=\"70\">{{\"CALENDAR_ORDER_REPEAT_PERIOD_70\" | translate}}</option></select></div><div ng-if=\"!ctrl.form.isEvent && ctrl.form.repeat\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_REPEAT_COUNT\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.form.repeat_count\" max=\"50\" min=\"1\" ng-disabled=\"ctrl.is_edit\"></div></div><div ng-if=\"ctrl.form.isEvent && ctrl.form.repeat\" class=\"form-group\"><label>{{\"CALENDAR_ORDER_REPEAT\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"{{\'CALENDAR_ORDER_REPEAT\' | translate}}\" ng-model=\"ctrl.form.period\" ng-disabled=\"ctrl.is_edit\" ng-required=\"ctrl.form.repeat\"><option value=\"1\">{{\"CALENDAR_ORDER_REPEAT_DAILY\" | translate}}</option><option value=\"2\">{{\"CALENDAR_ORDER_REPEAT_WEEKLY\" | translate}}</option><option value=\"4\">{{\"CALENDAR_ORDER_REPEAT_2WEEKS\" | translate}}</option><option value=\"3\">{{\"CALENDAR_ORDER_REPEAT_MONTHLY\" | translate}}</option></select></div><div ng-if=\"ctrl.form.isEvent && ctrl.form.repeat\"><div class=\"form-group\"><label>{{\"CALENDAR_END_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.endDate\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\" ng-disabled=\"ctrl.is_edit\"></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-group clearfix customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select\"><div class=\"customer-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectCustomer()\"></div><div class=\"customer-pic-wrapper no-margin\" ng-if=\"ctrl.form.customer.id\" ui-sref=\"app.customers.single({id: {{ctrl.form.customer.id}}})\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-required=\"!ctrl.form.randomCustomer\" ng-model=\"ctrl.customer_search_name\" class=\"form-control customer-input\"><ul id=\"searchResult\"><li ng-click=\"chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul><button type=\"button\" ng-click=\"ctrl.addNewCustomer();\" class=\"btn icon default large\" ng-if=\"!ctrl.form.randomCustomer && !ctrl.is_edit\"><i class=\"las la-user-plus\"></i></button></div></div></div><div class=\"col-md-4 col-xs-12 no-padding flex nowrap top gap-16\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-change=\"ctrl.random_customer_changed();\" ng-model=\"ctrl.form.randomCustomer\">{{\"CALENDAR_ORDER_OCC\" | translate}}</label></div><div class=\"col-md-5 col-xs-12 no-padding visible-xs\" ng-if=\"ctrl.is_edit && !ctrl.form.isEvent && ((ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone) || (ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3))\"><div class=\"flex gap-8\"><a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}\"><i class=\"lab la-whatsapp\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered blue\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"tel:{{(ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone)}}\"><i class=\"las la-phone\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn text small border-green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}?text={{ctrl.reminderText()}}\"><i class=\"lab la-whatsapp\"></i>{{\"CALENDAR_WA_REMINDER\" | translate}}</a> <button type=\"button\" ng-if=\"ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3\" class=\"btn icon small bordered red\" ng-click=\"ctrl.approveArrival();\"><i class=\"las la-thumbs-up\" style=\"color: red;\"></i></button></div></div></div><div class=\"col-md-3 col-xs-12 no-padding\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.request_feedback\">{{\"SETTINGS_REQUEST_FEEDBACK\" | translate}}</label></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label>{{\"CUSTOMER_FULL_NAME\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.customer_name\" ng-required=\"ctrl.form.randomCustomer\"></div></div><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PHONE\" | translate}}</label> <input type=\"tel\" class=\"form-control\" ng-model=\"ctrl.form.phone\" ng-required=\"ctrl.form.randomCustomer\"></div></div><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-check\" ng-if=\"ctrl.form.randomCustomer\"><label><input type=\"checkbox\" ng-model=\"ctrl.allow_sending\"> {{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</label></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label class=\"text-nowrap\">{{\"CALENDAR_ORDER_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <span class=\"select-holiday-name\">{{ctrl.holidayName}}</span></div></div><div class=\"col-md-8 col-xs-12 no-padding hidden-xs\" ng-if=\"ctrl.is_edit && !ctrl.form.isEvent && ((ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone) || (ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3))\"><div class=\"flex gap-16\"><a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}\"><i class=\"lab la-whatsapp\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered blue\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"tel:{{(ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone)}}\"><i class=\"las la-phone\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn text small border-green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}?text={{ctrl.reminderText()}}\"><i class=\"lab la-whatsapp\"></i>{{\"CALENDAR_WA_REMINDER\" | translate}}</a> <button type=\"button\" ng-if=\"ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3\" class=\"btn icon small bordered red\" ng-click=\"ctrl.approveArrival();\"><i class=\"las la-thumbs-up\" style=\"color: red;\"></i></button></div></div><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"ctrl.form.isEvent\"><div class=\"form-group\"><label for=\"event-description\">{{\"EVENT_DESCRIPTION_LABEL\" | translate}}</label> <input type=\"text\" id=\"event-description\" class=\"form-control\" ng-model=\"ctrl.form.event_description\"></div></div></div><div class=\"order-item\" ng-repeat=\"($orderItemIndex, orderItem) in ctrl.form.items\"><h3 ng-if=\"orderItem.item_type == \'service\' && !ctrl.form.isEvent\" class=\"item-type-h3\">{{\"SERVICE\" | translate}}</h3><h3 ng-if=\"orderItem.item_type == \'sale\' && !ctrl.form.isEvent\" class=\"item-type-h3\">{{\"SALE\" | translate}}</h3><a ng-click=\"ctrl.remove_item_from_order($orderItemIndex)\" ng-hide=\"ctrl.form.items.length == 1\" class=\"remove-item\"><i class=\"fa fa-remove\"></i></a><div class=\"flex form\" ng-if=\"!ctrl.form.isEvent\"><div class=\"col-md-4 col-xs-12 no-padding item-wrapper\"><div class=\"items-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectItem($orderItemIndex, orderItem)\"></div><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_ITEM_ASSOCIATE\" | translate}} <i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': ctrl.hasCustomerCardForItem(orderItem.item_id) === \'expired\'}\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-if=\"ctrl.hasCustomerCardForItem(orderItem.item_id) && ctrl.isMobile\"></i></label><select chosen=\"\" name=\"item_resource\" ng-model=\"orderItem.item_id\" ng-if=\"ctrl.items\" ng-change=\"ctrl.order_item_resource_change($orderItemIndex)\" required=\"\" ng-class=\"orderItem.item_id ? \'invalid-element\' : \'\'\" data-placeholder=\'{{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}\'><option value=\"\"></option><option value=\"{{item.id}}\" ng-repeat=\"(index, item) in ctrl.items | filter:filterItems(orderItem) | orderBy:getItemPriority\" ng-bind-html=\"getTrustedHtml((item.name) + \' (\' + (!ctrl.hide_prices ? ((item.originalPrice | price) + \', \') : \'\') + (item.duration | duration) + \')\', ctrl.addCardBadge(item), $last)\"></option></select></div></div><div class=\"col-md-4 col-xs-6 no-padding\" ng-hide=\"ctrl.hide_prices\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PRICE\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"orderItem.item.price\" ng-required=\"orderItem.item_type == \'sale\'\"></div></div><div class=\"col-md-4 col-xs-6 no-padding number-wrapper\" ng-if=\"orderItem.item_type == \'sale\' && !ctrl.form.isEvent\"><div class=\"mb-24\"><label>{{\"CALENDAR_ORDER_QUANTITY\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.item.quantity\" ng-required=\"orderItem.item_type == \'sale\'\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div><div ng-class=\"orderItem.item_type == \'sale\' ? \'col-xs-12\' : \'col-xs-6\'\" class=\"col-md-4 no-padding\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_WORKER\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"בחר משאב\" required=\"\" ng-model=\"orderItem.resource\"><option value=\"\"></option><option value=\"{{resource.id}}\" ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.status != 0\">{{resource.name}}</option></select></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"ctrl.form.isEvent\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_WORKER\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"בחר משאב\" required=\"\" ng-model=\"orderItem.resource\"><option value=\"\"></option><option value=\"{{resource.id}}\" ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.status != 0\">{{resource.name}}</option></select></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_START_TIME\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"orderItem.start_time\" ng-change=\"ctrl.changeStartTime($orderItemIndex)\"><option value=\"{{hour}}\" ng-repeat=\"hour in ctrl.dates.hours\">{{hour}}</option></select></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_LENGTH\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"orderItem.duration\" ng-disabled=\"!orderItem.item_id && !ctrl.form.isEvent\" ng-required=\"true\"><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\' && orderItem.item && orderItem.item.break && !ctrl.form.isEvent\"><div class=\"col-xs-12 no-padding\"><h3>{{orderItem.item.name_second}}</h3><div class=\"form-check second-part-check\"><label><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"orderItem.enabled_second\" ng-change=\"ctrl.enable_second_change($orderItemIndex)\">{{\"CALENDAR_ORDER_ENABLED_SECOND\" | translate}}</label></div></div></div><div class=\"flex form\" ng-if=\"orderItem.enabled_second && !ctrl.form.isEvent\"><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_WORKER2\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"בחר משאב\" required=\"\" ng-model=\"orderItem.resource_second\"><option value=\"\"></option><option value=\"{{resource.id}}\" ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.status != 0\">{{resource.name}}</option></select></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_START_TIME2\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"orderItem.start_time_second\"><option value=\"{{hour}}\" ng-repeat=\"hour in ctrl.dates.hours\">{{hour}}</option></select></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_LENGTH2\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"orderItem.duration_second\" ng-disabled=\"!orderItem.item_id && !ctrl.form.isEvent\" ng-required=\"true\"><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div></div></div></div><div class=\"flex form top\" ng-if=\"!ctrl.form.isEvent\"><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"!ctrl.form.randomCustomer && !ctrl.form.isEvent\"><div ng-if=\"ctrl.order.status != 7\" class=\"flex between mb-8 relative\">{{\"CALENDAR_ORDER_SERVICE_ITEM\" | translate}}<div class=\"flex between gap-8\"><div class=\"dropdown-container\" ng-class=\"{ open: ctrl.showMultiServiceDropdown }\" click-outside=\"ctrl.closeDropdown()\"><button type=\"button\" class=\"btn icon default\" tooltip2=\"{{\'CALENDAR_ORDER_SERVICE_ITEM_MULTIPLE_TOOLTIP\' | translate}}\" ng-click=\"ctrl.toggleDropdown($event)\"><i class=\"las la-list-alt\"></i></button><div class=\"dropdown\" ng-if=\"ctrl.showMultiServiceDropdown\" ng-animate=\"\'dropdown\'\"><input type=\"text\" class=\"form-control dropdown-filter\" ng-model=\"ctrl.multiServiceFilterText\" placeholder=\"{{\'SERVICE_ITEM_MULTIPLE_FILTER_ITEMS\' | translate}}\"><div class=\"dropdown-items\"><label class=\"dropdown-item\" ng-repeat=\"item in ctrl.items | filter:filterItems({item_type: \'service\', \'item_id\': null}) | filter:ctrl.multiServiceFilterText | orderBy:getItemPriority\" ng-click=\"ctrl.toggleItem(item.id)\"><span class=\"multicheck\" ng-class=\"{checked: ctrl.isSelected(item.id)}\"></span> {{ item.name }}</label></div></div></div><button type=\"button\" ng-click=\"ctrl.add_service_item();\" class=\"btn text primary short\">{{\"CALENDAR_ORDER_SERVICE_ADD_BUTTON\" | translate}}</button></div></div><div ng-if=\"ctrl.order.status != 7\" class=\"flex between mb-8\">{{\"CALENDAR_ORDER_SALES\" | translate}} <button type=\"button\" ng-click=\"ctrl.add_sales_item();\" class=\"btn text short primary\">{{\"CALENDAR_ORDER_SALES_ADD_BUTTON\" | translate}}</button></div><div ng-if=\"ctrl.form.customer\" class=\"flex gap-16 order-l-df-buttons\"><button type=\"button\" ng-click=\"ctrl.show_laser_file();\" class=\"btn text border-primary\">{{\"CALENDAR_ORDER_LASER_FILE\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.add_form();\" class=\"btn text border-primary\">{{\"CALENDAR_ORDER_DIGITAL_FORM\" | translate}}</button></div></div><div class=\"col-md-4 col-xs-6 no-padding order-images-col\"><p>{{\"CALENDAR_ORDER_IMAGES_BEFORE\" | translate}}</p><div class=\"flex column\"><label ng-repeat=\"(i, k) in ctrl.images_count\" ng-class=\"{\'import-image\': true, \'w-image\': !ctrl.form[\'image_before\'+k] || ctrl.form[\'image_before\'+k] == \'\', \'first\': ctrl.checkFirstWImage(\'image_before\', k)}\"><input ng-if=\"!ctrl.form[\'image_before\'+k] || ctrl.form[\'image_before\'+k] == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image_before{{k}}\" type=\"file\" accept=\"image/*\" ng-click=\"ctrl.allow_edit = true;\" ng-disabled=\"[1, 6].indexOf(ctrl.order.status) !== -1\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form[\'image_before\'+k] && ctrl.form[\'image_before\'+k] != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, ctrl.form[\'image_before\'+k]);\"><img ng-src=\"{{ctrl.form[\'image_before\'+k]}}\"></div><span class=\"filename\">{{ctrl.form[\'image_before\'+k].substring(ctrl.form[\'image_before\'+k].lastIndexOf(\'/\') + 1)}}</span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event, \'image_before\'+k)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!ctrl.form[\'image_before\'+k] || ctrl.form[\'image_before\'+k] == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div><div class=\"col-md-4 col-xs-6 no-padding order-images-col\"><p>{{\"CALENDAR_ORDER_IMAGES_AFTER\" | translate}}</p><div class=\"flex column\"><label ng-repeat=\"(i, k) in ctrl.images_count\" ng-class=\"{\'import-image\': true, \'w-image\': !ctrl.form[\'image_after\'+k] || ctrl.form[\'image_after\'+k] == \'\', \'first\': ctrl.checkFirstWImage(\'image_after\', k)}\"><input ng-if=\"!ctrl.form[\'image_after\'+k] || ctrl.form[\'image_after\'+k] == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image_after{{k}}\" type=\"file\" accept=\"image/*\" ng-click=\"ctrl.allow_edit = true;\" ng-disabled=\"[1, 6].indexOf(ctrl.order.status) !== -1\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form[\'image_after\'+k] && ctrl.form[\'image_after\'+k] != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, ctrl.form[\'image_after\'+k]);\"><img ng-src=\"{{ctrl.form[\'image_after\'+k]}}\"></div><span class=\"filename\">{{ctrl.form[\'image_after\'+k].substring(ctrl.form[\'image_after\'+k].lastIndexOf(\'/\') + 1)}}</span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event, \'image_after\'+k)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!ctrl.form[\'image_after\'+k] || ctrl.form[\'image_after\'+k] == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div></div><div class=\"flex form\" style=\"margin-top: 15px;\" ng-if=\"!ctrl.form.isEvent\"><div class=\"col-xs-12 no-padding\"><div class=\"form-group last\" audio-recorder=\"\" audio-model=\"ctrl.form.notes\"><label>{{\"CALENDAR_ORDER_REMARKS\" | translate}}</label> <textarea auto-expand=\"\" class=\"form-control\" ng-model=\"ctrl.form.notes\" placeholder=\"כאן תוכל להכניס מידע הרלוונטי להזמנה זו\" ng-change=\"ctrl.allow_edit = true\"></textarea></div></div></div></div></div>");
$templateCache.put("app/modules/calendar/order/order.stores_course.form.html","<div class=\"row\" ng-click=\"containerClicked()\"><div class=\"order-wrapper\" ng-class=\"{\'disabled\': ([1, 6, 3].indexOf(ctrl.order.status) !== -1)}\"><div class=\"event-order-switch flex form\"><div ng-if=\"!ctrl.is_edit\"><div class=\"form-group last\" style=\"margin-bottom: 10px; margin-top: 16px;\"><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"0\"> <label>{{\"ORDER_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"1\"> <label>{{\"EVENT_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div ng-if=\"ctrl.business.courses\" class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"2\"> <label>{{\"COURSE_ORDER_SWITCHER_LABEL\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><label class=\"text-nowrap\">{{\"CALENDAR_ORDER_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <span class=\"select-holiday-name\">{{ctrl.getHolidayName(ctrl.form.date)}}</span></div></div><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"items-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectItem($orderItemIndex, orderItem, true)\"></div><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_ITEM_ASSOCIATE\" | translate}}</label><select chosen=\"\" name=\"item_resource\" ng-model=\"ctrl.form.item_id\" ng-if=\"ctrl.items\" required=\"\" data-placeholder=\'{{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}\'><option value=\"\"></option><option ng-if=\"item.item_type == \'course\' && (!item.inactive || item.id == ctrl.form.item_id)\" class=\"\" value=\"{{item.id}}\" ng-repeat=\"item in ctrl.items\" ng-bind-html=\"(item.name) + (!ctrl.hide_prices ? \' (\' + (item.originalPrice | price) + \')\' : \'\')\"></option></select></div></div></div><div class=\"flex form\" ng-if=\"ctrl.courses_fields && ctrl.courses_fields.length > 0\"><div class=\"col-md-4 col-xs-6 no-padding\" ng-repeat=\"field in ctrl.courses_fields\"><div class=\"form-group form-select\" ng-if=\"field.type == \'list\'\"><label>{{field.name}}</label><select class=\"form-control\" ng-model=\"ctrl.form.courses_fields[field.id]\" ng-required=\"field.required\" data-placeholder=\"{{field.name}}\"><option value=\"\"></option><option value=\"{{value.id}}\" ng-repeat=\"value in field.values\">{{value.value}}</option></select></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group clearfix customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select\"><div class=\"customer-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectCustomer()\"></div><div class=\"customer-pic-wrapper no-margin\" ng-if=\"ctrl.form.customer.id\" ui-sref=\"app.customers.single({id: {{ctrl.form.customer.id}}})\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" class=\"form-control customer-input\"><ul id=\"searchResult\"><li ng-click=\"chooseCustomer($index,$event)\" ng-if=\"ctrl.check_existed_customer(customer.id) == false\" ng-repeat=\"customer in ctrl.searchResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul><button type=\"button\" ng-click=\"ctrl.addNewCustomer();\" class=\"btn icon default large\" ng-if=\"!ctrl.is_edit\"><i class=\"las la-user-plus\"></i></button></div></div></div></div><div class=\"flex form top\"><div class=\"col-md-12 col-xs-12 no-padding flex-customers\"><div class=\"customer-item ng-scope\" ng-repeat=\"($customerItemIndex, customerItem) in ctrl.form.customers_list\"><div class=\"customer-pic-wrapper no-margin\"><img ng-src=\"{{customerItem.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{customerItem.firstname}} {{customerItem.lastname}} <span class=\"customer-item-remove\" ng-click=\"ctrl.remove_customer_item($customerItemIndex)\"><i class=\"las la-times\"></i></span></div></div></div><div class=\"sline-sep\"></div><div class=\"flex form top\"><div class=\"col-md-12 col-xs-12 no-padding\"><div class=\"flex between mb-24\"><button type=\"button\" ng-click=\"ctrl.add_meeting_item();\" class=\"btn text primary\">{{\"CALENDAR_ORDER_MEETING_ADD_BUTTON\" | translate}}</button></div></div><div class=\"order-item meeting ng-scope\" ng-repeat=\"($orderItemIndex, orderItem) in ctrl.form.meetings\"><div class=\"flex form\"><div ng-class=\"{\'col-md-7\': ctrl.business.second_resource, \'col-md-11\': !ctrl.business.second_resource, \'col-xs-10 no-padding\': true}\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_MEETING_NAME\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"orderItem.name\" required=\"\"></div></div><div ng-if=\"isMobile\" class=\"col-md-1 col-xs-2 no-padding\"><button ng-click=\"ctrl.remove_meeting_item($orderItemIndex);\" class=\"btn icon circle large single-model-delete\" ng-if=\"ctrl.form.meetings.length > 1\"><i class=\"las la-trash-alt\"></i></button></div><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"ctrl.business.second_resource\"><div class=\"form-group\"><label>{{ctrl.business.second_resource_name}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"{{ctrl.business.second_resource_name}}\" ng-model=\"orderItem.second_resource\"><option value=\"\"></option><option value=\"{{resource.id}}\" ng-repeat=\"resource in ctrl.second_resources\" ng-if=\"resource.status != 0\">{{resource.name}}</option></select></div></div><div ng-if=\"!isMobile\" class=\"col-md-1 col-xs-2 no-padding\"><button ng-click=\"ctrl.remove_meeting_item($orderItemIndex);\" class=\"btn icon circle large single-model-delete\" ng-if=\"ctrl.form.meetings.length > 1\"><i class=\"las la-trash-alt\"></i></button></div></div><div class=\"flex form\"><div class=\"col-md-3 col-xs-6 no-padding\"><div class=\"form-group top-datepicker\"><label class=\"text-nowrap\">{{\"CALENDAR_ORDER_MEETING_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"orderItem.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <span class=\"select-holiday-name\">{{ctrl.getHolidayName(orderItem.date)}}</span></div></div><div class=\"col-md-2 col-xs-6 no-padding\"><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_MEETING_START_TIME\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"orderItem.start_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in ctrl.dates.hours\">{{hour}}</option></select></div></div><div class=\"col-md-3 col-xs-6 no-padding\"><div class=\"form-group form-select\"><label>{{\"CALENDAR_ORDER_LENGTH\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"orderItem.duration\" ng-required=\"true\"><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div></div><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_WORKER\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\"בחר משאב\" required=\"\" ng-model=\"orderItem.resource\"><option value=\"\"></option><option value=\"{{resource.id}}\" ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.status != 0\">{{resource.name}}</option></select></div></div></div></div></div><div class=\"sline-sep\"></div></div></div>");
$templateCache.put("app/modules/reports/popups/debt-remind.view.html","<div class=\"modal-form-inner remind-debt-popup\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"REMIND_DEBT_POPUP_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"\" ng-submit=\"\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"form-group\"><textarea class=\"form-control\" rows=\"5\" maxlength=\"70\" required=\"\" ng-model=\"ctrl.form.message\"></textarea></div><div class=\"flex form fill fill-m\"><div class=\"form-group\"><label class=\"settings_label\">{{\"REMIND_DEBT_SEND_METHOD\" | translate}}</label><br><div class=\"radio-btn\"><input id=\"send-reminde-debt-email\" type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"1\" data-ng-disabled=\"!ctrl.customer.email\"> <label for=\"send-reminde-debt-email\">{{\"SETTINGS_USER_MAIL\" | translate}}</label></div><div class=\"radio-btn\"><input id=\"send-reminde-debt-sms\" type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"2\" data-ng-disabled=\"!ctrl.customer.phone\"> <label for=\"send-reminde-debt-sms\">{{\"CUSTOMERS_SMS\" | translate}}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"REMIND_POPUP_CLOSE_BTN\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.sendReminder()\" class=\"btn text primary large\">{{\"REMIND_POPUP_SEND_BTN\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/reports/tax_files/reports.tax_files.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_TAX_FILES\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"infoForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_TAX_FILES_FROM\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.form.from\" name=\"from\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.from.$error\" class=\"ng-messages\" ng-show=\"infoForm.from.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_TAX_FILES_TO\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.form.to\" name=\"to\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.to.$error\" class=\"ng-messages\" ng-show=\"infoForm.to.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_TAX_FILES_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid || infoForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_TAX_FILES_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/marketing/automations/automations.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.marketing\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"MARKETING_AUTOMATIONS\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.marketing.automations.new\"><i class=\"las la-plus\"></i> {{\"AUTOMATIONS_ADD\" | translate}}</button></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.tableData\" id=\"automations_dt\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"AUTOMATION_NAME\" | translate}}</th><th>{{\"AUTOMATION_TRIGGER\" | translate}}</th><th>{{\"AUTOMATION_CUSTOMER_REMIND_TYPE\" | translate}}</th><th>{{\"AUTOMATION_ACTIVE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.marketing.automations.edit({id: {{row.id}}})\"><td>{{row.name}}</td><td><span ng-if=\"row.remind_type == \'before\'\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_BEFORE\" | translate}}</span> <span ng-if=\"row.remind_type == \'after\'\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_AFTER\" | translate}}</span> <span ng-if=\"row.remind_type == \'now\' || !row.remind_time\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_NOW\" | translate}}</span> <span ng-if=\"row.remind_type != \'now\' && row.remind_time\">{{row.remind_time}}</span> <span ng-if=\"row.remind_type != \'now\' && row.remind_time\"><span ng-if=\"row.timetype == \'minutes\'\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_MINUTES\" | translate}}</span> <span ng-if=\"row.timetype == \'hours\'\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_HOURS\" | translate}}</span> <span ng-if=\"row.timetype == \'days\'\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_DAYS\" | translate}}</span></span></td><td>{{\"AUTOMATION_TRIGGER_\"+row.trigger.toString().toUpperCase() | translate}}</td><td ng-click=\"$event.stopPropagation()\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"row.active\" ng-change=\"ctrl.updateActive(row)\"> {{\"AUTOMATION_ACTIVE\" | translate}}</label></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/color/settings.color.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_INT_LENGTH\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.interval\"><option value=\"5\">{{\"SETTINGS_INFO_MIN5\" | translate}}</option><option value=\"10\">{{\"SETTINGS_INFO_MIN10\" | translate}}</option><option value=\"15\">{{\"SETTINGS_INFO_MIN15\" | translate}}</option><option value=\"20\">{{\"SETTINGS_INFO_MIN20\" | translate}}</option><option value=\"30\">{{\"SETTINGS_INFO_MIN30\" | translate}}</option><option value=\"60\">{{\"SETTINGS_INFO_MIN60\" | translate}}</option><option value=\"90\">{{\"SETTINGS_INFO_MIN90\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_WORKING_HOURS_START\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"ctrl.form.min_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_WORKING_HOURS_END\" | translate}}</label><select class=\"form-control\" required=\"\" ng-model=\"ctrl.form.max_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_CALENDAR_DEFAULT\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.calendar_default\"><option value=\"0\">{{\"SETTINGS_CALENDAR_DEFAULT_DAILY\" | translate}}</option><option value=\"1\">{{\"SETTINGS_CALENDAR_DEFAULT_WEEKLY\" | translate}}</option><option value=\"2\">{{\"SETTINGS_CALENDAR_DEFAULT_MONTHLY\" | translate}}</option></select></div></div></div><div class=\"line-sep b\"></div><h3 class=\"title\">{{\"ADMIN_COLOR_TITLE\" | translate}}</h3><div class=\"flex form fill-m\"><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_BACK_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.back_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_MENU_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.menu_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_CALENDAR_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.calendar_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_HOLIDAY_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.holiday_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_CALENDAR_STRIPE_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.calendar_stripe_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_CALENDAR_EVENT_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.calendar_event_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.switch_colors\">{{\"SWITCH_MENU_COLORS\" | translate}}</label></div></div></div><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.resetColors()\">{{\"SETTINGS_INFO_RESET_COLORS\" | translate}}</button><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/digital_documents/settings.digital_documents.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_DIGITAL_DOCUMENTS_INFO_TITLE\" | translate }}</h3></div><div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex gap-24 mb-24\"><label class=\"btn text primary large\"><i class=\"las la-plus\"></i>{{\"SETTINGS_DIGITAL_DOCUMENT\" | translate}} <input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"document\" accept=\".pdf\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div><div><div ng-if=\"ctrl.list\" class=\"dd-files\"><div ng-repeat=\"row in ctrl.list\" class=\"laser-field gap-24\">{{row.name}} <a type=\"button\" class=\"btn icon red\" ng-click=\"ctrl.removeFile(row.id);\"><i class=\"las la-trash-alt\"></i></a></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/modules/settings/additional_fields/additional_fields.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_ADDITIONAL_FIELDS\" | translate }}</h3></div><div class=\"settings-block additional_fields\"><ul><li><a ui-sref=\"app.settings.additional_fields.interested\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-gratipay\"></i></span><div><h6>{{\"SETTINGS_INTERESTED\" | translate}}</h6><p>{{\"SETTINGS_INTERESTED_MANAGE\" | translate}}</p></div></a></li><li class=\"li custom_field\" ng-repeat=\"field in ctrl.customFields\"><a ui-sref=\"app.settings.custom_fields.single({ id: field.id })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{field.name}}</h6><p>{{\"SETTINGS_CUSTOM_FIELDS_VALUES\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/documents/documents.view.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"lang == \'he\'\">{{\"SETTINGS_DEC_SET_HEB\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"lang == \'en\'\">{{\"SETTINGS_DEC_SET_ENG\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"m-t\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DOC_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.agent\" class=\"form-control\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DOC_NOTE\" | translate}}</label> <textarea ng-model=\"ctrl.form.notes\" class=\"form-control\" style=\"height: 130px; resize: none;\"></textarea></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_DOC_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid || infoForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_DOC_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/google_calendar/google_calendar.view.html","<div ng-include=\"\'app/components/header/header.html\'\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"GOOGLE_CALENDAR_SETTINGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ng-click=\"ctrl.connectNewAccount()\">{{\"CONNECT_NEW_ACCOUNT\" | translate}}</button></div><table ng-if=\"ctrl.accounts.length\" class=\"sorted-table\"><thead><tr><th>{{\"GOOGLE_CALENDAR_ACCOUNT_NAME\" | translate}}</th><th>{{\"GOOGLE_CALENDAR_ACCOUNT_RESOURCES\" | translate}}</th><th></th><th style=\"text-align: end;\">{{\"GOOGLE_CALENDAR_ACCOUNT_ACTIVE\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in ctrl.accounts\" ng-click=\"ctrl.editAccountResources(row)\" ng-class=\"{\'error\': row.error_message}\"><td><div class=\"flex nowrap\"><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar_url || \'assets/images/default-avatar.png\'}}\" alt=\"\" class=\"customer-pic\"></div><div><p>{{row.name}}</p><p>{{row.email}}</p></div></div></td><td>{{row.resource_names.join(\', \')}}</td><td>{{row.error_message || \'\'}}</td><td style=\"text-align: end;\"><div class=\"form-switch form-group first last pull-end\" ng-click=\"$event.stopPropagation()\"><label style=\"padding-left: 42px;\"><input type=\"checkbox\" ng-change=\"ctrl.toggleAccountStatus(row)\" ng-model=\"row.is_active\">&nbsp;</label></div></td></tr></tbody></table><div ng-if=\"!ctrl.loading && ctrl.accounts.length === 0\" class=\"no-accounts\"><div class=\"no-accounts-content\"><i class=\"fa fa-google fa-3x\"></i><h4>{{\"NO_GOOGLE_ACCOUNTS\" | translate}}</h4><p>{{\"NO_GOOGLE_ACCOUNTS_DESCRIPTION\" | translate}}</p></div></div></div></div></div>");
$templateCache.put("app/modules/settings/info/info.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form\"><div class=\"col-md-2 col-xs-6\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.avatar + \')\'}\"></div></label></div><div class=\"col-md-2 col-xs-6\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"logo\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.logo + \')\'}\"></div></label></div></div><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_BUSS_NAME\" | translate}}</label> <input disabled=\"\" type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.name.$error\" class=\"ng-messages\" ng-show=\"infoForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_COMP_ID\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.company_id\" name=\"company_id\" class=\"form-control\" disabled=\"\" required=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_DEFAULT_SCREEN\" | translate}}</label><select class=\"form-control\" name=\"screen\" ng-model=\"ctrl.form.default_screen\"><option ng-repeat=\"k in default_screens\" value=\"{{k}}\">{{k | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_ACCOUNTANT_EMAIL\" | translate}}</label> <input type=\"accountant_email\" ng-model=\"ctrl.form.accountant_email\" name=\"accountant_email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"infoForm.accountant_email.$error\" class=\"ng-messages\" ng-show=\"infoForm.accountant_email.$dirty\"><div ng-message=\"accountant_email\">{{\"SETTINGS_INFO_ACCOUNTANT_EMAIL_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"infoForm.email.$error\" class=\"ng-messages\" ng-show=\"infoForm.email.$dirty\"><div ng-message=\"email\">{{\"SETTINGS_INFO_EMAIL_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PHONE\" | translate}}</label> <input type=\"tel\" name=\"phone\" required=\"\" ng-model=\"ctrl.form.phone\" placeholder=\"0534231367\" class=\"form-control\"><div ng-messages=\"businessForm.phone.$error\" class=\"ng-messages\" ng-show=\"businessForm.phone.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.city\" name=\"address\" class=\"form-control\"><div ng-messages=\"infoForm.city.$error\" class=\"ng-messages\" ng-show=\"infoForm.city.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_ADDRESS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"><div ng-messages=\"infoForm.address.$error\" class=\"ng-messages\" ng-show=\"infoForm.address.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_HOME_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.home_number\" name=\"name\" class=\"form-control\"><div ng-messages=\"infoForm.home_number.$error\" class=\"ng-messages\" ng-show=\"infoForm.home_number.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_POST_CODE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.zip\" name=\"name\" class=\"form-control\"><div ng-messages=\"infoForm.zip.$error\" class=\"ng-messages\" ng-show=\"infoForm.zip.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span>{{\"DEALER_TYPE\" | translate}}</label><select disabled=\"\" class=\"form-control\" name=\"type\" required=\"\" ng-model=\"ctrl.form.dealer_type\"><option value=\"licensed\">Licensed</option><option value=\"exempt\">Exempt</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_LANG\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.language_code\"><option value=\"hb_ISR\">{{\"SETTINGS_INFO_HB_ISR_LANG\" | translate}}</option><option value=\"en_US\">{{\"SETTINGS_INFO_EN_US_LANG\" | translate}}</option><option value=\"ru_RU\">{{\"SETTINGS_INFO_RU_RU_LANG\" | translate}}</option><option value=\"ja_JP\">{{\"SETTINGS_INFO_JA_JP_LANG\" | translate}}</option><option value=\"ar_AR\">{{\"SETTINGS_INFO_AR_AR_LANG\" | translate}}</option></select></div></div></div><div class=\"line-sep\"></div><div class=\"flex form\"><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_notes\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_notes\" ng-model=\"ctrl.form.show_notes\">{{\"SETTINGS_INFO_SHOW_NOTES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"stop_messages\"><input type=\"checkbox\" class=\"form-check-input\" id=\"stop_messages\" ng-model=\"ctrl.form.stop_messages\">{{\"SETTINGS_INFO_STOP_MESSAGES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"manage_leads\"><input type=\"checkbox\" class=\"form-check-input\" id=\"manage_leads\" ng-model=\"ctrl.form.manage_leads\">{{\"SETTINGS_INFO_MANAGE_LEADS\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"manage_employee\"><input type=\"checkbox\" class=\"form-check-input\" id=\"manage_employee\" ng-model=\"ctrl.form.manage_employee\">{{\"SETTINGS_MANAGE_EMPLOYEE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"print_invoices\"><input type=\"checkbox\" class=\"form-check-input\" id=\"print_invoices\" ng-model=\"ctrl.form.print_invoices\">{{\"SETTINGS_PRINT_AUTOMATICALLY\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_stock\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_stock\" ng-model=\"ctrl.form.show_stock\">{{\"SETTINGS_SHOW_STOCK\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"stop_saturday_messages\"><input type=\"checkbox\" class=\"form-check-input\" id=\"stop_saturday_messages\" ng-model=\"ctrl.form.stop_saturday_messages\">{{\"SETTINGS_STOP_SATURDAY_MESSAGES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_notes_page\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_notes_page\" ng-model=\"ctrl.form.show_notes_page\">{{\"SETTINGS_INFO_SHOW_NOTES_PAGE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_digital_forms_page\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_digital_forms_page\" ng-model=\"ctrl.form.show_digital_forms_page\">{{\"SETTINGS_INFO_SHOW_DIGITAL_FORMS_PAGE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"customer_wa_chat\"><input type=\"checkbox\" class=\"form-check-input\" id=\"customer_wa_chat\" ng-model=\"ctrl.form.customer_wa_chat\" ng-change=\"ctrl.changeCustomerWaChat()\">{{\"SETTINGS_INFO_CUSTOMER_WA_CHAT\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_wa_messages\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_wa_messages\" ng-model=\"ctrl.form.display_wa_messages\">{{\"SETTINGS_INFO_DISPLAY_WA_MESSAGES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"print_customer_dealer_id\"><input type=\"checkbox\" class=\"form-check-input\" id=\"print_customer_dealer_id\" ng-model=\"ctrl.form.print_customer_dealer_id\">{{\"SETTINGS_INFO_PRINT_CUSTOMER_DEALER_ID\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_order_user\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_order_user\" ng-model=\"ctrl.form.display_order_user\">{{\"SETTINGS_INFO_DISPLAY_ORDER_USER\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_one_block_services\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_one_block_services\" ng-model=\"ctrl.form.display_one_block_services\">{{\"SETTINGS_INFO_DISPLAY_ONE_BLOCK_SERVICES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_hebrew_dates\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_hebrew_dates\" ng-model=\"ctrl.form.display_hebrew_dates\">{{\"SETTINGS_INFO_DISPLAY_HEBREW_DATES\" | translate}}</label></div></div></div><div class=\"line-sep\"></div><h3 class=\"title\">{{\"ADMIN_OPTIONAL_TITLE\" | translate}}</h3><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_INFO_PREPAID\" | translate}}</label> <input type=\"number\" step=\"0.01\" ng-model=\"ctrl.form.prepaid\" name=\"prepaid\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_INFO_AVE_CALCULATION\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.ave_calculation\"><option value=\"1\">{{\"SETTINGS_INFO_AVE_CALCULATION_INVOICE\" | translate}}</option><option value=\"0\">{{\"SETTINGS_INFO_AVE_CALCULATION_SHOWS\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_DEFAULT_SCHEDULE_MESSAGE_CHANNEL\" | translate}}</label><select class=\"form-control\" ng-change=\"ctrl.checkCustomerDefault(\'msg_channel_scheduling\')\" ng-model=\"ctrl.form.msg_channel_scheduling\"><option value=\"{{ msg_channel.index }}\" ng-if=\"msg_channel.index != 4\" ng-repeat=\"msg_channel in msg_channels track by $index\">{{msg_channel.name | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ORDER_UPDATE_NOTIFICATION\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.update_order_notification\"><option value=\"0\">{{\"SETTINGS_ORDER_UPDATE_NOTIFICATION_0\" | translate}}</option><option value=\"1\">{{\"SETTINGS_ORDER_UPDATE_NOTIFICATION_1\" | translate}}</option><option value=\"2\">{{\"SETTINGS_ORDER_UPDATE_NOTIFICATION_2\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_USER_SEND_REMINDER\" | translate}}</label><select class=\"form-control\" ng-change=\"ctrl.checkCustomerDefault(\'send_reminder\')\" ng-model=\"ctrl.form.send_reminder\"><option value=\"0\">{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</option><option value=\"2\">{{\"SETTINGS_USER_REMINDER_2_HOURS\" | translate}}</option><option value=\"4\">{{\"SETTINGS_USER_REMINDER_4_HOURS\" | translate}}</option><option value=\"24\">{{\"SETTINGS_USER_REMINDER_24_HOURS\" | translate}}</option><option value=\"48\">{{\"SETTINGS_USER_REMINDER_48_HOURS\" | translate}}</option><option value=\"72\">{{\"SETTINGS_USER_REMINDER_72_HOURS\" | translate}}</option><option value=\"168\">{{\"SETTINGS_USER_REMINDER_168_HOURS\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\" ng-show=\"ctrl.form.send_reminder != 0\"><div class=\"form-group form-select\"><label>{{\"CUSTOMERS_SEND_REMINDER\" | translate}}</label><select class=\"form-control\" ng-change=\"ctrl.checkCustomerDefault(\'reminder_send_type\')\" ng-model=\"ctrl.form.reminder_send_type\"><option value=\"{{ msg_channel.index }}\" ng-if=\"msg_channel.index != 4\" ng-repeat=\"msg_channel in msg_channels track by $index\">{{msg_channel.name | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\" ng-show=\"ctrl.form.send_reminder != 0\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ORDER_CONFIRMATION_DEFAULT\" | translate}}</label><select class=\"form-control\" ng-change=\"ctrl.checkCustomerDefault(\'request_order_confirmation\')\" ng-model=\"ctrl.form.request_order_confirmation\"><option value=\"0\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</option><option value=\"1\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_DEFAULT_INV_LINK_MESSAGE_CHANNEL\" | translate}}</label><select class=\"form-control\" ng-change=\"ctrl.checkCustomerDefault(\'msg_channel_inv_link\')\" ng-model=\"ctrl.form.msg_channel_inv_link\"><option value=\"{{ msg_channel.index }}\" ng-repeat=\"msg_channel in msg_channels track by $index\">{{msg_channel.name | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_DF_DD_CHANNEL\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.dd_df_channel\"><option value=\"{{ msg_channel.index }}\" ng-if=\"msg_channel.index != 4 && msg_channel.index != 1\" ng-repeat=\"msg_channel in msg_channels track by $index\">{{msg_channel.name | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_CHANNEL\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.online_channel\"><option value=\"{{ msg_channel.index }}\" ng-if=\"msg_channel.index != 4 && msg_channel.index != 1\" ng-repeat=\"msg_channel in msg_channels track by $index\">{{msg_channel.name | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_NOT_ARRIVE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.not_arrive_option\"><option value=\"0\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</option><option value=\"1\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\" ng-if=\"false\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_UPDATE_ORDER_NOTIFICATION\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.update_order_notification\"><option value=\"0\">{{\"SETTINGS_UPDATE_ORDER_NOTIFICATION_0\" | translate}}</option><option value=\"1\">{{\"SETTINGS_UPDATE_ORDER_NOTIFICATION_1\" | translate}}</option><option value=\"2\">{{\"SETTINGS_UPDATE_ORDER_NOTIFICATION_2\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_APPROVAL_TEXT\" | translate}}</label> <textarea ng-model=\"ctrl.form.approval_text\" class=\"form-control\"></textarea></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_LEAD_APPEARENCE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.lead_appearence\"><option value=\"0\">{{\"SETTINGS_LEAD_APPEARENCE_DEFAULT\" | translate}}</option><option value=\"1\">{{\"SETTINGS_LEAD_APPEARENCE_STATUSES\" | translate}}</option></select></div></div><div ng-if=\"ctrl.form.stop_saturday_messages\" class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.stop_saturday_messages_condition\"><option value=\"before\">{{\"SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION_BEFORE\" | translate}}</option><option value=\"after\">{{\"SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION_AFTER\" | translate}}</option></select></div></div></div><div class=\"line-sep\"></div><h3 class=\"title\">{{\"ADMIN_LINK_TITLE\" | translate}}</h3><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_FACEBOOK_REVIEW\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.facebook_review\" name=\"name\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_GOOGLE_REVIEW\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.google_review\" name=\"name\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_TELEPHONY_LINK\" | translate}}</label> <input type=\"text\" value=\"{{ctrl.telephonyLink}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_TELEPHONY_TOKEN\" | translate}}</label> <input type=\"text\" value=\"{{ctrl.form.telephony_token}}\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/landing/settings.landing.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_LANDING_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form form_templates\"><div><div class=\"form_radio_img\"><img src=\"assets/images/template1.png\" alt=\"template1\"></div><div class=\"radio-btn\"><input ng-change=\"ctrl.submit()\" id=\"radio_template1\" type=\"radio\" value=\"1\" ng-model=\"ctrl.form.template\" name=\"name\"> <label for=\"radio_template1\">{{\"LANDING_TEMPLATE_1\" | translate}}</label></div></div><div><div class=\"form_radio_img\"><img src=\"assets/images/template2.png\" alt=\"template2\"></div><div class=\"radio-btn\"><input ng-change=\"ctrl.submit()\" id=\"radio_template2\" type=\"radio\" value=\"2\" ng-model=\"ctrl.form.template\" name=\"name\"> <label for=\"radio_template2\">{{\"LANDING_TEMPLATE_2\" | translate}}</label></div></div><div><div class=\"form_radio_img\"><img src=\"assets/images/template3.png\" alt=\"template3\"></div><div class=\"radio-btn\"><input ng-change=\"ctrl.submit()\" id=\"radio_template3\" type=\"radio\" value=\"3\" ng-model=\"ctrl.form.template\" name=\"name\"> <label for=\"radio_template3\">{{\"LANDING_TEMPLATE_3\" | translate}}</label></div></div></div><div class=\"line-sep\"></div><div class=\"flex form v-start\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"SETTINGS_ONLINE_ALIAS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.landing_alias\" ng-change=\"ctrl.onAliasChange()\" name=\"alias\" class=\"form-control\" ng-class=\"{\'form-control-error\': ctrl.aliasStatus == \'symbols\' || ctrl.aliasStatus == \'taken\' || ctrl.aliasStatus == \'length\'}\"><div ng-show=\"ctrl.aliasStatus == \'loading\'\" class=\"input-loader\"><i class=\"las la-spinner\"></i></div></div><i class=\"input-hint\" ng-class=\"{\'visible error\': ctrl.aliasStatus == \'symbols\' || ctrl.aliasStatus == \'taken\' || ctrl.aliasStatus == \'length\'}\"><span ng-if=\"ctrl.aliasStatus == \'pending\' || ctrl.aliasStatus == \'loading\' || ctrl.aliasStatus == \'success\'\">&nbsp;</span> <span ng-if=\"ctrl.aliasStatus == \'symbols\'\">{{\"SETTINGS_ONLINE_ALIAS_SYMBOLS\" | translate}}</span> <span ng-if=\"ctrl.aliasStatus == \'taken\'\">{{\"SETTINGS_ONLINE_ALIAS_TAKEN\" | translate}}</span> <span ng-if=\"ctrl.aliasStatus == \'length\'\">{{\"SETTINGS_ONLINE_ALIAS_LENGTH\" | translate}}</span></i></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"SETTINGS_LANDING_BOOKING_LINK\" | translate}}</label> <a href=\"javascript:;\" ng-click=\"ctrl.copyLink()\" class=\"copy-icon\"><i class=\"las la-copy\"></i></a> <input type=\"text\" value=\"{{ ctrl.uniqueBusinessBookingURL() }}\" class=\"form-control\" readonly=\"\"></div><i class=\"input-hint success\" ng-class=\"{\'visible\': ctrl.copied}\">{{\"SETTINGS_ONLINE_URL_COPIED\" | translate}}</i></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <a href=\"javascript:;\" ng-click=\"ctrl.editPage()\" class=\"btn text white large\"><i class=\"las la-pen\"></i>{{\"LANDING_EDIT\" | translate}}</a> <a href=\"{{ ctrl.uniqueBusinessBookingURL() }}\" target=\"_blank\" class=\"btn text primary large\"><i class=\"las la-eye\"></i>{{\"LANDING_PREVIEW\" | translate}}</a> <button type=\"button\" ng-click=\"ctrl.submit(true)\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/courses_fields/courses_fields.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_COURSES_FIELDS\" | translate }}</h3></div><div class=\"settings-block\"><ul><li class=\"li custom_field\" ng-repeat=\"field in ctrl.coursesFields\" ng-if=\"field.type == \'list\'\"><a ui-sref=\"app.settings.courses_fields.single({ id: field.id })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{field.name}}</h6><p>{{\"SETTINGS_COURSES_FIELDS_VALUES\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/custom_fields/custom_fields.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_CUSTOM_FIELDS\" | translate }}</h3></div><div class=\"settings-block\"><ul><li class=\"li custom_field\" ng-repeat=\"field in ctrl.customFields\"><a ui-sref=\"app.settings.custom_fields.single({ id: field.id })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{field.name}}</h6><p>{{\"SETTINGS_CUSTOM_FIELDS_VALUES\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/messages/settings.messages.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_NOT_SET\" | translate }}</h3></div><div class=\"mesages-settings\"><form class=\"modal-form_f\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><uib-tabset><uib-tab heading=\'{{\"SETTINGS_MESS_NEW_OR\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.order_created\"></textarea><br><p><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT3\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT11\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_UP_INV\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_2\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.order_updated\"></textarea><br><p><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT3\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT11\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_CANS_RES\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_3\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.order_cancelled\"></textarea><br><p><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT3\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_UPD_BAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_4\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.customer_debt\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_7\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT7\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_SEND_INV\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.invoice\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_10\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_REMINDER\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_8\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.reminder\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_11\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_APPROVAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_8\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.order_approval\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_12\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_BIRTHDAY\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.birthday\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_13\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_ONLINE_APPROVAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.online_approval\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_14\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT11\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_ONLINE_DECLINE\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.online_decline\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_15\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT11\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_CUSTOMER_UPDATE_ONLINE\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.customer_update_online\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_16\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT11\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_CUSTOMER_ONLINE_CANCELED\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.customer_online_canceled\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT9\" | translate}}<br>{{\"SETTINGS_MESS_TXT10\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT11\" | translate}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_DIGITAL_FORM\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.digital_form\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_18\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_DIGITAL_DOCUMENTS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.digital_documents\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_19\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_PAY_BY_LINK\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.pay_by_link\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_PREPAID\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.prepaid\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_PUBLIC_LINK\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.public_link\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_WAITING_SMS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.waiting_sms\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT8\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_GIFT_CARD_SMS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.gift_card_sms\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br>{{\"SETTINGS_MESS_TXT8\" | translate}}<br></p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_REQUEST_CARD\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.request_card\"></textarea><br><p><label>{{\"SETTINGS_MESS_ENTER_17\" | translate}}</label><br>{{\"SETTINGS_MESS_TXT2\" | translate}}<br>{{\"SETTINGS_MESS_TXT6\" | translate}}<br></p></div></div></div></uib-tab></uib-tabset><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_DOC_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid || infoForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_DOC_SEND\" | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/modules/settings/online/settings.online.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_ONLINE_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"import-multifile\">{{\"SETTINGS_PICTURE_BACKGROUND\" | translate}}<div class=\"import-multifile-inner\"><label><input style=\"visibility: hidden\" type=\"file\" name=\"background\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background + \')\'}\"></div><img ng-if=\"!ctrl.form.background\" src=\"/assets/images/empty_image.png\"> <span class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background\')\"><i class=\"las la-trash-alt\"></i></span></label> <label><input style=\"visibility: hidden\" type=\"file\" name=\"background1\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background1\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background1 + \')\'}\"></div><img ng-if=\"!ctrl.form.background1\" src=\"/assets/images/empty_image.png\"> <span ng-if=\"ctrl.form.background1\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background1\')\"><i class=\"las la-trash-alt\"></i></span></label> <label><input style=\"visibility: hidden\" type=\"file\" name=\"background2\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background2\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background2 + \')\'}\"></div><img ng-if=\"!ctrl.form.background2\" src=\"/assets/images/empty_image.png\"> <span ng-if=\"ctrl.form.background2\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background2\')\"><i class=\"las la-trash-alt\"></i></span></label> <label><input style=\"visibility: hidden\" type=\"file\" name=\"background3\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background3\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background3 + \')\'}\"></div><img ng-if=\"!ctrl.form.background3\" src=\"/assets/images/empty_image.png\"> <span ng-if=\"ctrl.form.background3\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background3\')\"><i class=\"las la-trash-alt\"></i></span></label></div></div></div><div class=\"col-md-2 col-xs-12\"><label class=\"import-file\">{{\"SETTINGS_PICTURE_LOGO\" | translate}} <input style=\"visibility: hidden\" type=\"file\" name=\"online_logo\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.online_logo + \')\'}\"></div><span class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'online_logo\')\"><i class=\"las la-trash-alt\"></i></span></label></div><div class=\"col-md-2 col-xs-12\"><label class=\"import-file\">{{\"SETTINGS_PICTURE_ICON\" | translate}} <input style=\"visibility: hidden\" type=\"file\" name=\"icon\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.icon + \')\'}\"></div><span class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'icon\')\"><i class=\"las la-trash-alt\"></i></span></label></div></div><div class=\"line-sep\"></div><div class=\"flex form v-start\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_BUSS_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.name.$error\" class=\"ng-messages\" ng-show=\"infoForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_WAZE_ADDRESS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_STATUS\" | translate}}</label><select class=\"form-control\" name=\"status\" ng-model=\"ctrl.form.status\"><option value=\"pending\">{{\"SETTINGS_ONLINE_STATUS_PENDING\" | translate}}</option><option value=\"open\">{{\"SETTINGS_ONLINE_STATUS_OPEN\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ALLOW_ONLINE_BOOKING\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.allow_online_booking\"><option value=\"0\">{{\"SETTINGS_ALLOW_ONLINE_BOOKING_NO\" | translate}}</option><option value=\"1\">{{\"SETTINGS_ALLOW_ONLINE_BOOKING_FOR_EXISTING_CUST\" | translate}}</option><option value=\"2\">{{\"SETTINGS_ALLOW_ONLINE_BOOKING_FOR_ALL_CUST\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_ALLOW_NEW\" | translate}}</label><select class=\"form-control\" name=\"allow_new\" ng-model=\"ctrl.form.allow_new\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_WAITING_LIST\" | translate}}</label><select class=\"form-control\" name=\"waiting_list\" ng-model=\"ctrl.form.waiting_list\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_DISPLAY_PRICE\" | translate}}</label><select class=\"form-control\" name=\"display_price\" ng-model=\"ctrl.form.display_price\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_DISPLAY_DURATION\" | translate}}</label><select class=\"form-control\" name=\"display_duration\" ng-model=\"ctrl.form.display_duration\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_DISABLE_CONFIRMATION_CODE\" | translate}}</label><select class=\"form-control\" name=\"disable_confirmation_code\" ng-model=\"ctrl.form.disable_confirmation_code\" ng-change=\"ctrl.handleDisableCode()\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_CONFIRMATION_CODE\" | translate}}</label><select class=\"form-control\" name=\"confirmation_code\" ng-model=\"ctrl.form.confirmation_code\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_SELECT_RESOURCE\" | translate}}</label><select class=\"form-control\" name=\"resource\" ng-model=\"ctrl.form.resource\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_DISPLAY_CATEGORY\" | translate}}</label><select class=\"form-control\" name=\"display_category\" ng-model=\"ctrl.form.display_category\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_DISPLAY_EARLIEST\" | translate}}</label><select class=\"form-control\" name=\"display_earliest\" ng-model=\"ctrl.form.display_earliest\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ALLOW_MULTI\" | translate}}</label><select class=\"form-control\" name=\"allow_multi\" ng-model=\"ctrl.form.allow_multi\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ALLOW_FIRST_AVAILABLE\" | translate}}</label><select class=\"form-control\" name=\"allow_first_available\" ng-model=\"ctrl.form.allow_first_available\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select last\"><label>{{\"SETTINGS_ONLINE_AVAILABLE_HOURS\" | translate}}</label><select class=\"form-control\" name=\"available_hours\" ng-model=\"ctrl.form.available_hours\"><option value=\"calendar\">{{\"SETTINGS_ONLINE_CALENDAR_INTERVAL\" | translate}}</option><option value=\"item\">{{\"SETTINGS_ONLINE_ITEM_DURATION\" | translate}}</option><option value=\"calendar_order\">{{\"SETTINGS_ONLINE_CALENDAR_ORDER_INTERVAL\" | translate}}</option><option value=\"item_order\">{{\"SETTINGS_ONLINE_ITEM_ORDER_DURATION\" | translate}}</option></select></div><i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'calendar\'\">{{\"SETTINGS_ONLINE_CALENDAR_INTERVAL_TOOLTIP\" | translate}}</i> <i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'item\'\">{{\"SETTINGS_ONLINE_ITEM_DURATION_TOOLTIP\" | translate}}</i> <i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'calendar_order\'\">{{\"SETTINGS_ONLINE_CALENDAR_ORDER_INTERVAL_TOOLTIP\" | translate}}</i> <i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'item_order\'\">{{\"SETTINGS_ONLINE_ITEM_ORDER_DURATION_TOOLTIP\" | translate}}</i><div class=\"mt-24\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_INTERVAL\" | translate}}</label><select class=\"form-control\" name=\"interval\" ng-model=\"ctrl.form.interval\"><option value=\"15\">{{\"SETTINGS_INFO_MIN15\" | translate}}</option><option value=\"20\">{{\"SETTINGS_INFO_MIN20\" | translate}}</option><option value=\"30\">{{\"SETTINGS_INFO_MIN30\" | translate}}</option><option value=\"45\">{{\"SETTINGS_INFO_MIN45\" | translate}}</option><option value=\"60\">{{\"SETTINGS_INFO_MIN60\" | translate}}</option><option value=\"75\">{{\"SETTINGS_INFO_MIN75\" | translate}}</option><option value=\"90\">{{\"SETTINGS_INFO_MIN90\" | translate}}</option><option value=\"105\">{{\"SETTINGS_INFO_MIN105\" | translate}}</option><option value=\"120\">{{\"SETTINGS_INFO_MIN120\" | translate}}</option><option value=\"135\">{{\"SETTINGS_INFO_MIN135\" | translate}}</option><option value=\"150\">{{\"SETTINGS_INFO_MIN150\" | translate}}</option><option value=\"165\">{{\"SETTINGS_INFO_MIN165\" | translate}}</option><option value=\"180\">{{\"SETTINGS_INFO_MIN180\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_PHONE_CALL\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.phone\" name=\"phone\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"SETTINGS_ONLINE_ALIAS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.alias\" ng-change=\"ctrl.onAliasChange()\" name=\"alias\" class=\"form-control\" ng-class=\"{\'form-control-error\': ctrl.aliasStatus == \'symbols\' || ctrl.aliasStatus == \'taken\' || ctrl.aliasStatus == \'length\'}\"><div ng-show=\"ctrl.aliasStatus == \'loading\'\" class=\"input-loader\"><i class=\"las la-spinner\"></i></div></div><i class=\"input-hint\" ng-class=\"{\'visible error\': ctrl.aliasStatus == \'symbols\' || ctrl.aliasStatus == \'taken\' || ctrl.aliasStatus == \'length\'}\"><span ng-if=\"ctrl.aliasStatus == \'pending\' || ctrl.aliasStatus == \'loading\' || ctrl.aliasStatus == \'success\'\">&nbsp;</span> <span ng-if=\"ctrl.aliasStatus == \'symbols\'\">{{\"SETTINGS_ONLINE_ALIAS_SYMBOLS\" | translate}}</span> <span ng-if=\"ctrl.aliasStatus == \'taken\'\">{{\"SETTINGS_ONLINE_ALIAS_TAKEN\" | translate}}</span> <span ng-if=\"ctrl.aliasStatus == \'length\'\">{{\"SETTINGS_ONLINE_ALIAS_LENGTH\" | translate}}</span></i></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"SETTINGS_ONLINE_BOOKING_LINK\" | translate}}</label> <a href=\"javascript:;\" ng-click=\"ctrl.copyLink()\" class=\"copy-icon\"><i class=\"las la-copy\"></i></a> <input type=\"text\" value=\"{{ ctrl.uniqueBusinessBookingURL() }}\" class=\"form-control\" readonly=\"\"></div><i class=\"input-hint success\" ng-class=\"{\'visible\': ctrl.copied}\">{{\"SETTINGS_ONLINE_URL_COPIED\" | translate}}</i></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_FACEBOOK\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.facebook\" name=\"facebook\" class=\"form-control\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_INSTAGRAM\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.instagram\" name=\"instagram\" class=\"form-control\"></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_ABOUT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.about\" name=\"about\" class=\"form-control\" style=\"min-height: 110px;\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_LINKEDIN\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.linkedin\" name=\"linkedin\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_TWITTER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.twitter\" name=\"twitter\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_BACKGROUND_PICTURE\" | translate}}</label><select class=\"form-control\" name=\"type\" ng-model=\"ctrl.form.background_picture\" ng-change=\"ctrl.checkDefaultBack()\"><option value=\"men\">{{\"SETTINGS_BACKGROUND_MEN\" | translate}}</option><option value=\"women\">{{\"SETTINGS_BACKGROUND_WOMEN\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-color\"><label>{{\"SETTINGS_ONLINE_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.online_color\" name=\"online_color\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-color\"><label>{{\"SETTINGS_ONLINE_TEXT_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.online_text_color\" name=\"online_text_color\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_ALLOW_UPDATE\" | translate}}</label><select class=\"form-control\" name=\"allow_update\" ng-model=\"ctrl.form.allow_update\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_UPDATE_HOURS\" | translate}}</label><select class=\"form-control\" name=\"update_hours\" ng-model=\"ctrl.form.update_hours\"><option value=\"0\">{{\"SETTINGS_ONLINE_0_HOURS\" | translate}}</option><option value=\"1h\">{{\"SETTINGS_ONLINE_1_HOURS\" | translate}}</option><option value=\"2h\">{{\"SETTINGS_ONLINE_2_HOURS\" | translate}}</option><option value=\"4h\">{{\"SETTINGS_ONLINE_4_HOURS\" | translate}}</option><option value=\"8h\">{{\"SETTINGS_ONLINE_8_HOURS\" | translate}}</option><option value=\"1d\">{{\"SETTINGS_ONLINE_1_DAYS\" | translate}}</option><option value=\"2d\">{{\"SETTINGS_ONLINE_2_DAYS\" | translate}}</option><option value=\"7d\">{{\"SETTINGS_ONLINE_7_DAYS\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_ALLOW_CANCEL\" | translate}}</label><select class=\"form-control\" name=\"allow_cancel\" ng-model=\"ctrl.form.allow_cancel\"><option value=\"0\">{{\"OPTION_NO\" | translate}}</option><option value=\"1\">{{\"OPTION_YES\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_CANCEL_HOURS\" | translate}}</label><select class=\"form-control\" name=\"cancel_hours\" ng-model=\"ctrl.form.cancel_hours\"><option value=\"0\">{{\"SETTINGS_ONLINE_0_HOURS\" | translate}}</option><option value=\"1h\">{{\"SETTINGS_ONLINE_1_HOURS\" | translate}}</option><option value=\"2h\">{{\"SETTINGS_ONLINE_2_HOURS\" | translate}}</option><option value=\"4h\">{{\"SETTINGS_ONLINE_4_HOURS\" | translate}}</option><option value=\"8h\">{{\"SETTINGS_ONLINE_8_HOURS\" | translate}}</option><option value=\"1d\">{{\"SETTINGS_ONLINE_1_DAYS\" | translate}}</option><option value=\"2d\">{{\"SETTINGS_ONLINE_2_DAYS\" | translate}}</option><option value=\"7d\">{{\"SETTINGS_ONLINE_7_DAYS\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ONLINE_CLOSEST_TIME\" | translate}}</label><select class=\"form-control\" name=\"closest_time\" ng-model=\"ctrl.form.closest_time\"><option value=\"0\">{{\"SETTINGS_ONLINE_0_CLOSEST_TIME\" | translate}}</option><option value=\"1\">{{\"SETTINGS_ONLINE_1_CLOSEST_TIME\" | translate}}</option><option value=\"2\">{{\"SETTINGS_ONLINE_2_CLOSEST_TIME\" | translate}}</option><option value=\"4\">{{\"SETTINGS_ONLINE_4_CLOSEST_TIME\" | translate}}</option><option value=\"8\">{{\"SETTINGS_ONLINE_8_CLOSEST_TIME\" | translate}}</option><option value=\"12\">{{\"SETTINGS_ONLINE_12_CLOSEST_TIME\" | translate}}</option><option value=\"24\">{{\"SETTINGS_ONLINE_24_CLOSEST_TIME\" | translate}}</option><option value=\"DAY\">{{\"SETTINGS_ONLINE_DAY_CLOSEST_TIME\" | translate}}</option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_LATEST_TIME\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.latest_time\" name=\"latest_time\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_FACEBOOK_PIXEL\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.facebook_pixel\" name=\"facebook_pixel\" class=\"form-control\"></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/photos_stock/photos_stock.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_PHOTOS_STOCK\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><label class=\"btn text primary\"><i class=\"las la-upload\"></i> {{\"SETTINGS_PHOTOS_STOCK_ADD_FILE\" | translate}} <input style=\"display: none\" type=\"file\" accept=\"image/*\" multiple=\"\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"photosstock_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_PHOTOS_STOCK_IMG\" | translate}}</th><th>{{\"SETTINGS_PHOTOS_STOCK_NAME\" | translate}}</th><th>{{\"SETTINGS_PHOTOS_STOCK_CREATED_AT\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><div class=\"stock-pic-wrapper no-margin\"><img ng-src=\"{{row.url}}\" alt=\"{{row.name}}\"></div></td><td><span>{{row.name}}</span></td><td><span>{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td><span class=\"btn icon small bordered red\" ng-click=\"ctrl.deletePhoto(row.id)\"><i class=\"las la-trash\"></i></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/laser_file/settings.laser_file.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_LASER_INFO_TITLE\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><div class=\"btn-group large\"><button ng-repeat=\"category in ctrl.laser_categories\" class=\"btn\" ng-click=\"ctrl.change_category(category.id);\" ng-class=\"{\'btn-primary\': ctrl.category == category.id, \'btn-default\': ctrl.category != category.id}\">{{category.name | translate}}</button></div><button class=\"btn text primary large\" ng-click=\"ctrl.new_field();\"><i class=\"las la-plus\"></i> {{\"SETTINGS_LASER_NEW_FIELD\" | translate}}</button></div></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\" ui-sortable=\"sortableOptions\" ng-model=\"ctrl.form\"><div ng-repeat=\"field in ctrl.form\" class=\"laser-field\" ng-show=\"field.category_id == ctrl.category\"><i class=\"drag-handle las la-braille\"></i><div class=\"form-check form-group last\"><label for=\"{{field.id}}\"><input type=\"checkbox\" id=\"{{field.id}}\" ng-model=\"field.active\"> <b>{{field.name}}</b></label></div><div class=\"flex gap-8 laser-list-setup\"><a ng-if=\"field.type==\'list\'\" class=\"btn text primary\" ng-click=\"ctrl.setup_list(field);\">{{\"SETTINGS_LASER_SETUP_LIST\" | translate}}</a> <a class=\"btn icon bordered primary\" ng-click=\"ctrl.new_field(field);\"><span class=\"las la-edit\"></span></a></div></div></div></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/modules/workers/popup/workers.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\" ng-if=\"isUserAllowedAccess(\'workers\')\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_SELECT_W\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><table ng-if=\"ctrl.workers && ctrl.workers.length>0\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example workers-table\"><thead><tr><th class=\"customer-name\">{{\"CUSTOMERS_NAME\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectCustomer($index)\" ng-repeat=\"row in ctrl.workers\"><td class=\"customer-name with-pic\">{{row.emp_firstname}} {{row.emp_lastname}}</td><td></td></tr></tbody></table></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/admin/modules/business-copy/business.copy.html","<div class=\"modal-form-inner\" id=\"settings-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADMIN_ADD_BUSINESS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"businessForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"ADMIN_BUSINESS_TYPE\" | translate}}</label><select class=\"form-control\" name=\"variant\" required=\"\" ng-model=\"ctrl.form.variant\"><option value=\"\">{{\"ADMIN_BUSINESS_TYPE\" | translate}}</option><option ng-repeat=\"(id, variant) in ctrl.variants\" value=\"{{id}}\">{{variant | translate}}</option></select></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_BUSINESS_NAME\" | translate}}</label> <input type=\"text\" name=\"name\" required=\"\" ng-minlength=\"5\" ng-model=\"ctrl.form.name\" placeholder=\"Business Name\" class=\"form-control\"><div ng-messages=\"businessForm.name.$error\" class=\"ng-messages\" ng-show=\"businessForm.name.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_EMAIL\" | translate}}</label> <input type=\"email\" name=\"email\" required=\"\" ng-model=\"ctrl.form.email\" placeholder=\"email@example.com\" class=\"form-control\"><div ng-messages=\"businessForm.email.$error\" class=\"ng-messages\" ng-show=\"businessForm.email.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div><div ng-message=\"email\">{{\"SETTINGS_USER_VALID_MAIL\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_USER_PERSON_NAME\" | translate}}</label> <input type=\"text\" ng-minlength=\"3\" required=\"\" name=\"personname\" ng-model=\"ctrl.form.user_name\" placeholder=\"User Name\" class=\"form-control\"><div ng-messages=\"businessForm.personname.$error\" class=\"ng-messages\" ng-show=\"businessForm.personname.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_3_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PASSWORD\" | translate}}</label> <input type=\"text\" ng-minlength=\"5\" required=\"\" name=\"password\" ng-model=\"ctrl.form.password\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.password.$error\" class=\"ng-messages\" ng-show=\"businessForm.password.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/business-form/business.form.html","<div class=\"modal-form-inner tabs-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!ctrl.hideUser\">{{\"ADMIN_ADD_BUSINESS\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"ctrl.hideUser\">{{\"ADMIN_EDIT_BUSINESS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"businessForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex top fill gap-16\"><div><div class=\"flex fill gap-16\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"ADMIN_BUSINESS_TYPE\" | translate}}</label><select class=\"form-control\" name=\"variant\" required=\"\" ng-model=\"ctrl.form.variant\"><option ng-repeat=\"(id, variant) in ctrl.variants\" value=\"{{id}}\">{{variant | translate}}</option></select></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_BUSINESS_NAME\" | translate}}</label> <input type=\"text\" name=\"name\" required=\"\" ng-minlength=\"5\" ng-model=\"ctrl.form.name\" class=\"form-control\"><div ng-messages=\"businessForm.name.$error\" class=\"ng-messages\" ng-show=\"businessForm.name.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_CONTACT_PERSON\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.agent\" ng-minlength=\"5\" required=\"\" name=\"agent\" placeholder=\"John Smith\" class=\"form-control\"><div ng-messages=\"businessForm.agent.$error\" class=\"ng-messages\" ng-show=\"businessForm.agent.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PHONE\" | translate}}</label> <input type=\"tel\" name=\"phone\" required=\"\" ng-model=\"ctrl.form.phone\" placeholder=\"0534231367\" class=\"form-control\"><div ng-messages=\"businessForm.phone.$error\" class=\"ng-messages\" ng-show=\"businessForm.phone.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_ADDRESS\" | translate}}</label> <input type=\"text\" name=\"address\" required=\"\" ng-model=\"ctrl.form.address\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.address.$error\" class=\"ng-messages\" ng-show=\"businessForm.address.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_CITY\" | translate}}</label> <input type=\"text\" name=\"city\" required=\"\" ng-model=\"ctrl.form.city\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.city.$error\" class=\"ng-messages\" ng-show=\"businessForm.city.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_HOME_NUMBER\" | translate}}</label> <input type=\"text\" name=\"home_number\" required=\"\" ng-model=\"ctrl.form.home_number\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.home_number.$error\" class=\"ng-messages\" ng-show=\"businessForm.home_number.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_POST_CODE\" | translate}}</label> <input type=\"text\" name=\"zip\" required=\"\" ng-model=\"ctrl.form.zip\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.zip.$error\" class=\"ng-messages\" ng-show=\"businessForm.zip.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_COMPANY_ID\" | translate}}</label> <input type=\"text\" name=\"company_id\" required=\"\" ng-minlength=\"3\" ng-model=\"ctrl.form.company_id\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.company_id.$error\" class=\"ng-messages\" ng-show=\"businessForm.company_id.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_3_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label>{{\"ADMIN_COURSES\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.courses\" type=\"radio\" name=\"courses\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.courses\" type=\"radio\" name=\"courses\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span>{{\"DEALER_TYPE\" | translate}}</label><select class=\"form-control\" name=\"type\" required=\"\" ng-model=\"ctrl.form.dealer_type\"><option value=\"licensed\">{{\"BUSINESS_TYPE_LICENSED\" | translate}}</option><option value=\"exempt\">{{\"BUSINESS_TYPE_EXTEMPT\" | translate}}</option></select><div ng-messages=\"businessForm.dealer_type.$error\" class=\"ng-messages\" ng-show=\"businessForm.dealer_type.$dirty\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_ZERO_VAT\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.zero_vat\" type=\"radio\" name=\"zero_vat\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.zero_vat\" type=\"radio\" name=\"zero_vat\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_WA_INSTANCE\" | translate}}</label> <input type=\"text\" name=\"wa_instance\" ng-model=\"ctrl.form.wa_instance\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"ADMIN_WA_TOKEN\" | translate}}</label> <input type=\"text\" name=\"wa_token\" ng-model=\"ctrl.form.wa_token\" class=\"form-control\"></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_DEDUCTIONS_FILE\" | translate}}</label> <input type=\"text\" name=\"deductions_file\" ng-minlength=\"3\" ng-model=\"ctrl.form.deductions_file\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.deductions_file.$error\" class=\"ng-messages\" ng-show=\"businessForm.deductions_file.$dirty\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group form-select\"><label>{{\"ADMIN_CREDIT_COMPANY\" | translate}}</label><select class=\"form-control\" name=\"status\" ng-model=\"ctrl.form.cerdit_company\"><option value=\"{{ $index }}\" ng-repeat=\"comp in credit_comp\">{{comp | translate}}</option></select></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_TRANZILA\" | translate}}</label> <input type=\"text\" name=\"credit_suplier\" ng-minlength=\"3\" ng-model=\"ctrl.form.credit_suplier\" placeholder=\"...\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"ADMIN_KEY\" | translate}}</label> <input type=\"text\" name=\"credit_yaad_key\" ng-minlength=\"3\" ng-model=\"ctrl.form.credit_yaad_key\" placeholder=\"...\" class=\"form-control\"></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_CASHBOX\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.cashbox\" type=\"radio\" name=\"cashbox\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.cashbox\" type=\"radio\" name=\"cashbox\" value=\"0\"> <label>N</label></div></div><div class=\"form-group form-select\"><label>{{\"ADMIN_BUSINESS_STATUS\" | translate}}</label><select class=\"form-control\" name=\"status\" ng-model=\"ctrl.form.status\"><option value=\"{{ $index }}\" ng-repeat=\"bis_status in bis_statuses\">{{bis_status | translate}}</option></select></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_CREDIT_CARD\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.credit_card\" type=\"radio\" name=\"credit_card\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.credit_card\" type=\"radio\" name=\"credit_card\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_PAID_LINK\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.paid_link\" type=\"radio\" name=\"paid_link\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.paid_link\" type=\"radio\" name=\"paid_link\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_SECOND_RESOURCE\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.second_resource\" type=\"radio\" name=\"second_resource\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.second_resource\" type=\"radio\" name=\"second_resource\" value=\"0\"> <label>N</label></div></div><div class=\"form-group last\"><label>{{\"ADMIN_SECOND_RESOURCE_NAME\" | translate}}</label> <input type=\"text\" name=\"second_resource_name\" ng-required=\"second_resource*1==1\" ng-model=\"ctrl.form.second_resource_name\" placeholder=\'{{\"ADMIN_SECOND_RESOURCE_NAME\" | translate}}\' class=\"form-control\"></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_ENABLED_RETAINERS\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.enabled_retainers\" type=\"radio\" name=\"enabled_retainers\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.enabled_retainers\" type=\"radio\" name=\"enabled_retainers\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"EMV_TERMINAL_ID\" | translate}}</label> <input type=\"text\" name=\"emv_terminal_id\" ng-model=\"ctrl.form.emv_terminal_id\" placeholder=\"emv_terminal_id\" class=\"form-control\"></div><div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ZCREDIT_KEY\" | translate}}</label> <input type=\"text\" name=\"zcredit_key\" ng-model=\"ctrl.form.zcredit_key\" placeholder=\"zcredit_key\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"ZCREDIT_CREDIT_DEAL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.z_credit_credit_deal\" type=\"radio\" name=\"z_credit_credit_deal\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.z_credit_credit_deal\" type=\"radio\" name=\"z_credit_credit_deal\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"CALL_TOKEN\" | translate}}</label> <input type=\"text\" name=\"call_token\" ng-model=\"ctrl.form.call_token\" placeholder=\"call_token\" class=\"form-control\"></div><div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span>{{\"ADMIN_LANGUAGE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.language_code\" required=\"\"><option value=\"hb_ISR\">{{\"SETTINGS_INFO_HB_ISR_LANG\" | translate}}</option><option value=\"en_US\">{{\"SETTINGS_INFO_EN_US_LANG\" | translate}}</option><option value=\"ru_RU\">{{\"SETTINGS_INFO_RU_RU_LANG\" | translate}}</option><option value=\"ar_AR\">{{\"SETTINGS_INFO_AR_AR_LANG\" | translate}}</option></select></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_EMAIL\" | translate}}</label> <input type=\"email\" name=\"email\" required=\"\" ng-model=\"ctrl.form.email\" placeholder=\"email@example.com\" class=\"form-control\"><div ng-messages=\"businessForm.email.$error\" class=\"ng-messages\" ng-show=\"businessForm.email.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div><div ng-message=\"email\">{{\"SETTINGS_USER_VALID_MAIL\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\" ng-if=\"!ctrl.hideUser\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_USER_PERSON_NAME\" | translate}}</label> <input type=\"text\" ng-minlength=\"5\" name=\"personname\" ng-model=\"ctrl.form.user_name\" placeholder=\"NikolaTesla\" class=\"form-control\"><div ng-messages=\"businessForm.personname.$error\" class=\"ng-messages\" ng-show=\"businessForm.personname.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PASSWORD\" | translate}}</label> <input type=\"text\" ng-minlength=\"5\" name=\"password\" ng-model=\"ctrl.form.password\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.password.$error\" class=\"ng-messages\" ng-show=\"businessForm.password.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div><div class=\"form-group\"><label>{{\"ADMIN_CUSTOMERS\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event)\" ng-model=\"ctrl.form.customers\" name=\"customer_file\"></div><div class=\"form-group\"><label>{{\"ADMIN_ORDERS\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event, \'orders\')\" ng-model=\"ctrl.form.orders\" name=\"orders_file\"></div><div class=\"form-group\"><label>{{\"ADMIN_CUSTOMER_NOTES\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event, \'customer_notes\')\" ng-model=\"ctrl.form.customer_notes\" name=\"notes_file\"></div><div class=\"form-group\"><label>{{\"ADMIN_IMPORT_CRM\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event, \'crm\')\" ng-model=\"ctrl.form.crm\" name=\"crm\"></div></div></div></div><div><div class=\"form-group\"><label>{{\"ADMIN_AI_ASSISTANT\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.ai_assistant\" type=\"radio\" name=\"ai_assistant\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.ai_assistant\" type=\"radio\" name=\"ai_assistant\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_ONLINE_PAYMENTS_TTL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.online_payments\" type=\"radio\" name=\"online_payments\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.online_payments\" type=\"radio\" name=\"online_payments\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_CARD_READER_TTL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.card_reader\" type=\"radio\" name=\"card_reader\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.card_reader\" type=\"radio\" name=\"card_reader\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_BUSINESS_SMS_SENDER_TITLE\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.sms_own_sign\" type=\"radio\" name=\"sms_own_sign\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.sms_own_sign\" type=\"radio\" name=\"sms_own_sign\" value=\"0\"> <label>N</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix form-select\"><label>{{\"SETTINGS_USER_SELF_ORDER\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.customers_settings.self_order.value\" ng-required=\"ctrl.form.customers_settings.self_order.update_all\" ng-disabled=\"!ctrl.form.customers_settings.self_order.update_all\"><option value=\"true\">{{\"SETTINGS_USER_SELF_ORDER_YES\" | translate}}</option><option value=\"false\">{{\"SETTINGS_USER_SELF_ORDER_NO\" | translate}}</option></select></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.self_order.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix form-select\"><label>{{\"SETTINGS_USER_RESOURCE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.customers_settings.resource.value\" ng-required=\"ctrl.form.customers_settings.resource.update_all\" ng-disabled=\"!ctrl.form.customers_settings.resource.update_all\"><option value=\"{{ resource.id }}\" ng-repeat=\"resource in ctrl.resources\">{{resource.name | translate}}</option></select></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.resource.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix form-select\"><label>{{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.customers_settings.send_notifications.value\" ng-required=\"ctrl.form.customers_settings.send_notifications.update_all\" ng-disabled=\"!ctrl.form.customers_settings.send_notifications.update_all\"><option value=\"{{ notification_channel.value }}\" ng-repeat=\"notification_channel in ctrl.businessControls.customers_notifications_channels\">{{notification_channel.name | translate}}</option></select></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.send_notifications.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix form-select\"><label>{{\"SETTINGS_USER_SEND_REMINDER\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.customers_settings.send_reminder.value\" ng-required=\"ctrl.form.customers_settings.send_reminder.update_all\" ng-disabled=\"!ctrl.form.customers_settings.send_reminder.update_all\"><option value=\"{{ reminder_send_time.value }}\" ng-repeat=\"reminder_send_time in ctrl.businessControls.reminder_send_times\">{{reminder_send_time.name | translate}}</option></select></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.send_reminder.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix form-select\"><label>{{\"CUSTOMERS_SEND_REMINDER\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.customers_settings.reminder_send_type.value\" ng-required=\"ctrl.form.customers_settings.reminder_send_type.update_all\" ng-disabled=\"!ctrl.form.customers_settings.reminder_send_type.update_all\"><option value=\"{{ notification_channel.value }}\" ng-repeat=\"notification_channel in ctrl.businessControls.customers_notifications_channels\">{{notification_channel.name | translate}}</option></select></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.reminder_send_type.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix form-select\"><label>{{\"SETTINGS_DEFAULT_INV_LINK_MESSAGE_CHANNEL\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.customers_settings.send_documents.value\" ng-required=\"ctrl.form.customers_settings.send_documents.update_all\" ng-disabled=\"!ctrl.form.customers_settings.send_documents.update_all\"><option value=\"{{ docs_msg_channel.index }}\" ng-repeat=\"docs_msg_channel in ctrl.businessControls.businesses_msg_channels\">{{docs_msg_channel.name | translate}}</option></select></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.send_documents.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><label>{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"1\" ng-model=\"ctrl.form.customers_settings.request_order_confirmation.value\" ng-required=\"ctrl.form.customers_settings.request_order_confirmation.update_all\" ng-disabled=\"!ctrl.form.customers_settings.request_order_confirmation.update_all\"> <label>Y</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"0\" ng-model=\"ctrl.form.customers_settings.request_order_confirmation.value\" ng-required=\"ctrl.form.customers_settings.request_order_confirmation.update_all\" ng-disabled=\"!ctrl.form.customers_settings.request_order_confirmation.update_all\"> <label>N</label></div></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.request_order_confirmation.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button><button type=\"submit\" class=\"btn text primary large\" ng-click=\"businessForm.$valid?$close():\'\'\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/business-single/business.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div id=\"loading_count\"><div>Imported: <span id=\"l_imported\"></span></div><div>Total: <span id=\"l_total\"></span></div></div><div class=\"{{wrapperClasses}} single-model-page\" id=\"business\" ng-if=\"userRole && ctrl.business != null\"><div class=\"row-fluid clearfix\"><div class=\"cloud col-xs-12 single-model-details border-top border-bottom border-right border-left\"><div class=\"single-model-head\"><div class=\"flex gap-24 gap-24-m-8\"><h3 class=\"main-title single-model-name\">{{ctrl.business.name}}</h3><button class=\"btn text primary large\" ui-sref=\"app.admin.single-business.edit({id: {{ctrl.businessId}}})\"><i class=\"fa fa-pencil\"></i> {{\"CUSTOMERS_EDIT\" | translate}}</button> <button class=\"btn text primary large\" ng-click=\"ctrl.createNewUser()\"><i class=\"fa fa-plus\"></i> {{\"SETTINGS_USER_NEW\" | translate}}</button></div></div><div class=\"single-model-info\"><div class=\"col-md-6 collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_GENERAL\" | translate}}</h4><dl><dt>{{\"ADMIN_BUSINESS_TYPE\" | translate}}</dt><dd>{{ctrl.variants[ctrl.business.variant] | translate | emptyValue}}</dd><dt>{{\"ADMIN_COMPANY_ID\" | translate}}</dt><dd>{{ctrl.business.company_id | emptyValue}}</dd><dt>{{\"ADMIN_DEDUCTIONS_FILE\" | translate}}</dt><dd>{{ctrl.business.deductions_file | emptyValue}}</dd><dt>{{\"DEALER_TYPE\" | translate}}</dt><dd>{{ctrl.business.dealer_type | emptyValue}}</dd><dt>{{\"ADMIN_ADDRESS\" | translate}}</dt><dd>{{ctrl.business.address | emptyValue}}</dd><dt>{{\"ADMIN_HOME_NUMBER\" | translate}}</dt><dd>{{ctrl.business.home_number | emptyValue}}</dd><dt>{{\"ADMIN_CITY\" | translate}}</dt><dd>{{ctrl.business.city | emptyValue}}</dd><dt>{{\"ADMIN_POST_CODE\" | translate}}</dt><dd>{{ctrl.business.zip | emptyValue}}</dd><dt>{{\"EMV_TERMINAL_ID\" | translate}}</dt><dd>{{ctrl.business.emv_terminal_id | translate}}</dd><dt>{{\"ZCREDIT_KEY\" | translate}}</dt><dd>{{ctrl.business.zcredit_key | translate}}</dd><dt>{{\"CALL_TOKEN\" | translate}}</dt><dd>{{ctrl.business.call_token | translate}}</dd><dt>{{\"ADMIN_LANGUAGE\" | translate}}</dt><dd>{{ctrl.business.language | translate}}</dd><dt>{{\"ADMIN_CASHBOX\" | translate}}</dt><dd>{{ctrl.business.cashbox ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_PAID_LINK\" | translate}}</dt><dd>{{ctrl.business.paid_link ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_CREDIT_CARD\" | translate}}</dt><dd>{{ctrl.business.credit_card ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_AI_ASSISTANT\" | translate}}</dt><dd>{{ctrl.business.ai_assistant ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_ONLINE_PAYMENTS_TTL\" | translate}}</dt><dd>{{ctrl.business.online_payments ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_CARD_READER_TTL\" | translate}}</dt><dd>{{ctrl.business.card_reader ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_ENABLED_RETAINERS\" | translate}}</dt><dd>{{ctrl.business.enabled_retainers ? \'Yes\': \'No\'}}</dd></dl></div><div class=\"col-md-6 collapsed-mobile\"><h4 class=\"info-title\">{{\"ADMIN_CONTACTS\" | translate}}</h4><dl><dt>{{\"ADMIN_CONTACT_PERSON\" | translate}}</dt><dd>{{ctrl.business.agent | emptyValue}}</dd><dt>{{\"ADMIN_PHONE\" | translate}}</dt><dd>{{ctrl.business.phone | emptyValue}}</dd><dt>{{\"ADMIN_EMAIL\" | translate}}</dt><dd>{{ctrl.business.email | emptyValue}}</dd></dl></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers-dd/customers.dd.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">\"{{Customer.firstname}} {{Customer.lastname}}\" {{\"CUSTOMERS_DD_TO\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"documentForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_DOCUMENT\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.document\"><option value=\"\">{{\"CUSTOMERS_DOCUMENT\" | translate}}</option><option ng-repeat=\"document in documents\" value=\"{{document.id}}\">{{document.name}}</option></select><div ng-messages=\"documentForm.message.$error\" class=\"ng-messages\" ng-show=\"documentForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"documentForm.$invalid || documentForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-df/customers.df.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_DF_TO\" | translate}} \"{{Customer.firstname}} {{Customer.lastname}}\"</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"formForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_DIGITAL_FORM\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.form\"><option value=\"\">{{\"CUSTOMERS_FORM\" | translate}}</option><option ng-repeat=\"form in forms\" value=\"{{form.id}}\">{{form.name}}</option></select><div ng-messages=\"formForm.message.$error\" class=\"ng-messages\" ng-show=\"documentForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"documentForm.$invalid || documentForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-form/customers.form.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ng-click=\"$close();\" ng-if=\"isModal\"><i class=\"las la-angle-right rotatable\"></i></a> <a class=\"btn icon default\" ui-sref=\"^.\" ng-if=\"!isModal\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"CUSTOMERS_ADD_NEW\" | translate}}</h3></div></div><form class=\"modal-form\" name=\"customersForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body-m\"><uib-tabset><uib-tab heading=\'{{\"CUSTOMERS_GEN_INFO\" | translate}}\'><div class=\"modal-body\"><div class=\"mb-24\"><div class=\"flex form\"><div class=\"col-md-3 col-xs-12\"><label class=\"import-file\"><input style=\"visibility: hidden; height:0\" type=\"file\" name=\"customer_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\" accept=\"image/*\"><div class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.avatar + \')\'}\"></div></label></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_ADD_CLIENT\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.firstname\" name=\"firstname\" class=\"form-control\" required=\"\"><div ng-messages=\"customersForm.firstname.$error\" class=\"ng-messages\" ng-show=\"customersForm.firstname.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LAST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.lastname\" class=\"form-control\"></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_PHONE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.phone\" placeholder=\"053-423-1367\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LANDLINE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.telephone\" placeholder=\"08-689-0823\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"DEALER_ID\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.dealer_id\" name=\"dealer_id\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-5 col-xs-12\"><div class=\"form-group last\"><label>{{\"CUSTOMERS_BIRTHDAY\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_year\"><option value=\"\">{{\"CUSTOMERS_YEAR\" | translate}}</option><option ng-repeat=\"year in datesProvider.years\" value=\"{{year}}\">{{year}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_month\"><option value=\"\">{{\"CUSTOMERS_MONTH\" | translate}}</option><option ng-repeat=\"(month, monthName) in datesProvider.months\" value=\"{{month+1}}\">{{monthName}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_day\"><option value=\"\">{{\"CUSTOMERS_DAY\" | translate}}</option><option ng-repeat=\"day in datesProvider.days\" value=\"{{day}}\">{{day}}</option></select></div></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"customersForm.email.$error\" class=\"ng-messages\" ng-show=\"customersForm.email.$dirty\"><div ng-message=\"email\">עליך להכניס כתובת דוא\"ל תקינה</div></div></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><div><label>{{\"CUSTOMER_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"></div></div></div></div><div class=\"flex form\"><div class=\"col-md-3 col-xs-6\"><div class=\"form-group form-select\"><label>{{\"CUSTOMERS_STATUS\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.status_id\"><option value=\"\">{{\"CUSTOMERS_STATUS\" | translate}}</option><option ng-repeat=\"status in ctrl.statuses\" value=\"{{status.id}}\">{{status.name}}</option></select></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group form-select\"><label>{{\"CUSTOMERS_INTERESTED\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.interested_id\"><option value=\"\">{{\"CUSTOMERS_INTERESTED\" | translate}}</option><option ng-repeat=\"interested in ctrl.interesteds\" value=\"{{interested.id}}\">{{interested.name}}</option></select></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group form-select\"><label>{{\"CUSTOMERS_RESOURSE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.resource_lead\"><option value=\"\">{{\"CUSTOMERS_RESOURSE\" | translate}}</option><option ng-repeat=\"resource in ctrl.resources\" ng-if=\"resource.sales_active\" value=\"{{resource.id}}\">{{resource.name}}</option></select></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><label>{{\"CUSTOMERS_GENDER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"0\"> <label>{{\"CUSTOMERS_GENDER_MALE\" | translate}}</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"1\"> <label>{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</label></div></div></div><div class=\"col-md-4 col-xs-6\" ng-if=\"ctrl.form.lead == false && ctrl.form.lead_platform\"><button class=\"btn text primary\" ng-click=\"d(); $event.stopPropagation(); ctrl.moveToLeads()\">{{\"CUSTOMERS_MAKE_LEAD\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group last\"><div><label>{{\"CUSTOMERS_NOTES\" | translate}}</label> <textarea ng-model=\"ctrl.form.notes\" placeholder=\'{{\"CUSTOMERS_INFO_ABOUT\" | translate}}\' class=\"customer-notes form-control\"></textarea></div></div></div></div></div></uib-tab><uib-tab heading=\'{{\"CUSTOMERS_ADDR\" | translate}}\'><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_ADDR\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_HOME_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.home_number\" name=\"address\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_MAILBOX\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.mailbox\" name=\"mailbox\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_POST_CODE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.zipcode\" name=\"zipcode\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.city\" name=\"city\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"CUSTOMERS_COUNTRY\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.country\"><option value=\"\">{{\"CUSTOMERS_COUNTRY\" | translate}}</option><option ng-repeat=\"country in countries\" value=\"{{country.code}}\">{{country.name}}</option></select></div></div></div></div></uib-tab><uib-tab ng-if=\"ctrl.customFields.length > 0\" heading=\'{{\"CUSTOMERS_CUSTOM_FIELDS\" | translate}}\'><div class=\"modal-body\"><div class=\"flex form\"><div ng-repeat=\"field in ctrl.customFields\" class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'form-select\': field.type === \'list\'}\"><label>{{field.name}}</label> <input ng-if=\"field.type === \'text\'\" type=\"text\" ng-model=\"ctrl.form.custom_values[field.id]\" class=\"form-control\"><select ng-if=\"field.type === \'list\'\" class=\"form-control\" ng-model=\"ctrl.form.custom_values[field.id]\"><option value=\"\">{{\"CUSTOMERS_CUSTOM_FIELDS_LIST_PLACEHOLDER\" | translate}}</option><option ng-repeat=\"value in field.values\" value=\"{{value.id}}\">{{value.value}}</option></select><input ng-if=\"field.type === \'date\'\" type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.custom_values[field.id]\" view=\"date\" min-view=\"date\" position=\"absolute\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <input ng-if=\"field.type === \'datetime\'\" type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.custom_values[field.id]\" view=\"date\" min-view=\"minutes\" position=\"absolute\" format=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\"></div></div></div></div></uib-tab><uib-tab heading=\'{{\"CUSTOMERS_SETTINGS\" | translate}}\'><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"0\"> <label>{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"1\"> <label>{{\"CUSTOMER_SETTING_EMAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"3\"> <label><span class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{\"CUSTOMERS_WHATSAPP\" | translate}}</label></div></div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_USER_SEND_REMINDER\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"0\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"2\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_2_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"4\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_4_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"24\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_24_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"48\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_48_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"72\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_72_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"168\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_168_HOURS\" | translate}}</label></div></div><div class=\"form-group animate-show-hide\" ng-show=\"ctrl.form.send_reminder != 0\"><label class=\"settings_label\">{{\"CUSTOMERS_SEND_REMINDER\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"reminder_send_type\" ng-model=\"ctrl.form.reminder_send_type\" value=\"1\"> <label>{{\"SETTINGS_USER_MAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"reminder_send_type\" ng-model=\"ctrl.form.reminder_send_type\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"reminder_send_type\" ng-model=\"ctrl.form.reminder_send_type\" value=\"3\"> <label><span class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{\"CUSTOMERS_WHATSAPP\" | translate}}</label></div></div><div class=\"form-group\" ng-if=\"ctrl.bu_type == 1 && ctrl.form.send_reminder != 0\"><label class=\"settings_label\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"0\" ng-model=\"ctrl.form.request_order_confirmation\"> <label>{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"1\" ng-model=\"ctrl.form.request_order_confirmation\"> <label>{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</label></div></div><div class=\"form-group\"><label class=\"settings_label\">{{\"CUSTOMERS_SEND_DOCUMENTS\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" value=\"0\" ng-model=\"ctrl.form.send_documents\"> <label>{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"1\"> <label>{{\"CUSTOMER_SETTING_EMAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"3\"> <label><span class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{\"CUSTOMERS_WHATSAPP\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"4\"> <label>{{\"CUSTOMERS_PRINT\" | translate}}</label></div></div></div><div><div class=\"form-group\"><label class=\"settings_label\">{{\"CUSTOMERS_IND_ORD\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"orders\" ng-model=\"ctrl.form.self_order\" value=\"0\"> <label>{{\"CUSTOMERS_UNAUTHORIZED\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"orders\" ng-model=\"ctrl.form.self_order\" value=\"1\"> <label>{{\"CUSTOMERS_ALLOWED\" | translate}}</label></div></div></div><div><div class=\"form-group\"><label class=\"settings_label\">{{\"CUSTOMERS_GROUP_MESS\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"messages\" ng-model=\"ctrl.form.group_notifications\" value=\"0\"> <label>{{\"CUSTOMERS_OFF\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"messages\" ng-model=\"ctrl.form.group_notifications\" value=\"1\"> <label>{{\"CUSTOMERS_ACTIVE\" | translate}}</label></div></div></div><div class=\"col-md-3 no-padding\"><div class=\"form-group form-select last\"><label class=\"settings_label\">{{\"CUSTOMERS_PREF_RES\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.resource\" ng-disabled=\"!ctrl.resources || ctrl.resources.length == 0\"><option ng-repeat=\"resource in ctrl.resources\" value=\"{{resource.id}}\">{{resource.name}}</option></select></div></div></div></div></div></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\" ng-if=\"!isModal\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\" ng-if=\"isModal\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"customersForm.$invalid || customersForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/business-message/business.message.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADMIN_ADD_BUSINESS_MESSAGE\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"m-t\" name=\"businessMForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"ADMIN_BUSINESS_MESSAGE_TYPE\" | translate}}</label><select class=\"form-control\" name=\"type\" ng-model=\"ctrl.form.type\"><option value=\"info\">{{\"ADMIN_BUSINESS_MESSAGE_TYPE_INFO\" | translate}}</option><option value=\"error\">{{\"ADMIN_BUSINESS_MESSAGE_TYPE_ERROR\" | translate}}</option><option value=\"success\">{{\"ADMIN_BUSINESS_MESSAGE_TYPE_SUCCESS\" | translate}}</option></select></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_BUSINESS_MESSAGE_TEXT\" | translate}}</label> <textarea name=\"text\" ng-model=\"ctrl.form.text\" class=\"form-control\"></textarea></div></div></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn btn-w-m btn-white\">{{\"CUSTOMERS_CANCEL\" | translate}}</button><button type=\"submit\" class=\"btn btn-w-m btn-primary\" ng-click=\"ctrl.submit()\">{{\"CUSTOMERS_SEND\" | translate}}</button></div>");
$templateCache.put("app/modules/customers/modules/customers-public-form/customers.public.form.html","<div class=\"modal-form-inner digital_form_modal\" ng-if=\"business\"><div class=\"modal-head modal-head-online\"><div class=\"background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: contain;\"><div class=\"logo-container\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><h1 class=\"business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"business-address\">{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}</h2></div></div><h1 class=\"digital_form_title\">{{\"CUSTOMER_FORM_TITLE\" | translate}}</h1><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"mb-24\"><div class=\"flex form\"><div class=\"col-md-3 col-xs-12\"><label class=\"import-file\"><input style=\"visibility: hidden; height:0\" type=\"file\" name=\"customer_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\" accept=\"image/*\"><div ng-if=\"ctrl.form.avatar\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.avatar + \')\'}\"></div><div ng-if=\"!ctrl.form.avatar\" class=\"image\" ng-style=\"{\'background-image\':\'url(/assets/images/avatar.jpg)\'}\"></div></label></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_ADD_CLIENT\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.firstname\" name=\"firstname\" class=\"form-control\" required=\"\"><div ng-messages=\"customersForm.firstname.$error\" class=\"ng-messages\" ng-show=\"customersForm.firstname.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LAST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.lastname\" class=\"form-control\"></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_PHONE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.phone\" placeholder=\"053-423-1367\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LANDLINE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.telephone\" placeholder=\"08-689-0823\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"DEALER_ID\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.dealer_id\" name=\"dealer_id\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-5 col-xs-12\"><div class=\"form-group last\"><label>{{\"CUSTOMERS_BIRTHDAY\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_year\"><option value=\"\">{{\"CUSTOMERS_YEAR\" | translate}}</option><option ng-repeat=\"year in datesProvider.years\" value=\"{{year}}\">{{year}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_month\"><option value=\"\">{{\"CUSTOMERS_MONTH\" | translate}}</option><option ng-repeat=\"(month, monthName) in datesProvider.months\" value=\"{{month+1}}\">{{monthName}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_day\"><option value=\"\">{{\"CUSTOMERS_DAY\" | translate}}</option><option ng-repeat=\"day in datesProvider.days\" value=\"{{day}}\">{{day}}</option></select></div></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"customersForm.email.$error\" class=\"ng-messages\" ng-show=\"customersForm.email.$dirty\"><div ng-message=\"email\">עליך להכניס כתובת דוא\"ל תקינה</div></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-6\"><div class=\"form-group\"><label>{{\"CUSTOMERS_GENDER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"0\"> <label>{{\"CUSTOMERS_GENDER_MALE\" | translate}}</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"1\"> <label>{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</label></div></div></div><div class=\"col-md-4 col-xs-6\" ng-if=\"ctrl.form.lead == false && ctrl.form.lead_platform\"><button class=\"btn text primary\" ng-click=\"d(); $event.stopPropagation(); ctrl.moveToLeads()\">{{\"CUSTOMERS_MAKE_LEAD\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_ADDR\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_HOME_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.home_number\" name=\"address\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_MAILBOX\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.mailbox\" name=\"mailbox\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_POST_CODE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.zipcode\" name=\"zipcode\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.city\" name=\"city\" class=\"form-control\"></div></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/customers.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} customer-details-single single-model-page\" id=\"customer\" ng-if=\"isUserAllowedAccess(\'customers\') && customer != null\"><div class=\"row-fluid clearfix\"><div class=\"cloud col-xs-12 col-lg-9 single-model-details border-top border-bottom border-right border-left\"><div class=\"single-model-head\"><div class=\"flex gap-24 gap-24-m-8 nowrap\"><button class=\"btn icon default\" ng-click=\"ctrl.goBackOrNavigate(customer.lead, $event)\"><i class=\"las la-angle-right rotatable\"></i></button><h3 class=\"main-title single-model-name\"><div class=\"customer-pic-wrapper\" ng-if=\"customer.avatar\"><img ng-src=\"{{customer.avatar}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{customer.firstname}} {{customer.lastname}} <span ng-if=\"customer.credit_cards && customer.credit_cards.length > 0\" class=\"btn icon circle green customer-have-credit-card\"><i class=\"las la-credit-card\"></i></span></h3></div><div class=\"btn-socials gap-16\"><a href=\"/cashbox?customer={{customer.id}}\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\" class=\"btn text success large\"><i class=\"las la-hand-holding-usd\"></i> {{\"CUSTOMER_GO_CASHBOX\" | translate}}</a> <a href=\"/calendar/customer/{{customer.id}}\" class=\"btn text purple large\"><i class=\"las la-calendar\"></i> {{\"CUSTOMER_GO_CALENDAR\" | translate}}</a> <button type=\"button\" ng-click=\"ctrl.request_review(customer.id, \'facebook\');\" ng-if=\"ctrl.business.facebook_review && !customer.facebook_review_request\" class=\"btn text transparent large\"><i class=\"lab la-facebook\"></i> {{\"REQUEST_FACEBOOK_REVIEW\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.request_review(customer.id, \'google\');\" ng-if=\"ctrl.business.google_review && !customer.google_review_request\" class=\"btn text transparent large\"><i class=\"lab la-google\"></i> {{\"REQUEST_GOOGLE_REVIEW\" | translate}}</button></div><div class=\"btn-actions\"><button tooltip=\'{{\"CUSTOMER_GO_QUOTATION\" | translate}}\' ng-click=\"ctrl.go_quotation()\" class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><i class=\"las la-file-invoice-dollar\"></i></button> <button tooltip=\'{{\"SEND_PUBLIC_LINK\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"(customer.phone != \'\' || customer.telephone != \'\')\" ng-click=\"ctrl.social_link(customer.id)\"><i class=\"las la-external-link-alt\"></i></button> <button tooltip=\'{{\"SEND_DIGITAL_DOCUMENT\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"documents && documents.length > 0 && (customer.phone != \'\' || customer.telephone != \'\')\" ui-sref=\"app.customers.single.dd({id: {{customer.id}}})\"><i class=\"las la-book\"></i></button> <button tooltip=\'{{\"SEND_DIGITAL_FORM\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"forms && forms.length > 0 && (customer.phone != \'\' || customer.telephone != \'\')\" ui-sref=\"app.customers.single.df({id: {{customer.id}}})\"><i class=\"las la-file-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_SEND_SMS\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"customer.phone != \'\' || customer.telephone != \'\'\" ui-sref=\"app.customers.single.sms({id: {{customer.id}}})\"><i class=\"las la-comment\"></i></button> <button tooltip=\'{{\"CUSTOMERS_REQUEST_CARD\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"(customer.phone != \'\' || customer.telephone != \'\') && ctrl.business.cerdit_company == 3 && ctrl.business.enabled_retainers\" ng-click=\"ctrl.request_card()\"><i class=\"las la-credit-card\"></i></button> <button tooltip=\'{{\"CUSTOMERS_EDIT\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-edit\" ng-click=\"ctrl.edit_customer()\"><i class=\"las la-edit\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DELETE\" | translate}}\' ng-click=\"ctrl.delete();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"customer.status != 2\" ng-disabled=\"customer.hasOrders\"><i class=\"las la-trash-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_RECOVER\" | translate}}\' ng-click=\"ctrl.recover();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"customer.status == 2\"><i class=\"las la-trash-restore-alt\"></i></button></div></div><div class=\"single-model-info\"><div class=\"col-md-4 collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_GENERAL\" | translate}} <span ng-if=\"customer.status_item\" class=\"btn btn-primary btn-xs category-item\" ng-style=\"{\'background-color\': ctrl.hexToRgbA(customer.status_item.color || \'#a9cfe8\')}\">{{customer.status_item.name}}</span> <button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_1 = !ctrl.info_1\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_1, \'la-angle-up\': ctrl.info_1}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_1}\"><div><div class=\"info-label\">{{\"CUSTOMERS_GENDER\" | translate}}</div><div class=\"info-value\">{{customer.gender | gender | emptyValue }}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_EMAIL\" | translate}}</div><div class=\"info-value\">{{customer.email | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_PHONE\" | translate}}</div><div class=\"info-value\">{{customer.phone | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_LANDLINE\" | translate}}</div><div class=\"info-value\">{{customer.telephone | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_BIRTHDAY\" | translate}}</div><div class=\"info-value\">{{customer.birthdate | date: \'dd/MM/yyyy\' | emptyValue}} <span ng-if=\"customer.birthdate\">({{ ctrl.calculateAge(customer.birthdate) }})</span></div></div><div><div class=\"info-label\">{{\"CUSTOMER_ARRIVAL_SOURCE\" | translate}}</div><div class=\"info-value\">{{customer.arrival_source | emptyValue}}</div></div><div><div class=\"info-label\">{{\"DEALER_ID\" | translate}}</div><div class=\"info-value\">{{customer.dealer_id | emptyValue}}</div></div><div class=\"notes-bubble\"><div class=\"info-label\">{{\"CUSTOMERS_REMARKS\" | translate}}</div><div class=\"info-value\">{{customer.notes | emptyValue}}</div></div></div></div><div class=\"col-md-4\"><div class=\"collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_ADDR\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_2 = !ctrl.info_2\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_2, \'la-angle-up\': ctrl.info_2}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_2}\"><div><div class=\"info-label\">{{\"CUSTOMERS_ADDR\" | translate}}</div><div class=\"info-value\">{{customer.address | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_HOME_NUMBER\" | translate}}</div><div class=\"info-value\">{{customer.home_number | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_CITY\" | translate}}</div><div class=\"info-value\">{{customer.city | emptyValue}}</div></div></div></div><div class=\"collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_LEAD_DETAILS\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_4 = !ctrl.info_4\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_4, \'la-angle-up\': ctrl.info_4}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_4}\"><div><div class=\"info-label\">{{\"CUSTOMERS_INTERESTED\" | translate}}</div><div class=\"info-value\">{{customer.interested_in ? customer.interested_in.name : \'\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_RESOURSE\" | translate}}</div><div class=\"info-value\">{{customer.resource_lead_name | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_CAMPAING_NAME\" | translate}}</div><div class=\"info-value\">{{customer.campaign_name | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_AD_NAME\" | translate}}</div><div class=\"info-value\">{{customer.ad_name | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_ADSET_NAME\" | translate}}</div><div class=\"info-value\">{{customer.adset_name | emptyValue}}</div></div><div ng-if=\"customer.custom_fields\" style=\"display: block;\"><h4 class=\"info-title\" style=\"width: 100%;\">{{\"CUSTOMERS_LEAD_QUESTIONS\" | translate}}<button class=\"btn icon simple\" ng-click=\"ctrl.info_5 = !ctrl.info_5\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_5, \'la-angle-up\': ctrl.info_5}\"></i></button></h4><div class=\"dl collapsed-all\" ng-class=\"{\'active\': ctrl.info_5}\"><div ng-repeat=\"(name, value) in customer.custom_fields\"><div class=\"info-label\">{{name | translate}}</div><div class=\"info-value\">{{value | emptyValue}}</div></div></div></div><div ng-if=\"customer.custom_values_list.length > 0\" style=\"display: block;\"><h4 class=\"info-title\" style=\"width: 100%;\">{{\"CUSTOMERS_CUSTOM_FIELDS\" | translate}}<button class=\"btn icon simple\" ng-click=\"ctrl.info_6 = !ctrl.info_6\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_6, \'la-angle-up\': ctrl.info_6}\"></i></button></h4><div class=\"dl collapsed-all\" ng-class=\"{\'active\': ctrl.info_6}\"><div ng-repeat=\"item in customer.custom_values_list\"><div class=\"info-label\">{{item.name}}</div><div class=\"info-value\">{{item.value }}</div></div></div></div></div></div></div><div class=\"col-md-4 collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_CL_SETT\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_3 = !ctrl.info_3\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_3, \'la-angle-up\': ctrl.info_3}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_3}\"><div><div class=\"info-label\">{{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</div><div class=\"info-value\"><span ng-if=\"customer.send_notifications==3\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{customer.send_notifications | notificationTypes | translate}}</div></div><div><div class=\"info-label\">{{\"SETTINGS_USER_SEND_REMINDER\" | translate}}</div><div class=\"info-value\">{{customer.send_reminder | sendReminderTypes | translate}}</div></div><div ng-if=\"customer.send_reminder>0\"><div class=\"info-label\">{{\"CUSTOMERS_SEND_REMINDER\" | translate}}</div><div class=\"info-value\"><span ng-if=\"customer.reminder_send_type==3\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{customer.reminder_send_type | notificationTypes | translate}}</div></div><div ng-if=\"customer.send_reminder>0\"><div class=\"info-label\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION\" | translate}}</div><div class=\"info-value\" ng-if=\"customer.request_order_confirmation == 0\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</div><div class=\"info-value\" ng-if=\"customer.request_order_confirmation == 1\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_SEND_DOCUMENTS\" | translate}}</div><div class=\"info-value\"><span ng-if=\"customer.send_documents==3\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{customer.send_documents | sendDocumentsTypes | translate}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_IND_ORD\" | translate}}</div><div class=\"info-value\">{{customer.self_order | booleanText:\'מורשה\':\'לא מורשה\'}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_GROUP_MESS\" | translate}}</div><div class=\"info-value\">{{customer.group_notifications | booleanText:\'פעיל\':\'כבוי\'}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_PREF_RES\" | translate}}</div><div class=\"info-value\">{{customer.resource_name | emptyValue}}</div></div></div></div></div></div><div class=\"col-xs-12 col col-lg-3 single-model-highlights\"><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\"><div class=\"btn icon fill-black\"><i class=\"las la-calendar\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_REG_DATE\" | translate}}</div><div ng-if=\"customer.created_at\" class=\"info-value mb0\">{{customer.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div><div ng-if=\"!customer.created_at\" class=\"info-value mb0\">{{customer.date | toUnixTimestamp | date: \'dd/MM/yyyy\'}}</div><div ng-if=\"customer.repeat_at\" class=\"mt-8\"><div class=\"info-label\">{{\"CUSTOMERS_REPEAT_DATE\" | translate}}</div><div class=\"info-value mb0\">{{customer.repeat_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div></div><div ng-if=\"customer.repeat_second_at\" class=\"mt-8\"><div class=\"info-label\">{{\"CUSTOMERS_REPEAT_SECOND_DATE\" | translate}}</div><div class=\"info-value mb0\">{{customer.repeat_second_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div></div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\"><div class=\"btn icon fill-orange\"><i class=\"las la-box\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_INV\" | translate}}</div><div class=\"info-value mb0\">{{customer.number_of_shows}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\"><div class=\"btn icon fill-red\"><i class=\"las la-times\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_CONS\" | translate}}</div><div class=\"info-value mb0\">{{customer.cancelations}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\"><div class=\"btn icon fill-green\"><i class=\"las la-dollar-sign\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_LAST_12_MONTH\" | translate}}</div><div class=\"info-value mb0\">{{customer.current_year_income | price}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\"><div class=\"btn icon fill-blue\"><i class=\"las la-chart-line\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_AVE\" | translate}}</div><div class=\"info-value mb0\">{{customer.ave | price}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\"><div class=\"btn icon fill-purple\"><i class=\"las la-wallet\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_BAL\" | translate}}</div><div class=\"info-value mb0\">{{customer.oncredit | price}}</div></div><a ui-sref=\"app.cashbox.closedebt({customer: {{customer.id}}})\" class=\"close-debt btn text primary\" ng-if=\"customer.oncredit > 0\">{{\"CUSTOMERS_OV_COV\" | translate}}</a></div></div></div><div class=\"row-fluid\"><div class=\"col-md-12 border-top border-bottom single-model-tabs customer-single-model cloud\"><ul ng-if=\"!isMobile\" ui-sortable=\"{ stop: ctrl.dropMenu }\" class=\"nav nav-tabs\" ng-model=\"ctrl.menuList\"><li ng-repeat=\"row in ctrl.menuList\" ng-if=\"row.name != \'wachat\' || (row.name == \'wachat\' && customer_wa_chat)\" ng-class=\"[{active: ctrl.active_tab == row.name}, [\'uib-tab\', \'nav-item\']]\"><a href=\"\" ng-click=\"ctrl.setActiveTab(row.name)\" class=\"nav-link nowrap\"><span ng-if=\"row.name == \'wachat\'\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{ctrl.menuTitles[row.name]}}</a></li></ul><ul ng-if=\"isMobile\" class=\"nav nav-tabs\" ng-model=\"ctrl.menuList\"><li ng-repeat=\"row in ctrl.menuList\" ng-if=\"row.name != \'wachat\' || (row.name == \'wachat\' && customer_wa_chat)\" ng-class=\"[{active: ctrl.active_tab == row.name}, [\'uib-tab\', \'nav-item\']]\"><a href=\"\" ng-click=\"ctrl.setActiveTab(row.name)\" class=\"nav-link nowrap\"><span ng-if=\"row.name == \'wachat\'\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{ctrl.menuTitles[row.name]}}</a></li></ul><div class=\"tab-content\"><div ng-class=\"[{active: ctrl.active_tab === \'history\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-history\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_ORDERS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_ORDERS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'history\' && ctrl.initedTableData.length>0\"><div class=\"flex form top nowrap mb-16\"><div><div class=\"form-group last\"><select selectize=\"statusesSelectize\" config=\"selectizeConfig\" name=\"orders_statuses\" ng-change=\"ctrl.loadOrderHistory()\" data-placeholder=\'{{\"CUSTOMERS_HISTORY_FILTER_BY_STATUS\" | translate}}\' ng-model=\"ctrl.historyOrdersStatusFilter\"><option></option><option value=\"{{statusItem.value}}\" ng-repeat=\"statusItem in ctrl.orderStatus\">{{statusItem.title| translate}}</option></select></div></div><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.searchTableData(\'historyOrdersSearchFilter\')\" ng-model=\"ctrl.historyOrdersSearchFilter\" class=\"form-control\"></div></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyOrdersSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_DATE\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_ITEM\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_RESOURCE\" | translate}}</th><th class=\"customer-cell\" ng-if=\"b_type==1\">{{\"CUSTOMER_ORDER_HISTORY_QTY\" | translate}}</th><th class=\"customer-cell\" ng-if=\"b_type==2\">{{\"CUSTOMER_ORDER_HISTORY_NIGHTS\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_PRICE\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_TOTAL\" | translate}}</th><th class=\"customer-cell\"></th><th class=\"images-cell\">{{\"CALENDAR_ORDER_IMAGES_BEFORE\" | translate}}</th><th class=\"images-cell\">{{\"CALENDAR_ORDER_IMAGES_AFTER\" | translate}}</th><th class=\"notes-cell\">{{\"CALENDAR_ORDER_REMARKS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.edit_order_form(row)\"><td class=\"customer-cell\"><span ng-hide=\"true\">{{row.order_date | toUnixTimestamp }}</span> {{row.order_date}} <i ng-click=\"ctrl.goToOrder($event, row)\" class=\"las la-eye show-order\"></i></td><td class=\"customer-cell\"><b>{{row.item_data.name}}</b></td><td class=\"customer-cell\">{{row.resource_name}}</td><td class=\"customer-cell\" ng-if=\"b_type==1\">{{row.item_data.quantity ? row.item_data.quantity : 1}}</td><td class=\"customer-cell\" ng-if=\"b_type==2\">{{row.nights}}</td><td class=\"customer-cell\">{{row.item_data.price}}</td><td class=\"customer-cell\">{{row.order_price}}</td><td class=\"customer-cell\"><div class=\"flex gap-8\"><div class=\"single-model-floating\" ng-if=\"row.customer_form_ids\" ng-repeat=\"form_id in row.customer_form_ids\"><div class=\"single-model-floating-inner\"><button class=\"btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation();\" ui-sref=\"app.customers.single.customers_digital_form({id: customer.id, form_id: form_id})\"><i class=\"las la-file-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DF_PDF_TOOLTIP\" | translate}}\' class=\"have-tooltip green btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.send_form(form_id)\"><i class=\"las la-file-pdf\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DF_PRINT_TOOLTIP\" | translate}}\' class=\"have-tooltip blue btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.print_form(form_id)\"><i class=\"las la-print\"></i></button></div></div></div></td><td class=\"images-cell\"><div ng-if=\"row.images_before && row.images_before.length > 0\" class=\"image-for-orders\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, row.images_before);\"><img ng-src=\"{{row.images_before[0]}}\" alt=\"\"></div><span ng-if=\"row.images_before.length > 1\" class=\"nav-mark\">{{row.images_before.length}}</span></div></td><td class=\"images-cell\"><div ng-if=\"row.images_after && row.images_after.length > 0\" class=\"image-for-orders\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, row.images_after);\"><img ng-src=\"{{row.images_after[0]}}\" alt=\"\"></div><span ng-if=\"row.images_after.length > 1\" class=\"nav-mark\">{{row.images_after.length}}</span></div></td><td class=\"notes-cell\"><div class=\"remark-cell\" tooltip2-size=\"target-fit,object-fit\" tooltip2=\"{{row.order_notes}}\"><div>{{row.order_notes}}</div></div></td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'wachat\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'wachat\'\"><div class=\"empty-section\" ng-if=\"!customer.phone\"><i class=\"lab la-whatsapp\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_WA\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_WA_SENTENCE\" | translate}}</p></div><div ng-if=\"customer.phone\" ng-include=\"\'app/modules/customers/modules/customers-wa-chat/customers.wa.chat.html\'\"></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'notes\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-clipboard\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_NOTES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_NOTES_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.add_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_NOTE\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'notes\' && ctrl.tableData.length\"><div class=\"flex form top nowrap mb-16\"><div><a ng-click=\"ctrl.add_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_NOTE\" | translate}}</a></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-notes\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-note-cell\">{{\"NOTES_CREATED_AT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_TEXT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_REMIND_AT\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.add_note(row)\"><td class=\"customer-note-cell\">{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-note-cell\">{{row.resource_name}}</td><td class=\"customer-note-cell\">{{row.text}}</td><td class=\"customer-note-cell\">{{row.remind_at_display}}</td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'medical_notes\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-clipboard\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_NOTES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_NOTES_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.add_medical_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_MEDICAL_NOTE\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'medical_notes\' && ctrl.tableData.length\"><div class=\"flex form top nowrap mb-16\"><div><a ng-click=\"ctrl.add_medical_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_MEDICAL_NOTE\" | translate}}</a></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-medical_notes\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-note-cell\">{{\"NOTES_CREATED_AT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_TEXT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_REMIND_AT\" | translate}}</th><th class=\"customer-note-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-class=\"{\'deleted-row\': row.removed_at}\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.add_medical_note(row)\"><td class=\"customer-note-cell\">{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-note-cell\">{{row.resource_name}}</td><td class=\"customer-note-cell\">{{row.text}}</td><td class=\"customer-note-cell\">{{row.remind_at_display}}</td><td class=\"customer-note-cell\"><i ng-click=\"ctrl.open_medical_note_log($event, row)\" class=\"las la-eye show-order\"></i></td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'cards\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-ticket-alt\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_CARDS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_CARDS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'cards\' && ctrl.initedTableData.length\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-cards\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-card-cell\">{{\"CUSTOMER_CARD_NAME\" | translate}}</th><th class=\"customer-card-cell\">{{\"CUSTOMER_CARD_BALANCE\" | translate}}</th><th class=\"customer-card-cell\">{{\"MAKE_CARD_EXPIRED_DATE\" | translate}}</th><th class=\"customer-card-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_customer_card_transactions(row.id)\"><td class=\"customer-card-cell\"><i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': row.expired}\"></i> {{row.card_name}}</td><td class=\"customer-card-cell\">{{row.balance}}</td><td class=\"customer-card-cell\">{{row.expired_at | toUnixTimestamp | date:\"dd/MM/yyyy\"}}</td><td class=\"customer-card-cell customer-card-change-cell\"><button class=\"btn text primary\" ng-click=\"ctrl.showChangeCard(row.id);$event.stopPropagation()\">{{\"CARD_BALANCE_CHANGE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'color\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-tint\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_COLOR\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_COLOR_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.edit_color_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_COLOR\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'color\' && ctrl.initedTableData.length > 0\"><div class=\"mb-24\"><a ng-click=\"ctrl.edit_color_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_COLOR\" | translate}}</a></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-color\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_DATE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_OXYGEN\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_OXYGEN_DOSAGE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_BRAND\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_COMMENTS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.edit_color_form(row.id)\"><td class=\"customer-color-cell\">{{row.date}}</td><td class=\"customer-color-cell\">{{row.color_number}}<br ng-if=\"row.color_number_2\">{{row.color_number_2}}<br ng-if=\"row.color_number_3\">{{row.color_number_3}}<br ng-if=\"row.color_number_4\">{{row.color_number_4}}</td><td class=\"customer-color-cell\">{{row.color_dosage}}<br ng-if=\"row.color_dosage_2\">{{row.color_dosage_2}}<br ng-if=\"row.color_dosage_3\">{{row.color_dosage_3}}<br ng-if=\"row.color_dosage_4\">{{row.color_dosage_4}}</td><td class=\"customer-color-cell\">{{row.oxygen_percent}}</td><td class=\"customer-color-cell\">{{row.oxygen_dosage}}</td><td class=\"customer-color-cell\">{{row.brand}}</td><td class=\"customer-color-cell\">{{row.comments}}</td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'transaction\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-file-invoice-dollar\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_TRANSACTIONS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_TRANSACTIONS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'transaction\' && ctrl.initedTableData.length > 0\"><div class=\"flex form gap-16 mb-16\"><div><div class=\"btn-group\" role=\"group\"><button ng-click=\"ctrl.change_item_type(\'service\')\" type=\"button\" class=\"btn {{ctrl.active_item_type == \'service\' ? \'btn-primary\' : \'\'}}\">{{\"SERVICE\" | translate}}</button> <button ng-click=\"ctrl.change_item_type(\'sale\')\" type=\"button\" class=\"btn {{ctrl.active_item_type == \'sale\' ? \'btn-primary\' : \'\'}}\">{{\"SALE\" | translate}}</button> <button ng-click=\"ctrl.change_item_type(\'card\')\" type=\"button\" class=\"btn {{ctrl.active_item_type == \'card\' ? \'btn-primary\' : \'\'}}\">{{\"CARD_ITEM_TYPE\" | translate}}</button></div></div><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.searchTableData(\'historyTransSearchFilter\')\" ng-model=\"ctrl.historyTransSearchFilter\" class=\"form-control\"></div></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyTransSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_DATE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_NAME\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_QUANTITY\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_PRICE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_TOTAL_PRICE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_log_card(row)\"><td class=\"customer-color-cell\">{{row.date}}<div ng-if=\"row.quotation\" class=\"prepaid-label\">{{\"SETTINGS_LOG_QUOTATION_LABEL\" | translate}}</div></td><td><b ng-bind-html=\"row.name | nl2br\"></b></td><td class=\"customer-color-cell\">{{row.quantity}}</td><td class=\"customer-color-cell\">{{row.price}}</td><td class=\"customer-color-cell\">{{row.total}}</td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'documents\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-book\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_DOCUMENTS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_DOCUMENTS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab == \'documents\' && ctrl.initedTableData.length > 0\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyDocumentsSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_NAME\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_DATE\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_DATE_SIGN\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_SIGN\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_LINK\" | translate}}</th><th class=\"customer-document-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-document-cell\"><b>{{ctrl.documentName(row)}}</b></td><td class=\"customer-document-cell\">{{row.date}}</td><td class=\"customer-document-cell\">{{row.sign_date}}</td><td class=\"customer-document-cell\"><span ng-if=\"row.sign\" class=\"btn text success label\">{{\"CUSTOMER_DOCUMENTS_SIGNED\" | translate}}</span> <span ng-if=\"!row.sign\" class=\"btn text warning label\">{{\"CUSTOMER_DOCUMENTS_SIGN_WAIT\" | translate}}</span></td><td class=\"customer-document-cell\"><a ng-if=\"ctrl.isWebView()\" ng-click=\"ctrl.openPdf(row.url)\" class=\"btn icon bordered\"><i class=\"las la-file-alt\"></i></a> <a ng-if=\"!ctrl.isWebView()\" href=\"{{row.url}}\" class=\"btn icon bordered\" target=\"_blank\"><i class=\"las la-file-alt\"></i></a></td><td class=\"customer-document-cell\"><button class=\"btn text border-red\" ng-click=\"ctrl.removeDocument(row.id); $event.stopPropagation()\">{{\"CUSTOMER_DOCUMENTS_REMOVE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'forms\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-file-alt\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_FORMS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_FORMS_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.add_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_FORM\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab == \'forms\' && ctrl.initedTableData.length > 0\"><div class=\"mb-24\"><a ng-click=\"ctrl.add_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_FORM\" | translate}}</a></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyFormsSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-forms-cell\">{{\"CUSTOMER_FORMS_NAME\" | translate}}</th><th class=\"customer-forms-cell\">{{\"CUSTOMER_FORMS_DATE\" | translate}}</th><th class=\"customer-forms-cell\">{{\"CUSTOMER_FORMS_FILL_DATE\" | translate}}</th><th></th><th></th></tr></thead><tbody><tr ui-sref=\"app.customers.single.customers_digital_form({id: customer.id, form_id: row.id})\" class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-forms-cell\"><b>{{row.name}}</b></td><td class=\"customer-forms-cell\">{{row.date}}</td><td class=\"customer-forms-cell\">{{row.fill_date}}</td><td class=\"customer-forms-cell\"><button tooltip=\'{{\"CUSTOMERS_DF_PDF_TOOLTIP\" | translate}}\' class=\"have-tooltip green btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.send_form(row.id)\"><i class=\"las la-file-pdf\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DF_PRINT_TOOLTIP\" | translate}}\' class=\"have-tooltip blue btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.print_form(row.id)\"><i class=\"las la-print\"></i></button></td><td class=\"customer-forms-cell\"><button class=\"btn text border-red\" ng-click=\"ctrl.removeForm(row.id); $event.stopPropagation()\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'laser\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" id=\"drop-area\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0 && !ctrl.laser_form.length\"><i class=\"las la-file\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_LASER_FILES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_LASER_FILES_SENTENCE\" | translate}}</p><button type=\"submit\" ng-click=\"ctrl.add_line();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_ADD\" | translate}}</button></div><div ng-if=\"!ctrl.tabLoading && (ctrl.initedTableData.length || ctrl.laser_form.length)\"><div class=\"flex form gap-16 mb-16\"><div><div class=\"btn-group\"><button ng-repeat=\"category in ctrl.laser_categories\" class=\"btn\" ng-click=\"ctrl.laser_category = category.id\" ng-class=\"{\'btn-primary\': ctrl.laser_category == category.id, \'btn-default\': ctrl.laser_category != category.id}\">{{category.name | translate}}</button></div></div></div><div class=\"laser-values\"><table class=\"dataTable\"><thead><tr><th class=\"min\"></th><th ng-repeat=\"field in ctrl.laser_fields\" ng-if=\"field.category_id == ctrl.laser_category\" class=\"laser-value-column\"><p>{{field.name}}</p></th><th class=\"min\"></th></tr></thead><tbody><tr ng-repeat=\"(index, form) in ctrl.laser_form\" ng-if=\"!form.remove && form.category_id == ctrl.laser_category && (form.show || form.first)\"><td class=\"min\" width=\"1%\"><button ng-if=\"form.order_id && form.first && ctrl.laser_orders[form.order_id] == \'closed\' && ctrl.laser_orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form);\" class=\"btn icon bordered\"><i class=\"las la-angle-down\"></i></button> <button ng-if=\"form.order_id && form.first && ctrl.laser_orders[form.order_id] == \'opened\' && ctrl.laser_orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form, true);\" class=\"btn icon bordered\"><i class=\"las la-angle-up\"></i></button></td><td ng-repeat=\"field in ctrl.laser_fields\" ng-if=\"field.category_id == ctrl.laser_category\" ng-class=\"{\'min\': field.type == \'map\', \'laser-value-column\': true}\"><div ng-if=\"field.type == \'text\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"text\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'date\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"date\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'datetime\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"datetime-local\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'textarea\'\" class=\"form-group\"><textarea placeholder=\"{{field.name}}\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" auto-expand=\"\" class=\"form-control small\"></textarea></div><div ng-if=\"field.type == \'list\'\" class=\"form-group form-select\"><select class=\"form-control small\" name=\"{{field.id}}\" data-placeholder=\"{{field.name}}\" ng-model=\"form[field.id]\"><option value=\"\">{{field.name}}</option><option ng-if=\"field.list\" ng-repeat=\"(index, item) in field.list\" value=\"{{item.id}}\">{{item.name}}</option></select></div><div ng-if=\"field.type == \'map\'\" class=\"form-group\"><button ng-click=\"ctrl.laser_map(index, field);\" class=\"btn text border-primary\">{{\"LASER_FILE_MAP_BUTTON\" | translate}}</button></div></td><td class=\"min\" width=\"1%\"><button ng-click=\"ctrl.remove_line(index);\" class=\"btn icon circle error\"><i class=\"las la-trash-alt\"></i></button></td></tr></tbody></table></div><div class=\"laser-footer\"><button type=\"submit\" ng-click=\"ctrl.add_line();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_ADD\" | translate}}</button> <button type=\"submit\" ng-click=\"ctrl.submit_fields();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'files\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" id=\"drop-area\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-file\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_FILES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_FILES_SENTENCE\" | translate}}</p><label class=\"btn text primary\">{{\"CUSTOMERS_ADD_FILE\" | translate}} <input style=\"display: none\" type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'files\' && ctrl.initedTableData.length\"><div class=\"flex form top nowrap mb-16\"><div><label class=\"btn text primary\">{{\"CUSTOMERS_ADD_FILE\" | translate}} <input style=\"display: none\" type=\"file\" multiple=\"\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-files\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-file-cell\">{{\"FILES_NAME\" | translate}}</th><th class=\"customer-file-cell\">{{\"FILES_CREATED_AT\" | translate}}</th><th class=\"customer-file-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-file-cell\"><a ng-if=\"ctrl.isWebView() && (ctrl.isPdfUrl(row.url) || ctrl.isImageUrl(row.url))\" ng-click=\"ctrl.openPdf(row.url)\" class=\"btn icon bordered\"><i class=\"las la-download\"></i></a> <a ng-if=\"!(ctrl.isWebView() && (ctrl.isPdfUrl(row.url) || ctrl.isImageUrl(row.url)))\" class=\"btn icon bordered\" download=\"\" target=\"_blank\" href=\"{{row.url}}\"><i class=\"las la-download\"></i></a> {{row.name}}</td><td class=\"customer-file-cell\">{{row.created_at_display}}</td><td class=\"customer-file-cell\"><button class=\"btn text border-red\" ng-click=\"ctrl.deleteFile(row.id); $event.stopPropagation()\">{{\"CUSTOMER_FILES_REMOVE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-class=\"[{active: ctrl.active_tab === \'smses\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-comment\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_SMSES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_SMSES_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'smses\' && ctrl.initedTableData.length\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyTransSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th style=\"width: auto !important;\" class=\"customer-color-cell\">{{\"CUSTOMER_SMSES_DATE\" | translate}}</th><th style=\"min-width: 40%; width: auto !important;\" class=\"customer-color-cell\">{{\"CUSTOMER_SMSES_TEXT\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\" class=\"customer-color-cell\">{{\"CUSTOMER_SMSES_STATUS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-color-cell\"><span ng-hide=\"true\">{{row.created_at | toUnixTimestamp }}</span> {{row.sent}}</td><td class=\"customer-color-cell\"><b>{{row.message}}</b></td><td class=\"customer-color-cell\">{{row.updated}} - <span ng-if=\"!row.error\">{{\"SETTINGS_SMS_LOGS_STATUS_SENT\" | translate}}</span> <span ng-if=\"row.error\"><span ng-if=\"row.error == \'Delivered\'\">{{\"SETTINGS_SMS_LOGS_STATUS_DELIVERED\" | translate}}</span> <span ng-if=\"row.error != \'Delivered\'\">{{row.error}}</span></span></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers-sms/customers.sms.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">\"{{Customer.firstname}} {{Customer.lastname}}\" {{\"CUSTOMERS_SMS_TO\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"smsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group with_upload\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_CONTENT_MESSAGE\" | translate}}</label> <span class=\"upload_file_paperclip\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"> <i class=\"la la-paperclip\"></i> <span ng-if=\"ctrl.form.files && ctrl.form.files.length\" class=\"remove\"><i class=\"las la-times\"></i></span></span> <textarea class=\"form-control\" name=\"message\" ng-model=\"ctrl.form.message\" required=\"\" style=\"height: 120px; resize: none;\"></textarea><div ng-messages=\"smsForm.message.$error\" class=\"ng-messages\" ng-show=\"smsForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"smsForm.$invalid || smsForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-list/customers.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'customers\')\"><div class=\"cloud\"><div class=\"flex full mb-24 gap-24 gap-24-m-8 customer-list-header\"><button class=\"btn text large primary\" ui-sref=\"app.customers.new\"><i class=\"las la-plus\"></i> {{\"NEW_CLIENT\" | translate}}</button><div class=\"form-group icon-prepend last search-input\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_customer()\" ng-model=\"ctrl.customer_name\" class=\"form-control\"></div><div ng-include=\"\'app/components/cfilter/button.html\'\"></div><button class=\"btn icon default green\" ng-class=\"{\'loading\': ctrl.download_in_progress}\" ng-click=\"ctrl.downloadCustomerData()\"><i class=\"las la-file-excel\"></i></button><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_deleted()\" ng-model=\"ctrl.show_deleted\">{{\"SHOW_DELETED\" | translate}}</label></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><div id=\"module-loading\" class=\"ibox-content sk-loading\" ng-if=\"module_is_loading\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div><table id=\"cust_dt\" ng-table=\"ctrl.tableCustomers\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCustomers\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"></table><div id=\"custom-pagination-container\"><div class=\"dataTables_per-page\"><span>{{\"ENTRIES_PER_PAGE\" | translate}}</span><div class=\"per-page-options\"><label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"20\"><span>20</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"50\"><span>50</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"100\"><span>100</span></label></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{DigitalForm ? DigitalForm.name : \"CUSTOMERS_DIGITAL_FORM\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.close()\">&times;</a></div><form class=\"modal-form_f\" name=\"formForm\" ng-submit=\"ctrl.chooseForm()\" ng-if=\"!DigitalForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex fill gap-24\"><div ng-if=\"!ctrl.customer_page\" class=\"form-group customer-select-wrapper\"><label><span class=\"required\">*</span> {{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\"><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-disabled=\"ctrl.customer_modal\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div><div><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_DIGITAL_FORM\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.form_id\"><option value=\"\">{{\"CUSTOMERS_FORM\" | translate}}</option><option ng-repeat=\"form in forms\" value=\"{{form.id}}\">{{form.name}}</option></select><div ng-messages=\"formForm.message.$error\" class=\"ng-messages\" ng-show=\"documentForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"button\" ng-disabled=\"documentForm.$invalid || documentForm.$pristine || !ctrl.form.customer_id || !ctrl.form.form_id\" ng-click=\"ctrl.send_to_customer()\" class=\"btn text border-primary large\">{{\"SEND_DIGITAL_FORM\" | translate}}</button> <button type=\"submit\" ng-disabled=\"documentForm.$invalid || documentForm.$pristine || !ctrl.form.customer_id || !ctrl.form.form_id\" class=\"btn text primary large\">{{\"PLEASE_FILL_FORM\" | translate}}</button></div></form><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data track by $index\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea ng-disabled=\"DigitalForm.cf_locked\" auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\">{{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\"> {{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group form-select\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><select ng-disabled=\"DigitalForm.cf_locked\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\"><option value=\"\">{{field.name}}</option><option value=\"{{item.value}}\" ng-repeat=\"(i, item) in field.items\">{{item.name}}</option></select></div><div ng-if=\"field.other\" class=\"form-group\"><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"date\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"drawing-toolbar\"><div class=\"tool-buttons\"><button type=\"button\" ng-class=\"{ active: field.tool === \'pen\', default: field.tool !== \'pen\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'pen\'\"><i class=\"la la-pencil\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'spray\', default: field.tool !== \'spray\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'spray\'\"><i class=\"la la-spray-can\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'text\', default: field.tool !== \'text\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'text\'\"><i class=\"la la-font\"></i></button></div><div class=\"color-picker\"><div class=\"color-circle\" ng-style=\"{\'background\': field.color}\" ng-click=\"openColorPicker($event, field)\"></div><input type=\"color\" class=\"color-input\" ng-model=\"field.color\"></div><div class=\"size-slider\"><input type=\"range\" min=\"1\" max=\"30\" ng-model=\"field.size\"></div><button class=\"btn icon red\" ng-click=\"clearCanvas(field)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div><div class=\"drawing-canvas-container\"><img ng-src=\"{{field.map}}\"><canvas id=\"mapCanvas{{$index}}\"></canvas></div></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.backForm()\" class=\"btn text border-primary large\">{{\"CUSTOMERS_BACK\" | translate}}</button> <button ng-if=\"!DigitalForm.cf_locked\" type=\"button\" ng-click=\"ctrl.save()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html","<div id=\"print-form\" class=\"modal-form-inner print_one\"><div class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{ctrl.business_name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name ? DigitalForm.name : \"&nbsp;\"}}</h2></div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\' || field.type == \'textarea\'\"><div class=\"form-group\"><label>{{field.name}}</label><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'date\' && field.value\"><div class=\"form-group\"><label>{{field.name}}</label><p>{{field.value | toUnixTimestamp | date: \'dd/MM/yyyy\'}}</p></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\" ng-if=\"item.value == field.value\"><p>{{item.name}}</p><p></p></div></div><p ng-bind-html=\"ctrl.textValueWithBR(field.other_value)\"></p></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\" ng-if=\"item.checked\"><p>{{item.name}}</p><p></p></div></div><p ng-bind-html=\"ctrl.textValueWithBR(field.other_value)\"></p></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label>{{field.name}}</label><p ng-if=\"item.value == field.value\" ng-repeat=\"(i, item) in field.items\">{{item.name}}</p></div><p ng-bind-html=\"ctrl.textValueWithBR(field.other_value)\"></p></div></div><div ng-if=\"field.type == \'comment\'\"><p class=\"text-danger\">{{field.name}}</p></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"drawing-canvas-container\"><img style=\"position: relative\" ng-src=\"{{field.map}}\"> <img class=\"drawed_image\" ng-if=\"field.value\" ng-src=\"{{field.value}}\"></div></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-card-request/customers.card_request.html","<div class=\"modal-form-inner modal-approval\"><div class=\"modal-head modal-head-online\"><div class=\"background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: contain;\"><div class=\"logo-container\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><h1 class=\"business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"business-address\">{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}</h2></div></div><div class=\"modal-head\"><h3 class=\"form-title no-padding-x\">{{\"CUSTOMERS_CARD_REQUEST_TITLE\" | translate}}</h3></div><div class=\"modal-body\"><div class=\"panel-body\"><iframe ng-src=\"{{ctrl.iframe}}\" style=\"width:100%; height:100%; min-height: 700px;\" frameborder=\"0\"></iframe></div></div></div>");
$templateCache.put("app/modules/customers/modules/leads-list/leads.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'customers\')\"><div class=\"cloud\"><div class=\"flex full mb-24 gap-24 gap-24-m-8 leads-list-header\"><button class=\"btn text large primary\" ui-sref=\"app.leads.new_lead\"><i class=\"las la-plus\"></i> {{\"NEW_LEAD\" | translate}}</button><div class=\"form-group icon-prepend last search-input\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_customer()\" ng-model=\"ctrl.customer_name\" class=\"form-control\"></div><div ng-include=\"\'app/components/cfilter/button.html\'\"></div><button class=\"btn icon default green\" ng-class=\"{\'loading\': ctrl.download_in_progress}\" ng-click=\"ctrl.downloadCustomerData()\"><i class=\"las la-file-excel\"></i></button></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><div id=\"module-loading\" class=\"ibox-content sk-loading\" ng-if=\"module_is_loading\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div><table id=\"cust_dt\" ng-table=\"ctrl.tableCustomers\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCustomers\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"></table><div id=\"custom-pagination-container\"><div class=\"dataTables_per-page\"><span>{{\"ENTRIES_PER_PAGE\" | translate}}</span><div class=\"per-page-options\"><label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"20\"><span>20</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"50\"><span>50</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"100\"><span>100</span></label></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/businesses/modules/businesses-list/businesses.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn btn-primary\" ui-sref=\"app.settings.categories.new\">קטגוריה חדשה</button></div><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>שם הקטגוריה</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.categories.edit({id: {{row.id}}})\"><td>{{row.name}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_ADD_MEDICAL_NOTE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\"><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-disabled=\"ctrl.customer_modal\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"NOTES_RESOURCE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.resource_id\"><option value=\"\">{{\"NOTES_RESOURCE_EMPTY\" | translate}}</option><option value=\"{{resource.id}}\" ng-repeat=\"resource in resources\">{{resource.name}}</option></select></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" audio-recorder=\"\" audio-model=\"ctrl.form.text\"><label>{{\"NOTES_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.text\" name=\"text\" class=\"form-control\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"NOTES_REMIND_AT\" | translate}}</label><div class=\"flex form nowrap gap-8\"><input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.remind_at_date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\"> <input type=\"time\" class=\"form-control\" ng-model=\"ctrl.form.remind_at_time\"></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-wa-chat/customers.wa.chat.html","<div class=\"wachat\" ng-controller=\"CustomersWaChatController as wachat\"><div class=\"wachat_scroll\"><div class=\"wachat_messages\"><div class=\"wachat_body\"><div id=\"wa-chat-container\" ng-if=\"wa_history && wa_history && !wa_history.invokeStatus\"><div ng-repeat=\"item in wa_history\" ng-key=\"$index\"><div ng-class=\"{\'wachat__msg\': true, \'wachat__msg_reply\': item.type == \'outgoing\'}\"><div class=\"wachat__user\" ng-if=\"item.type == \'incoming\' && wa_avatar\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar }}\" alt=\"User\"></div><div class=\"wachat__user\" ng-if=\"item.type == \'outgoing\' && wa_avatar_my\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar_my }}\" alt=\"User\"></div><div class=\"wachat__wrap\"><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'textMessage\' || item.typeMessage == \'extendedTextMessage\'\" ng-bind-html=\"formattedText(item.textMessage)\"></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'audioMessage\'\"><i ng-if=\"currentAudioId == item.idMessage\" class=\"las la-stop play-wa\" ng-click=\"playWaRecord(item)\"></i> <i ng-if=\"currentAudioId != item.idMessage\" class=\"las la-play play-wa\" ng-click=\"playWaRecord(item)\"></i></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'imageMessage\' || item.typeMessage == \'videoMessage\'\"><a ng-href=\"{{ item.downloadUrl }}\" target=\"_blank\"><img ng-if=\"item.jpegThumbnail\" ng-src=\"data:image/png;base64,{{item.jpegThumbnail}}\"></a><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'documentMessage\'\"><a ng-href=\"{{ item.downloadUrl }}\" download=\"{{ item.fileName }}\"><i class=\"las la-file play-wa\"></i> {{ item.fileName }}</a><br ng-if=\"item.caption\">{{ item.caption }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'quotedMessage\' && item.extendedTextMessage && item.extendedTextMessage.text\"><div class=\"wachat__quoted\" ng-if=\"item.quotedMessage\"><div ng-class=\"{\'wachat__msg\': true, \'wachat__msg_reply\': item.type == \'outgoing\'}\"><div class=\"wachat__user\" ng-if=\"item.type == \'incoming\' && wa_avatar\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar }}\" alt=\"User\"></div><div class=\"wachat__user\" ng-if=\"item.type == \'outgoing\' && wa_avatar_my\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar_my }}\" alt=\"User\"></div><div class=\"wachat__wrap\"><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'textMessage\' || item.typeMessage == \'extendedTextMessage\'\" ng-bind-html=\"formattedText(item.textMessage)\"></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'audioMessage\'\"><i ng-if=\"currentAudioId == item.idMessage\" class=\"las la-stop play-wa\" ng-click=\"playWaRecord(item)\"></i> <i ng-if=\"currentAudioId != item.idMessage\" class=\"las la-play play-wa\" ng-click=\"playWaRecord(item)\"></i></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'imageMessage\' || item.typeMessage == \'videoMessage\'\"><img ng-if=\"item.jpegThumbnail\" ng-src=\"data:image/png;base64,{{item.jpegThumbnail}}\"> {{ item.caption }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'documentMessage\'\"><a ng-href=\"{{ item.downloadUrl }}\" download=\"{{ item.fileName }}\"><i class=\"las la-file play-wa\"></i> {{ item.fileName }}</a><br ng-if=\"item.caption\">{{ item.caption }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'quotedMessage\' && item.extendedTextMessage && item.extendedTextMessage.text\"><div class=\"wachat__quoted\" ng-if=\"item.quotedMessage\"></div>{{ item.extendedTextMessage.text }}</div></div></div></div>{{ item.extendedTextMessage.text }}</div></div><div class=\"wachat__time\">{{ getReadableTime(item.timestamp) }}</div></div></div></div></div><div ng-if=\"wa_history && wa_history.invokeStatus && wa_history.invokeStatus.descr\" class=\"wachat__error\">{{ wa_history.invokeStatus.descr }}</div><div ng-if=\"!wa_history\" class=\"wachat__loader\"><span></span></div></div></div></div><div class=\"reply wachat__reply\" ng-hide=\"!(wa_history && wa_history && !wa_history.invokeStatus)\"><div class=\"reply__field\"><textarea ng-model=\"wa_message\" ng-keydown=\"handleKeyDown($event)\" class=\"reply__textarea\" placeholder=\"{{ \'WACHAT_MESSAGE\' | translate }}\"></textarea></div><div class=\"reply__actions\"><div class=\"wa-papperclip\"><span class=\"upload-input-wrapper\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\" class=\"upload-input\"></span> <i class=\"la la-paperclip\"></i> <span ng-if=\"files && files.length\" class=\"remove\" ng-click=\"clearFiles()\"><i class=\"las la-times\"></i></span></div><button class=\"wa-submit\" ng-click=\"sendWaMessage()\"></button></div></div></div>");
$templateCache.put("app/modules/medical_notes/modules/medical_notes-log/medical_notes.log.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_MEDICAL_NOTE_LOG\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"ctrl.list\" class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-medical_notes\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-note-cell\">{{\"NOTES_LOG_DATE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_ACTION\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_USER\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_OLD_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_NEW_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_OLD_TEXT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_NEW_TEXT\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.list\"><td class=\"customer-note-cell\">{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-note-cell\">{{\"NOTES_LOG_ACTION_\"+row.action.toUpperCase() | translate}}</td><td class=\"customer-note-cell\">{{row.user_name}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_resource_name != row.new_resource_name) ? row.old_resource_name : \'\'}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_resource_name != row.new_resource_name) || row.action == \'create\' || row.action == \'delete\' ? row.new_resource_name : \'\'}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_text != row.new_text) ? row.old_text : \'\'}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_text != row.new_text) || row.action == \'create\' || row.action == \'delete\' ? row.new_text : \'\'}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/digital_forms/modules/digital-forms-list/digital-forms.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text large primary\" ng-click=\"ctrl.newForm()\"><i class=\"las la-plus\"></i> {{\"CUSTOMER_ADD_FORM\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_items()\" ng-model=\"ctrl.search\" class=\"form-control\"></div></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">&nbsp;</h3><a class=\"close\" ng-click=\"$close(DigitalFormList)\">&times;</a></div><div ng-if=\"DigitalForm.id\" class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{ctrl.business_name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name ? DigitalForm.name : \"&nbsp;\"}}</h2></div><div ng-if=\"DigitalForm.cf_locked\" class=\"df-locked\"><i class=\"las la-lock\"></i>{{\"DIGITAL_FORM_LOCKED_TITLE\" | translate}}</div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\" audio-recorder=\"\" audio-model=\"field.value\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea ng-disabled=\"DigitalForm.cf_locked\" auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\">{{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\"> {{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group form-select\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><select ng-disabled=\"DigitalForm.cf_locked\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\"><option value=\"\">{{field.name}}</option><option value=\"{{item.value}}\" ng-repeat=\"(i, item) in field.items\">{{item.name}}</option></select></div><div ng-if=\"field.other\" class=\"form-group\"><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"date\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"drawing-toolbar\"><div class=\"tool-buttons\"><button type=\"button\" ng-class=\"{ active: field.tool === \'pen\', default: field.tool !== \'pen\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'pen\'\"><i class=\"la la-pencil\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'spray\', default: field.tool !== \'spray\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'spray\'\"><i class=\"la la-spray-can\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'text\', default: field.tool !== \'text\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'text\'\"><i class=\"la la-font\"></i></button></div><div class=\"color-picker\"><div class=\"color-circle\" ng-style=\"{\'background\': field.color}\" ng-click=\"openColorPicker($event, field)\"></div><input type=\"color\" class=\"color-input\" ng-model=\"field.color\"></div><div class=\"size-slider\"><input type=\"range\" min=\"1\" max=\"30\" ng-model=\"field.size\"></div><button class=\"btn icon red\" ng-click=\"clearCanvas(field)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div><div class=\"drawing-canvas-container\"><img ng-src=\"{{field.map}}\"><canvas id=\"mapCanvas{{$index}}\"></canvas></div></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close()\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button ng-if=\"!DigitalForm.cf_locked\" type=\"button\" ng-click=\"ctrl.save()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form><div ng-if=\"!DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"digital_form_list\"><div class=\"digital_form_form\" ng-click=\"ctrl.openForm(form)\" ng-repeat=\"(index, form) in DigitalFormList\">{{form.name}}</div><div class=\"digital_form_form\" ng-click=\"ctrl.newForm()\">{{\"ADD_NEW_CUSTOMER_ORDER_FORM\" | translate}}</div></div></div></div></div></div>");
$templateCache.put("app/modules/notifications/modules/notifications_list/notifications_list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.dashboard\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"NOTIFICATIONS_LIST\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"NOTIFICATIONS_CUSTOMER\" | translate}}</th><th>{{\"NOTIFICATIONS_MESSAGE\" | translate}}</th><th>{{\"NOTIFICATIONS_DATE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><span>{{row.title}}</span></td><td><span>{{row.text}}</span></td><td><span>{{row.date}}</span></td><td><button class=\"btn icon circle\" ng-click=\"ctrl.delete(row.id)\"><i class=\"las la-trash-alt\"></i></button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/marketing/automations/form/automations.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_AUTOMATION_NEW\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_AUTOMATION_EDIT\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"automationsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"AUTOMATION_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-4 col-xs-12\" ng-class=\"{\'col-xs-10\': ctrl.form.trigger != \'order_status\'}\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"AUTOMATION_TRIGGER\" | translate}}</label><select selectize=\"userSelectize\" name=\"trigger\" config=\"{create: true,sortField: \'text\'}\" required=\"\" ng-model=\"ctrl.form.trigger\"><option value=\"\"></option><option ng-repeat=\"item in ctrl.triggers\" value=\"{{item.id}}\" ng-bind=\"(item.name)\"></option></select><div ng-messages=\"itemsForm.trigger.$error\" class=\"ng-messages\" ng-show=\"itemsForm.trigger.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"ctrl.form.trigger != \'order_status\' && ctrl.form.trigger != \'birthday\'\" class=\"col-xs-2\"><div ng-include=\"\'app/components/cfilter/button.html\'\"></div></div><div ng-if=\"ctrl.form.trigger == \'order_status\' || ctrl.form.trigger == \'birthday\'\" class=\"col-md-4 col-xs-12\"><div class=\"flex form\"><div ng-if=\"ctrl.form.trigger == \'order_status\'\" class=\"col-sm-9 col-xs-10\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"AUTOMATION_TRIGGER_ORDER_STATUS\" | translate}}</label><select selectize=\"userSelectize\" name=\"order_status\" config=\"{create: true}\" required=\"ctrl.form.trigger == \'order_status\'\" ng-model=\"ctrl.form.order_status\"><option value=\"\"></option><option ng-repeat=\"item in ctrl.orderStatuses\" value=\"{{item.value}}\" ng-bind=\"(item.name)\"></option></select><div ng-messages=\"itemsForm.order_status.$error\" class=\"ng-messages\" ng-show=\"itemsForm.order_status.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"ctrl.form.trigger == \'birthday\'\" class=\"col-sm-9 col-xs-10\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"AUTOMATION_TRIGGER_BIRTHDAY_TIME\" | translate}}</label> <input type=\"time\" ng-model=\"ctrl.form.birthday_time\" name=\"birthday_time\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.birthday_time.$error\" class=\"ng-messages\" ng-show=\"itemsForm.birthday_time.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-sm-3 col-xs-2\"><div ng-include=\"\'app/components/cfilter/button.html\'\"></div></div></div></div></div><div class=\"form-group\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-6\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.send_message\"> {{\"AUTOMATION_SEND_MESSAGE\" | translate}}</label></div></div><div class=\"col-md-6 col-xs-6\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.active\"> {{\"AUTOMATION_ACTIVE\" | translate}}</label></div></div></div><div class=\"collapse\" ng-class=\"{\'in\': ctrl.form.send_message}\"><div class=\"panel panel-custom\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-check form-group\"><label class=\"form-check-label\" for=\"recommendation\"><input type=\"checkbox\" class=\"form-control\" id=\"recommendation\" ng-model=\"ctrl.form.recommendation\"> {{\"AUTOMATION_RECOMMENDATION\" | translate}}</label></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"AUTOMATION_DIGITAL_FORM\" | translate}}</label><select selectize=\"userSelectize\" config=\"{sortField: \'text\'}\" ng-model=\"ctrl.form.digital_form_id\"><option value=\"\">{{\"AUTOMATION_DIGITAL_FORM\" | translate}}</option><option ng-repeat=\"item in ctrl.digitalForms\" value=\"{{item.id}}\" ng-bind=\"(item.name)\"></option></select></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"AUTOMATION_CUSTOMER_NOTIFY_TYPE\" | translate}}</label><select selectize=\"userSelectize\" config=\"{sortField: \'text\'}\" ng-model=\"ctrl.form.notify_type\"><option value=\"email\">{{\"AUTOMATION_CUSTOMER_NOTIFY_TYPE_EMAIL\" | translate}}</option><option value=\"sms\">{{\"AUTOMATION_CUSTOMER_NOTIFY_TYPE_SMS\" | translate}}</option><option ng-if=\"ctrl.wa_status == \'authorized\'\" value=\"wa\">{{\"AUTOMATION_CUSTOMER_NOTIFY_TYPE_WA\" | translate}}</option></select></div></div><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"with-button with_upload\">{{\"AUTOMATION_CUSTOMER_TEXT\" | translate}}<div class=\"variables-block\"><button type=\"button\" class=\"btn text primary\" ng-click=\"event.stopPropagation(); ctrl.showVariables = !ctrl.showVariables\">{{\"AUTOMATION_VARIABLES\" | translate}}</button><div class=\"variables-list\" ng-if=\"ctrl.showVariables\"><button type=\"button\" class=\"btn text\" ng-click=\"event.stopPropagation(); ctrl.showVariables = !ctrl.showVariables; ctrl.insertVariable(\'customer_name\')\">{{\"AUTOMATION_VARIABLES_CUSTOMER_NAME\" | translate}}</button> <button type=\"button\" class=\"btn text\" ng-click=\"event.stopPropagation(); ctrl.showVariables = !ctrl.showVariables; ctrl.insertVariable(\'businesses_name\')\">{{\"AUTOMATION_VARIABLES_BUSINESS_NAME\" | translate}}</button></div></div></label> <span class=\"upload_file_paperclip\" style=\"margin-top: 15px;\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"> <i class=\"la la-paperclip\"></i> <span ng-if=\"ctrl.form.files && ctrl.form.files.length\" ng-click=\"event.stopPropagation(); ctrl.form.files = []\" class=\"remove\"><i class=\"las la-times\"></i></span></span> <textarea auto-expand=\"\" class=\"form-control\" style=\"min-height: 70px;\" name=\"notify_text\" ng-model=\"ctrl.form.notify_text\"></textarea></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"AUTOMATION_CUSTOMER_REMIND_TYPE\" | translate}}</label><select ng-if=\"ctrl.displayRemindType\" selectize=\"userSelectize\" config=\"{sortField: \'text\'}\" ng-model=\"ctrl.form.remind_type\"><option ng-if=\"ctrl.checkRemindType(\'before\')\" value=\"before\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_BEFORE\" | translate}}</option><option ng-if=\"ctrl.checkRemindType(\'after\')\" value=\"after\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_AFTER\" | translate}}</option><option ng-if=\"ctrl.checkRemindType(\'now\')\" value=\"now\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_NOW\" | translate}}</option></select></div></div><div ng-if=\"ctrl.form.remind_type != \'now\'\" class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"AUTOMATION_CUSTOMER_REMIND_TIME\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.remind_time\" name=\"remind_time\" class=\"form-control\"></div></div><div ng-if=\"ctrl.form.remind_type != \'now\'\" class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"AUTOMATION_CUSTOMER_TIMETYPE\" | translate}}</label><select selectize=\"userSelectize\" config=\"{sortField: \'text\'}\" ng-model=\"ctrl.form.timetype\"><option value=\"minutes\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_MINUTES\" | translate}}</option><option value=\"hours\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_HOURS\" | translate}}</option><option value=\"days\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_DAYS\" | translate}}</option></select></div></div></div><div class=\"flex gap-24\"><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"once\"><input type=\"checkbox\" class=\"form-control\" id=\"once\" ng-model=\"ctrl.form.once\"> {{\"AUTOMATION_ONCE\" | translate}}</label></div><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"last\"><input type=\"checkbox\" class=\"form-control\" id=\"last\" ng-model=\"ctrl.form.last\"> {{\"AUTOMATION_LAST\" | translate}}</label></div></div></div></div></div></div><div class=\"form-group\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.change_customer_status\"> {{\"AUTOMATION_CHANGE_CUSTOMER_STATUS\" | translate}}</label></div></div></div><div class=\"collapse\" ng-class=\"{\'in\': ctrl.form.change_customer_status}\"><div class=\"panel panel-custom\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><label>{{\"AUTOMATION_CHANGE_CUSTOMER_STATUS_TO\" | translate}}</label><select selectize=\"userSelectize\" config=\"{sortField: \'text\'}\" ng-model=\"ctrl.form.status_id\" required=\"ctrl.form.change_customer_status\"><option value=\"\">{{\"AUTOMATION_CUSTOMER_STATUS\" | translate}}</option><option ng-repeat=\"item in ctrl.customerStatuses\" value=\"{{item.id}}\" ng-bind=\"(item.name)\"></option></select></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/businesses/modules/businesses-form/businesses.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">הוספת קטגוריה</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"categoriesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> שם הקטגוריה</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"categoriesForm.name.$error\" class=\"ng-messages\" ng-show=\"categoriesForm.name.$dirty\"><div ng-message=\"required\">2שדה זה הוא שדה חובה</div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">הסר קטגוריה</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">ביטול</button> <button type=\"submit\" ng-disabled=\"categoriesForm.$invalid || categoriesForm.$pristine\" class=\"btn text primary large\">שליחה</button></div></form></div>");
$templateCache.put("app/modules/settings/gift_cards/popup/balance.view.html","<div class=\"modal-form-inner tabs-form\" id=\"gift-card-balance\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GIFT_CARD_CHANGE_BALANCE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"details-gc-column\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_BALANCE\" | translate }}</p><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.giftCard.balance\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer end\"><div class=\"modal-footer-buttons\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"GIFT_CARD_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.save()\">{{\"GIFT_CARD_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/popup/details.view.html","<div class=\"modal-form-inner tabs-form\" id=\"gift-card-details\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GIFT_CARD_DETAILS\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"details-gc-column\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_NAME\" | translate }}</p><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.values.name\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div><div class=\"details-gc-row\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_GIFTED_TO\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.receiver}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.receiver\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.values.receiver\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_SENDER\" | translate }} ({{ \"GIFT_CARD_GIFTED_BY\" | translate }})</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.sender}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.sender\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.values.sender\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div></div><div class=\"details-gc-row\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_SERVICE\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.service}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.service\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" readonly=\"\" ng-model=\"ctrl.values.service\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_VALUE\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.value}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.value\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" readonly=\"\" ng-model=\"ctrl.values.value\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_MESSAGE\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.message}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.message\" ng-change=\"ctrl.bumpSettings()\"></label></div><textarea ng-model=\"ctrl.values.message\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></textarea></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_TEMPLATES\" | translate }}</p><div class=\"details-gc-templates\"><div ng-repeat=\"(index, template) in ctrl.templates\" class=\"details-gc-templates-item\" ng-click=\"ctrl.selectTemplate(index)\"><div class=\"details-gc-preview\" ng-style=\"{\'background-color\': template.page_bg_color}\"><gift-card settings=\"ctrl.selectedTemplate == index ? ctrl.localSettings : template\" values=\"ctrl.values\" size=\"small\" view=\"mobile\" zoom-on-hover=\"::true\"></gift-card></div><div class=\"details-gc-name\"><p>&nbsp;{{ template.name }}&nbsp;</p></div><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"radio\" name=\"template\" class=\"form-check-input\" ng-value=\"index\" ng-model=\"ctrl.selectedTemplate\"></label></div></div></div></div></div></div></div><div class=\"modal-footer between\"><div class=\"details-gc-info\"><p>{{ \"GIFT_CARD_PRICE\" | translate }}</p><span>₪{{ctrl.values.value}}</span></div><div class=\"modal-footer-buttons\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"GIFT_CARD_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.save()\">{{\"GIFT_CARD_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/popup/select.view.html","<div class=\"modal-form-inner tabs-form\" id=\"gift-card-details\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GIFT_CARD_SELECT\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div ng-if=\"ctrl.giftCards.length\" class=\"panel-body\"><div class=\"flex gap-24 gap-24-m-8 mb-24\"><div class=\"form-group last icon-prepend\"><i class=\"las la-search\"></i> <input id=\"giftCardSearch\" type=\"text\" ng-model=\"ctrl.search\" class=\"form-control\" placeholder=\'{{\"GIFT_CARD_SEARCH\" | translate}}\'></div></div><table ng-if=\"ctrl.tableData.length\" class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"GIFT_CARD_NUMBER\" | translate}}</th><th>{{\"GIFT_CARD_NAME\" | translate}}</th><th>{{\"GIFT_CARD_PRICE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE\" | translate}}</th></tr></thead><tbody ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.giftCardToggle(row)\"><td width=\"1%\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-checked=\"ctrl.isSelected(row)\"></label></div></td><td>{{row.number}}</td><td>{{row.name}}</td><td>₪{{row.price}}</td><td>₪{{row.balance}}</td></tr></tbody></table><div ng-if=\"!ctrl.tableData.length\"><h3>{{\"GIFT_CARD_SEARCH_EMPTY\" | translate}}</h3></div></div><div ng-if=\"!ctrl.giftCards.length\" class=\"panel-body\"><div class=\"flex gap-24 gap-24-m-8 mb-24\"><h3>{{\"GIFT_CARD_LIST_EMPTY\" | translate}}</h3></div></div></div><div class=\"modal-footer end\"><div class=\"modal-footer-buttons\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"GIFT_CARD_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.confirm()\">{{\"GIFT_CARD_CONFIRM\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/items/popup/items.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'ITEM_ENTER_NAME\' | translate}}\" ng-change=\"find_item()\" ng-model=\"ctrl.item_name\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.items\"><table datatable=\"\" dt-options=\"dtOptions\" id=\"items_dt\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"><thead><tr><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th class=\"item-price\">{{\"CUSTOMER_ORDER_HISTORY_PRICE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectCustomer($index)\" ng-repeat=\"row in ctrl.items\"><td><div class=\"bg-div\" style=\"background-color: {{row.bg_color}};\"></div><div ng-if=\"row.item_image\" class=\"item-pic-wrapper\"><img src=\"{{row.item_image}}\" alt=\"Image\" class=\"item-pic\"></div>{{row.name}} <i class=\"las la-ticket-alt\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-if=\"row.customer_has_card\"></i></td><td class=\"item-price\">{{row.price}}<i class=\"fa fa-ils\" aria-hidden=\"true\"></i></td><td></td></tr></tbody></table></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/notes/modules/notes-form/notes.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_ADD_NOTE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\"><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-disabled=\"ctrl.customer_modal\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"NOTES_RESOURCE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.resource_id\"><option value=\"\">{{\"NOTES_RESOURCE_EMPTY\" | translate}}</option><option value=\"{{resource.id}}\" ng-repeat=\"resource in resources\">{{resource.name}}</option></select></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" audio-recorder=\"\" audio-model=\"ctrl.form.text\"><label>{{\"NOTES_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.text\" name=\"text\" class=\"form-control\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"NOTES_REMIND_AT\" | translate}}</label><div class=\"flex form nowrap gap-8\"><input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.remind_at_date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\"> <input type=\"time\" class=\"form-control\" ng-model=\"ctrl.form.remind_at_time\"></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/notes/modules/notes-list/notes.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text large primary\" ng-click=\"ctrl.type == \'notes\' ? ctrl.add_note() : ctrl.add_medical_note()\"><i class=\"las la-plus\"></i> {{ctrl.type == \'notes\' ? \"NEW_NOTE\" : \"NEW_MEDICAL_NOTE\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_items()\" ng-model=\"ctrl.search\" class=\"form-control\"></div><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.change_type(\'notes\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.type == \'notes\'}\">{{\"NOTE_TYPE\" | translate}}</button> <button ng-click=\"ctrl.change_type(\'medical_notes\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.type == \'medical_notes\'}\">{{\"MEDICAL_NOTE_TYPE\" | translate}}</button></div></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/items/stock_log/items.stock_log.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.items.edit({id: {{ctrl.item.id}}})\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{\"ITEMS_TRANSACTIONS_LABEL\" | translate}}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.transactions\" id=\"logs_dt\" datatable=\"ng\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover customers-table\"><thead><tr><th class=\"\">{{\"ITEM_TRANSACTION_DATE\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_CHANGE_AMOUNT\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_AMOUNT_AFTER\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_ORDER_ID\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_COMMENTS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.transactions\"><td class=\"\"><span ng-hide=\"true\">{{row.date_created | toUnixTimestamp }}</span> {{row.date_created | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"\"><span ng-if=\"row.amount_changed > 0\">+</span>{{row.amount_changed}}</td><td class=\"\">{{row.amount_result}}</td><td ng-if=\"row.transaction_id\"><button ng-click=\"ctrl.open_log_card(row.transaction_id)\" class=\"btn text primary large\">{{\"ITEM_TRANSACTION_SHOW_INVOICE\" | translate}}</button></td><td class=\"\">{{row.comment | emptyValue}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/items/stock/items.stock.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ITEM_STOCK_CHANGE_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"editForm\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_STOCK_AMOUNT\" | translate}}</label><div class=\"item-inputs\"><input-number-spinner data-ng-model=\"ctrl.form.amount_changed\" data-input-number-spinner-required=\"true\"></input-number-spinner></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_STOCK_COST\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.cost\" name=\"cost\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-12\"><div class=\"form-group\"><label>{{\"ITEM_STOCK_COMMENT\" | translate}}</label> <textarea class=\"form-control\" ng-model=\"ctrl.form.comment\" placeholder=\"\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_CURRENT_STOCK\" | translate}}: {{ ctrl.item.stock }}</label></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_RESULT_STOCK\" | translate}}: {{ ((ctrl.item.stock*1) + ctrl.form.amount_changed)}}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid\" ng-click=\"ctrl.saveForm()\" class=\"btn text primary large\">{{\"ITEM_CHANGE_STOCK_SAVE_BTN\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/laser_file/popup/laser_file.popup.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_ORDER_LASER_FILE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"empty-section\" id=\"drop-area\" ng-if=\"ctrl.form.length == 0\"><i class=\"las la-file\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_LASER_FILES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_LASER_FILES_SENTENCE\" | translate}}</p><button type=\"submit\" ng-click=\"ctrl.add_line();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_ADD\" | translate}}</button></div><div ng-if=\"ctrl.form.length\"><div class=\"flex form gap-16 mb-16\"><div><div class=\"btn-group\"><button ng-repeat=\"category in ctrl.laser_categories\" class=\"btn\" ng-click=\"ctrl.laser_category = category.id\" ng-class=\"{\'btn-primary\': ctrl.laser_category == category.id, \'btn-default\': ctrl.laser_category != category.id}\">{{category.name | translate}}</button></div></div></div><div class=\"laser-values\"><table><tr><th class=\"min\"></th><th ng-repeat=\"field in ctrl.fields\" ng-if=\"field.category_id == ctrl.laser_category\" class=\"laser-value-column\"><p>{{field.name}}</p></th><th class=\"min\"></th></tr><tr ng-repeat=\"(index, form) in ctrl.form\" ng-if=\"!form.remove && form.category_id == ctrl.laser_category && (form.show || form.first)\"><td class=\"min\" width=\"1%\"><button ng-if=\"form.order_id && form.first && ctrl.orders[form.order_id] == \'closed\' && ctrl.orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form);\" class=\"btn icon bordered\"><i class=\"las la-angle-down\"></i></button> <button ng-if=\"form.order_id && form.first && ctrl.orders[form.order_id] == \'opened\' && ctrl.orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form, true);\" class=\"btn icon bordered\"><i class=\"las la-angle-up\"></i></button></td><td ng-repeat=\"field in ctrl.fields\" ng-if=\"field.category_id == ctrl.laser_category\" ng-class=\"{\'min\': field.type == \'map\', \'laser-value-column\': true}\"><div ng-if=\"field.type == \'text\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"text\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control\"></div><div ng-if=\"field.type == \'date\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"date\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control\"></div><div ng-if=\"field.type == \'datetime\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"datetime-local\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'textarea\'\" class=\"form-group\"><textarea placeholder=\"{{field.name}}\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" auto-expand=\"\" class=\"form-control small\"></textarea></div><div ng-if=\"field.type == \'list\'\" class=\"form-group form-select\"><select class=\"form-control\" name=\"{{field.id}}\" data-placeholder=\"{{field.name}}\" ng-model=\"form[field.id]\"><option value=\"\">{{field.name}}</option><option ng-if=\"field.list\" ng-repeat=\"(index, item) in field.list\" value=\"{{item.id}}\">{{item.name}}</option></select></div><div ng-if=\"field.type == \'map\'\" class=\"form-group\"><button ng-click=\"ctrl.laser_map(index, field);\" class=\"btn text border-primary laser-map-setup\">{{\"LASER_FILE_MAP_BUTTON\" | translate}}</button></div></td><td class=\"min\" width=\"1%\"><button ng-click=\"ctrl.remove_line(index);\" class=\"btn btn-nostyle\"><span class=\"btn-minus inline-icon-btn medium\"><i class=\"las la-trash-alt\"></i></span></button></td></tr></table></div></div></div><div class=\"modal-footer end\"><button type=\"submit\" ng-click=\"ctrl.add_line();\" class=\"btn text primary large\">{{\"LASER_FILE_ADD\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"LASER_FILE_CANCEL\" | translate}}</button> <button type=\"submit\" ng-click=\"ctrl.submit();\" ng-disabled=\"false\" class=\"btn text primary large\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/modules/settings/laser_file/list/laser_file.list.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LASER_INFO_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div ng-repeat=\"(index, field) in ctrl.list\" class=\"laser-value-list-field\"><div class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"text\" ng-model=\"field.name\" name=\"{{field.id}}\" class=\"form-control\"> <button ng-click=\"ctrl.remove_value(index);\" class=\"btn icon red\"><i class=\"las la-trash-alt\"></i></button></div></div><button type=\"button\" ng-click=\"ctrl.add_value();\" ng-disabled=\"false\" class=\"btn text border-primary\">{{\"LASER_FILE_ADD_VALUE\" | translate}}</button></div><div class=\"modal-footer end\"><button type=\"submit\" ng-click=\"$close(ctrl.list);\" ng-disabled=\"false\" class=\"btn text primary large\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/modules/settings/laser_file/popup_field/laser_file.popup_field.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LASER_FIELD_ADD_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"fieldForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_LASER_FIELD_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"fieldForm.name.$error\" class=\"ng-messages\" ng-show=\"fieldForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_LASER_FIELD_TYPE\" | translate}}</label><select required=\"\" class=\"form-control\" ng-model=\"ctrl.form.type\"><option value=\"\">{{\"SETTINGS_LASER_FIELD_TYPE\" | translate}}</option><option value=\"text\">{{\"SETTINGS_LASER_FIELD_TYPE_TEXT\" | translate}}</option><option value=\"list\">{{\"SETTINGS_LASER_FIELD_TYPE_LIST\" | translate}}</option><option value=\"date\">{{\"SETTINGS_LASER_FIELD_TYPE_DATE\" | translate}}</option><option value=\"datetime\">{{\"SETTINGS_LASER_FIELD_TYPE_DATETIME\" | translate}}</option><option value=\"textarea\">{{\"SETTINGS_LASER_FIELD_TYPE_TEXTAREA\" | translate}}</option><option value=\"map\">{{\"SETTINGS_LASER_FIELD_TYPE_MAP\" | translate}}</option></select></div></div><div class=\"col-md-12 col-xs-12\" ng-if=\"ctrl.form.type == \'map\'\"><div class=\"order-images-col\"><p>{{\"SETTINGS_LASER_FIELD_TYPE_PICTURE\" | translate}}</p><div class=\"flex column\"><label ng-class=\"{\'import-image\': true, \'w-image\': !ctrl.form.image || ctrl.form.image == \'\', \'first\': true}\"><input ng-if=\"!ctrl.form.image || ctrl.form.image == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image\" type=\"file\" accept=\"image/*\" ng-disabled=\"false\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.image && ctrl.form.image != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, ctrl.form.image);\"><img ng-src=\"{{ctrl.form.image}}\"></div><span class=\"filename\">{{ctrl.form.image.substring(ctrl.form.image.lastIndexOf(\'/\') + 1)}}</span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!ctrl.form.image || ctrl.form.image == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"fieldForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/laser_file/map/laser_file.map.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LASER_MAP\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.save(); $close(ctrl);\">&times;</a></div><div class=\"modal-body\"><div class=\"laser-map\"><canvas id=\"can\"></canvas></div></div><div class=\"modal-footer between\"><div class=\"form-switch form-group\" ng-if=\"!ctrl.field.image\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_image()\" ng-model=\"ctrl.men\">{{\"LASER_FILE_MAP_MEN\" | translate}}</label></div><div class=\"flex gap-16\"><button type=\"button\" ng-click=\"ctrl.erase()\" class=\"btn text border-red large\">{{\"LASER_FILE_MAP_CLEAR\" | translate}}</button> <button type=\"submit\" ng-click=\"ctrl.save(); $close(ctrl);\" ng-disabled=\"false\" class=\"btn text primary large\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/workers/modules/workers-single/workers.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} single-model-page\" id=\"worker\" ng-if=\"worker != null\"><div class=\"row-fluid clearfix\"><div class=\"cloud mb-24 col-xs-12 single-model-details border-top border-bottom border-right border-left\"><div class=\"single-model-head\"><div class=\"flex gap-24 gap-24-m-8 nowrap\"><button class=\"btn icon default\" ui-sref=\"^.\"><i class=\"las la-angle-right rotatable\"></i></button><h3 class=\"main-title single-model-name\">{{worker.emp_firstname}} {{worker.emp_lastname}}</h3></div><div class=\"btn-actions\"><button class=\"btn icon circle large single-model-edit\" ui-sref=\"app.workers.single.edit({id: {{worker.id}}})\"><i class=\"las la-edit\"></i></button> <button tooltip=\'{{\"WORKERS_DELETE\" | translate}}\' ng-click=\"ctrl.delete();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"worker.emp_status != 0\"><i class=\"las la-trash-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_RECOVER\" | translate}}\' ng-click=\"ctrl.recover();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"worker.emp_status == 0\"><i class=\"las la-trash-restore-alt\"></i></button></div></div><div class=\"single-model-info\"><div class=\"col-md-12 collapsed-mobile\"><h4 class=\"info-title\">{{\"WORKERS_GENERAL\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_1 = !ctrl.info_1\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_1, \'la-angle-up\': ctrl.info_1}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_1}\"><div><div class=\"info-label\">{{\"WORKERS_GENDER\" | translate}}</div><div class=\"info-value\">{{worker.emp_gender | gender | emptyValue }}</div></div><div><div class=\"info-label\">{{\"WORKERS_PHONE\" | translate}}</div><div class=\"info-value\">{{worker.emp_mobilephone | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_BIRTHDAY\" | translate}}</div><div class=\"info-value\">{{worker.emp_birthdate | date: \'dd/MM/yyyy\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_JOB_START\" | translate}}</div><div class=\"info-value\">{{worker.emp_jobstartdate| date: \'dd/MM/yyyy\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_JOB_END\" | translate}}</div><div class=\"info-value\">{{worker.emp_jobenddate | date: \'dd/MM/yyyy\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_ROLE\" | translate}}</div><div class=\"info-value\">{{worker.emp_role | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_ADRESS\" | translate}}</div><div class=\"info-value\">{{worker.emp_adress | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_CITY\" | translate}}</div><div class=\"info-value\">{{worker.emp_city | emptyValue}}</div></div></div></div></div></div></div><div class=\"cloud\"><h3 class=\"info-title\">{{\"WORKER_HOURS\" | translate}}</h3><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"customer-hitsory-orders\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-log-cell\">{{\"WORKER_ENTRY_TIME\" | translate}}</th><th class=\"customer-log-cell\">{{\"WORKER_EXIT_TIME\" | translate}}</th><th class=\"customer-log-cell\">{{\"WORKER_SUM_HOURS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"turntoinput(row.id,row.entry_date_time,row.exit_date_time)\"><td class=\"customer-log-cell\"><span ng-hide=\"true\">{{row.entry_date_time | toUnixTimestamp }}</span> {{row.entry_date_time | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-log-cell\">{{row.exit_date_time | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-log-cell\">{{row.trn_sum_of_hours}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/workers/modules/workers-sms/workers.sms.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">\"{{Customer.firstname}} {{Customer.lastname}}\" {{\"CUSTOMERS_SMS_TO\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"smsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_CONTENT_MESSAGE\" | translate}}</label> <textarea class=\"form-control\" name=\"message\" ng-model=\"ctrl.form.message\" required=\"\" style=\"height: 120px; resize: none;\"></textarea><div ng-messages=\"smsForm.message.$error\" class=\"ng-messages\" ng-show=\"smsForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"smsForm.$invalid || smsForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/workers/modules/workers-form/workers.form.html","<div class=\"modal-form-inner tabs-form\" id=\"workers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ng-click=\"$close();\" ng-if=\"isModal\"><i class=\"las la-angle-right rotatable\"></i></a> <a class=\"btn icon default\" ui-sref=\"^.\" ng-if=\"!isModal\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"WORKERS_ADD_NEW\" | translate}}</h3></div></div><form class=\"modal-form\" name=\"workersForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_FIRST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_firstname\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_LAST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_lastname\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_PASSWORD\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.emp_password\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group date-control last\"><label>{{\"WORKERS_BIRTHDAY\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_year\"><option value=\"\">{{\"WORKERS_YEAR\" | translate}}</option><option ng-repeat=\"year in datesProvider.years\" value=\"{{year}}\">{{year}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_month\"><option value=\"\">{{\"WORKERS_MONTH\" | translate}}</option><option ng-repeat=\"(month, monthName) in datesProvider.months\" value=\"{{month+1}}\">{{monthName}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.birthdate_day\"><option value=\"\">{{\"WORKERS_DAY\" | translate}}</option><option ng-repeat=\"day in datesProvider.days\" value=\"{{day}}\">{{day}}</option></select></div></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_GENDER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.emp_gender\" type=\"radio\" name=\"emp_gender\" value=\"0\"> <label>{{\"WORKERS_GENDER_MALE\" | translate}}</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.emp_gender\" type=\"radio\" name=\"emp_gender\" value=\"1\"> <label>{{\"WORKERS_GENDER_FEMALE\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group date-control last\"><label>{{\"WORKERS_START_JOB\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.startjob_year\"><option value=\"\">{{\"WORKERS_YEAR\" | translate}}</option><option ng-repeat=\"year in datesProvider.years\" value=\"{{year}}\">{{year}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.startjob_month\"><option value=\"\">{{\"WORKERS_MONTH\" | translate}}</option><option ng-repeat=\"(month, monthName) in datesProvider.months\" value=\"{{month+1}}\">{{monthName}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.startjob_day\"><option value=\"\">{{\"WORKERS_DAY\" | translate}}</option><option ng-repeat=\"day in datesProvider.days\" value=\"{{day}}\">{{day}}</option></select></div></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group date-control last\"><label>{{\"WORKERS_END_JOB\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.endjob_year\"><option value=\"\">{{\"WORKERS_YEAR\" | translate}}</option><option ng-repeat=\"year in datesProvider.years\" value=\"{{year}}\">{{year}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.endjob_month\"><option value=\"\">{{\"WORKERS_MONTH\" | translate}}</option><option ng-repeat=\"(month, monthName) in datesProvider.months\" value=\"{{month+1}}\">{{monthName}}</option></select></div></div><div class=\"col-xs-4\"><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.endjob_day\"><option value=\"\">{{\"WORKERS_DAY\" | translate}}</option><option ng-repeat=\"day in datesProvider.days\" value=\"{{day}}\">{{day}}</option></select></div></div></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_PHONE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.emp_mobilephone\" placeholder=\"053-423-1367\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_ADRESS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_adress\" name=\"emp_adress\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_city\" name=\"emp_city\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_ROLE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_role\" name=\"emp_role\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\" ng-if=\"!isModal\">{{\"WORKERS_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\" ng-if=\"isModal\">{{\"WORKERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"workersForm.$invalid || workersForm.$pristine\" class=\"btn text primary large\">{{\"WORKERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/workers/modules/workers-list/workers.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'workers\')\"><div class=\"cloud\"><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text large primary\" ui-sref=\"app.workers.new\"><i class=\"las la-plus\"></i> {{\"NEW_WORKER\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_worker()\" ng-model=\"ctrl.worker_name\" class=\"form-control\"></div></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_deleted()\" ng-model=\"ctrl.show_deleted\">{{\"SHOW_DELETED\" | translate}}</label></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers-single/cards/change-balance.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CARD_BALANCE_CHANGE_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"editForm\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"CARD_CHANGE_BALANCE_AMOUNT\" | translate}}</label><div class=\"item-inputs\"><input-number-spinner data-ng-model=\"ctrl.form.amount_changed\" data-input-number-spinner-min=\"-(ctrl.card.balance)\" data-input-number-spinner-required=\"true\"></input-number-spinner></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"card-expired\">{{\"MAKE_CARD_EXPIRED_DATE\" | translate}}</label> <input type=\"date\" id=\"card-expired\" class=\"form-control\" ng-model=\"ctrl.form.expired_at\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 notes-wrapper\"><div class=\"form-group\"><label>{{\"CARD_CHANGE_BALANCE_COMMENT\" | translate}}</label> <textarea class=\"form-control\" ng-model=\"ctrl.form.comment\" placeholder=\"\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"CARD_CURRENT_BALANCE\" | translate}}: {{ ctrl.card.balance }}</label></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"CARD_RESULT_BALANCE\" | translate}}: {{ (ctrl.card.balance + ctrl.form.amount_changed)}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid\" ng-click=\"ctrl.saveForm()\" class=\"btn text primary large\">{{\"CARD_CHANGE_BALANCE_SAVE_BTN\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/cards/coloring.form.html","<div class=\"modal-form-inner tabs-form\" id=\"coloring-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMER_ADD_COLOR\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\" ng-if=\"!isModal\">&times;</a> <a class=\"close\" ng-click=\"$close();\" ng-if=\"isModal\">&times;</a></div><form class=\"modal-form\" name=\"customersColoring\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_BRAND\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.brand\" class=\"form-control\"></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage\" class=\"form-control\"></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_OXYGEN\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.oxygen_percent\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_OXYGEN_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.oxygen_dosage\" class=\"form-control\"></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_COMMENTS\" | translate}}</label> <textarea ng-model=\"ctrl.form.comments\" class=\"form-control\"></textarea></div></div></div><div ng-if=\"ctrl.color_inputs[2]\" class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number_2\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage_2\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.color_inputs[3]\" class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number_3\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage_3\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.color_inputs[4]\" class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number_4\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage_4\" class=\"form-control\"></div></div></div><div ng-if=\"!ctrl.color_inputs[2] || !ctrl.color_inputs[3] || !ctrl.color_inputs[4]\" class=\"flex form fill\"><div><button type=\"button\" ng-click=\"ctrl.add_color();\" class=\"btn text border-primary large\"><i class=\"las la-plus\"></i> {{\"CUSTOMER_COLOR_ADD\" | translate}}</button></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.remove();\" ng-if=\"ctrl.form.id\" class=\"btn text border-red large\">{{\"CUSTOMERS_COLOR_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"CUSTOMER_COLOR_SAVE\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/cards/transactions.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.customers.single({id: {{ctrl.customer.id}}})\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{\"CUSTOMERS_CARDS_TRANSACTIONS_LABEL\" | translate}}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.transactions\" id=\"logs_dt\" datatable=\"ng\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover customers-table\"><thead><tr><th class=\"\">{{\"CARD_TRANSACTION_DATE\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_CHANGE_AMOUNT\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_AMOUNT_AFTER\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_ORDER_ID\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_COMMENTS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.transactions\"><td class=\"\"><span ng-hide=\"true\">{{row.date_created | toUnixTimestamp }}</span> {{row.date_created | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"\"><span ng-if=\"row.amount_changed > 0\">+</span>{{row.amount_changed}}</td><td class=\"\">{{row.amount_result}}</td><td class=\"\">{{row.order_id | emptyValue}}</td><td class=\"\">{{row.comment | emptyValue}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/list/list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_GIFT_CARDS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.gift_cards.templates\">{{\"SETTINGS_GIFT_CARDS_TEMPLATES\" | translate}}</button><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.changeUsed()\" ng-model=\"ctrl.showUsed\">{{\"SHOW_USED\" | translate}}</label></div></div><div class=\"cloud-list\"><table class=\"sorted-table\"><thead><tr><th>{{\"GIFT_CARD_NUMBER\" | translate}}</th><th>{{\"GIFT_CARD_NAME\" | translate}}</th><th>{{\"GIFT_CARD_PRICE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE\" | translate}}</th><th>{{\"GIFT_CARD_STATUS\" | translate}}</th><th>{{\"GIFT_CARD_CUSTOMER\" | translate}}</th><th width=\"1%\">{{\"GIFT_CARD_LINK\" | translate}}</th></tr></thead><tbody ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.gift_cards.single({id: {{row.id}}})\"><td>{{row.number}}</td><td>{{row.name}}</td><td>₪{{row.price}}</td><td>₪{{row.balance}}</td><td>{{row.used ? (\"GIFT_CARD_USED\" | translate) : (\"GIFT_CARD_NOT_USED\" | translate)}}</td><td>{{row.customer_name}}</td><td width=\"1%\"><a target=\"_blank\" class=\"btn text primary\" ui-sref=\"gift_card({id: row.b_id + \'b\' + row.number})\" ng-click=\"$event.stopPropagation()\">{{\"GIFT_CARD_PREVIEW\" | translate}}</a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/settings/call_logs/modules/call_logs/call_logs.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_CALL_LOGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_CALL_LOGS_PHONE\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_CUSTOMER\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_DATE\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_STATUS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><span>{{row.caller}}</span></td><td><span>{{row.customer}}</span></td><td><span>{{row.created_at}}</span></td><td><span>{{(row.status ? \"SETTINGS_CALL_LOGS_STATUS_\"+(row.status.toUpperCase()) : \'\') | translate}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/categories/modules/categories-form/categories.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_CAT_ADD\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"categoriesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CAT_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"categoriesForm.name.$error\" class=\"ng-messages\" ng-show=\"categoriesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-switch form-group first last pull-end\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.active\" ng-change=\"ctrl.change_active()\">{{\"SETTINGS_CAT_ACTIVE\" | translate}}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"categoriesForm.$invalid || categoriesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/templates/templates.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.gift_cards\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_GIFT_CARDS_TEMPLATES\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.gift_cards.templates.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_GIFT_CARDS_TEMPLATE_NEW\" | translate}}</button></div><div class=\"details-gc-templates details-gc-templates--start\"><div ng-repeat=\"(index, template) in ctrl.templates\" class=\"details-gc-templates-item\" ui-sref=\"app.settings.gift_cards.templates.single({id: template.id})\"><div class=\"details-gc-preview\" ng-style=\"{\'background-color\': template.page_bg_color}\"><gift-card settings=\"template\" size=\"small\" view=\"mobile\" zoom-on-hover=\"::true\"></gift-card></div><div class=\"details-gc-name\"><p>{{ template.name }}</p></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/google_calendar/modules/connect-account/connect-account.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CONNECT_GOOGLE_ACCOUNT\" | translate}}</h3><a class=\"close\" ng-click=\"$dismiss()\">&times;</a></div><div class=\"modal-body\"><div class=\"connect-account-content\"><div class=\"google-auth-section\" ng-if=\"!ctrl.authSuccess\"><div class=\"auth-icon\"><i class=\"fa fa-google fa-3x\"></i></div><h4>{{\"GOOGLE_AUTH_TITLE\" | translate}}</h4><p>{{\"GOOGLE_AUTH_DESCRIPTION\" | translate}}</p><button type=\"button\" ng-click=\"ctrl.authenticateWithGoogle()\" class=\"btn text primary large\" ng-disabled=\"ctrl.authLoading\"><span ng-if=\"ctrl.authLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"AUTHENTICATING\" | translate}}...</span> <span ng-if=\"!ctrl.authLoading\"><i class=\"fa fa-google\"></i> {{\"SIGN_IN_WITH_GOOGLE\" | translate}}</span></button></div><div ng-if=\"ctrl.authSuccess && ctrl.availableResources.length > 0\" class=\"resources-selection\"><h4>{{\"SELECT_RESOURCES_TO_SYNC\" | translate}}</h4><p>{{\"SELECT_RESOURCES_DESCRIPTION\" | translate}}</p><div class=\"resources-list\"><div ng-repeat=\"resource in ctrl.availableResources\" class=\"resource-item\"><div class=\"form-check form-group\"><label><input type=\"checkbox\" ng-model=\"resource.selected\" ng-change=\"ctrl.updateSelectedResources()\">{{resource.name}}</label></div></div></div><div class=\"selected-resources-summary\"><p><strong>{{\"SELECTED_RESOURCES\" | translate}}: {{ctrl.selectedResources.length}}</strong></p></div></div></div></div><div class=\"modal-footer end\" ng-if=\"ctrl.authSuccess\"><button type=\"button\" ng-click=\"$dismiss()\" class=\"btn text border-primary large\">{{\"CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.saveAccount()\" class=\"btn text primary large\" ng-disabled=\"ctrl.saveLoading || ctrl.selectedResources.length === 0\"><span ng-if=\"ctrl.saveLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"SAVING\" | translate}}...</span> <span ng-if=\"!ctrl.saveLoading\">{{\"SAVE_ACCOUNT\" | translate}}</span></button></div></div>");
$templateCache.put("app/modules/settings/google_calendar/modules/manage-resources/manage-resources.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"MANAGE_ACCOUNT_RESOURCES\" | translate}}</h3><a class=\"close\" ng-click=\"$dismiss()\">&times;</a></div><div class=\"modal-body\"><div class=\"account-info\"><div class=\"account-avatar\"><img ng-src=\"{{ctrl.account.avatar_url || \'assets/images/default-avatar.png\'}}\" alt=\"{{ctrl.account.email}}\"></div><div class=\"account-details\"><h4>{{ctrl.account.email}}</h4><p>{{ctrl.account.name || ctrl.account.email}}</p></div></div><div class=\"resources-management\"><h4>{{\"SELECT_RESOURCES_TO_SYNC\" | translate}}</h4><p>{{\"MANAGE_RESOURCES_DESCRIPTION\" | translate}}</p><div class=\"resources-list\"><div ng-repeat=\"resource in ctrl.availableResources\" class=\"resource-item\"><div class=\"form-check form-group\"><label><input type=\"checkbox\" ng-model=\"resource.selected\" ng-change=\"ctrl.updateSelectedResources()\">{{resource.name}}</label></div></div></div><div class=\"selected-resources-summary\"><p><strong>{{\"SELECTED_RESOURCES\" | translate}}: {{ctrl.selectedResources.length}}</strong></p></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.disconnectAccount()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$dismiss()\" class=\"btn text border-primary large\">{{\"CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.saveResources()\" class=\"btn text primary large\" ng-disabled=\"ctrl.saveLoading\"><span ng-if=\"ctrl.saveLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"SAVING\" | translate}}...</span> <span ng-if=\"!ctrl.saveLoading\">{{\"SAVE_RESOURCES\" | translate}}</span></button></div></div>");
$templateCache.put("app/modules/settings/items/modules/items-form/items.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_ITEM_NEW\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_ITEM_EDIT\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><label class=\"import-file\">{{\"SETTINGS_ITEM_IMAGE\" | translate}} <input style=\"visibility: hidden; height: 0;\" type=\"file\" name=\"item_image\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.item_image\" class=\"image small\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.item_image + \')\'}\"></div><div ng-if=\"!ctrl.form.item_image\" class=\"image small\" ng-style=\"{\'background-image\':\'url(/assets/images/empty_image.png)\'}\"></div><span ng-if=\"ctrl.form.item_image\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'item_image\')\"><i class=\"las la-trash-alt\"></i></span></label></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_TYPE\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"service\" ng-disabled=\"isEdit\"> <label>{{\'SERVICE\' | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"sale\" ng-disabled=\"isEdit\"> <label>{{\'SALE\' | translate}}</label></div><div ng-if=\"ctrl.business.courses\" class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"course\" ng-disabled=\"isEdit\"> <label>{{\'COURSE\' | translate}}</label></div><div ng-if=\"isEdit\" class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"card\" ng-disabled=\"isEdit\" ng-change=\"ctrl.cardTypeSelected()\"> <label>{{\'CARD_ITEM_TYPE\' | translate}}</label></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label ng-if=\"ctrl.form.item_type != \'card\'\"><span class=\"required\">*</span> {{\"SETTINGS_ITEM_NAME\" | translate}}</label> <label ng-if=\"ctrl.form.item_type == \'card\'\"><span class=\"required\">*</span> {{\"SETTINGS_ITEM_CARD_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_ITEM_PRICE\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.price\" name=\"price\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.price.$error\" class=\"ng-messages\" ng-show=\"itemsForm.price.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div class=\"col-xs-12 form-group\"><label>{{\"SETTINGS_ITEM_DESCRIPTION\" | translate}}</label> <textarea ng-model=\"ctrl.form.description\" name=\"description\" class=\"form-control\" style=\"min-height: 42px;\" auto-expand=\"\"></textarea></div></div><div class=\"flex form\" ng-if=\"ctrl.form.item_type==\'service\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ITEM_LENGTH\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.duration\" required=\"\"><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ITEM_BREAK\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.break\"><option value=\"\">{{\"SETTINGS_ITEM_NO_BREAK\" | translate}}</option><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.item_type==\'service\' && ctrl.form.break\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_ITEM_NAME2\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name_second\" name=\"name_second\" class=\"form-control\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_ITEM_LENGTH2\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.duration_second\"><option value=\"\">{{\"SETTINGS_ITEM_NOT_SET\" | translate}}</option><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.item_type == \'card\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CALENDAR_ORDER_ITEM_ASSOCIATE\" | translate}}</label><select selectize=\"userSelectize\" name=\"item_id\" config=\"ctrl.itemsSelectBoxConfig\" ng-change=\"ctrl.itemSelected(ctrl.form.item_id)\" data-ng-disabled=\"isEdit\" required=\"\" data-placeholder=\'{{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}\' ng-model=\"ctrl.form.item_id\"><option value=\"\"></option><option ng-repeat=\"item in ctrl.items\" value=\"{{item.id}}\" ng-if=\"item.item_type == \'service\'\" ng-bind=\"(item.name) + \' (\' + (item.originalPrice | price) + \', \' + (item.duration | duration) + \')\'\"></option></select></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_ITEM_AMOUNT\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.amount\" name=\"amount\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.amount.$error\" class=\"ng-messages\" ng-show=\"itemsForm.amount.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_CAT_ASSOC\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" data-placeholder=\'{{\"SETTINGS_ITEM_CAT_SEL\" | translate}}\' ng-disabled=\"ctrl.form.item_type==\'card\'\" ng-model=\"ctrl.form.categories\"><option></option><option value=\"{{category.id}}\" ng-repeat=\"category in categories\">{{category.name}}</option></select></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_CUSTOMER_BOOKING\" | translate}}</label><select selectize=\"userSelectize\" config=\"userConfig\" ng-model=\"ctrl.form.customer_allowed_booking\"><option value=\"0\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</option><option value=\"1\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</option></select></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\" ng-if=\"[\'service\', \'card\', \'course\'].indexOf(ctrl.form.item_type) !== -1\"><div class=\"form-group form-color inl\"><label>{{\"SETTINGS_ITEM_COLOR_SEL\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.bg_color\" name=\"name\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-check form-group\"><label class=\"form-check-label\" for=\"inactive\"><input type=\"checkbox\" class=\"form-control\" id=\"inactive\" ng-model=\"ctrl.form.inactive\"> {{\"SETTINGS_ITEM_INACTIVE\" | translate}}</label></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12\"><label>{{\"SETTINGS_ITEM_RESOURCES\" | translate}}</label><div class=\"item-resources\"><div ng-if=\"item.status == 1 && !item.hide_online\" class=\"item\" ng-repeat=\"(index, item) in ctrl.resources track by $index\"><div class=\"form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-control\" ng-model=\"ctrl.form.resources[item.id]\"> {{item.name}}</label><div ng-if=\"ctrl.form.resources[item.id]\" class=\"form-group form-select last\"><label>{{\"SETTINGS_ITEM_LENGTH\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.resources_options[item.id].duration\"><option value=\"\">{{\"SETTINGS_ITEM_NOT_SET\" | translate}}</option><option value=\"{{duration.duration}}\" ng-repeat=\"duration in ctrl.dates.duration\">{{duration.label}}</option></select></div><div ng-if=\"ctrl.form.resources[item.id]\" class=\"form-group last\"><label>{{\"SETTINGS_ITEM_PRICE\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.resources_options[item.id].price\" name=\"price\" class=\"form-control\"><div ng-messages=\"itemsForm.price.$error\" class=\"ng-messages\" ng-show=\"itemsForm.price.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12 item-df flex-form\"><label>{{\"DIGITAL_FORM_SEND_DIGITAL_FORM\" | translate}}</label><div class=\"form-group form-select first last\"><select class=\"form-control\" ng-model=\"ctrl.form.digital_form\"><option value=\"0\">{{\"DIGITAL_FORM_SEND_DIGITAL_FORM\" | translate}}</option><option ng-repeat=\"form in ctrl.dfs\" value=\"{{form.id}}\">{{form.name}}</option></select></div><label>{{\"DIGITAL_FORM_SEND_TEXT_2\" | translate}}</label><div class=\"form-group first last\"><input type=\"number\" style=\"width:60px;\" ng-model=\"ctrl.form.digital_form_hour\" name=\"digital_form_hour\" class=\"form-control\"></div><label>{{\"DIGITAL_FORM_SEND_TEXT_3\" | translate}}</label><div class=\"form-group form-select first last\"><select class=\"form-control\" ng-model=\"ctrl.form.digital_form_option\"><option value=\"order_start\">{{\"DIGITAL_FORM_SEND_OPTION_1\" | translate}}</option><option value=\"order_end\">{{\"DIGITAL_FORM_SEND_OPTION_2\" | translate}}</option><option value=\"invoice\">{{\"DIGITAL_FORM_SEND_OPTION_3\" | translate}}</option></select></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12 mt-24\"><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"digital_form_once\"><input type=\"checkbox\" class=\"form-control\" id=\"digital_form_once\" ng-model=\"ctrl.form.digital_form_once\"> {{\"DIGITAL_FORM_ONCE\" | translate}}</label></div></div></div><div ng-if=\"ctrl.business.online_payments\"><div class=\"flex form fill last\"><div class=\"col-md-12 mt-24\"><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"require_online_payment\"><input type=\"checkbox\" class=\"form-control\" id=\"require_online_payment\" ng-model=\"ctrl.form.require_online_payment\"> {{\"ITEM_REQUIRE_ONLINE_PAYMENT\" | translate}}</label></div></div></div><div ng-if=\"ctrl.form.require_online_payment\" class=\"flex form\"><div><div class=\"form-group\"><div class=\"radio-btn\"><input id=\"online_payment_type1\" type=\"radio\" name=\"online_payment_type\" ng-model=\"ctrl.form.online_payment_type\" value=\"1\"> <label for=\"online_payment_type1\">{{\'ITEM_FULL_ONLINE_PAYMENT\' | translate}}</label></div><div class=\"radio-btn\"><input id=\"online_payment_type2\" type=\"radio\" name=\"online_payment_type\" ng-model=\"ctrl.form.online_payment_type\" value=\"2\"> <label for=\"online_payment_type2\">{{\'ITEM_PREPAID_ONLINE_PAYMENT\' | translate}}</label></div></div></div><div ng-if=\"ctrl.form.online_payment_type == 2\"><div class=\"form-group\"><input type=\"number\" placeholder=\"{{\'ITEM_SUM_ONLINE_PAYMENT\' | translate}}\" ng-model=\"ctrl.form.online_payment_amount\" name=\"online_payment_amount\" class=\"form-control\"></div></div></div></div></div><div class=\"modal-footer end\"><a ng-if=\"ctrl.show_stock && isEdit && itemId && ctrl.form.item_type == \'sale\'\" ui-sref=\"app.settings.items.stock_log({item_id: {{itemId}}})\" class=\"start-position btn text border-green large\">{{\"SETTINGS_INFO_STOCK_LOG\" | translate}}</a> <button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/settings/categories/modules/categories-list/categories.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_CAT\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.categories.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_CAT_NEW\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_CAT_NAME\" | translate}}</th><th style=\"text-align: end;\">{{\"SETTINGS_CAT_ACTIVE\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.categories.edit({id: {{row.id}}})\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><span>{{row.name}}</span></td><td style=\"text-align: end;\"><div class=\"form-switch form-group first last pull-end\" ng-click=\"$event.stopPropagation()\"><label style=\"padding-left: 42px;\"><input type=\"checkbox\" ng-change=\"ctrl.change_active(row)\" ng-model=\"row.active\">&nbsp;</label></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/single/single.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.gift_cards\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ ctrl.settings.name ? ctrl.settings.name : (\"GIFT_CARD_NUMBER\" | translate) }} - #{{ ctrl.values.number }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><h3>{{\"GIFT_CARD_BALANCE\" | translate}}: ₪{{ctrl.balance}}</h3><button class=\"btn text primary large\" ng-click=\"ctrl.changeBalanceModal()\">{{\"GIFT_CARD_CHANGE\" | translate}}</button></div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><table ng-if=\"ctrl.tableData.length\" class=\"sorted-table\"><thead><tr><th>{{\"GIFT_CARD_DATE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE_BEFORE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE_AFTER\" | translate}}</th><th>{{\"GIFT_CARD_AMOUNT\" | translate}}</th><th width=\"1%\"></th></tr></thead><tbody ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.giftCardToggle(row)\"><td>{{row.created_at}}</td><td>{{row.balance_before}}₪</td><td>{{row.balance_after}}₪</td><td>{{(row.balance_before - row.balance_after) * -1}}₪</td><td width=\"1%\"><a ng-if=\"row.invoice\" tooltip=\'{{\"SETTINGS_LOG_INV\" | translate}}\' href=\"{{row.invoice}}\" target=\"_blank\" class=\"have-tooltip btn icon small default\"><i class=\"las la-file-invoice\"></i></a></td></tr></tbody></table><div class=\"gc-preview-row\"><div class=\"gc-preview\" ng-style=\"{ backgroundColor: ctrl.settings.page_bg_color }\"><gift-card settings=\"ctrl.settings\" values=\"ctrl.values\" size=\"normal\" view=\"mobile\"></gift-card></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/additional_fields/modules/interested/interested.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.additional_fields\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_INTERESTED\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.additional_fields.interested.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_INTERESTED_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_INTERESTED_NAME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.additional_fields.interested.edit({id: {{row.id}}})\"><td><span>{{row.name}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-facebook/leads.facebook.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_FACEBOOK\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"facebookForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div ng-repeat=\"item in ctrl.pages\">{{item.name}} - <span ng-if=\"item.subscribed*1 == 1\">{{\"SETTINGS_LEADS_FACEBOOK_SUBSCRIBED\" | translate}}</span> <span ng-if=\"item.subscribed*1 != 1\">{{\"SETTINGS_LEADS_FACEBOOK_NOT_SUBSCRIBED\" | translate}}</span></div><button type=\"button\" class=\"btn text border-primary\" ng-click=\"ctrl.loginFacebook()\"><i class=\"la la-facebook\"></i>{{ctrl.pages.length > 0 ? \"SETTINGS_LEADS_FACEBOOK_RECONNECT\" : \"SETTINGS_LEADS_FACEBOOK_CONNECT\" | translate}}</button></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_LEADS_STATUSES\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.status\"><option value=\"{{status.id}}\" ng-repeat=\"status in ctrl.statuses\">{{status.name}}</option></select></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"><div ng-messages=\"facebookForm.arrival_source.$error\" class=\"ng-messages\" ng-show=\"facebookForm.arrival_source.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-settings/leads.settings.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_LEADS\" | translate }}</h3></div><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-3 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_LEADS_NOTIFY\" | translate}}</label><div class=\"form-control\"><ui-select multiple=\"\" ng-model=\"ctrl.form.notify\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"SETTINGS_LEADS_NOTIFY\" | translate}}\'>{{$item.name | translate}}</ui-select-match><ui-select-choices toggle-selection=\"msg_channel\" ng-model=\"ctrl.form.notify\" repeat=\"msg_channel in msg_channels track by $index\"><span class=\"multicheck\"></span>{{msg_channel.name | translate}}</ui-select-choices></ui-select></div></div></div></div></div><div class=\"settings-block leads\"><ul><li><a ui-sref=\"app.settings.leads.facebook\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-facebook\"></i></span><div><h6>{{\"SETTINGS_LEADS_FACEBOOK\" | translate}}</h6></div></a></li><li><a ui-sref=\"app.settings.leads.webhook\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-user-cog\"></i></span><div><h6>{{\"SETTINGS_LEADS_WEBHOOK\" | translate}}</h6></div></a></li><li class=\"green\"><a ui-sref=\"app.settings.leads.whatsapp\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-whatsapp\"></i></span><div><h6>{{\"SETTINGS_LEADS_WHATSAPP\" | translate}}</h6></div></a></li><li><a ui-sref=\"app.settings.leads.statuses\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-star\"></i></span><div><h6>{{\"SETTINGS_LEADS_STATUSES\" | translate}}</h6><p>{{\"SETTINGS_LEADS_STATUSES_MANAGE\" | translate}}</p></div></a></li></ul></div><div class=\"flex end gap-24 mt-24\"><button ng-click=\"ctrl.submitSettings()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-statuses/leads.statuses.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.leads\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_LEADS_STATUSES\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.leads.statuses.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_LEADS_STATUSES_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_LEADS_STATUSES_NAME\" | translate}}</th><th>{{\"SETTINGS_LEADS_STATUSES_DISPLAY\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.leads.statuses.edit({id: {{row.id}}})\"><td><div class=\"bg-div\" ng-style=\"{\'background-color\': row.color ? row.color : \'#a9cfe8\'}\"></div><span>{{row.name}}</span></td><td style=\"width: 200px;\"><div style=\"width: 200px;\" class=\"form-group form-select\"><select style=\"width: 200px;\" class=\"form-control\" ng-model=\"row.type\" ng-click=\"$event.stopPropagation()\" ng-change=\"ctrl.update(row)\"><option value=\"0\">{{\"SETTINGS_LEADS_STATUSES_DISPLAY_IN_CUSTOMERS\" | translate}}</option><option value=\"1\">{{\"SETTINGS_LEADS_STATUSES_DISPLAY_IN_LEADS\" | translate}}</option></select></div><span style=\"display: none;\">{{row.type}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-statuses-new/leads.statuses.new.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_STATUSES_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"statusesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_LEADS_STATUSES_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"statusesForm.name.$error\" class=\"ng-messages\" ng-show=\"statusesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_LEADS_STATUSES_DISPLAY\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.type\"><option value=\"0\">{{\"SETTINGS_LEADS_STATUSES_DISPLAY_IN_CUSTOMERS\" | translate}}</option><option value=\"1\">{{\"SETTINGS_LEADS_STATUSES_DISPLAY_IN_LEADS\" | translate}}</option></select></div></div><div class=\"col-md-12\"><div class=\"form-group form-color inl\"><label>{{\"SETTINGS_LEADS_STATUSES_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.color\" name=\"color\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-webhook/leads.webhook.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_WEBHOOK\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"webhookForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><p>{{ctrl.url}}</p></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><p><b>{{\"SETTINGS_LEADS_WEBHOOK_TOKEN\" | translate}}:</b> {{ctrl.token}}</p></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_LEADS_STATUSES\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.status\"><option value=\"{{status.id}}\" ng-repeat=\"status in ctrl.statuses\">{{status.name}}</option></select></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"><div ng-messages=\"webhookForm.arrival_source.$error\" class=\"ng-messages\" ng-show=\"webhookForm.arrival_source.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-whatsapp/leads.whatsapp.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_WHATSAPP\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"whatsappForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.enabled\">{{\"SETTINGS_LEADS_WHATSAPP_ENABLED\" | translate}}</label></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_LEADS_STATUSES\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.status\"><option value=\"{{status.id}}\" ng-repeat=\"status in ctrl.statuses\">{{status.name}}</option></select></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"><div ng-messages=\"whatsappForm.arrival_source.$error\" class=\"ng-messages\" ng-show=\"whatsappForm.arrival_source.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/custom_fields/modules/custom_fields_form/custom_fields.form.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_CUSTOM_FIELDS_VALUE_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_VALUE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.value\" name=\"value\" class=\"form-control\" required=\"\"><div ng-messages=\"itemForm.value.$error\" class=\"ng-messages\" ng-show=\"itemForm.value.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"ctrl.isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemForm.$invalid || itemForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/items/modules/items-list/items.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_ITEMS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.items.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_ITEM_NEW\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_inactive()\" ng-model=\"ctrl.show_inactive\">{{\"SHOW_INACTIVE\" | translate}}</label></div></div><div class=\"cloud-list\"><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_ITEM\" | translate}}</th><th>{{\"SETTINGS_ITEM_PRICE\" | translate}}</th><th>{{\"SETTINGS_ITEM_CAT\" | translate}}</th><th ng-if=\"ctrl.show_stock\" colspan=\"2\">{{\"SETTINGS_ITEM_STOCK\" | translate}}</th><th>{{\"SETTINGS_ITEM_TYPE\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.items.edit({id: {{row.id}}})\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><div class=\"bg-div\" style=\"background-color: {{row.bg_color}};\"></div><div ng-if=\"row.item_image\" class=\"item-pic-wrapper\"><img src=\"{{row.item_image}}\" alt=\"Image\" class=\"item-pic\"></div><span>{{row.name}}</span></td><td>{{row.price | price}}</td><td><span ng-repeat=\"(index, categoryID) in row.categories track by $index\"><span ng-if=\"index > 0\">,</span>{{categories[categoryID].name}}</span></td><td ng-if=\"ctrl.show_stock\"><span ng-if=\"row.item_type == \'sale\'\">{{row.stock}}</span></td><td ng-if=\"ctrl.show_stock\"><button ng-if=\"row.item_type == \'sale\'\" class=\"btn icon bordered green have-tooltip\" tooltip=\"{{\'ITEM_STOCK\' | translate}}\" ng-click=\"d(); $event.stopPropagation(); ctrl.stockModal(row.id);\"><i class=\"las la-caret-square-up\"></i></button></td><td ng-if=\"row.item_type == \'service\'\">{{\"SERVICE\" | translate}}</td><td ng-if=\"row.item_type == \'sale\'\">{{\"SALE\" | translate}}</td><td ng-if=\"row.item_type == \'course\'\">{{\"COURSE\" | translate}}</td><td ng-if=\"row.item_type == \'card\'\">{{\"CARD_ITEM_TYPE\" | translate}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/template/template.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.gift_cards.templates\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_GIFT_CARDS_TEMPLATE\" | translate }}</h3></div><div class=\"gc-page\"><div class=\"gc-container\"><div class=\"gc-page gc-start\"><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_NAME\" | translate }}</div><div class=\"gc-section__body gc-section__body-input\"><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.settings.name\" class=\"form-control\" ng-change=\"ctrl.bumpSettings()\"></div></div><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_COLORS\" | translate }}</div><div class=\"gc-section__body\"><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.page_bg_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_PAGE_BACKGROUND_COLOR\" | translate }}</p></div><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.card_bg_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_CERTIFICATE_BACKGROUND_COLOR\" | translate }}</p></div><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.primary_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_ACCENT_COLOR\" | translate }}</p></div><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.text_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_TEXT_COLOR\" | translate }}</p></div></div><div class=\"gc-section__footer\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.resetColors()\">{{\"SETTINGS_INFO_RESET_COLORS\" | translate}}</button></div></div><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_VISUALS\" | translate }}</div><div class=\"gc-section__body\"><div class=\"gc-upload\"><p>{{ \"GIFT_CARD_COMPANY_LOGO\" | translate }}</p><label class=\"gc-upload__area\"><div class=\"gc-upload__area-start\"><input type=\"file\" name=\"logo\" onchange=\"angular.element(this).scope().uploadImage(this)\" style=\"visibility: hidden; display: none;\"><div class=\"gc-upload__area-preview\" ng-style=\"{\'background-image\':\'url(\' + ctrl.settings.logo + \')\'}\"></div><div class=\"gc-upload__area-filename\">{{ ctrl.getFilename(ctrl.settings.logo) }}</div></div><div ng-if=\"ctrl.settings.logo != \'\'\" class=\"gc-upload__area-end\" ng-click=\"ctrl.removeImage(\'logo\', $event)\"><i class=\"las la-trash-alt\"></i></div></label></div><div class=\"gc-upload\"><p>{{ \"GIFT_CARD_BANNER\" | translate }}</p><label class=\"gc-upload__area\"><div class=\"gc-upload__area-start\"><input type=\"file\" name=\"image\" onchange=\"angular.element(this).scope().uploadImage(this)\" style=\"visibility: hidden; display: none;\"><div class=\"gc-upload__area-preview cover\" ng-style=\"{\'background-image\':\'url(\' + ctrl.settings.image + \')\'}\"></div><div class=\"gc-upload__area-filename\">{{ ctrl.getFilename(ctrl.settings.image) }}</div></div><div ng-if=\"ctrl.settings.image != \'\'\" class=\"gc-upload__area-end\" ng-click=\"ctrl.removeImage(\'image\', $event)\"><i class=\"las la-trash-alt\"></i></div></label></div></div></div><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_TEXT_FIELDS\" | translate }}</div><div class=\"gc-section__body\"><div class=\"form-check\"><label class=\"form-check-label\" for=\"receiver\"><input type=\"checkbox\" class=\"form-check-input\" id=\"receiver\" ng-model=\"ctrl.settings.receiver\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_GIFTED_TO\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"value\"><input type=\"checkbox\" class=\"form-check-input\" id=\"value\" ng-model=\"ctrl.settings.value\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_VALUE\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"service\"><input type=\"checkbox\" class=\"form-check-input\" id=\"service\" ng-model=\"ctrl.settings.service\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_SERVICE\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"message\"><input type=\"checkbox\" class=\"form-check-input\" id=\"message\" ng-model=\"ctrl.settings.message\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_MESSAGE\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"sender\"><input type=\"checkbox\" class=\"form-check-input\" id=\"sender\" ng-model=\"ctrl.settings.sender\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_SENDER\" | translate}}</label></div></div></div></div><div class=\"gc-end\"><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_TEMPLATE_PREVIEW\" | translate }}</div><div class=\"gc-preview-row\"><div class=\"gc-preview\" ng-style=\"{ backgroundColor: ctrl.settings.page_bg_color }\"><gift-card settings=\"ctrl.settings\" values=\"ctrl.values\" size=\"normal\" view=\"mobile\"></gift-card></div></div></div></div></div><div class=\"flex end gap-24\"><button type=\"button\" ng-if=\"ctrl.isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_GIFT_CARDS_TEMPLATES_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.saveTemplate()\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></div></div>");
$templateCache.put("app/modules/settings/additional_fields/modules/interested-form/interested-form.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_INTERESTED_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INTERESTED_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemForm.name.$error\" class=\"ng-messages\" ng-show=\"itemForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemForm.$invalid || itemForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/custom_fields/modules/custom_fields_single/custom_fields.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.custom_fields\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ ctrl.title }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.custom_fields.single.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_CUSTOM_FIELDS_VALUE_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_CUSTOM_FIELDS_VALUE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.custom_fields.single.edit({vid: {{row.id}}})\"><td><span>{{row.value}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-capacity/resources.capacity.html","<div class=\"modal-form-inner\" id=\"capacity-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{capacityDate | date:\"dd/MM/yyyy\"}} - {{\"SETTINGS_RES_H_CAP\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"capacityForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"ctrl.formScreen == 0\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group form-select\"><label>{{\"SETTINGS_RES_START_S\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.start_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"SETTINGS_RES_END_S\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.end_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div></div><div class=\"flex form fill\" ng-if=\"ctrl.form.has_second_shift\"><div><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.shift2_start_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div><div><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.shift2_end_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div></div><div class=\"flex form\"><div class=\"form-group\"><button type=\"button\" ng-if=\"!ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = true\" class=\"btn text border-primary\">{{\"SETTINGS_RES_ADD_S\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = false\" class=\"btn text border-red\">{{\"SETTINGS_RES_DEL_S\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_RES_FORCE_S\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.has_end_date\"><option value=\"0\">{{\"SETTINGS_RES_PERM\" | translate}}</option><option value=\"1\">{{\"SETTINGS_RES_SPEC_DATE\" | translate}}</option></select></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"ctrl.form.has_end_date == 1\"><div class=\"form-group\"><label>{{\"SETTINGS_RES_END_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.form.end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false)\" ng-if=\"capacityID\">{{\"SETTINGS_INFO_DEL\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-disabled=\"capacityForm.$invalid\" ng-click=\"ctrl.submit(false)\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 1\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_1\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.submit(false, false)\">{{\"SETTINGS_RES_EDIT\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.submit(false, true)\">{{\"SETTINGS_RES_EDIT_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 2\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_2\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.delete(false, false)\">{{\"SETTINGS_RES_DEL\" | translate}}</button> <button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false, true)\">{{\"SETTINGS_RES_DEL_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-form/resources.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_RES_ADD_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"resourcesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"worker_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image\" ng-style=\"{\'background-image\':\'url(\' + (ctrl.form.worker_avatar || \'assets/images/avatar.jpg\') + \')\', \'background-size\': \'cover\', \'background-position\': \'center\', \'background-repeat\': \'no-repeat\'}\"></div></label></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_RES_NAME_OF\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"resourcesForm.name.$error\" class=\"ng-messages\" ng-show=\"resourcesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_STATUS\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"1\"> <label>{{\"SETTINGS_RES_STATUS_ACTIVE\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"0\"> <label>{{\"SETTINGS_RES_STATUS_INACTIVE\" | translate}}</label></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_SALES_ACTIVE\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_DEFAULT\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"false\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"true\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_HIDE_ONLINE\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"resourcesForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.DeleteButton\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></div></div></div></form></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-permissions/resources.permissions.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_RES_PERMISSIONS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"resourcesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><div ng-repeat=\"(key, permission) in ctrl.form.permissions\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"permission.enabled\">{{\"SETTINGS_PERMISSIONS_\"+key.toUpperCase() | translate}}</label></div><div class=\"form-switch form-group margin-start-50\" ng-if=\"permission.enabled && permission.personal != undefined\"><label><input type=\"checkbox\" ng-model=\"permission.personal\">{{\"SETTINGS_PERMISSIONS_PERSONAL_\"+key.toUpperCase() | translate}}</label></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"resourcesForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/courses_fields/modules/courses_fields_form/courses_fields.form.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_COURSES_FIELDS_VALUE_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_COURSES_FIELDS_VALUE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.value\" name=\"value\" class=\"form-control\" required=\"\"><div ng-messages=\"itemForm.value.$error\" class=\"ng-messages\" ng-show=\"itemForm.value.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group form-switch\" ng-if=\"ctrl.coursesField.cashbox_condition\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.cashbox_condition\"> {{\"SETTINGS_COURSES_FIELDS_CASHBOX_CONDITION\" | translate}}</label></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"ctrl.isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemForm.$invalid || itemForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/courses_fields/modules/courses_fields_single/courses_fields.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.courses_fields\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ ctrl.title }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.courses_fields.single.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_COURSES_FIELDS_VALUE_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_COURSES_FIELDS_VALUE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.courses_fields.single.edit({vid: {{row.id}}})\"><td><span>{{row.value}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/logs/modules/logs-info/logs.info.html","<div class=\"modal-form-inner\" id=\"logs-info\"><div class=\"modal-head\"><h3 class=\"form-title\">{{transaction.document_number}} # {{\"SETTINGS_LOG_TR_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body document-buttons\"><div><a ng-href=\"{{transaction[\'document_invoice_receipt\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_invoice_receipt\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV_TAX\" | translate}}</a> <a ng-href=\"{{transaction[\'document_invoice\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_invoice\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV\" | translate}}</a> <a ng-href=\"{{transaction[\'document_receipt\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_receipt\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_ACC\" | translate}}</a> <a ng-href=\"{{transaction[\'document_proforma_invoice\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_proforma_invoice\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV_TR\" | translate}}</a> <a ng-href=\"{{transaction[\'document_credit\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_credit\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV_CR\" | translate}}</a> <a ng-href=\"{{transaction[\'document_cards-document\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_cards-document\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_CARD_TR\" | translate}}</a> <a ng-href=\"{{transaction[\'document_quotation\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_quotation\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_QUOTATION\" | translate}}</a></div><div ng-if=\"!ctrl.isMobile\"><a ng-click=\"ctrl.printInvoice(transaction[\'document_invoice_receipt\'].file)\" ng-if=\"transaction[\'document_invoice_receipt\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_invoice\'].file)\" ng-if=\"transaction[\'document_invoice\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_receipt\'].file)\" ng-if=\"transaction[\'document_receipt\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_proforma_invoice\'].file)\" ng-if=\"transaction[\'document_proforma_invoice\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_credit\'].file)\" ng-if=\"transaction[\'document_credit\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_cards-document\'].file)\" ng-if=\"transaction[\'document_cards-document\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_quotation\'].file)\" ng-if=\"transaction[\'document_quotation\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a></div><div ng-if=\"transaction[\'customer_phone\']\"><a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_invoice_receipt\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_invoice\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_receipt\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_proforma_invoice\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_credit\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_cards-document\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_quotation\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a></div><div ng-if=\"transaction.total > 0\"><button type=\"button\" ui-sref=\"app.cashbox.credit({transaction: {{transaction.id}}})\" ng-if=\"transaction.total > 0\" class=\"btn text success large\"><i class=\"las la-file-alt\"></i>{{\"SETTINGS_LOG_TR_CR\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_DIGITAL_FORM_NEW\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_DIGITAL_FORM_EDIT\" | translate}}</h3><a class=\"close\" ng-click=\"$close()\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body digital_form\"><div class=\"flex form\"><div ng-class=\"{\'col-xs-12\': true, \'col-md-8\': ctrl.master_business || ctrl.form.logo, \'col-md-12\': !ctrl.master_business || !ctrl.form.logo}\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_DIGITAL_FORM_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"ctrl.master_business || ctrl.form.logo\" ng-class=\"{\'col-xs-12\': true, \'col-md-4\': ctrl.master_business || ctrl.form.logo, \'col-md-12\': !ctrl.master_business || !ctrl.form.logo}\"><label class=\"import-file\">{{\"SETTINGS_DIGITAL_FORM_LOGO\" | translate}} <input style=\"visibility: hidden; height: 0;\" type=\"file\" name=\"logo\" onchange=\"angular.element(this).scope().uploadImage(this, index)\"><div ng-if=\"ctrl.form.logo\" class=\"image logo small\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.logo + \')\'}\"></div><div ng-if=\"!ctrl.form.logo\" class=\"image logo small\" ng-style=\"{\'background-image\':\'url(/assets/images/empty_image.png)\'}\"></div><span ng-if=\"ctrl.master_business && ctrl.form.logo\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'logo\')\"><i class=\"las la-trash-alt\"></i></span></label><div ng-if=\"!ctrl.master_business && ctrl.form.logo\" class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.hide_logo\">{{\"SETTINGS_DIGITAL_FORM_HIDE_LOGO\" | translate}}</label></div></div></div><div class=\"flex form\"><div class=\"col-md-6 cols-xs-12\"><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.text_form\">{{\"SETTINGS_DIGITAL_FORM_TEXT_FORM\" | translate}}</label></div></div><div ng-if=\"!ctrl.form.text_form\" class=\"col-md-6 cols-xs-12\"><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.locked\">{{\"SETTINGS_DIGITAL_FORM_LOCKED\" | translate}}</label></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.text_form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.text\" class=\"form-control\" style=\"height: 200px;\"></textarea></div></div></div><div ng-if=\"!ctrl.form.text_form\" class=\"digital_form_fields\"><h3>{{\"SETTINGS_DIGITAL_FORM_FIELDS\" | translate}}</h3><div ui-sortable=\"sortableOptions\" ng-model=\"ctrl.form.fields\"><div class=\"digital_form_item move\" ng-repeat=\"(index, field) in ctrl.form.fields\"><span tooltip=\'{{\"SETTINGS_DIGITAL_FORM_MOVE\" | translate}}\' class=\"drag-handle have-tooltip move-triger\"><i class=\"las la-braille\"></i></span><div class=\"flex form\"><div class=\"col-md-8 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.name\" name=\"field_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE\" | translate}}</label><select class=\"form-control\" ng-model=\"field.type\" ng-change=\"ctrl.onChangeType(index, field.type)\" required=\"\"><option value=\"input\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_INPUT\" | translate}}</option><option value=\"textarea\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_TEXTAREA\" | translate}}</option><option value=\"radio\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_RADIO\" | translate}}</option><option value=\"checkbox\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_CHECKBOX\" | translate}}</option><option value=\"select\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_SELECT\" | translate}}</option><option value=\"date\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_DATE\" | translate}}</option><option value=\"comment\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_COMMENT\" | translate}}</option><option value=\"signature\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_SIGNATURE\" | translate}}</option><option value=\"text\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_TEXT\" | translate}}</option><option value=\"business_signature\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_BUSINESS_SIGNATURE\" | translate}}</option><option value=\"map\">{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_MAP\" | translate}}</option></select></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"field.value\" class=\"form-control\" style=\"height:200px;border:1px solid red;\"></textarea></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"flex form\" ng-repeat=\"(i, item) in field.items\"><div class=\"col-md-8 col-xs-10\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OPTION\" | translate}}</label> <input type=\"text\" ng-model=\"item.name\" name=\"item_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-2 text-right\"><button class=\"digital_form_remove_option btn icon red\" ng-click=\"ctrl.onRemoveItem(index, i)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.other_name\" name=\"other_name\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><button class=\"digital_form_add_option btn text border-primary\" ng-click=\"ctrl.onAddItem(index)\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_OPTION\" | translate}}</button></div><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\"><label><input type=\"checkbox\" ng-model=\"field.other\">{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER\" | translate}}</label></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"flex form\" ng-repeat=\"(i, item) in field.items\"><div class=\"col-md-8 col-xs-10\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OPTION\" | translate}}</label> <input type=\"text\" ng-model=\"item.name\" name=\"item_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-2 text-right\"><button class=\"digital_form_remove_option btn icon red\" ng-click=\"ctrl.onRemoveItem(index, i)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.other_name\" name=\"other_name\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><button class=\"digital_form_add_option btn text border-primary\" ng-click=\"ctrl.onAddItem(index)\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_OPTION\" | translate}}</button></div><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\"><label><input type=\"checkbox\" ng-model=\"field.other\">{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER\" | translate}}</label></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"flex form\" ng-repeat=\"(i, item) in field.items\"><div class=\"col-md-8 col-xs-10\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OPTION\" | translate}}</label> <input type=\"text\" ng-model=\"item.name\" name=\"item_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-2 text-right\"><button class=\"digital_form_remove_option btn icon red\" ng-click=\"ctrl.onRemoveItem(index, i)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.other_name\" name=\"other_name\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><button class=\"digital_form_add_option btn text border-primary\" ng-click=\"ctrl.onAddItem(index)\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_OPTION\" | translate}}</button></div><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\"><label><input type=\"checkbox\" ng-model=\"field.other\">{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER\" | translate}}</label></div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"form-group\"><div class=\"text-danger\">{{field.name}}</div></div></div><div ng-if=\"field.type == \'business_signature\'\"><div class=\"order-images-col\"><div class=\"flex column\"><label ng-class=\"{\'import-image\': true, \'w-image\': !field.image || field.image == \'\', \'first\': true}\"><input ng-if=\"!field.image || field.image == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image\" data-index=\"{{index}}\" type=\"file\" accept=\"image/*\" ng-disabled=\"false\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"field.image && field.image != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, field.image);\"><img ng-src=\"{{field.image}}\"></div><span class=\"filename\">{{field.image.substring(field.image.lastIndexOf(\'/\') + 1)}}</span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event, index)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!field.image || field.image == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div></div><div ng-if=\"field.type == \'map\'\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_DIGITAL_FORM_MAP\" | translate}}</label><select class=\"form-control\" ng-model=\"field.map\" required=\"\"><option ng-repeat=\"option in ctrl.mapOptions\" value=\"{{option.url}}\">{{option.name}}</option></select></div></div></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\" ng-if=\"field.type != \'comment\' && field.type != \'text\' && field.type != \'business_signature\' && field.type != \'map\'\"><label><input type=\"checkbox\" ng-model=\"field.require\">{{\"SETTINGS_DIGITAL_FORM_FIELD_REQUIRE\" | translate}}</label></div></div><div class=\"col-xs-6 text-right\"><button ng-if=\"ctrl.form.fields.length > 1\" class=\"digital_form_remove_field btn icon red\" ng-click=\"ctrl.onRemoveField(index)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div></div></div><button class=\"digital_form_add_field btn text border-green\" ng-click=\"ctrl.onAddField()\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_FIELD\" | translate}}</button></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close()\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid || !ctrl.checkRequiredFields()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-single/resources.single.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ui-sref=\"^.\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"SETTINGS_RES_CAP_SET\" | translate}}</h3></div></div><div id=\"resource\" ng-if=\"resource != null\"><div class=\"modal-body\"><div class=\"flex form\"><div><div class=\"form-group last\"><select selectize=\"test\" config=\"userConfig\" class=\"resource-cap-type\" ng-model=\"ctrl.resource_view_type\" ng-change=\"ctrl.changeShiftsView()\"><option ng-repeat=\"shifts_view in ctrl.resource_view_types\" value=\"{{shifts_view.value}}\">{{shifts_view.title | translate}}</option></select></div></div><div><div class=\"resource-date-picker\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.prevWeek();\" class=\"btn icon\"><i class=\"las la-angle-right rotatable\"></i></button></span><div class=\"inputs-wrapper\"><input type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.capacityDate\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.nextWeek();\" class=\"btn icon\"><i class=\"las la-angle-left rotatable\"></i></button></span></div></div></div><div class=\"flex form\"><button class=\"btn icon circle large default\" ui-sref=\"app.settings.resources.edit(ctrl.edit_params)\"><i class=\"las la-edit\"></i></button> <button ng-if=\"resource.user_id && userRole == 0\" class=\"btn icon circle large default\" ui-sref=\"app.settings.resources.edit_permissions(ctrl.edit_params)\"><i class=\"las la-check-circle\"></i></button></div></div><div class=\"capacity-block\"><div class=\"capacity-days\" ng-class=\"{\'loading\': ctrl.loading}\"><div class=\"capacity-day\" ng-repeat=\"(index, capacityRow) in capacityData track by $index\"><h4 class=\"info-title\">{{datesProvider.daysNames[index]}} {{\"SETTINGS_RES_A_DAY\" | translate}} <span class=\"date\">{{capacityRow.date*1000 | date: \"dd/MM/yyyy\"}}</span></h4><div class=\"capacity-hours\"><button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time == null\">{{\"SETTINGS_RES_SET_H\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time != null\">{{capacityRow.start_time | hourAndMinute}} - {{capacityRow.end_time | hourAndMinute}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.shift2_end_time\">{{capacityRow.shift2_start_time | hourAndMinute}} - {{capacityRow.shift2_end_time | hourAndMinute}}</button></div><div ng-if=\"false && ctrl.resource_view_type == 2\"><div class=\"form-group form-select last\"><select class=\"form-control\"><option value=\"1\">{{\"SETTINGS_RES_MULTIPLE_BOOK\" | translate}}: 1</option><option value=\"2\">{{\"SETTINGS_RES_MULTIPLE_BOOK\" | translate}}: 2</option><option value=\"3\">{{\"SETTINGS_RES_MULTIPLE_BOOK\" | translate}}: 3</option></select></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-list/digital_forms.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_DIGITAL_FORMS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.digital_forms.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_DIGITAL_FORM_NEW\" | translate}}</button> <button class=\"btn text primary large\" ui-sref=\"app.settings.digital_forms.templates\"><i class=\"las la-plus\"></i>{{\"SETTINGS_DIGITAL_FORM_NEW_TEMPLATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_DIGITAL_FORM\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td ui-sref=\"app.settings.digital_forms.edit({id: {{row.id}}})\"><span>{{row.name}}</span></td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ui-sref=\"app.settings.digital_forms.preview({id: {{row.id}}})\">{{\"SETTINGS_DIGITAL_FORM_PREVIEW\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-list/resources.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3 ng-if=\"ctrl.bu_type == 2\">{{ \"SETTINGS_RESOURCE\" | translate }}</h3><h3 ng-if=\"ctrl.bu_type == 1\">{{ \"SETTINGS_STAFF\" | translate }}</h3></div><div><div class=\"flex full between mb-24 gap-16\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.settings.resources.new\" ng-if=\"ctrl.bu_type == 2\"><i class=\"las la-plus\"></i> {{\"SETTINGS_RES_NEW\" | translate}}</button> <button class=\"btn text primary large\" ui-sref=\"app.settings.resources.new\" ng-if=\"ctrl.bu_type == 1\"><i class=\"las la-plus\"></i> {{\"SETTINGS_EMP_NEW\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_inactive()\" ng-model=\"ctrl.show_inactive\">{{\"SHOW_INACTIVE\" | translate}}</label></div></div></div><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_RES_NAME\" | translate}}</th><th>{{\"SETTINGS_RES_STATUS\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_resource_card(row.id)\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar ? row.avatar : \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{row.name}}</td><td>{{row.status == 1 ? \"SETTINGS_RES_STATUS_ACTIVE\" : \"SETTINGS_RES_STATUS_INACTIVE\" | translate }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-preview/digital_forms.preview.html","<div class=\"modal-form-inner digital_form_modal\"><div class=\"modal-head modal-head-online\"><div ng-if=\"business.online_booking_data.background\" class=\"df-background\"><img ng-src=\"{{business.online_booking_data.background}}\"></div><a class=\"close\" ng-click=\"ctrl.back()\" style=\"top: 20px;\">&times;</a></div><div class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name}}</h2></div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group form-select\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><select class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"><option value=\"\">{{field.name}}</option><option value=\"{{item.value}}\" ng-repeat=\"(i, item) in field.items\">{{item.name}}</option></select></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"date\" min=\"1900-01-01\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"map-image\"><img ng-src=\"{{field.map}}\" alt=\"{{field.name}}\"></div></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-templates/digital_forms.templates.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_DIGITAL_FORM_NEW_TEMPLATE\" | translate}}</h3><a class=\"close\" ng-click=\"$close()\" style=\"top: 20px;\">&times;</a></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.list\" class=\"table table-striped table-hover\"><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.list\"><td><span>{{row.name}}</span></td><td width=\"1%\"><button type=\"button\" class=\"btn text border-green\" ui-sref=\"app.settings.digital_forms.preview({id: {{row.id}}})\">{{\"SETTINGS_DIGITAL_FORM_PREVIEW\" | translate}}</button></td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.createForm(row)\">{{\"SETTINGS_DIGITAL_FORM_CREATE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></form></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-list/second_resources.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ctrl.second_resource_name}} {{ \"SETTINGS_SECOND_STAFF\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.settings.second_resources.new\"><i class=\"las la-plus\"></i> {{\"SETTINGS_EMP_NEW\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_RES_NAME\" | translate}}</th><th>{{\"SETTINGS_RES_STATUS\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_resource_card(row.id)\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar ? row.avatar : \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{row.name}}</td><td>{{row.status == 1 ? \"SETTINGS_RES_STATUS_ACTIVE\" : \"SETTINGS_RES_STATUS_INACTIVE\" | translate }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/settings/logs/modules/logs-list/logs.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.reports\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"REPORTS_TRANSACTIONS_HISTORY_LBL\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.cashbox\"><i class=\"las la-plus\"></i> {{\"SETTINGS_LOG_NEW_DEAL\" | translate}}</button><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div><div class=\"filter-button\" style=\"flex: none\"><button type=\"button\" class=\"btn icon default\" ng-click=\"ctrl.openFilter()\"><span ng-show=\"(ctrl.filter | notEmptyCountFilter) > 0\" class=\"filter-count\">{{ctrl.filter | notEmptyCountFilter}}</span><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal\': true, \'active\': ctrl.filterModal}\" ng-click=\"event.stopPropagation();\"><div><div><div class=\"form-group form-select\"><label>{{\"FILTER_PAYMENT_TYPE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.filter.payment_type\"><option value=\"\">{{\"FILTER_PAYMENT_TYPE\" | translate}}</option><option value=\"1\">{{\"CALENDAR_CASH_CASH\" | translate}}</option><option value=\"2\">{{\"ADMIN_CREDIT_CARD\" | translate}}</option><option value=\"3\">{{\"CALENDAR_CASH_ON_CREDIT\" | translate}}</option><option value=\"4\">{{\"CALENDAR_CASH_CHEQUE\" | translate}}</option><option value=\"5\">{{\"CALENDAR_CASH_BANK_TRANS\" | translate}}</option><option value=\"6\">{{\"CALENDAR_CASH_CREDIT_CARD_EXT\" | translate}}</option></select></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_DATE_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.date_from || ctrl.filter.date_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter.date_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_DATE_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.date_to || ctrl.filter.date_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter.date_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"></div></div><div class=\"flex nowrap gap-16\"><a ng-click=\"ctrl.closeFilter()\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"ctrl.clearFilter()\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a> <a ng-click=\"ctrl.applyFilter()\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div></div></div><div class=\"flex gap-16\"><button ng-if=\"ctrl.enabled_retainers\" class=\"btn text large\" ng-class=\"ctrl.show_retainers ? \'primary\' : \'\'\" ng-click=\"ctrl.toggle_retainers()\">{{\"SHOW_RETAINERS\" | translate}}</button> <button class=\"btn text large\" ng-class=\"ctrl.show_pending_payments ? \'primary\' : \'\'\" ng-click=\"ctrl.toggle_pending_payments()\">{{\"SHOW_PENDING_PAYMENTS\" | translate}}</button></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"logs_dt\" class=\"customer-table-holder\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\"></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-single/second_resources.single.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ui-sref=\"^.\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"SETTINGS_RES_CAP_SET\" | translate}}</h3></div></div><div id=\"resource\" ng-if=\"second_resource != null\"><div class=\"modal-body\"><div class=\"flex form\"><div><div class=\"form-group last\"><select selectize=\"test\" config=\"userConfig\" class=\"resource-cap-type\" ng-model=\"ctrl.resource_view_type\" ng-change=\"ctrl.changeShiftsView()\"><option ng-repeat=\"shifts_view in ctrl.resource_view_types\" value=\"{{shifts_view.value}}\">{{shifts_view.title | translate}}</option></select></div></div><div><div class=\"resource-date-picker\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.prevWeek();\" class=\"btn icon\"><i class=\"las la-angle-right rotatable\"></i></button></span><div class=\"inputs-wrapper\"><input type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.capacityDate\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.nextWeek();\" class=\"btn icon\"><i class=\"las la-angle-left rotatable\"></i></button></span></div></div></div><div><button class=\"btn icon circle large default\" ui-sref=\"app.settings.second_resources.edit(ctrl.edit_params)\"><i class=\"las la-edit\"></i></button></div></div><div class=\"capacity-block\"><div class=\"capacity-days\" ng-class=\"{\'loading\': ctrl.loading}\"><div class=\"capacity-day\" ng-repeat=\"(index, capacityRow) in capacityData track by $index\"><h4 class=\"info-title\">{{datesProvider.daysNames[index]}} {{\"SETTINGS_RES_A_DAY\" | translate}} <span class=\"date\">{{capacityRow.date*1000 | date: \"dd/MM/yyyy\"}}</span></h4><div class=\"capacity-hours\"><button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time == null\">{{\"SETTINGS_RES_SET_H\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time != null\">{{capacityRow.start_time | hourAndMinute}} - {{capacityRow.end_time | hourAndMinute}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.shift2_end_time\">{{capacityRow.shift2_start_time | hourAndMinute}} - {{capacityRow.shift2_end_time | hourAndMinute}}</button></div><div ng-if=\"false && ctrl.resource_view_type == 2\"><div class=\"form-group form-select last\"><select class=\"form-control\"><option value=\"1\">{{\"SETTINGS_RES_MULTIPLE_BOOK\" | translate}}: 1</option><option value=\"2\">{{\"SETTINGS_RES_MULTIPLE_BOOK\" | translate}}: 2</option><option value=\"3\">{{\"SETTINGS_RES_MULTIPLE_BOOK\" | translate}}: 3</option></select></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-capacity/second_resources.capacity.html","<div class=\"modal-form-inner\" id=\"capacity-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{capacityDate | date:\"dd/MM/yyyy\"}} - {{\"SETTINGS_RES_H_CAP\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"capacityForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"ctrl.formScreen == 0\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group form-select\"><label>{{\"SETTINGS_RES_START_S\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.start_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div><div><div class=\"form-group form-select\"><label>{{\"SETTINGS_RES_END_S\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.end_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div></div><div class=\"flex form fill\" ng-if=\"ctrl.form.has_second_shift\"><div><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.shift2_start_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div><div><div class=\"form-group form-select\"><select class=\"form-control\" ng-model=\"ctrl.form.shift2_end_time\"><option value=\"{{hour}}\" ng-repeat=\"hour in datesProvider.hours\">{{hour}}</option></select></div></div></div><div class=\"flex form\"><div class=\"form-group\"><button type=\"button\" ng-if=\"!ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = true\" class=\"btn text border-primary\">{{\"SETTINGS_RES_ADD_S\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = false\" class=\"btn text border-red\">{{\"SETTINGS_RES_DEL_S\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group form-select\"><label>{{\"SETTINGS_RES_FORCE_S\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.has_end_date\"><option value=\"0\">{{\"SETTINGS_RES_PERM\" | translate}}</option><option value=\"1\">{{\"SETTINGS_RES_SPEC_DATE\" | translate}}</option></select></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"ctrl.form.has_end_date == 1\"><div class=\"form-group\"><label>{{\"SETTINGS_RES_END_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.form.end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false)\" ng-if=\"capacityID\">{{\"SETTINGS_INFO_DEL\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-disabled=\"capacityForm.$invalid\" ng-click=\"ctrl.submit(false)\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 1\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_1\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.submit(false, false)\">{{\"SETTINGS_RES_EDIT\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.submit(false, true)\">{{\"SETTINGS_RES_EDIT_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 2\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_2\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.delete(false, false)\">{{\"SETTINGS_RES_DEL\" | translate}}</button> <button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false, true)\">{{\"SETTINGS_RES_DEL_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-form/second_resources.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_RES_ADD_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"resourcesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"worker_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image\" ng-style=\"{\'background-image\':\'url(\' + (ctrl.form.worker_avatar || \'assets/images/avatar.jpg\') + \')\', \'background-size\': \'cover\', \'background-position\': \'center\', \'background-repeat\': \'no-repeat\'}\"></div></label></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_RES_NAME_OF\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"resourcesForm.name.$error\" class=\"ng-messages\" ng-show=\"resourcesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_STATUS\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"1\"> <label>{{\"SETTINGS_RES_STATUS_ACTIVE\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"0\"> <label>{{\"SETTINGS_RES_STATUS_INACTIVE\" | translate}}</label></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_SALES_ACTIVE\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_DEFAULT\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"false\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"true\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_HIDE_ONLINE\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"resourcesForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.DeleteButton\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></div></div></div></form></div>");
$templateCache.put("app/modules/settings/sms_logs/modules/sms_logs/sms_logs.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_SMS_LOGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"smslog_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th style=\"width: auto !important;\">{{\"SETTINGS_SMS_LOGS_DATE\" | translate}}</th><th style=\"width: auto !important;\">{{\"SETTINGS_SMS_LOGS_CUSTOMER\" | translate}}</th><th style=\"min-width: 40%; width: auto !important;\">{{\"SETTINGS_SMS_LOGS_TEXT\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\">{{\"SETTINGS_SMS_LOGS_STATUS\" | translate}}</th><th style=\"min-width: 5%; width: auto !important;\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><span ng-hide=\"true\">{{row.created_at | toUnixTimestamp }}</span> <span>{{row.sent}}</span></td><td><span>{{row.customer ? row.customer : row.mobile}}</span></td><td><span>{{row.message}}</span></td><td>{{row.updated}} - <span ng-if=\"!row.error\">{{\"SETTINGS_SMS_LOGS_STATUS_SENT\" | translate}}</span> <span ng-if=\"row.error\"><span ng-if=\"row.error == \'Delivered\'\">{{\"SETTINGS_SMS_LOGS_STATUS_DELIVERED\" | translate}}</span> <span ng-if=\"row.error != \'Delivered\'\">{{row.error}}</span></span></td><td><span ng-if=\"row.wa\" class=\"btn icon circle small bordered green\"><i class=\"lab la-whatsapp\"></i></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/custom-fields/modules/custom-fields-form/custom-fields.form.html","<div class=\"modal-form-inner\" id=\"categories-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"ctrl.isEdit\">{{\"SETTINGS_CUSTOM_FIELDS_EDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"!ctrl.isEdit\">{{\"SETTINGS_CUSTOM_FIELDS_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"customFieldForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"row\"><div><div class=\"col-md-6 form-group\" ng-repeat=\"locale in ctrl.availableLocales\"><label><span class=\"required\" ng-if=\"ctrl.isLocalRequired(locale)\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_NAME_\" + locale.split(\'_\')[0].toUpperCase() | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name[locale]\" name=\"name_{{locale}}\" class=\"form-control\" ng-required=\"ctrl.isLocalRequired(locale)\" autocomplete=\"off\"></div></div></div><div class=\"row\"><div><div class=\"col-md-6 form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_BUSINESSES\" | translate}}</label><div class=\"form-control form-select\"><ui-select multiple=\"\" name=\"businesses\" required=\"\" ng-model=\"ctrl.selectedBusinesses\" theme=\"select2\" close-on-select=\"false\" remove-selected=\"false\"><ui-select-match placeholder=\'{{\"SETTINGS_CUSTOM_FIELDS_SELECT_BUSINESSES\" | translate}}\'>{{$item.name}}</ui-select-match><ui-select-choices toggle-selection=\"item\" ng-model=\"ctrl.selectedBusinesses\" repeat=\"item in ctrl.businesses | filter:$select.search\"><span class=\"multicheck\"></span>{{item.name}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6 form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_TYPE\" | translate}}</label><div class=\"form-select\"><select name=\"type\" class=\"form-control\" required=\"\" ng-model=\"ctrl.form.type\"><option ng-repeat=\"type in ctrl.types\" value=\"{{type.key}}\">{{type.title}}</option></select></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"customFieldForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/custom-fields/modules/custom-fields-list/custom-fields.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn text primary large\" ui-sref=\"app.admin.custom-fields.new\">{{\"SETTINGS_CUSTOM_FIELDS_NEW\" | translate}}</button></div><div class=\"table-main-options table-holder\"><div class=\"table-responsive table-with-search\"><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_CUSTOM_FIELDS_NAME\" | translate}}</th><th>{{\"SETTINGS_CUSTOM_FIELDS_BUSINESSES\" | translate}}</th><th>{{\"SETTINGS_CUSTOM_FIELDS_TYPE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.editItem(row.id)\"><td>{{ctrl.getCurrentName(row.name)}}</td><td>{{ctrl.getBusinesses(row.businesses)}}</td><td>{{ctrl.getType(row.type)}}</td><td style=\"width: 80px; text-align: right;\"><a class=\"btn icon circle small bordered blue\" ng-click=\"ctrl.editItem(row.id); $event.stopPropagation();\"><i class=\"las la-edit\"></i></a> <a class=\"btn icon circle small bordered red\" ng-click=\"ctrl.removeItem(row.id); $event.stopPropagation();\"><i class=\"las la-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/users/modules/popup/business.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"bank-select-mob\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADMIN_BUSINESS\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><table ng-if=\"ctrl.businesses\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover businesses-select-table\"><thead><tr><th>{{\"ADMIN_BUSINESS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectBusiness($index)\" ng-repeat=\"row in ctrl.businesses\"><td>{{row.name}}</td></tr></tbody></table></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/admin/modules/users/modules/users-form/users.form.html","<div class=\"modal-form-inner\" id=\"categories-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_USER_EDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_USER_N\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"usersForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"formScreen == 0\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_USER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\" autocomplete=\"off\"><div ng-messages=\"usersForm.name.$error\" class=\"ng-messages\" ng-show=\"usersForm.name.$dirty\"><div ng-message=\"required\">1שדה זה הוא שדה חובה</div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> Use for login</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" required=\"\" placeholder=\"email@example.co.il\" class=\"form-control\" autocomplete=\"off\"><div ng-messages=\"usersForm.email.$error\" class=\"ng-messages\" ng-show=\"usersForm.email.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div><div ng-message=\"email\">{{\"SETTINGS_USER_VALID_MAIL\" | translate}}</div></div></div></div></div><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"ADMIN_BUSINESS\" | translate}}</label> <input type=\"text\" readonly=\"true\" ng-if=\"isMobile\" ng-model=\"ctrl.name_business\" class=\"form-control\" ng-click=\"ctrl.showBusinessList()\"><select chosen=\"\" ng-model=\"ctrl.form.b_id\" ng-if=\"!isMobile\" ng-change=\"ctrl.business_change($orderItemIndex)\" data-placeholder=\'{{\"ADMIN_BUSINESS\" | translate}}\'><option value=\"\"></option><option ng-if=\"orderItem.item_type == item.item_type\" class=\"\" value=\"{{business.id}}\" ng-repeat=\"business in ctrl.businesses\">{{business.name}}</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_USER_ROLE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.role\" ng-change=\"ctrl.roleChange()\"><option ng-repeat=\"role in ctrl.user_roles\" ng-disabled=\"(!ctrl.form.b_id || ctrl.form.b_id == \'undefined\') && role.key == 3\" value=\"{{role.key}}\">{{role.title|translate}}</option></select></div></div></div><div ng-if=\"ctrl.form.role == 3\" class=\"col-md-12 no-padding-col\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group form-select\"><label><span class=\"required\">*</span> {{\"SETTINGS_USER_RESOURCE\" | translate}}</label><select class=\"form-control\" ng-model=\"ctrl.form.resource_id\"><option ng-repeat=\"resource in ctrl.resources\" value=\"{{resource.id}}\">{{resource.name}}</option></select></div></div></div></div><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><div class=\"form-group\"><div><label><span class=\"required\" ng-if=\"!isEdit\">*</span> {{\"SETTINGS_USER_PASS\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.password\" name=\"password\" class=\"form-control\" required=\"\" ng-if=\"!isEdit\" autocomplete=\"off\"> <input type=\"password\" ng-model=\"ctrl.form.password\" placeholder=\'{{\"SETTINGS_USER_NOT_CH\" | translate}}\' name=\"password\" class=\"form-control\" ng-if=\"isEdit\" autocomplete=\"off\"><div ng-messages=\"usersForm.password.$error\" class=\"ng-messages\" ng-show=\"usersForm.password.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"usersForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button type=\"button\" ng-if=\"isEdit && $user.id != ctrl.form.id\" ng-click=\"ctrl.delete();\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></div></div><div ng-if=\"formScreen == 1\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\">{{\"SETTINGS_USER_SENTENCE_1\" | translate}}</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"formScreen = 0\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_OK\" | translate}}</button></div></div><div ng-if=\"formScreen == 2\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\">{{\"SETTINGS_USER_QUEST\" | translate}}</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"formScreen = 0\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"CUSTOMERS_DELETE\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/admin/modules/users/modules/users-list/users.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn text primary large\" ui-sref=\"app.admin.users.new\">{{\"SETTINGS_USER_NEW\" | translate}}</button></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_USER_NAME\" | translate}}</th><th>{{\"SETTINGS_USER_MAIL\" | translate}}</th><th>{{\"ADMIN_BUSINESS_NAME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.admin.users.edit({id: {{row.id}}})\"><td>{{row.name}}</td><td>{{row.email}}</td><td>{{row.business}}</td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/logs/modules/logs-list/logs.list.html","<div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row admin-logs\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\"><div class=\"flex full mb-24 gap-24 gap-24-m-8\"><div class=\"date-picker\"><div class=\"input-group date-picker--input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerPrev();\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div style=\"width:100px;\"></div><div class=\"inputs-wrapper\"><input style=\"width: 100%; height: 33px; text-align: center;\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.date\" auto-close=\"true\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerNext();\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div></div><div class=\"btn-group\"><button class=\"btn\" ng-click=\"ctrl.change_type(\'all\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'all\', \'btn-default\': ctrl.type != \'all\'}\">{{\"All\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_type(\'error\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'error\', \'btn-default\': ctrl.type != \'error\'}\">{{\"Error\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_type(\'debug\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'debug\', \'btn-default\': ctrl.type != \'debug\'}\">{{\"Debug\" | translate}}</button></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th style=\"width: 140px;\">{{\"Date\" | translate}}</th><th style=\"width: 1%;\">{{\"Type\" | translate}}</th><th>{{\"Text\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td style=\"width: 140px;\">{{row.date}}</td><td style=\"width: 1%;\">{{row.type}}</td><td ng-bind-html=\"row.text | nl2br\"></td></tr></tbody></table></div></div></div></div></div></div></div>");}]);